(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('ractive'), require('algoliasearch')) :
	typeof define === 'function' && define.amd ? define(['ractive', 'algoliasearch'], factory) :
	(global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.app = factory(global.Ractive, global.algoliasearch));
})(this, (function (ractive, algoliasearch) { 'use strict';

	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

	var ractive__default = /*#__PURE__*/_interopDefaultLegacy(ractive);
	var algoliasearch__default = /*#__PURE__*/_interopDefaultLegacy(algoliasearch);

	var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}

	function getCjsExportFromNamespace (n) {
		return n && n['default'] || n;
	}

	var check = function (it) {
	  return it && it.Math === Math && it;
	};

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var globalThis_1 =
	// eslint-disable-next-line es/no-global-this -- safe
	check(typeof globalThis == 'object' && globalThis) || check(typeof window == 'object' && window) ||
	// eslint-disable-next-line no-restricted-globals -- safe
	check(typeof self == 'object' && self) || check(typeof commonjsGlobal == 'object' && commonjsGlobal) || check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
	// eslint-disable-next-line no-new-func -- fallback
	function () {
	  return this;
	}() || Function('return this')();

	var fails = function (exec) {
	  try {
	    return !!exec();
	  } catch (error) {
	    return true;
	  }
	};

	// Detect IE8's incomplete defineProperty implementation
	var descriptors = !fails(function () {
	  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
	  return Object.defineProperty({}, 1, {
	    get: function () {
	      return 7;
	    }
	  })[1] !== 7;
	});

	var functionBindNative = !fails(function () {
	  // eslint-disable-next-line es/no-function-prototype-bind -- safe
	  var test = function () {/* empty */}.bind();
	  // eslint-disable-next-line no-prototype-builtins -- safe
	  return typeof test != 'function' || test.hasOwnProperty('prototype');
	});

	var call$2 = Function.prototype.call;
	// eslint-disable-next-line es/no-function-prototype-bind -- safe
	var functionCall = functionBindNative ? call$2.bind(call$2) : function () {
	  return call$2.apply(call$2, arguments);
	};

	var $propertyIsEnumerable = {}.propertyIsEnumerable;
	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor;

	// Nashorn ~ JDK8 bug
	var NASHORN_BUG = getOwnPropertyDescriptor$2 && !$propertyIsEnumerable.call({
	  1: 2
	}, 1);

	// `Object.prototype.propertyIsEnumerable` method implementation
	// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
	var f$5 = NASHORN_BUG ? function propertyIsEnumerable(V) {
	  var descriptor = getOwnPropertyDescriptor$2(this, V);
	  return !!descriptor && descriptor.enumerable;
	} : $propertyIsEnumerable;
	var objectPropertyIsEnumerable = {
	  f: f$5
	};

	var createPropertyDescriptor = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};

	var FunctionPrototype$2 = Function.prototype;
	var call$1 = FunctionPrototype$2.call;
	// eslint-disable-next-line es/no-function-prototype-bind -- safe
	var uncurryThisWithBind = functionBindNative && FunctionPrototype$2.bind.bind(call$1, call$1);
	var functionUncurryThis = functionBindNative ? uncurryThisWithBind : function (fn) {
	  return function () {
	    return call$1.apply(fn, arguments);
	  };
	};

	var toString$1 = functionUncurryThis({}.toString);
	var stringSlice = functionUncurryThis(''.slice);
	var classofRaw = function (it) {
	  return stringSlice(toString$1(it), 8, -1);
	};

	var $Object$4 = Object;
	var split = functionUncurryThis(''.split);

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var indexedObject = fails(function () {
	  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
	  // eslint-disable-next-line no-prototype-builtins -- safe
	  return !$Object$4('z').propertyIsEnumerable(0);
	}) ? function (it) {
	  return classofRaw(it) === 'String' ? split(it, '') : $Object$4(it);
	} : $Object$4;

	// we can't use just `it == null` since of `document.all` special case
	// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
	var isNullOrUndefined = function (it) {
	  return it === null || it === undefined;
	};

	var $TypeError$d = TypeError;

	// `RequireObjectCoercible` abstract operation
	// https://tc39.es/ecma262/#sec-requireobjectcoercible
	var requireObjectCoercible = function (it) {
	  if (isNullOrUndefined(it)) throw new $TypeError$d("Can't call method on " + it);
	  return it;
	};

	// toObject with fallback for non-array-like ES3 strings

	var toIndexedObject = function (it) {
	  return indexedObject(requireObjectCoercible(it));
	};

	// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
	var documentAll = typeof document == 'object' && document.all;

	// `IsCallable` abstract operation
	// https://tc39.es/ecma262/#sec-iscallable
	// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
	var isCallable = typeof documentAll == 'undefined' && documentAll !== undefined ? function (argument) {
	  return typeof argument == 'function' || argument === documentAll;
	} : function (argument) {
	  return typeof argument == 'function';
	};

	var isObject = function (it) {
	  return typeof it == 'object' ? it !== null : isCallable(it);
	};

	var aFunction = function (argument) {
	  return isCallable(argument) ? argument : undefined;
	};
	var getBuiltIn = function (namespace, method) {
	  return arguments.length < 2 ? aFunction(globalThis_1[namespace]) : globalThis_1[namespace] && globalThis_1[namespace][method];
	};

	var objectIsPrototypeOf = functionUncurryThis({}.isPrototypeOf);

	var navigator = globalThis_1.navigator;
	var userAgent = navigator && navigator.userAgent;
	var environmentUserAgent = userAgent ? String(userAgent) : '';

	var process = globalThis_1.process;
	var Deno = globalThis_1.Deno;
	var versions = process && process.versions || Deno && Deno.version;
	var v8 = versions && versions.v8;
	var match, version;
	if (v8) {
	  match = v8.split('.');
	  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
	  // but their correct versions are not interesting for us
	  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
	}

	// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
	// so check `userAgent` even if `.v8` exists, but 0
	if (!version && environmentUserAgent) {
	  match = environmentUserAgent.match(/Edge\/(\d+)/);
	  if (!match || match[1] >= 74) {
	    match = environmentUserAgent.match(/Chrome\/(\d+)/);
	    if (match) version = +match[1];
	  }
	}
	var environmentV8Version = version;

	/* eslint-disable es/no-symbol -- required for testing */

	var $String$3 = globalThis_1.String;

	// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
	var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails(function () {
	  var symbol = Symbol('symbol detection');
	  // Chrome 38 Symbol has incorrect toString conversion
	  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
	  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
	  // of course, fail.
	  return !$String$3(symbol) || !(Object(symbol) instanceof Symbol) ||
	  // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
	  !Symbol.sham && environmentV8Version && environmentV8Version < 41;
	});

	/* eslint-disable es/no-symbol -- required for testing */

	var useSymbolAsUid = symbolConstructorDetection && !Symbol.sham && typeof Symbol.iterator == 'symbol';

	var $Object$3 = Object;
	var isSymbol = useSymbolAsUid ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  var $Symbol = getBuiltIn('Symbol');
	  return isCallable($Symbol) && objectIsPrototypeOf($Symbol.prototype, $Object$3(it));
	};

	var $String$2 = String;
	var tryToString = function (argument) {
	  try {
	    return $String$2(argument);
	  } catch (error) {
	    return 'Object';
	  }
	};

	var $TypeError$c = TypeError;

	// `Assert: IsCallable(argument) is true`
	var aCallable = function (argument) {
	  if (isCallable(argument)) return argument;
	  throw new $TypeError$c(tryToString(argument) + ' is not a function');
	};

	// `GetMethod` abstract operation
	// https://tc39.es/ecma262/#sec-getmethod
	var getMethod = function (V, P) {
	  var func = V[P];
	  return isNullOrUndefined(func) ? undefined : aCallable(func);
	};

	var $TypeError$b = TypeError;

	// `OrdinaryToPrimitive` abstract operation
	// https://tc39.es/ecma262/#sec-ordinarytoprimitive
	var ordinaryToPrimitive = function (input, pref) {
	  var fn, val;
	  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = functionCall(fn, input))) return val;
	  if (isCallable(fn = input.valueOf) && !isObject(val = functionCall(fn, input))) return val;
	  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = functionCall(fn, input))) return val;
	  throw new $TypeError$b("Can't convert object to primitive value");
	};

	// eslint-disable-next-line es/no-object-defineproperty -- safe
	var defineProperty = Object.defineProperty;
	var defineGlobalProperty = function (key, value) {
	  try {
	    defineProperty(globalThis_1, key, {
	      value: value,
	      configurable: true,
	      writable: true
	    });
	  } catch (error) {
	    globalThis_1[key] = value;
	  }
	  return value;
	};

	var sharedStore = createCommonjsModule(function (module) {

	  var SHARED = '__core-js_shared__';
	  var store = module.exports = globalThis_1[SHARED] || defineGlobalProperty(SHARED, {});
	  (store.versions || (store.versions = [])).push({
	    version: '3.43.0',
	    mode: 'global',
	    copyright: '© 2014-2025 Denis Pushkarev (zloirock.ru)',
	    license: 'https://github.com/zloirock/core-js/blob/v3.43.0/LICENSE',
	    source: 'https://github.com/zloirock/core-js'
	  });
	});

	var shared = function (key, value) {
	  return sharedStore[key] || (sharedStore[key] = value || {});
	};

	var $Object$2 = Object;

	// `ToObject` abstract operation
	// https://tc39.es/ecma262/#sec-toobject
	var toObject = function (argument) {
	  return $Object$2(requireObjectCoercible(argument));
	};

	var hasOwnProperty = functionUncurryThis({}.hasOwnProperty);

	// `HasOwnProperty` abstract operation
	// https://tc39.es/ecma262/#sec-hasownproperty
	// eslint-disable-next-line es/no-object-hasown -- safe
	var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
	  return hasOwnProperty(toObject(it), key);
	};

	var id = 0;
	var postfix = Math.random();
	var toString = functionUncurryThis(1.1.toString);
	var uid = function (key) {
	  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
	};

	var Symbol$1 = globalThis_1.Symbol;
	var WellKnownSymbolsStore = shared('wks');
	var createWellKnownSymbol = useSymbolAsUid ? Symbol$1['for'] || Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid;
	var wellKnownSymbol = function (name) {
	  if (!hasOwnProperty_1(WellKnownSymbolsStore, name)) {
	    WellKnownSymbolsStore[name] = symbolConstructorDetection && hasOwnProperty_1(Symbol$1, name) ? Symbol$1[name] : createWellKnownSymbol('Symbol.' + name);
	  }
	  return WellKnownSymbolsStore[name];
	};

	var $TypeError$a = TypeError;
	var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

	// `ToPrimitive` abstract operation
	// https://tc39.es/ecma262/#sec-toprimitive
	var toPrimitive = function (input, pref) {
	  if (!isObject(input) || isSymbol(input)) return input;
	  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
	  var result;
	  if (exoticToPrim) {
	    if (pref === undefined) pref = 'default';
	    result = functionCall(exoticToPrim, input, pref);
	    if (!isObject(result) || isSymbol(result)) return result;
	    throw new $TypeError$a("Can't convert object to primitive value");
	  }
	  if (pref === undefined) pref = 'number';
	  return ordinaryToPrimitive(input, pref);
	};

	// `ToPropertyKey` abstract operation
	// https://tc39.es/ecma262/#sec-topropertykey
	var toPropertyKey = function (argument) {
	  var key = toPrimitive(argument, 'string');
	  return isSymbol(key) ? key : key + '';
	};

	var document$1 = globalThis_1.document;
	// typeof document.createElement is 'object' in old IE
	var EXISTS$1 = isObject(document$1) && isObject(document$1.createElement);
	var documentCreateElement = function (it) {
	  return EXISTS$1 ? document$1.createElement(it) : {};
	};

	// Thanks to IE8 for its funny defineProperty
	var ie8DomDefine = !descriptors && !fails(function () {
	  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
	  return Object.defineProperty(documentCreateElement('div'), 'a', {
	    get: function () {
	      return 7;
	    }
	  }).a !== 7;
	});

	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

	// `Object.getOwnPropertyDescriptor` method
	// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
	var f$4 = descriptors ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
	  O = toIndexedObject(O);
	  P = toPropertyKey(P);
	  if (ie8DomDefine) try {
	    return $getOwnPropertyDescriptor$1(O, P);
	  } catch (error) {/* empty */}
	  if (hasOwnProperty_1(O, P)) return createPropertyDescriptor(!functionCall(objectPropertyIsEnumerable.f, O, P), O[P]);
	};
	var objectGetOwnPropertyDescriptor = {
	  f: f$4
	};

	// V8 ~ Chrome 36-
	// https://bugs.chromium.org/p/v8/issues/detail?id=3334
	var v8PrototypeDefineBug = descriptors && fails(function () {
	  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
	  return Object.defineProperty(function () {/* empty */}, 'prototype', {
	    value: 42,
	    writable: false
	  }).prototype !== 42;
	});

	var $String$1 = String;
	var $TypeError$9 = TypeError;

	// `Assert: Type(argument) is Object`
	var anObject = function (argument) {
	  if (isObject(argument)) return argument;
	  throw new $TypeError$9($String$1(argument) + ' is not an object');
	};

	var $TypeError$8 = TypeError;
	// eslint-disable-next-line es/no-object-defineproperty -- safe
	var $defineProperty = Object.defineProperty;
	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var ENUMERABLE = 'enumerable';
	var CONFIGURABLE$1 = 'configurable';
	var WRITABLE = 'writable';

	// `Object.defineProperty` method
	// https://tc39.es/ecma262/#sec-object.defineproperty
	var f$3 = descriptors ? v8PrototypeDefineBug ? function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPropertyKey(P);
	  anObject(Attributes);
	  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
	    var current = $getOwnPropertyDescriptor(O, P);
	    if (current && current[WRITABLE]) {
	      O[P] = Attributes.value;
	      Attributes = {
	        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
	        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
	        writable: false
	      };
	    }
	  }
	  return $defineProperty(O, P, Attributes);
	} : $defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPropertyKey(P);
	  anObject(Attributes);
	  if (ie8DomDefine) try {
	    return $defineProperty(O, P, Attributes);
	  } catch (error) {/* empty */}
	  if ('get' in Attributes || 'set' in Attributes) throw new $TypeError$8('Accessors not supported');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};
	var objectDefineProperty = {
	  f: f$3
	};

	var createNonEnumerableProperty = descriptors ? function (object, key, value) {
	  return objectDefineProperty.f(object, key, createPropertyDescriptor(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};

	var FunctionPrototype$1 = Function.prototype;
	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var getDescriptor = descriptors && Object.getOwnPropertyDescriptor;
	var EXISTS = hasOwnProperty_1(FunctionPrototype$1, 'name');
	// additional protection from minified / mangled / dropped function names
	var PROPER = EXISTS && function something() {/* empty */}.name === 'something';
	var CONFIGURABLE = EXISTS && (!descriptors || descriptors && getDescriptor(FunctionPrototype$1, 'name').configurable);
	var functionName = {
	  EXISTS: EXISTS,
	  PROPER: PROPER,
	  CONFIGURABLE: CONFIGURABLE
	};

	var functionToString = functionUncurryThis(Function.toString);

	// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
	if (!isCallable(sharedStore.inspectSource)) {
	  sharedStore.inspectSource = function (it) {
	    return functionToString(it);
	  };
	}
	var inspectSource = sharedStore.inspectSource;

	var WeakMap$1 = globalThis_1.WeakMap;
	var weakMapBasicDetection = isCallable(WeakMap$1) && /native code/.test(String(WeakMap$1));

	var keys = shared('keys');
	var sharedKey = function (key) {
	  return keys[key] || (keys[key] = uid(key));
	};

	var hiddenKeys$1 = {};

	var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
	var TypeError$1 = globalThis_1.TypeError;
	var WeakMap = globalThis_1.WeakMap;
	var set, get, has$1;
	var enforce = function (it) {
	  return has$1(it) ? get(it) : set(it, {});
	};
	var getterFor = function (TYPE) {
	  return function (it) {
	    var state;
	    if (!isObject(it) || (state = get(it)).type !== TYPE) {
	      throw new TypeError$1('Incompatible receiver, ' + TYPE + ' required');
	    }
	    return state;
	  };
	};
	if (weakMapBasicDetection || sharedStore.state) {
	  var store = sharedStore.state || (sharedStore.state = new WeakMap());
	  /* eslint-disable no-self-assign -- prototype methods protection */
	  store.get = store.get;
	  store.has = store.has;
	  store.set = store.set;
	  /* eslint-enable no-self-assign -- prototype methods protection */
	  set = function (it, metadata) {
	    if (store.has(it)) throw new TypeError$1(OBJECT_ALREADY_INITIALIZED);
	    metadata.facade = it;
	    store.set(it, metadata);
	    return metadata;
	  };
	  get = function (it) {
	    return store.get(it) || {};
	  };
	  has$1 = function (it) {
	    return store.has(it);
	  };
	} else {
	  var STATE = sharedKey('state');
	  hiddenKeys$1[STATE] = true;
	  set = function (it, metadata) {
	    if (hasOwnProperty_1(it, STATE)) throw new TypeError$1(OBJECT_ALREADY_INITIALIZED);
	    metadata.facade = it;
	    createNonEnumerableProperty(it, STATE, metadata);
	    return metadata;
	  };
	  get = function (it) {
	    return hasOwnProperty_1(it, STATE) ? it[STATE] : {};
	  };
	  has$1 = function (it) {
	    return hasOwnProperty_1(it, STATE);
	  };
	}
	var internalState = {
	  set: set,
	  get: get,
	  has: has$1,
	  enforce: enforce,
	  getterFor: getterFor
	};

	var makeBuiltIn_1 = createCommonjsModule(function (module) {

	  var CONFIGURABLE_FUNCTION_NAME = functionName.CONFIGURABLE;
	  var enforceInternalState = internalState.enforce;
	  var getInternalState = internalState.get;
	  var $String = String;
	  // eslint-disable-next-line es/no-object-defineproperty -- safe
	  var defineProperty = Object.defineProperty;
	  var stringSlice = functionUncurryThis(''.slice);
	  var replace = functionUncurryThis(''.replace);
	  var join = functionUncurryThis([].join);
	  var CONFIGURABLE_LENGTH = descriptors && !fails(function () {
	    return defineProperty(function () {/* empty */}, 'length', {
	      value: 8
	    }).length !== 8;
	  });
	  var TEMPLATE = String(String).split('String');
	  var makeBuiltIn = module.exports = function (value, name, options) {
	    if (stringSlice($String(name), 0, 7) === 'Symbol(') {
	      name = '[' + replace($String(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
	    }
	    if (options && options.getter) name = 'get ' + name;
	    if (options && options.setter) name = 'set ' + name;
	    if (!hasOwnProperty_1(value, 'name') || CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
	      if (descriptors) defineProperty(value, 'name', {
	        value: name,
	        configurable: true
	      });else value.name = name;
	    }
	    if (CONFIGURABLE_LENGTH && options && hasOwnProperty_1(options, 'arity') && value.length !== options.arity) {
	      defineProperty(value, 'length', {
	        value: options.arity
	      });
	    }
	    try {
	      if (options && hasOwnProperty_1(options, 'constructor') && options.constructor) {
	        if (descriptors) defineProperty(value, 'prototype', {
	          writable: false
	        });
	        // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
	      } else if (value.prototype) value.prototype = undefined;
	    } catch (error) {/* empty */}
	    var state = enforceInternalState(value);
	    if (!hasOwnProperty_1(state, 'source')) {
	      state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
	    }
	    return value;
	  };

	  // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	  // eslint-disable-next-line no-extend-native -- required
	  Function.prototype.toString = makeBuiltIn(function toString() {
	    return isCallable(this) && getInternalState(this).source || inspectSource(this);
	  }, 'toString');
	});

	var defineBuiltIn = function (O, key, value, options) {
	  if (!options) options = {};
	  var simple = options.enumerable;
	  var name = options.name !== undefined ? options.name : key;
	  if (isCallable(value)) makeBuiltIn_1(value, name, options);
	  if (options.global) {
	    if (simple) O[key] = value;else defineGlobalProperty(key, value);
	  } else {
	    try {
	      if (!options.unsafe) delete O[key];else if (O[key]) simple = true;
	    } catch (error) {/* empty */}
	    if (simple) O[key] = value;else objectDefineProperty.f(O, key, {
	      value: value,
	      enumerable: false,
	      configurable: !options.nonConfigurable,
	      writable: !options.nonWritable
	    });
	  }
	  return O;
	};

	var ceil = Math.ceil;
	var floor = Math.floor;

	// `Math.trunc` method
	// https://tc39.es/ecma262/#sec-math.trunc
	// eslint-disable-next-line es/no-math-trunc -- safe
	var mathTrunc = Math.trunc || function trunc(x) {
	  var n = +x;
	  return (n > 0 ? floor : ceil)(n);
	};

	// `ToIntegerOrInfinity` abstract operation
	// https://tc39.es/ecma262/#sec-tointegerorinfinity
	var toIntegerOrInfinity = function (argument) {
	  var number = +argument;
	  // eslint-disable-next-line no-self-compare -- NaN check
	  return number !== number || number === 0 ? 0 : mathTrunc(number);
	};

	var max = Math.max;
	var min$1 = Math.min;

	// Helper for a popular repeating case of the spec:
	// Let integer be ? ToInteger(index).
	// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
	var toAbsoluteIndex = function (index, length) {
	  var integer = toIntegerOrInfinity(index);
	  return integer < 0 ? max(integer + length, 0) : min$1(integer, length);
	};

	var min = Math.min;

	// `ToLength` abstract operation
	// https://tc39.es/ecma262/#sec-tolength
	var toLength = function (argument) {
	  var len = toIntegerOrInfinity(argument);
	  return len > 0 ? min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
	};

	// `LengthOfArrayLike` abstract operation
	// https://tc39.es/ecma262/#sec-lengthofarraylike
	var lengthOfArrayLike = function (obj) {
	  return toLength(obj.length);
	};

	// `Array.prototype.{ indexOf, includes }` methods implementation
	var createMethod = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIndexedObject($this);
	    var length = lengthOfArrayLike(O);
	    if (length === 0) return !IS_INCLUDES && -1;
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare -- NaN check
	    if (IS_INCLUDES && el !== el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare -- NaN check
	      if (value !== value) return true;
	      // Array#indexOf ignores holes, Array#includes - not
	    } else for (; length > index; index++) {
	      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
	    }
	    return !IS_INCLUDES && -1;
	  };
	};
	var arrayIncludes = {
	  // `Array.prototype.includes` method
	  // https://tc39.es/ecma262/#sec-array.prototype.includes
	  includes: createMethod(true),
	  // `Array.prototype.indexOf` method
	  // https://tc39.es/ecma262/#sec-array.prototype.indexof
	  indexOf: createMethod(false)
	};

	var indexOf = arrayIncludes.indexOf;
	var push$1 = functionUncurryThis([].push);
	var objectKeysInternal = function (object, names) {
	  var O = toIndexedObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) !hasOwnProperty_1(hiddenKeys$1, key) && hasOwnProperty_1(O, key) && push$1(result, key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (hasOwnProperty_1(O, key = names[i++])) {
	    ~indexOf(result, key) || push$1(result, key);
	  }
	  return result;
	};

	// IE8- don't enum bug keys
	var enumBugKeys = ['constructor', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'toLocaleString', 'toString', 'valueOf'];

	var hiddenKeys = enumBugKeys.concat('length', 'prototype');

	// `Object.getOwnPropertyNames` method
	// https://tc39.es/ecma262/#sec-object.getownpropertynames
	// eslint-disable-next-line es/no-object-getownpropertynames -- safe
	var f$2 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return objectKeysInternal(O, hiddenKeys);
	};
	var objectGetOwnPropertyNames = {
	  f: f$2
	};

	// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
	var f$1 = Object.getOwnPropertySymbols;
	var objectGetOwnPropertySymbols = {
	  f: f$1
	};

	var concat = functionUncurryThis([].concat);

	// all object keys, includes non-enumerable and symbols
	var ownKeys = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
	  var keys = objectGetOwnPropertyNames.f(anObject(it));
	  var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
	  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
	};

	var copyConstructorProperties = function (target, source, exceptions) {
	  var keys = ownKeys(source);
	  var defineProperty = objectDefineProperty.f;
	  var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    if (!hasOwnProperty_1(target, key) && !(exceptions && hasOwnProperty_1(exceptions, key))) {
	      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
	    }
	  }
	};

	var replacement = /#|\.prototype\./;
	var isForced = function (feature, detection) {
	  var value = data[normalize(feature)];
	  return value === POLYFILL ? true : value === NATIVE ? false : isCallable(detection) ? fails(detection) : !!detection;
	};
	var normalize = isForced.normalize = function (string) {
	  return String(string).replace(replacement, '.').toLowerCase();
	};
	var data = isForced.data = {};
	var NATIVE = isForced.NATIVE = 'N';
	var POLYFILL = isForced.POLYFILL = 'P';
	var isForced_1 = isForced;

	var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;

	/*
	  options.target         - name of the target object
	  options.global         - target is the global object
	  options.stat           - export as static methods of target
	  options.proto          - export as prototype methods of target
	  options.real           - real prototype method for the `pure` version
	  options.forced         - export even if the native feature is available
	  options.bind           - bind methods to the target, required for the `pure` version
	  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
	  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
	  options.sham           - add a flag to not completely full polyfills
	  options.enumerable     - export as enumerable property
	  options.dontCallGetSet - prevent calling a getter on target
	  options.name           - the .name of the function if it does not match the key
	*/
	var _export = function (options, source) {
	  var TARGET = options.target;
	  var GLOBAL = options.global;
	  var STATIC = options.stat;
	  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
	  if (GLOBAL) {
	    target = globalThis_1;
	  } else if (STATIC) {
	    target = globalThis_1[TARGET] || defineGlobalProperty(TARGET, {});
	  } else {
	    target = globalThis_1[TARGET] && globalThis_1[TARGET].prototype;
	  }
	  if (target) for (key in source) {
	    sourceProperty = source[key];
	    if (options.dontCallGetSet) {
	      descriptor = getOwnPropertyDescriptor$1(target, key);
	      targetProperty = descriptor && descriptor.value;
	    } else targetProperty = target[key];
	    FORCED = isForced_1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
	    // contained in target
	    if (!FORCED && targetProperty !== undefined) {
	      if (typeof sourceProperty == typeof targetProperty) continue;
	      copyConstructorProperties(sourceProperty, targetProperty);
	    }
	    // add a flag to not completely full polyfills
	    if (options.sham || targetProperty && targetProperty.sham) {
	      createNonEnumerableProperty(sourceProperty, 'sham', true);
	    }
	    defineBuiltIn(target, key, sourceProperty, options);
	  }
	};

	var $TypeError$7 = TypeError;
	var anInstance = function (it, Prototype) {
	  if (objectIsPrototypeOf(Prototype, it)) return it;
	  throw new $TypeError$7('Incorrect invocation');
	};

	var correctPrototypeGetter = !fails(function () {
	  function F() {/* empty */}
	  F.prototype.constructor = null;
	  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
	  return Object.getPrototypeOf(new F()) !== F.prototype;
	});

	var IE_PROTO$1 = sharedKey('IE_PROTO');
	var $Object$1 = Object;
	var ObjectPrototype = $Object$1.prototype;

	// `Object.getPrototypeOf` method
	// https://tc39.es/ecma262/#sec-object.getprototypeof
	// eslint-disable-next-line es/no-object-getprototypeof -- safe
	var objectGetPrototypeOf = correctPrototypeGetter ? $Object$1.getPrototypeOf : function (O) {
	  var object = toObject(O);
	  if (hasOwnProperty_1(object, IE_PROTO$1)) return object[IE_PROTO$1];
	  var constructor = object.constructor;
	  if (isCallable(constructor) && object instanceof constructor) {
	    return constructor.prototype;
	  }
	  return object instanceof $Object$1 ? ObjectPrototype : null;
	};

	var defineBuiltInAccessor = function (target, name, descriptor) {
	  if (descriptor.get) makeBuiltIn_1(descriptor.get, name, {
	    getter: true
	  });
	  if (descriptor.set) makeBuiltIn_1(descriptor.set, name, {
	    setter: true
	  });
	  return objectDefineProperty.f(target, name, descriptor);
	};

	var createProperty = function (object, key, value) {
	  if (descriptors) objectDefineProperty.f(object, key, createPropertyDescriptor(0, value));else object[key] = value;
	};

	// `Object.keys` method
	// https://tc39.es/ecma262/#sec-object.keys
	// eslint-disable-next-line es/no-object-keys -- safe
	var objectKeys = Object.keys || function keys(O) {
	  return objectKeysInternal(O, enumBugKeys);
	};

	// `Object.defineProperties` method
	// https://tc39.es/ecma262/#sec-object.defineproperties
	// eslint-disable-next-line es/no-object-defineproperties -- safe
	var f = descriptors && !v8PrototypeDefineBug ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var props = toIndexedObject(Properties);
	  var keys = objectKeys(Properties);
	  var length = keys.length;
	  var index = 0;
	  var key;
	  while (length > index) objectDefineProperty.f(O, key = keys[index++], props[key]);
	  return O;
	};
	var objectDefineProperties = {
	  f: f
	};

	var html$1 = getBuiltIn('document', 'documentElement');

	/* global ActiveXObject -- old IE, WSH */

	var GT = '>';
	var LT = '<';
	var PROTOTYPE = 'prototype';
	var SCRIPT = 'script';
	var IE_PROTO = sharedKey('IE_PROTO');
	var EmptyConstructor = function () {/* empty */};
	var scriptTag = function (content) {
	  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
	};

	// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
	var NullProtoObjectViaActiveX = function (activeXDocument) {
	  activeXDocument.write(scriptTag(''));
	  activeXDocument.close();
	  var temp = activeXDocument.parentWindow.Object;
	  // eslint-disable-next-line no-useless-assignment -- avoid memory leak
	  activeXDocument = null;
	  return temp;
	};

	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var NullProtoObjectViaIFrame = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = documentCreateElement('iframe');
	  var JS = 'java' + SCRIPT + ':';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  html$1.appendChild(iframe);
	  // https://github.com/zloirock/core-js/issues/475
	  iframe.src = String(JS);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(scriptTag('document.F=Object'));
	  iframeDocument.close();
	  return iframeDocument.F;
	};

	// Check for document.domain and active x support
	// No need to use active x approach when document.domain is not set
	// see https://github.com/es-shims/es5-shim/issues/150
	// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
	// avoid IE GC bug
	var activeXDocument;
	var NullProtoObject = function () {
	  try {
	    activeXDocument = new ActiveXObject('htmlfile');
	  } catch (error) {/* ignore */}
	  NullProtoObject = typeof document != 'undefined' ? document.domain && activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) // old IE
	  : NullProtoObjectViaIFrame() : NullProtoObjectViaActiveX(activeXDocument); // WSH
	  var length = enumBugKeys.length;
	  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
	  return NullProtoObject();
	};
	hiddenKeys$1[IE_PROTO] = true;

	// `Object.create` method
	// https://tc39.es/ecma262/#sec-object.create
	// eslint-disable-next-line es/no-object-create -- safe
	var objectCreate = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    EmptyConstructor[PROTOTYPE] = anObject(O);
	    result = new EmptyConstructor();
	    EmptyConstructor[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = NullProtoObject();
	  return Properties === undefined ? result : objectDefineProperties.f(result, Properties);
	};

	var ITERATOR$3 = wellKnownSymbol('iterator');
	var BUGGY_SAFARI_ITERATORS = false;

	// `%IteratorPrototype%` object
	// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
	var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

	/* eslint-disable es/no-array-prototype-keys -- safe */
	if ([].keys) {
	  arrayIterator = [].keys();
	  // Safari 8 has buggy iterators w/o `next`
	  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;else {
	    PrototypeOfArrayIteratorPrototype = objectGetPrototypeOf(objectGetPrototypeOf(arrayIterator));
	    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
	  }
	}
	var NEW_ITERATOR_PROTOTYPE = !isObject(IteratorPrototype$2) || fails(function () {
	  var test = {};
	  // FF44- legacy iterators case
	  return IteratorPrototype$2[ITERATOR$3].call(test) !== test;
	});
	if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$2 = {};

	// `%IteratorPrototype%[@@iterator]()` method
	// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
	if (!isCallable(IteratorPrototype$2[ITERATOR$3])) {
	  defineBuiltIn(IteratorPrototype$2, ITERATOR$3, function () {
	    return this;
	  });
	}
	var iteratorsCore = {
	  IteratorPrototype: IteratorPrototype$2,
	  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
	};

	var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
	var CONSTRUCTOR = 'constructor';
	var ITERATOR$2 = 'Iterator';
	var TO_STRING_TAG$3 = wellKnownSymbol('toStringTag');
	var $TypeError$6 = TypeError;
	var NativeIterator = globalThis_1[ITERATOR$2];

	// FF56- have non-standard global helper `Iterator`
	var FORCED$3 = !isCallable(NativeIterator) || NativeIterator.prototype !== IteratorPrototype$1
	// FF44- non-standard `Iterator` passes previous tests
	|| !fails(function () {
	  NativeIterator({});
	});
	var IteratorConstructor = function Iterator() {
	  anInstance(this, IteratorPrototype$1);
	  if (objectGetPrototypeOf(this) === IteratorPrototype$1) throw new $TypeError$6('Abstract class Iterator not directly constructable');
	};
	var defineIteratorPrototypeAccessor = function (key, value) {
	  if (descriptors) {
	    defineBuiltInAccessor(IteratorPrototype$1, key, {
	      configurable: true,
	      get: function () {
	        return value;
	      },
	      set: function (replacement) {
	        anObject(this);
	        if (this === IteratorPrototype$1) throw new $TypeError$6("You can't redefine this property");
	        if (hasOwnProperty_1(this, key)) this[key] = replacement;else createProperty(this, key, replacement);
	      }
	    });
	  } else IteratorPrototype$1[key] = value;
	};
	if (!hasOwnProperty_1(IteratorPrototype$1, TO_STRING_TAG$3)) defineIteratorPrototypeAccessor(TO_STRING_TAG$3, ITERATOR$2);
	if (FORCED$3 || !hasOwnProperty_1(IteratorPrototype$1, CONSTRUCTOR) || IteratorPrototype$1[CONSTRUCTOR] === Object) {
	  defineIteratorPrototypeAccessor(CONSTRUCTOR, IteratorConstructor);
	}
	IteratorConstructor.prototype = IteratorPrototype$1;

	// `Iterator` constructor
	// https://tc39.es/ecma262/#sec-iterator
	_export({
	  global: true,
	  constructor: true,
	  forced: FORCED$3
	}, {
	  Iterator: IteratorConstructor
	});

	var functionUncurryThisClause = function (fn) {
	  // Nashorn bug:
	  //   https://github.com/zloirock/core-js/issues/1128
	  //   https://github.com/zloirock/core-js/issues/1130
	  if (classofRaw(fn) === 'Function') return functionUncurryThis(fn);
	};

	var bind = functionUncurryThisClause(functionUncurryThisClause.bind);

	// optional / simple context binding
	var functionBindContext = function (fn, that) {
	  aCallable(fn);
	  return that === undefined ? fn : functionBindNative ? bind(fn, that) : function /* ...args */
	  () {
	    return fn.apply(that, arguments);
	  };
	};

	var iterators = {};

	var ITERATOR$1 = wellKnownSymbol('iterator');
	var ArrayPrototype = Array.prototype;

	// check on default Array iterator
	var isArrayIteratorMethod = function (it) {
	  return it !== undefined && (iterators.Array === it || ArrayPrototype[ITERATOR$1] === it);
	};

	var TO_STRING_TAG$2 = wellKnownSymbol('toStringTag');
	var test = {};
	test[TO_STRING_TAG$2] = 'z';
	var toStringTagSupport = String(test) === '[object z]';

	var TO_STRING_TAG$1 = wellKnownSymbol('toStringTag');
	var $Object = Object;

	// ES3 wrong here
	var CORRECT_ARGUMENTS = classofRaw(function () {
	  return arguments;
	}()) === 'Arguments';

	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (error) {/* empty */}
	};

	// getting tag from ES6+ `Object.prototype.toString`
	var classof = toStringTagSupport ? classofRaw : function (it) {
	  var O, tag, result;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	  // @@toStringTag case
	  : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG$1)) == 'string' ? tag
	  // builtinTag case
	  : CORRECT_ARGUMENTS ? classofRaw(O)
	  // ES3 arguments fallback
	  : (result = classofRaw(O)) === 'Object' && isCallable(O.callee) ? 'Arguments' : result;
	};

	var ITERATOR = wellKnownSymbol('iterator');
	var getIteratorMethod = function (it) {
	  if (!isNullOrUndefined(it)) return getMethod(it, ITERATOR) || getMethod(it, '@@iterator') || iterators[classof(it)];
	};

	var $TypeError$5 = TypeError;
	var getIterator = function (argument, usingIterator) {
	  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
	  if (aCallable(iteratorMethod)) return anObject(functionCall(iteratorMethod, argument));
	  throw new $TypeError$5(tryToString(argument) + ' is not iterable');
	};

	var iteratorClose = function (iterator, kind, value) {
	  var innerResult, innerError;
	  anObject(iterator);
	  try {
	    innerResult = getMethod(iterator, 'return');
	    if (!innerResult) {
	      if (kind === 'throw') throw value;
	      return value;
	    }
	    innerResult = functionCall(innerResult, iterator);
	  } catch (error) {
	    innerError = true;
	    innerResult = error;
	  }
	  if (kind === 'throw') throw value;
	  if (innerError) throw innerResult;
	  anObject(innerResult);
	  return value;
	};

	var $TypeError$4 = TypeError;
	var Result = function (stopped, result) {
	  this.stopped = stopped;
	  this.result = result;
	};
	var ResultPrototype = Result.prototype;
	var iterate = function (iterable, unboundFunction, options) {
	  var that = options && options.that;
	  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
	  var IS_RECORD = !!(options && options.IS_RECORD);
	  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
	  var INTERRUPTED = !!(options && options.INTERRUPTED);
	  var fn = functionBindContext(unboundFunction, that);
	  var iterator, iterFn, index, length, result, next, step;
	  var stop = function (condition) {
	    if (iterator) iteratorClose(iterator, 'normal');
	    return new Result(true, condition);
	  };
	  var callFn = function (value) {
	    if (AS_ENTRIES) {
	      anObject(value);
	      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
	    }
	    return INTERRUPTED ? fn(value, stop) : fn(value);
	  };
	  if (IS_RECORD) {
	    iterator = iterable.iterator;
	  } else if (IS_ITERATOR) {
	    iterator = iterable;
	  } else {
	    iterFn = getIteratorMethod(iterable);
	    if (!iterFn) throw new $TypeError$4(tryToString(iterable) + ' is not iterable');
	    // optimisation for array iterators
	    if (isArrayIteratorMethod(iterFn)) {
	      for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
	        result = callFn(iterable[index]);
	        if (result && objectIsPrototypeOf(ResultPrototype, result)) return result;
	      }
	      return new Result(false);
	    }
	    iterator = getIterator(iterable, iterFn);
	  }
	  next = IS_RECORD ? iterable.next : iterator.next;
	  while (!(step = functionCall(next, iterator)).done) {
	    try {
	      result = callFn(step.value);
	    } catch (error) {
	      iteratorClose(iterator, 'throw', error);
	    }
	    if (typeof result == 'object' && result && objectIsPrototypeOf(ResultPrototype, result)) return result;
	  }
	  return new Result(false);
	};

	// `GetIteratorDirect(obj)` abstract operation
	// https://tc39.es/proposal-iterator-helpers/#sec-getiteratordirect
	var getIteratorDirect = function (obj) {
	  return {
	    iterator: obj,
	    next: obj.next,
	    done: false
	  };
	};

	// https://github.com/tc39/ecma262/pull/3467
	var iteratorHelperWithoutClosingOnEarlyError = function (METHOD_NAME, ExpectedError) {
	  var Iterator = globalThis_1.Iterator;
	  var IteratorPrototype = Iterator && Iterator.prototype;
	  var method = IteratorPrototype && IteratorPrototype[METHOD_NAME];
	  var CLOSED = false;
	  if (method) try {
	    method.call({
	      next: function () {
	        return {
	          done: true
	        };
	      },
	      'return': function () {
	        CLOSED = true;
	      }
	    }, -1);
	  } catch (error) {
	    // https://bugs.webkit.org/show_bug.cgi?id=291195
	    if (!(error instanceof ExpectedError)) CLOSED = false;
	  }
	  if (!CLOSED) return method;
	};

	var forEachWithoutClosingOnEarlyError = iteratorHelperWithoutClosingOnEarlyError('forEach', TypeError);

	// `Iterator.prototype.forEach` method
	// https://tc39.es/ecma262/#sec-iterator.prototype.foreach
	_export({
	  target: 'Iterator',
	  proto: true,
	  real: true,
	  forced: forEachWithoutClosingOnEarlyError
	}, {
	  forEach: function forEach(fn) {
	    anObject(this);
	    try {
	      aCallable(fn);
	    } catch (error) {
	      iteratorClose(this, 'throw', error);
	    }
	    if (forEachWithoutClosingOnEarlyError) return functionCall(forEachWithoutClosingOnEarlyError, this, fn);
	    var record = getIteratorDirect(this);
	    var counter = 0;
	    iterate(record, function (value) {
	      fn(value, counter++);
	    }, {
	      IS_RECORD: true
	    });
	  }
	});

	Math.log10 = Math.log10 || function (x) {
	  return Math.log(x) * Math.LOG10E;
	};

	// `IsArray` abstract operation
	// https://tc39.es/ecma262/#sec-isarray
	// eslint-disable-next-line es/no-array-isarray -- safe
	var isArray = Array.isArray || function isArray(argument) {
	  return classofRaw(argument) === 'Array';
	};

	var $TypeError$3 = TypeError;
	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

	// Safari < 13 does not throw an error in this case
	var SILENT_ON_NON_WRITABLE_LENGTH_SET = descriptors && !function () {
	  // makes no sense without proper strict mode support
	  if (this !== undefined) return true;
	  try {
	    // eslint-disable-next-line es/no-object-defineproperty -- safe
	    Object.defineProperty([], 'length', {
	      writable: false
	    }).length = 1;
	  } catch (error) {
	    return error instanceof TypeError;
	  }
	}();
	var arraySetLength = SILENT_ON_NON_WRITABLE_LENGTH_SET ? function (O, length) {
	  if (isArray(O) && !getOwnPropertyDescriptor(O, 'length').writable) {
	    throw new $TypeError$3('Cannot set read only .length');
	  }
	  return O.length = length;
	} : function (O, length) {
	  return O.length = length;
	};

	var $TypeError$2 = TypeError;
	var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

	var doesNotExceedSafeInteger = function (it) {
	  if (it > MAX_SAFE_INTEGER) throw $TypeError$2('Maximum allowed index exceeded');
	  return it;
	};

	var INCORRECT_TO_LENGTH = fails(function () {
	  return [].push.call({
	    length: 0x100000000
	  }, 1) !== 4294967297;
	});

	// V8 <= 121 and Safari <= 15.4; FF < 23 throws InternalError
	// https://bugs.chromium.org/p/v8/issues/detail?id=12681
	var properErrorOnNonWritableLength = function () {
	  try {
	    // eslint-disable-next-line es/no-object-defineproperty -- safe
	    Object.defineProperty([], 'length', {
	      writable: false
	    }).push();
	  } catch (error) {
	    return error instanceof TypeError;
	  }
	};
	var FORCED$2 = INCORRECT_TO_LENGTH || !properErrorOnNonWritableLength();

	// `Array.prototype.push` method
	// https://tc39.es/ecma262/#sec-array.prototype.push
	_export({
	  target: 'Array',
	  proto: true,
	  arity: 1,
	  forced: FORCED$2
	}, {
	  // eslint-disable-next-line no-unused-vars -- required for `.length`
	  push: function push(item) {
	    var O = toObject(this);
	    var len = lengthOfArrayLike(O);
	    var argCount = arguments.length;
	    doesNotExceedSafeInteger(len + argCount);
	    for (var i = 0; i < argCount; i++) {
	      O[len] = arguments[i];
	      len++;
	    }
	    arraySetLength(O, len);
	    return len;
	  }
	});

	var FunctionPrototype = Function.prototype;
	var apply = FunctionPrototype.apply;
	var call = FunctionPrototype.call;

	// eslint-disable-next-line es/no-function-prototype-bind, es/no-reflect -- safe
	var functionApply = typeof Reflect == 'object' && Reflect.apply || (functionBindNative ? call.bind(apply) : function () {
	  return call.apply(apply, arguments);
	});

	var $TypeError$1 = TypeError;

	// https://bugs.webkit.org/show_bug.cgi?id=291651
	var FAILS_ON_INITIAL_UNDEFINED = fails(function () {
	  // eslint-disable-next-line es/no-iterator-prototype-reduce, es/no-array-prototype-keys, array-callback-return -- required for testing
	  [].keys().reduce(function () {/* empty */}, undefined);
	});
	var reduceWithoutClosingOnEarlyError = !FAILS_ON_INITIAL_UNDEFINED && iteratorHelperWithoutClosingOnEarlyError('reduce', $TypeError$1);

	// `Iterator.prototype.reduce` method
	// https://tc39.es/ecma262/#sec-iterator.prototype.reduce
	_export({
	  target: 'Iterator',
	  proto: true,
	  real: true,
	  forced: FAILS_ON_INITIAL_UNDEFINED || reduceWithoutClosingOnEarlyError
	}, {
	  reduce: function reduce(reducer /* , initialValue */) {
	    anObject(this);
	    try {
	      aCallable(reducer);
	    } catch (error) {
	      iteratorClose(this, 'throw', error);
	    }
	    var noInitial = arguments.length < 2;
	    var accumulator = noInitial ? undefined : arguments[1];
	    if (reduceWithoutClosingOnEarlyError) {
	      return functionApply(reduceWithoutClosingOnEarlyError, this, noInitial ? [reducer] : [reducer, accumulator]);
	    }
	    var record = getIteratorDirect(this);
	    var counter = 0;
	    iterate(record, function (value) {
	      if (noInitial) {
	        noInitial = false;
	        accumulator = value;
	      } else {
	        accumulator = reducer(accumulator, value, counter);
	      }
	      counter++;
	    }, {
	      IS_RECORD: true
	    });
	    if (noInitial) throw new $TypeError$1('Reduce of empty iterator with no initial value');
	    return accumulator;
	  }
	});

	var defineBuiltIns = function (target, src, options) {
	  for (var key in src) defineBuiltIn(target, key, src[key], options);
	  return target;
	};

	// `CreateIterResultObject` abstract operation
	// https://tc39.es/ecma262/#sec-createiterresultobject
	var createIterResultObject = function (value, done) {
	  return {
	    value: value,
	    done: done
	  };
	};

	var iteratorCloseAll = function (iters, kind, value) {
	  for (var i = iters.length - 1; i >= 0; i--) {
	    if (iters[i] === undefined) continue;
	    try {
	      value = iteratorClose(iters[i].iterator, kind, value);
	    } catch (error) {
	      kind = 'throw';
	      value = error;
	    }
	  }
	  if (kind === 'throw') throw value;
	  return value;
	};

	var IteratorPrototype = iteratorsCore.IteratorPrototype;
	var TO_STRING_TAG = wellKnownSymbol('toStringTag');
	var ITERATOR_HELPER = 'IteratorHelper';
	var WRAP_FOR_VALID_ITERATOR = 'WrapForValidIterator';
	var NORMAL = 'normal';
	var THROW = 'throw';
	var setInternalState = internalState.set;
	var createIteratorProxyPrototype = function (IS_ITERATOR) {
	  var getInternalState = internalState.getterFor(IS_ITERATOR ? WRAP_FOR_VALID_ITERATOR : ITERATOR_HELPER);
	  return defineBuiltIns(objectCreate(IteratorPrototype), {
	    next: function next() {
	      var state = getInternalState(this);
	      // for simplification:
	      //   for `%WrapForValidIteratorPrototype%.next` or with `state.returnHandlerResult` our `nextHandler` returns `IterResultObject`
	      //   for `%IteratorHelperPrototype%.next` - just a value
	      if (IS_ITERATOR) return state.nextHandler();
	      if (state.done) return createIterResultObject(undefined, true);
	      try {
	        var result = state.nextHandler();
	        return state.returnHandlerResult ? result : createIterResultObject(result, state.done);
	      } catch (error) {
	        state.done = true;
	        throw error;
	      }
	    },
	    'return': function () {
	      var state = getInternalState(this);
	      var iterator = state.iterator;
	      state.done = true;
	      if (IS_ITERATOR) {
	        var returnMethod = getMethod(iterator, 'return');
	        return returnMethod ? functionCall(returnMethod, iterator) : createIterResultObject(undefined, true);
	      }
	      if (state.inner) try {
	        iteratorClose(state.inner.iterator, NORMAL);
	      } catch (error) {
	        return iteratorClose(iterator, THROW, error);
	      }
	      if (state.openIters) try {
	        iteratorCloseAll(state.openIters, NORMAL);
	      } catch (error) {
	        return iteratorClose(iterator, THROW, error);
	      }
	      if (iterator) iteratorClose(iterator, NORMAL);
	      return createIterResultObject(undefined, true);
	    }
	  });
	};
	var WrapForValidIteratorPrototype = createIteratorProxyPrototype(true);
	var IteratorHelperPrototype = createIteratorProxyPrototype(false);
	createNonEnumerableProperty(IteratorHelperPrototype, TO_STRING_TAG, 'Iterator Helper');
	var iteratorCreateProxy = function (nextHandler, IS_ITERATOR, RETURN_HANDLER_RESULT) {
	  var IteratorProxy = function Iterator(record, state) {
	    if (state) {
	      state.iterator = record.iterator;
	      state.next = record.next;
	    } else state = record;
	    state.type = IS_ITERATOR ? WRAP_FOR_VALID_ITERATOR : ITERATOR_HELPER;
	    state.returnHandlerResult = !!RETURN_HANDLER_RESULT;
	    state.nextHandler = nextHandler;
	    state.counter = 0;
	    state.done = false;
	    setInternalState(this, state);
	  };
	  IteratorProxy.prototype = IS_ITERATOR ? WrapForValidIteratorPrototype : IteratorHelperPrototype;
	  return IteratorProxy;
	};

	// call something on iterator step with safe closing on error
	var callWithSafeIterationClosing = function (iterator, fn, value, ENTRIES) {
	  try {
	    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
	  } catch (error) {
	    iteratorClose(iterator, 'throw', error);
	  }
	};

	// Should throw an error on invalid iterator
	// https://issues.chromium.org/issues/336839115
	var iteratorHelperThrowsOnInvalidIterator = function (methodName, argument) {
	  // eslint-disable-next-line es/no-iterator -- required for testing
	  var method = typeof Iterator == 'function' && Iterator.prototype[methodName];
	  if (method) try {
	    method.call({
	      next: null
	    }, argument).next();
	  } catch (error) {
	    return true;
	  }
	};

	var FILTER_WITHOUT_THROWING_ON_INVALID_ITERATOR = !iteratorHelperThrowsOnInvalidIterator('filter', function () {/* empty */});
	var filterWithoutClosingOnEarlyError = !FILTER_WITHOUT_THROWING_ON_INVALID_ITERATOR && iteratorHelperWithoutClosingOnEarlyError('filter', TypeError);
	var FORCED$1 = FILTER_WITHOUT_THROWING_ON_INVALID_ITERATOR || filterWithoutClosingOnEarlyError;
	var IteratorProxy$1 = iteratorCreateProxy(function () {
	  var iterator = this.iterator;
	  var predicate = this.predicate;
	  var next = this.next;
	  var result, done, value;
	  while (true) {
	    result = anObject(functionCall(next, iterator));
	    done = this.done = !!result.done;
	    if (done) return;
	    value = result.value;
	    if (callWithSafeIterationClosing(iterator, predicate, [value, this.counter++], true)) return value;
	  }
	});

	// `Iterator.prototype.filter` method
	// https://tc39.es/ecma262/#sec-iterator.prototype.filter
	_export({
	  target: 'Iterator',
	  proto: true,
	  real: true,
	  forced: FORCED$1
	}, {
	  filter: function filter(predicate) {
	    anObject(this);
	    try {
	      aCallable(predicate);
	    } catch (error) {
	      iteratorClose(this, 'throw', error);
	    }
	    if (filterWithoutClosingOnEarlyError) return functionCall(filterWithoutClosingOnEarlyError, this, predicate);
	    return new IteratorProxy$1(getIteratorDirect(this), {
	      predicate: predicate
	    });
	  }
	});

	var findWithoutClosingOnEarlyError = iteratorHelperWithoutClosingOnEarlyError('find', TypeError);

	// `Iterator.prototype.find` method
	// https://tc39.es/ecma262/#sec-iterator.prototype.find
	_export({
	  target: 'Iterator',
	  proto: true,
	  real: true,
	  forced: findWithoutClosingOnEarlyError
	}, {
	  find: function find(predicate) {
	    anObject(this);
	    try {
	      aCallable(predicate);
	    } catch (error) {
	      iteratorClose(this, 'throw', error);
	    }
	    if (findWithoutClosingOnEarlyError) return functionCall(findWithoutClosingOnEarlyError, this, predicate);
	    var record = getIteratorDirect(this);
	    var counter = 0;
	    return iterate(record, function (value, stop) {
	      if (predicate(value, counter++)) return stop(value);
	    }, {
	      IS_RECORD: true,
	      INTERRUPTED: true
	    }).result;
	  }
	});

	var MAP_WITHOUT_THROWING_ON_INVALID_ITERATOR = !iteratorHelperThrowsOnInvalidIterator('map', function () {/* empty */});
	var mapWithoutClosingOnEarlyError = !MAP_WITHOUT_THROWING_ON_INVALID_ITERATOR && iteratorHelperWithoutClosingOnEarlyError('map', TypeError);
	var FORCED = MAP_WITHOUT_THROWING_ON_INVALID_ITERATOR || mapWithoutClosingOnEarlyError;
	var IteratorProxy = iteratorCreateProxy(function () {
	  var iterator = this.iterator;
	  var result = anObject(functionCall(this.next, iterator));
	  var done = this.done = !!result.done;
	  if (!done) return callWithSafeIterationClosing(iterator, this.mapper, [result.value, this.counter++], true);
	});

	// `Iterator.prototype.map` method
	// https://tc39.es/ecma262/#sec-iterator.prototype.map
	_export({
	  target: 'Iterator',
	  proto: true,
	  real: true,
	  forced: FORCED
	}, {
	  map: function map(mapper) {
	    anObject(this);
	    try {
	      aCallable(mapper);
	    } catch (error) {
	      iteratorClose(this, 'throw', error);
	    }
	    if (mapWithoutClosingOnEarlyError) return functionCall(mapWithoutClosingOnEarlyError, this, mapper);
	    return new IteratorProxy(getIteratorDirect(this), {
	      mapper: mapper
	    });
	  }
	});

	var $String = String;
	var toString_1 = function (argument) {
	  if (classof(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
	  return $String(argument);
	};

	var $TypeError = TypeError;
	var validateArgumentsLength = function (passed, required) {
	  if (passed < required) throw new $TypeError('Not enough arguments');
	  return passed;
	};

	var $URLSearchParams$1 = URLSearchParams;
	var URLSearchParamsPrototype$2 = $URLSearchParams$1.prototype;
	var append = functionUncurryThis(URLSearchParamsPrototype$2.append);
	var $delete = functionUncurryThis(URLSearchParamsPrototype$2['delete']);
	var forEach$1 = functionUncurryThis(URLSearchParamsPrototype$2.forEach);
	var push = functionUncurryThis([].push);
	var params$1 = new $URLSearchParams$1('a=1&a=2&b=3');
	params$1['delete']('a', 1);
	// `undefined` case is a Chromium 117 bug
	// https://bugs.chromium.org/p/v8/issues/detail?id=14222
	params$1['delete']('b', undefined);
	if (params$1 + '' !== 'a=2') {
	  defineBuiltIn(URLSearchParamsPrototype$2, 'delete', function (name /* , value */) {
	    var length = arguments.length;
	    var $value = length < 2 ? undefined : arguments[1];
	    if (length && $value === undefined) return $delete(this, name);
	    var entries = [];
	    forEach$1(this, function (v, k) {
	      // also validates `this`
	      push(entries, {
	        key: k,
	        value: v
	      });
	    });
	    validateArgumentsLength(length, 1);
	    var key = toString_1(name);
	    var value = toString_1($value);
	    var index = 0;
	    var dindex = 0;
	    var found = false;
	    var entriesLength = entries.length;
	    var entry;
	    while (index < entriesLength) {
	      entry = entries[index++];
	      if (found || entry.key === key) {
	        found = true;
	        $delete(this, entry.key);
	      } else dindex++;
	    }
	    while (dindex < entriesLength) {
	      entry = entries[dindex++];
	      if (!(entry.key === key && entry.value === value)) append(this, entry.key, entry.value);
	    }
	  }, {
	    enumerable: true,
	    unsafe: true
	  });
	}

	var $URLSearchParams = URLSearchParams;
	var URLSearchParamsPrototype$1 = $URLSearchParams.prototype;
	var getAll = functionUncurryThis(URLSearchParamsPrototype$1.getAll);
	var $has = functionUncurryThis(URLSearchParamsPrototype$1.has);
	var params = new $URLSearchParams('a=1');

	// `undefined` case is a Chromium 117 bug
	// https://bugs.chromium.org/p/v8/issues/detail?id=14222
	if (params.has('a', 2) || !params.has('a', undefined)) {
	  defineBuiltIn(URLSearchParamsPrototype$1, 'has', function has(name /* , value */) {
	    var length = arguments.length;
	    var $value = length < 2 ? undefined : arguments[1];
	    if (length && $value === undefined) return $has(this, name);
	    var values = getAll(this, name); // also validates `this`
	    validateArgumentsLength(length, 1);
	    var value = toString_1($value);
	    var index = 0;
	    while (index < values.length) {
	      if (values[index++] === value) return true;
	    }
	    return false;
	  }, {
	    enumerable: true,
	    unsafe: true
	  });
	}

	var URLSearchParamsPrototype = URLSearchParams.prototype;
	var forEach = functionUncurryThis(URLSearchParamsPrototype.forEach);

	// `URLSearchParams.prototype.size` getter
	// https://github.com/whatwg/url/pull/734
	if (descriptors && !('size' in URLSearchParamsPrototype)) {
	  defineBuiltInAccessor(URLSearchParamsPrototype, 'size', {
	    get: function size() {
	      var count = 0;
	      forEach(this, function () {
	        count++;
	      });
	      return count;
	    },
	    configurable: true,
	    enumerable: true
	  });
	}

	var BN = {
		name: "Bunny",
		imgPath: "/img/statistics/bunny.svg",
		cacheHitRate: 99.61,
		color: "#3370EB",
		enabled: true
	};
	var CF = {
		name: "Cloudflare",
		imgPath: "/img/statistics/cloudflare.svg",
		cacheHitRate: 99.49,
		color: "#F6821F",
		enabled: true
	};
	var FY = {
		name: "Fastly",
		imgPath: "/img/statistics/fastly.svg",
		cacheHitRate: 99.43,
		color: "#FF282D",
		enabled: true
	};
	var GC = {
		name: "GCore",
		imgPath: "/img/statistics/g-core.svg",
		cacheHitRate: 98.93,
		color: "#A234D2",
		enabled: true
	};
	var MX = {
		name: "StackPath",
		cacheHitRate: 99.24,
		imgPath: "/img/statistics/stackpath.svg",
		color: "#106534",
		enabled: false
	};
	var QT = {
		name: "Quantil",
		imgPath: "/img/statistics/quantil.ico",
		cacheHitRate: 99.18,
		color: "#961C1F",
		enabled: false
	};
	var combinedProviders = {
		name: "Combined Providers",
		imgPath: "/img/statistics/stackpath.ico",
		color: "#F65128",
		enabled: false
	};
	var netProviders = {
		BN: BN,
		CF: CF,
		FY: FY,
		GC: GC,
		MX: MX,
		QT: QT,
		combinedProviders: combinedProviders
	};

	var netProviders$1 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		BN: BN,
		CF: CF,
		FY: FY,
		GC: GC,
		MX: MX,
		QT: QT,
		combinedProviders: combinedProviders,
		'default': netProviders
	});

	var newHost = "img.jsdelivr.com";
	var hosts = [
		"cloud.githubusercontent.com",
		"img.shields.io",
		"img.badgesize.io",
		"raw.githubusercontent.com",
		"github.com",
		"upload.wikimedia.org",
		"opencollective.com",
		"flat.badgen.net",
		"images.opencollective.com",
		"avatars.githubusercontent.com",
		"badgen.net"
	];
	var optimizedHosts$1 = {
		newHost: newHost,
		hosts: hosts
	};

	var optimizedHosts$2 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		newHost: newHost,
		hosts: hosts,
		'default': optimizedHosts$1
	});

	var providerData = getCjsExportFromNamespace(netProviders$1);

	var optimizedHosts = getCjsExportFromNamespace(optimizedHosts$2);

	var _ = createCommonjsModule(function (module) {
	  const MONTHS_SHORT_NAMES_LIST = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	  const MONTHS_FULL_NAMES_LIST = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
	  const DAY_NAME_NUMBER_MAP = {
	    Mon: 0,
	    Tue: 1,
	    Wed: 2,
	    Thu: 3,
	    Fri: 4,
	    Sat: 5,
	    Sun: 6
	  };
	  const MONTH_NAME_NUMBER_MAP = {
	    Jan: 0,
	    Feb: 1,
	    Mar: 2,
	    Apr: 3,
	    May: 4,
	    Jun: 5,
	    Jul: 6,
	    Aug: 7,
	    Sep: 8,
	    Oct: 9,
	    Nov: 10,
	    Dec: 11
	  };
	  const MONTH_FULL_OF_DAYS = '31';
	  const MONTH_SHORT_OF_DAYS = '30';
	  const MONTH_FEB_DAYS = '28';
	  const MONTH_LEAP_FEB_DAYS = '29';
	  const screenType = {
	    mobile: 480,
	    tablet: 768,
	    mdDesktop: 992,
	    lgDesktop: 1200,
	    xlDesktop: 1400
	  };
	  module.exports = {
	    screenType,
	    isTabletScreen() {
	      return screen.width > screenType.mobile && screen.width <= screenType.tablet;
	    },
	    isMobileScreen() {
	      return screen.width <= screenType.mobile;
	    },
	    calculateGrowth(curr, prev) {
	      if (!prev) {
	        return 0;
	      }
	      return curr / prev * 100 - 100;
	    },
	    getValueFormatter(isBandwidth, values) {
	      if (!isBandwidth) {
	        return module.exports.formatNumber;
	      }
	      let unit = module.exports.findUnitFromArray(values);
	      return value => module.exports.formatBytesWithUnit(value, unit);
	    },
	    flattenFiles: function flattenFiles(tree, path = '/', files = []) {
	      tree.forEach(item => {
	        if (item.type === 'file') {
	          files.push(path + item.name);
	        } else {
	          flattenFiles(item.files, path + item.name + '/', files);
	        }
	      });
	      return files;
	    },
	    formatDate(date, format = 'long') {
	      if (!date) {
	        return '';
	      }
	      if (typeof date === 'string') {
	        date = new Date(date);
	      }
	      if (format === 'short') {
	        return date.toLocaleDateString('en-US', {
	          day: 'numeric',
	          month: 'short'
	        });
	      }
	      return date.toLocaleDateString('en-US', {
	        day: 'numeric',
	        month: 'short',
	        year: 'numeric'
	      });
	    },
	    formatDateTime(date) {
	      if (!date) {
	        return '';
	      }
	      if (typeof date === 'string') {
	        date = new Date(date);
	      }
	      return date.toLocaleDateString('en-US', {
	        day: 'numeric',
	        month: 'short',
	        year: 'numeric',
	        hour: 'numeric',
	        minute: 'numeric',
	        second: 'numeric',
	        hour12: false
	      });
	    },
	    formatHits(hits) {
	      if (hits < 1e9) {
	        return 1;
	      }
	      return Math.round(hits / 1e9);
	    },
	    formatNumber(number) {
	      return Math.floor(number).toString().replace(/\d(?=(?:\d{3})+$)/g, '$& ');
	    },
	    formatNumberWithSpace(val) {
	      // remove sign if negative
	      let sign = 1;
	      if (val < 0) {
	        sign = -1;
	        val = -val;
	      }
	      let num = val.toString().includes('.') ? val.toString().split('.')[0] : val.toString();
	      while (/(\d+)(\d{3})/.test(num.toString())) {
	        num = num.toString().replace(/(\d+)(\d{3})/, '$1 $2');
	      }
	      if (val.toString().includes('.')) {
	        num = num + '.' + val.toString().split('.')[1];
	      }
	      return sign < 0 ? '-' + num : num;
	    },
	    getMinifiedName(name) {
	      return name.replace(/\.(js|css)$/i, '.min.$1');
	    },
	    getNonMinifiedName(name) {
	      return name.replace(/\.min\.(js|css)$/i, '.$1');
	    },
	    listFiles: function listFiles(files = [], path) {
	      if (!path.length) {
	        return files;
	      }
	      let p = path.slice();
	      let n = p.shift();
	      let d = files.filter(f => f.name === n)[0];
	      return d && d.files ? listFiles(d.files, p) : null;
	    },
	    nth(n) {
	      n = Math.floor(n);
	      let m = n % 10;
	      if (n === 1) {
	        return '';
	      } else if (n > 20 && m === 1) {
	        return `${n}st`;
	      } else if (n === 2 || n > 20 && m === 2) {
	        return `${n}nd`;
	      } else if (n === 3 || n > 20 && m === 3) {
	        return `${n}rd`;
	      }
	      return `${n}th`;
	    },
	    getChartXAxisData(periodDates, period = 'month', periodGroupBy = 'day') {
	      let chartXData = [];
	      let dataPerMonths = periodDates.reduce((dataPerMonths, date) => {
	        let splittedDate = date.split('-');
	        let dateYear = splittedDate[0];
	        let dateMonth = splittedDate.slice(0, 2).join('-');
	        let periodMonthFormatted = MONTHS_SHORT_NAMES_LIST[new Date(dateMonth).getUTCMonth()];
	        if (!dataPerMonths[`${dateYear} ${periodMonthFormatted}`]) {
	          dataPerMonths[`${dateYear} ${periodMonthFormatted}`] = [];
	        }
	        dataPerMonths[`${dateYear} ${periodMonthFormatted}`].push(date);
	        return dataPerMonths;
	      }, []);
	      let labelArea = 0;
	      Object.keys(dataPerMonths).forEach(yearMonthKey => {
	        // let middleLength = Math.round(dataPerMonths[yearMonthKey].length / 2);

	        dataPerMonths[yearMonthKey].forEach((day, idx) => {
	          // for every case except we set month in the start of the days
	          // if period is year we should return month for every day since it will be filtered on ticks callback as needed
	          let year = yearMonthKey.split(' ')[0];
	          let month = yearMonthKey.split(' ')[1];
	          labelArea++;
	          if (period === 'year') {
	            if (idx === 0) {
	              if (periodGroupBy === 'day' && dataPerMonths[yearMonthKey].length > 15 && labelArea < 359) {
	                chartXData.push([day, month, year]);
	                return;
	              } else if (periodGroupBy === 'week' && labelArea > 0 && labelArea < 54) {
	                chartXData.push([day, month, year]);
	                return;
	              } else if (periodGroupBy === 'month' && labelArea < 12) {
	                chartXData.push([day, month, year]);
	                return;
	              }
	            }
	            if (periodGroupBy !== 'month') {
	              chartXData.push([day, '', '']);
	            }
	          } else if (idx === 0) {
	            if (periodGroupBy === 'month') {
	              chartXData.push(['', month]);
	            } else if (dataPerMonths[yearMonthKey].length > 1) {
	              chartXData.push([day, month]);
	            }
	          } else {
	            chartXData.push([day, '']);
	          }
	        });
	      });
	      return chartXData;
	    },
	    // escaping code: https://github.com/component/escape-html/blob/master/index.js
	    unescapeHtml(text) {
	      return text.replace(/&quot;/g, '"').replace(/&amp;/g, '&').replace(/&#39;/g, '\'').replace(/&lt;/g, '<').replace(/&gt;/g, '>');
	    },
	    // ignoreExtremlySmallValue: true when you need to find min value for the axis min e.g.
	    getValueByMagnitude(value, rounding = 'round', magnitudeCorrection = 0, ignoreExtremlySmallValue = true) {
	      let magnitude = Math.floor(Math.log10(value) === -Infinity ? 0 : Math.log10(value)) - magnitudeCorrection;
	      if (ignoreExtremlySmallValue && value < 10) {
	        return rounding === 'ceil' ? 10 : 0;
	      }
	      switch (rounding) {
	        case 'round':
	          return Math.round(value / Math.pow(10, magnitude)) * Math.pow(10, magnitude);
	        case 'ceil':
	          return Math.ceil(value / Math.pow(10, magnitude)) * Math.pow(10, magnitude);
	        case 'floor':
	          return Math.floor(value / Math.pow(10, magnitude)) * Math.pow(10, magnitude);
	      }
	    },
	    convertBytesToUnits(bytesAmount, units = 'GB') {
	      let unitsBase = null;
	      switch (units) {
	        case 'kB':
	          unitsBase = 1e3;
	          break;
	        case 'MB':
	          unitsBase = 1e6;
	          break;
	        case 'GB':
	          unitsBase = 1e9;
	          break;
	        case 'TB':
	          unitsBase = 1e12;
	          break;
	        case 'PB':
	          unitsBase = 1e15;
	          break;
	        case 'EB':
	          unitsBase = 1e18;
	          break;
	        default:
	          unitsBase = 1;
	      }
	      return Math.round(bytesAmount / unitsBase);
	    },
	    findUnitFromArray(numbers) {
	      let lookup = [{
	        value: 1,
	        symbol: 'B'
	      }, {
	        value: 1e4,
	        symbol: 'kB'
	      }, {
	        value: 1e7,
	        symbol: 'MB'
	      }, {
	        value: 1e10,
	        symbol: 'GB'
	      }, {
	        value: 1e13,
	        symbol: 'TB'
	      }, {
	        value: 1e16,
	        symbol: 'PB'
	      }, {
	        value: 1e19,
	        symbol: 'EB'
	      }];
	      return numbers.map(num => {
	        return lookup.slice().reverse().find(item => {
	          return num >= item.value;
	        });
	      }).sort((a, b) => a.value - b.value)[0].symbol;
	    },
	    findUnitFromNumber(num) {
	      let lookup = [{
	        value: 1e4,
	        symbol: 'kB'
	      }, {
	        value: 1e7,
	        symbol: 'MB'
	      }, {
	        value: 1e10,
	        symbol: 'GB'
	      }, {
	        value: 1e13,
	        symbol: 'TB'
	      }, {
	        value: 1e16,
	        symbol: 'PB'
	      }, {
	        value: 1e19,
	        symbol: 'EB'
	      }];
	      let unit = lookup.slice().reverse().find(item => {
	        return num >= item.value;
	      });
	      if (!unit) {
	        return 'B';
	      }
	      return unit.symbol;
	    },
	    formatBytesWithUnit(num, unit) {
	      let lookup = [{
	        value: 1,
	        symbol: 'B'
	      }, {
	        value: 1e3,
	        symbol: 'kB'
	      }, {
	        value: 1e6,
	        symbol: 'MB'
	      }, {
	        value: 1e9,
	        symbol: 'GB'
	      }, {
	        value: 1e12,
	        symbol: 'TB'
	      }, {
	        value: 1e15,
	        symbol: 'PB'
	      }, {
	        value: 1e18,
	        symbol: 'EB'
	      }];
	      let item = lookup.find(l => l.symbol === unit) || lookup.slice().reverse().find(item => {
	        return num >= item.value;
	      });
	      return item ? module.exports.formatNumber(num / item.value) + ' ' + item.symbol : '0';
	    },
	    formatGrowth(num, fixed = 1) {
	      if (num === 0 || num.toFixed(fixed) === '0') {
	        return `+0%`;
	      }
	      return `${num >= 0 ? '+' : ''}${num.toFixed(fixed)}%`;
	    },
	    formatShare(num, fixed = 1) {
	      if (num === 0 || num.toFixed(fixed) === '0') {
	        return `0%`;
	      }
	      return `${num.toFixed(fixed)}%`;
	    },
	    formatToShortNumber(num, delimiter = '', unit) {
	      let lookup = [{
	        value: 1,
	        symbol: ''
	      }, {
	        value: 1e3,
	        symbol: 'K'
	      }, {
	        value: 1e6,
	        symbol: 'M'
	      }, {
	        value: 1e9,
	        symbol: 'B'
	      }, {
	        value: 1e12,
	        symbol: 'T'
	      }, {
	        value: 1e15,
	        symbol: 'P'
	      }, {
	        value: 1e18,
	        symbol: 'E'
	      }];
	      let rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
	      let item = lookup.find(l => l.symbol === unit) || lookup.slice().reverse().find(item => {
	        return num >= item.value;
	      });
	      return item ? (num / item.value).toFixed(1).replace(rx, '$1') + delimiter + item.symbol : '0';
	    },
	    makeHTTPRequest(obj) {
	      let {
	        method = 'GET',
	        rawResponse = false,
	        body,
	        url,
	        headers,
	        responseHeadersToGet = null,
	        withCredentials = false
	      } = obj;
	      return new Promise((resolve, reject) => {
	        let xhr = new XMLHttpRequest();
	        xhr.open(method || 'GET', method === 'GET' && body ? url + this.createQueryString(body) : url);
	        if (method === 'POST') {
	          xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        }
	        if (headers) {
	          Object.keys(headers).forEach(key => xhr.setRequestHeader(key, headers[key]));
	        }
	        if (withCredentials) {
	          xhr.withCredentials = true;
	        }
	        xhr.onerror = xhr.onload = () => {
	          let response = xhr.response;
	          if (!rawResponse) {
	            try {
	              response = JSON.parse(response);
	            } catch (e) {
	              console.error(e);
	            }
	          }
	          let responseHeaders = responseHeadersToGet ? responseHeadersToGet.reduce((headerValuePairs, headerName) => {
	            headerValuePairs[headerName] = xhr.getResponseHeader(headerName);
	            return headerValuePairs;
	          }, {}) : null;
	          if (xhr.status >= 200 && xhr.status < 300) {
	            let resolveData;
	            if (responseHeaders && Object.keys(responseHeaders).length) {
	              resolveData = {
	                response,
	                responseHeaders
	              };
	            } else {
	              resolveData = response;
	            }
	            resolve(resolveData);
	          } else {
	            let rejectData = {
	              ...response,
	              responseStatusCode: xhr.status
	            };
	            if (responseHeaders && Object.keys(responseHeaders).length) {
	              rejectData = {
	                ...rejectData,
	                responseHeaders
	              };
	            }

	            // eslint-disable-next-line prefer-promise-reject-errors
	            reject(rejectData);
	          }
	        };
	        if (method === 'GET') {
	          xhr.send();
	        } else if (method === 'POST') {
	          xhr.send(JSON.stringify(body));
	        }
	      });
	    },
	    createQueryString(params) {
	      let keys = Object.keys(params);
	      if (!keys.length) {
	        return '';
	      }
	      return '?' + keys.filter(key => params[key]).map(key => `${key}=${encodeURIComponent(params[key])}`).join('&');
	    },
	    deepExtend(out = {}, ...rest) {
	      for (let i = 0; i < rest.length; i++) {
	        let obj = rest[i];
	        if (!obj) {
	          continue;
	        }
	        for (let key in obj) {
	          if (Object.hasOwn(obj, key)) {
	            if (typeof obj[key] === 'object' && obj[key] !== null) {
	              if (obj[key] instanceof Array) {
	                out[key] = obj[key].slice(0);
	              } else {
	                out[key] = this.deepExtend(out[key], obj[key]);
	              }
	            } else {
	              out[key] = obj[key];
	            }
	          }
	        }
	      }
	      return out;
	    },
	    onDocumentReady(fn) {
	      if (document.readyState !== 'loading') {
	        fn();
	      } else {
	        document.addEventListener('DOMContentLoaded', fn);
	      }
	    },
	    checkIfYearIsLeap(year) {
	      if (isNaN(Number(year)) || String(year).length !== 4) {
	        console.warn('Func isLeapYear expected a year as a String or a Number with 4 signs');
	        return false;
	      }
	      if (year % 4 === 0) {
	        if (year % 100 === 0) {
	          if (year % 400 === 0) {
	            return true;
	          }
	          return false;
	        }
	        return true;
	      }
	      return false;
	    },
	    getAmountOfDaysByMonth(month, year) {
	      switch (month) {
	        case '01':
	        case '03':
	        case '05':
	        case '07':
	        case '08':
	        case '10':
	        case '12':
	          return MONTH_FULL_OF_DAYS;
	        case '04':
	        case '06':
	        case '09':
	        case '11':
	          return MONTH_SHORT_OF_DAYS;
	        case '02':
	          return this.checkIfYearIsLeap(year) ? MONTH_LEAP_FEB_DAYS : MONTH_FEB_DAYS;
	      }
	    },
	    getDateFormats(date) {
	      let splittedDate = date.split('-');
	      let dateYear = splittedDate[0];
	      let dateMonth = splittedDate[1];
	      let dateDay = splittedDate[2];
	      let parsedDateDay = parseInt(splittedDate[2]);
	      let dateDayName = new Date(Date.UTC(Number(dateYear), Number(dateMonth) - 1, Number(dateDay))).toLocaleDateString('en-US', {
	        weekday: 'short'
	      });
	      let periodMonthShort = MONTHS_SHORT_NAMES_LIST[new Date(`${dateYear}-${dateMonth}`).getUTCMonth()];
	      let periodMonthFull = MONTHS_FULL_NAMES_LIST[new Date(`${dateYear}-${dateMonth}`).getUTCMonth()];
	      return {
	        dateYear,
	        dateMonth,
	        dateDay,
	        dateDayName,
	        periodMonthShort,
	        periodMonthFull,
	        parsedDateDay
	      };
	    },
	    prepareDataForChartGroupedBy(rawData, groupBy, valueByDatePropName = '') {
	      let rawDataDatesKeys = Object.keys(rawData.dates);
	      let rawDataDatesData = rawData.dates;
	      return rawDataDatesKeys.reduce((resData, date) => {
	        let {
	          dateYear,
	          dateMonth,
	          dateDay,
	          dateDayName,
	          periodMonthShort,
	          periodMonthFull,
	          parsedDateDay
	        } = this.getDateFormats(date);
	        let valueByDateConverted = valueByDatePropName ? rawDataDatesData[date][valueByDatePropName] : rawDataDatesData[date];
	        switch (groupBy) {
	          case 'month':
	            if (!resData.preparedData[dateMonth]) {
	              resData.preparedData[dateMonth] = {
	                isFull: false,
	                value: valueByDateConverted,
	                day: dateDay,
	                month: periodMonthShort,
	                year: dateYear,
	                periodStart: `${periodMonthFull} ${parsedDateDay}, ${dateYear}`,
	                periodEnd: null
	              };
	            } else {
	              let lastDayNum = this.getAmountOfDaysByMonth(dateMonth, dateYear);
	              resData.preparedData[dateMonth].value += valueByDateConverted;
	              if (dateDay === lastDayNum) {
	                resData.preparedData[dateMonth].periodEnd = `${periodMonthFull} ${parsedDateDay}, ${dateYear}`;
	                if (resData.preparedData[dateMonth].day === `01`) {
	                  resData.preparedData[dateMonth].isFull = true;
	                }
	              }
	            }
	            return resData;
	          case 'week':
	            if (!resData.preparedData[resData.weekNumber]) {
	              resData.preparedData[resData.weekNumber] = {
	                isFull: false,
	                value: valueByDateConverted,
	                day: dateDay,
	                month: periodMonthShort,
	                year: dateYear,
	                periodStart: `${periodMonthFull} ${parsedDateDay}, ${dateYear}`,
	                periodEnd: null
	              };
	              resData.weekDayCnt = 1;
	            } else {
	              resData.preparedData[resData.weekNumber].value += valueByDateConverted;
	              resData.weekDayCnt++;
	              if (resData.weekDayCnt === 7) {
	                resData.preparedData[resData.weekNumber].isFull = true;
	                resData.preparedData[resData.weekNumber].periodEnd = `${periodMonthFull} ${parsedDateDay}, ${dateYear}`;
	              }
	            }
	            if (DAY_NAME_NUMBER_MAP[dateDayName] === 6) {
	              resData.weekNumber++;
	            }
	            return resData;
	          case 'day':
	            if (!resData.preparedData.days) {
	              resData.preparedData.days = [];
	            }
	            resData.preparedData.days.push({
	              value: valueByDateConverted,
	              day: dateDay,
	              month: periodMonthShort,
	              year: dateYear,
	              periodStart: `${periodMonthFull} ${parsedDateDay}, ${dateYear}`,
	              periodEnd: `${periodMonthFull} ${parsedDateDay}, ${dateYear}`
	            });
	            return resData;
	        }
	        return resData;
	      }, {
	        weekNumber: 0,
	        weekDayCnt: 0,
	        preparedData: {}
	      });
	    },
	    createWeekPeriodChartLabels(labels) {
	      // for both Mobile and Desktop we will show Day and Month per each tick
	      // no matter what resolution is
	      return labels.map(label => {
	        return label.slice(0, 2);
	      });
	    },
	    createMonthPeriodChartLabels(labels, groupBy) {
	      let formattedLabels = [];
	      if (groupBy === 'day') {
	        formattedLabels = labels.map((label, idx) => {
	          switch (true) {
	            case screen.width >= 992:
	              if (idx === 0 || label[0] === '01') {
	                return label.slice(0, 2);
	              }
	              return label.slice(0, 1);
	            case idx === Math.round(labels.length / 2):
	            case idx === 0:
	              return label.slice(0, 2);
	            default:
	              return [];
	          }
	        });
	      }
	      if (groupBy === 'week') {
	        formattedLabels = labels;
	      }
	      return formattedLabels;
	    },
	    createYearPeriodChartLabels(labels, groupBy) {
	      let formattedLabels = [...labels];
	      if (groupBy === 'day') {
	        let tempCurrMonth = labels[0][1];
	        let currAxisYear = labels[0][2];
	        formattedLabels = labels.map((label, idx) => {
	          switch (true) {
	            case screen.width >= 992:
	              if (idx === 0) {
	                return label.slice(1, 3);
	              } else if (label[2] !== currAxisYear && label[1] !== tempCurrMonth) {
	                currAxisYear = label[2];
	                tempCurrMonth = label[1];
	                return label.slice(1, 3);
	              } else if (label[1] !== tempCurrMonth && label[2] === currAxisYear) {
	                tempCurrMonth = label[1];
	                return label.slice(1, 2);
	              }
	              return [];
	            case idx === 0 || idx === labels.length - 1:
	              return label.slice(1, 3);
	          }
	          return [];
	        });
	      }
	      if (groupBy === 'week') {
	        let tempCurrMonth = labels[0][1];
	        let lastPeriodMonth = labels[labels.length - 1][1];
	        let currAxisYear = labels[0][2];
	        formattedLabels = labels.map((label, idx) => {
	          switch (true) {
	            case screen.width >= 768:
	              if (idx === 0 || idx === labels.length - 1 || label[2] !== currAxisYear) {
	                currAxisYear = label[2];
	                tempCurrMonth = label[1];
	                return label.slice(1, 3);
	              } else if (label[1] !== tempCurrMonth && label[1] !== lastPeriodMonth) {
	                tempCurrMonth = label[1];
	                return label.slice(1, 2);
	              }
	              return [];
	            case idx === 0 || idx === labels.length - 1:
	              return label.slice(1, 3);
	          }
	          return [];
	        });
	      }
	      if (groupBy === 'month') {
	        let currAxisYear = labels[0][2];
	        formattedLabels = labels.map((label, idx) => {
	          if (idx === 0 || idx === labels.length - 1 || label[2] !== currAxisYear) {
	            currAxisYear = label[2];
	            return label.slice(1, 3);
	          }
	          if (screen.width < 768) {
	            return [];
	          }
	          return label.slice(1, 2);
	        });
	      }
	      return formattedLabels;
	    },
	    getSortedIterableChartData(data, groupBy) {
	      let toSort = groupBy === 'day' ? data.days : Object.values(data);
	      let getDate = value => {
	        return new Date(Number(value.year), MONTH_NAME_NUMBER_MAP[value.month], Number(value.day));
	      };
	      return toSort.sort((a, b) => getDate(a) - getDate(b));
	    },
	    // take preparedData for charts and then group it by day/week/month, calc magnitude, create labels for x-axis
	    getPreparedDataForBarChart(rawData, groupBy, chartPeriod, showChartBandwidth, onlyFullPeriods = true) {
	      let {
	        preparedData
	      } = this.prepareDataForChartGroupedBy(rawData, groupBy);
	      let results = {
	        values: [],
	        labels: [],
	        labelsStartEndPeriods: [],
	        minRangeValue: 0,
	        maxRangeValue: 0,
	        valueUnits: ''
	      };
	      let dataToIterate = this.getSortedIterableChartData(preparedData, groupBy);

	      // collect data for chart depending on groupBy
	      results = dataToIterate.reduce((res, period) => {
	        if (onlyFullPeriods && period.isFull === false) {
	          return res;
	        }
	        res.values.push(period.value);
	        res.labels.push([period.day, period.month, period.year]);
	        res.labelsStartEndPeriods.push([period.periodStart, period.periodEnd, period.value]);
	        return res;
	      }, results);
	      if (showChartBandwidth) {
	        let unit = module.exports.findUnitFromArray(results.values);
	        results.values = results.values.map(v => module.exports.convertBytesToUnits(v, unit));
	        results.valueUnits = ` ${unit}`;
	      }

	      // get min/max magnitude for y-axis
	      results.minRangeValue = this.getValueByMagnitude(Math.min(...results.values), 'floor');
	      results.maxRangeValue = this.getValueByMagnitude(Math.max(...results.values), 'ceil', 1);

	      // create labels depending on chartPeriod, Screen size, groupBy
	      switch (chartPeriod) {
	        case 's-week':
	          results.labels = this.createWeekPeriodChartLabels(results.labels);
	          break;
	        case 's-month':
	          results.labels = this.createMonthPeriodChartLabels(results.labels, groupBy);
	          break;
	        case 's-quarter':
	        case 's-year':
	          results.labels = this.createYearPeriodChartLabels(results.labels, groupBy);
	          break;
	      }
	      return results;
	    },
	    calcChartBarThicknessByResolution(chartPeriod = 'month', usageChartGroupBy = 'day') {
	      let sreenWidth = screen.width;
	      let schema = {
	        thinnestBar: 1,
	        thinBar: 2,
	        regularBar: 4,
	        wideBar: 10
	      };
	      switch (chartPeriod) {
	        case 's-week':
	          return schema.wideBar;
	        case 's-month':
	          switch (usageChartGroupBy) {
	            case 'day':
	              if (sreenWidth >= 576) {
	                return schema.wideBar;
	              }
	              return schema.regularBar;
	            case 'week':
	              return schema.wideBar;
	          }
	          break;
	        case 's-quarter':
	          switch (usageChartGroupBy) {
	            case 'day':
	              if (sreenWidth >= 768) {
	                return schema.regularBar;
	              }
	              return schema.thinBar;
	            case 'week':
	              return schema.regularBar;
	            case 'month':
	              return schema.wideBar;
	          }
	          break;
	        case 's-year':
	          switch (usageChartGroupBy) {
	            case 'day':
	              return schema.thinnestBar;
	            case 'week':
	              if (sreenWidth >= 768) {
	                return schema.regularBar;
	              }
	              return schema.thinBar;
	            case 'month':
	              return schema.wideBar;
	          }
	          break;
	        default:
	          return schema.regularBar;
	      }
	    },
	    // prepare data for Providers Line Chart
	    getPreparedProvidersDataForLineChart(rawData, groupBy, chartPeriod, showChartBandwidth, onlyFullPeriods = true) {
	      let dataType = showChartBandwidth ? 'bandwidth' : 'hits';
	      let valueUnits = '',
	        unit;
	      let sortedProviders = rawData[dataType].providers.sort((a, b) => b.total - a.total);
	      let topProviderData = sortedProviders[0] || {};
	      let {
	        preparedData: topProviderPrepData
	      } = this.prepareDataForChartGroupedBy(topProviderData, groupBy, 'total');
	      let labelsData = {
	        labels: [],
	        labelsStartEndPeriods: []
	      };
	      let dataToIterate = this.getSortedIterableChartData(topProviderPrepData, groupBy);

	      // collect labels, period starts/ends data for chart
	      labelsData = dataToIterate.reduce((labelsData, period) => {
	        if (onlyFullPeriods && period.isFull === false) {
	          return labelsData;
	        }
	        labelsData.labels.push([period.day, period.month, period.year]);
	        labelsData.labelsStartEndPeriods.push([period.periodStart, period.periodEnd, period.value]);
	        return labelsData;
	      }, labelsData);

	      // create labels depending on chartPeriod, Screen size, groupBy
	      switch (chartPeriod) {
	        case 's-week':
	          labelsData.labels = this.createWeekPeriodChartLabels(labelsData.labels);
	          break;
	        case 's-month':
	          labelsData.labels = this.createMonthPeriodChartLabels(labelsData.labels, groupBy);
	          break;
	        case 's-quarter':
	        case 's-year':
	          labelsData.labels = this.createYearPeriodChartLabels(labelsData.labels, groupBy);
	          break;
	      }
	      let {
	        allGroupedByValues,
	        datasets
	      } = rawData[dataType].providers.reduce((res, providerData$1) => {
	        let {
	          preparedData
	        } = this.prepareDataForChartGroupedBy(providerData$1, groupBy, 'total');
	        let dataToIterate = this.getSortedIterableChartData(preparedData, groupBy);
	        let groupedByValues = dataToIterate.reduce((values, period) => {
	          if (onlyFullPeriods && period.isFull === false) {
	            return values;
	          }
	          values.push(period.value);
	          return values;
	        }, []);
	        if (showChartBandwidth) {
	          if (!unit) {
	            unit = module.exports.findUnitFromArray(groupedByValues);
	            valueUnits = ` ${unit}`;
	          }
	          groupedByValues = groupedByValues.map(v => module.exports.convertBytesToUnits(v, unit));
	        }
	        let dataset = {
	          label: providerData[providerData$1.code].name,
	          data: groupedByValues,
	          borderColor: providerData[providerData$1.code].color,
	          backgroundColor: providerData[providerData$1.code].color
	        };
	        res.datasets.push(dataset);
	        res.allGroupedByValues = [...res.allGroupedByValues, ...groupedByValues];
	        return res;
	      }, {
	        allGroupedByValues: [],
	        datasets: []
	      });

	      // get min/max magnitude for y-axis
	      let maxRangeValue = this.getValueByMagnitude(Math.max(...allGroupedByValues), 'ceil', 1);
	      return {
	        ...labelsData,
	        maxRangeValue,
	        valueUnits,
	        datasets
	      };
	    },
	    // prepare data for LineChart
	    getPreparedDataForLineChart(rawData, groupBy, chartPeriod, showChartBandwidth, numberOfDatasets = 5, onlyFullPeriods = true, colorsArray = []) {
	      let dataType = showChartBandwidth ? 'bandwidth' : 'hits';
	      let rawDataFiltered = rawData.sort((a, b) => b[dataType].hits - a[dataType].hits).slice(0, numberOfDatasets);
	      let valueUnits = '',
	        unit;
	      // get top by stats version of package to get from it values for y-axis, and labels to x-axis
	      let topVersionData = rawDataFiltered[0][dataType];
	      let {
	        preparedData: topVersionPrepData
	      } = this.prepareDataForChartGroupedBy(topVersionData, groupBy);
	      let labelsData = {
	        labels: [],
	        labelsStartEndPeriods: []
	      };
	      let dataToIterate = this.getSortedIterableChartData(topVersionPrepData, groupBy);

	      // collect labels, period starts/ends adta for chart
	      labelsData = dataToIterate.reduce((labelsData, period) => {
	        if (onlyFullPeriods && period.isFull === false) {
	          return labelsData;
	        }
	        labelsData.labels.push([period.day, period.month, period.year]);
	        labelsData.labelsStartEndPeriods.push([period.periodStart, period.periodEnd, period.value]);
	        return labelsData;
	      }, labelsData);

	      // create labels depending on chartPeriod, Screen size, groupBy
	      switch (chartPeriod) {
	        case 's-week':
	          labelsData.labels = this.createWeekPeriodChartLabels(labelsData.labels);
	          break;
	        case 's-month':
	          labelsData.labels = this.createMonthPeriodChartLabels(labelsData.labels, groupBy);
	          break;
	        case 's-quarter':
	        case 's-year':
	          labelsData.labels = this.createYearPeriodChartLabels(labelsData.labels, groupBy);
	          break;
	      }
	      let {
	        allGroupedByValues,
	        datasets
	      } = rawDataFiltered.reduce((res, versionData, idx) => {
	        let {
	          preparedData
	        } = this.prepareDataForChartGroupedBy(versionData[dataType], groupBy);
	        let dataToIterate = this.getSortedIterableChartData(preparedData, groupBy);
	        let groupedByValues = dataToIterate.reduce((values, period) => {
	          if (onlyFullPeriods && period.isFull === false) {
	            return values;
	          }
	          values.push(period.value);
	          return values;
	        }, []);
	        if (showChartBandwidth) {
	          if (!unit) {
	            unit = module.exports.findUnitFromArray(groupedByValues);
	            valueUnits = ` ${unit}`;
	          }
	          groupedByValues = groupedByValues.map(v => module.exports.convertBytesToUnits(v, unit));
	        }
	        let dataset = {
	          label: this.truncate(versionData.version, 20),
	          data: groupedByValues,
	          borderColor: colorsArray[idx],
	          backgroundColor: colorsArray[idx]
	        };
	        res.datasets.push(dataset);
	        res.allGroupedByValues = [...res.allGroupedByValues, ...groupedByValues];
	        return res;
	      }, {
	        allGroupedByValues: [],
	        datasets: []
	      });

	      // get min/max magnitude for y-axis
	      let maxRangeValue = this.getValueByMagnitude(Math.max(...allGroupedByValues), 'ceil', 1);
	      return {
	        ...labelsData,
	        maxRangeValue,
	        valueUnits,
	        datasets
	      };
	    },
	    // create barChart, lineChart improved tooltip title
	    createImprovedExternalTooltipTitle(periodStart, periodEnd, groupedBy) {
	      if (groupedBy === 'month') {
	        let [monthName,, year] = periodStart.split(' ');
	        return `${monthName}, ${year}`;
	      }
	      return periodStart === periodEnd ? `${periodStart}` : `${periodStart} - ${periodEnd}`;
	    },
	    translatePeriodsToSNotation(periodValue) {
	      switch (periodValue) {
	        case 'month':
	          return 's-month';
	        case 'quarter':
	          return 's-quarter';
	        case 'year':
	          return 's-year';
	        default:
	          return periodValue;
	      }
	    },
	    optimizeSrc(url, github) {
	      let {
	        newHost,
	        hosts
	      } = optimizedHosts;
	      let base = github ? `https://cdn.jsdelivr.net/gh/${github.user}/${github.project}@${github.head}/` : typeof location !== 'undefined' ? location.href : undefined;
	      let parsed = new URL(url.replace(/^\/+/, ''), base);
	      if (hosts.includes(parsed.hostname)) {
	        parsed.pathname = parsed.hostname + parsed.pathname;
	        parsed.hostname = newHost;
	      }
	      return parsed.toString();
	    },
	    normalizeHref(url, idPrefix) {
	      try {
	        let parsed = new URL(url.replace(/^\/+/, ''), location.href);
	        if (parsed.origin === location.origin && parsed.pathname === location.pathname) {
	          if (parsed.hash) {
	            parsed.hash = `#${idPrefix}${parsed.hash.substr(1)}`;
	          }
	        }
	        return parsed.toString();
	      } catch (e) {
	        return url;
	      }
	    },
	    isExternalLink(url) {
	      try {
	        let parsed = new URL(url.replace(/^\/+/, ''), location.href);
	        return parsed.hostname !== location.hostname;
	      } catch (e) {
	        return false;
	      }
	    },
	    packageToImportName(name) {
	      name = name.split(/[ ._-]/g).reduce((acc, value) => {
	        return acc + value.substr(0, 1).toUpperCase() + value.substr(1);
	      }).replace(/[^a-zA-Z0-9_$]/g, '');
	      if (/^\d/.test(name)) {
	        return `_${name}`;
	      }
	      return name || 'm';
	    },
	    filterListStatPeriods(rawListStatPeriods, filterFor) {
	      if (!filterFor) {
	        return rawListStatPeriods;
	      }
	      return rawListStatPeriods.reduce((res, item) => {
	        if (Object.hasOwn(item.links, 'filterFor')) {
	          res.push(item);
	        }
	        return res;
	      }, []);
	    },
	    prepareFilteredStatPeriods(rawPeriods) {
	      let {
	        prepPeriods
	      } = rawPeriods.reduce((res, rawItem, rawItemIdx) => {
	        let monthQuarterText = '';
	        let {
	          period,
	          periodType
	        } = rawItem;
	        let [year, monthOrQuarter] = period.split('-');
	        if (monthOrQuarter) {
	          monthQuarterText = isNaN(Number(monthOrQuarter)) ? monthOrQuarter : MONTHS_FULL_NAMES_LIST[Number(monthOrQuarter) - 1];
	        }
	        res.prepPeriods.push({
	          periodType,
	          periodText: `${monthQuarterText} ${year}`.trim(),
	          periodValue: period
	        });
	        if (res.yearPointer !== year) {
	          res.yearPointer = year;
	        }

	        // check if next item has different year form current, if so - add separator
	        if (rawPeriods[rawItemIdx + 1] && rawPeriods[rawItemIdx + 1].period.split('-')[0] !== year) {
	          res.prepPeriods.push({
	            periodType: 'separator'
	          });
	        }
	        return res;
	      }, {
	        prepPeriods: [],
	        yearPointer: null
	      });
	      let defaultPeriods = [{
	        periodType: 's-month',
	        periodText: 'month',
	        periodValue: 'month'
	      }, {
	        periodType: 's-quarter',
	        periodText: 'quarter',
	        periodValue: 'quarter'
	      }, {
	        periodType: 's-year',
	        periodText: 'year',
	        periodValue: 'year'
	      }, {
	        periodType: 'separator'
	      }];
	      return defaultPeriods.concat(prepPeriods);
	    },
	    getPreparedListStatPeriods(rawListStatPeriods, filterFor) {
	      let filteredStatPeriods = this.filterListStatPeriods(rawListStatPeriods, filterFor);
	      return this.prepareFilteredStatPeriods(filteredStatPeriods);
	    },
	    truncate(text, length) {
	      if (text.length <= length) {
	        return text;
	      }
	      return `${text.substr(0, length - 3)}...`;
	    },
	    capitalizeFirstLetter(word) {
	      return word ? word[0].toUpperCase() + word.slice(1) : '';
	    },
	    capitalizeStrEveryFirstLetter(string, exclude = []) {
	      return string.split(' ').reduce((res, w) => {
	        if (exclude.includes(w)) {
	          res.push(w);
	        } else {
	          res.push(this.capitalizeFirstLetter(w));
	        }
	        return res;
	      }, []).join(' ');
	    },
	    getElementOffset(el) {
	      let box = el.getBoundingClientRect();
	      let docElem = document.documentElement;
	      return {
	        top: box.top + window.scrollY - docElem.clientTop,
	        left: box.left + window.scrollX - docElem.clientLeft
	      };
	    },
	    memoize(func) {
	      let cache = new Map();
	      return function (...args) {
	        let key = JSON.stringify(args);
	        if (!cache.has(key)) {
	          cache.set(key, func.apply(this, args));
	        }
	        return cache.get(key);
	      };
	    },
	    pluralize(singular, countOrPlural, countOrUndefined) {
	      let count = countOrUndefined ?? countOrPlural;
	      let plural = countOrUndefined ? countOrPlural : singular + 's';
	      return count === 1 ? singular : plural;
	    }
	  };
	});
	_.screenType;
	_.isTabletScreen;
	_.isMobileScreen;
	_.calculateGrowth;
	_.getValueFormatter;
	_.flattenFiles;
	_.formatDate;
	_.formatDateTime;
	_.formatHits;
	_.formatNumber;
	_.formatNumberWithSpace;
	_.getMinifiedName;
	_.getNonMinifiedName;
	_.listFiles;
	_.nth;
	_.getChartXAxisData;
	_.unescapeHtml;
	_.getValueByMagnitude;
	_.convertBytesToUnits;
	_.findUnitFromArray;
	_.findUnitFromNumber;
	_.formatBytesWithUnit;
	_.formatGrowth;
	_.formatShare;
	_.formatToShortNumber;
	_.makeHTTPRequest;
	_.createQueryString;
	_.deepExtend;
	_.onDocumentReady;
	_.checkIfYearIsLeap;
	_.getAmountOfDaysByMonth;
	_.getDateFormats;
	_.prepareDataForChartGroupedBy;
	_.createWeekPeriodChartLabels;
	_.createMonthPeriodChartLabels;
	_.createYearPeriodChartLabels;
	_.getSortedIterableChartData;
	_.getPreparedDataForBarChart;
	_.calcChartBarThicknessByResolution;
	_.getPreparedProvidersDataForLineChart;
	_.getPreparedDataForLineChart;
	_.createImprovedExternalTooltipTitle;
	_.translatePeriodsToSNotation;
	_.optimizeSrc;
	_.normalizeHref;
	_.isExternalLink;
	_.packageToImportName;
	_.filterListStatPeriods;
	_.prepareFilteredStatPeriods;
	_.getPreparedListStatPeriods;
	_.truncate;
	_.capitalizeFirstLetter;
	_.capitalizeStrEveryFirstLetter;
	_.getElementOffset;
	_.memoize;
	_.pluralize;

	const API_HOST = 'https://data.jsdelivr.com';
	const GITHUB_API_HOST = 'https://api.github.com';
	const SNYK_API_HOST = 'https://snyk-widget.herokuapp.com';
	const RAW_GH_USER_CONTENT_HOST = 'https://raw.githubusercontent.com';
	const HTTP_CACHE = new Map();
	const getWithCache = (url, params = {}, responseHeadersToGet = null) => {
	  url += _.createQueryString(params);
	  if (HTTP_CACHE.has(url)) {
	    return HTTP_CACHE.get(url);
	  }
	  let request;
	  if (responseHeadersToGet) {
	    request = _.makeHTTPRequest({
	      url,
	      responseHeadersToGet
	    });
	  } else {
	    request = _.makeHTTPRequest({
	      url
	    });
	  }
	  HTTP_CACHE.set(url, request);
	  return request;
	};
	var fetchPackageReadme = (type, name, version) => {
	  return _.makeHTTPRequest({
	    url: `/readme/${type}/${name}${version ? `/${version}` : ''}`,
	    rawResponse: true
	  });
	};
	var fetchNetworkStats = (period = 'month') => {
	  return getWithCache(`${API_HOST}/v1/stats/network/content?period=${period}`);
	};
	var fetchPackageFiles = (type, name, version) => {
	  return getWithCache(`${API_HOST}/v1/packages/${type}/${name}@${encodeURIComponent(version)}`);
	};
	var fetchPackageFilesFlat = (type, name, version) => {
	  let flatten = items => {
	    return items.reduce((acc, item) => {
	      if (item.type === 'file') {
	        acc.push({
	          ...item,
	          name: `/${item.name}`
	        });
	        return acc;
	      }
	      return flatten(item.files).reduce((acc, file) => {
	        acc.push({
	          ...file,
	          name: `/${item.name}${file.name}`
	        });
	        return acc;
	      }, acc);
	    }, []);
	  };
	  return getWithCache(`${API_HOST}/v1/packages/${type}/${name}@${encodeURIComponent(version)}`).then(response => {
	    return {
	      ...response,
	      files: flatten(response.files)
	    };
	  });
	};
	var fetchPackageFileStats = (type, name, version, period = 'month', by = 'hits', limit = undefined) => {
	  return getWithCache(`${API_HOST}/v1/stats/packages/${type}/${name}@${encodeURIComponent(version)}/files`, {
	    period,
	    by,
	    limit
	  });
	};
	var fetchPackageFileStatsWithHeaders = (type, name, version, period = 'month', by = 'hits', limit = 5, page = 1) => {
	  let responseHeadersToGet = ['x-total-count', 'x-total-pages'];
	  return getWithCache(`${API_HOST}/v1/stats/packages/${type}/${name}@${encodeURIComponent(version)}/files`, {
	    period,
	    by,
	    limit,
	    page
	  }, responseHeadersToGet);
	};
	var fetchPackageSummaryStats = (type, name, period = 'month') => {
	  return getWithCache(`${API_HOST}/v1/stats/packages/${type}/${name}`, {
	    period
	  });
	};
	var fetchPackageVersionsStats = (type, name, period = 'month', by = 'hits', limit = '5') => {
	  return getWithCache(`${API_HOST}/v1/stats/packages/${type}/${name}/versions`, {
	    period,
	    by,
	    limit
	  });
	};
	var fetchPackageVersionsStatsWithHeaders = (type, name, period = 'month', by = 'hits', limit = 5, page = 1) => {
	  let responseHeadersToGet = ['x-total-count', 'x-total-pages'];
	  return getWithCache(`${API_HOST}/v1/stats/packages/${type}/${name}/versions`, {
	    period,
	    by,
	    limit,
	    page
	  }, responseHeadersToGet);
	};
	var fetchPackageVersions = (type, name) => {
	  return getWithCache(`${API_HOST}/v1/packages/${type}/${name}`);
	};
	var fetchTopPackages = (period = 'month') => {
	  return getWithCache(`${API_HOST}/v1/stats/packages?type=npm&period=${period}`);
	};
	var fetchProjectCommits = (owner, repo) => {
	  return getWithCache(`${GITHUB_API_HOST}/repos/${owner}/${repo}/commits`);
	};
	var findProjectIssue = (owner, repo, title) => {
	  return getWithCache(`${GITHUB_API_HOST}/search/issues`, {
	    q: `${title} user:${owner} repo:${repo}`
	  });
	};
	var fetchPackageVulnerabilities = (name, version) => {
	  return _.makeHTTPRequest({
	    url: `${SNYK_API_HOST}/test/npm/lib/${name}/${version}`,
	    headers: {
	      Authorization: '8U@$Kh6Qs#b@9qxYB!QhtvLeD=e+?Hq$_b#5%x*t'
	    }
	  });
	};
	var fetchPackageEntrypoints = (type, name, version) => {
	  return getWithCache(`${API_HOST}/v1/packages/${type}/${name}@${encodeURIComponent(version)}/entrypoints`);
	};
	var getGHUserContentPackageReadme = (packageOwner, packageName, packageGitHead = 'HEAD') => {
	  return new Promise((resolve, reject) => {
	    _.makeHTTPRequest({
	      url: `${RAW_GH_USER_CONTENT_HOST}/${packageOwner}/${packageName}/${packageGitHead}/README.md`,
	      rawResponse: true
	    }).then(response => {
	      resolve(response);
	    }).catch(() => {
	      _.makeHTTPRequest({
	        url: `${RAW_GH_USER_CONTENT_HOST}/${packageOwner}/${packageName}/${packageGitHead}/README.markdown`,
	        rawResponse: true
	      }).then(response => {
	        resolve(response);
	      }).catch(err => {
	        reject(err);
	      });
	    });
	  });
	};
	var fetchCdnOssStats = (name, period = 'month') => {
	  return getWithCache(`${API_HOST}/v1/stats/proxies/${name}`, {
	    period
	  });
	};
	var fetchNetworkProviderStats = (period, country = '', continent = '') => {
	  let body = {
	    period
	  };
	  country && (body.country = country);
	  continent && (body.continent = continent);
	  return getWithCache(`${API_HOST}/v1/stats/network`, body);
	};
	var fetchNetworkProviderStatsByCountry = (period = 'month') => {
	  return getWithCache(`${API_HOST}/v1/stats/network/countries`, {
	    period
	  });
	};

	/** *
	 * @param dataType - request type value: "platforms", "browsers"
	 * @param isVersionGrouped  - version grouped switchbox value: boolean
	 * @param selectedItem - selected certain platform or browser value:string
	 * @param breakdown - country breakdown, browser breakdown, platform, version breakdown
	 * @param period -  time period for which the stats are returned (s-month, s-year)
	 * @param country - country. Includes only data for this country
	 * @param continent - continent. Includes only data for this country
	 ***/
	var fetchTopPlatformBrowserStats = (dataType, isVersionGrouped, period, selectedItem, breakdown, country, continent, page = 1, limit = 10) => {
	  let responseHeadersToGet = ['x-total-count', 'x-total-pages'];
	  let url = dataType === 'platform' ? `${API_HOST}/v1/stats/platforms` : `${API_HOST}/v1/stats/browsers`;
	  let body = {
	    period: _.translatePeriodsToSNotation(period),
	    page,
	    limit
	  };
	  if (country) {
	    body.country = country;
	  }
	  if (continent) {
	    body.continent = continent;
	  }
	  if (selectedItem) {
	    if (selectedItem.version) {
	      url += `/${selectedItem.name.toLowerCase()}/versions/${selectedItem.version}/countries`;
	    } else {
	      url += `/${selectedItem.name.toLowerCase()}/${breakdown}`;
	    }
	  } else if (!isVersionGrouped) {
	    url += '/versions';
	  }
	  return _.makeHTTPRequest({
	    url,
	    body,
	    responseHeadersToGet
	  });
	};
	var fetchProjectStats = (type, period, sortBy = 'hits', page = 1, limit = 10) => {
	  let responseHeadersToGet = ['x-total-count', 'x-total-pages'];
	  let body = {
	    period,
	    by: sortBy,
	    page,
	    limit
	  };
	  if (type !== 'all') {
	    body.type = type;
	  }
	  return _.makeHTTPRequest({
	    url: `${API_HOST}/v1/stats/packages`,
	    body,
	    responseHeadersToGet
	  });
	};
	var fetchNetworkWideStats = () => {
	  return getWithCache(`${API_HOST}/v1/stats/network`);
	};
	var fetchNumberOfResources = () => {
	  let responseHeadersToGet = ['x-total-count'];
	  let body = {
	    limit: 1
	  };
	  return _.makeHTTPRequest({
	    url: `${API_HOST}/v1/stats/packages`,
	    body,
	    responseHeadersToGet
	  });
	};
	var fetchListStatPeriods = () => {
	  return getWithCache(`${API_HOST}/v1/stats/periods`);
	};
	var getBlogRss = () => {
	  return _.makeHTTPRequest({
	    url: `/blog/rss`,
	    rawResponse: true
	  });
	};
	var getCdnOssFiles = (name, by = 'hits', limit = 5, page = 1) => {
	  let responseHeadersToGet = ['x-total-count', 'x-total-pages'];
	  return getWithCache(`${API_HOST}/v1/stats/proxies/${name}/files`, {
	    page,
	    limit,
	    by
	  }, responseHeadersToGet);
	};
	var http = {
	  fetchPackageReadme: fetchPackageReadme,
	  fetchNetworkStats: fetchNetworkStats,
	  fetchPackageFiles: fetchPackageFiles,
	  fetchPackageFilesFlat: fetchPackageFilesFlat,
	  fetchPackageFileStats: fetchPackageFileStats,
	  fetchPackageFileStatsWithHeaders: fetchPackageFileStatsWithHeaders,
	  fetchPackageSummaryStats: fetchPackageSummaryStats,
	  fetchPackageVersionsStats: fetchPackageVersionsStats,
	  fetchPackageVersionsStatsWithHeaders: fetchPackageVersionsStatsWithHeaders,
	  fetchPackageVersions: fetchPackageVersions,
	  fetchTopPackages: fetchTopPackages,
	  fetchProjectCommits: fetchProjectCommits,
	  findProjectIssue: findProjectIssue,
	  fetchPackageVulnerabilities: fetchPackageVulnerabilities,
	  fetchPackageEntrypoints: fetchPackageEntrypoints,
	  getGHUserContentPackageReadme: getGHUserContentPackageReadme,
	  fetchCdnOssStats: fetchCdnOssStats,
	  fetchNetworkProviderStats: fetchNetworkProviderStats,
	  fetchNetworkProviderStatsByCountry: fetchNetworkProviderStatsByCountry,
	  fetchTopPlatformBrowserStats: fetchTopPlatformBrowserStats,
	  fetchProjectStats: fetchProjectStats,
	  fetchNetworkWideStats: fetchNetworkWideStats,
	  fetchNumberOfResources: fetchNumberOfResources,
	  fetchListStatPeriods: fetchListStatPeriods,
	  getBlogRss: getBlogRss,
	  getCdnOssFiles: getCdnOssFiles
	};

	var has = {
	  localStorage() {
	    try {
	      localStorage.setItem('localStorageTest', 1);
	      localStorage.removeItem('localStorageTest');
	    } catch (e) {
	      return false;
	    }
	    return true;
	  },
	  sessionStorage() {
	    try {
	      sessionStorage.setItem('sessionStorageTest', 1);
	      sessionStorage.removeItem('sessionStorageTest');
	    } catch (e) {
	      return false;
	    }
	    return true;
	  }
	};

	var component$18 = {
	  exports: {}
	};
	component$18.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      t: 13,
	      n: "class",
	      f: "c-header-gradient",
	      g: 1
	    }],
	    f: [{
	      t: 7,
	      e: "img",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "header-gradient_primary",
	        g: 1
	      }, {
	        n: "fetchpriority",
	        f: "high",
	        t: 13,
	        g: 1
	      }, {
	        n: "width",
	        f: "1440",
	        t: 13,
	        g: 1
	      }, {
	        n: "height",
	        f: "684",
	        t: 13,
	        g: 1
	      }, {
	        n: "src",
	        f: [{
	          t: 2,
	          r: "@shared.assetsHost"
	        }, "/img/about/about-gradient.jpg"],
	        t: 13
	      }]
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "header-gradient_secondary",
	        g: 1
	      }]
	    }, " ", {
	      t: 4,
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "header-gradient_map",
	          g: 1
	        }]
	      }],
	      n: 50,
	      r: "showMap"
	    }]
	  }]
	};
	var headerGradient = ractive__default["default"].extend(component$18.exports);

	var component$17 = {
	  exports: {}
	};
	const notificationKey = 'job-1-notificationSeen';
	component$17.exports = {
	  data() {
	    return {
	      notificationSeen: true
	    };
	  },
	  oninit() {
	    if (ractive__default["default"].isServer) {
	      this.set('notificationSeen', true);
	    } else {
	      if (has.localStorage()) {
	        if (localStorage.getItem(notificationKey)) {
	          this.set('notificationSeen', true);
	        }
	        this.observe('notificationSeen', newValue => {
	          localStorage.setItem(notificationKey, JSON.stringify(newValue));
	        }, {
	          init: false
	        });
	      }

	      // this.observe('notificationSeen', (newValue) => {
	      // 	document.body.classList[newValue ? 'remove' : 'add']('c-notification-visible');
	      // });
	    }
	  }
	};
	component$17.exports.template = {
	  v: 4,
	  t: [{
	    t: 4,
	    f: [{
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "c-notification",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "i",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "fa fa-bullhorn",
	          g: 1
	        }, {
	          n: "aria-hidden",
	          f: "true",
	          t: 13,
	          g: 1
	        }]
	      }, " ", {
	        t: 7,
	        e: "a",
	        m: [{
	          n: "href",
	          f: "https://gist.github.com/jimaek/de24cee25048de8bbe3f0d811695cdf7",
	          t: 13,
	          g: 1
	        }, {
	          n: "target",
	          f: "_blank",
	          t: 13,
	          g: 1
	        }],
	        f: ["We're looking for a Senior Node.js Engineer to help expand our open-source projects!"]
	      }, " ", {
	        t: 7,
	        e: "a",
	        m: [{
	          n: ["click"],
	          t: 70,
	          f: {
	            r: ["@this"],
	            s: "[_0.set(\"notificationSeen\",true)]"
	          }
	        }, {
	          n: "aria-label",
	          f: "Close",
	          t: 13,
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "i",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "fa fa-times",
	            g: 1
	          }, {
	            n: "aria-hidden",
	            f: "true",
	            t: 13,
	            g: 1
	          }]
	        }]
	      }]
	    }],
	    n: 50,
	    x: {
	      r: ["notificationSeen"],
	      s: "!_0"
	    }
	  }],
	  e: {
	    "[_0.set(\"notificationSeen\",true)]": function (_0) {
	      return [_0.set("notificationSeen", true)];
	    },
	    "!_0": function (_0) {
	      return !_0;
	    }
	  }
	};
	var notification = ractive__default["default"].extend(component$17.exports);

	var component$16 = {
	  exports: {}
	};
	component$16.exports = {
	  data() {
	    return {
	      date: new Date(),
	      docInnerHtml: null,
	      blogLinksData: null
	    };
	  },
	  oninit() {
	    if (!ractive__default["default"].isServer) {
	      http.getBlogRss().then(response => {
	        if (response) {
	          let document = new window.DOMParser().parseFromString(response, 'text/xml');
	          let items = document.documentElement.childNodes[0].getElementsByTagName('item');
	          let data = [];
	          for (let i = 0; i < items.length; i++) {
	            let currItemNodesList = items[i].childNodes;
	            let currItemTitle;
	            let currItemLink;
	            let currItemPubDate;
	            for (let k = 0; k < currItemNodesList.length; k++) {
	              if (currItemNodesList[k].nodeName === 'title') {
	                currItemTitle = currItemNodesList[k].textContent;
	              } else if (currItemNodesList[k].nodeName === 'link') {
	                currItemLink = currItemNodesList[k].textContent;
	              } else if (currItemNodesList[k].nodeName === 'pubDate') {
	                currItemPubDate = currItemNodesList[k].textContent;
	              }
	            }
	            data.push({
	              text: currItemTitle,
	              url: `/blog${new URL(currItemLink, 'https://www.jsdelivr.com').pathname}`,
	              date: new Date(currItemPubDate).getTime()
	            });
	          }
	          data.sort((a, b) => b.date - a.date);
	          this.set('blogLinksData', data.slice(0, 5));
	        }
	      });
	    }
	  }
	};
	component$16.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "footer",
	    m: [{
	      t: 13,
	      n: "class",
	      f: "c-footer",
	      g: 1
	    }],
	    f: [{
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "wrapper",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "container-fluid container-mw",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "row block-main",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "col-xs-12 col-sm-6 main-left",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "maintain-header",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "span",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "text-footer-14 op-64",
	                  g: 1
	                }],
	                f: ["Maintained by"]
	              }, " ", {
	                t: 7,
	                e: "a",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "text-footer-14",
	                  g: 1
	                }, {
	                  n: "href",
	                  f: "/about#people",
	                  t: 13,
	                  g: 1
	                }],
	                f: ["jsDelivr team and contributors"]
	              }, " ", {
	                t: 7,
	                e: "br"
	              }, " ", {
	                t: 7,
	                e: "span",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "text-footer-14 op-64",
	                  g: 1
	                }],
	                f: ["Founded by"]
	              }, " ", {
	                t: 7,
	                e: "a",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "text-footer-14",
	                  g: 1
	                }, {
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "rel",
	                  f: "noopener noreferrer",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "href",
	                  f: "https://dakulov.com/",
	                  t: 13,
	                  g: 1
	                }],
	                f: ["Dmitriy Akulov"]
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "col-xs-12 col-sm-6 main-right",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "main-right-container",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "subscribe-header",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "text-footer-14",
	                    g: 1
	                  }],
	                  f: ["Sign up to our newsletter"]
	                }]
	              }, " ", {
	                t: 7,
	                e: "form",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "form-inline subscribe-content",
	                  g: 1
	                }, {
	                  n: "action",
	                  f: "https://jsdelivr.us11.list-manage.com/subscribe?u=0c85fe2c9a60310df9a3d6751&id=283887f736",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "method",
	                  f: "POST",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "form-group",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "input",
	                    m: [{
	                      n: "type",
	                      f: "email",
	                      t: 13
	                    }, {
	                      n: "autocomplete",
	                      f: "email",
	                      t: 13
	                    }, {
	                      n: "class",
	                      f: "form-control",
	                      t: 13
	                    }, {
	                      n: "name",
	                      f: "MERGE0",
	                      t: 13
	                    }, {
	                      n: "id",
	                      f: "new-email",
	                      t: 13
	                    }, {
	                      n: "placeholder",
	                      f: "Enter your e-mail",
	                      t: 13
	                    }]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "button",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "btn btn-default semi-bold",
	                    g: 1
	                  }, {
	                    n: "type",
	                    f: "submit",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: ["Subscribe"]
	                }]
	              }]
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "footer-separator",
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "block-list",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "title-copy-bottom op-64",
	              g: 1
	            }],
	            f: ["© jsdelivr.com, 2012 - ", {
	              t: 2,
	              x: {
	                r: ["date"],
	                s: "_0.getFullYear()"
	              }
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "row list-primary",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "col-sm-12",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "title-copy op-64",
	                  g: 1
	                }],
	                f: ["© jsdelivr.com, 2012 - ", {
	                  t: 2,
	                  x: {
	                    r: ["date"],
	                    s: "_0.getFullYear()"
	                  }
	                }]
	              }, " ", {
	                t: 7,
	                e: "ul",
	                f: [{
	                  t: 7,
	                  e: "li",
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "href",
	                      f: "/about",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["About"]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "li",
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "href",
	                      f: "/history",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["Our History"]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "li",
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "href",
	                      f: "/sponsors",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["Our Sponsors"]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "li",
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "href",
	                      f: "/oss-cdn",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["Custom OSS CDN"]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "li",
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "href",
	                      f: "https://status.jsdelivr.com/",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["Status"]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "li",
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "href",
	                      f: "/terms",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["Terms & Policies"]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "li",
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "href",
	                      f: "mailto:d@jsdelivr.com",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["d@jsdelivr.com"]
	                  }]
	                }]
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "row list-second",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "col-sm-12",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "title-convert op-64",
	                  g: 1
	                }],
	                f: ["Convert from:"]
	              }, " ", {
	                t: 7,
	                e: "ul",
	                f: [{
	                  t: 7,
	                  e: "li",
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "href",
	                      f: "/github",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["GitHub"]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "li",
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "href",
	                      f: "/google",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["Google Hosted Libraries"]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "li",
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "href",
	                      f: "/unpkg",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["unpkg"]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "li",
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "href",
	                      f: "/skypack",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["Skypack"]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "li",
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "href",
	                      f: "/esmsh",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["esm.sh"]
	                  }]
	                }]
	              }]
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "footer-separator",
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "footer-blog-links",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "footer-blog-links_title op-64",
	              g: 1
	            }],
	            f: ["From our Blog"]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "footer-blog-links_block",
	              g: 1
	            }],
	            f: [{
	              t: 4,
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "router-ignore",
	                  g: 1
	                }, {
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "href",
	                  f: [{
	                    t: 2,
	                    r: "@shared.serverHost"
	                  }, {
	                    t: 2,
	                    r: "./url"
	                  }],
	                  t: 13
	                }],
	                f: [{
	                  t: 2,
	                  r: "./text"
	                }]
	              }],
	              n: 52,
	              r: "blogLinksData"
	            }]
	          }]
	        }]
	      }]
	    }]
	  }],
	  e: {
	    "_0.getFullYear()": function (_0) {
	      return _0.getFullYear();
	    }
	  }
	};
	var footer = ractive__default["default"].extend(component$16.exports);

	var component$15 = {
	  exports: {}
	};
	component$15.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "header",
	    m: [{
	      n: "class",
	      f: ["c-header ", {
	        t: 4,
	        f: ["disabled"],
	        n: 50,
	        r: "searchOpened"
	      }, " ", {
	        t: 4,
	        f: [{
	          t: 2,
	          r: "additionalClasses"
	        }],
	        n: 50,
	        r: "additionalClasses"
	      }],
	      t: 13
	    }],
	    f: [{
	      t: 7,
	      e: "nav",
	      m: [{
	        n: "class",
	        f: ["navbar navbar-default ", {
	          t: 2,
	          x: {
	            r: ["@shared.actualPath", "useWhiteLogos"],
	            s: "!_0||_1?\"navbar-filled\":\"\""
	          }
	        }],
	        t: 13
	      }],
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "container-fluid container-mw",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "navbar-header",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "a",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "main-logo",
	              g: 1
	            }, {
	              n: "href",
	              f: "/",
	              t: 13,
	              g: 1
	            }, {
	              n: ["click"],
	              t: 70,
	              f: {
	                r: ["@this"],
	                s: "[_0.fire(\"main-logo-click\")]"
	              }
	            }],
	            f: [{
	              t: 9,
	              c: "\n\t\t\t\t\t\tLooking for the logo?\n\t\t\t\t\t\tGet all versions here: https://github.com/jsdelivr/jsdelivr-media\n\t\t\t\t\t"
	            }, " ", {
	              t: 4,
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "29",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "32",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/icons/jsdelivr_icon.svg"],
	                  t: 13
	                }, {
	                  n: "title",
	                  f: "jsDelivr",
	                  t: 13,
	                  g: 1
	                }]
	              }],
	              n: 50,
	              x: {
	                r: ["@shared.actualPath"],
	                s: "_0&&_0.startsWith(\"/package/\")"
	              }
	            }, {
	              t: 4,
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "140",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "34",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/jsdelivr-horizontal-white.svg"],
	                  t: 13
	                }, {
	                  n: "title",
	                  f: "jsDelivr",
	                  t: 13,
	                  g: 1
	                }]
	              }, " "],
	              n: 50,
	              x: {
	                r: ["@shared.actualPath"],
	                s: "_0&&_0.startsWith(\"/docs/data.jsdelivr.com\")"
	              },
	              l: 1
	            }, {
	              t: 4,
	              f: [" ", {
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "140",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "34",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/jsdelivr-horizontal-full-white.svg"],
	                  t: 13
	                }, {
	                  n: "title",
	                  f: "jsDelivr",
	                  t: 13,
	                  g: 1
	                }]
	              }, " "],
	              n: 50,
	              x: {
	                r: ["@shared.actualPath", "useWhiteLogos"],
	                s: "_0&&_1"
	              },
	              l: 1
	            }, {
	              t: 4,
	              f: [" ", {
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "140",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "34",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/jsdelivr-horizontal-regular.svg"],
	                  t: 13
	                }, {
	                  n: "title",
	                  f: "jsDelivr",
	                  t: 13,
	                  g: 1
	                }]
	              }],
	              n: 50,
	              r: "@shared.actualPath",
	              l: 1
	            }]
	          }, " ", {
	            t: 4,
	            f: [{
	              t: 16
	            }],
	            n: 50,
	            x: {
	              r: ["@shared.actualPath"],
	              s: "_0&&_0.includes(\"/package/\")"
	            }
	          }, " ", {
	            t: 7,
	            e: "button",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "navbar-toggle collapsed",
	              g: 1
	            }, {
	              n: "type",
	              f: "button",
	              t: 13,
	              g: 1
	            }, {
	              n: "data-toggle",
	              f: "collapse",
	              t: 13,
	              g: 1
	            }, {
	              n: "data-target",
	              f: "#main-navbar",
	              t: 13,
	              g: 1
	            }, {
	              n: "aria-expanded",
	              f: "false",
	              t: 13,
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "sr-only",
	                g: 1
	              }],
	              f: ["Toggle navigation"]
	            }, " ", {
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "icon-bar",
	                g: 1
	              }]
	            }, " ", {
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "icon-bar",
	                g: 1
	              }]
	            }, " ", {
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "icon-bar",
	                g: 1
	              }]
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "collapse navbar-collapse",
	            g: 1
	          }, {
	            n: "id",
	            f: "main-navbar",
	            t: 13,
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "ul",
	            m: [{
	              n: "class",
	              f: ["nav navbar-nav navbar-right ", {
	                t: 2,
	                x: {
	                  r: ["@shared.actualPath", "useWhiteLogos"],
	                  s: "!_0?\"navbar-hidden\":_1?\"about-navbar-right\":\"default-navbar-right\""
	                }
	              }],
	              t: 13
	            }],
	            f: [{
	              t: 7,
	              e: "li",
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "href",
	                  f: "/about",
	                  t: 13,
	                  g: 1
	                }],
	                f: ["About Us"]
	              }]
	            }, " ", {
	              t: 7,
	              e: "li",
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "href",
	                  f: "/network",
	                  t: 13,
	                  g: 1
	                }],
	                f: ["Network"]
	              }]
	            }, " ", {
	              t: 7,
	              e: "li",
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "href",
	                  f: "/statistics",
	                  t: 13,
	                  g: 1
	                }],
	                f: ["Stats"]
	              }]
	            }, " ", {
	              t: 7,
	              e: "li",
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "href",
	                  f: "/sponsors",
	                  t: 13,
	                  g: 1
	                }],
	                f: ["Sponsors"]
	              }]
	            }, " ", {
	              t: 7,
	              e: "li",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "dropdown",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "dropdown-toggle",
	                  g: 1
	                }, {
	                  n: "data-toggle",
	                  f: "dropdown",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "role",
	                  f: "button",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "aria-haspopup",
	                  f: "true",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "aria-expanded",
	                  f: "false",
	                  t: 13,
	                  g: 1
	                }],
	                f: ["Tools ", {
	                  t: 7,
	                  e: "i",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "fa fa-angle-down",
	                    g: 1
	                  }, {
	                    n: "aria-hidden",
	                    f: "true",
	                    t: 13,
	                    g: 1
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "ul",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "dropdown-menu",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "li",
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "href",
	                      f: "/tools/purge",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["Purge cache"]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "li",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "divider",
	                    g: 1
	                  }, {
	                    n: "role",
	                    f: "separator",
	                    t: 13,
	                    g: 1
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "li",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "dropdown-header",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "div",
	                    f: ["Convert from"]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "li",
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "href",
	                      f: "/github",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["GitHub"]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "li",
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "href",
	                      f: "/google",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["Google Hosted Libraries"]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "li",
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "href",
	                      f: "/unpkg",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["unpkg"]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "li",
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "href",
	                      f: "/skypack",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["Skypack"]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "li",
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "href",
	                      f: "/esmsh",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["esm.sh"]
	                  }]
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "li",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "dropdown",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "dropdown-toggle",
	                  g: 1
	                }, {
	                  n: "data-toggle",
	                  f: "dropdown",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "role",
	                  f: "button",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "aria-haspopup",
	                  f: "true",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "aria-expanded",
	                  f: "false",
	                  t: 13,
	                  g: 1
	                }],
	                f: ["Resources ", {
	                  t: 7,
	                  e: "i",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "fa fa-angle-down",
	                    g: 1
	                  }, {
	                    n: "aria-hidden",
	                    f: "true",
	                    t: 13,
	                    g: 1
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "ul",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "dropdown-menu",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "li",
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "router-ignore",
	                      g: 1
	                    }, {
	                      n: "target",
	                      f: "_blank",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "href",
	                      f: "/blog/",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["Blog ", {
	                      t: 7,
	                      e: "i",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "fa fa-external-link",
	                        g: 1
	                      }, {
	                        n: "aria-hidden",
	                        f: "true",
	                        t: 13,
	                        g: 1
	                      }]
	                    }]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "li",
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "target",
	                      f: "_blank",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "rel",
	                      f: "noopener noreferrer",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "href",
	                      f: "https://jsdelivr.us11.list-manage.com/subscribe?u=0c85fe2c9a60310df9a3d6751&id=283887f736",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["Newsletter ", {
	                      t: 7,
	                      e: "i",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "fa fa-external-link",
	                        g: 1
	                      }, {
	                        n: "aria-hidden",
	                        f: "true",
	                        t: 13,
	                        g: 1
	                      }]
	                    }]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "li",
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "href",
	                      f: "/esm",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["esm.run"]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "li",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "dropdown-header",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "div",
	                    f: ["Documentation"]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "li",
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "href",
	                      f: "/documentation",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["Open Source CDN"]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "li",
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "router-ignore",
	                      g: 1
	                    }, {
	                      n: "href",
	                      f: "/docs/data.jsdelivr.com",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["Public API"]
	                  }]
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "li",
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "href",
	                  f: "https://globalping.io",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }],
	                f: ["Globalping", {
	                  t: 7,
	                  e: "i",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "fa fa-external-link",
	                    g: 1
	                  }]
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "li",
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "rel",
	                  f: "noopener noreferrer",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "href",
	                  f: "https://github.com/jsdelivr/jsdelivr",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "title",
	                  f: "GitHub",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "i",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "fa fa-github",
	                    g: 1
	                  }, {
	                    n: "aria-hidden",
	                    f: "true",
	                    t: 13,
	                    g: 1
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "icon-label-mobile",
	                    g: 1
	                  }],
	                  f: ["GitHub"]
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "li",
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "rel",
	                  f: "noopener noreferrer",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "href",
	                  f: "https://twitter.com/jsDelivr",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "title",
	                  f: "Twitter",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "i",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "fa fa-twitter",
	                    g: 1
	                  }, {
	                    n: "aria-hidden",
	                    f: "true",
	                    t: 13,
	                    g: 1
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "icon-label-mobile",
	                    g: 1
	                  }],
	                  f: ["Twitter"]
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "li",
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "router-ignore",
	                  g: 1
	                }, {
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "rel",
	                  f: "noopener noreferrer",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "href",
	                  f: "/discord",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "title",
	                  f: "Discord",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "svg",
	                  m: [{
	                    t: 13,
	                    n: "style",
	                    f: "margin-top: 1px;",
	                    g: 1
	                  }, {
	                    t: 13,
	                    n: "class",
	                    f: "fa",
	                    g: 1
	                  }, {
	                    n: "xmlns",
	                    f: "http://www.w3.org/2000/svg",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "viewBox",
	                    f: "0 0 640 512",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "width",
	                    f: "14",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "14",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "title",
	                    f: "Discord",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "path",
	                    m: [{
	                      n: "fill",
	                      f: [{
	                        t: 4,
	                        f: ["#fff"],
	                        n: 50,
	                        r: "useWhiteLogos"
	                      }, {
	                        t: 4,
	                        f: ["#17233b"],
	                        n: 51,
	                        l: 1
	                      }],
	                      t: 13
	                    }, {
	                      n: "d",
	                      f: "M524.531 69.836a1.5 1.5 0 0 0-.764-.7A485.065 485.065 0 0 0 404.081 32.03a1.816 1.816 0 0 0-1.923.91 337.461 337.461 0 0 0-14.9 30.6 447.848 447.848 0 0 0-134.426 0 309.541 309.541 0 0 0-15.135-30.6 1.89 1.89 0 0 0-1.924-.91 483.689 483.689 0 0 0-119.688 37.107 1.712 1.712 0 0 0-.788.676C39.068 183.651 18.186 294.69 28.43 404.354a2.016 2.016 0 0 0 .765 1.375 487.666 487.666 0 0 0 146.825 74.189 1.9 1.9 0 0 0 2.063-.676A348.2 348.2 0 0 0 208.12 430.4a1.86 1.86 0 0 0-1.019-2.588 321.173 321.173 0 0 1-45.868-21.853 1.885 1.885 0 0 1-.185-3.126 251.047 251.047 0 0 0 9.109-7.137 1.819 1.819 0 0 1 1.9-.256c96.229 43.917 200.41 43.917 295.5 0a1.812 1.812 0 0 1 1.924.233 234.533 234.533 0 0 0 9.132 7.16 1.884 1.884 0 0 1-.162 3.126 301.407 301.407 0 0 1-45.89 21.83 1.875 1.875 0 0 0-1 2.611 391.055 391.055 0 0 0 30.014 48.815 1.864 1.864 0 0 0 2.063.7A486.048 486.048 0 0 0 610.7 405.729a1.882 1.882 0 0 0 .765-1.352c12.264-126.783-20.532-236.912-86.934-334.541ZM222.491 337.58c-28.972 0-52.844-26.587-52.844-59.239s23.409-59.241 52.844-59.241c29.665 0 53.306 26.82 52.843 59.239 0 32.654-23.41 59.241-52.843 59.241Zm195.38 0c-28.971 0-52.843-26.587-52.843-59.239s23.409-59.241 52.843-59.241c29.667 0 53.307 26.82 52.844 59.239 0 32.654-23.177 59.241-52.844 59.241Z",
	                      t: 13,
	                      g: 1
	                    }]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "icon-label-mobile",
	                    g: 1
	                  }],
	                  f: ["Discord"]
	                }]
	              }]
	            }]
	          }]
	        }]
	      }]
	    }]
	  }],
	  e: {
	    "!_0||_1?\"navbar-filled\":\"\"": function (_0, _1) {
	      return !_0 || _1 ? "navbar-filled" : "";
	    },
	    "[_0.fire(\"main-logo-click\")]": function (_0) {
	      return [_0.fire("main-logo-click")];
	    },
	    "_0&&_0.startsWith(\"/package/\")": function (_0) {
	      return _0 && _0.startsWith("/package/");
	    },
	    "_0&&_0.startsWith(\"/docs/data.jsdelivr.com\")": function (_0) {
	      return _0 && _0.startsWith("/docs/data.jsdelivr.com");
	    },
	    "_0&&_1": function (_0, _1) {
	      return _0 && _1;
	    },
	    "_0&&_0.includes(\"/package/\")": function (_0) {
	      return _0 && _0.includes("/package/");
	    },
	    "!_0?\"navbar-hidden\":_1?\"about-navbar-right\":\"default-navbar-right\"": function (_0, _1) {
	      return !_0 ? "navbar-hidden" : _1 ? "about-navbar-right" : "default-navbar-right";
	    }
	  }
	};
	var header = ractive__default["default"].extend(component$15.exports);

	var component$14 = {
	  exports: {}
	};
	component$14.exports.template = {
	  v: 4,
	  t: [{
	    t: 4,
	    f: [{
	      t: 7,
	      e: "script",
	      m: [{
	        n: "type",
	        f: "text/plain",
	        t: 13,
	        g: 1
	      }, {
	        n: "id",
	        f: "ractive-data",
	        t: 13,
	        g: 1
	      }],
	      f: ["\t\t<<RACTIVE_SERIALIZED_DATA>>\n\t"]
	    }, " ", {
	      t: 7,
	      e: "script",
	      m: [{
	        n: "type",
	        f: "text/plain",
	        t: 13,
	        g: 1
	      }, {
	        n: "id",
	        f: "ractive-shared",
	        t: 13,
	        g: 1
	      }],
	      f: ["\t\t", {
	        t: 2,
	        x: {
	          r: ["@shared", "@shared.serverHost", "@shared.assetsHost", "@shared.apiDocsHost", "@shared.assetsVersion", "@shared.route", "@shared.params", "@shared.qsParams", "@shared.options"],
	          s: "_0.escape(JSON.stringify({serverHost:_1,assetsHost:_2,apiDocsHost:_3,assetsVersion:_4,route:_5,params:_6,qsParams:_7,options:_8}))"
	        }
	      }, "\n\t"]
	    }],
	    n: 50,
	    r: "@shared.isServer"
	  }],
	  e: {
	    "_0.escape(JSON.stringify({serverHost:_1,assetsHost:_2,apiDocsHost:_3,assetsVersion:_4,route:_5,params:_6,qsParams:_7,options:_8}))": function (_0, _1, _2, _3, _4, _5, _6, _7, _8) {
	      return _0.escape(JSON.stringify({
	        serverHost: _1,
	        assetsHost: _2,
	        apiDocsHost: _3,
	        assetsVersion: _4,
	        route: _5,
	        params: _6,
	        qsParams: _7,
	        options: _8
	      }));
	    }
	  }
	};
	var rSerialize = ractive__default["default"].extend(component$14.exports);

	var component$13 = {
	  exports: {}
	};
	const R_META_CLASS = 'r-meta-e';
	ractive__default["default"].sharedSet('R_META_CLASS', R_META_CLASS);
	component$13.exports = {
	  oninit() {
	    let rPage = this.findParent('r-page');
	    let tMeta = rPage.partials.meta;
	    let tSeo = rPage.partials.seo;
	    let filterNodes = (o, predicate) => {
	      if (Array.isArray(o)) {
	        return o.filter(predicate).map(n => filterNodes(n, predicate));
	      } else if (o && typeof o === 'object') {
	        return Object.fromEntries(Object.entries(o).map(([key, value]) => {
	          return [key, filterNodes(value, predicate)];
	        }));
	      }
	      return o;
	    };
	    let walkElements = (o, callback) => {
	      if (Array.isArray(o)) {
	        o.forEach(i => walkElements(i, callback));
	      } else if (o && typeof o === 'object') {
	        if (o.t === 7) {
	          callback(o);
	        }
	        Object.values(o).forEach(v => walkElements(v, callback));
	      }
	    };
	    if (!tMeta._metaDecorated) {
	      tMeta = filterNodes(tMeta, n => n.t !== 9);
	      walkElements(tMeta, e => {
	        e.m = e.m || [];
	        e.m.push({
	          t: 13,
	          n: 'class',
	          f: R_META_CLASS
	        });
	      });
	      tMeta._metaDecorated = true;
	    }
	    if (tSeo && !tSeo._metaDecorated) {
	      tSeo = filterNodes(tSeo, n => n.t !== 9);
	      walkElements(tSeo, e => {
	        e.m = e.m || [];
	        e.m.push({
	          t: 13,
	          n: 'class',
	          f: R_META_CLASS
	        });
	      });
	      tSeo._metaDecorated = true;
	    }

	    // We need a way to identify the nodes rendered by the component via SSR
	    // when running on the client. We do this by injecting a special class into
	    // all elements in the template.
	    rPage.partials.seo = tSeo;
	    rPage.partials.meta = tMeta;
	    this.partials = rPage.partials;
	    this.resetPartial('meta', tMeta);

	    // A bit of context hacking:
	    // the meta partial itself renders with the context of r-page
	    // the seo partial renders with the context of the current page (root context)
	    this.link('', 'rootContext', {
	      instance: rPage.parent
	    });
	    this.link('', 'rPageContext', {
	      instance: rPage
	    });

	    // Update the shared path on page switch.
	    this.set('@shared.actualPath', this.get('@shared')?.app?.router?.uri?.path);
	  }
	};
	component$13.exports.template = {
	  v: 4,
	  t: [{
	    t: 8,
	    r: "meta",
	    c: {
	      r: "rPageContext"
	    }
	  }]
	};
	var rMeta = ractive__default["default"].extend(component$13.exports);

	var component$12 = {
	  exports: {}
	};
	component$12.exports = {
	  data() {
	    return {
	      publicRoot: ''
	    };
	  },
	  onrender() {
	    document.querySelectorAll(`.${ractive__default["default"].sharedGet('R_META_CLASS')}`).forEach(e => e.remove());
	    // eslint-disable-next-line new-cap
	    app.meta = new this.components['r-meta']({
	      el: document.head,
	      append: document.querySelector('meta').nextElementSibling,
	      parent: this
	    });
	  },
	  onunrender() {
	    app.meta.teardown();
	  }
	};
	component$12.exports.template = {
	  v: 4,
	  t: [{
	    t: 4,
	    f: [{
	      t: 16
	    }],
	    n: 50,
	    x: {
	      r: ["@shared.isServer"],
	      s: "!_0"
	    }
	  }, {
	    t: 4,
	    f: [{
	      t: 18,
	      a: " html"
	    }, " ", {
	      t: 7,
	      e: "html",
	      m: [{
	        n: "lang",
	        f: "en",
	        t: 13,
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "head",
	        f: [{
	          t: 7,
	          e: "meta",
	          m: [{
	            n: "charset",
	            f: "utf-8",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "r-meta"
	        }, " ", {
	          t: 9,
	          c: " Static part that doesn't change after the initial render. "
	        }, " ", {
	          t: 9,
	          c: " Maybe will be useful in Firefox at some point. "
	        }, " ", {
	          t: 7,
	          e: "link",
	          m: [{
	            n: "rel",
	            f: "dns-prefetch",
	            t: 13,
	            g: 1
	          }, {
	            n: "href",
	            f: "https://cdn.jsdelivr.net/",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "link",
	          m: [{
	            n: "rel",
	            f: "dns-prefetch",
	            t: 13,
	            g: 1
	          }, {
	            n: "href",
	            f: "https://data.jsdelivr.com/",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "link",
	          m: [{
	            n: "rel",
	            f: "dns-prefetch",
	            t: 13,
	            g: 1
	          }, {
	            n: "href",
	            f: "https://datum.jsdelivr.com/",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "link",
	          m: [{
	            n: "rel",
	            f: "preconnect",
	            t: 13,
	            g: 1
	          }, {
	            n: "href",
	            f: "https://cdn.jsdelivr.net/",
	            t: 13,
	            g: 1
	          }, {
	            n: "crossorigin",
	            f: "anonymous",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "link",
	          m: [{
	            n: "rel",
	            f: "preconnect",
	            t: 13,
	            g: 1
	          }, {
	            n: "href",
	            f: "https://data.jsdelivr.com/",
	            t: 13,
	            g: 1
	          }, {
	            n: "crossorigin",
	            f: "anonymous",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "link",
	          m: [{
	            n: "rel",
	            f: "preconnect",
	            t: 13,
	            g: 1
	          }, {
	            n: "href",
	            f: "https://datum.jsdelivr.com/",
	            t: 13,
	            g: 1
	          }, {
	            n: "crossorigin",
	            f: "anonymous",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "link",
	          m: [{
	            n: "rel",
	            f: "stylesheet",
	            t: 13,
	            g: 1
	          }, {
	            n: "href",
	            f: [{
	              t: 2,
	              r: "@shared.assetsHost"
	            }, "/css/app.css?v=", {
	              t: 2,
	              r: "@shared.assetsVersion"
	            }],
	            t: 13
	          }]
	        }, " ", {
	          t: 7,
	          e: "link",
	          m: [{
	            n: "rel",
	            f: "stylesheet",
	            t: 13,
	            g: 1
	          }, {
	            n: "href",
	            f: "https://cdn.jsdelivr.net/npm/font-awesome@4.7.0/css/font-awesome.min.css",
	            t: 13,
	            g: 1
	          }, {
	            n: "media",
	            f: "print",
	            t: 13,
	            g: 1
	          }, {
	            n: "onload",
	            f: "this.media='all'",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "link",
	          m: [{
	            n: "rel",
	            f: "sitemap",
	            t: 13,
	            g: 1
	          }, {
	            n: "href",
	            f: "/sitemap/index.xml",
	            t: 13,
	            g: 1
	          }, {
	            n: "type",
	            f: "application/xml",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "link",
	          m: [{
	            n: "rel",
	            f: "search",
	            t: 13,
	            g: 1
	          }, {
	            n: "href",
	            f: "/opensearch.xml",
	            t: 13,
	            g: 1
	          }, {
	            n: "type",
	            f: "application/opensearchdescription+xml",
	            t: 13,
	            g: 1
	          }, {
	            n: "title",
	            f: "jsDelivr",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "style",
	          f: ["\t\t\t\t@font-face {\n\t\t\t\t\tfont-family: 'Lexend';\n\t\t\t\t\tfont-style: normal;\n\t\t\t\t\tfont-weight: 100 900;\n\t\t\t\t\tsrc: url(https://cdn.jsdelivr.net/fontsource/fonts/lexend:vf@latest/latin-wght-normal.woff2) format('woff2-variations');\n\t\t\t\t}\n\n\t\t\t\t@font-face {\n\t\t\t\t\tfont-family: 'Source Code Pro';\n\t\t\t\t\tfont-style: normal;\n\t\t\t\t\tfont-weight: 200 900;\n\t\t\t\t\tsrc: url(https://cdn.jsdelivr.net/fontsource/fonts/source-code-pro:vf@latest/latin-wght-normal.woff2) format('woff2-variations');\n\t\t\t\t}\n\n\t\t\t\t@font-face {\n\t\t\t\t\tfont-family: 'Inter';\n\t\t\t\t\tfont-style: normal;\n\t\t\t\t\tfont-weight: 100 900;\n\t\t\t\t\tsrc: url(https://cdn.jsdelivr.net/fontsource/fonts/inter:vf@latest/latin-wght-normal.woff2) format('woff2-variations');\n\t\t\t\t}\n\t\t\t"]
	        }, " ", {
	          t: 16,
	          r: "css"
	        }]
	      }, " ", {
	        t: 7,
	        e: "body",
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            n: "id",
	            f: "page",
	            t: 13,
	            g: 1
	          }],
	          f: [{
	            t: 4,
	            f: [{
	              t: 16
	            }],
	            n: 51,
	            r: "noYield"
	          }]
	        }, " ", {
	          t: 7,
	          e: "r-serialize"
	        }, " ", {
	          t: 7,
	          e: "script",
	          m: [{
	            n: "src",
	            f: "https://cdn.jsdelivr.net/npm/ractive@1.4.0/runtime.min.js",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "script",
	          m: [{
	            n: "src",
	            f: "https://cdn.jsdelivr.net/npm/ractive-route@0.3.11/ractive-route.min.js",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "script",
	          m: [{
	            n: "src",
	            f: "https://cdn.jsdelivr.net/npm/ractive-decorators-sortable@0.2.1/Ractive-decorators-sortable.min.js",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "script",
	          m: [{
	            n: "src",
	            f: "https://cdn.jsdelivr.net/npm/ractive-transitions-fly@0.3.0/dist/ractive-transitions-fly.umd.min.js",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "script",
	          m: [{
	            n: "src",
	            f: "https://cdn.jsdelivr.net/npm/ractive-transitions-slide@0.4.0/dist/ractive-transitions-slide.umd.min.js",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "script",
	          m: [{
	            n: "src",
	            f: "https://cdn.jsdelivr.net/npm/jquery@3.6.3/dist/jquery.slim.min.js",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "script",
	          m: [{
	            n: "src",
	            f: "https://cdn.jsdelivr.net/npm/algoliasearch@3.35.1/dist/algoliasearchLite.min.js",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "script",
	          m: [{
	            n: "src",
	            f: "https://cdn.jsdelivr.net/npm/bootstrap@3.3.7/dist/js/bootstrap.min.js",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "script",
	          m: [{
	            n: "src",
	            f: "https://cdn.jsdelivr.net/npm/clipboard@2.0.11/dist/clipboard.min.js",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "script",
	          m: [{
	            n: "src",
	            f: "https://cdn.jsdelivr.net/npm/input-autogrow@1.1.1/dist/input-autogrow.min.js",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "script",
	          m: [{
	            n: "src",
	            f: "https://cdn.jsdelivr.net/npm/autocomplete.js@0.38.1/dist/autocomplete.jquery.min.js",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 16,
	          r: "js"
	        }, " ", {
	          t: 7,
	          e: "script",
	          m: [{
	            n: "src",
	            f: [{
	              t: 2,
	              r: "@shared.assetsHost"
	            }, "/js/app.js?v=", {
	              t: 2,
	              r: "@shared.assetsVersion"
	            }],
	            t: 13
	          }]
	        }, " ", {
	          t: 7,
	          e: "script",
	          m: [{
	            n: "defer",
	            f: 0,
	            t: 13
	          }, {
	            n: "data-domain",
	            f: "jsdelivr.com",
	            t: 13,
	            g: 1
	          }, {
	            n: "src",
	            f: "https://datum.jsdelivr.com/js/script.js",
	            t: 13,
	            g: 1
	          }]
	        }]
	      }]
	    }],
	    n: 51,
	    l: 1
	  }],
	  p: {
	    meta: [{
	      t: 9,
	      c: " Dynamic metadata that may change between pages. "
	    }, " ", {
	      t: 7,
	      e: "meta",
	      m: [{
	        n: "name",
	        f: "viewport",
	        t: 13,
	        g: 1
	      }, {
	        n: "content",
	        f: "width=device-width, initial-scale=1",
	        t: 13,
	        g: 1
	      }]
	    }, " ", {
	      t: 7,
	      e: "meta",
	      m: [{
	        n: "name",
	        f: "description",
	        t: 13,
	        g: 1
	      }, {
	        n: "content",
	        f: [{
	          t: 2,
	          x: {
	            r: ["description"],
	            s: "_0||\"Optimized for JS and ESM delivery from npm and GitHub. Works with all web formats. Serving more than 150 billion requests per month.\""
	          }
	        }],
	        t: 13
	      }]
	    }, " ", {
	      t: 7,
	      e: "meta",
	      m: [{
	        n: "name",
	        f: "keywords",
	        t: 13,
	        g: 1
	      }, {
	        n: "content",
	        f: "jsdelivr, cdn, npm, github, js, javascript, free, open source, oss, deno, wordpress",
	        t: 13,
	        g: 1
	      }]
	    }, " ", {
	      t: 7,
	      e: "meta",
	      m: [{
	        n: "property",
	        f: "og:locale",
	        t: 13,
	        g: 1
	      }, {
	        n: "content",
	        f: "en_US",
	        t: 13,
	        g: 1
	      }]
	    }, " ", {
	      t: 7,
	      e: "meta",
	      m: [{
	        n: "property",
	        f: "og:type",
	        t: 13,
	        g: 1
	      }, {
	        n: "content",
	        f: "website",
	        t: 13,
	        g: 1
	      }]
	    }, " ", {
	      t: 7,
	      e: "meta",
	      m: [{
	        n: "property",
	        f: "og:title",
	        t: 13,
	        g: 1
	      }, {
	        n: "content",
	        f: [{
	          t: 2,
	          x: {
	            r: ["title"],
	            s: "_0||\"jsDelivr - A free, fast, and reliable CDN for JS and Open Source\""
	          }
	        }],
	        t: 13
	      }]
	    }, " ", {
	      t: 7,
	      e: "meta",
	      m: [{
	        n: "property",
	        f: "og:description",
	        t: 13,
	        g: 1
	      }, {
	        n: "content",
	        f: [{
	          t: 2,
	          x: {
	            r: ["description"],
	            s: "_0||\"Optimized for JS and ESM delivery from npm and GitHub. Works with all web formats. Serving more than 150 billion requests per month.\""
	          }
	        }],
	        t: 13
	      }]
	    }, " ", {
	      t: 7,
	      e: "meta",
	      m: [{
	        n: "property",
	        f: "og:url",
	        t: 13,
	        g: 1
	      }, {
	        n: "content",
	        f: [{
	          t: 2,
	          r: "@shared.serverHost"
	        }, {
	          t: 2,
	          r: "@shared.actualPath"
	        }],
	        t: 13
	      }]
	    }, " ", {
	      t: 7,
	      e: "meta",
	      m: [{
	        n: "property",
	        f: "og:site_name",
	        t: 13,
	        g: 1
	      }, {
	        n: "content",
	        f: "jsDelivr",
	        t: 13,
	        g: 1
	      }]
	    }, " ", {
	      t: 4,
	      f: [{
	        t: 7,
	        e: "meta",
	        m: [{
	          n: "property",
	          f: "og:image",
	          t: 13,
	          g: 1
	        }, {
	          n: "content",
	          f: [{
	            t: 2,
	            r: "openGraphImage"
	          }],
	          t: 13
	        }]
	      }, " ", {
	        t: 7,
	        e: "meta",
	        m: [{
	          n: "property",
	          f: "og:image:secure_url",
	          t: 13,
	          g: 1
	        }, {
	          n: "content",
	          f: [{
	            t: 2,
	            r: "openGraphImage"
	          }],
	          t: 13
	        }]
	      }, " ", {
	        t: 7,
	        e: "meta",
	        m: [{
	          n: "property",
	          f: "og:image:width",
	          t: 13,
	          g: 1
	        }, {
	          n: "content",
	          f: "1280",
	          t: 13,
	          g: 1
	        }]
	      }, " ", {
	        t: 7,
	        e: "meta",
	        m: [{
	          n: "property",
	          f: "og:image:height",
	          t: 13,
	          g: 1
	        }, {
	          n: "content",
	          f: "640",
	          t: 13,
	          g: 1
	        }]
	      }, " ", {
	        t: 7,
	        e: "meta",
	        m: [{
	          n: "name",
	          f: "twitter:image",
	          t: 13,
	          g: 1
	        }, {
	          n: "content",
	          f: [{
	            t: 2,
	            r: "openGraphImage"
	          }],
	          t: 13
	        }]
	      }, " ", {
	        t: 9,
	        c: " Only for package pages: "
	      }, " ", {
	        t: 7,
	        e: "link",
	        m: [{
	          n: "rel",
	          f: "dns-prefetch",
	          t: 13,
	          g: 1
	        }, {
	          n: "href",
	          f: "https://img.jsdelivr.com/",
	          t: 13,
	          g: 1
	        }]
	      }, " ", {
	        t: 7,
	        e: "link",
	        m: [{
	          n: "rel",
	          f: "preconnect",
	          t: 13,
	          g: 1
	        }, {
	          n: "href",
	          f: "https://img.jsdelivr.com/",
	          t: 13,
	          g: 1
	        }, {
	          n: "crossorigin",
	          f: "anonymous",
	          t: 13,
	          g: 1
	        }]
	      }],
	      n: 50,
	      r: "openGraphImage"
	    }, {
	      t: 4,
	      f: [{
	        t: 7,
	        e: "meta",
	        m: [{
	          n: "property",
	          f: "og:image",
	          t: 13,
	          g: 1
	        }, {
	          n: "content",
	          f: [{
	            t: 2,
	            r: "@shared.assetsHost"
	          }, "/img/og-jsdelivr.png"],
	          t: 13
	        }]
	      }, " ", {
	        t: 7,
	        e: "meta",
	        m: [{
	          n: "property",
	          f: "og:image:secure_url",
	          t: 13,
	          g: 1
	        }, {
	          n: "content",
	          f: [{
	            t: 2,
	            r: "@shared.assetsHost"
	          }, "/img/og-jsdelivr.png"],
	          t: 13
	        }]
	      }, " ", {
	        t: 7,
	        e: "meta",
	        m: [{
	          n: "property",
	          f: "og:image:width",
	          t: 13,
	          g: 1
	        }, {
	          n: "content",
	          f: "1280",
	          t: 13,
	          g: 1
	        }]
	      }, " ", {
	        t: 7,
	        e: "meta",
	        m: [{
	          n: "property",
	          f: "og:image:height",
	          t: 13,
	          g: 1
	        }, {
	          n: "content",
	          f: "640",
	          t: 13,
	          g: 1
	        }]
	      }, " ", {
	        t: 7,
	        e: "meta",
	        m: [{
	          n: "name",
	          f: "twitter:image",
	          t: 13,
	          g: 1
	        }, {
	          n: "content",
	          f: [{
	            t: 2,
	            r: "@shared.assetsHost"
	          }, "/img/og-jsdelivr.png"],
	          t: 13
	        }]
	      }],
	      n: 51,
	      l: 1
	    }, " ", {
	      t: 7,
	      e: "meta",
	      m: [{
	        n: "name",
	        f: "twitter:card",
	        t: 13,
	        g: 1
	      }, {
	        n: "content",
	        f: "summary_large_image",
	        t: 13,
	        g: 1
	      }]
	    }, " ", {
	      t: 7,
	      e: "meta",
	      m: [{
	        n: "name",
	        f: "twitter:description",
	        t: 13,
	        g: 1
	      }, {
	        n: "content",
	        f: [{
	          t: 2,
	          x: {
	            r: ["description"],
	            s: "_0||\"Optimized for JS and ESM delivery from npm and GitHub. Works with all web formats. Serving more than 150 billion requests per month.\""
	          }
	        }],
	        t: 13
	      }]
	    }, " ", {
	      t: 7,
	      e: "meta",
	      m: [{
	        n: "name",
	        f: "twitter:title",
	        t: 13,
	        g: 1
	      }, {
	        n: "content",
	        f: [{
	          t: 2,
	          x: {
	            r: ["title"],
	            s: "_0||\"jsDelivr - A free, fast, and reliable CDN for JS and Open Source\""
	          }
	        }],
	        t: 13
	      }]
	    }, " ", {
	      t: 7,
	      e: "meta",
	      m: [{
	        n: "name",
	        f: "twitter:site",
	        t: 13,
	        g: 1
	      }, {
	        n: "content",
	        f: "@jsdelivr",
	        t: 13,
	        g: 1
	      }]
	    }, " ", {
	      t: 7,
	      e: "meta",
	      m: [{
	        n: "name",
	        f: "twitter:creator",
	        t: 13,
	        g: 1
	      }, {
	        n: "content",
	        f: "@jsdelivr",
	        t: 13,
	        g: 1
	      }]
	    }, " ", {
	      t: 7,
	      e: "title",
	      f: [{
	        t: 2,
	        x: {
	          r: ["title"],
	          s: "_0||\"jsDelivr - A free, fast, and reliable CDN for JS and open source\""
	        }
	      }]
	    }, " ", {
	      t: 7,
	      e: "link",
	      m: [{
	        n: "rel",
	        f: "icon",
	        t: 13,
	        g: 1
	      }, {
	        n: "type",
	        f: "image/x-icon",
	        t: 13,
	        g: 1
	      }, {
	        n: "href",
	        f: [{
	          t: 2,
	          r: "publicRoot"
	        }, "/favicon.ico"],
	        t: 13
	      }]
	    }, " ", {
	      t: 7,
	      e: "link",
	      m: [{
	        n: "rel",
	        f: "icon",
	        t: 13,
	        g: 1
	      }, {
	        n: "type",
	        f: "image/svg+xml",
	        t: 13,
	        g: 1
	      }, {
	        n: "href",
	        f: [{
	          t: 2,
	          r: "publicRoot"
	        }, "/icons/favicon.svg"],
	        t: 13
	      }]
	    }, " ", {
	      t: 7,
	      e: "link",
	      m: [{
	        n: "rel",
	        f: "icon",
	        t: 13,
	        g: 1
	      }, {
	        n: "type",
	        f: "image/png",
	        t: 13,
	        g: 1
	      }, {
	        n: "sizes",
	        f: "48x48",
	        t: 13,
	        g: 1
	      }, {
	        n: "href",
	        f: [{
	          t: 2,
	          r: "publicRoot"
	        }, "/icons/favicon-48x48.png"],
	        t: 13
	      }]
	    }, " ", {
	      t: 7,
	      e: "link",
	      m: [{
	        n: "rel",
	        f: "icon",
	        t: 13,
	        g: 1
	      }, {
	        n: "type",
	        f: "image/png",
	        t: 13,
	        g: 1
	      }, {
	        n: "sizes",
	        f: "32x32",
	        t: 13,
	        g: 1
	      }, {
	        n: "href",
	        f: [{
	          t: 2,
	          r: "publicRoot"
	        }, "/icons/favicon-32x32.png"],
	        t: 13
	      }]
	    }, " ", {
	      t: 7,
	      e: "link",
	      m: [{
	        n: "rel",
	        f: "icon",
	        t: 13,
	        g: 1
	      }, {
	        n: "type",
	        f: "image/png",
	        t: 13,
	        g: 1
	      }, {
	        n: "sizes",
	        f: "16x16",
	        t: 13,
	        g: 1
	      }, {
	        n: "href",
	        f: [{
	          t: 2,
	          r: "publicRoot"
	        }, "/icons/favicon-16x16.png"],
	        t: 13
	      }]
	    }, " ", {
	      t: 7,
	      e: "link",
	      m: [{
	        n: "rel",
	        f: "apple-touch-icon",
	        t: 13,
	        g: 1
	      }, {
	        n: "sizes",
	        f: "180x180",
	        t: 13,
	        g: 1
	      }, {
	        n: "href",
	        f: [{
	          t: 2,
	          r: "publicRoot"
	        }, "/icons/apple-touch-icon.png"],
	        t: 13
	      }]
	    }, " ", {
	      t: 7,
	      e: "link",
	      m: [{
	        n: "rel",
	        f: "manifest",
	        t: 13,
	        g: 1
	      }, {
	        n: "href",
	        f: [{
	          t: 2,
	          r: "publicRoot"
	        }, "/icons/site.webmanifest"],
	        t: 13
	      }]
	    }, " ", {
	      t: 7,
	      e: "link",
	      m: [{
	        n: "rel",
	        f: "mask-icon",
	        t: 13,
	        g: 1
	      }, {
	        n: "href",
	        f: [{
	          t: 2,
	          r: "publicRoot"
	        }, "/icons/safari-pinned-tab.svg"],
	        t: 13
	      }, {
	        n: "color",
	        f: "#e64e3d",
	        t: 13,
	        g: 1
	      }]
	    }, " ", {
	      t: 7,
	      e: "meta",
	      m: [{
	        n: "name",
	        f: "apple-mobile-web-app-title",
	        t: 13,
	        g: 1
	      }, {
	        n: "content",
	        f: "jsDelivr",
	        t: 13,
	        g: 1
	      }]
	    }, " ", {
	      t: 7,
	      e: "meta",
	      m: [{
	        n: "name",
	        f: "application-name",
	        t: 13,
	        g: 1
	      }, {
	        n: "content",
	        f: "jsDelivr",
	        t: 13,
	        g: 1
	      }]
	    }, " ", {
	      t: 7,
	      e: "meta",
	      m: [{
	        n: "name",
	        f: "msapplication-TileColor",
	        t: 13,
	        g: 1
	      }, {
	        n: "content",
	        f: "#ffffff",
	        t: 13,
	        g: 1
	      }]
	    }, " ", {
	      t: 7,
	      e: "meta",
	      m: [{
	        n: "name",
	        f: "msapplication-config",
	        t: 13,
	        g: 1
	      }, {
	        n: "content",
	        f: [{
	          t: 2,
	          r: "publicRoot"
	        }, "/icons/browserconfig.xml"],
	        t: 13
	      }]
	    }, " ", {
	      t: 7,
	      e: "meta",
	      m: [{
	        n: "name",
	        f: "theme-color",
	        t: 13,
	        g: 1
	      }, {
	        n: "content",
	        f: "#ffffff",
	        t: 13,
	        g: 1
	      }]
	    }, " ", {
	      t: 8,
	      r: "seo",
	      c: {
	        r: "~/rootContext"
	      }
	    }]
	  },
	  e: {
	    "!_0": function (_0) {
	      return !_0;
	    },
	    "_0||\"Optimized for JS and ESM delivery from npm and GitHub. Works with all web formats. Serving more than 150 billion requests per month.\"": function (_0) {
	      return _0 || "Optimized for JS and ESM delivery from npm and GitHub. Works with all web formats. Serving more than 150 billion requests per month.";
	    },
	    "_0||\"jsDelivr - A free, fast, and reliable CDN for JS and Open Source\"": function (_0) {
	      return _0 || "jsDelivr - A free, fast, and reliable CDN for JS and Open Source";
	    },
	    "_0||\"jsDelivr - A free, fast, and reliable CDN for JS and open source\"": function (_0) {
	      return _0 || "jsDelivr - A free, fast, and reliable CDN for JS and open source";
	    }
	  }
	};
	component$12.exports.components = {
	  "r-serialize": rSerialize,
	  "r-meta": rMeta
	};
	var rPage = ractive__default["default"].extend(component$12.exports);

	var component$11 = {
	  exports: {}
	};
	const disabledProvidersArr = Object.values(providerData).filter(provider => !provider.enabled);
	component$11.exports = {
	  data() {
	    return {
	      title: 'About - jsDelivr',
	      description: 'jsDelivr is a public, open-source CDN (Content Delivery Network) developed by ProspectOne, focused on performance, reliability, and security. It is free to use for everyone, with no bandwidth limits.',
	      montlyRequests: 0,
	      monthlyTraffic: 0,
	      regions: 0,
	      usedBy: 0,
	      projects: 0
	    };
	  },
	  oninit() {
	    if (!ractive__default["default"].isServer) {
	      http.fetchNetworkWideStats().then(({
	        hits,
	        bandwidth
	      }) => {
	        this.set('monthlyRequestsActual', parseInt(_.formatToShortNumber(hits.total, ' ', 'B')));
	        this.set('monthlyTrafficActual', parseInt(_.formatBytesWithUnit(bandwidth.total)));
	      });
	      http.fetchNumberOfResources().then(({
	        responseHeaders
	      }) => {
	        this.set('projectsActual', responseHeaders['x-total-count']);
	      });
	      fetch(`${this.get('@shared.assetsHost')}/js/map/map.json`).then(r => r.json()).then(locationsArr => {
	        // filter CDNs locations from disabled CDNs
	        let filteredLocations = disabledProvidersArr.reduce((res, provider) => {
	          res = res.filter(location => {
	            let target = location.title.toLowerCase();
	            let search = provider.name.toLowerCase();
	            if (target.includes(search)) {
	              return false;
	            }
	            return true;
	          });
	          return res;
	        }, locationsArr);

	        // get rid of duplicates
	        let locationsActual = filteredLocations.reduce((res, item) => {
	          // replace CDN_NAME with actual locationName
	          let locationName = item.title.replace(/(?:\w+\s?-\s?){1}(.*)/, '$1');
	          if (!res.includes(locationName)) {
	            res.push(locationName);
	          }
	          return res;
	        }, []);
	        this.set('regionsActual', locationsActual.length);
	      });
	    }
	  },
	  onrender() {
	    this.observe('monthlyRequestsActual monthlyTrafficActual projectsActual regionsActual', () => {
	      if (!this.get('monthlyRequestsActual') || !this.get('monthlyTrafficActual') || !this.get('projectsActual') || !this.get('regionsActual')) {
	        return;
	      }
	      let options = {
	        threshold: 1
	      };
	      let callback = (entries, observer) => {
	        entries.forEach(entry => {
	          if (entry.isIntersecting) {
	            let el = entry.target.dataset.target;
	            let newValue = entry.target.dataset.value;
	            setTimeout(() => {
	              this.animate(el, newValue, {
	                duration: 1500,
	                easing: x => 1 - Math.pow(1 - x, 5)
	              });
	              observer.unobserve(entry.target);
	            }, 300);
	          }
	        });
	      };
	      let observer = new IntersectionObserver(callback, options),
	        animated = this.findAll('.animatedOnScroll');
	      animated.forEach(el => {
	        observer.observe(el);
	      });
	    });
	  }
	};
	component$11.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "r-page",
	    m: [{
	      n: "noYield",
	      f: [{
	        t: 2,
	        r: "noYield"
	      }],
	      t: 13
	    }, {
	      n: "title",
	      f: [{
	        t: 2,
	        r: "title"
	      }],
	      t: 13
	    }, {
	      n: "description",
	      f: [{
	        t: 2,
	        r: "description"
	      }],
	      t: 13
	    }],
	    f: [" ", {
	      t: 7,
	      e: "c-notification"
	    }, " ", {
	      t: 7,
	      e: "c-header",
	      m: [{
	        n: "useWhiteLogos",
	        f: "true",
	        t: 13,
	        g: 1
	      }, {
	        n: "additionalClasses",
	        f: "header-with-orange-bg",
	        t: 13,
	        g: 1
	      }]
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "p-about",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "c-header-gradient",
	        m: [{
	          n: "showMap",
	          f: [{
	            t: 2,
	            x: {
	              r: [],
	              s: "true"
	            }
	          }],
	          t: 13
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "navigation",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "a",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "active",
	            g: 1
	          }, {
	            n: "href",
	            f: "/about",
	            t: 13,
	            g: 1
	          }],
	          f: ["About Us"]
	        }, " ", {
	          t: 7,
	          e: "a",
	          m: [{
	            n: "href",
	            f: "/history",
	            t: 13,
	            g: 1
	          }],
	          f: ["Our History"]
	        }]
	      }, " ", {
	        t: 7,
	        e: "section",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "about-descr",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "container container-sm",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "h1",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "page-title",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "span",
	              f: ["About jsDelivr"]
	            }, " ", {
	              t: 7,
	              e: "span",
	              f: ["A free global CDN"]
	            }]
	          }, " ", {
	            t: 7,
	            e: "p",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "bold-text_reg-alt",
	              g: 1
	            }],
	            f: ["jsDelivr is a free CDN (Content Delivery Network) for open source files. We are tightly integrated with GitHub and NPM, allowing us to automatically provide a reliable CDN service to almost every open source project out there. ", {
	              t: 7,
	              e: "br"
	            }, " ", {
	              t: 7,
	              e: "br"
	            }, " We offer a stable CDN that can be used in production on popular websites with huge amounts of traffic. There are no bandwidth limits or premium features and its completely free to use by anybody."]
	          }, " ", {
	            t: 7,
	            e: "p",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "bold-text_lg-alt",
	              g: 1
	            }],
	            f: ["We’re focused on:"]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "about-descr_blocks",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "38",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "46",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/about/performance.svg"],
	                  t: 13
	                }, {
	                  n: "loading",
	                  f: "lazy",
	                  t: 13,
	                  g: 1
	                }]
	              }, " ", {
	                t: 7,
	                e: "span",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "bold-text_md",
	                  g: 1
	                }],
	                f: ["Performance"]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "40",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "48",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/about/reliability.svg"],
	                  t: 13
	                }, {
	                  n: "loading",
	                  f: "lazy",
	                  t: 13,
	                  g: 1
	                }]
	              }, " ", {
	                t: 7,
	                e: "span",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "bold-text_md",
	                  g: 1
	                }],
	                f: ["Reliability"]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "44",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "48",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/about/security.svg"],
	                  t: 13
	                }, {
	                  n: "loading",
	                  f: "lazy",
	                  t: 13,
	                  g: 1
	                }]
	              }, " ", {
	                t: 7,
	                e: "span",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "bold-text_md",
	                  g: 1
	                }],
	                f: ["Security"]
	              }]
	            }]
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "section",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "about-numbers",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "container container-sm",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "h2",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "about-header",
	              g: 1
	            }],
	            f: ["jsDelivr in numbers"]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "about-numbers_table",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              f: [{
	                t: 7,
	                e: "span",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "bold-text_lg",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "b",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "animatedOnScroll",
	                    g: 1
	                  }, {
	                    n: "data-target",
	                    f: "montlyRequests",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "data-value",
	                    f: [{
	                      t: 2,
	                      r: "monthlyRequestsActual"
	                    }],
	                    t: 13
	                  }],
	                  f: [{
	                    t: 2,
	                    x: {
	                      r: ["montlyRequests"],
	                      s: "Math.round(_0)"
	                    }
	                  }]
	                }, "+ billion"]
	              }, " ", {
	                t: 7,
	                e: "p",
	                f: ["monthly requests"]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              f: [{
	                t: 7,
	                e: "span",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "bold-text_lg",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "b",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "animatedOnScroll",
	                    g: 1
	                  }, {
	                    n: "data-target",
	                    f: "monthlyTraffic",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "data-value",
	                    f: [{
	                      t: 2,
	                      r: "monthlyTrafficActual"
	                    }],
	                    t: 13
	                  }],
	                  f: [{
	                    t: 2,
	                    x: {
	                      r: ["monthlyTraffic"],
	                      s: "Math.round(_0)"
	                    }
	                  }]
	                }, "+ petabytes"]
	              }, " ", {
	                t: 7,
	                e: "p",
	                f: ["traffic"]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              f: [{
	                t: 7,
	                e: "span",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "bold-text_lg",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "b",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "animatedOnScroll",
	                    g: 1
	                  }, {
	                    n: "data-target",
	                    f: "regions",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "data-value",
	                    f: [{
	                      t: 2,
	                      r: "regionsActual"
	                    }],
	                    t: 13
	                  }],
	                  f: [{
	                    t: 2,
	                    x: {
	                      r: ["regions"],
	                      s: "Math.round(_0)"
	                    }
	                  }]
	                }, "+"]
	              }, " ", {
	                t: 7,
	                e: "p",
	                f: ["global regions"]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              f: [{
	                t: 7,
	                e: "span",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "bold-text_lg",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "b",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "animatedOnScroll",
	                    g: 1
	                  }, {
	                    n: "data-target",
	                    f: "usedBy",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "data-value",
	                    f: "12",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: [{
	                    t: 2,
	                    x: {
	                      r: ["usedBy"],
	                      s: "Math.round(_0)"
	                    }
	                  }]
	                }, "+ million"]
	              }, " ", {
	                t: 7,
	                e: "p",
	                f: ["websites using jsDelivr"]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              f: [{
	                t: 7,
	                e: "span",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "bold-text_lg",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "b",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "animatedOnScroll",
	                    g: 1
	                  }, {
	                    n: "data-target",
	                    f: "projects",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "data-value",
	                    f: [{
	                      t: 2,
	                      r: "projectsActual"
	                    }],
	                    t: 13
	                  }],
	                  f: [{
	                    t: 2,
	                    x: {
	                      r: ["projects"],
	                      s: "Math.round(_0)"
	                    }
	                  }]
	                }, "+"]
	              }, " ", {
	                t: 7,
	                e: "p",
	                f: ["active projects being served"]
	              }]
	            }, " ", {
	              t: 7,
	              e: "a",
	              m: [{
	                n: "href",
	                f: "/network/infographic",
	                t: 13,
	                g: 1
	              }],
	              f: ["See how we do it"]
	            }]
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "section",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "banner-history",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "container container-lg",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "container banner-history-container",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "banner-history-content",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                f: ["Learn how jsDelivr has evolved over the years"]
	              }, " ", {
	                t: 7,
	                e: "a",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "btn-primary",
	                  g: 1
	                }, {
	                  n: "href",
	                  f: "/history",
	                  t: 13,
	                  g: 1
	                }],
	                f: ["Check our history"]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "banner-history-graphic",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "bars",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "span",
	                  f: ["December"]
	                }]
	              }, " ", {
	                t: 7,
	                e: "h2",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "about-header",
	                  g: 1
	                }],
	                f: ["2020"]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "bars right",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "span",
	                  f: ["October"]
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "bars",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "span",
	                  f: ["November"]
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "img",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "banner-map",
	                g: 1
	              }, {
	                n: "width",
	                f: "796",
	                t: 13,
	                g: 1
	              }, {
	                n: "height",
	                f: "288",
	                t: 13,
	                g: 1
	              }, {
	                n: "src",
	                f: [{
	                  t: 2,
	                  r: "@shared.assetsHost"
	                }, "/img/about/banner-jsdelivr-map.svg"],
	                t: 13
	              }]
	            }]
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "section",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "about-production",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "container container-sm",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "h2",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "about-header",
	              g: 1
	            }],
	            f: ["Ready for production"]
	          }, " ", {
	            t: 7,
	            e: "p",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "bold-text_reg",
	              g: 1
	            }],
	            f: ["Our public CDN is built to be used in production by even the largest websites. Performance is monitored at all times, and we are always looking into new technologies and providers that may further improve our CDN. Downtime, timeouts or slow responses are simply unacceptable. ", {
	              t: 7,
	              e: "br"
	            }, " ", {
	              t: 7,
	              e: "br"
	            }, " We do everything possible to ensure our CDN will NEVER break any websites regardless of use-case. If a file is available via our CDN we assume its used in production and make sure that file will continue to work no matter what."]
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "section",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "about-sustainability",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "container container-sm",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "h2",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "about-header",
	              g: 1
	            }],
	            f: ["Sustainability"]
	          }, " ", {
	            t: 7,
	            e: "p",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "bold-text_reg",
	              g: 1
	            }],
	            f: ["Since jsDelivr is a free CDN we rely heavily on our sponsors to support the service. All of the traffic we serve is offered to us for free thanks to our CDN sponsors. We load-balance the traffic between them for better performance but also it allows us to avoid overloading a single CDN. ", {
	              t: 7,
	              e: "br"
	            }, " ", {
	              t: 7,
	              e: "br"
	            }, " In case a CDN provider decides to stop sponsoring us we can quickly remove them from rotation and if needed replace them with other sponsors. We maintain a good relationship with the CDN industry overall. ", {
	              t: 7,
	              e: "br"
	            }, " ", {
	              t: 7,
	              e: "br"
	            }, " Our main expenses include hosting of the origin and supporting infrastructure like APIs and log parsing. As well as part-time and freelancer developers and designers. At the moment these expenses are covered by Dmitriy A.. ", {
	              t: 7,
	              e: "br"
	            }, " ", {
	              t: 7,
	              e: "br"
	            }, " Our goal is to eventually cover all expenses with the help of our users, ", {
	              t: 7,
	              e: "a",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "about-link",
	                g: 1
	              }, {
	                n: "href",
	                f: "https://github.com/sponsors/jsdelivr",
	                t: 13,
	                g: 1
	              }, {
	                n: "target",
	                f: "_blank",
	                t: 13,
	                g: 1
	              }, {
	                n: "rel",
	                f: "noopener noreferrer",
	                t: 13,
	                g: 1
	              }],
	              f: ["GitHub Sponsors"]
	            }, " and ", {
	              t: 7,
	              e: "a",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "about-link",
	                g: 1
	              }, {
	                n: "href",
	                f: "https://opencollective.com/jsdelivr",
	                t: 13,
	                g: 1
	              }, {
	                n: "target",
	                f: "_blank",
	                t: 13,
	                g: 1
	              }, {
	                n: "rel",
	                f: "noopener noreferrer",
	                t: 13,
	                g: 1
	              }],
	              f: ["Open Collective sponsors"]
	            }, "."]
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "section",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "about-people",
	          g: 1
	        }, {
	          n: "id",
	          f: "people",
	          t: 13,
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "container container-sm",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "h2",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "about-header",
	              g: 1
	            }],
	            f: ["The people behind"]
	          }, " ", {
	            t: 7,
	            e: "p",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "bold-text_reg",
	              g: 1
	            }],
	            f: ["These people currently run or previously helped with running this project. Want to join them? We are always looking for help!"]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "about-people_row",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "h4",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "bold-text_lg-alt",
	                g: 1
	              }],
	              f: ["Core Team"]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "about-people_row_cell",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "80",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "80",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/about/dmitriy-akulov.png"],
	                  t: 13
	                }, {
	                  n: "srcset",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/about/dmitriy-akulov@2x.png 2x"],
	                  t: 13
	                }, {
	                  n: "loading",
	                  f: "lazy",
	                  t: 13,
	                  g: 1
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "personal-info",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "h5",
	                  f: ["Dmitriy Akulov"]
	                }, " ", {
	                  t: 7,
	                  e: "span",
	                  f: ["Founder"]
	                }]
	              }, " ", {
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "href",
	                  f: "https://twitter.com/jimaek",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "rel",
	                  f: "noopener noreferrer",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: "width",
	                    f: "24",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "24",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/about/twitter-icon.svg"],
	                    t: 13
	                  }, {
	                    n: "loading",
	                    f: "lazy",
	                    t: 13,
	                    g: 1
	                  }]
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "about-people_row_cell",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "80",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "80",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/about/martin-kolarik.png"],
	                  t: 13
	                }, {
	                  n: "srcset",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/about/martin-kolarik@2x.png 2x"],
	                  t: 13
	                }, {
	                  n: "loading",
	                  f: "lazy",
	                  t: 13,
	                  g: 1
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "personal-info",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "h5",
	                  f: ["Martin Kolarik"]
	                }, " ", {
	                  t: 7,
	                  e: "span",
	                  f: ["Core Developer"]
	                }]
	              }, " ", {
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "href",
	                  f: "https://twitter.com/makolarik",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "rel",
	                  f: "noopener noreferrer",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: "width",
	                    f: "24",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "24",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/about/twitter-icon.svg"],
	                    t: 13
	                  }, {
	                    n: "loading",
	                    f: "lazy",
	                    t: 13,
	                    g: 1
	                  }]
	                }]
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "about-people_divider",
	              g: 1
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "about-people_row",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "h4",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "bold-text_lg-alt",
	                g: 1
	              }],
	              f: ["Frequent Contributors"]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "about-people_row_cell",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "80",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "80",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/about/artem-stoianov.png"],
	                  t: 13
	                }, {
	                  n: "srcset",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/about/artem-stoianov@2x.png 2x"],
	                  t: 13
	                }, {
	                  n: "loading",
	                  f: "lazy",
	                  t: 13,
	                  g: 1
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "personal-info",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "h5",
	                  f: ["Artem Stoianov"]
	                }, " ", {
	                  t: 7,
	                  e: "span",
	                  f: ["Developer"]
	                }]
	              }, " ", {
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "href",
	                  f: "https://twitter.com/zarianec",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "rel",
	                  f: "noopener noreferrer",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: "width",
	                    f: "24",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "24",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/about/twitter-icon.svg"],
	                    t: 13
	                  }, {
	                    n: "loading",
	                    f: "lazy",
	                    t: 13,
	                    g: 1
	                  }]
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "about-people_row_cell",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "80",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "80",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/about/jakub-drgon.png"],
	                  t: 13
	                }, {
	                  n: "srcset",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/about/jakub-drgon@2x.png 2x"],
	                  t: 13
	                }, {
	                  n: "loading",
	                  f: "lazy",
	                  t: 13,
	                  g: 1
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "personal-info",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "h5",
	                  f: ["Jakub Drgon"]
	                }, " ", {
	                  t: 7,
	                  e: "span",
	                  f: ["Developer"]
	                }]
	              }, " ", {
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "href",
	                  f: "https://www.linkedin.com/in/jakub-drgon/",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "rel",
	                  f: "noopener noreferrer",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: "width",
	                    f: "24",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "24",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/about/linkedin-icon.svg"],
	                    t: 13
	                  }, {
	                    n: "loading",
	                    f: "lazy",
	                    t: 13,
	                    g: 1
	                  }]
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "about-people_row_cell",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "80",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "80",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/about/patryk-ilnicki.png"],
	                  t: 13
	                }, {
	                  n: "srcset",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/about/patryk-ilnicki@2x.png 2x"],
	                  t: 13
	                }, {
	                  n: "loading",
	                  f: "lazy",
	                  t: 13,
	                  g: 1
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "personal-info",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "h5",
	                  f: ["Patryk Ilnicki"]
	                }, " ", {
	                  t: 7,
	                  e: "span",
	                  f: ["Designer"]
	                }]
	              }, " ", {
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "href",
	                  f: "https://twitter.com/IlnickiPatryk",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "rel",
	                  f: "noopener noreferrer",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: "width",
	                    f: "24",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "24",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/about/twitter-icon.svg"],
	                    t: 13
	                  }, {
	                    n: "loading",
	                    f: "lazy",
	                    t: 13,
	                    g: 1
	                  }]
	                }]
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "about-people_divider",
	              g: 1
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "about-people_contributors",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "h4",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "bold-text_lg-alt",
	                g: 1
	              }],
	              f: ["Contributors"]
	            }, " ", {
	              t: 7,
	              e: "img",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "about-people_contributors_numbers",
	                g: 1
	              }, {
	                n: "width",
	                f: "291",
	                t: 13,
	                g: 1
	              }, {
	                n: "height",
	                f: "96",
	                t: 13,
	                g: 1
	              }, {
	                n: "src",
	                f: [{
	                  t: 2,
	                  r: "@shared.assetsHost"
	                }, "/img/about/contributors-numbers.svg"],
	                t: 13
	              }, {
	                n: "loading",
	                f: "lazy",
	                t: 13,
	                g: 1
	              }]
	            }, " ", {
	              t: 7,
	              e: "img",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "about-people_contributors_list",
	                g: 1
	              }, {
	                n: "width",
	                f: "264",
	                t: 13,
	                g: 1
	              }, {
	                n: "height",
	                f: "96",
	                t: 13,
	                g: 1
	              }, {
	                n: "src",
	                f: [{
	                  t: 2,
	                  r: "@shared.assetsHost"
	                }, "/img/about/contributors.png"],
	                t: 13
	              }, {
	                n: "srcset",
	                f: [{
	                  t: 2,
	                  r: "@shared.assetsHost"
	                }, "/img/about/contributors@2x.png 2x"],
	                t: 13
	              }, {
	                n: "loading",
	                f: "lazy",
	                t: 13,
	                g: 1
	              }]
	            }]
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "section",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "about-sponsors",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "container container-sm",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "h2",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "about-header",
	              g: 1
	            }],
	            f: ["Our Sponsors"]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "about-sponsors_row",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "about-sponsors_row_cell",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "118",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "40",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/about/cloudflare.svg"],
	                  t: 13
	                }, {
	                  n: "loading",
	                  f: "lazy",
	                  t: 13,
	                  g: 1
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "about-sponsors_row_cell",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "100",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "40",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/about/fastly.svg"],
	                  t: 13
	                }, {
	                  n: "loading",
	                  f: "lazy",
	                  t: 13,
	                  g: 1
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "about-sponsors_row_cell",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "100",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "40",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/about/ibm.svg"],
	                  t: 13
	                }, {
	                  n: "loading",
	                  f: "lazy",
	                  t: 13,
	                  g: 1
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "about-sponsors_row_cell",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "141",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "40",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/about/gcorelabs.svg"],
	                  t: 13
	                }, {
	                  n: "loading",
	                  f: "lazy",
	                  t: 13,
	                  g: 1
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "about-sponsors_row_cell",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "138",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "40",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/about/bunny.svg"],
	                  t: 13
	                }, {
	                  n: "loading",
	                  f: "lazy",
	                  t: 13,
	                  g: 1
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "about-sponsors_divider",
	                g: 1
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "about-sponsors_row_cell",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "150",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "34",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/about/algolia.svg"],
	                  t: 13
	                }, {
	                  n: "loading",
	                  f: "lazy",
	                  t: 13,
	                  g: 1
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "about-sponsors_row_cell",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "100",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "40",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/about/cloudns.svg"],
	                  t: 13
	                }, {
	                  n: "loading",
	                  f: "lazy",
	                  t: 13,
	                  g: 1
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "about-sponsors_row_cell alt-height",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "229",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "40",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/about/pb.svg"],
	                  t: 13
	                }, {
	                  n: "loading",
	                  f: "lazy",
	                  t: 13,
	                  g: 1
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "about-sponsors_row_cell",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "209",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "40",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/sponsors/render-black.svg"],
	                  t: 13
	                }, {
	                  n: "loading",
	                  f: "lazy",
	                  t: 13,
	                  g: 1
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "about-sponsors_divider",
	                g: 1
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "about-sponsors_row_cell",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "154",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "40",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/about/clever-cloud.svg"],
	                  t: 13
	                }, {
	                  n: "loading",
	                  f: "lazy",
	                  t: 13,
	                  g: 1
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "about-sponsors_row_cell",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "211",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "40",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/about/digitalocean.svg"],
	                  t: 13
	                }, {
	                  n: "loading",
	                  f: "lazy",
	                  t: 13,
	                  g: 1
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "about-sponsors_row_cell about-sponsors_row_cell-btn",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "btn-secondary",
	                  g: 1
	                }, {
	                  n: "href",
	                  f: "/sponsors",
	                  t: 13,
	                  g: 1
	                }],
	                f: ["View all"]
	              }]
	            }]
	          }]
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "c-footer"
	    }],
	    p: {
	      seo: [{
	        t: 7,
	        e: "script",
	        m: [{
	          n: "type",
	          f: "application/ld+json",
	          t: 13,
	          g: 1
	        }],
	        f: ["\t\t[{\n\t\t\t\"@context\":\"http://schema.org\",\n\t\t\t\"@type\":\"Organization\",\n\t\t\t\"url\":\"https://www.jsdelivr.com/\",\n\t\t\t\"sameAs\":[\"https://www.linkedin.com/company/jsdelivr/\",\"https://twitter.com/jsdelivr\", \"https://en.wikipedia.org/wiki/JSDelivr\"],\n\t\t\t\"@id\":\"#organization\",\n\t\t\t\"name\":\"jsDelivr\",\n\t\t\t\"alternateName\": \"JSDelivr\",\n\t\t\t\"brand\": \"jsDelivr\",\n\t\t\t\"foundingDate\": \"2012-04-10\",\n\t\t\t\"logo\":\"https://www.jsdelivr.com/icon_256x256.png\"\n\t\t},\n\t\t{\n\t\t\t\"@context\": \"http://schema.org\",\n\t\t\t\"@type\": \"AboutPage\",\n\t\t\t\"url\":\"https://www.jsdelivr.com/about\",\n\t\t\t\"relatedLink\": \"https://www.jsdelivr.com/history\",\n\t\t\t\"name\": \"About jsDelivr\",\n\t\t\t\"description\": \"jsDelivr is a free CDN (Content Delivery Network) for open source files. We are tightly integrated with GitHub and NPM, allowing us to automatically provide a reliable CDN service to almost every open source project out there.\"\n\t\t}]\n\t"]
	      }]
	    }
	  }],
	  e: {
	    "true": function () {
	      return true;
	    },
	    "Math.round(_0)": function (_0) {
	      return Math.round(_0);
	    }
	  }
	};
	component$11.exports.components = {
	  "c-header-gradient": headerGradient,
	  "c-notification": notification,
	  "c-footer": footer,
	  "c-header": header,
	  "r-page": rPage
	};
	var about = ractive__default["default"].extend(component$11.exports);

	var debounce = (fn, wait = 100) => {
	  let timeout;
	  return (...args) => {
	    clearTimeout(timeout);
	    timeout = setTimeout(fn, wait, ...args);
	  };
	};

	var throttle = (fn, wait = 100) => {
	  let lastCalled, timeout;
	  return (...args) => {
	    let now = Date.now();
	    if (lastCalled && now - lastCalled < wait) {
	      clearTimeout(timeout);
	      return timeout = setTimeout(fn, wait - (now - lastCalled), ...args);
	    }
	    lastCalled = now;
	    clearTimeout(timeout);
	    fn(...args);
	  };
	};

	var clipboard = (node, title = 'Copy to Clipboard', tooltipPlacement = 'top', nodeSelector) => {
	  let clipboard = new ClipboardJS(node);
	  let $node = nodeSelector ? $(node).parents(nodeSelector).first() : $(node);
	  let tooltipOptions = {
	    title,
	    placement: tooltipPlacement,
	    trigger: 'hover',
	    container: 'body',
	    animation: false
	  };
	  function onDocumentClick(e) {
	    if (e.srcElement !== $node[0] && !$(e.srcElement).closest($node[0]).length) {
	      setDefaultTooltip();
	    }
	  }
	  function setDefaultTooltip() {
	    $node.tooltip('destroy').tooltip(tooltipOptions);
	  }
	  setDefaultTooltip();
	  document.addEventListener('click', onDocumentClick);
	  clipboard.on('success', () => {
	    $node.tooltip('destroy').tooltip(Object.assign({}, tooltipOptions, {
	      trigger: 'manual',
	      title: 'Copied!'
	    })).tooltip('show');
	    setTimeout(setDefaultTooltip, 1000);
	  });
	  clipboard.on('error', () => {
	    $node.tooltip('destroy').tooltip(Object.assign({}, tooltipOptions, {
	      trigger: 'manual',
	      title: 'Press Ctrl+C to copy'
	    })).tooltip('show');
	    setTimeout(setDefaultTooltip, 1000);
	  });
	  return {
	    teardown: () => {
	      document.removeEventListener('click', onDocumentClick);
	    }
	  };
	};

	var component$10 = {
	  exports: {}
	};

	/* eslint-disable no-throw-literal */

	const defaultError$4 = 'Sorry, this doesn\'t look like a valid GitHub link :(';
	component$10.exports = {
	  decorators: {
	    clipboard
	  },
	  data() {
	    return {
	      title: 'Migrate from GitHub to jsDelivr',
	      description: 'Migrate from GitHub to jsDelivr - a free, fast, and reliable Open Source CDN optimized for JS and ESM delivery from npm and GitHub. Works with all web formats. Serving more than 150 billion requests per month.'
	    };
	  },
	  oninit() {
	    let buildJsDelivrLink = (user, repo, version, path) => {
	      if (version === 'latest') {
	        return `https://cdn.jsdelivr.net/gh/${user}/${repo}/${path}`;
	      }
	      return `https://cdn.jsdelivr.net/gh/${user}/${repo}@${version}/${path}`;
	    };
	    let isCommitPrefixOrTag = (user, repo, sha) => {
	      return _.makeHTTPRequest({
	        url: `https://api.github.com/repos/${user}/${repo}/commits/${sha}`
	      }).then(response => {
	        return response.sha.indexOf(sha) === 0 ? response.sha : sha;
	      }).catch(() => {
	        return false;
	      });
	    };
	    let gitHub2jsDelivr = gitHub => Promise.resolve().then(() => {
	      // TODO: broken match (version instead of sha, no file etc.)
	      // pattern must be broken, need to be rewrited
	      // why is it working if api.github returns 422
	      let pattern = /^https?:\/\/(?:github|raw\.githubusercontent)\.com\/([^/]+)\/([^/]+)(?:(?:\/blob)?\/([^/]+)\/(.*))?\/?$/i;
	      let commitPattern = /^[0-9a-f]{40}$/;
	      let match = pattern.exec(gitHub);
	      if (match) {
	        let [, user, repo, version, file] = match;
	        if (!version && !file) {
	          return `https://cdn.jsdelivr.net/gh/${user}/${repo}/`;
	        }

	        // full commit hash
	        if (commitPattern.test(version)) {
	          return buildJsDelivrLink(user, repo, version, file);
	        }

	        // tag/commit prefix
	        return isCommitPrefixOrTag(user, repo, version).then(sha => {
	          if (sha) {
	            return buildJsDelivrLink(user, repo, sha, file);
	          }

	          // branch
	          return buildJsDelivrLink(user, repo, version, file);
	        });
	      }
	      throw defaultError$4;
	    });
	    this.observe('in', debounce(throttle(gitHub => {
	      this.set('displayHtmlWarning', /\.html?$/i.test(gitHub));
	      if (!gitHub) {
	        return this.set('out', '');
	      }
	      gitHub2jsDelivr(gitHub).then(jsDelivr => {
	        this.set('error', false);
	        if (this.get('in') === gitHub) {
	          this.set('out', jsDelivr);
	        }
	      }).catch(error => {
	        this.set('error', true);
	        this.set('out', typeof error === 'string' ? error : defaultError$4);
	      });
	    }, 1000)));
	  }
	};
	component$10.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "r-page",
	    m: [{
	      n: "noYield",
	      f: [{
	        t: 2,
	        r: "noYield"
	      }],
	      t: 13
	    }, {
	      n: "title",
	      f: [{
	        t: 2,
	        r: "title"
	      }],
	      t: 13
	    }, {
	      n: "description",
	      f: [{
	        t: 2,
	        r: "description"
	      }],
	      t: 13
	    }],
	    f: [{
	      t: 7,
	      e: "c-header",
	      m: [{
	        n: "useWhiteLogos",
	        f: "true",
	        t: 13,
	        g: 1
	      }, {
	        n: "additionalClasses",
	        f: "header-with-orange-bg",
	        t: 13,
	        g: 1
	      }]
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "p-github",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "c-header-gradient",
	        m: [{
	          n: "showMap",
	          f: [{
	            t: 2,
	            x: {
	              r: [],
	              s: "true"
	            }
	          }],
	          t: 13
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "content",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "title",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "h1",
	            f: ["Migrating from GitHub to jsDelivr"]
	          }, " ", {
	            t: 7,
	            e: "h2",
	            f: ["jsDelivr is a free, fast, and reliable Open Source CDN for npm and GitHub. Most GitHub links can be easily converted to jsDelivr links."]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "container",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "box",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                n: "class",
	                f: ["bar ", {
	                  t: 4,
	                  f: ["bar-active"],
	                  n: 50,
	                  x: {
	                    r: ["out", "error"],
	                    s: "_0&&!_1"
	                  }
	                }],
	                t: 13
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "circle",
	                  g: 1
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  n: "class",
	                  f: ["line ", {
	                    t: 4,
	                    f: ["filled"],
	                    n: 50,
	                    x: {
	                      r: ["out", "error"],
	                      s: "_0&&!_1"
	                    }
	                  }],
	                  t: 13
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  n: "class",
	                  f: ["circle bottom ", {
	                    t: 4,
	                    f: ["circle-disabled"],
	                    n: 51,
	                    x: {
	                      r: ["out", "error"],
	                      s: "_0&&!_1"
	                    }
	                  }],
	                  t: 13
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "icon-competitor",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "84",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "30",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/github.svg"],
	                  t: 13
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "input-wrapper mb-48",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "input",
	                m: [{
	                  n: "type",
	                  f: "text",
	                  t: 13
	                }, {
	                  n: "class",
	                  f: ["input ", {
	                    t: 4,
	                    f: ["active"],
	                    n: 50,
	                    r: "out"
	                  }],
	                  t: 13
	                }, {
	                  n: "placeholder",
	                  f: "Paste a GitHub link here",
	                  t: 13
	                }, {
	                  n: "value",
	                  f: [{
	                    t: 2,
	                    r: "in"
	                  }],
	                  t: 13
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "icon-jsdelivr",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "115",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "28",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/jsDelivr.logo.svg"],
	                  t: 13
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "input-wrapper",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "input",
	                m: [{
	                  n: "type",
	                  f: "text",
	                  t: 13
	                }, {
	                  n: "class",
	                  f: ["input ", {
	                    t: 4,
	                    f: ["input-jsdelivr-copy"],
	                    n: 50,
	                    x: {
	                      r: ["out", "error"],
	                      s: "_0&&!_1"
	                    }
	                  }, " ", {
	                    t: 4,
	                    f: ["active"],
	                    n: 50,
	                    r: "out"
	                  }],
	                  t: 13
	                }, {
	                  n: "placeholder",
	                  f: "Get a jsDelivr link here",
	                  t: 13
	                }, {
	                  n: "value",
	                  f: [{
	                    t: 2,
	                    r: "out"
	                  }],
	                  t: 13
	                }]
	              }, " ", {
	                t: 4,
	                f: [{
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "copy",
	                    g: 1
	                  }, {
	                    n: "clipboard",
	                    t: 71
	                  }, {
	                    n: "data-clipboard-text",
	                    f: [{
	                      t: 2,
	                      r: "out"
	                    }],
	                    t: 13
	                  }],
	                  f: ["Copy"]
	                }],
	                n: 50,
	                x: {
	                  r: ["out", "error"],
	                  s: "_0&&!_1"
	                }
	              }]
	            }, " ", {
	              t: 4,
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "alert alert-warning",
	                  g: 1
	                }, {
	                  n: "role",
	                  f: "alert",
	                  t: 13,
	                  g: 1
	                }],
	                f: ["For security reasons, we serve HTML files with ", {
	                  t: 7,
	                  e: "code",
	                  f: ["Content-Type: text/plain"]
	                }, ". We recommend using ", {
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    n: "href",
	                    f: "https://pages.github.com/",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "target",
	                    f: "_blank",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "rel",
	                    f: "noopener noreferrer",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: ["GitHub Pages"]
	                }, " if this is a problem."]
	              }],
	              n: 50,
	              r: "displayHtmlWarning"
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "host-descr-title",
	              g: 1
	            }],
	            f: ["jsDelivr is a free CDN (Content Delivery Network) ", {
	              t: 7,
	              e: "br"
	            }, " for open source files"]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "host-descr-text",
	              g: 1
	            }],
	            f: ["By using jsDelivr CDN URLs you get better performance globally thanks to our multi-CDN infrastructure. We also permanently cache all files to ensure reliability, even if your files get deleted from GitHub they will continue to work on jsDelivr without breaking any sites using them. The jsDelivr CDN is designed for production use with multiple layers of failover to ensure best possible uptime."]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "buttons",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "a",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "all-features",
	                g: 1
	              }, {
	                n: "href",
	                f: "/",
	                t: 13,
	                g: 1
	              }],
	              f: ["See All Features"]
	            }]
	          }]
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "c-footer"
	    }]
	  }],
	  e: {
	    "true": function () {
	      return true;
	    },
	    "_0&&!_1": function (_0, _1) {
	      return _0 && !_1;
	    }
	  }
	};
	component$10.exports.components = {
	  "c-header-gradient": headerGradient,
	  "c-footer": footer,
	  "c-header": header,
	  "r-page": rPage
	};
	var github = ractive__default["default"].extend(component$10.exports);

	var component$$ = {
	  exports: {}
	};
	component$$.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "footer",
	    m: [{
	      t: 13,
	      n: "class",
	      f: "c-foundation-cdn-footer",
	      g: 1
	    }, {
	      n: "id",
	      f: "features",
	      t: 13,
	      g: 1
	    }],
	    f: [{
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "container",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "h2",
	        f: ["OUR CDN FEATURES:"]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "row",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "col-md-1 hidden-xs hidden-sm",
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "col-xs-6 col-sm-4 col-md-2",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "img",
	            m: [{
	              n: "width",
	              f: "150",
	              t: 13,
	              g: 1
	            }, {
	              n: "height",
	              f: "88",
	              t: 13,
	              g: 1
	            }, {
	              n: "src",
	              f: [{
	                t: 2,
	                r: "@shared.assetsHost"
	              }, "/img/foundation-cdn/multicdn.png"],
	              t: 13
	            }, {
	              n: "loading",
	              f: "lazy",
	              t: 13,
	              g: 1
	            }]
	          }, " ", {
	            t: 7,
	            e: "h3",
	            f: ["FREE MULTI-CDN"]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "col-xs-6 col-sm-4 col-md-2",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "img",
	            m: [{
	              n: "width",
	              f: "150",
	              t: 13,
	              g: 1
	            }, {
	              n: "height",
	              f: "88",
	              t: 13,
	              g: 1
	            }, {
	              n: "src",
	              f: [{
	                t: 2,
	                r: "@shared.assetsHost"
	              }, "/img/foundation-cdn/load-balancing.png"],
	              t: 13
	            }, {
	              n: "loading",
	              f: "lazy",
	              t: 13,
	              g: 1
	            }]
	          }, " ", {
	            t: 7,
	            e: "h3",
	            f: ["LOAD BALANCING"]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "col-xs-6 col-sm-4 col-md-2",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "img",
	            m: [{
	              n: "width",
	              f: "150",
	              t: 13,
	              g: 1
	            }, {
	              n: "height",
	              f: "88",
	              t: 13,
	              g: 1
	            }, {
	              n: "src",
	              f: [{
	                t: 2,
	                r: "@shared.assetsHost"
	              }, "/img/foundation-cdn/api.png"],
	              t: 13
	            }, {
	              n: "loading",
	              f: "lazy",
	              t: 13,
	              g: 1
	            }]
	          }, " ", {
	            t: 7,
	            e: "h3",
	            f: ["A REAL API"]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "col-xs-6 col-sm-4 col-md-2 col-sm-push-2 col-md-push-0",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "img",
	            m: [{
	              n: "width",
	              f: "150",
	              t: 13,
	              g: 1
	            }, {
	              n: "height",
	              f: "88",
	              t: 13,
	              g: 1
	            }, {
	              n: "src",
	              f: [{
	                t: 2,
	                r: "@shared.assetsHost"
	              }, "/img/foundation-cdn/combinefiles.png"],
	              t: 13
	            }, {
	              n: "loading",
	              f: "lazy",
	              t: 13,
	              g: 1
	            }]
	          }, " ", {
	            t: 7,
	            e: "h3",
	            f: ["COMBINE FILES"]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "col-xs-6 col-sm-4 col-md-2 col-xs-push-3 col-sm-push-2 col-md-push-0",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "img",
	            m: [{
	              n: "width",
	              f: "150",
	              t: 13,
	              g: 1
	            }, {
	              n: "height",
	              f: "88",
	              t: 13,
	              g: 1
	            }, {
	              n: "src",
	              f: [{
	                t: 2,
	                r: "@shared.assetsHost"
	              }, "/img/foundation-cdn/autoupdates.png"],
	              t: 13
	            }, {
	              n: "loading",
	              f: "lazy",
	              t: 13,
	              g: 1
	            }]
	          }, " ", {
	            t: 7,
	            e: "h3",
	            f: ["AUTOMATIC UPDATES"]
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "a",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "button",
	          g: 1
	        }, {
	          n: "href",
	          f: "/",
	          t: 13,
	          g: 1
	        }, {
	          n: "target",
	          f: "_blank",
	          t: 13,
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "i",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "fa fa-eye",
	            g: 1
	          }]
	        }, " See All Features"]
	      }]
	    }]
	  }]
	};
	var foundationCdnFooter = ractive__default["default"].extend(component$$.exports);

	var component$_ = {
	  exports: {}
	};
	component$_.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "header",
	    m: [{
	      t: 13,
	      n: "class",
	      f: "c-foundation-cdn-header",
	      g: 1
	    }],
	    f: [{
	      t: 7,
	      e: "nav",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "navbar navbar-fixed-top",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "container",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "a",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "navbar-brand",
	            g: 1
	          }, {
	            n: "href",
	            f: "/foundationcdn",
	            t: 13,
	            g: 1
	          }],
	          f: ["FoundationCDN"]
	        }, " ", {
	          t: 7,
	          e: "a",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "jsdelivr-logo",
	            g: 1
	          }, {
	            n: "href",
	            f: "/",
	            t: 13,
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "img",
	            m: [{
	              n: "width",
	              f: "182",
	              t: 13,
	              g: 1
	            }, {
	              n: "height",
	              f: "26",
	              t: 13,
	              g: 1
	            }, {
	              n: "src",
	              f: [{
	                t: 2,
	                r: "@shared.assetsHost"
	              }, "/img/foundation-cdn/jsdelivr-logo.svg"],
	              t: 13
	            }, {
	              n: "alt",
	              f: "A free super-fast CDN for developers and webmasters!",
	              t: 13,
	              g: 1
	            }]
	          }]
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "span",
	      m: [{
	        n: "id",
	        f: "forkongithub",
	        t: 13,
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "a",
	        m: [{
	          n: "target",
	          f: "_blank",
	          t: 13,
	          g: 1
	        }, {
	          n: "rel",
	          f: "noopener noreferrer",
	          t: 13,
	          g: 1
	        }, {
	          n: "href",
	          f: "https://github.com/jsdelivr/foundationcdn",
	          t: 13,
	          g: 1
	        }],
	        f: ["Fork me on GitHub"]
	      }]
	    }]
	  }]
	};
	var foundationCdnHeader = ractive__default["default"].extend(component$_.exports);

	const addManagedListener = (component, target, event, handler) => {
	  if (!target || typeof target.addEventListener !== 'function' || typeof target.removeEventListener !== 'function') {
	    console.warn('Invalid target passed to addManagedListener');
	    return;
	  }
	  target.addEventListener(event, handler);
	  if (!component || typeof component.on !== 'function') {
	    console.warn('Invalid component passed to addManagedListener');
	    return;
	  }
	  component.on('unrender', () => {
	    target.removeEventListener(event, handler);
	  });
	};
	var addManagedListener_1 = addManagedListener;
	var screenWidthListener = component => {
	  component.set('screenWidth', window.innerWidth);
	  addManagedListener(component, window, 'resize', debounce(throttle(() => component.set('screenWidth', window.innerWidth), 200)));
	};
	var stickySidebarScrollListener = component => {
	  let sidebar = document.querySelector('.page-content_side-menu');
	  if (sidebar) {
	    let top = sidebar.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop);
	    let handleStickySidebarScroll = () => {
	      let y = document.scrollingElement.scrollTop;
	      let currentSidebarTop = sidebar.getBoundingClientRect().top;
	      if (currentSidebarTop <= 20 && currentSidebarTop >= 0 || y > top) {
	        sidebar.setAttribute('style', 'position: sticky; top: 20px');
	      } else {
	        sidebar.removeAttribute('style');
	      }
	    };
	    addManagedListener(component, window, 'scroll', handleStickySidebarScroll);
	    handleStickySidebarScroll();
	  }
	};
	var listeners = {
	  addManagedListener: addManagedListener_1,
	  screenWidthListener: screenWidthListener,
	  stickySidebarScrollListener: stickySidebarScrollListener
	};

	const JS_PATTERN = /\.js$/i;
	const CSS_PATTERN = /\.css$/i;
	const ESM_PATERN = /\+esm/i;
	const CDN_ROOT = 'https://cdn.jsdelivr.net';

	// from https://github.com/mojombo/semver/issues/232
	// modified to only allow stable versions
	const SEMVER_PATTERN = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)$/;
	var buildLinks_1 = {
	  buildLinks: buildLinks$2,
	  buildIntegrity: buildIntegrity$2,
	  buildHtml: buildHtml$2,
	  canBuildHtml: canBuildHtml$2
	};
	function buildLinks$2(collection, html, optimize, alias, sri, outArray) {
	  if (sri) {
	    html = true;
	    optimize = false;
	    alias = false;
	  }
	  let links = {
	    js: [],
	    css: [],
	    other: []
	  };
	  if (outArray) {
	    links.js = links.css = links.other = outArray;
	  }
	  let collectionCopy = collection.map(file => {
	    let copy = _.deepExtend({}, file);
	    if (optimize && copy.file === _.getNonMinifiedName(copy.file)) {
	      copy.file = _.getMinifiedName(file.file);
	    }

	    // Aliasing only works with valid semver versions.
	    if (alias && SEMVER_PATTERN.test(copy.version)) {
	      let parsed = SEMVER_PATTERN.exec(copy.version);
	      if (Number(parsed[1]) > 0) {
	        copy.version = parsed[1];
	      }
	    }
	    return copy;
	  });
	  collectionCopy.forEach(file => {
	    let link = CDN_ROOT + '/' + buildFileLink(file);
	    if (JS_PATTERN.test(file.file)) {
	      links.js.push(buildFileLinkHtml(true, link, html, sri && file.hash));
	    } else if (CSS_PATTERN.test(file.file)) {
	      links.css.push(buildFileLinkHtml(false, link, html, sri && file.hash));
	    } else {
	      links.other.push({
	        html: link,
	        text: link
	      });
	    }
	  });
	  if (links.js.length > 1) {
	    links.js.unshift(buildFileLinkHtml(true, buildCombined(collectionCopy, JS_PATTERN), html));
	  }
	  if (links.css.length > 1) {
	    links.css.unshift(buildFileLinkHtml(false, buildCombined(collectionCopy, CSS_PATTERN), html));
	  }
	  return outArray || links;
	}
	function buildCombined(collection, filter) {
	  return CDN_ROOT + '/combine/' + collection.filter(file => filter.test(file.file)).map(file => {
	    return buildFileLink(file, true);
	  }).join(',');
	}
	function buildFileLink(file, useDefault = false) {
	  return `${file.type}/${file.name}@${file.version}${file.isDefault && useDefault ? '' : file.file}`;
	}
	function buildFileLinkHtml(isJs, link, html, hash, esmName) {
	  let result = {
	    text: link
	  };
	  if (esmName) {
	    result.html = `<script type="module"> import ${esmName} from '${link}' </script>`;
	  } else if (hash) {
	    result.html = isJs ? `<script src="${link}" integrity="${buildIntegrity$2(hash)}" crossorigin="anonymous"></script>` : `<link rel="stylesheet" href="${link}" integrity="${buildIntegrity$2(hash)}" crossorigin="anonymous">`;
	  } else if (html) {
	    result.html = isJs ? `<script src="${link}"></script>` : `<link rel="stylesheet" href="${link}">`;
	  } else {
	    result.html = link;
	  }
	  return result;
	}
	function buildIntegrity$2(hash) {
	  return `sha256-${hash}`;
	}
	function buildHtml$2(link, hash, esmName) {
	  if (CSS_PATTERN.test(link)) {
	    return buildFileLinkHtml(false, link, true, hash).html;
	  } else if (JS_PATTERN.test(link)) {
	    return buildFileLinkHtml(true, link, true, hash).html;
	  } else if (ESM_PATERN.test(link)) {
	    return buildFileLinkHtml(true, link, true, hash, esmName).html;
	  }
	  return buildFileLinkHtml(null, link, false).html;
	}
	function canBuildHtml$2(link) {
	  return CSS_PATTERN.test(link) || JS_PATTERN.test(link) || ESM_PATERN.test(link);
	}

	var component$Z = {
	  exports: {}
	};
	const {
	  buildLinks: buildLinks$1
	} = buildLinks_1;
	component$Z.exports = {
	  data() {
	    return {
	      title: 'Foundation CDN',
	      description: '',
	      selectedVersion: 'x.x.x',
	      defaultJs: 'foundation.min.js',
	      defaultCss: 'foundation.min.css',
	      addTag: false,
	      enableSri: false,
	      modalGroupLinks: false,
	      modalAddTag: false,
	      modalEnableSri: false,
	      toggleAll: false,
	      files: [],
	      versions: []
	    };
	  },
	  decorators: {
	    clipboard
	  },
	  computed: {
	    completeFiles() {
	      if (!this.get('files') || this.get('files').length < 1) {
	        return [{
	          file: ''
	        }, {
	          file: ''
	        }];
	      }
	      return this.getLink([this.get('files')[0], this.get('files')[1]], this.get('addTag'), this.get('enableSri'));
	    },
	    selectedFiles() {
	      if (!this.get('files')) {
	        return [];
	      }
	      return this.get('files').filter(file => {
	        return file.selected;
	      });
	    },
	    customizeText() {
	      let selectedLinks = this.getLink(this.get('selectedFiles'), false, false);
	      if (selectedLinks.js.length && selectedLinks.css.length) {
	        return 'Multiple file types selected. Use the View button instead.';
	      } else if (!selectedLinks.js.length && !selectedLinks.css.length) {
	        return '';
	      }
	      return selectedLinks.js.length ? selectedLinks.js[0].html : selectedLinks.css[0].html;
	    }
	  },
	  oninit() {
	    if (!ractive__default["default"].isServer) {
	      http.fetchPackageVersions('npm', 'foundation-sites').then(response => {
	        let filteredVersionsArr = response.versions.map(item => item.version).filter(version => {
	          return /^\d+\.\d+\.\d+$/.test(version) && Number(version.split('.')[0]) > 5;
	        });
	        this.set('selectedVersion', response.tags.latest);
	        this.set('versions', filteredVersionsArr);
	        this.updateFiles().then(() => {
	          this.observe('addTag', () => {
	            if (!this.get('addTag')) {
	              this.set('enableSri', false);
	            }
	          });
	          this.observe('enableSri', () => {
	            if (this.get('enableSri')) {
	              this.set('addTag', true);
	            }
	          });
	          this.observe('modalGroupLinks', () => {
	            if (this.get('modalGroupLinks')) {
	              this.set('modalEnableSri', false);
	            }
	          });
	          this.observe('modalAddTag', () => {
	            if (!this.get('modalAddTag')) {
	              this.set('modalEnableSri', false);
	            }
	          });
	          this.observe('modalEnableSri', () => {
	            if (this.get('modalEnableSri')) {
	              this.set('modalGroupLinks', false);
	              this.set('modalAddTag', true);
	            }
	          });
	          let files = this.get('files');
	          this.observe('toggleAll', () => {
	            files.forEach(file => {
	              file.selected = this.get('toggleAll');
	            });
	            this.set('files', files);
	          });
	          files[0].selected = true;
	          files[1].selected = true;
	          this.set('files', files);
	        }).catch(error => {
	          console.error(`Package files not found.`, error);
	        });
	      }).catch(error => {
	        console.error(`Package versions not found.`, error);
	      });
	      let handleScroll = () => {
	        let $customizeBar = document.querySelector('.section-2 .customize-bar');
	        let sectionOneEl = document.querySelector('.section-1');
	        if (!sectionOneEl) {
	          return;
	        }
	        if (document.body.clientWidth >= 992) {
	          let offset = parseFloat(getComputedStyle(sectionOneEl, null).height.replace('px', ''));
	          let scrolled = window.pageYOffset;
	          if ($customizeBar.classList.contains('fixed-cb')) {
	            if (offset > scrolled) {
	              $customizeBar.classList.remove('fixed-cb');
	              document.querySelector('.section-2').style.marginTop = 0;
	            }
	          } else {
	            if (offset < scrolled) {
	              $customizeBar.classList.add('fixed-cb');
	              document.querySelector('.section-2').style.marginTop = $customizeBar.offsetHeight;
	            }
	          }
	        } else if ($customizeBar.classList.contains('fixed-cb')) {
	          $customizeBar.classList.remove('fixed-cb');
	          document.querySelector('.section-2').style.marginTop = 0;
	        }
	      };
	      listeners.addManagedListener(this, window, 'scroll', handleScroll);
	    }
	  },
	  getLink(files, addTag, enableSri, outFiles) {
	    return buildLinks$1(files, addTag, false, false, enableSri, outFiles);
	  },
	  getGroupedLinks(files, addTag, enableSri) {
	    let builtLinks = buildLinks$1(files, addTag, false, false, enableSri);
	    let outLinks = [];
	    if (builtLinks.js.length) {
	      outLinks.push(builtLinks.js[0].html);
	    }
	    if (builtLinks.css.length) {
	      outLinks.push(builtLinks.css[0].html);
	    }
	    return outLinks;
	  },
	  setVersion(version) {
	    this.set('selectedVersion', version);
	    this.updateFiles();
	  },
	  updateFiles() {
	    return http.fetchPackageFilesFlat('npm', 'foundation-sites', this.get('selectedVersion')).then(files => {
	      let distFiles = [];
	      this.set('toggleAll', false);
	      files.files.forEach(file => {
	        if (/^(\/dist\/)((?!\.min\.).)*(\.js|\.css)+$/.test(file.name)) {
	          file.name = file.name.replace(/\.js$/, '.min.js').replace(/\.css$/, '.min.css');
	        }
	        if (distFiles.filter(f => f.file === file.name).length === 0 && /^(\/dist\/).*(\.js|\.css)+$/.test(file.name)) {
	          if (file.name.endsWith(this.get('defaultJs'))) {
	            distFiles.unshift(this.getFileObject(file.name, file.hash));
	          } else if (file.name.endsWith(this.get('defaultCss'))) {
	            distFiles.unshift(this.getFileObject(file.name, file.hash));
	            if (distFiles.length > 1 && distFiles[1].file.endsWith(this.get('defaultJs'))) {
	              let defaultJs = distFiles[1];
	              distFiles.splice(1, 1);
	              distFiles.unshift(defaultJs);
	            }
	          } else {
	            distFiles.push(this.getFileObject(file.name, file.hash));
	          }
	        }
	      });
	      distFiles[0].selected = true;
	      distFiles[1].selected = true;
	      this.set('files', distFiles);
	    });
	  },
	  getFileObject(name, hash) {
	    return {
	      file: name,
	      hash,
	      type: 'npm',
	      name: 'foundation-sites',
	      version: this.get('selectedVersion'),
	      selected: false
	    };
	  }
	};
	component$Z.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "r-page",
	    m: [{
	      n: "noYield",
	      f: [{
	        t: 2,
	        r: "noYield"
	      }],
	      t: 13
	    }, {
	      n: "title",
	      f: [{
	        t: 2,
	        r: "title"
	      }],
	      t: 13
	    }, {
	      n: "description",
	      f: [{
	        t: 2,
	        r: "description"
	      }],
	      t: 13
	    }],
	    f: [{
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "p-foundation-cdn",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "c-foundation-cdn-header"
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          n: "id",
	          f: "modal-overlay",
	          t: 13,
	          g: 1
	        }]
	      }, " ", {
	        t: 7,
	        e: "section",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "section-1",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "container",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "screen-height",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "centered",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "h1",
	                f: ["FoundationCDN"]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "title-description",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    n: "href",
	                    f: "https://www.jsdelivr.com/",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "target",
	                    f: "_blank",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "rel",
	                    f: "noopener noreferrer",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: ["Free super-fast CDN"]
	                }, " for the most advanced responsive front-end framework ", {
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    n: "href",
	                    f: "http://foundation.zurb.com/",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "target",
	                    f: "_blank",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "rel",
	                    f: "noopener noreferrer",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: ["Foundation 6"]
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "quick-use",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "h2",
	                  f: ["Quick Use:"]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "jsline",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "div",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "jsline-filters",
	                      g: 1
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "div",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "title",
	                        g: 1
	                      }],
	                      f: ["Complete JavaScript"]
	                    }, " ", {
	                      t: 7,
	                      e: "div",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "collection",
	                        g: 1
	                      }],
	                      f: [{
	                        t: 7,
	                        e: "div",
	                        m: [{
	                          t: 13,
	                          n: "class",
	                          f: "checkbox-style",
	                          g: 1
	                        }],
	                        f: [{
	                          t: 7,
	                          e: "input",
	                          m: [{
	                            n: "type",
	                            f: "checkbox",
	                            t: 13
	                          }, {
	                            n: "id",
	                            f: "addTag",
	                            t: 13
	                          }, {
	                            n: "checked",
	                            f: [{
	                              t: 2,
	                              r: "addTag"
	                            }],
	                            t: 13
	                          }]
	                        }, " ", {
	                          t: 7,
	                          e: "label",
	                          m: [{
	                            n: "for",
	                            f: "addTag",
	                            t: 13,
	                            g: 1
	                          }],
	                          f: ["Add the ", {
	                            t: 7,
	                            e: "b",
	                            f: ["<script>"]
	                          }, " tag"]
	                        }]
	                      }, " ", {
	                        t: 7,
	                        e: "div",
	                        m: [{
	                          t: 13,
	                          n: "class",
	                          f: "checkbox-style",
	                          g: 1
	                        }],
	                        f: [{
	                          t: 7,
	                          e: "input",
	                          m: [{
	                            n: "type",
	                            f: "checkbox",
	                            t: 13
	                          }, {
	                            n: "id",
	                            f: "enableSRI",
	                            t: 13
	                          }, {
	                            n: "checked",
	                            f: [{
	                              t: 2,
	                              r: "enableSri"
	                            }],
	                            t: 13
	                          }]
	                        }, " ", {
	                          t: 7,
	                          e: "label",
	                          m: [{
	                            n: "for",
	                            f: "enableSRI",
	                            t: 13,
	                            g: 1
	                          }],
	                          f: ["Enable SRI"]
	                        }]
	                      }]
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "input",
	                    m: [{
	                      n: "type",
	                      f: "text",
	                      t: 13
	                    }, {
	                      n: "id",
	                      f: "getjs",
	                      t: 13
	                    }, {
	                      n: "value",
	                      f: [{
	                        t: 2,
	                        r: "completeFiles.js.0.html"
	                      }],
	                      t: 13
	                    }, {
	                      t: 73,
	                      v: "t",
	                      f: "false"
	                    }, {
	                      n: "class",
	                      f: "form-control",
	                      t: 13
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "button",
	                    m: [{
	                      n: "title",
	                      f: "",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "clipboard",
	                      t: 71
	                    }, {
	                      n: "data-clipboard-target",
	                      f: "#getjs",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "i",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "fa fa-copy",
	                        g: 1
	                      }]
	                    }, " Copy"]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "cssline",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "div",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "title",
	                      g: 1
	                    }],
	                    f: ["Complete CSS"]
	                  }, " ", {
	                    t: 7,
	                    e: "input",
	                    m: [{
	                      n: "type",
	                      f: "text",
	                      t: 13
	                    }, {
	                      n: "id",
	                      f: "getcss",
	                      t: 13
	                    }, {
	                      n: "value",
	                      f: [{
	                        t: 2,
	                        r: "completeFiles.css.0.html"
	                      }],
	                      t: 13
	                    }, {
	                      t: 73,
	                      v: "t",
	                      f: "false"
	                    }, {
	                      n: "class",
	                      f: "form-control",
	                      t: 13
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "button",
	                    m: [{
	                      n: "title",
	                      f: "",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "clipboard",
	                      t: 71
	                    }, {
	                      n: "data-clipboard-target",
	                      f: "#getcss",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "i",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "fa fa-copy",
	                        g: 1
	                      }]
	                    }, " Copy"]
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "poweredby",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "span",
	                  f: ["Powered by:"]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "sponsors",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "div",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "sponsor",
	                      g: 1
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "a",
	                      m: [{
	                        n: "href",
	                        f: "https://appfleet.com",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "target",
	                        f: "_blank",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "rel",
	                        f: "noopener noreferrer",
	                        t: 13,
	                        g: 1
	                      }],
	                      f: [{
	                        t: 7,
	                        e: "img",
	                        m: [{
	                          n: "width",
	                          f: "177",
	                          t: 13,
	                          g: 1
	                        }, {
	                          n: "height",
	                          f: "34",
	                          t: 13,
	                          g: 1
	                        }, {
	                          n: "src",
	                          f: [{
	                            t: 2,
	                            r: "@shared.assetsHost"
	                          }, "/img/foundation-cdn/appfleet.png"],
	                          t: 13
	                        }, {
	                          n: "srcset",
	                          f: [{
	                            t: 2,
	                            r: "@shared.assetsHost"
	                          }, "/img/foundation-cdn/appfleet@2x.png 2x"],
	                          t: 13
	                        }, {
	                          n: "title",
	                          f: "appfleet",
	                          t: 13,
	                          g: 1
	                        }]
	                      }]
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "div",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "sponsor",
	                      g: 1
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "a",
	                      m: [{
	                        n: "href",
	                        f: "https://www.cloudflare.com/",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "target",
	                        f: "_blank",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "rel",
	                        f: "noopener noreferrer",
	                        t: 13,
	                        g: 1
	                      }],
	                      f: [{
	                        t: 7,
	                        e: "img",
	                        m: [{
	                          n: "width",
	                          f: "149",
	                          t: 13,
	                          g: 1
	                        }, {
	                          n: "height",
	                          f: "49",
	                          t: 13,
	                          g: 1
	                        }, {
	                          n: "src",
	                          f: [{
	                            t: 2,
	                            r: "@shared.assetsHost"
	                          }, "/img/foundation-cdn/cloudflare.png"],
	                          t: 13
	                        }, {
	                          n: "srcset",
	                          f: [{
	                            t: 2,
	                            r: "@shared.assetsHost"
	                          }, "/img/foundation-cdn/cloudflare@2x.png 2x"],
	                          t: 13
	                        }, {
	                          n: "title",
	                          f: "The web performance & security company",
	                          t: 13,
	                          g: 1
	                        }]
	                      }]
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "div",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "sponsor",
	                      g: 1
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "a",
	                      m: [{
	                        n: "href",
	                        f: "https://www.fastly.com",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "target",
	                        f: "_blank",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "rel",
	                        f: "noopener noreferrer",
	                        t: 13,
	                        g: 1
	                      }],
	                      f: [{
	                        t: 7,
	                        e: "img",
	                        m: [{
	                          n: "width",
	                          f: "116",
	                          t: 13,
	                          g: 1
	                        }, {
	                          n: "height",
	                          f: "45",
	                          t: 13,
	                          g: 1
	                        }, {
	                          n: "src",
	                          f: [{
	                            t: 2,
	                            r: "@shared.assetsHost"
	                          }, "/img/foundation-cdn/fastly.png"],
	                          t: 13
	                        }, {
	                          n: "srcset",
	                          f: [{
	                            t: 2,
	                            r: "@shared.assetsHost"
	                          }, "/img/foundation-cdn/fastly@2x.png 2x"],
	                          t: 13
	                        }, {
	                          n: "title",
	                          f: "Fastly",
	                          t: 13,
	                          g: 1
	                        }]
	                      }]
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "div",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "sponsor",
	                      g: 1
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "a",
	                      m: [{
	                        n: "href",
	                        f: "https://www.ibm.com/products/ns1-connect",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "target",
	                        f: "_blank",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "rel",
	                        f: "noopener noreferrer",
	                        t: 13,
	                        g: 1
	                      }],
	                      f: [{
	                        t: 7,
	                        e: "img",
	                        m: [{
	                          n: "width",
	                          f: "100",
	                          t: 13,
	                          g: 1
	                        }, {
	                          n: "height",
	                          f: "40",
	                          t: 13,
	                          g: 1
	                        }, {
	                          n: "src",
	                          f: [{
	                            t: 2,
	                            r: "@shared.assetsHost"
	                          }, "/img/foundation-cdn/ibm.svg"],
	                          t: 13
	                        }, {
	                          n: "title",
	                          f: "Intelligent DNS & Traffic Management",
	                          t: 13,
	                          g: 1
	                        }]
	                      }]
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "div",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "sponsor",
	                      g: 1
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "a",
	                      m: [{
	                        n: "href",
	                        f: "https://bunny.net",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "target",
	                        f: "_blank",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "rel",
	                        f: "noopener noreferrer",
	                        t: 13,
	                        g: 1
	                      }],
	                      f: [{
	                        t: 7,
	                        e: "img",
	                        m: [{
	                          n: "width",
	                          f: "172",
	                          t: 13,
	                          g: 1
	                        }, {
	                          n: "height",
	                          f: "50",
	                          t: 13,
	                          g: 1
	                        }, {
	                          n: "src",
	                          f: [{
	                            t: 2,
	                            r: "@shared.assetsHost"
	                          }, "/img/foundation-cdn/bunny.png"],
	                          t: 13
	                        }, {
	                          n: "srcset",
	                          f: [{
	                            t: 2,
	                            r: "@shared.assetsHost"
	                          }, "/img/foundation-cdn/bunny@2x.png 2x"],
	                          t: 13
	                        }, {
	                          n: "title",
	                          f: "bunny.net",
	                          t: 13,
	                          g: 1
	                        }]
	                      }]
	                    }]
	                  }]
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "customize-btn",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "href",
	                  f: "/foundationcdn#customize",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "i",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "fa fa-gear",
	                    g: 1
	                  }]
	                }, " Customize Foundation"]
	              }]
	            }]
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "section",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "section-2",
	          g: 1
	        }, {
	          n: "id",
	          f: "customize",
	          t: 13,
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "customize-bar",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "container",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "title",
	                g: 1
	              }],
	              f: ["Custom Foundation:"]
	            }, " ", {
	              t: 7,
	              e: "input",
	              m: [{
	                n: "type",
	                f: "text",
	                t: 13
	              }, {
	                n: "class",
	                f: "form-control",
	                t: 13
	              }, {
	                n: "id",
	                f: "customize-text",
	                t: 13
	              }, {
	                n: "value",
	                f: [{
	                  t: 2,
	                  r: "customizeText"
	                }],
	                t: 13
	              }, {
	                t: 73,
	                v: "t",
	                f: "false"
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "btns",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "button",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "button white-outline js-open-modal",
	                  g: 1
	                }, {
	                  n: "type",
	                  f: "button",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "data-toggle",
	                  f: "modal",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "data-target",
	                  f: "#modal",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "title",
	                  f: "",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "i",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "fa fa-code",
	                    g: 1
	                  }]
	                }, " View"]
	              }, " ", {
	                t: 7,
	                e: "a",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "button white-outline active",
	                  g: 1
	                }, {
	                  n: "clipboard",
	                  t: 71
	                }, {
	                  n: "data-clipboard-target",
	                  f: "#customize-text",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "title",
	                  f: "",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "i",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "fa fa-copy",
	                    g: 1
	                  }]
	                }, " Copy"]
	              }, " ", {
	                t: 7,
	                e: "a",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "button white-outline",
	                  g: 1
	                }, {
	                  n: "id",
	                  f: "download-link",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "rel",
	                  f: "noopener noreferrer",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "href",
	                  f: ["https://registry.npmjs.org/foundation-sites/-/foundation-sites-", {
	                    t: 2,
	                    r: "selectedVersion"
	                  }, ".tgz"],
	                  t: 13
	                }],
	                f: [{
	                  t: 7,
	                  e: "i",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "fa fa-download",
	                    g: 1
	                  }]
	                }, " Download"]
	              }]
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "container",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "customize-fields",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "cf-header",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "left",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "author",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "i",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "fa fa-github",
	                      g: 1
	                    }]
	                  }, " Zurb.com"]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "versions dropdown",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "button",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "dropdown-toggle",
	                      g: 1
	                    }, {
	                      n: "type",
	                      f: "button",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "id",
	                      f: "dropdownMenu",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "data-toggle",
	                      f: "dropdown",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "aria-haspopup",
	                      f: "true",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "aria-expanded",
	                      f: "true",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: [{
	                      t: 2,
	                      r: "selectedVersion"
	                    }, " ", {
	                      t: 7,
	                      e: "i",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "fa fa-angle-down",
	                        g: 1
	                      }]
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "ul",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "dropdown-menu",
	                      g: 1
	                    }, {
	                      n: "aria-labelledby",
	                      f: "dropdownMenu",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: [{
	                      t: 4,
	                      f: [{
	                        t: 7,
	                        e: "li",
	                        m: [{
	                          n: ["click"],
	                          t: 70,
	                          f: {
	                            r: ["@this", "."],
	                            s: "[_0.setVersion(_1)]"
	                          }
	                        }],
	                        f: [{
	                          t: 2,
	                          r: "."
	                        }]
	                      }],
	                      n: 52,
	                      r: "versions"
	                    }]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "name",
	                    g: 1
	                  }],
	                  f: ["foundation"]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "descr",
	                    g: 1
	                  }],
	                  f: ["The most advanced responsive front-end framework in the world"]
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "btns",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "button",
	                    g: 1
	                  }, {
	                    n: "href",
	                    f: ["https://data.jsdelivr.com/v1/package/npm/foundation-sites@", {
	                      t: 2,
	                      r: "selectedVersion"
	                    }],
	                    t: 13
	                  }, {
	                    n: "target",
	                    f: "_blank",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "rel",
	                    f: "noopener noreferrer",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "i",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "fa fa-gear",
	                      g: 1
	                    }]
	                  }, " API"]
	                }, " ", {
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "button",
	                    g: 1
	                  }, {
	                    n: "href",
	                    f: "http://foundation.zurb.com",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "target",
	                    f: "_blank",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "rel",
	                    f: "noopener noreferrer",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "i",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "fa fa-link",
	                      g: 1
	                    }]
	                  }, " Project page"]
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "cf-list",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "cfl-get",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "span",
	                  f: ["CDN files:"]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "switch",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "span",
	                    f: ["Select all"]
	                  }, " ", {
	                    t: 7,
	                    e: "input",
	                    m: [{
	                      n: "id",
	                      f: "get-all-links",
	                      t: 13
	                    }, {
	                      n: "type",
	                      f: "checkbox",
	                      t: 13
	                    }, {
	                      n: "checked",
	                      f: [{
	                        t: 2,
	                        r: "toggleAll"
	                      }],
	                      t: 13
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "label",
	                    m: [{
	                      n: "for",
	                      f: "get-all-links",
	                      t: 13,
	                      g: 1
	                    }]
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  n: "id",
	                  f: "cdn-files-list",
	                  t: 13,
	                  g: 1
	                }],
	                f: [" ", {
	                  t: 4,
	                  f: [{
	                    t: 8,
	                    r: "fileItem",
	                    c: {
	                      x: {
	                        r: ["."],
	                        s: "{offset:0,file:_0}"
	                      }
	                    }
	                  }],
	                  n: 52,
	                  x: {
	                    r: ["files"],
	                    s: "_0.slice(0,5)"
	                  }
	                }, " ", {
	                  t: 4,
	                  f: [{
	                    t: 7,
	                    e: "div",
	                    m: [{
	                      n: "slide",
	                      t: 72,
	                      v: "t0"
	                    }],
	                    f: [{
	                      t: 4,
	                      f: [{
	                        t: 8,
	                        r: "fileItem",
	                        c: {
	                          x: {
	                            r: ["."],
	                            s: "{offset:5,file:_0}"
	                          }
	                        }
	                      }],
	                      n: 52,
	                      x: {
	                        r: ["files"],
	                        s: "_0.slice(5)"
	                      }
	                    }]
	                  }],
	                  n: 50,
	                  r: "showMoreFiles"
	                }, " ", {
	                  t: 4,
	                  f: [{
	                    t: 4,
	                    f: [{
	                      t: 7,
	                      e: "div",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "showmoreless",
	                        g: 1
	                      }, {
	                        n: ["click"],
	                        t: 70,
	                        f: {
	                          r: ["@this"],
	                          s: "[_0.toggle(\"showMoreFiles\")]"
	                        }
	                      }],
	                      f: [{
	                        t: 7,
	                        e: "span",
	                        f: [{
	                          t: 7,
	                          e: "i",
	                          m: [{
	                            t: 13,
	                            n: "class",
	                            f: "fa fa-chevron-up",
	                            g: 1
	                          }]
	                        }, " Show less..."]
	                      }]
	                    }],
	                    n: 50,
	                    r: "showMoreFiles"
	                  }, {
	                    t: 4,
	                    f: [{
	                      t: 7,
	                      e: "div",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "showmoreless",
	                        g: 1
	                      }, {
	                        n: ["click"],
	                        t: 70,
	                        f: {
	                          r: ["@this"],
	                          s: "[_0.toggle(\"showMoreFiles\")]"
	                        }
	                      }],
	                      f: [{
	                        t: 7,
	                        e: "span",
	                        f: [{
	                          t: 7,
	                          e: "i",
	                          m: [{
	                            t: 13,
	                            n: "class",
	                            f: "fa fa-chevron-down",
	                            g: 1
	                          }]
	                        }, " Show more..."]
	                      }]
	                    }],
	                    n: 51,
	                    l: 1
	                  }],
	                  n: 50,
	                  x: {
	                    r: ["files.length"],
	                    s: "_0>5"
	                  }
	                }],
	                p: {
	                  fileContent: [{
	                    t: 7,
	                    e: "span",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "link-left",
	                      g: 1
	                    }],
	                    f: [{
	                      t: 2,
	                      x: {
	                        r: ["@this", "file"],
	                        s: "_0.getLink([_1],false,false,[])[0].html"
	                      }
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "div",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "switch",
	                      g: 1
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "input",
	                      m: [{
	                        n: "name",
	                        f: [{
	                          t: 2,
	                          r: "file.file"
	                        }],
	                        t: 13
	                      }, {
	                        n: "id",
	                        f: [{
	                          t: 2,
	                          r: "file.file"
	                        }],
	                        t: 13
	                      }, {
	                        n: "type",
	                        f: "checkbox",
	                        t: 13
	                      }, {
	                        n: "checked",
	                        f: [{
	                          t: 2,
	                          rx: {
	                            r: "files",
	                            m: [{
	                              r: ["@index", "./offset"],
	                              s: "_0+_1"
	                            }, "selected"]
	                          }
	                        }],
	                        t: 13
	                      }]
	                    }, " ", {
	                      t: 7,
	                      e: "label",
	                      m: [{
	                        n: "for",
	                        f: [{
	                          t: 2,
	                          r: "file.file"
	                        }],
	                        t: 13
	                      }]
	                    }]
	                  }],
	                  fileItem: [{
	                    t: 4,
	                    f: [{
	                      t: 7,
	                      e: "div",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "fileItem active",
	                        g: 1
	                      }],
	                      f: [{
	                        t: 8,
	                        r: "fileContent"
	                      }]
	                    }],
	                    n: 50,
	                    r: "selected"
	                  }, {
	                    t: 4,
	                    f: [{
	                      t: 7,
	                      e: "div",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "fileItem",
	                        g: 1
	                      }],
	                      f: [{
	                        t: 8,
	                        r: "fileContent"
	                      }]
	                    }],
	                    n: 51,
	                    l: 1
	                  }]
	                }
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "modal fade",
	              g: 1
	            }, {
	              n: "id",
	              f: "modal",
	              t: 13,
	              g: 1
	            }, {
	              n: "tabindex",
	              f: "-1",
	              t: 13,
	              g: 1
	            }, {
	              n: "role",
	              f: "dialog",
	              t: 13,
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "modal-dialog modal-lg",
	                g: 1
	              }, {
	                n: "role",
	                f: "document",
	                t: 13,
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "modal-content",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "modal-body",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "div",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "top",
	                      g: 1
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "div",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "title",
	                        g: 1
	                      }],
	                      f: ["Customize:"]
	                    }, " ", {
	                      t: 7,
	                      e: "div",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "collection",
	                        g: 1
	                      }],
	                      f: [{
	                        t: 7,
	                        e: "div",
	                        m: [{
	                          t: 13,
	                          n: "class",
	                          f: "checkbox-style",
	                          g: 1
	                        }],
	                        f: [{
	                          t: 7,
	                          e: "input",
	                          m: [{
	                            n: "type",
	                            f: "checkbox",
	                            t: 13
	                          }, {
	                            n: "id",
	                            f: "groupLinksM",
	                            t: 13
	                          }, {
	                            n: "checked",
	                            f: [{
	                              t: 2,
	                              r: "modalGroupLinks"
	                            }],
	                            t: 13
	                          }]
	                        }, " ", {
	                          t: 7,
	                          e: "label",
	                          m: [{
	                            n: "for",
	                            f: "groupLinksM",
	                            t: 13,
	                            g: 1
	                          }],
	                          f: ["Group links"]
	                        }]
	                      }, " ", {
	                        t: 7,
	                        e: "div",
	                        m: [{
	                          t: 13,
	                          n: "class",
	                          f: "checkbox-style",
	                          g: 1
	                        }],
	                        f: [{
	                          t: 7,
	                          e: "input",
	                          m: [{
	                            n: "type",
	                            f: "checkbox",
	                            t: 13
	                          }, {
	                            n: "id",
	                            f: "addTagM",
	                            t: 13
	                          }, {
	                            n: "checked",
	                            f: [{
	                              t: 2,
	                              r: "modalAddTag"
	                            }],
	                            t: 13
	                          }]
	                        }, " ", {
	                          t: 7,
	                          e: "label",
	                          m: [{
	                            n: "for",
	                            f: "addTagM",
	                            t: 13,
	                            g: 1
	                          }],
	                          f: ["Add the ", {
	                            t: 7,
	                            e: "b",
	                            f: ["<script>"]
	                          }, " tag"]
	                        }]
	                      }, " ", {
	                        t: 7,
	                        e: "div",
	                        m: [{
	                          t: 13,
	                          n: "class",
	                          f: "checkbox-style",
	                          g: 1
	                        }],
	                        f: [{
	                          t: 7,
	                          e: "input",
	                          m: [{
	                            n: "type",
	                            f: "checkbox",
	                            t: 13
	                          }, {
	                            n: "id",
	                            f: "enableSRIM",
	                            t: 13
	                          }, {
	                            n: "checked",
	                            f: [{
	                              t: 2,
	                              r: "modalEnableSri"
	                            }],
	                            t: 13
	                          }]
	                        }, " ", {
	                          t: 7,
	                          e: "label",
	                          m: [{
	                            n: "for",
	                            f: "enableSRIM",
	                            t: 13,
	                            g: 1
	                          }],
	                          f: ["Enable SRI"]
	                        }]
	                      }]
	                    }, " ", {
	                      t: 7,
	                      e: "i",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "fa fa-close",
	                        g: 1
	                      }, {
	                        n: "data-dismiss",
	                        f: "modal",
	                        t: 13,
	                        g: 1
	                      }]
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "div",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "bottom",
	                      g: 1
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "ul",
	                      f: [{
	                        t: 4,
	                        f: [{
	                          t: 4,
	                          f: [{
	                            t: 7,
	                            e: "li",
	                            f: [{
	                              t: 7,
	                              e: "span",
	                              m: [{
	                                n: "id",
	                                f: ["group-tag-", {
	                                  t: 2,
	                                  r: "@index"
	                                }],
	                                t: 13
	                              }],
	                              f: [{
	                                t: 2,
	                                r: "."
	                              }]
	                            }, " ", {
	                              t: 7,
	                              e: "button",
	                              m: [{
	                                n: "clipboard",
	                                t: 71
	                              }, {
	                                n: "data-clipboard-target",
	                                f: ["#group-tag-", {
	                                  t: 2,
	                                  r: "@index"
	                                }],
	                                t: 13
	                              }],
	                              f: [{
	                                t: 7,
	                                e: "i",
	                                m: [{
	                                  t: 13,
	                                  n: "class",
	                                  f: "fa fa-copy",
	                                  g: 1
	                                }]
	                              }]
	                            }]
	                          }],
	                          n: 52,
	                          x: {
	                            r: ["@this", "selectedFiles", "modalAddTag"],
	                            s: "_0.getGroupedLinks(_1,_2,false)"
	                          }
	                        }],
	                        n: 50,
	                        r: "modalGroupLinks"
	                      }, {
	                        t: 4,
	                        f: [{
	                          t: 4,
	                          f: [{
	                            t: 4,
	                            f: [{
	                              t: 7,
	                              e: "li",
	                              f: [{
	                                t: 7,
	                                e: "span",
	                                m: [{
	                                  n: "id",
	                                  f: ["file-", {
	                                    t: 2,
	                                    r: "@index"
	                                  }],
	                                  t: 13
	                                }],
	                                f: [{
	                                  t: 2,
	                                  r: "./html"
	                                }]
	                              }, " ", {
	                                t: 7,
	                                e: "button",
	                                m: [{
	                                  n: "clipboard",
	                                  t: 71
	                                }, {
	                                  n: "data-clipboard-target",
	                                  f: ["#file-", {
	                                    t: 2,
	                                    r: "@index"
	                                  }],
	                                  t: 13
	                                }],
	                                f: [{
	                                  t: 7,
	                                  e: "i",
	                                  m: [{
	                                    t: 13,
	                                    n: "class",
	                                    f: "fa fa-copy",
	                                    g: 1
	                                  }]
	                                }]
	                              }]
	                            }],
	                            n: 52,
	                            x: {
	                              r: ["@this", "selectedFiles", "modalAddTag", "modalEnableSri"],
	                              s: "_0.getLink(_1,_2,_3,[]).slice(2)"
	                            }
	                          }],
	                          n: 50,
	                          x: {
	                            r: ["@this", "selectedFiles", "modalAddTag", "modalEnableSri"],
	                            s: "_0.getLink(_1,_2,_3,[]).length>1"
	                          }
	                        }, {
	                          t: 4,
	                          f: [{
	                            t: 7,
	                            e: "li",
	                            f: [{
	                              t: 7,
	                              e: "span",
	                              m: [{
	                                n: "id",
	                                f: "file-0",
	                                t: 13,
	                                g: 1
	                              }],
	                              f: [{
	                                t: 2,
	                                x: {
	                                  r: ["@this", "selectedFiles", "modalAddTag", "modalEnableSri"],
	                                  s: "_0.getLink(_1,_2,_3,[])[0].html"
	                                }
	                              }]
	                            }, " ", {
	                              t: 7,
	                              e: "button",
	                              m: [{
	                                n: "clipboard",
	                                t: 71
	                              }, {
	                                n: "data-clipboard-target",
	                                f: "#file-0",
	                                t: 13,
	                                g: 1
	                              }],
	                              f: [{
	                                t: 7,
	                                e: "i",
	                                m: [{
	                                  t: 13,
	                                  n: "class",
	                                  f: "fa fa-copy",
	                                  g: 1
	                                }]
	                              }]
	                            }]
	                          }],
	                          n: 51,
	                          l: 1
	                        }],
	                        n: 51,
	                        l: 1
	                      }]
	                    }]
	                  }]
	                }]
	              }]
	            }]
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "c-foundation-cdn-footer"
	      }]
	    }]
	  }],
	  e: {
	    "[_0.setVersion(_1)]": function (_0, _1) {
	      return [_0.setVersion(_1)];
	    },
	    "{offset:0,file:_0}": function (_0) {
	      return {
	        offset: 0,
	        file: _0
	      };
	    },
	    "_0.slice(0,5)": function (_0) {
	      return _0.slice(0, 5);
	    },
	    "{offset:5,file:_0}": function (_0) {
	      return {
	        offset: 5,
	        file: _0
	      };
	    },
	    "_0.slice(5)": function (_0) {
	      return _0.slice(5);
	    },
	    "[_0.toggle(\"showMoreFiles\")]": function (_0) {
	      return [_0.toggle("showMoreFiles")];
	    },
	    "_0>5": function (_0) {
	      return _0 > 5;
	    },
	    "_0.getLink([_1],false,false,[])[0].html": function (_0, _1) {
	      return _0.getLink([_1], false, false, [])[0].html;
	    },
	    "_0+_1": function (_0, _1) {
	      return _0 + _1;
	    },
	    "_0.getGroupedLinks(_1,_2,false)": function (_0, _1, _2) {
	      return _0.getGroupedLinks(_1, _2, false);
	    },
	    "_0.getLink(_1,_2,_3,[]).slice(2)": function (_0, _1, _2, _3) {
	      return _0.getLink(_1, _2, _3, []).slice(2);
	    },
	    "_0.getLink(_1,_2,_3,[]).length>1": function (_0, _1, _2, _3) {
	      return _0.getLink(_1, _2, _3, []).length > 1;
	    },
	    "_0.getLink(_1,_2,_3,[])[0].html": function (_0, _1, _2, _3) {
	      return _0.getLink(_1, _2, _3, [])[0].html;
	    }
	  }
	};
	component$Z.exports.components = {
	  "c-foundation-cdn-footer": foundationCdnFooter,
	  "c-foundation-cdn-header": foundationCdnHeader,
	  "r-page": rPage
	};
	var foundationcdn = ractive__default["default"].extend(component$Z.exports);

	let tooltipDecorator = (node, content, position = 'top', rawHtml = false, elementName = 'div', className, offsetX, offsetY) => {
	  let tooltip, handlers, eventName;
	  let getPositionClass = position => {
	    let resClass;
	    switch (position) {
	      case 'top':
	        resClass = 'ractive-tooltip-top';
	        break;
	      case 'left':
	        resClass = 'ractive-tooltip-left';
	        break;
	      case 'right':
	        resClass = 'ractive-tooltip-right';
	        break;
	      default:
	        resClass = 'ractive-tooltip-bottom';
	    }
	    return resClass;
	  };
	  let getYPos = position => {
	    let yPos;
	    let {
	      top,
	      bottom
	    } = node.getBoundingClientRect();
	    switch (position) {
	      case 'top':
	        yPos = top - tooltip.clientHeight - 10;
	        break;
	      case 'left':
	      case 'right':
	        yPos = (top + bottom) / 2 - tooltip.clientHeight / 2;
	        break;
	      default:
	        yPos = bottom + 10;
	    }
	    return Math.round(yPos);
	  };
	  let getXPos = position => {
	    let xPos;
	    let {
	      left,
	      right
	    } = node.getBoundingClientRect();
	    switch (position) {
	      case 'left':
	        xPos = left - tooltip.clientWidth - 10;
	        break;
	      case 'right':
	        xPos = right + 10;
	        break;
	      default:
	        xPos = left + (right - left) / 2 - tooltip.clientWidth / 2;
	    }
	    return Math.round(xPos);
	  };
	  handlers = {
	    mouseover() {
	      if (document.querySelector('#ractive-tooltip-instance') === null) {
	        tooltip = document.createElement(elementName);
	        tooltip.className = `ractive-tooltip ${getPositionClass(position)}${className ? ` ${className}` : ''}`;
	        if (rawHtml) {
	          let preTag = document.createElement('pre');
	          tooltip.classList.add('raw');
	          preTag.textContent = content;
	          tooltip.appendChild(preTag);
	        } else {
	          if (!Array.isArray(content)) {
	            tooltip.textContent = content;
	          } else {
	            content.forEach(line => {
	              tooltip.appendChild(document.createTextNode(line));
	              tooltip.appendChild(document.createElement('br'));
	            });
	          }
	        }
	        tooltip.id = 'ractive-tooltip-instance';
	        document.body.appendChild(tooltip);
	      }
	    },
	    mousemove() {
	      tooltip.style.left = `${offsetX ? offsetX : getXPos(position)}px`;
	      tooltip.style.top = `${offsetY ? offsetY : getYPos(position)}px`;
	    },
	    mouseleave() {
	      let tooltipInstance = document.querySelector('#ractive-tooltip-instance');
	      tooltipInstance.parentElement.removeChild(tooltipInstance);
	    }
	  };
	  for (eventName in handlers) {
	    if (Object.hasOwn(handlers, eventName)) {
	      node.addEventListener(eventName, handlers[eventName], false);
	    }
	  }
	  return {
	    teardown() {
	      for (eventName in handlers) {
	        if (Object.hasOwn(handlers, eventName)) {
	          node.removeEventListener(eventName, handlers[eventName], false);
	        }
	      }
	    }
	  };
	};
	var tooltip = tooltipDecorator;

	var component$Y = {
	  exports: {}
	};
	component$Y.exports = {
	  decorators: {
	    tooltip
	  }
	};
	component$Y.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      t: 13,
	      n: "class",
	      f: "c-comparison-table",
	      g: 1
	    }],
	    f: [{
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "jsdelivr-wrapper",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "div"
	      }, " ", {
	        t: 7,
	        e: "div"
	      }, " ", {
	        t: 7,
	        e: "div",
	        f: [{
	          t: 7,
	          e: "div"
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "table-header",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "div"
	      }, " ", {
	        t: 7,
	        e: "div",
	        f: [{
	          t: 4,
	          f: [{
	            t: 7,
	            e: "img",
	            m: [{
	              n: "width",
	              f: [{
	                t: 2,
	                r: "competitorImgWidth"
	              }],
	              t: 13
	            }, {
	              n: "height",
	              f: [{
	                t: 2,
	                r: "competitorImgHeight"
	              }],
	              t: 13
	            }, {
	              n: "src",
	              f: [{
	                t: 2,
	                r: "competitorImgSrc"
	              }],
	              t: 13
	            }, {
	              n: "srcset",
	              f: [{
	                t: 2,
	                r: "competitorImgSrcset"
	              }],
	              t: 13
	            }]
	          }],
	          n: 50,
	          r: "competitorImgSrc"
	        }, {
	          t: 4,
	          f: [{
	            t: 3,
	            r: "competitorTitleEl"
	          }],
	          n: 51,
	          l: 1
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        f: [{
	          t: 7,
	          e: "img",
	          m: [{
	            n: "width",
	            f: "115",
	            t: 13,
	            g: 1
	          }, {
	            n: "height",
	            f: "28",
	            t: 13,
	            g: 1
	          }, {
	            n: "src",
	            f: [{
	              t: 2,
	              r: "@shared.assetsHost"
	            }, "/img/jsDelivr.logo.svg"],
	            t: 13
	          }]
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "table-row",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "compare-subject",
	          g: 1
	        }],
	        f: ["Multi-CDN ", {
	          t: 7,
	          e: "img",
	          m: [{
	            n: "width",
	            f: "20",
	            t: 13,
	            g: 1
	          }, {
	            n: "height",
	            f: "20",
	            t: 13,
	            g: 1
	          }, {
	            n: "src",
	            f: [{
	              t: 2,
	              r: "@shared.assetsHost"
	            }, "/img/icons/information.svg"],
	            t: 13
	          }, {
	            n: "tooltip",
	            t: 71,
	            f: {
	              r: [],
	              s: "[\"Uses multiple independent CDN providers\",\"right\"]"
	            }
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "compare-detail left",
	          g: 1
	        }],
	        f: ["1"]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "compare-detail right",
	          g: 1
	        }],
	        f: ["4"]
	      }]
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "table-row",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "compare-subject",
	          g: 1
	        }],
	        f: ["Multi-DNS ", {
	          t: 7,
	          e: "img",
	          m: [{
	            n: "width",
	            f: "20",
	            t: 13,
	            g: 1
	          }, {
	            n: "height",
	            f: "20",
	            t: 13,
	            g: 1
	          }, {
	            n: "src",
	            f: [{
	              t: 2,
	              r: "@shared.assetsHost"
	            }, "/img/icons/information.svg"],
	            t: 13
	          }, {
	            n: "tooltip",
	            t: 71,
	            f: {
	              r: [],
	              s: "[\"Uses multiple independent DNS providers\",\"right\"]"
	            }
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "compare-detail left",
	          g: 1
	        }],
	        f: ["1"]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "compare-detail right",
	          g: 1
	        }],
	        f: ["2"]
	      }]
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "table-row",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "compare-subject",
	          g: 1
	        }],
	        f: ["Smart load-balancing ", {
	          t: 7,
	          e: "img",
	          m: [{
	            n: "width",
	            f: "20",
	            t: 13,
	            g: 1
	          }, {
	            n: "height",
	            f: "20",
	            t: 13,
	            g: 1
	          }, {
	            n: "src",
	            f: [{
	              t: 2,
	              r: "@shared.assetsHost"
	            }, "/img/icons/information.svg"],
	            t: 13
	          }, {
	            n: "tooltip",
	            t: 71,
	            f: {
	              r: [],
	              s: "[\"Chooses the best provider for each individual user\",\"right\"]"
	            }
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "compare-detail left",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "img",
	          m: [{
	            n: "width",
	            f: "32",
	            t: 13,
	            g: 1
	          }, {
	            n: "height",
	            f: "32",
	            t: 13,
	            g: 1
	          }, {
	            n: "src",
	            f: [{
	              t: 2,
	              r: "@shared.assetsHost"
	            }, "/img/icons/check-circle.disabled.svg"],
	            t: 13
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "compare-detail right",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "img",
	          m: [{
	            n: "width",
	            f: "32",
	            t: 13,
	            g: 1
	          }, {
	            n: "height",
	            f: "32",
	            t: 13,
	            g: 1
	          }, {
	            n: "src",
	            f: [{
	              t: 2,
	              r: "@shared.assetsHost"
	            }, "/img/icons/check-circle.full.svg"],
	            t: 13
	          }]
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "table-row",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "compare-subject",
	          g: 1
	        }],
	        f: ["Combining multiple files"]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "compare-detail left",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "img",
	          m: [{
	            n: "width",
	            f: "32",
	            t: 13,
	            g: 1
	          }, {
	            n: "height",
	            f: "32",
	            t: 13,
	            g: 1
	          }, {
	            n: "src",
	            f: [{
	              t: 2,
	              r: "@shared.assetsHost"
	            }, "/img/icons/check-circle.disabled.svg"],
	            t: 13
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "compare-detail right",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "img",
	          m: [{
	            n: "width",
	            f: "32",
	            t: 13,
	            g: 1
	          }, {
	            n: "height",
	            f: "32",
	            t: 13,
	            g: 1
	          }, {
	            n: "src",
	            f: [{
	              t: 2,
	              r: "@shared.assetsHost"
	            }, "/img/icons/check-circle.full.svg"],
	            t: 13
	          }]
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "table-row",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "compare-subject",
	          g: 1
	        }],
	        f: ["Fully featured API ", {
	          t: 7,
	          e: "img",
	          m: [{
	            n: "width",
	            f: "20",
	            t: 13,
	            g: 1
	          }, {
	            n: "height",
	            f: "20",
	            t: 13,
	            g: 1
	          }, {
	            n: "src",
	            f: [{
	              t: 2,
	              r: "@shared.assetsHost"
	            }, "/img/icons/information.svg"],
	            t: 13
	          }, {
	            n: "tooltip",
	            t: 71,
	            f: {
	              r: [],
	              s: "[\"Package version listings, directory listings, and detailed usage stats\",\"right\"]"
	            }
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "compare-detail left",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "img",
	          m: [{
	            n: "width",
	            f: "32",
	            t: 13,
	            g: 1
	          }, {
	            n: "height",
	            f: "32",
	            t: 13,
	            g: 1
	          }, {
	            n: "src",
	            f: [{
	              t: 2,
	              r: "@shared.assetsHost"
	            }, "/img/icons/check-circle.disabled.svg"],
	            t: 13
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "compare-detail right",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "img",
	          m: [{
	            n: "width",
	            f: "32",
	            t: 13,
	            g: 1
	          }, {
	            n: "height",
	            f: "32",
	            t: 13,
	            g: 1
	          }, {
	            n: "src",
	            f: [{
	              t: 2,
	              r: "@shared.assetsHost"
	            }, "/img/icons/check-circle.full.svg"],
	            t: 13
	          }]
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "table-row",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "compare-subject",
	          g: 1
	        }],
	        f: ["Cache purge API ", {
	          t: 7,
	          e: "img",
	          m: [{
	            n: "width",
	            f: "20",
	            t: 13,
	            g: 1
	          }, {
	            n: "height",
	            f: "20",
	            t: 13,
	            g: 1
	          }, {
	            n: "src",
	            f: [{
	              t: 2,
	              r: "@shared.assetsHost"
	            }, "/img/icons/information.svg"],
	            t: 13
	          }, {
	            n: "tooltip",
	            t: 71,
	            f: {
	              r: [],
	              s: "[\"Instantly refresh a file cached on the CDN\",\"right\"]"
	            }
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "compare-detail left",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "img",
	          m: [{
	            n: "width",
	            f: "32",
	            t: 13,
	            g: 1
	          }, {
	            n: "height",
	            f: "32",
	            t: 13,
	            g: 1
	          }, {
	            n: "src",
	            f: [{
	              t: 2,
	              r: "@shared.assetsHost"
	            }, "/img/icons/check-circle.disabled.svg"],
	            t: 13
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "compare-detail right",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "img",
	          m: [{
	            n: "width",
	            f: "32",
	            t: 13,
	            g: 1
	          }, {
	            n: "height",
	            f: "32",
	            t: 13,
	            g: 1
	          }, {
	            n: "src",
	            f: [{
	              t: 2,
	              r: "@shared.assetsHost"
	            }, "/img/icons/check-circle.full.svg"],
	            t: 13
	          }]
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "table-row",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "compare-subject",
	          g: 1
	        }],
	        f: ["Download stats"]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "compare-detail left",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "img",
	          m: [{
	            n: "width",
	            f: "32",
	            t: 13,
	            g: 1
	          }, {
	            n: "height",
	            f: "32",
	            t: 13,
	            g: 1
	          }, {
	            n: "src",
	            f: [{
	              t: 2,
	              r: "@shared.assetsHost"
	            }, "/img/icons/check-circle.disabled.svg"],
	            t: 13
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "compare-detail right",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "img",
	          m: [{
	            n: "width",
	            f: "32",
	            t: 13,
	            g: 1
	          }, {
	            n: "height",
	            f: "32",
	            t: 13,
	            g: 1
	          }, {
	            n: "src",
	            f: [{
	              t: 2,
	              r: "@shared.assetsHost"
	            }, "/img/icons/check-circle.full.svg"],
	            t: 13
	          }]
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "table-row",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "compare-subject",
	          g: 1
	        }],
	        f: ["POPs in China ", {
	          t: 7,
	          e: "img",
	          m: [{
	            n: "width",
	            f: "20",
	            t: 13,
	            g: 1
	          }, {
	            n: "height",
	            f: "20",
	            t: 13,
	            g: 1
	          }, {
	            n: "src",
	            f: [{
	              t: 2,
	              r: "@shared.assetsHost"
	            }, "/img/icons/information.svg"],
	            t: 13
	          }, {
	            n: "tooltip",
	            t: 71,
	            f: {
	              r: [],
	              s: "[\"Including a valid ICP license\",\"right\"]"
	            }
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "compare-detail left",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "img",
	          m: [{
	            n: "width",
	            f: "32",
	            t: 13,
	            g: 1
	          }, {
	            n: "height",
	            f: "32",
	            t: 13,
	            g: 1
	          }, {
	            n: "src",
	            f: [{
	              t: 2,
	              r: "@shared.assetsHost"
	            }, "/img/icons/check-circle.disabled.svg"],
	            t: 13
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "compare-detail right",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "img",
	          m: [{
	            n: "width",
	            f: "32",
	            t: 13,
	            g: 1
	          }, {
	            n: "height",
	            f: "32",
	            t: 13,
	            g: 1
	          }, {
	            n: "src",
	            f: [{
	              t: 2,
	              r: "@shared.assetsHost"
	            }, "/img/icons/check-circle.full.svg"],
	            t: 13
	          }]
	        }]
	      }]
	    }]
	  }],
	  e: {
	    "[\"Uses multiple independent CDN providers\",\"right\"]": function () {
	      return ["Uses multiple independent CDN providers", "right"];
	    },
	    "[\"Uses multiple independent DNS providers\",\"right\"]": function () {
	      return ["Uses multiple independent DNS providers", "right"];
	    },
	    "[\"Chooses the best provider for each individual user\",\"right\"]": function () {
	      return ["Chooses the best provider for each individual user", "right"];
	    },
	    "[\"Package version listings, directory listings, and detailed usage stats\",\"right\"]": function () {
	      return ["Package version listings, directory listings, and detailed usage stats", "right"];
	    },
	    "[\"Instantly refresh a file cached on the CDN\",\"right\"]": function () {
	      return ["Instantly refresh a file cached on the CDN", "right"];
	    },
	    "[\"Including a valid ICP license\",\"right\"]": function () {
	      return ["Including a valid ICP license", "right"];
	    }
	  }
	};
	var comparisonTable = ractive__default["default"].extend(component$Y.exports);

	var component$X = {
	  exports: {}
	};

	/* eslint-disable no-throw-literal */

	const defaultError$3 = 'Sorry, this doesn\'t look like a valid unpkg link :(';
	component$X.exports = {
	  decorators: {
	    clipboard
	  },
	  data() {
	    return {
	      title: 'Migrate from unpkg to jsDelivr',
	      description: 'Migrate from unpkg to jsDelivr - a free, fast, and reliable Open Source CDN optimized for JS and ESM delivery from npm and GitHub. Works with all web formats. Serving more than 150 billion requests per month.'
	    };
	  },
	  oninit() {
	    let buildJsDelivrLink = (esm, [, name, version, file]) => {
	      return `${esm ? 'https://esm.run/' : 'https://cdn.jsdelivr.net/npm/'}${name}${version || ''}${file || ''}`;
	    };
	    let unpkg2jsDelivr = unpkg => Promise.resolve().then(() => {
	      let pattern = /^https?:\/\/unpkg\.com\/([^/@?]+|@[^/@?]+\/[^/@?]+)(@[^/?]+)?([^?]*\/[^?]*)*(\?module)?$/i;
	      let match = pattern.exec(unpkg);
	      if (match) {
	        return buildJsDelivrLink(!!match[4], match);
	      }
	      throw defaultError$3;
	    });
	    this.observe('in', debounce(throttle(unpkg => {
	      this.set('displayHtmlWarning', unpkg.slice(-5) === '.html');
	      if (!unpkg) {
	        return this.set('out', '');
	      }
	      unpkg2jsDelivr(unpkg).then(jsDelivr => {
	        this.set('error', false);
	        if (this.get('in') === unpkg) {
	          this.set('out', jsDelivr);
	        }
	      }).catch(error => {
	        this.set('error', true);
	        this.set('out', typeof error === 'string' ? error : defaultError$3);
	      });
	    }, 1000)));
	  }
	};
	component$X.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "r-page",
	    m: [{
	      n: "noYield",
	      f: [{
	        t: 2,
	        r: "noYield"
	      }],
	      t: 13
	    }, {
	      n: "title",
	      f: [{
	        t: 2,
	        r: "title"
	      }],
	      t: 13
	    }, {
	      n: "description",
	      f: [{
	        t: 2,
	        r: "description"
	      }],
	      t: 13
	    }],
	    f: [{
	      t: 7,
	      e: "c-header",
	      m: [{
	        n: "useWhiteLogos",
	        f: "true",
	        t: 13,
	        g: 1
	      }, {
	        n: "additionalClasses",
	        f: "header-with-orange-bg",
	        t: 13,
	        g: 1
	      }]
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "p-unpkg",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "c-header-gradient",
	        m: [{
	          n: "showMap",
	          f: [{
	            t: 2,
	            x: {
	              r: [],
	              s: "true"
	            }
	          }],
	          t: 13
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "content",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "title",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "h1",
	            f: ["Migrating from unpkg to jsDelivr"]
	          }, " ", {
	            t: 7,
	            e: "h2",
	            f: ["jsDelivr is a free, fast, and reliable Open Source CDN for npm and GitHub. Most unpkg links can be easily converted to jsDelivr links."]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "container",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "box",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                n: "class",
	                f: ["bar ", {
	                  t: 4,
	                  f: ["bar-active"],
	                  n: 50,
	                  x: {
	                    r: ["out", "error"],
	                    s: "_0&&!_1"
	                  }
	                }],
	                t: 13
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "circle",
	                  g: 1
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  n: "class",
	                  f: ["line ", {
	                    t: 4,
	                    f: ["filled"],
	                    n: 50,
	                    x: {
	                      r: ["out", "error"],
	                      s: "_0&&!_1"
	                    }
	                  }],
	                  t: 13
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  n: "class",
	                  f: ["circle bottom ", {
	                    t: 4,
	                    f: ["circle-disabled"],
	                    n: 51,
	                    x: {
	                      r: ["out", "error"],
	                      s: "_0&&!_1"
	                    }
	                  }],
	                  t: 13
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "icon-competitor",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "91",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "50",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/unpkg.png"],
	                  t: 13
	                }, {
	                  n: "srcset",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/unpkg@2x.png 2x"],
	                  t: 13
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "input-wrapper mb-48",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "input",
	                m: [{
	                  n: "type",
	                  f: "text",
	                  t: 13
	                }, {
	                  n: "class",
	                  f: ["input ", {
	                    t: 4,
	                    f: ["active"],
	                    n: 50,
	                    r: "out"
	                  }],
	                  t: 13
	                }, {
	                  n: "placeholder",
	                  f: "Paste an unpkg link here",
	                  t: 13
	                }, {
	                  n: "value",
	                  f: [{
	                    t: 2,
	                    r: "in"
	                  }],
	                  t: 13
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "icon-jsdelivr",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "115",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "28",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/jsDelivr.logo.svg"],
	                  t: 13
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "input-wrapper",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "input",
	                m: [{
	                  n: "type",
	                  f: "text",
	                  t: 13
	                }, {
	                  n: "class",
	                  f: ["input ", {
	                    t: 4,
	                    f: ["input-jsdelivr-copy"],
	                    n: 50,
	                    x: {
	                      r: ["out", "error"],
	                      s: "_0&&!_1"
	                    }
	                  }, " ", {
	                    t: 4,
	                    f: ["active"],
	                    n: 50,
	                    r: "out"
	                  }],
	                  t: 13
	                }, {
	                  n: "placeholder",
	                  f: "Get a jsDelivr link here",
	                  t: 13
	                }, {
	                  n: "value",
	                  f: [{
	                    t: 2,
	                    r: "out"
	                  }],
	                  t: 13
	                }]
	              }, " ", {
	                t: 4,
	                f: [{
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "copy",
	                    g: 1
	                  }, {
	                    n: "clipboard",
	                    t: 71
	                  }, {
	                    n: "data-clipboard-text",
	                    f: [{
	                      t: 2,
	                      r: "out"
	                    }],
	                    t: 13
	                  }],
	                  f: ["Copy"]
	                }],
	                n: 50,
	                x: {
	                  r: ["out", "error"],
	                  s: "_0&&!_1"
	                }
	              }]
	            }, " ", {
	              t: 4,
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "alert alert-warning",
	                  g: 1
	                }, {
	                  n: "role",
	                  f: "alert",
	                  t: 13,
	                  g: 1
	                }],
	                f: ["For security reasons, we serve HTML files with ", {
	                  t: 7,
	                  e: "code",
	                  f: ["Content-Type: text/plain"]
	                }, ". We recommend using ", {
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    n: "href",
	                    f: "https://pages.github.com/",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "target",
	                    f: "_blank",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "rel",
	                    f: "noopener noreferrer",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: ["GitHub Pages"]
	                }, " if this is a problem."]
	              }],
	              n: 50,
	              r: "displayHtmlWarning"
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "host-descr-title",
	              g: 1
	            }],
	            f: ["unpkg and jsDelivr comparison"]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "host-descr-text",
	              g: 1
	            }],
	            f: ["jsDelivr is a great alternative for unpkg and offers many advanced features like direct npm and github integration, file minification, and ES modules compilation and optimized delivery. In addition to that jsDelivr is faster thanks to it's global infrastructure that utilizes multiple CDN providers"]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "container",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "c-comparison-table",
	            m: [{
	              n: "competitorImgSrc",
	              f: [{
	                t: 2,
	                r: "@shared.assetsHost"
	              }, "/img/unpkg.png"],
	              t: 13
	            }, {
	              n: "competitorImgWidth",
	              f: "91",
	              t: 13,
	              g: 1
	            }, {
	              n: "competitorImgHeight",
	              f: "50",
	              t: 13,
	              g: 1
	            }, {
	              n: "competitorImgSrcset",
	              f: [{
	                t: 2,
	                r: "@shared.assetsHost"
	              }, "/img/unpkg@2x.png 2x"],
	              t: 13
	            }],
	            f: []
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "buttons",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "a",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "all-features",
	                g: 1
	              }, {
	                n: "href",
	                f: "/",
	                t: 13,
	                g: 1
	              }],
	              f: ["See All Features"]
	            }]
	          }]
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "c-footer"
	    }]
	  }],
	  e: {
	    "true": function () {
	      return true;
	    },
	    "_0&&!_1": function (_0, _1) {
	      return _0 && !_1;
	    }
	  }
	};
	component$X.exports.components = {
	  "c-header-gradient": headerGradient,
	  "c-comparison-table": comparisonTable,
	  "c-footer": footer,
	  "c-header": header,
	  "r-page": rPage
	};
	var unpkg = ractive__default["default"].extend(component$X.exports);

	var component$W = {
	  exports: {}
	};

	/* eslint-disable no-throw-literal */

	const defaultError$2 = 'Sorry, this doesn\'t look like a valid Google hosted library link :(';
	const options = {
	  'd3js': {
	    getPath(version, file) {
	      return `/npm/d3@${version}/dist/${file}`;
	    }
	  },
	  'dojo': {
	    getPath(version, file) {
	      return `/gh/dojo/dojo@${version}/${file.slice(5, -3)}.min.js`;
	    }
	  },
	  'hammerjs': {
	    getPath(version, file) {
	      return `/npm/hammerjs@${version}/${file}`;
	    }
	  },
	  'indefinite-observable': {
	    getPath(version, file) {
	      return `/npm/indefinite-observable@${version}/dist/${file}`;
	    }
	  },
	  'jquery': {
	    getPath(version, file) {
	      return `/npm/jquery@${version}/dist/${file}`;
	    }
	  },
	  'jquerymobile': {
	    getPath(version, file) {
	      return `/npm/jquery-mobile@${version}/dist/${file}`;
	    },
	    isError(version, file) {
	      if (version !== '1.4.1' || !file.endsWith('js') && !file.endsWith('css')) {
	        return true;
	      }
	    }
	  },
	  'jqueryui': {
	    getPath(version, file) {
	      return `/npm/jquery-ui-dist@${version}/${file}`;
	    },
	    isError(version, file) {
	      if (file.includes('themes')) {
	        return true;
	      }
	    }
	  },
	  'mootools': {
	    getPath() {
	      return `/npm/mootools-core-dist@1.5.1/dist/mootools-core.min.js`;
	    }
	  },
	  'myanmar-tools': {
	    getPath(version, file) {
	      return `/npm/myanmar-tools@${version}/build_node/${file}`;
	    }
	  },
	  'shaka-player': {
	    getPath(version, file) {
	      return `/npm/shaka-player@${version}/dist/${file}`;
	    }
	  },
	  'spf': {
	    getPath(version, file) {
	      return `/npm/spf@${version}/dist/${file}`;
	    }
	  },
	  'swfobject': {
	    getPath(version, file) {
	      return `/gh/swfobject/swfobject@2.2.0/${file}`;
	    },
	    isError(version) {
	      if (version !== '2.2') {
	        return true;
	      }
	    }
	  },
	  'threejs': {
	    getPath(version, file) {
	      return `/npm/three@0.${version.slice(-2)}.0/build/${file}`;
	    }
	  },
	  'webfont': {
	    getPath(version, file) {
	      return `/npm/webfontloader@${version}/${file.slice(0, -3)}loader.js`;
	    }
	  }
	};
	component$W.exports = {
	  decorators: {
	    clipboard
	  },
	  data() {
	    return {
	      title: 'Migrate from Google Hosted Libraries to jsDelivr',
	      description: 'Migrate from Google Hosted Libraries to jsDelivr - a free, fast, and reliable Open Source CDN optimized for JS and ESM delivery from npm and GitHub. Works with all web formats. Serving more than 150 billion requests per month.'
	    };
	  },
	  oninit() {
	    let google2jsDelivr = google => Promise.resolve().then(() => {
	      let pattern = /^https?:\/\/ajax\.googleapis\.com\/ajax\/libs\/([^/@]+)\/([^/@]+)\/(.*)$/i;
	      let match = pattern.exec(google);
	      if (match) {
	        let [, name, version, file] = match;
	        if (options[name].isError && options[name].isError(version, file)) {
	          throw defaultError$2;
	        } else {
	          return `https://cdn.jsdelivr.net${options[name].getPath(version, file)}`;
	        }
	      }
	      throw defaultError$2;
	    });
	    this.observe('in', debounce(throttle(google => {
	      this.set('displayHtmlWarning', google.slice(-5) === '.html');
	      if (!google) {
	        return this.set('out', '');
	      }
	      google2jsDelivr(google).then(jsDelivr => {
	        this.set('error', false);
	        if (this.get('in') === google) {
	          this.set('out', jsDelivr);
	        }
	      }).catch(error => {
	        this.set('error', true);
	        this.set('out', typeof error === 'string' ? error : defaultError$2);
	      });
	    }, 1000)));
	  }
	};
	component$W.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "r-page",
	    m: [{
	      n: "noYield",
	      f: [{
	        t: 2,
	        r: "noYield"
	      }],
	      t: 13
	    }, {
	      n: "title",
	      f: [{
	        t: 2,
	        r: "title"
	      }],
	      t: 13
	    }, {
	      n: "description",
	      f: [{
	        t: 2,
	        r: "description"
	      }],
	      t: 13
	    }],
	    f: [{
	      t: 7,
	      e: "c-header",
	      m: [{
	        n: "useWhiteLogos",
	        f: "true",
	        t: 13,
	        g: 1
	      }, {
	        n: "additionalClasses",
	        f: "header-with-orange-bg",
	        t: 13,
	        g: 1
	      }]
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "p-google",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "c-header-gradient",
	        m: [{
	          n: "showMap",
	          f: [{
	            t: 2,
	            x: {
	              r: [],
	              s: "true"
	            }
	          }],
	          t: 13
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "content",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "title",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "h1",
	            f: ["Migrating from Google hosted libraries to jsDelivr"]
	          }, " ", {
	            t: 7,
	            e: "h2",
	            f: ["jsDelivr is a free, fast, and reliable Open Source CDN for npm and GitHub. Most Google hosted library links can be easily converted to jsDelivr links."]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "container",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "box",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                n: "class",
	                f: ["bar ", {
	                  t: 4,
	                  f: ["bar-active"],
	                  n: 50,
	                  x: {
	                    r: ["out", "error"],
	                    s: "_0&&!_1"
	                  }
	                }],
	                t: 13
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "circle",
	                  g: 1
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  n: "class",
	                  f: ["line ", {
	                    t: 4,
	                    f: ["filled"],
	                    n: 50,
	                    x: {
	                      r: ["out", "error"],
	                      s: "_0&&!_1"
	                    }
	                  }],
	                  t: 13
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  n: "class",
	                  f: ["circle bottom ", {
	                    t: 4,
	                    f: ["circle-disabled"],
	                    n: 51,
	                    x: {
	                      r: ["out", "error"],
	                      s: "_0&&!_1"
	                    }
	                  }],
	                  t: 13
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "icon-competitor",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "198",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "24",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/google.svg"],
	                  t: 13
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "input-wrapper mb-48",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "input",
	                m: [{
	                  n: "type",
	                  f: "text",
	                  t: 13
	                }, {
	                  n: "class",
	                  f: ["input ", {
	                    t: 4,
	                    f: ["active"],
	                    n: 50,
	                    r: "out"
	                  }],
	                  t: 13
	                }, {
	                  n: "placeholder",
	                  f: "Paste a Google hosted library link here",
	                  t: 13
	                }, {
	                  n: "value",
	                  f: [{
	                    t: 2,
	                    r: "in"
	                  }],
	                  t: 13
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "icon-jsdelivr",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "115",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "28",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/jsDelivr.logo.svg"],
	                  t: 13
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "input-wrapper",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "input",
	                m: [{
	                  n: "type",
	                  f: "text",
	                  t: 13
	                }, {
	                  n: "class",
	                  f: ["input ", {
	                    t: 4,
	                    f: ["input-jsdelivr-copy"],
	                    n: 50,
	                    x: {
	                      r: ["out", "error"],
	                      s: "_0&&!_1"
	                    }
	                  }, " ", {
	                    t: 4,
	                    f: ["active"],
	                    n: 50,
	                    r: "out"
	                  }],
	                  t: 13
	                }, {
	                  n: "placeholder",
	                  f: "Get a jsDelivr link here",
	                  t: 13
	                }, {
	                  n: "value",
	                  f: [{
	                    t: 2,
	                    r: "out"
	                  }],
	                  t: 13
	                }]
	              }, " ", {
	                t: 4,
	                f: [{
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "copy",
	                    g: 1
	                  }, {
	                    n: "clipboard",
	                    t: 71
	                  }, {
	                    n: "data-clipboard-text",
	                    f: [{
	                      t: 2,
	                      r: "out"
	                    }],
	                    t: 13
	                  }],
	                  f: ["Copy"]
	                }],
	                n: 50,
	                x: {
	                  r: ["out", "error"],
	                  s: "_0&&!_1"
	                }
	              }]
	            }, " ", {
	              t: 4,
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "alert alert-warning",
	                  g: 1
	                }, {
	                  n: "role",
	                  f: "alert",
	                  t: 13,
	                  g: 1
	                }],
	                f: ["For security reasons, we serve HTML files with ", {
	                  t: 7,
	                  e: "code",
	                  f: ["Content-Type: text/plain"]
	                }, ". We recommend using ", {
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    n: "href",
	                    f: "https://pages.github.com/",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "target",
	                    f: "_blank",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "rel",
	                    f: "noopener noreferrer",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: ["GitHub Pages"]
	                }, " if this is a problem."]
	              }],
	              n: 50,
	              r: "displayHtmlWarning"
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "host-descr-title",
	              g: 1
	            }],
	            f: ["Google hosted libraries and jsDelivr comparison"]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "host-descr-text",
	              g: 1
	            }],
	            f: ["jsDelivr is a great alternative for Google hosted libraries and offers many advanced features like direct npm and github integration, file minification, and ES modules compilation and optimized delivery. In addition to that jsDelivr is faster thanks to it's global infrastructure that utilizes multiple CDN providers"]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "container",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "c-comparison-table",
	            m: [{
	              n: "competitorImgSrc",
	              f: [{
	                t: 2,
	                r: "@shared.assetsHost"
	              }, "/img/google.svg"],
	              t: 13
	            }, {
	              n: "competitorImgWidth",
	              f: "198",
	              t: 13,
	              g: 1
	            }, {
	              n: "competitorImgHeight",
	              f: "24",
	              t: 13,
	              g: 1
	            }],
	            f: []
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "buttons",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "a",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "all-features",
	                g: 1
	              }, {
	                n: "href",
	                f: "/",
	                t: 13,
	                g: 1
	              }],
	              f: ["See All Features"]
	            }]
	          }]
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "c-footer"
	    }]
	  }],
	  e: {
	    "true": function () {
	      return true;
	    },
	    "_0&&!_1": function (_0, _1) {
	      return _0 && !_1;
	    }
	  }
	};
	component$W.exports.components = {
	  "c-header-gradient": headerGradient,
	  "c-comparison-table": comparisonTable,
	  "c-footer": footer,
	  "c-header": header,
	  "r-page": rPage
	};
	var google$1 = ractive__default["default"].extend(component$W.exports);

	var component$V = {
	  exports: {}
	};
	component$V.exports = {
	  data() {
	    return {
	      title: 'Become a Sponsor - jsDelivr',
	      description: 'Become a sponsor and help us make jsDelivr better!',
	      activePlan: ''
	    };
	  },
	  handleSlider(ractiveThis, wrapper, plansList, tabsWrapper, columnGap) {
	    plansList.style.columnGap = `${columnGap}px`;
	    let posX1 = 0,
	      posX2 = 0,
	      posInitial = 0,
	      posFinal,
	      threshold = 100,
	      slides = plansList.querySelectorAll('.plans_wrapper_plans-list_plan'),
	      // one slide is Custom plan which is hidden for slider, ergo -1
	      slidesLength = slides.length - 1,
	      slideWidth = plansList.querySelector('.plans_wrapper_plans-list_plan').offsetWidth,
	      currentActiveTabIndex = 0,
	      allowShift = true,
	      tabs = tabsWrapper.querySelectorAll('.plans_tabs_tab');
	    wrapper.classList.add('loaded');
	    plansList.onmousedown = handleDragStart;
	    plansList.addEventListener('touchstart', handleDragStart);
	    plansList.addEventListener('touchend', handleDragEnd);
	    plansList.addEventListener('touchmove', handleDragAction);
	    plansList.addEventListener('transitionend', handleEndOfTransition);
	    tabs.forEach((tab, tabIdx) => {
	      tab.addEventListener('click', () => handleTabClick(tab, tabIdx));
	    });
	    function handleTabClick(tab, tabIdx) {
	      if (tabIdx !== currentActiveTabIndex) {
	        let shiftSize = tabIdx - currentActiveTabIndex;
	        let shiftDir = shiftSize > 0 ? 1 : -1;
	        handleShiftSlide(shiftDir, Math.abs(shiftSize));
	      }
	    }
	    function getPlanNameBasedOnIndex(planIndex) {
	      switch (planIndex) {
	        case 1:
	          return 'gold';
	        case 2:
	          return 'bronze';
	        default:
	          return '';
	      }
	    }
	    function handleDragStart(e) {
	      e.preventDefault();
	      posInitial = plansList.offsetLeft;
	      if (e.type === 'touchstart') {
	        posX1 = e.touches[0].clientX;
	      } else {
	        posX1 = e.clientX;
	        document.onmouseup = handleDragEnd;
	        document.onmousemove = handleDragAction;
	      }
	    }
	    function handleDragAction(e) {
	      if (e.type === 'touchmove') {
	        posX2 = posX1 - e.touches[0].clientX;
	        posX1 = e.touches[0].clientX;
	      } else {
	        posX2 = posX1 - e.clientX;
	        posX1 = e.clientX;
	      }
	      if (plansList.offsetLeft === 0 && plansList.offsetLeft - posX2 > 0 || plansList.offsetLeft === -((slideWidth + columnGap) * (slidesLength - 1)) && plansList.offsetLeft - posX2 < -((slideWidth + columnGap) * (slidesLength - 1))) {
	        plansList.style.left = plansList.offsetLeft;
	      } else {
	        plansList.style.left = `${plansList.offsetLeft - posX2}px`;
	      }
	    }
	    function handleDragEnd() {
	      posFinal = plansList.offsetLeft;
	      if (posFinal - posInitial < -threshold) {
	        handleShiftSlide(1);
	      } else if (posFinal - posInitial > threshold) {
	        handleShiftSlide(-1);
	      } else {
	        plansList.style.left = posInitial + 'px';
	      }
	      document.onmouseup = null;
	      document.onmousemove = null;
	    }
	    function handleShiftSlide(shiftDir, shiftSize = 1) {
	      plansList.classList.add('shifting');
	      if (allowShift) {
	        if (shiftDir === 1) {
	          posInitial -= slideWidth * shiftSize + columnGap * shiftSize;
	          plansList.style.left = `${posInitial}px`;
	          currentActiveTabIndex += shiftSize;
	        } else if (shiftDir === -1) {
	          posInitial += slideWidth * shiftSize + columnGap * shiftSize;
	          plansList.style.left = `${posInitial}px`;
	          currentActiveTabIndex -= shiftSize;
	        }
	      }
	      ractiveThis.set('activePlan', getPlanNameBasedOnIndex(currentActiveTabIndex));
	      allowShift = false;
	    }
	    function handleEndOfTransition() {
	      plansList.classList.remove('shifting');
	      allowShift = true;
	    }
	  },
	  onrender() {
	    if (!ractive__default["default"].isServer) {
	      // init slider only when screen width is larger than 768px
	      if (window.innerWidth < 768) {
	        let plansListWrapper = document.querySelector('.plans_wrapper');
	        let plansList = document.querySelector('.plans_wrapper_plans-list');
	        let tabsWrapper = document.querySelector('.plans_tabs');
	        this.handleSlider(this, plansListWrapper, plansList, tabsWrapper, 8);
	      }
	    }
	  }
	};
	component$V.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "r-page",
	    m: [{
	      n: "noYield",
	      f: [{
	        t: 2,
	        r: "noYield"
	      }],
	      t: 13
	    }, {
	      n: "title",
	      f: [{
	        t: 2,
	        r: "title"
	      }],
	      t: 13
	    }, {
	      n: "description",
	      f: [{
	        t: 2,
	        r: "description"
	      }],
	      t: 13
	    }],
	    f: [{
	      t: 7,
	      e: "c-notification"
	    }, " ", {
	      t: 7,
	      e: "c-header"
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "p-become-a-sponsor",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "navigation",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "a",
	          m: [{
	            n: "href",
	            f: "/sponsors",
	            t: 13,
	            g: 1
	          }],
	          f: ["Our sponsors"]
	        }, " ", {
	          t: 7,
	          e: "a",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "active",
	            g: 1
	          }],
	          f: ["Become our sponsor"]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "container",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "head-wrapper",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "head-wrapper_map-wrapper",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "img",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "head-map-bg",
	                g: 1
	              }, {
	                n: "width",
	                f: "908",
	                t: 13,
	                g: 1
	              }, {
	                n: "height",
	                f: "428",
	                t: 13,
	                g: 1
	              }, {
	                n: "src",
	                f: [{
	                  t: 2,
	                  r: "@shared.assetsHost"
	                }, "/img/sponsors/map.svg"],
	                t: 13
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "head-title",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "span",
	              f: ["Become a sponsor"]
	            }, " ", {
	              t: 7,
	              e: "span",
	              f: ["and help us make jsDelivr better"]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "head-subtitle",
	              g: 1
	            }],
	            f: ["Support us"]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "head-descr",
	              g: 1
	            }],
	            f: ["Support jsDelivr by donating to us through GitHub Sponsors and Open Collective and help cover the expenses of our infrastructure and sponsor the development of new features"]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "head-ctrls",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "a",
	              m: [{
	                n: "target",
	                f: "_blank",
	                t: 13,
	                g: 1
	              }, {
	                n: "rel",
	                f: "noopener noreferrer",
	                t: 13,
	                g: 1
	              }, {
	                n: "href",
	                f: "https://github.com/sponsors/jsdelivr",
	                t: 13,
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "20",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "20",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/icons/github.black.svg"],
	                  t: 13
	                }]
	              }, " GitHub Sponsors"]
	            }, " ", {
	              t: 7,
	              e: "a",
	              m: [{
	                n: "target",
	                f: "_blank",
	                t: 13,
	                g: 1
	              }, {
	                n: "rel",
	                f: "noopener noreferrer",
	                t: 13,
	                g: 1
	              }, {
	                n: "href",
	                f: "https://opencollective.com/jsdelivr",
	                t: 13,
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "18",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "18",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/icons/open-collective.svg"],
	                  t: 13
	                }]
	              }, " Open Collective"]
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "h3",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "main-title",
	            g: 1
	          }],
	          f: ["For corporate Sponsors"]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "plans_tabs",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "a",
	            m: [{
	              n: "class",
	              f: ["plans_tabs_tab ", {
	                t: 4,
	                f: ["active"],
	                n: 51,
	                r: "activePlan"
	              }],
	              t: 13
	            }],
	            f: ["Platinum"]
	          }, " ", {
	            t: 7,
	            e: "a",
	            m: [{
	              n: "class",
	              f: ["plans_tabs_tab ", {
	                t: 4,
	                f: ["active"],
	                n: 50,
	                x: {
	                  r: ["activePlan"],
	                  s: "_0===\"gold\""
	                }
	              }],
	              t: 13
	            }],
	            f: ["Gold"]
	          }, " ", {
	            t: 7,
	            e: "a",
	            m: [{
	              n: "class",
	              f: ["plans_tabs_tab ", {
	                t: 4,
	                f: ["active"],
	                n: 50,
	                x: {
	                  r: ["activePlan"],
	                  s: "_0===\"bronze\""
	                }
	              }],
	              t: 13
	            }],
	            f: ["Bronze"]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "plans_wrapper",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "plans_wrapper_plans-list",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "plans_wrapper_plans-list_plan platinum",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "sp-topline",
	                  g: 1
	                }],
	                f: [" "]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "sp-top",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "sp-level platinum",
	                    g: 1
	                  }],
	                  f: ["platinum"]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "amount",
	                    g: 1
	                  }],
	                  f: ["$1,500 + ", {
	                    t: 7,
	                    e: "div",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "sp-tooltip",
	                      g: 1
	                    }],
	                    f: ["$1,500/month worth of services,", {
	                      t: 7,
	                      e: "br"
	                    }, " developer hours or monthly donation"]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "month",
	                    g: 1
	                  }],
	                  f: ["/month"]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "sp-desc",
	                    g: 1
	                  }],
	                  f: ["$1500/month worth of services, developer hours or monthly donation"]
	                }]
	              }, " ", {
	                t: 7,
	                e: "a",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "sp-button",
	                  g: 1
	                }, {
	                  n: "href",
	                  f: "mailto:d@jsdelivr.com?subject=Become a platinum sponsor",
	                  t: 13,
	                  g: 1
	                }],
	                f: ["Become a sponsor"]
	              }, " ", {
	                t: 7,
	                e: "a",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "sample",
	                  g: 1
	                }, {
	                  n: "href",
	                  f: "/sponsors#platinum",
	                  t: 13,
	                  g: 1
	                }],
	                f: ["Sample"]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "sp-divider",
	                  g: 1
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "plan-feautures",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "div",
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "width",
	                      f: "24",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "24",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/icons/check-circle.full.svg"],
	                      t: 13
	                    }]
	                  }, " Big logo on top, on \"Sponsors\" page along with a text description"]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "width",
	                      f: "24",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "24",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/icons/check-circle.full.svg"],
	                      t: 13
	                    }]
	                  }, " Logo + link in header"]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "width",
	                      f: "24",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "24",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/icons/check-circle.full.svg"],
	                      t: 13
	                    }]
	                  }, " Tweet"]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "width",
	                      f: "24",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "24",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/icons/check-circle.full.svg"],
	                      t: 13
	                    }]
	                  }, " Blog post announcing the sponsorship"]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "width",
	                      f: "24",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "24",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/icons/check-circle.full.svg"],
	                      t: 13
	                    }]
	                  }, " Mentions future in blog posts on third-party websites"]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "width",
	                      f: "24",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "24",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/icons/check-circle.full.svg"],
	                      t: 13
	                    }]
	                  }, " Other possible partnership opportunities"]
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "plans_wrapper_plans-list_plan gold",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "sp-topline",
	                  g: 1
	                }],
	                f: [" "]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "sp-top",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "sp-level gold",
	                    g: 1
	                  }],
	                  f: ["gold"]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "amount gold",
	                    g: 1
	                  }],
	                  f: ["$500 ", {
	                    t: 7,
	                    e: "div",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "sp-tooltip",
	                      g: 1
	                    }],
	                    f: ["$500/month worth of services,", {
	                      t: 7,
	                      e: "br"
	                    }, " developer hours or monthly donation"]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "month",
	                    g: 1
	                  }],
	                  f: ["/month"]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "sp-desc",
	                    g: 1
	                  }],
	                  f: ["$500/month worth of services, developer hours or monthly donation"]
	                }]
	              }, " ", {
	                t: 7,
	                e: "a",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "sp-button",
	                  g: 1
	                }, {
	                  n: "href",
	                  f: "mailto:d@jsdelivr.com?subject=Become a gold sponsor",
	                  t: 13,
	                  g: 1
	                }],
	                f: ["Become a sponsor"]
	              }, " ", {
	                t: 7,
	                e: "a",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "sample",
	                  g: 1
	                }, {
	                  n: "href",
	                  f: "/sponsors#gold",
	                  t: 13,
	                  g: 1
	                }],
	                f: ["Sample"]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "sp-divider",
	                  g: 1
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "plan-feautures",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "div",
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "width",
	                      f: "24",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "24",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/icons/check-circle.full.svg"],
	                      t: 13
	                    }]
	                  }, " Logo + link below Platinum sponsors on \"Sponsors\" page. Small description"]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "width",
	                      f: "24",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "24",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/icons/check-circle.full.svg"],
	                      t: 13
	                    }]
	                  }, " Logo + link in header"]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "width",
	                      f: "24",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "24",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/icons/check-circle.full.svg"],
	                      t: 13
	                    }]
	                  }, " Tweet"]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "disabled",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "width",
	                      f: "24",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "24",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/icons/check-circle.disabled.svg"],
	                      t: 13
	                    }]
	                  }, " Blog post announcing the sponsorship"]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "disabled",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "width",
	                      f: "24",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "24",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/icons/check-circle.disabled.svg"],
	                      t: 13
	                    }]
	                  }, " Mentions future in blog posts on third-party websites"]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "disabled",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "width",
	                      f: "24",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "24",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/icons/check-circle.disabled.svg"],
	                      t: 13
	                    }]
	                  }, " Other possible partnership opportunities"]
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "plans_wrapper_plans-list_plan bronze",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "sp-topline",
	                  g: 1
	                }],
	                f: [" "]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "sp-top",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "sp-level bronze",
	                    g: 1
	                  }],
	                  f: ["bronze"]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "amount",
	                    g: 1
	                  }],
	                  f: ["$150 ", {
	                    t: 7,
	                    e: "div",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "sp-tooltip",
	                      g: 1
	                    }],
	                    f: ["$150/month worth of services,", {
	                      t: 7,
	                      e: "br"
	                    }, " developer hours or monthly donation"]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "month",
	                    g: 1
	                  }],
	                  f: ["/month"]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "sp-desc",
	                    g: 1
	                  }],
	                  f: ["$150/month worth of services, developer hours or monthly donation"]
	                }]
	              }, " ", {
	                t: 7,
	                e: "a",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "sp-button",
	                  g: 1
	                }, {
	                  n: "href",
	                  f: "mailto:d@jsdelivr.com?subject=Become a bronze sponsor",
	                  t: 13,
	                  g: 1
	                }],
	                f: ["Become a sponsor"]
	              }, " ", {
	                t: 7,
	                e: "a",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "sample",
	                  g: 1
	                }, {
	                  n: "href",
	                  f: "/sponsors#bronze",
	                  t: 13,
	                  g: 1
	                }],
	                f: ["Sample"]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "sp-divider",
	                  g: 1
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "plan-feautures",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "div",
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "width",
	                      f: "24",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "24",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/icons/check-circle.full.svg"],
	                      t: 13
	                    }]
	                  }, " Logo + link below Gold sponsors on \"Sponsors\" page. No description"]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "disabled",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "width",
	                      f: "24",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "24",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/icons/check-circle.disabled.svg"],
	                      t: 13
	                    }]
	                  }, " Logo + link in header"]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "disabled",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "width",
	                      f: "24",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "24",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/icons/check-circle.disabled.svg"],
	                      t: 13
	                    }]
	                  }, " Tweet"]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "disabled",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "width",
	                      f: "24",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "24",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/icons/check-circle.disabled.svg"],
	                      t: 13
	                    }]
	                  }, " Blog post announcing the sponsorship"]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "disabled",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "width",
	                      f: "24",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "24",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/icons/check-circle.disabled.svg"],
	                      t: 13
	                    }]
	                  }, " Mentions future in blog posts on third-party websites"]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "disabled",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "width",
	                      f: "24",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "24",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/icons/check-circle.disabled.svg"],
	                      t: 13
	                    }]
	                  }, " Other possible partnership opportunities"]
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "plans_wrapper_plans-list_plan custom",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "sp-topline",
	                  g: 1
	                }],
	                f: [" "]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "sp-top",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "sp-level custom",
	                    g: 1
	                  }],
	                  f: ["custom"]
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "sp-text",
	                  g: 1
	                }],
	                f: ["For companies that want to offer a smaller or bigger amount than the ones listed above and/or have custom requirements from jsDelivr."]
	              }, " ", {
	                t: 7,
	                e: "a",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "sp-button",
	                  g: 1
	                }, {
	                  n: "href",
	                  f: "mailto:d@jsdelivr.com?subject=Become a custom sponsor",
	                  t: 13,
	                  g: 1
	                }],
	                f: ["Become a sponsor"]
	              }]
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "plans_rows",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              n: "class",
	              f: ["plans_rows_row ", {
	                t: 4,
	                f: ["active"],
	                n: 51,
	                r: "activePlan"
	              }],
	              t: 13
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              n: "class",
	              f: ["plans_rows_row ", {
	                t: 4,
	                f: ["active"],
	                n: 50,
	                x: {
	                  r: ["activePlan"],
	                  s: "_0===\"gold\""
	                }
	              }],
	              t: 13
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              n: "class",
	              f: ["plans_rows_row ", {
	                t: 4,
	                f: ["active"],
	                n: 50,
	                x: {
	                  r: ["activePlan"],
	                  s: "_0===\"bronze\""
	                }
	              }],
	              t: 13
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "custom-plan",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "custom-plan_name",
	              g: 1
	            }],
	            f: ["custom"]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "custom-plan_text",
	              g: 1
	            }],
	            f: ["For companies that want to offer a smaller or bigger amount than the ones listed above and/or have custom requirements from jsDelivr."]
	          }, " ", {
	            t: 7,
	            e: "a",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "custom-plan_btn",
	              g: 1
	            }, {
	              n: "href",
	              f: "mailto:d@jsdelivr.com?subject=Become a custom sponsor",
	              t: 13,
	              g: 1
	            }],
	            f: ["Become a sponsor"]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "bottom-info",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "title",
	              g: 1
	            }],
	            f: ["You can sponsor jsDelivr by:"]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "list",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "24",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "24",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/icons/check-circle.svg"],
	                  t: 13
	                }]
	              }, " providing us your service for free (CDN, DNS, web hosting, anything else we might need)"]
	            }, " ", {
	              t: 7,
	              e: "div",
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "24",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "24",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/icons/check-circle.svg"],
	                  t: 13
	                }]
	              }, " making monthly donations to help us cover development costs and other expenses"]
	            }, " ", {
	              t: 7,
	              e: "div",
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "24",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "24",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/icons/check-circle.svg"],
	                  t: 13
	                }]
	              }, " donating development hours of your employees"]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "descr",
	              g: 1
	            }],
	            f: ["Your sponsorship level is based on the value of your monthly donation. For example, to become a Bronze sponsor, you ", {
	              t: 7,
	              e: "br"
	            }, " need to sponsor a service worth $150 - 499 per month, donate the same amount of money, or corresponding number ", {
	              t: 7,
	              e: "br"
	            }, " of development hours."]
	          }, " ", {
	            t: 7,
	            e: "div",
	            f: ["Just ", {
	              t: 7,
	              e: "a",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "mail-us",
	                g: 1
	              }, {
	                n: "href",
	                f: "mailto:d@jsdelivr.com?subject=Sponsoring jsDelivr",
	                t: 13,
	                g: 1
	              }],
	              f: ["send us an email"]
	            }, " if you have any questions."]
	          }]
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "c-footer"
	    }]
	  }],
	  e: {
	    "_0===\"gold\"": function (_0) {
	      return _0 === "gold";
	    },
	    "_0===\"bronze\"": function (_0) {
	      return _0 === "bronze";
	    }
	  }
	};
	component$V.exports.components = {
	  "c-notification": notification,
	  "c-footer": footer,
	  "c-header": header,
	  "r-page": rPage
	};
	var becomeASponsor = ractive__default["default"].extend(component$V.exports);

	var component$U = {
	  exports: {}
	};
	component$U.exports = {
	  data() {
	    return {
	      _
	    };
	  },
	  oninit() {
	    if (!ractive__default["default"].isServer) {
	      if (this.get('type') === 'npm') {
	        this.observe('version', newValue => {
	          if (newValue) {
	            http.fetchPackageVulnerabilities(this.get('name'), newValue).then(data => {
	              this.set('vulnerabilities', data.vulns);
	              this.set('vulnerabilitiesUrl', data.url);
	            }).catch(error => {
	              this.set('vulnerabilities', undefined);
	              console.error('Failed to fetch vulnerability info', error);
	            });
	          }
	        });
	      }
	    }
	  },
	  setTypeFilter(filterBy) {
	    if (filterBy === this.get('filterType')) {
	      this.set('filterType', '');
	    } else {
	      this.set('filterType', filterBy);
	    }
	  },
	  setStyleFilter(filterBy) {
	    if (filterBy === this.get('filterStyle')) {
	      this.set('filterStyle', '');
	    } else {
	      this.set('filterStyle', filterBy);
	    }
	  },
	  handlePageNameClick(name) {
	    this.event.original.preventDefault();
	    this.event.original.stopPropagation();

	    // make sure scrollY is at 0 when page is rendered
	    window.scrollTo(0, 0);
	    setTimeout(() => window.scrollTo(0, 0), 0);

	    // navigate to the Package page
	    app.router.dispatch(`/package/npm/${name}`);
	  }
	};
	component$U.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      t: 13,
	      n: "class",
	      f: "c-package-header",
	      g: 1
	    }],
	    f: [{
	      t: 4,
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "row",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "col-sm-8",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "package-name-wrapper",
	              g: 1
	            }],
	            f: [{
	              t: 4,
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "package-name",
	                  g: 1
	                }, {
	                  n: "href",
	                  f: ["/package/npm/", {
	                    t: 2,
	                    r: "name"
	                  }],
	                  t: 13
	                }, {
	                  n: ["click"],
	                  t: 70,
	                  f: {
	                    r: ["@this", "name"],
	                    s: "[_0.handlePageNameClick(_1)]"
	                  }
	                }],
	                f: [{
	                  t: 2,
	                  r: "name"
	                }]
	              }],
	              n: 50,
	              r: "packageNameAsLink"
	            }, {
	              t: 4,
	              f: [{
	                t: 7,
	                e: "h1",
	                f: [{
	                  t: 2,
	                  r: "name"
	                }]
	              }],
	              n: 51,
	              l: 1
	            }, " ", {
	              t: 4,
	              f: [{
	                t: 7,
	                e: "span",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "package_downloads-amount",
	                  g: 1
	                }, {
	                  n: "title",
	                  f: "Downloads",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "span",
	                  f: [{
	                    t: 2,
	                    x: {
	                      r: ["_", "jsDelivrHits"],
	                      s: "_1?_0.formatToShortNumber(_1):\"< 100\""
	                    }
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "span",
	                  f: ["downloads"]
	                }]
	              }],
	              n: 50,
	              r: "showDownloads"
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "package-info",
	              g: 1
	            }],
	            f: [{
	              t: 4,
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "package-owner",
	                  g: 1
	                }, {
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "rel",
	                  f: "noopener noreferrer",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "href",
	                  f: ["https://github.com/", {
	                    t: 2,
	                    r: "owner.name"
	                  }],
	                  t: 13
	                }],
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: "width",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      x: {
	                        r: ["_", "owner.avatar"],
	                        s: "_0.optimizeSrc(_1)"
	                      }
	                    }],
	                    t: 13
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "span",
	                  f: [{
	                    t: 2,
	                    r: "owner.name"
	                  }]
	                }]
	              }],
	              n: 50,
	              x: {
	                r: ["~/type"],
	                s: "_0===\"gh\""
	              }
	            }, {
	              t: 4,
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "package-owner",
	                  g: 1
	                }, {
	                  n: "href",
	                  f: ["/?query=author%3A%20", {
	                    t: 2,
	                    r: "owner.name"
	                  }],
	                  t: 13
	                }],
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: "width",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      x: {
	                        r: ["_", "owner.avatar"],
	                        s: "_0.optimizeSrc(_1)"
	                      }
	                    }],
	                    t: 13
	                  }, {
	                    n: "loading",
	                    f: "lazy",
	                    t: 13,
	                    g: 1
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "span",
	                  f: [{
	                    t: 2,
	                    r: "owner.name"
	                  }]
	                }]
	              }],
	              n: 51,
	              l: 1
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "sub-info",
	                g: 1
	              }],
	              f: [{
	                t: 4,
	                f: [{
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "sub-info_package sub-info_package_popular",
	                    g: 1
	                  }, {
	                    n: "title",
	                    f: "Popular",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: ["popular"]
	                }],
	                n: 50,
	                r: "popular"
	              }, " ", {
	                t: 4,
	                f: [{
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "sub-info_package sub-info_package_esm",
	                    g: 1
	                  }, {
	                    n: ["click"],
	                    t: 70,
	                    f: {
	                      r: ["@this"],
	                      s: "[_0.setTypeFilter(\"esm\")]"
	                    }
	                  }, {
	                    n: "title",
	                    f: "ESM",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: ["esm"]
	                }],
	                n: 50,
	                x: {
	                  r: ["moduleTypes"],
	                  s: "_0.indexOf(\"esm\")!==-1"
	                }
	              }, " ", {
	                t: 4,
	                f: [{
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "sub-info_package sub-info_package_cjs",
	                    g: 1
	                  }, {
	                    n: ["click"],
	                    t: 70,
	                    f: {
	                      r: ["@this"],
	                      s: "[_0.setTypeFilter(\"cjs\")]"
	                    }
	                  }, {
	                    n: "title",
	                    f: "CJS",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: ["cjs"]
	                }],
	                n: 50,
	                x: {
	                  r: ["moduleTypes"],
	                  s: "_0.indexOf(\"cjs\")!==-1"
	                }
	              }, " ", {
	                t: 4,
	                f: [{
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "sub-info_package sub-info_package_js",
	                    g: 1
	                  }, {
	                    n: ["click"],
	                    t: 70,
	                    f: {
	                      r: ["@this"],
	                      s: "[_0.setTypeFilter(\"js\")]"
	                    }
	                  }, {
	                    n: "title",
	                    f: "JS",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: ["js"]
	                }],
	                n: 50,
	                x: {
	                  r: ["moduleTypes"],
	                  s: "_0.indexOf(\"unknown\")!==-1"
	                }
	              }, " ", {
	                t: 4,
	                f: [{
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "sub-info_package sub-info_package_styles",
	                    g: 1
	                  }, {
	                    n: ["click"],
	                    t: 70,
	                    f: {
	                      r: ["@this"],
	                      s: "[_0.setStyleFilter(\"styles\")]"
	                    }
	                  }, {
	                    n: "title",
	                    f: "Styles",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: ["Styles"]
	                }],
	                n: 50,
	                x: {
	                  r: ["styleTypes"],
	                  s: "_0.indexOf(\"none\")===-1"
	                }
	              }, " ", {
	                t: 4,
	                f: [{
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "sub-info_package sub-info_package_deprecated",
	                    g: 1
	                  }, {
	                    n: "title",
	                    f: "Deprecated",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: ["deprecated"]
	                }],
	                n: 50,
	                r: "deprecated"
	              }, " ", {
	                t: 4,
	                f: [{
	                  t: 4,
	                  f: [{
	                    t: 7,
	                    e: "span",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "sub-info_package sub-info_package_neutral",
	                      g: 1
	                    }, {
	                      n: "title",
	                      f: [{
	                        t: 2,
	                        r: "version"
	                      }],
	                      t: 13
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "span",
	                      f: ["Version"]
	                    }, " ", {
	                      t: 7,
	                      e: "span",
	                      f: [{
	                        t: 2,
	                        r: "version"
	                      }]
	                    }]
	                  }],
	                  n: 51,
	                  r: "packageVersionsNotFound"
	                }, " ", {
	                  t: 4,
	                  f: [{
	                    t: 7,
	                    e: "span",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "sub-info_package sub-info_package_neutral",
	                      g: 1
	                    }, {
	                      n: "title",
	                      f: [{
	                        t: 2,
	                        x: {
	                          r: ["_", "license"],
	                          s: "_0.unescapeHtml(_1)"
	                        }
	                      }],
	                      t: 13
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "span",
	                      f: ["License"]
	                    }, " ", {
	                      t: 7,
	                      e: "span",
	                      f: [{
	                        t: 2,
	                        x: {
	                          r: ["_", "license"],
	                          s: "_0.unescapeHtml(_1)"
	                        }
	                      }]
	                    }]
	                  }],
	                  n: 50,
	                  r: "license"
	                }],
	                n: 50,
	                r: "showSearchElements"
	              }]
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "col-sm-4",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "package-buttons",
	              g: 1
	            }],
	            f: [{
	              t: 4,
	              f: [{
	                t: 4,
	                f: [{
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "button",
	                    g: 1
	                  }, {
	                    n: "target",
	                    f: "_blank",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "rel",
	                    f: "noopener noreferrer nofollow",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "href",
	                    f: [{
	                      t: 2,
	                      r: "homepage"
	                    }],
	                    t: 13
	                  }, {
	                    n: "title",
	                    f: "Homepage",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "width",
	                      f: "20",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "20",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/icons/globe.svg"],
	                      t: 13
	                    }, {
	                      n: "alt",
	                      f: [{
	                        t: 2,
	                        r: "name"
	                      }, " JS library homepage"],
	                      t: 13
	                    }, {
	                      n: "title",
	                      f: [{
	                        t: 2,
	                        r: "name"
	                      }, " homepage"],
	                      t: 13
	                    }]
	                  }]
	                }],
	                n: 50,
	                r: "homepage"
	              }, " ", {
	                t: 4,
	                f: [{
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "button",
	                    g: 1
	                  }, {
	                    n: "target",
	                    f: "_blank",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "rel",
	                    f: "noopener noreferrer",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "href",
	                    f: ["https://github.com/", {
	                      t: 2,
	                      r: "githubRepo.user"
	                    }, "/", {
	                      t: 2,
	                      r: "githubRepo.project"
	                    }, "/"],
	                    t: 13
	                  }, {
	                    n: "title",
	                    f: "GitHub",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "width",
	                      f: "20",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "20",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/icons/github.svg"],
	                      t: 13
	                    }, {
	                      n: "alt",
	                      f: [{
	                        t: 2,
	                        r: "name"
	                      }, " JS library on GitHub"],
	                      t: 13
	                    }, {
	                      n: "title",
	                      f: [{
	                        t: 2,
	                        r: "name"
	                      }, " on GitHub"],
	                      t: 13
	                    }]
	                  }]
	                }],
	                n: 50,
	                r: "githubRepo"
	              }, " ", {
	                t: 7,
	                e: "a",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "button",
	                  g: 1
	                }, {
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "rel",
	                  f: "noopener noreferrer",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "href",
	                  f: ["https://www.npmjs.com/package/", {
	                    t: 2,
	                    r: "name"
	                  }],
	                  t: 13
	                }, {
	                  n: "title",
	                  f: "npm",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: "width",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/icons/npm.svg"],
	                    t: 13
	                  }, {
	                    n: "alt",
	                    f: [{
	                      t: 2,
	                      r: "name"
	                    }, " JS library on npm"],
	                    t: 13
	                  }, {
	                    n: "title",
	                    f: [{
	                      t: 2,
	                      r: "name"
	                    }, " on npm"],
	                    t: 13
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "a",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "button",
	                  g: 1
	                }, {
	                  n: "rel",
	                  f: "noopener noreferrer",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "href",
	                  f: ["https://registry.npmjs.org/", {
	                    t: 2,
	                    r: "name"
	                  }, "/-/", {
	                    t: 2,
	                    x: {
	                      r: ["name"],
	                      s: "_0.split(\"/\").slice(-1)[0]"
	                    }
	                  }, "-", {
	                    t: 2,
	                    r: "~/version"
	                  }, ".tgz"],
	                  t: 13
	                }, {
	                  n: "title",
	                  f: "Download",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: "width",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/icons/download.svg"],
	                    t: 13
	                  }, {
	                    n: "alt",
	                    f: ["Download ", {
	                      t: 2,
	                      r: "name"
	                    }, " JS library"],
	                    t: 13
	                  }, {
	                    n: "title",
	                    f: ["Download ", {
	                      t: 2,
	                      r: "name"
	                    }],
	                    t: 13
	                  }]
	                }]
	              }],
	              n: 50,
	              x: {
	                r: ["~/type"],
	                s: "!_0||_0===\"npm\""
	              }
	            }, {
	              t: 4,
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "button",
	                  g: 1
	                }, {
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "rel",
	                  f: "noopener noreferrer",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "href",
	                  f: ["https://github.com/", {
	                    t: 2,
	                    r: "githubRepo.user"
	                  }, "/", {
	                    t: 2,
	                    r: "githubRepo.project"
	                  }, "/"],
	                  t: 13
	                }, {
	                  n: "title",
	                  f: "GitHub",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "i",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "fa fa-github",
	                    g: 1
	                  }, {
	                    n: "aria-hidden",
	                    f: "true",
	                    t: 13,
	                    g: 1
	                  }]
	                }]
	              }],
	              n: 51,
	              l: 1
	            }]
	          }, " ", {
	            t: 4,
	            f: [{
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "package_downloads-amount wide-screen",
	                g: 1
	              }, {
	                n: "title",
	                f: "Downloads",
	                t: 13,
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "span",
	                f: [{
	                  t: 2,
	                  x: {
	                    r: ["_", "jsDelivrHits"],
	                    s: "_1?_0.formatToShortNumber(_1):\"< 100\""
	                  }
	                }]
	              }, " ", {
	                t: 7,
	                e: "span",
	                f: ["downloads"]
	              }]
	            }],
	            n: 50,
	            r: "showDownloads"
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "p",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "package-description",
	          g: 1
	        }],
	        f: [{
	          t: 3,
	          r: "description"
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "package-header-bottom",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "horizontal-divider-16",
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "col-xs-12",
	            g: 1
	          }],
	          f: [{
	            t: 4,
	            f: [{
	              t: 7,
	              e: "span",
	              m: [{
	                n: "title",
	                f: [{
	                  t: 2,
	                  r: "version"
	                }],
	                t: 13
	              }],
	              f: ["Version ", {
	                t: 7,
	                e: "span",
	                f: [{
	                  t: 2,
	                  r: "version"
	                }]
	              }]
	            }],
	            n: 51,
	            r: "packageVersionsNotFound"
	          }, " ", {
	            t: 4,
	            f: [{
	              t: 7,
	              e: "span",
	              m: [{
	                n: "title",
	                f: [{
	                  t: 2,
	                  x: {
	                    r: ["_", "license"],
	                    s: "_0.unescapeHtml(_1)"
	                  }
	                }],
	                t: 13
	              }],
	              f: ["License ", {
	                t: 7,
	                e: "span",
	                f: [{
	                  t: 2,
	                  x: {
	                    r: ["_", "license"],
	                    s: "_0.unescapeHtml(_1)"
	                  }
	                }]
	              }]
	            }],
	            n: 50,
	            r: "license"
	          }, " ", {
	            t: 4,
	            f: [{
	              t: 7,
	              e: "span",
	              m: [{
	                n: "title",
	                f: "view details at snyk.io",
	                t: 13,
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "rel",
	                  f: "nofollow noopener",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "href",
	                  f: [{
	                    t: 2,
	                    r: "~/vulnerabilitiesUrl"
	                  }],
	                  t: 13
	                }, {
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }],
	                f: ["Vulnerabilities ", {
	                  t: 7,
	                  e: "span",
	                  f: [{
	                    t: 2,
	                    r: "~/vulnerabilities"
	                  }]
	                }]
	              }]
	            }],
	            n: 50,
	            x: {
	              r: ["~/vulnerabilities"],
	              s: "_0!==undefined"
	            }
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "package-buttons-mobile",
	          g: 1
	        }],
	        f: [{
	          t: 4,
	          f: [{
	            t: 7,
	            e: "div",
	            f: [{
	              t: 4,
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "button",
	                  g: 1
	                }, {
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "rel",
	                  f: "noopener noreferrer nofollow",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "href",
	                  f: [{
	                    t: 2,
	                    r: "homepage"
	                  }],
	                  t: 13
	                }, {
	                  n: "title",
	                  f: "Homepage",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: "width",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/icons/globe.svg"],
	                    t: 13
	                  }, {
	                    n: "alt",
	                    f: [{
	                      t: 2,
	                      r: "name"
	                    }, " JS library homepage"],
	                    t: 13
	                  }, {
	                    n: "title",
	                    f: [{
	                      t: 2,
	                      r: "name"
	                    }, " homepage"],
	                    t: 13
	                  }]
	                }]
	              }],
	              n: 50,
	              r: "homepage"
	            }, {
	              t: 4,
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "20",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "20",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/icons/globe.disabled.svg"],
	                  t: 13
	                }, {
	                  n: "alt",
	                  f: [{
	                    t: 2,
	                    r: "name"
	                  }, " has no homepage"],
	                  t: 13
	                }, {
	                  n: "title",
	                  f: [{
	                    t: 2,
	                    r: "name"
	                  }, " has no homepage"],
	                  t: 13
	                }]
	              }],
	              n: 51,
	              l: 1
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            f: [{
	              t: 4,
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "button",
	                  g: 1
	                }, {
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "rel",
	                  f: "noopener noreferrer",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "href",
	                  f: ["https://github.com/", {
	                    t: 2,
	                    r: "githubRepo.user"
	                  }, "/", {
	                    t: 2,
	                    r: "githubRepo.project"
	                  }, "/"],
	                  t: 13
	                }, {
	                  n: "title",
	                  f: "GitHub",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: "width",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/icons/github.svg"],
	                    t: 13
	                  }, {
	                    n: "alt",
	                    f: [{
	                      t: 2,
	                      r: "name"
	                    }, " JS library on GitHub"],
	                    t: 13
	                  }, {
	                    n: "title",
	                    f: [{
	                      t: 2,
	                      r: "name"
	                    }, " on GitHub"],
	                    t: 13
	                  }]
	                }]
	              }],
	              n: 50,
	              r: "githubRepo"
	            }, {
	              t: 4,
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "20",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "20",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/icons/github.disabled.svg"],
	                  t: 13
	                }, {
	                  n: "alt",
	                  f: [{
	                    t: 2,
	                    r: "name"
	                  }, " JS library on GitHub"],
	                  t: 13
	                }, {
	                  n: "title",
	                  f: [{
	                    t: 2,
	                    r: "name"
	                  }, " on GitHub"],
	                  t: 13
	                }]
	              }],
	              n: 51,
	              l: 1
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            f: [{
	              t: 7,
	              e: "a",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "button",
	                g: 1
	              }, {
	                n: "target",
	                f: "_blank",
	                t: 13,
	                g: 1
	              }, {
	                n: "rel",
	                f: "noopener noreferrer",
	                t: 13,
	                g: 1
	              }, {
	                n: "href",
	                f: ["https://www.npmjs.com/package/", {
	                  t: 2,
	                  r: "name"
	                }],
	                t: 13
	              }, {
	                n: "title",
	                f: "npm",
	                t: 13,
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "20",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "20",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/icons/npm.svg"],
	                  t: 13
	                }, {
	                  n: "alt",
	                  f: [{
	                    t: 2,
	                    r: "name"
	                  }, " JS library on npm"],
	                  t: 13
	                }, {
	                  n: "title",
	                  f: [{
	                    t: 2,
	                    r: "name"
	                  }, " on npm"],
	                  t: 13
	                }]
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            f: [{
	              t: 7,
	              e: "a",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "button",
	                g: 1
	              }, {
	                n: "rel",
	                f: "noopener noreferrer",
	                t: 13,
	                g: 1
	              }, {
	                n: "href",
	                f: ["https://registry.npmjs.org/", {
	                  t: 2,
	                  r: "name"
	                }, "/-/", {
	                  t: 2,
	                  x: {
	                    r: ["name"],
	                    s: "_0.split(\"/\").slice(-1)[0]"
	                  }
	                }, "-", {
	                  t: 2,
	                  r: "~/version"
	                }, ".tgz"],
	                t: 13
	              }, {
	                n: "title",
	                f: "Download",
	                t: 13,
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "20",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "20",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/icons/download.svg"],
	                  t: 13
	                }, {
	                  n: "alt",
	                  f: ["Download ", {
	                    t: 2,
	                    r: "name"
	                  }, " JS library"],
	                  t: 13
	                }, {
	                  n: "title",
	                  f: ["Download ", {
	                    t: 2,
	                    r: "name"
	                  }],
	                  t: 13
	                }]
	              }]
	            }]
	          }],
	          n: 50,
	          x: {
	            r: ["~/type"],
	            s: "!_0||_0===\"npm\""
	          }
	        }, {
	          t: 4,
	          f: [{
	            t: 7,
	            e: "a",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "button",
	              g: 1
	            }, {
	              n: "target",
	              f: "_blank",
	              t: 13,
	              g: 1
	            }, {
	              n: "rel",
	              f: "noopener noreferrer",
	              t: 13,
	              g: 1
	            }, {
	              n: "href",
	              f: ["https://github.com/", {
	                t: 2,
	                r: "githubRepo.user"
	              }, "/", {
	                t: 2,
	                r: "githubRepo.project"
	              }, "/"],
	              t: 13
	            }, {
	              n: "title",
	              f: "GitHub",
	              t: 13,
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "i",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "fa fa-github",
	                g: 1
	              }, {
	                n: "aria-hidden",
	                f: "true",
	                t: 13,
	                g: 1
	              }]
	            }]
	          }],
	          n: 51,
	          l: 1
	        }]
	      }, " ", {
	        t: 4,
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "package-keywords_title",
	            g: 1
	          }],
	          f: ["Keywords"]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "package-keywords_list",
	            g: 1
	          }],
	          f: [{
	            t: 4,
	            f: [{
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "package-keywords_list_item",
	                g: 1
	              }, {
	                n: "title",
	                f: [{
	                  t: 2,
	                  r: "."
	                }],
	                t: 13
	              }],
	              f: [{
	                t: 2,
	                r: "."
	              }]
	            }],
	            n: 52,
	            x: {
	              r: ["keywords"],
	              s: "_0.slice(0,15)"
	            }
	          }]
	        }],
	        n: 50,
	        r: "keywords"
	      }],
	      n: 54,
	      r: "package"
	    }]
	  }],
	  e: {
	    "[_0.handlePageNameClick(_1)]": function (_0, _1) {
	      return [_0.handlePageNameClick(_1)];
	    },
	    "_1?_0.formatToShortNumber(_1):\"< 100\"": function (_0, _1) {
	      return _1 ? _0.formatToShortNumber(_1) : "< 100";
	    },
	    "_0.optimizeSrc(_1)": function (_0, _1) {
	      return _0.optimizeSrc(_1);
	    },
	    "_0===\"gh\"": function (_0) {
	      return _0 === "gh";
	    },
	    "[_0.setTypeFilter(\"esm\")]": function (_0) {
	      return [_0.setTypeFilter("esm")];
	    },
	    "_0.indexOf(\"esm\")!==-1": function (_0) {
	      return _0.indexOf("esm") !== -1;
	    },
	    "[_0.setTypeFilter(\"cjs\")]": function (_0) {
	      return [_0.setTypeFilter("cjs")];
	    },
	    "_0.indexOf(\"cjs\")!==-1": function (_0) {
	      return _0.indexOf("cjs") !== -1;
	    },
	    "[_0.setTypeFilter(\"js\")]": function (_0) {
	      return [_0.setTypeFilter("js")];
	    },
	    "_0.indexOf(\"unknown\")!==-1": function (_0) {
	      return _0.indexOf("unknown") !== -1;
	    },
	    "[_0.setStyleFilter(\"styles\")]": function (_0) {
	      return [_0.setStyleFilter("styles")];
	    },
	    "_0.indexOf(\"none\")===-1": function (_0) {
	      return _0.indexOf("none") === -1;
	    },
	    "_0.unescapeHtml(_1)": function (_0, _1) {
	      return _0.unescapeHtml(_1);
	    },
	    "_0.split(\"/\").slice(-1)[0]": function (_0) {
	      return _0.split("/").slice(-1)[0];
	    },
	    "!_0||_0===\"npm\"": function (_0) {
	      return !_0 || _0 === "npm";
	    },
	    "_0!==undefined": function (_0) {
	      return _0 !== undefined;
	    },
	    "_0.slice(0,15)": function (_0) {
	      return _0.slice(0, 15);
	    }
	  }
	};
	var packageHeader = ractive__default["default"].extend(component$U.exports);

	let algolia = algoliasearch__default["default"]('OFCNCOG2CU', 'f54e21fa3a2a0160595bb058179bfb1e', {
	  protocol: 'https:'
	});
	let npmIndex$1 = algolia.initIndex('npm-search');
	var algolia_2 = algolia;
	var npmIndex_1 = npmIndex$1;
	var algolia_1 = {
	  algolia: algolia_2,
	  npmIndex: npmIndex_1
	};

	const {
	  npmIndex
	} = algolia_1;
	var search = (queryString, page = 0, hitsPerPage = 10) => {
	  return Promise.resolve().then(() => {
	    let parsed = parseQuery(queryString);
	    let options = {
	      page,
	      hitsPerPage,
	      attributesToHighlight: [],
	      attributesToRetrieve: ['deprecated', 'description', 'githubRepo', 'homepage', 'keywords', 'license', 'name', 'owner', 'version', 'popular', 'moduleTypes', 'styleTypes', 'jsDelivrHits'],
	      analyticsTags: ['jsdelivr']
	    };
	    if (parsed.facetFilters) {
	      options.facetFilters = parsed.facetFilters;
	    }
	    return npmIndex.search(parsed.query, options).then(response => {
	      return {
	        response: _.deepExtend({}, response),
	        query: queryString
	      };
	    });
	  });
	};
	var getByName = name => {
	  return npmIndex.getObject(name).then(pkg => {
	    return _.deepExtend({}, pkg);
	  });
	};
	const ATTR_REGEXP = /\s*(?:[a-z]+)\s*:\s*(?:.(?![a-z]*\s*:))*/gi;
	const QUERY_REGEXP = /^((?:(?:[^\s:]+(?![a-z]*\s*:))\s*)*)/i;
	const filterMapping = {
	  author: 'owner.name',
	  type: 'moduleTypes',
	  style: 'styleTypes'
	};
	function parseQuery(queryString) {
	  let query = queryString.match(QUERY_REGEXP)[0].trim();
	  let substr = queryString.substr(query.length);
	  let filters = [];
	  let match;
	  while ((match = ATTR_REGEXP.exec(substr)) !== null) {
	    let temp = match[0].split(':');
	    if (filterMapping[temp[0].trim()]) {
	      filters.push(filterMapping[temp[0].trim()] + ':' + temp[1].trim());
	    }
	  }
	  return {
	    query,
	    facetFilters: filters.join(',')
	  };
	}
	search.getByName = getByName;

	var component$T = {
	  exports: {}
	};
	component$T.exports = {
	  data() {
	    return {
	      _,
	      page: 0,
	      query: '',
	      packages: [],
	      filterType: '',
	      filterStyle: '',
	      pagination(page, nbPages) {
	        let start = Math.max(page - 2, 0);
	        let pages = [];
	        if (nbPages - page === 1) {
	          start = Math.max(Math.min(start, start - 1, start - 2), 0);
	        } else if (nbPages - page === 2) {
	          start = Math.max(Math.min(start, start - 1), 0);
	        }
	        for (let i = 0; i < 5 && start + i < nbPages; i++) {
	          pages.push(start + i);
	        }
	        return pages;
	      }
	    };
	  },
	  onrender() {
	    if (!this.isServer) {
	      let offsetTop = scrollY;
	      this.find('.search-input').focus({
	        preventScroll: true
	      });
	      this.find('.search-input').focus();
	      // Restore scroll position after focusing the input.
	      window.scrollTo(0, offsetTop);
	      setTimeout(() => window.scrollTo(0, offsetTop), 0);
	      if (this.get('caretPosition')) {
	        this.find('.search-input').setSelectionRange(this.get('caretPosition'), this.get('caretPosition'));
	      }
	      let s = debounce(keypath => {
	        if (this.get('query')) {
	          let newQuery = this.get('query');
	          if (this.get('filterStyle') === 'styles') {
	            newQuery += ' style:-none';
	          }
	          if (this.get('filterType') === 'js') {
	            newQuery += ' type:-none';
	          }
	          if (this.get('filterType') === 'esm' || this.get('filterType') === 'cjs') {
	            newQuery += ' type:' + this.get('filterType');
	          }
	          search(newQuery, this.get('page'), 10).then(result => {
	            // The query might have changed since we sent the request.
	            if (result.query === newQuery) {
	              this.set('packages', result.response.hits, {
	                shuffle: 'name'
	              });
	              this.set('hideLanding', true);
	              this.set({
	                fadeIn: true,
	                nbPages: result.response.nbPages,
	                nbHits: result.response.nbHits
	              });

	              // Scroll to the results.
	              if (!scrollY || keypath === 'page') {
	                this.scrollToSearch();
	              }
	            }
	          });
	        }
	      }, 40);

	      // Make sure query is always a string.
	      this.observe('query', value => {
	        if (typeof value !== 'string') {
	          this.set('query', String(value));
	        }
	      });

	      // Update results on input.
	      this.observe('page query filterType filterStyle __ready', (newValue, oldValue, keypath) => {
	        // Don't send requests before have all the data.
	        if (this.get('__ready')) {
	          // Reset page on query change.
	          if (keypath === 'query' && this.get('page') !== 0) {
	            this.set('page', 0);
	          } else if (!this.get('query')) {
	            this.set('hideLanding', false);
	            this.set('packages', []);
	          } else {
	            s(keypath);
	          }
	        }
	      });
	    }
	  },
	  setTypeFilter(filterBy) {
	    if (filterBy === this.get('filterType')) {
	      this.set('filterType', '');
	    } else {
	      this.set('filterType', filterBy);
	    }
	  },
	  setStyleFilter(filterBy) {
	    if (filterBy === this.get('filterStyle')) {
	      this.set('filterStyle', '');
	    } else {
	      this.set('filterStyle', filterBy);
	    }
	  },
	  scrollToSearch() {
	    let page = document.querySelector('html');
	    let searchInputEl = this.find('.search-input');
	    let scrollToPos = Math.floor(_.getElementOffset(searchInputEl).top / 100) * 100;
	    page.scrollTo({
	      behavior: 'smooth',
	      top: scrollToPos
	    });
	  }
	};
	component$T.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      t: 13,
	      n: "class",
	      f: "c-search",
	      g: 1
	    }],
	    f: [{
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "container-fluid container-mw",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "row",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "col-xs-12 col-lg-10 col-lg-push-1",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "search-input-wrapper",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "input",
	              m: [{
	                n: "class",
	                f: "search-input",
	                t: 13
	              }, {
	                n: "type",
	                f: "text",
	                t: 13
	              }, {
	                n: "placeholder",
	                f: "search all of npm",
	                t: 13
	              }, {
	                n: "value",
	                f: [{
	                  t: 2,
	                  r: "query"
	                }],
	                t: 13
	              }, {
	                n: "spellcheck",
	                f: "false",
	                t: 13
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "search-by",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "span",
	                f: ["Real-time search by"]
	              }, " ", {
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "rel",
	                  f: "noopener noreferrer",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "href",
	                  f: "https://www.algolia.com",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/algolia_grey.svg"],
	                    t: 13
	                  }, {
	                    n: "title",
	                    f: "Algolia",
	                    t: 13,
	                    g: 1
	                  }]
	                }]
	              }]
	            }, " ", {
	              t: 4,
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "filter-by",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "span",
	                  f: ["Filter for:"]
	                }, " ", {
	                  t: 7,
	                  e: "button",
	                  m: [{
	                    n: "class",
	                    f: ["btn-package-label btn-esm ", {
	                      t: 4,
	                      f: ["active"],
	                      n: 50,
	                      x: {
	                        r: ["filterType"],
	                        s: "_0===\"esm\""
	                      }
	                    }],
	                    t: 13
	                  }, {
	                    n: ["click"],
	                    t: 70,
	                    f: {
	                      r: ["@this"],
	                      s: "[_0.setTypeFilter(\"esm\")]"
	                    }
	                  }],
	                  f: ["ESM"]
	                }, " ", {
	                  t: 7,
	                  e: "button",
	                  m: [{
	                    n: "class",
	                    f: ["btn-package-label btn-cjs ", {
	                      t: 4,
	                      f: ["active"],
	                      n: 50,
	                      x: {
	                        r: ["filterType"],
	                        s: "_0===\"cjs\""
	                      }
	                    }],
	                    t: 13
	                  }, {
	                    n: ["click"],
	                    t: 70,
	                    f: {
	                      r: ["@this"],
	                      s: "[_0.setTypeFilter(\"cjs\")]"
	                    }
	                  }],
	                  f: ["CJS"]
	                }, " ", {
	                  t: 7,
	                  e: "button",
	                  m: [{
	                    n: "class",
	                    f: ["btn-package-label btn-js ", {
	                      t: 4,
	                      f: ["active"],
	                      n: 50,
	                      x: {
	                        r: ["filterType"],
	                        s: "_0===\"js\""
	                      }
	                    }],
	                    t: 13
	                  }, {
	                    n: ["click"],
	                    t: 70,
	                    f: {
	                      r: ["@this"],
	                      s: "[_0.setTypeFilter(\"js\")]"
	                    }
	                  }],
	                  f: ["JS"]
	                }, " ", {
	                  t: 7,
	                  e: "button",
	                  m: [{
	                    n: "class",
	                    f: ["btn-package-label btn-styles ", {
	                      t: 4,
	                      f: ["active"],
	                      n: 50,
	                      x: {
	                        r: ["filterStyle"],
	                        s: "_0===\"styles\""
	                      }
	                    }],
	                    t: 13
	                  }, {
	                    n: ["click"],
	                    t: 70,
	                    f: {
	                      r: ["@this"],
	                      s: "[_0.setStyleFilter(\"styles\")]"
	                    }
	                  }],
	                  f: ["Styles"]
	                }]
	              }],
	              n: 50,
	              r: "hideLanding"
	            }]
	          }, " ", {
	            t: 4,
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "search-results",
	                g: 1
	              }],
	              f: [{
	                t: 4,
	                f: [{
	                  t: 7,
	                  e: "c-package-header",
	                  m: [{
	                    n: "showSearchElements",
	                    f: "true",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "package",
	                    f: [{
	                      t: 2,
	                      r: "."
	                    }],
	                    t: 13
	                  }, {
	                    n: "version",
	                    f: [{
	                      t: 2,
	                      r: "version"
	                    }],
	                    t: 13
	                  }, {
	                    n: "query",
	                    f: [{
	                      t: 2,
	                      r: "query"
	                    }],
	                    t: 13
	                  }, {
	                    n: "filterType",
	                    f: [{
	                      t: 2,
	                      r: "filterType"
	                    }],
	                    t: 13
	                  }, {
	                    n: "filterStyle",
	                    f: [{
	                      t: 2,
	                      r: "filterStyle"
	                    }],
	                    t: 13
	                  }, {
	                    n: "packageNameAsLink",
	                    f: "true",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "showDownloads",
	                    f: "true",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: []
	                }],
	                n: 52,
	                r: "packages"
	              }, {
	                t: 4,
	                f: [{
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "no-results",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "width",
	                      f: "270",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "148",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/landing/new/no-results.svg"],
	                      t: 13
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "p",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "no-results_title",
	                      g: 1
	                    }],
	                    f: ["No results found"]
	                  }]
	                }],
	                n: 50,
	                x: {
	                  r: ["query", "nbHits"],
	                  s: "_0&&_1===0"
	                },
	                l: 1
	              }]
	            }, " ", {
	              t: 7,
	              e: "nav",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "search-pagination",
	                g: 1
	              }, {
	                n: "aria-label",
	                f: "Search results pagination",
	                t: 13,
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "pages-counter",
	                  g: 1
	                }],
	                f: ["Page ", {
	                  t: 2,
	                  x: {
	                    r: ["page"],
	                    s: "_0+1"
	                  }
	                }, " of ", {
	                  t: 2,
	                  r: "nbPages"
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  n: "class",
	                  f: ["pagination-btn pagination-btn_prev ", {
	                    t: 4,
	                    f: ["pagination-btn_disabled"],
	                    n: 51,
	                    r: "page"
	                  }],
	                  t: 13
	                }, {
	                  n: ["click"],
	                  t: 70,
	                  f: {
	                    r: ["page", "@this"],
	                    s: "[_0>0&&_1.subtract(\"page\")]"
	                  }
	                }],
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: "width",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/icons/chevron-down.svg"],
	                    t: 13
	                  }]
	                }]
	              }, " ", {
	                t: 4,
	                f: [{
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    n: "class",
	                    f: ["page-num ", {
	                      t: 4,
	                      f: ["active"],
	                      n: 50,
	                      x: {
	                        r: ["page", "."],
	                        s: "_0===_1"
	                      }
	                    }],
	                    t: 13
	                  }, {
	                    n: ["click"],
	                    t: 70,
	                    f: {
	                      r: ["@this", "."],
	                      s: "[_0.set(\"page\",_1)]"
	                    }
	                  }],
	                  f: [{
	                    t: 2,
	                    x: {
	                      r: ["."],
	                      s: "_0+1"
	                    }
	                  }]
	                }],
	                n: 52,
	                x: {
	                  r: ["pagination", "page", "nbPages"],
	                  s: "_0(_1,_2)"
	                }
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  n: "class",
	                  f: ["pagination-btn pagination-btn_next ", {
	                    t: 4,
	                    f: ["pagination-btn_disabled"],
	                    n: 51,
	                    x: {
	                      r: ["page", "nbPages"],
	                      s: "_0+1<_1"
	                    }
	                  }],
	                  t: 13
	                }, {
	                  n: ["click"],
	                  t: 70,
	                  f: {
	                    r: ["page", "nbPages", "@this"],
	                    s: "[_0+1<_1&&_2.add(\"page\")]"
	                  }
	                }],
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: "width",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/icons/chevron-down.svg"],
	                    t: 13
	                  }]
	                }]
	              }]
	            }],
	            n: 50,
	            r: "hideLanding"
	          }]
	        }]
	      }]
	    }]
	  }],
	  e: {
	    "_0===\"esm\"": function (_0) {
	      return _0 === "esm";
	    },
	    "[_0.setTypeFilter(\"esm\")]": function (_0) {
	      return [_0.setTypeFilter("esm")];
	    },
	    "_0===\"cjs\"": function (_0) {
	      return _0 === "cjs";
	    },
	    "[_0.setTypeFilter(\"cjs\")]": function (_0) {
	      return [_0.setTypeFilter("cjs")];
	    },
	    "_0===\"js\"": function (_0) {
	      return _0 === "js";
	    },
	    "[_0.setTypeFilter(\"js\")]": function (_0) {
	      return [_0.setTypeFilter("js")];
	    },
	    "_0===\"styles\"": function (_0) {
	      return _0 === "styles";
	    },
	    "[_0.setStyleFilter(\"styles\")]": function (_0) {
	      return [_0.setStyleFilter("styles")];
	    },
	    "_0&&_1===0": function (_0, _1) {
	      return _0 && _1 === 0;
	    },
	    "_0+1": function (_0) {
	      return _0 + 1;
	    },
	    "[_0>0&&_1.subtract(\"page\")]": function (_0, _1) {
	      return [_0 > 0 && _1.subtract("page")];
	    },
	    "_0===_1": function (_0, _1) {
	      return _0 === _1;
	    },
	    "[_0.set(\"page\",_1)]": function (_0, _1) {
	      return [_0.set("page", _1)];
	    },
	    "_0(_1,_2)": function (_0, _1, _2) {
	      return _0(_1, _2);
	    },
	    "_0+1<_1": function (_0, _1) {
	      return _0 + 1 < _1;
	    },
	    "[_0+1<_1&&_2.add(\"page\")]": function (_0, _1, _2) {
	      return [_0 + 1 < _1 && _2.add("page")];
	    }
	  }
	};
	component$T.exports.components = {
	  "c-package-header": packageHeader
	};
	var search_1 = ractive__default["default"].extend(component$T.exports);

	var component$S = {
	  exports: {}
	};
	component$S.exports = {
	  onrender() {
	    this.set('fly', true);
	  }
	};
	component$S.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      t: 13,
	      n: "class",
	      f: "c-slide",
	      g: 1
	    }, {
	      n: "style",
	      f: [{
	        t: 4,
	        f: ["position: absolute; top: 0; width: 100%;"],
	        n: 50,
	        r: "isIn"
	      }],
	      t: 13
	    }],
	    f: [{
	      t: 4,
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 4,
	          f: [{
	            n: "fly",
	            t: 72,
	            f: {
	              r: ["transitionOptions"],
	              s: "[_0]"
	            },
	            v: "t0"
	          }],
	          n: 50,
	          r: "fly"
	        }],
	        f: [{
	          t: 16
	        }]
	      }],
	      n: 50,
	      r: "active"
	    }]
	  }],
	  e: {
	    "[_0]": function (_0) {
	      return [_0];
	    }
	  }
	};
	var slide = ractive__default["default"].extend(component$S.exports);

	var component$R = {
	  exports: {}
	};
	component$R.exports = {
	  data() {
	    return {
	      active: 0,
	      direction: 'horizontal',
	      distance: 2000,
	      duration: 400,
	      slides: []
	    };
	  },
	  oninit() {
	    this.set('slides', this.findAllComponents('c-slide'));
	    this.get('slides')[this.get('active')].set('active', true);
	  },
	  onrender() {
	    this.parent.on('*.slide-next', () => this.next());
	    this.parent.on('*.slide-prev', () => this.prev());
	    this.parent.on('*.slide-show', (e, slideIndex) => this.show(slideIndex));
	  },
	  next(slideIndex = this.get('active') + 1) {
	    let slides = this.get('slides');
	    if (this.get('active') < slides.length - 1) {
	      let curr = slides[this.get('active')];
	      let next = slides[slideIndex];
	      if (this.get('direction') === 'horizontal') {
	        curr.set({
	          transitionOptions: {
	            easing: 'linear',
	            duration: this.get('duration'),
	            x: -this.get('distance'),
	            y: 0
	          }
	        });
	        next.set({
	          transitionOptions: {
	            easing: 'linear',
	            duration: this.get('duration'),
	            x: this.get('distance'),
	            y: 0
	          }
	        });
	      } else {
	        curr.set({
	          transitionOptions: {
	            easing: 'linear',
	            duration: this.get('duration'),
	            x: 0,
	            y: -this.get('distance')
	          }
	        });
	        next.set({
	          transitionOptions: {
	            easing: 'linear',
	            duration: this.get('duration'),
	            x: 0,
	            y: this.get('distance')
	          }
	        });
	      }
	      curr.set({
	        active: false,
	        isOut: true
	      }).then(() => curr.set({
	        transitionOptions: null,
	        isOut: false
	      }));
	      next.set({
	        active: true,
	        isIn: true
	      }).then(() => next.set({
	        transitionOptions: null,
	        isIn: false
	      }));
	      this.set('active', slideIndex);
	    }
	  },
	  prev(slideIndex = this.get('active') - 1) {
	    let slides = this.get('slides');
	    if (this.get('active') > 0) {
	      let curr = slides[this.get('active')];
	      let next = slides[slideIndex];
	      if (this.get('direction') === 'horizontal') {
	        curr.set({
	          transitionOptions: {
	            easing: 'linear',
	            duration: this.get('duration'),
	            x: this.get('distance'),
	            y: 0
	          }
	        });
	        next.set({
	          transitionOptions: {
	            easing: 'linear',
	            duration: this.get('duration'),
	            x: -this.get('distance'),
	            y: 0
	          }
	        });
	      } else {
	        curr.set({
	          transitionOptions: {
	            easing: 'linear',
	            duration: this.get('duration'),
	            x: 0,
	            y: this.get('distance')
	          }
	        });
	        next.set({
	          transitionOptions: {
	            easing: 'linear',
	            duration: this.get('duration'),
	            x: 0,
	            y: -this.get('distance')
	          }
	        });
	      }
	      curr.set({
	        active: false,
	        isOut: true
	      }).then(() => curr.set({
	        transitionOptions: null,
	        isOut: false
	      }));
	      next.set({
	        active: true,
	        isIn: true
	      }).then(() => next.set({
	        transitionOptions: null,
	        isIn: false
	      }));
	      this.set('active', slideIndex);
	    }
	  },
	  show(slideIndex) {
	    if (slideIndex < this.get('active')) {
	      this.prev(slideIndex);
	    } else if (slideIndex > this.get('active')) {
	      this.next(slideIndex);
	    }
	  }
	};
	component$R.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      t: 13,
	      n: "class",
	      f: "c-slider",
	      g: 1
	    }],
	    f: [{
	      t: 16
	    }]
	  }]
	};
	var slider = ractive__default["default"].extend(component$R.exports);

	var component$Q = {
	  exports: {}
	};
	const docs = ['', 'esm', 'gh', 'wp'];
	component$Q.exports = {
	  noIntro: true,
	  computed: {
	    activeDocsLineLeft() {
	      return this.get('activeSlide') * 25;
	    },
	    activeDocsIndex() {
	      return docs.indexOf(this.get('activeDocs'));
	    }
	  },
	  data() {
	    return {
	      _,
	      activeDocs: '',
	      networkStats: {
	        hits: {
	          total: 15e10
	        },
	        bandwidth: {
	          total: 5e15
	        }
	      },
	      cdnsList: [{
	        slug: '',
	        label: 'npm',
	        image: 'npm.svg'
	      }, {
	        slug: 'esm',
	        label: 'esm',
	        image: 'esm.svg'
	      }, {
	        slug: 'gh',
	        label: 'GitHub',
	        image: 'github.svg'
	      }, {
	        slug: 'wp',
	        label: 'WordPress',
	        image: 'wordpress.svg'
	      }],
	      slidesData: {
	        slide1: [{
	          comments: ['// load any project hosted on npm'],
	          links: ['https://cdn.jsdelivr.net/npm/package@version/file']
	        }, {
	          comments: ['// load jQuery v3.6.4'],
	          links: ['https://cdn.jsdelivr.net/npm/jquery@3.6.4/dist/jquery.min.js']
	        }, {
	          comments: ['// use a version range instead of a specific version'],
	          links: ['https://cdn.jsdelivr.net/npm/jquery@3.6/dist/jquery.min.js', 'https://cdn.jsdelivr.net/npm/jquery@3/dist/jquery.min.js']
	        }, {
	          comments: ['// omit the version completely to get the latest one', '// you should NOT use this in production'],
	          links: ['https://cdn.jsdelivr.net/npm/jquery/dist/jquery.min.js']
	        }, {
	          comments: ['// add ".min" to any JS/CSS file to get a minified version', '// if one doesn\'t exist, we\'ll generate it for you'],
	          links: ['https://cdn.jsdelivr.net/npm/jquery@3.6.4/src/core.min.js']
	        }, {
	          comments: ['// omit the file path to get the default file'],
	          links: ['https://cdn.jsdelivr.net/npm/jquery@3.6']
	        }, {
	          comments: ['// add / at the end to get a directory listing'],
	          links: ['https://cdn.jsdelivr.net/npm/jquery/']
	        }],
	        slide2: [{
	          comments: ['// load any project hosted on npm'],
	          links: ['https://esm.run/package@version/file']
	        }, {
	          comments: ['// load d3 v7.8.3'],
	          links: ['https://esm.run/d3@7.8.3']
	        }, {
	          comments: ['// use a version range instead of a specific version'],
	          links: ['https://esm.run/d3@7.8', 'https://esm.run/d3@7']
	        }, {
	          comments: ['// omit the version completely to get the latest one', '// you should NOT use this in production'],
	          links: ['https://esm.run/d3']
	        }, {
	          comments: ['// load a non-default file'],
	          links: ['https://esm.run/d3/dist/d3.js']
	        }, {
	          comments: ['// all packages are automatically bundled and minified']
	        }],
	        slide3: [{
	          comments: ['// load any GitHub release, commit, or branch', '// note: we recommend using npm for projects that support it'],
	          links: ['https://cdn.jsdelivr.net/gh/user/repo@version/file']
	        }, {
	          comments: ['// load jQuery v3.6.4'],
	          links: ['https://cdn.jsdelivr.net/gh/jquery/jquery@3.6.4/dist/jquery.min.js']
	        }, {
	          comments: ['// use a version range instead of a specific version'],
	          links: ['https://cdn.jsdelivr.net/gh/jquery/jquery@3.6/dist/jquery.min.js', 'https://cdn.jsdelivr.net/gh/jquery/jquery@3/dist/jquery.min.js']
	        }, {
	          comments: ['// omit the version completely to get the latest one', '// you should NOT use this in production'],
	          links: ['https://cdn.jsdelivr.net/gh/jquery/jquery/dist/jquery.min.js']
	        }, {
	          comments: ['// add ".min" to any JS/CSS file to get a minified version', '// if one doesn\'t exist, we\'ll generate it for you'],
	          links: ['https://cdn.jsdelivr.net/gh/jquery/jquery@3.6.4/src/core.min.js']
	        }, {
	          comments: ['// add / at the end to get a directory listing'],
	          links: ['https://cdn.jsdelivr.net/gh/jquery/jquery/']
	        }],
	        slide4: [{
	          comments: ['// load any plugin from the WordPress.org plugins SVN repo'],
	          links: ['https://cdn.jsdelivr.net/wp/plugins/project/tags/version/file']
	        }, {
	          comments: ['// load an exact version'],
	          links: ['https://cdn.jsdelivr.net/wp/plugins/wp-slimstat/tags/4.6.5/wp-slimstat.js']
	        }, {
	          comments: ['// load the latest version', '// you should NOT use this in production'],
	          links: ['https://cdn.jsdelivr.net/wp/plugins/wp-slimstat/trunk/wp-slimstat.js']
	        }, {
	          comments: ['// load any theme from the WordPress.org themes SVN repo'],
	          links: ['https://cdn.jsdelivr.net/wp/themes/project/version/file']
	        }, {
	          comments: ['// load an exact version'],
	          links: ['https://cdn.jsdelivr.net/wp/themes/twenty-eightteen/1.7/assets/js/html5.js']
	        }, {
	          comments: ['// add ".min" to any JS/CSS file to get a minified version', '// if one doesn\'t exist, we\'ll generate it for you'],
	          links: []
	        }]
	      },
	      docsSlideTopHeight: 0
	    };
	  },
	  oninit() {
	    // It's too soon to call the show method here.
	    this.findComponent('c-slider').set('active', docs.indexOf(this.get('activeDocs')) !== -1 ? docs.indexOf(this.get('activeDocs')) : 0);
	    if (!ractive__default["default"].isServer) {
	      this.observe('activeDocs', newValue => {
	        this.findComponent('c-slider').show(docs.indexOf(newValue) !== -1 ? docs.indexOf(newValue) : 0);
	      }, {
	        init: false
	      });

	      // Load network stats.
	      http.fetchNetworkStats().then(data => {
	        this.animate('networkStats', data);
	      });
	    }
	  }
	};
	component$Q.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      t: 13,
	      n: "class",
	      f: "c-landing-top",
	      g: 1
	    }],
	    f: [{
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "content",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "section",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "heading",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "span",
	          f: ["Fast. Reliable. Automated."]
	        }, " ", {
	          t: 7,
	          e: "h1",
	          f: ["A free CDN for open source projects"]
	        }, " ", {
	          t: 7,
	          e: "p",
	          f: ["Optimized for JS and ESM delivery from npm and GitHub. Works with all web formats."]
	        }, " ", {
	          t: 7,
	          e: "span",
	          f: ["Operating since 2012."]
	        }]
	      }, " ", {
	        t: 7,
	        e: "section",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "stats",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          f: [{
	            t: 7,
	            e: "h3",
	            f: [{
	              t: 2,
	              x: {
	                r: ["_", "networkStats.hits.total"],
	                s: "_0.formatHits(_1)"
	              }
	            }, " billion requests"]
	          }, " ", {
	            t: 7,
	            e: "span",
	            f: ["past month"]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          f: [{
	            t: 7,
	            e: "h3",
	            f: ["over ", {
	              t: 2,
	              x: {
	                r: ["_", "networkStats.bandwidth.total"],
	                s: "_0.formatBytesWithUnit(_1,\"TB\")"
	              }
	            }]
	          }, " ", {
	            t: 7,
	            e: "span",
	            f: ["past month"]
	          }]
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "container-fluid container-mw",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "row",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "col-xs-12 col-lg-10 col-lg-push-1",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "section",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "docs",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "docs_tabs",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "docs_tabs_wrapper",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    n: "class",
	                    f: ["docs_tabs_tab ", {
	                      t: 4,
	                      f: ["active-docs-tab"],
	                      n: 51,
	                      r: "activeDocs"
	                    }],
	                    t: 13
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: ["click"],
	                      t: 70,
	                      f: {
	                        r: ["@this"],
	                        s: "[_0.set(\"activeDocs\",\"\")]"
	                      }
	                    }, {
	                      n: "class",
	                      f: [{
	                        t: 4,
	                        f: ["active"],
	                        n: 51,
	                        r: "activeDocs"
	                      }],
	                      t: 13
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "img",
	                      m: [{
	                        n: "width",
	                        f: "50",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "height",
	                        f: "14",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "src",
	                        f: [{
	                          t: 2,
	                          r: "@shared.assetsHost"
	                        }, "/img/landing/new/docs-code/npm.svg"],
	                        t: 13
	                      }]
	                    }]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    n: "class",
	                    f: ["docs_tabs_tab ", {
	                      t: 4,
	                      f: ["active-docs-tab"],
	                      n: 50,
	                      x: {
	                        r: ["activeDocs"],
	                        s: "_0===\"esm\""
	                      }
	                    }],
	                    t: 13
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: ["click"],
	                      t: 70,
	                      f: {
	                        r: ["@this"],
	                        s: "[_0.set(\"activeDocs\",\"esm\")]"
	                      }
	                    }, {
	                      n: "class",
	                      f: [{
	                        t: 4,
	                        f: ["active"],
	                        n: 50,
	                        x: {
	                          r: ["activeDocs"],
	                          s: "_0===\"esm\""
	                        }
	                      }],
	                      t: 13
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "img",
	                      m: [{
	                        n: "width",
	                        f: "44",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "height",
	                        f: "17",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "src",
	                        f: [{
	                          t: 2,
	                          r: "@shared.assetsHost"
	                        }, "/img/landing/new/docs-code/esm.svg"],
	                        t: 13
	                      }]
	                    }]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    n: "class",
	                    f: ["docs_tabs_tab ", {
	                      t: 4,
	                      f: ["active-docs-tab"],
	                      n: 50,
	                      x: {
	                        r: ["activeDocs"],
	                        s: "_0===\"gh\""
	                      }
	                    }],
	                    t: 13
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: ["click"],
	                      t: 70,
	                      f: {
	                        r: ["@this"],
	                        s: "[_0.set(\"activeDocs\",\"gh\")]"
	                      }
	                    }, {
	                      n: "class",
	                      f: [{
	                        t: 4,
	                        f: ["active"],
	                        n: 50,
	                        x: {
	                          r: ["activeDocs"],
	                          s: "_0===\"gh\""
	                        }
	                      }],
	                      t: 13
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "img",
	                      m: [{
	                        n: "width",
	                        f: "67",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "height",
	                        f: "19",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "src",
	                        f: [{
	                          t: 2,
	                          r: "@shared.assetsHost"
	                        }, "/img/landing/new/docs-code/github.svg"],
	                        t: 13
	                      }]
	                    }]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    n: "class",
	                    f: ["docs_tabs_tab ", {
	                      t: 4,
	                      f: ["active-docs-tab"],
	                      n: 50,
	                      x: {
	                        r: ["activeDocs"],
	                        s: "_0===\"wp\""
	                      }
	                    }],
	                    t: 13
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: ["click"],
	                      t: 70,
	                      f: {
	                        r: ["@this"],
	                        s: "[_0.set(\"activeDocs\",\"wp\")]"
	                      }
	                    }, {
	                      n: "class",
	                      f: [{
	                        t: 4,
	                        f: ["active"],
	                        n: 50,
	                        x: {
	                          r: ["activeDocs"],
	                          s: "_0===\"wp\""
	                        }
	                      }],
	                      t: 13
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "img",
	                      m: [{
	                        n: "width",
	                        f: "107",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "height",
	                        f: "22",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "src",
	                        f: [{
	                          t: 2,
	                          r: "@shared.assetsHost"
	                        }, "/img/landing/new/docs-code/wordpress.svg"],
	                        t: 13
	                      }]
	                    }]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "active-tab-line",
	                    g: 1
	                  }, {
	                    n: "style",
	                    f: ["left: ", {
	                      t: 2,
	                      r: "activeDocsLineLeft"
	                    }, "%"],
	                    t: 13
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "dropdown",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "button",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "dropdown-toggle",
	                    g: 1
	                  }, {
	                    n: "type",
	                    f: "button",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "id",
	                    f: "cdn-dropdown",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "data-toggle",
	                    f: "dropdown",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "aria-haspopup",
	                    f: "true",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "aria-expanded",
	                    f: "true",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "div",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "selected",
	                      g: 1
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "img",
	                      m: [{
	                        n: "src",
	                        f: [{
	                          t: 2,
	                          r: "@shared.assetsHost"
	                        }, "/img/landing/new/docs-code/", {
	                          t: 2,
	                          rx: {
	                            r: "cdnsList",
	                            m: [{
	                              t: 30,
	                              n: "activeDocsIndex"
	                            }, "image"]
	                          }
	                        }],
	                        t: 13
	                      }]
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "width",
	                      f: "20",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "20",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/icons/chevron-down.white.svg"],
	                      t: 13
	                    }, {
	                      n: "loading",
	                      f: "lazy",
	                      t: 13,
	                      g: 1
	                    }]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "ul",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "dropdown-menu",
	                    g: 1
	                  }, {
	                    n: "aria-labelledby",
	                    f: "cdn-dropdown",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: [{
	                    t: 4,
	                    f: [{
	                      t: 4,
	                      f: [{
	                        t: 7,
	                        e: "li",
	                        f: [{
	                          t: 7,
	                          e: "a",
	                          m: [{
	                            n: ["click"],
	                            t: 70,
	                            f: {
	                              r: ["@this", ".slug"],
	                              s: "[_0.set(\"activeDocs\",_1)]"
	                            }
	                          }],
	                          f: [{
	                            t: 7,
	                            e: "img",
	                            m: [{
	                              n: "src",
	                              f: [{
	                                t: 2,
	                                r: "@shared.assetsHost"
	                              }, "/img/landing/new/docs-code/", {
	                                t: 2,
	                                r: ".image"
	                              }],
	                              t: 13
	                            }]
	                          }]
	                        }]
	                      }],
	                      n: 50,
	                      x: {
	                        r: ["activeDocs", ".slug"],
	                        s: "_0!==_1"
	                      }
	                    }],
	                    n: 52,
	                    r: "~/cdnsList"
	                  }]
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "docs_code",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "c-slider",
	                m: [{
	                  n: "active",
	                  f: [{
	                    t: 2,
	                    r: "activeSlide"
	                  }],
	                  t: 13
	                }, {
	                  n: "direction",
	                  f: "horizontal",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "distance",
	                  f: "400",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "duration",
	                  f: "400",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 4,
	                  f: [{
	                    t: 7,
	                    e: "c-slide",
	                    f: [{
	                      t: 7,
	                      e: "div",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "docs_code_slide",
	                        g: 1
	                      }, {
	                        n: "id",
	                        f: [{
	                          t: 2,
	                          r: "slideIdx"
	                        }],
	                        t: 13
	                      }],
	                      f: [{
	                        t: 4,
	                        f: [{
	                          t: 4,
	                          f: [{
	                            t: 7,
	                            e: "p",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "docs-comment",
	                              g: 1
	                            }],
	                            f: [{
	                              t: 2,
	                              r: "."
	                            }]
	                          }],
	                          n: 52,
	                          r: "./comments"
	                        }, " ", {
	                          t: 4,
	                          f: [{
	                            t: 7,
	                            e: "p",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "docs-link",
	                              g: 1
	                            }],
	                            f: [{
	                              t: 7,
	                              e: "a",
	                              m: [{
	                                n: "target",
	                                f: "_blank",
	                                t: 13,
	                                g: 1
	                              }, {
	                                n: "rel",
	                                f: "noopener noreferrer",
	                                t: 13,
	                                g: 1
	                              }, {
	                                n: "href",
	                                f: [{
	                                  t: 2,
	                                  r: "."
	                                }],
	                                t: 13
	                              }],
	                              f: [{
	                                t: 2,
	                                r: "."
	                              }]
	                            }]
	                          }],
	                          n: 52,
	                          r: "./links"
	                        }, " ", {
	                          t: 4,
	                          f: [{
	                            t: 7,
	                            e: "br"
	                          }],
	                          n: 51,
	                          x: {
	                            r: ["idx", "slideIdx", "slidesData"],
	                            s: "_0===_2[_1].length-1"
	                          }
	                        }],
	                        n: 52,
	                        i: "idx",
	                        r: "."
	                      }]
	                    }]
	                  }],
	                  n: 52,
	                  i: "slideIdx",
	                  r: "slidesData"
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "a",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "btn-docview btn-grey btn-sm",
	                g: 1
	              }, {
	                n: "href",
	                f: "/documentation",
	                t: 13,
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/icons/info_circle.svg"],
	                  t: 13
	                }]
	              }, "Full docs"]
	            }]
	          }, " ", {
	            t: 7,
	            e: "section",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "sponsors",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "span",
	              f: ["jsDelivr operates thanks to our main sponsors:"]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "sponsors-logos",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "sponsors-logos_item",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    n: "target",
	                    f: "_blank",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "rel",
	                    f: "noopener noreferrer",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "href",
	                    f: "https://www.cloudflare.com",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "width",
	                      f: "149",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "50",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/landing/cloudflare.png"],
	                      t: 13
	                    }, {
	                      n: "srcset",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/landing/cloudflare@2x.png 2x"],
	                      t: 13
	                    }, {
	                      n: "title",
	                      f: "Sponsored by Cloudflare",
	                      t: 13,
	                      g: 1
	                    }]
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "sponsors-logos_item",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    n: "target",
	                    f: "_blank",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "rel",
	                    f: "noopener noreferrer",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "href",
	                    f: "https://www.fastly.com",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "width",
	                      f: "116",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "50",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/landing/fastly.png"],
	                      t: 13
	                    }, {
	                      n: "srcset",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/landing/fastly@2x.png 2x"],
	                      t: 13
	                    }, {
	                      n: "title",
	                      f: "Sponsored by Fastly",
	                      t: 13,
	                      g: 1
	                    }]
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "sponsors-logos_item",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    n: "target",
	                    f: "_blank",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "rel",
	                    f: "noopener noreferrer",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "href",
	                    f: "https://gcore.com/",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "width",
	                      f: "409",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "116",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/landing/new/gcorelabs.svg"],
	                      t: 13
	                    }, {
	                      n: "title",
	                      f: "Sponsored by G-Core Labs",
	                      t: 13,
	                      g: 1
	                    }]
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "sponsors-logos_item",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    n: "target",
	                    f: "_blank",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "rel",
	                    f: "noopener noreferrer",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "href",
	                    f: "https://www.ibm.com/products/ns1-connect",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "width",
	                      f: "125",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "50",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/landing/ibm.svg"],
	                      t: 13
	                    }, {
	                      n: "title",
	                      f: "Sponsored by IBM NS1 Connect",
	                      t: 13,
	                      g: 1
	                    }]
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "sponsors-logos_item",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    n: "target",
	                    f: "_blank",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "rel",
	                    f: "noopener noreferrer",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "href",
	                    f: "https://render.com/",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "width",
	                      f: "262",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "50",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/sponsors/render-black.svg"],
	                      t: 13
	                    }, {
	                      n: "title",
	                      f: "Sponsored by render.com",
	                      t: 13,
	                      g: 1
	                    }]
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "sponsors-logos_item",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    n: "target",
	                    f: "_blank",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "rel",
	                    f: "noopener noreferrer",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "href",
	                    f: "https://bunny.net",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "width",
	                      f: "172",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "50",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/landing/bunny.png"],
	                      t: 13
	                    }, {
	                      n: "srcset",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/landing/bunny@2x.png 2x"],
	                      t: 13
	                    }, {
	                      n: "title",
	                      f: "Sponsored by bunny.net",
	                      t: 13,
	                      g: 1
	                    }]
	                  }]
	                }]
	              }]
	            }]
	          }]
	        }]
	      }]
	    }]
	  }],
	  e: {
	    "_0.formatHits(_1)": function (_0, _1) {
	      return _0.formatHits(_1);
	    },
	    "_0.formatBytesWithUnit(_1,\"TB\")": function (_0, _1) {
	      return _0.formatBytesWithUnit(_1, "TB");
	    },
	    "[_0.set(\"activeDocs\",\"\")]": function (_0) {
	      return [_0.set("activeDocs", "")];
	    },
	    "_0===\"esm\"": function (_0) {
	      return _0 === "esm";
	    },
	    "[_0.set(\"activeDocs\",\"esm\")]": function (_0) {
	      return [_0.set("activeDocs", "esm")];
	    },
	    "_0===\"gh\"": function (_0) {
	      return _0 === "gh";
	    },
	    "[_0.set(\"activeDocs\",\"gh\")]": function (_0) {
	      return [_0.set("activeDocs", "gh")];
	    },
	    "_0===\"wp\"": function (_0) {
	      return _0 === "wp";
	    },
	    "[_0.set(\"activeDocs\",\"wp\")]": function (_0) {
	      return [_0.set("activeDocs", "wp")];
	    },
	    "[_0.set(\"activeDocs\",_1)]": function (_0, _1) {
	      return [_0.set("activeDocs", _1)];
	    },
	    "_0!==_1": function (_0, _1) {
	      return _0 !== _1;
	    },
	    "_0===_2[_1].length-1": function (_0, _1, _2) {
	      return _0 === _2[_1].length - 1;
	    }
	  }
	};
	component$Q.exports.components = {
	  "c-slide": slide,
	  "c-slider": slider
	};
	var landingTop = ractive__default["default"].extend(component$Q.exports);

	var component$P = {
	  exports: {}
	};
	component$P.exports = {
	  data() {
	    return {
	      _,
	      bandwidthUnit: '',
	      hitsTotal: 0,
	      bandwidthTotal: 0
	    };
	  },
	  oninit() {
	    if (!ractive__default["default"].isServer) {
	      this.observe('apiName', apiName => {
	        let period = this.get('period') || 'month';
	        let bandwidthUnit = this.get('bandwidthUnit');
	        http.fetchCdnOssStats(apiName, period).then(({
	          hits,
	          bandwidth
	        }) => {
	          if (hits.total >= 0) {
	            this.animate('hitsTotal', hits.total, {
	              duration: 1000
	            });
	          }
	          if (bandwidth.total >= 0) {
	            if (!bandwidthUnit) {
	              bandwidthUnit = _.findUnitFromNumber(bandwidth.total);
	            }
	            this.set('bandwidthUnitInternal', bandwidthUnit);
	            this.animate('bandwidthTotal', _.convertBytesToUnits(bandwidth.total, bandwidthUnit), {
	              duration: 1000
	            });
	          }
	        });
	      });
	    }
	  },
	  get2xPngSrc(imgSrc) {
	    return imgSrc.replace('.png', '@2x.png 2x');
	  }
	};
	component$P.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      t: 13,
	      n: "class",
	      f: "c-proxy-data-card endpoints_list_wrapper_item",
	      g: 1
	    }],
	    f: [{
	      t: 7,
	      e: "a",
	      m: [{
	        n: "href",
	        f: [{
	          t: 2,
	          r: "jsDelivrLink"
	        }],
	        t: 13
	      }],
	      f: [{
	        t: 4,
	        f: [{
	          t: 7,
	          e: "img",
	          m: [{
	            n: "width",
	            f: [{
	              t: 2,
	              r: "imgWidth"
	            }],
	            t: 13
	          }, {
	            n: "height",
	            f: [{
	              t: 2,
	              r: "imgHeight"
	            }],
	            t: 13
	          }, {
	            n: "src",
	            f: [{
	              t: 2,
	              r: "@shared.assetsHost"
	            }, {
	              t: 2,
	              r: "imgSrc"
	            }],
	            t: 13
	          }, {
	            n: "loading",
	            f: "lazy",
	            t: 13,
	            g: 1
	          }]
	        }],
	        n: 50,
	        x: {
	          r: ["imgSrc"],
	          s: "_0.endsWith(\".svg\")"
	        }
	      }, {
	        t: 4,
	        f: [{
	          t: 7,
	          e: "img",
	          m: [{
	            n: "width",
	            f: [{
	              t: 2,
	              r: "imgWidth"
	            }],
	            t: 13
	          }, {
	            n: "height",
	            f: [{
	              t: 2,
	              r: "imgHeight"
	            }],
	            t: 13
	          }, {
	            n: "src",
	            f: [{
	              t: 2,
	              r: "@shared.assetsHost"
	            }, {
	              t: 2,
	              r: "imgSrc"
	            }],
	            t: 13
	          }, {
	            n: "srcset",
	            f: [{
	              t: 2,
	              r: "@shared.assetsHost"
	            }, {
	              t: 2,
	              x: {
	                r: ["@this", "imgSrc"],
	                s: "_0.get2xPngSrc(_1)"
	              }
	            }],
	            t: 13
	          }, {
	            n: "loading",
	            f: "lazy",
	            t: 13,
	            g: 1
	          }]
	        }],
	        n: 51,
	        l: 1
	      }]
	    }, " ", {
	      t: 7,
	      e: "p",
	      f: [{
	        t: 2,
	        x: {
	          r: ["_", "hitsTotal"],
	          s: "_0.formatNumber(_1)"
	        }
	      }]
	    }, " ", {
	      t: 7,
	      e: "span",
	      f: ["Requests past ", {
	        t: 2,
	        r: "period"
	      }]
	    }, " ", {
	      t: 7,
	      e: "p",
	      f: [{
	        t: 2,
	        x: {
	          r: ["_", "bandwidthTotal"],
	          s: "_0.formatNumber(_1)"
	        }
	      }, " ", {
	        t: 2,
	        r: "bandwidthUnitInternal"
	      }]
	    }, " ", {
	      t: 7,
	      e: "span",
	      f: ["Bandwidth past ", {
	        t: 2,
	        r: "period"
	      }]
	    }]
	  }],
	  e: {
	    "_0.endsWith(\".svg\")": function (_0) {
	      return _0.endsWith(".svg");
	    },
	    "_0.get2xPngSrc(_1)": function (_0, _1) {
	      return _0.get2xPngSrc(_1);
	    },
	    "_0.formatNumber(_1)": function (_0, _1) {
	      return _0.formatNumber(_1);
	    }
	  }
	};
	var proxyDataCard = ractive__default["default"].extend(component$P.exports);

	var someWithoutClosingOnEarlyError = iteratorHelperWithoutClosingOnEarlyError('some', TypeError);

	// `Iterator.prototype.some` method
	// https://tc39.es/ecma262/#sec-iterator.prototype.some
	_export({
	  target: 'Iterator',
	  proto: true,
	  real: true,
	  forced: someWithoutClosingOnEarlyError
	}, {
	  some: function some(predicate) {
	    anObject(this);
	    try {
	      aCallable(predicate);
	    } catch (error) {
	      iteratorClose(this, 'throw', error);
	    }
	    if (someWithoutClosingOnEarlyError) return functionCall(someWithoutClosingOnEarlyError, this, predicate);
	    var record = getIteratorDirect(this);
	    var counter = 0;
	    return iterate(record, function (value, stop) {
	      if (predicate(value, counter++)) return stop();
	    }, {
	      IS_RECORD: true,
	      INTERRUPTED: true
	    }).stopped;
	  }
	});

	var component$O = {
	  exports: {}
	};
	component$O.exports = {
	  computed: {
	    filteredVersions() {
	      let filterBy = this.get('filterBy');
	      let versions = this.get('versions');
	      let results = versions;
	      if (filterBy) {
	        results = filterBy.toLowerCase().split(' ').reduce((acc, filterPart) => {
	          return acc.filter(item => item === 'separator' || item.toLowerCase().includes(filterPart));
	        }, [...versions]);
	      }

	      // Remove extra separators
	      results = results.reduce((acc, item) => {
	        if (item === 'separator' && (!acc.length || acc[acc.length - 1] === 'separator')) {
	          return acc;
	        }
	        acc.push(item);
	        return acc;
	      }, []);
	      if (results[results.length - 1] === 'separator') {
	        results.pop();
	      }
	      return results;
	    }
	  },
	  data() {
	    return {
	      filterPlaceholder: 'Filter versions',
	      noVersionsMsg: 'No results found',
	      dropdownOpened: false,
	      currSelectedItemIdx: null,
	      currentSelectedClass: 'selected'
	    };
	  },
	  oncomplete() {
	    if (!ractive__default["default"].isServer) {
	      // close dropdown and clear filter on click outside the dropdown el
	      let el = this.find('.version-dropdown');
	      let handleOnClickOutside = event => {
	        let currDropdownOpened = this.get('dropdownOpened');
	        if (currDropdownOpened && !el.contains(event.target)) {
	          this.set('dropdownOpened', false);
	        }
	      };
	      listeners.addManagedListener(this, document, 'click', handleOnClickOutside);
	      this.observe('dropdownOpened', newValue => {
	        let ul = this.find('.version-dropdown_wrapper_list');
	        if (!ul) {
	          return;
	        }
	        if (newValue) {
	          this.set('calculatedListWidth', Math.max(160, ul.getBoundingClientRect().width));
	          this.find('.version-dropdown_wrapper_filter input').focus();
	          this.find('.version-dropdown_wrapper_list_item.selected')?.scrollIntoView?.({
	            block: 'nearest'
	          });
	        } else {
	          this.set('calculatedListWidth', null);
	        }
	      }, {
	        defer: true
	      });
	      this.observe('currSelectedItemIdx', () => {
	        this.find('.version-dropdown_wrapper_list_item.selected')?.scrollIntoView?.({
	          block: 'nearest'
	        });
	      }, {
	        defer: true
	      });
	    }
	  },
	  onKeyDown(e) {
	    let listEl = this.find('.version-dropdown_wrapper_list');
	    if (!listEl) {
	      return;
	    }
	    let selectedItemEl = listEl.querySelector('.version-dropdown_wrapper_list_item.selected');
	    let currSelectedItemIdx = this.get('currSelectedItemIdx');
	    let versions = this.get('filteredVersions');
	    let currentlySelectedVersion = this.get('version');

	    // start nav from the selected value position
	    currSelectedItemIdx === null && versions.some((v, vIdx) => {
	      if (v === currentlySelectedVersion) {
	        currSelectedItemIdx = vIdx;
	        return true;
	      }
	      return false;
	    });
	    if (e.key === 'ArrowDown') {
	      currSelectedItemIdx = currSelectedItemIdx === null ? 0 : currSelectedItemIdx + 1 > versions.length - 1 ? versions.length - 1 : currSelectedItemIdx + 1;
	      if (versions[currSelectedItemIdx] === 'separator') {
	        currSelectedItemIdx++;
	      }
	      this.set('currSelectedItemIdx', currSelectedItemIdx);
	    } else if (e.key === 'ArrowUp') {
	      currSelectedItemIdx = currSelectedItemIdx === null ? 0 : currSelectedItemIdx - 1 < 0 ? 0 : currSelectedItemIdx - 1;
	      if (versions[currSelectedItemIdx] === 'separator') {
	        currSelectedItemIdx--;
	      }
	      this.set('currSelectedItemIdx', currSelectedItemIdx);
	    } else if (e.key === 'Enter') {
	      this.selectItem(selectedItemEl.textContent);
	    } else {
	      this.set('currSelectedItemIdx', 0);
	    }
	  },
	  toggleDropdown() {
	    this.set('dropdownOpened', !this.get('dropdownOpened'));
	    this.set('currSelectedItemIdx', null);
	  },
	  selectItem(version) {
	    this.toggleDropdown();
	    this.set('version', version);
	  }
	};
	component$O.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      t: 13,
	      n: "class",
	      f: "version-dropdown",
	      g: 1
	    }],
	    f: [{
	      t: 4,
	      f: [{
	        t: 7,
	        e: "button",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "version-dropdown_selected",
	          g: 1
	        }, {
	          n: ["click"],
	          t: 70,
	          f: {
	            r: ["@this"],
	            s: "[_0.toggleDropdown()]"
	          }
	        }],
	        f: [{
	          t: 7,
	          e: "a",
	          f: [{
	            t: 2,
	            r: "version"
	          }]
	        }, " ", {
	          t: 7,
	          e: "img",
	          m: [{
	            n: "width",
	            f: "20",
	            t: 13,
	            g: 1
	          }, {
	            n: "height",
	            f: "20",
	            t: 13,
	            g: 1
	          }, {
	            n: "src",
	            f: [{
	              t: 2,
	              r: "@shared.assetsHost"
	            }, "/img/icons/", {
	              t: 4,
	              f: ["chevron-down.white"],
	              n: 50,
	              r: "useCustomIconStyles"
	            }, {
	              t: 4,
	              f: ["chevron-down"],
	              n: 51,
	              l: 1
	            }, ".svg"],
	            t: 13
	          }, {
	            n: "loading",
	            f: "lazy",
	            t: 13,
	            g: 1
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          n: "class",
	          f: ["version-dropdown_wrapper ", {
	            t: 4,
	            f: ["opened"],
	            n: 50,
	            r: "dropdownOpened"
	          }],
	          t: 13
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "version-dropdown_wrapper_filter",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "img",
	            m: [{
	              n: "width",
	              f: "20",
	              t: 13,
	              g: 1
	            }, {
	              n: "height",
	              f: "20",
	              t: 13,
	              g: 1
	            }, {
	              n: "src",
	              f: [{
	                t: 2,
	                r: "@shared.assetsHost"
	              }, "/img/icons/magnifier.svg"],
	              t: 13
	            }]
	          }, " ", {
	            t: 7,
	            e: "input",
	            m: [{
	              n: "placeholder",
	              f: [{
	                t: 2,
	                r: "filterPlaceholder"
	              }],
	              t: 13
	            }, {
	              n: "value",
	              f: [{
	                t: 2,
	                r: "filterBy"
	              }],
	              t: 13
	            }, {
	              n: ["keydown"],
	              t: 70,
	              f: {
	                r: ["@this", "@event"],
	                s: "[_0.onKeyDown(_1)]"
	              }
	            }]
	          }]
	        }, " ", {
	          t: 4,
	          f: [{
	            t: 7,
	            e: "ul",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "version-dropdown_wrapper_list",
	              g: 1
	            }, {
	              n: "style",
	              f: [{
	                t: 4,
	                f: ["min-width: ", {
	                  t: 2,
	                  r: "calculatedListWidth"
	                }, "px;"],
	                n: 50,
	                r: "calculatedListWidth"
	              }],
	              t: 13
	            }],
	            f: [{
	              t: 4,
	              f: [{
	                t: 4,
	                f: [{
	                  t: 7,
	                  e: "li",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "version-dropdown_wrapper_list_separator",
	                    g: 1
	                  }]
	                }],
	                n: 50,
	                x: {
	                  r: ["."],
	                  s: "_0===\"separator\""
	                }
	              }, {
	                t: 4,
	                f: [{
	                  t: 7,
	                  e: "li",
	                  m: [{
	                    n: "class",
	                    f: ["version-dropdown_wrapper_list_item ", {
	                      t: 4,
	                      f: [{
	                        t: 2,
	                        r: "currentSelectedClass"
	                      }],
	                      n: 50,
	                      x: {
	                        r: ["currSelectedItemIdx", "currentSelectedClass", ".", "version"],
	                        s: "_0===null&&_1&&_2===_3"
	                      }
	                    }, " ", {
	                      t: 4,
	                      f: ["selected"],
	                      n: 50,
	                      x: {
	                        r: ["currSelectedItemIdx", "itemIndex"],
	                        s: "_0==_1"
	                      }
	                    }],
	                    t: 13
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: ["click"],
	                      t: 70,
	                      f: {
	                        r: ["@this", "."],
	                        s: "[_0.selectItem(_1)]"
	                      }
	                    }],
	                    f: [{
	                      t: 2,
	                      r: "."
	                    }]
	                  }]
	                }],
	                n: 51,
	                l: 1
	              }],
	              n: 52,
	              i: "itemIndex",
	              r: "filteredVersions"
	            }]
	          }],
	          n: 50,
	          r: "filteredVersions.length"
	        }, {
	          t: 4,
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "version-dropdown_wrapper_no-versions-found",
	              g: 1
	            }],
	            f: [{
	              t: 2,
	              r: "noVersionsMsg"
	            }]
	          }],
	          n: 51,
	          l: 1
	        }]
	      }],
	      n: 50,
	      x: {
	        r: ["versions.length"],
	        s: "_0>1"
	      }
	    }, {
	      t: 4,
	      f: [{
	        t: 7,
	        e: "span",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "version-dropdown_selected",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "a",
	          f: [{
	            t: 2,
	            r: "version"
	          }]
	        }]
	      }],
	      n: 51,
	      l: 1
	    }]
	  }],
	  e: {
	    "[_0.toggleDropdown()]": function (_0) {
	      return [_0.toggleDropdown()];
	    },
	    "[_0.onKeyDown(_1)]": function (_0, _1) {
	      return [_0.onKeyDown(_1)];
	    },
	    "_0===\"separator\"": function (_0) {
	      return _0 === "separator";
	    },
	    "_0===null&&_1&&_2===_3": function (_0, _1, _2, _3) {
	      return _0 === null && _1 && _2 === _3;
	    },
	    "_0==_1": function (_0, _1) {
	      return _0 == _1;
	    },
	    "[_0.selectItem(_1)]": function (_0, _1) {
	      return [_0.selectItem(_1)];
	    },
	    "_0>1": function (_0) {
	      return _0 > 1;
	    }
	  }
	};
	var versionDropdown = ractive__default["default"].extend(component$O.exports);

	var component$N = {
	  exports: {}
	};
	component$N.exports = {
	  data() {
	    return {
	      desc: true,
	      formatValue: _.formatNumber,
	      valueKey: 'hits'
	    };
	  },
	  decorators: {
	    tooltip
	  }
	};
	component$N.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      t: 13,
	      n: "class",
	      f: "c-stats-table",
	      g: 1
	    }],
	    f: [{
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "flex stats-table-table",
	        g: 1
	      }],
	      f: [{
	        t: 4,
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "item state-title",
	            g: 1
	          }],
	          f: [{
	            t: 2,
	            r: "title"
	          }]
	        }],
	        n: 50,
	        r: "title"
	      }, " ", {
	        t: 4,
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "item",
	            g: 1
	          }],
	          f: [{
	            t: 4,
	            f: [{
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "index",
	                g: 1
	              }],
	              f: [{
	                t: 2,
	                x: {
	                  r: ["i"],
	                  s: "_0+1"
	                }
	              }]
	            }],
	            n: 50,
	            r: "rowIndexes"
	          }, " ", {
	            t: 8,
	            r: "column1"
	          }, " ", {
	            t: 7,
	            e: "span",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "hits text-table-number",
	              g: 1
	            }],
	            f: [{
	              t: 2,
	              x: {
	                r: ["formatValue", "valueKey", "."],
	                s: "_0(_2[_1])"
	              }
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "table-chart-lg",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "table-chart",
	                g: 1
	              }, {
	                n: "style-width",
	                f: [{
	                  t: 2,
	                  x: {
	                    r: [".", "valueKey", "desc", "data.length", "data"],
	                    s: "_0[_1]/_4[_2?0:_3-1][_1]*100"
	                  }
	                }, "%"],
	                t: 13
	              }]
	            }]
	          }]
	        }],
	        n: 52,
	        i: "i",
	        r: "~/data"
	      }]
	    }]
	  }],
	  e: {
	    "_0+1": function (_0) {
	      return _0 + 1;
	    },
	    "_0(_2[_1])": function (_0, _1, _2) {
	      return _0(_2[_1]);
	    },
	    "_0[_1]/_4[_2?0:_3-1][_1]*100": function (_0, _1, _2, _3, _4) {
	      return _0[_1] / _4[_2 ? 0 : _3 - 1][_1] * 100;
	    }
	  }
	};
	component$N.exports.components = {
	  "c-version-dropdown": versionDropdown
	};
	var statsTable = ractive__default["default"].extend(component$N.exports);

	var component$M = {
	  exports: {}
	};
	component$M.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "section",
	    m: [{
	      t: 13,
	      n: "class",
	      f: "c-new-infographic-banner infographic",
	      g: 1
	    }],
	    f: [{
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "infographic_wrapper",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "infographic_content",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "h3",
	          f: ["Learn more about", {
	            t: 7,
	            e: "br"
	          }, " the infrastructure that", {
	            t: 7,
	            e: "br"
	          }, " powers ", {
	            t: 7,
	            e: "strong",
	            f: ["jsDelivr"]
	          }]
	        }, " ", {
	          t: 7,
	          e: "a",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "btn-primary router-ignore",
	            g: 1
	          }, {
	            n: "target",
	            f: "_blank",
	            t: 13,
	            g: 1
	          }, {
	            n: "href",
	            f: "/network/infographic",
	            t: 13,
	            g: 1
	          }],
	          f: ["Check our infographic"]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "infographic_image-desktop hidden",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "img",
	          m: [{
	            n: "width",
	            f: "624",
	            t: 13,
	            g: 1
	          }, {
	            n: "height",
	            f: "338",
	            t: 13,
	            g: 1
	          }, {
	            n: "src",
	            f: [{
	              t: 2,
	              r: "@shared.assetsHost"
	            }, "/img/landing/new/infographics.png"],
	            t: 13
	          }, {
	            n: "srcset",
	            f: [{
	              t: 2,
	              r: "@shared.assetsHost"
	            }, "/img/landing/new/infographics@2x.png 2x"],
	            t: 13
	          }, {
	            n: "loading",
	            f: "lazy",
	            t: 13,
	            g: 1
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "infographic_image hidden",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "img",
	          m: [{
	            n: "width",
	            f: "280",
	            t: 13,
	            g: 1
	          }, {
	            n: "height",
	            f: "205",
	            t: 13,
	            g: 1
	          }, {
	            n: "src",
	            f: [{
	              t: 2,
	              r: "@shared.assetsHost"
	            }, "/img/landing/new/infographics.mobile.png"],
	            t: 13
	          }, {
	            n: "srcset",
	            f: [{
	              t: 2,
	              r: "@shared.assetsHost"
	            }, "/img/landing/new/infographics.mobile@2x.png 2x"],
	            t: 13
	          }, {
	            n: "loading",
	            f: "lazy",
	            t: 13,
	            g: 1
	          }]
	        }]
	      }]
	    }]
	  }]
	};
	var newInfographicBanner = ractive__default["default"].extend(component$M.exports);

	var cocoa = {
		title: "CocoaPods",
		apiCdnName: "cocoa",
		descr: "CocoaPods is a dependency manager for Swift and Objective-C Cocoa projects. It has over 87 thousand libraries and is used in over 3 million apps. CocoaPods can help you scale your projects elegantly.",
		link: "https://www.cocoapods.org",
		docsLink: "https://github.com/CocoaPods/cdn.cocoapods.org",
		jsDelivrLink: "/oss-cdn/cocoa",
		imgSrc: "/img/proxy/cocoa.svg",
		imgWidth: "202",
		imgHeight: "46"
	};
	var ghost = {
		title: "Ghost",
		apiCdnName: "ghost",
		descr: "Ghost is a powerful app for new-media creators to publish, share, and grow a business around their content. It comes with modern tools to build a website, publish content, send newsletters & offer paid subscriptions to members.",
		link: "https://ghost.org",
		docsLink: "https://ghost.org/docs/install",
		jsDelivrLink: "/oss-cdn/ghost",
		imgSrc: "/img/proxy/ghost.png",
		imgWidth: "152",
		imgHeight: "56"
	};
	var pyodide = {
		title: "Pyodide",
		apiCdnName: "pyodide",
		descr: "Pyodide brings the Python 3.9 runtime to the browser via WebAssembly, thanks to Emscripten. It builds the Python scientific stack including NumPy, Pandas, Matplotlib, SciPy, and scikit-learn. Over 75 packages are currently available. In addition, it’s possible to install pure Python wheels from PyPI.",
		link: "https://pyodide.org",
		docsLink: "https://pyodide.org/en/stable/usage/index.html",
		jsDelivrLink: "/oss-cdn/pyodide",
		imgSrc: "/img/proxy/pyodide.svg",
		imgWidth: "170",
		imgHeight: "56"
	};
	var atlas = {
		title: "AtlasOS",
		apiCdnName: "atlas",
		descr: "A transparent and lightweight modification to Windows, designed to optimize performance, privacy, and usability.",
		link: "https://atlasos.net",
		docsLink: "https://docs.atlasos.net",
		jsDelivrLink: "/oss-cdn/atlas",
		imgSrc: "/img/proxy/atlas.svg",
		imgWidth: "162",
		imgHeight: "34"
	};
	var musescore = {
		title: "MuseScore",
		apiCdnName: "musescore",
		descr: "Create, play and print beautiful sheet music. The world’s most popular notation software.",
		link: "https://musescore.org",
		docsLink: "https://musescore.org",
		jsDelivrLink: "/oss-cdn/musescore",
		imgSrc: "/img/proxy/musescore.svg",
		imgWidth: "213",
		imgHeight: "48"
	};
	var fontsource = {
		title: "Fontsource",
		apiCdnName: "fontsource",
		descr: "Fontsource is a collection of open-source fonts.",
		link: "https://fontsource.org",
		docsLink: "https://fontsource.org/docs/getting-started/cdn",
		jsDelivrLink: "/oss-cdn/fontsource",
		imgSrc: "/img/proxy/fontsource.svg",
		imgWidth: "239",
		imgHeight: "46"
	};
	var yocto = {
		title: "Yocto",
		apiCdnName: "yocto-sstate",
		descr: "The Yocto Project is an open-source collaboration project that helps developers create custom Linux-based systems regardless of the hardware architecture. The project provides a flexible set of tools and a space where embedded developers worldwide can share technologies, software stacks, configurations, and best practices that can be used to create tailored Linux images for embedded and IOT devices.",
		link: "https://www.yoctoproject.org",
		docsLink: "https://docs.yoctoproject.org",
		jsDelivrLink: "/oss-cdn/yocto",
		imgSrc: "/img/proxy/yocto.svg",
		imgWidth: "145",
		imgHeight: "56"
	};
	var ossCdnProjects$1 = {
		cocoa: cocoa,
		ghost: ghost,
		pyodide: pyodide,
		atlas: atlas,
		musescore: musescore,
		fontsource: fontsource,
		yocto: yocto
	};

	var ossCdnProjects$2 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		cocoa: cocoa,
		ghost: ghost,
		pyodide: pyodide,
		atlas: atlas,
		musescore: musescore,
		fontsource: fontsource,
		yocto: yocto,
		'default': ossCdnProjects$1
	});

	var ossCdnProjects = getCjsExportFromNamespace(ossCdnProjects$2);

	var component$L = {
	  exports: {}
	};
	const codeTabs = ['entrypoints', 'versions', 'files'];
	const FIREWORKS_ANIMATION_DURATION = 4000;
	function createLineNums(heightSelector, lineHeightSelector, targetSelector) {
	  let preOffsetHeight = document.querySelector(heightSelector).offsetHeight;
	  let lineHeightEl = document.querySelector(lineHeightSelector);
	  let lineHeight = Number(document.defaultView.getComputedStyle(lineHeightEl, null).getPropertyValue('line-height').replace('px', ''));
	  let countedLines = Math.ceil(preOffsetHeight / lineHeight);
	  let countersBlock = document.querySelector(targetSelector);
	  for (let i = 1; i <= countedLines; i++) {
	    let span = document.createElement('span');
	    span.textContent = i;
	    countersBlock.append(span);
	  }
	}
	component$L.exports = {
	  data() {
	    return {
	      _,
	      activeTab: 'entrypoints',
	      codeList: ['entrypoints', 'versions', 'files'],
	      // external website logos
	      exWebLogo: [{
	        image: 'cnn.svg'
	      }, {
	        image: 'ikea.svg'
	      }, {
	        image: 'nvidia.svg'
	      }, {
	        image: 'nintendo.svg'
	      }, {
	        image: 'ubisoft.svg'
	      }, {
	        image: 'harvard.svg'
	      }, {
	        image: 'nba.svg'
	      }, {
	        image: 'coinmarketcap.svg'
	      }, {
	        image: 'mailonline.svg'
	      }, {
	        image: 'roblox.svg'
	      }, {
	        image: 'urban.svg'
	      }, {
	        image: 'rotten-tomatoes.svg'
	      }, {
	        image: 'olx.svg'
	      }, {
	        image: 'der-spiegel.svg'
	      }, {
	        image: 'upwork.svg'
	      }, {
	        image: 'govgr.svg'
	      }, {
	        image: 'tawk.to.png'
	      }, {
	        image: 'foot-locker.svg'
	      }, {
	        image: 'euro-vision.svg'
	      }],
	      showMoreExLogo: false,
	      esmDemoLoadTime: null,
	      esmDemoRunning: false,
	      fireworks: null,
	      netStatsAnimData: {
	        reqMultiplier: 0,
	        bandwMultiplier: 0
	      },
	      ossCdnProjects
	    };
	  },
	  oninit() {
	    this.findComponent('c-slider').set('active', codeTabs.indexOf(this.get('activeTab')) !== -1 ? codeTabs.indexOf(this.get('activeTab')) : 0);
	    if (!ractive__default["default"].isServer) {
	      this.observe('activeTab', newValue => {
	        document.querySelector('.code-slider .c-slider').scrollTop = 0;
	        this.findComponent('c-slider').show(codeTabs.indexOf(newValue) !== -1 ? codeTabs.indexOf(newValue) : 0);
	        let activeTabLink = document.querySelectorAll('.code-tabs a')[this.get('activeSlide') || 0];
	        this.set('activeTabLineData', [activeTabLink.offsetLeft, activeTabLink.clientWidth]);
	        setTimeout(() => {
	          createLineNums(`.api_code .${newValue} .code-wrapper`, `.api_code .${newValue} .code-wrapper div`, `.api_code .${newValue} .code-lines-counter`);
	        }, 100);
	      }, {
	        init: false
	      });

	      // Load top packages.
	      http.fetchTopPackages().then(data => {
	        this.set('topPackages', data);
	      });

	      // Load network stats for the previous day
	      http.fetchNetworkStats('month').then(data => {
	        this.set('baseRequestsPerSecond', data.hits.total / 30 / 24 / 60 / 60);
	        this.set('baseBandwidth', data.bandwidth.total / 30 / 24 / 60 / 60 / 1e6);
	      });
	      setInterval(() => {
	        let max = 102;
	        let min = 97;
	        let {
	          reqMultiplier,
	          bandwMultiplier
	        } = this.get('netStatsAnimData');
	        let newReqMultiplier = this.getNewMultiplier(min, max, reqMultiplier);
	        let newBandwMultiplier = this.getNewMultiplier(min, max, bandwMultiplier);
	        this.set('netStatsAnimData', {
	          reqMultiplier: newReqMultiplier,
	          bandwMultiplier: newBandwMultiplier
	        });
	      }, 1400);
	      this.observe('netStatsAnimData', ({
	        reqMultiplier,
	        bandwMultiplier
	      }) => {
	        let animationConfig = {
	          easing: x => 1 - Math.sqrt(1 - Math.pow(x, 2))
	        };
	        let netStatsToAnimate = {
	          requestsPerSecond: reqMultiplier * this.get('baseRequestsPerSecond') || 0,
	          bandwidth: bandwMultiplier * this.get('baseBandwidth') * 8 || 0
	        };
	        this.animate('netStatsToAnimate', netStatsToAnimate, animationConfig);
	      }, {
	        init: false
	      });
	    }
	  },
	  oncomplete() {
	    if (!ractive__default["default"].isServer) {
	      createLineNums('.js-modules_code pre', '.js-modules_code pre span', '.js-modules_code_wrapper_counters');
	      createLineNums('.api_code .entrypoints .code-wrapper', '.api_code .entrypoints .code-wrapper div', '.api_code .entrypoints .code-lines-counter');
	    }
	  },
	  getRandomMultiplier(min, max) {
	    return (Math.random() * (max - min + 1) + min) / 100;
	  },
	  getNewMultiplier(min, max, prevMultiplier) {
	    let multiplier = this.getRandomMultiplier(min, max);
	    if (multiplier === prevMultiplier) {
	      return this.getNewMultiplier(min, max, multiplier);
	    }
	    return multiplier;
	  },
	  runEsmDemo(e) {
	    performance.clearResourceTimings();
	    let src = 'https://cdn.jsdelivr.net/npm/fireworks-js@2.10.1/+esm';
	    import(src).then(({
	      Fireworks
	    }) => {
	      let entries = performance.getEntriesByType('resource').filter(resource => resource.name === src);
	      this.set('esmDemoLoadTime', entries.length && entries.at(-1).transferSize ? Math.round(entries.at(-1).duration) : 0);
	      let container = document.querySelector('.fireworks');
	      container.style.zIndex = '1000';
	      let fireworks = new Fireworks(container, {
	        acceleration: 1.1,
	        delay: {
	          min: 10,
	          max: 20
	        }
	      });
	      fireworks.start();
	      setTimeout(() => {
	        e.target.blur();
	        fireworks.waitStop();
	        container.style.zIndex = '-1';
	        container.innerHTML = '';
	      }, FIREWORKS_ANIMATION_DURATION);
	    });
	  }
	};
	component$L.exports.template = {
	  v: 4,
	  t: [{
	    t: 9,
	    c: " Commenting this out while we switch to another API "
	  }, {
	    t: 9,
	    c: " <link rel=\"ractive\" href=\"./rum.html\" name=\"c-rum\"> "
	  }, " ", {
	    t: 7,
	    e: "div",
	    m: [{
	      t: 13,
	      n: "class",
	      f: "c-landing-bottom",
	      g: 1
	    }],
	    f: [{
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "container-fluid container-mw",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "row",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "col-xs-12 col-lg-10 col-lg-push-1",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "section",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "features wrapper",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "span",
	              f: ["Multi-CDN Global Network"]
	            }, " ", {
	              t: 7,
	              e: "h2",
	              f: ["Built for production"]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "features_features-list",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "href",
	                  f: "/network/infographic",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: "width",
	                    f: "64",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "64",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/landing/new/built-for-prod/1.svg"],
	                    t: 13
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "h6",
	                  f: ["Four CDN", {
	                    t: 7,
	                    e: "br"
	                  }, " & three DNS providers"]
	                }]
	              }, " ", {
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "href",
	                  f: "/network#map",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: "width",
	                    f: "64",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "64",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/landing/new/built-for-prod/2.svg"],
	                    t: 13
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "h6",
	                  f: ["More than 540 points", {
	                    t: 7,
	                    e: "br"
	                  }, " of presence"]
	                }]
	              }, " ", {
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "href",
	                  f: "/network#china",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: "width",
	                    f: "64",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "64",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/landing/new/built-for-prod/3.svg"],
	                    t: 13
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "h6",
	                  f: ["Low latency \"Near China\"", {
	                    t: 7,
	                    e: "br"
	                  }, " network"]
	                }]
	              }, " ", {
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "href",
	                  f: "/documentation#id-multi-cdn",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: "width",
	                    f: "64",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "64",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/landing/new/built-for-prod/4.svg"],
	                    t: 13
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "h6",
	                  f: ["Smart load-balancing", {
	                    t: 7,
	                    e: "br"
	                  }, " and routing"]
	                }]
	              }, " ", {
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "href",
	                  f: "/network#failover",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: "width",
	                    f: "64",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "64",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/landing/new/built-for-prod/5.svg"],
	                    t: 13
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "h6",
	                  f: ["Multi-layer cache", {
	                    t: 7,
	                    e: "br"
	                  }, " and failover"]
	                }]
	              }, " ", {
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "href",
	                  f: "/terms",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: "width",
	                    f: "64",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "64",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/landing/new/built-for-prod/6.svg"],
	                    t: 13
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "h6",
	                  f: ["Formal ToS", {
	                    t: 7,
	                    e: "br"
	                  }, " and Privacy Policy"]
	                }]
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "section",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "network-data",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "svg",
	              m: [{
	                n: "width",
	                f: "908",
	                t: 13,
	                g: 1
	              }, {
	                n: "height",
	                f: "428",
	                t: 13,
	                g: 1
	              }, {
	                n: "viewBox",
	                f: "0 0 908 428",
	                t: 13,
	                g: 1
	              }, {
	                n: "fill",
	                f: "none",
	                t: 13,
	                g: 1
	              }, {
	                n: "xmlns",
	                f: "http://www.w3.org/2000/svg",
	                t: 13,
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "g",
	                m: [{
	                  n: "transform",
	                  f: "translate(64, 144)",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "circle",
	                  m: [{
	                    n: "r",
	                    f: "2",
	                    t: 13,
	                    g: 1
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "circle",
	                  m: [{
	                    n: "r",
	                    f: "2",
	                    t: 13,
	                    g: 1
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "g",
	                m: [{
	                  n: "transform",
	                  f: "translate(136, 120)",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "circle",
	                  m: [{
	                    n: "r",
	                    f: "2",
	                    t: 13,
	                    g: 1
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "circle",
	                  m: [{
	                    n: "r",
	                    f: "2",
	                    t: 13,
	                    g: 1
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "g",
	                m: [{
	                  n: "transform",
	                  f: "translate(176, 152)",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "circle",
	                  m: [{
	                    n: "r",
	                    f: "2",
	                    t: 13,
	                    g: 1
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "circle",
	                  m: [{
	                    n: "r",
	                    f: "2",
	                    t: 13,
	                    g: 1
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "g",
	                m: [{
	                  n: "transform",
	                  f: "translate(224, 376)",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "circle",
	                  m: [{
	                    n: "r",
	                    f: "2",
	                    t: 13,
	                    g: 1
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "circle",
	                  m: [{
	                    n: "r",
	                    f: "2",
	                    t: 13,
	                    g: 1
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "g",
	                m: [{
	                  n: "transform",
	                  f: "translate(384, 128)",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "circle",
	                  m: [{
	                    n: "r",
	                    f: "2",
	                    t: 13,
	                    g: 1
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "circle",
	                  m: [{
	                    n: "r",
	                    f: "2",
	                    t: 13,
	                    g: 1
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "g",
	                m: [{
	                  n: "transform",
	                  f: "translate(400, 136)",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "circle",
	                  m: [{
	                    n: "r",
	                    f: "2",
	                    t: 13,
	                    g: 1
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "circle",
	                  m: [{
	                    n: "r",
	                    f: "2",
	                    t: 13,
	                    g: 1
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "g",
	                m: [{
	                  n: "transform",
	                  f: "translate(416, 96)",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "circle",
	                  m: [{
	                    n: "r",
	                    f: "2",
	                    t: 13,
	                    g: 1
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "circle",
	                  m: [{
	                    n: "r",
	                    f: "2",
	                    t: 13,
	                    g: 1
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "g",
	                m: [{
	                  n: "transform",
	                  f: "translate(440, 104)",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "circle",
	                  m: [{
	                    n: "r",
	                    f: "2",
	                    t: 13,
	                    g: 1
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "circle",
	                  m: [{
	                    n: "r",
	                    f: "2",
	                    t: 13,
	                    g: 1
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "g",
	                m: [{
	                  n: "transform",
	                  f: "translate(792, 224)",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "circle",
	                  m: [{
	                    n: "r",
	                    f: "2",
	                    t: 13,
	                    g: 1
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "circle",
	                  m: [{
	                    n: "r",
	                    f: "2",
	                    t: 13,
	                    g: 1
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "g",
	                m: [{
	                  n: "transform",
	                  f: "translate(848, 352)",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "circle",
	                  m: [{
	                    n: "r",
	                    f: "2",
	                    t: 13,
	                    g: 1
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "circle",
	                  m: [{
	                    n: "r",
	                    f: "2",
	                    t: 13,
	                    g: 1
	                  }]
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "wrapper-lg",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "network-data_stats",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "network-data_stats_item",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "width",
	                      f: "80",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "80",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/landing/new/map-icons/1.svg"],
	                      t: 13
	                    }]
	                  }, " ", {
	                    t: 4,
	                    f: [{
	                      t: 7,
	                      e: "div",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "network-data_stats_item_green",
	                        g: 1
	                      }],
	                      f: [{
	                        t: 7,
	                        e: "span",
	                        f: ["1 mil+"]
	                      }, " ", {
	                        t: 7,
	                        e: "span",
	                        f: ["active oss projects served"]
	                      }]
	                    }],
	                    n: 50,
	                    r: "netStatsToAnimate"
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "network-data_stats_item",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "width",
	                      f: "80",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "80",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/landing/new/map-icons/2.svg"],
	                      t: 13
	                    }]
	                  }, " ", {
	                    t: 4,
	                    f: [{
	                      t: 7,
	                      e: "div",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "network-data_stats_item_green",
	                        g: 1
	                      }],
	                      f: [{
	                        t: 7,
	                        e: "span",
	                        f: ["99.46%"]
	                      }, " ", {
	                        t: 7,
	                        e: "span",
	                        f: ["cache hit ratio"]
	                      }]
	                    }],
	                    n: 50,
	                    r: "netStatsToAnimate"
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "network-data_stats_item",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "width",
	                      f: "80",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "80",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/landing/new/map-icons/3.svg"],
	                      t: 13
	                    }]
	                  }, " ", {
	                    t: 4,
	                    f: [{
	                      t: 7,
	                      e: "div",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "network-data_stats_item_regular",
	                        g: 1
	                      }],
	                      f: [{
	                        t: 7,
	                        e: "span",
	                        f: [{
	                          t: 2,
	                          x: {
	                            r: ["_", "netStatsToAnimate.requestsPerSecond"],
	                            s: "_0.formatNumber(_1)"
	                          }
	                        }]
	                      }, " ", {
	                        t: 7,
	                        e: "span",
	                        f: ["requests per second"]
	                      }]
	                    }],
	                    n: 50,
	                    r: "netStatsToAnimate"
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "network-data_stats_item",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "width",
	                      f: "80",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "80",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/landing/new/map-icons/4.svg"],
	                      t: 13
	                    }]
	                  }, " ", {
	                    t: 4,
	                    f: [{
	                      t: 7,
	                      e: "div",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "network-data_stats_item_regular",
	                        g: 1
	                      }],
	                      f: [{
	                        t: 7,
	                        e: "span",
	                        f: [{
	                          t: 2,
	                          x: {
	                            r: ["_", "netStatsToAnimate.bandwidth"],
	                            s: "_0.formatNumber(_1)"
	                          }
	                        }, " Mbps"]
	                      }, " ", {
	                        t: 7,
	                        e: "span",
	                        f: ["bandwidth"]
	                      }]
	                    }],
	                    n: 50,
	                    r: "netStatsToAnimate"
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "btn-link-to",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "btn-arrow",
	                    g: 1
	                  }, {
	                    n: "href",
	                    f: "/network#map",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "span",
	                    f: ["View our network map"]
	                  }, " ", {
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "width",
	                      f: "20",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "20",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/icons/arrow-right.svg"],
	                      t: 13
	                    }]
	                  }]
	                }]
	              }]
	            }]
	          }]
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "section",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "dev-friendly",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "wrapper-lg",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "wrapper",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "h4",
	            f: ["Developer Friendly"]
	          }, " ", {
	            t: 7,
	            e: "p",
	            f: ["All files from ", {
	              t: 7,
	              e: "span",
	              f: ["npm"]
	            }, " and ", {
	              t: 7,
	              e: "span",
	              f: ["GitHub"]
	            }, " available with zero setup"]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "dev-friendly_features-list",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "a",
	              m: [{
	                n: "href",
	                f: "/statistics",
	                t: 13,
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "64",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "64",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/landing/new/dev-friendly/1.svg"],
	                  t: 13
	                }]
	              }, " ", {
	                t: 7,
	                e: "h6",
	                f: ["Usage statistics"]
	              }]
	            }, " ", {
	              t: 7,
	              e: "a",
	              m: [{
	                n: "href",
	                f: "/documentation#id-combine-multiple-files",
	                t: 13,
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "64",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "64",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/landing/new/dev-friendly/2.svg"],
	                  t: 13
	                }]
	              }, " ", {
	                t: 7,
	                e: "h6",
	                f: ["Combine multiple", {
	                  t: 7,
	                  e: "br"
	                }, "files on-demand"]
	              }]
	            }, " ", {
	              t: 7,
	              e: "a",
	              m: [{
	                n: "href",
	                f: "/documentation#id-npm",
	                t: 13,
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "64",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "64",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/landing/new/dev-friendly/3.svg"],
	                  t: 13
	                }]
	              }, " ", {
	                t: 7,
	                e: "h6",
	                f: ["Minify files on-demand"]
	              }]
	            }, " ", {
	              t: 7,
	              e: "a",
	              m: [{
	                n: "href",
	                f: "/documentation#id-npm",
	                t: 13,
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "64",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "64",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/landing/new/dev-friendly/4.svg"],
	                  t: 13
	                }]
	              }, " ", {
	                t: 7,
	                e: "h6",
	                f: ["Source map support"]
	              }]
	            }, " ", {
	              t: 7,
	              e: "a",
	              m: [{
	                n: "href",
	                f: "/documentation#id-npm",
	                t: 13,
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "64",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "64",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/landing/new/dev-friendly/5.svg"],
	                  t: 13
	                }]
	              }, " ", {
	                t: 7,
	                e: "h6",
	                f: ["Version aliasing"]
	              }]
	            }, " ", {
	              t: 7,
	              e: "a",
	              m: [{
	                n: "target",
	                f: "_blank",
	                t: 13,
	                g: 1
	              }, {
	                n: "rel",
	                f: "noopener noreferrer",
	                t: 13,
	                g: 1
	              }, {
	                n: "href",
	                f: "https://github.com/jsdelivr?q=plugin",
	                t: 13,
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "64",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "64",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/landing/new/dev-friendly/6.svg"],
	                  t: 13
	                }]
	              }, " ", {
	                t: 7,
	                e: "h6",
	                f: ["Multiple", {
	                  t: 7,
	                  e: "br"
	                }, "IDE Integrations"]
	              }]
	            }]
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "dev-friendly_gradient",
	          g: 1
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "dev-friendly_image",
	          g: 1
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "container-fluid container-mw",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "row",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "col-xs-12",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "section",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "api wrapper-lg",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "api_content",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "h3",
	                f: ["A free API for all your ", {
	                  t: 7,
	                  e: "br"
	                }, " NPM and ESM needs"]
	              }, " ", {
	                t: 7,
	                e: "p",
	                f: ["The jsDelivr API allows you to get details about NPM packages, such as their versions, tags, and files. By analyzing package metadata and its real usage, it can automatically suggest the correct entry point for each file type."]
	              }, " ", {
	                t: 7,
	                e: "p",
	                f: ["Additionally the API provides detailed download statistics for each project, version, and file, as well as network-wide usage statistics."]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "btn-link-to",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "btn-arrow router-ignore",
	                    g: 1
	                  }, {
	                    n: "href",
	                    f: "/docs/data.jsdelivr.com",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "span",
	                    f: ["Read the API documentation"]
	                  }, " ", {
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "width",
	                      f: "20",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "20",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/icons/arrow-right.svg"],
	                      t: 13
	                    }]
	                  }]
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "api_code code",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "code-head",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "span"
	                }, " ", {
	                  t: 7,
	                  e: "span"
	                }, " ", {
	                  t: 7,
	                  e: "span"
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "code-tabs",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    n: ["click"],
	                    t: 70,
	                    f: {
	                      r: ["@this"],
	                      s: "[_0.set(\"activeTab\",\"entrypoints\")]"
	                    }
	                  }, {
	                    n: "class",
	                    f: [{
	                      t: 4,
	                      f: ["active"],
	                      n: 50,
	                      x: {
	                        r: ["activeTab"],
	                        s: "_0===\"entrypoints\""
	                      }
	                    }],
	                    t: 13
	                  }],
	                  f: ["Get project entry points"]
	                }, " ", {
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    n: ["click"],
	                    t: 70,
	                    f: {
	                      r: ["@this"],
	                      s: "[_0.set(\"activeTab\",\"versions\")]"
	                    }
	                  }, {
	                    n: "class",
	                    f: [{
	                      t: 4,
	                      f: ["active"],
	                      n: 50,
	                      x: {
	                        r: ["activeTab"],
	                        s: "_0===\"versions\""
	                      }
	                    }],
	                    t: 13
	                  }],
	                  f: ["List project versions"]
	                }, " ", {
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    n: ["click"],
	                    t: 70,
	                    f: {
	                      r: ["@this"],
	                      s: "[_0.set(\"activeTab\",\"files\")]"
	                    }
	                  }, {
	                    n: "class",
	                    f: [{
	                      t: 4,
	                      f: ["active"],
	                      n: 50,
	                      x: {
	                        r: ["activeTab"],
	                        s: "_0===\"files\""
	                      }
	                    }],
	                    t: 13
	                  }],
	                  f: ["List package files"]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "code-tabs-line",
	                    g: 1
	                  }, {
	                    n: "style",
	                    f: ["left: ", {
	                      t: 2,
	                      r: "activeTabLineData.0"
	                    }, "px; width: ", {
	                      t: 2,
	                      r: "activeTabLineData.1"
	                    }, "px;"],
	                    t: 13
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "dropdown",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "button",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "dropdown-toggle",
	                      g: 1
	                    }, {
	                      n: "type",
	                      f: "button",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "id",
	                      f: "cdn-dropdown",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "data-toggle",
	                      f: "dropdown",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "aria-haspopup",
	                      f: "true",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "aria-expanded",
	                      f: "true",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "img",
	                      m: [{
	                        n: "width",
	                        f: "20",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "height",
	                        f: "20",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "src",
	                        f: [{
	                          t: 2,
	                          r: "@shared.assetsHost"
	                        }, "/img/icons/chevron-down.svg"],
	                        t: 13
	                      }, {
	                        n: "loading",
	                        f: "lazy",
	                        t: 13,
	                        g: 1
	                      }]
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "ul",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "dropdown-menu dropdown-menu-right",
	                      g: 1
	                    }, {
	                      n: "aria-labelledby",
	                      f: "cdn-dropdown",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: [{
	                      t: 4,
	                      f: [{
	                        t: 7,
	                        e: "li",
	                        f: [{
	                          t: 7,
	                          e: "a",
	                          m: [{
	                            n: ["click"],
	                            t: 70,
	                            f: {
	                              r: ["@this", "."],
	                              s: "[_0.set(\"activeTab\",_1)]"
	                            }
	                          }],
	                          f: [{
	                            t: 2,
	                            r: "."
	                          }]
	                        }]
	                      }],
	                      n: 52,
	                      r: "~/codeList"
	                    }]
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "code-slider",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "c-slider",
	                  m: [{
	                    n: "active",
	                    f: [{
	                      t: 2,
	                      r: "activeSlide"
	                    }],
	                    t: 13
	                  }, {
	                    n: "direction",
	                    f: "horizontal",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "distance",
	                    f: "500",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "duration",
	                    f: "0",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "c-slide",
	                    f: [{
	                      t: 7,
	                      e: "div",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "code-slide entrypoints",
	                        g: 1
	                      }],
	                      f: [{
	                        t: 7,
	                        e: "div",
	                        m: [{
	                          t: 13,
	                          n: "class",
	                          f: "code-lines-counter",
	                          g: 1
	                        }]
	                      }, " ", {
	                        t: 7,
	                        e: "div",
	                        m: [{
	                          t: 13,
	                          n: "class",
	                          f: "code-wrapper",
	                          g: 1
	                        }],
	                        f: [{
	                          t: 7,
	                          e: "div",
	                          m: [{
	                            t: 13,
	                            n: "class",
	                            f: "code-link",
	                            g: 1
	                          }],
	                          f: [{
	                            t: 7,
	                            e: "span",
	                            f: ["https://data.jsdelivr.com/v1/packages/npm/bootstrap@5.1.0/entrypoints"]
	                          }]
	                        }, " ", {
	                          t: 7,
	                          e: "div",
	                          f: [" "]
	                        }, " ", {
	                          t: 7,
	                          e: "div",
	                          f: ["// =>"]
	                        }, " ", {
	                          t: 7,
	                          e: "div",
	                          f: ["{"]
	                        }, " ", {
	                          t: 7,
	                          e: "div",
	                          f: ["  \" ", {
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "code-key",
	                              g: 1
	                            }],
	                            f: ["entrypoints"]
	                          }, " \": {"]
	                        }, " ", {
	                          t: 7,
	                          e: "div",
	                          f: ["    \" ", {
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "code-key",
	                              g: 1
	                            }],
	                            f: ["js"]
	                          }, " \": {"]
	                        }, " ", {
	                          t: 7,
	                          e: "div",
	                          f: ["      \" ", {
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "code-key",
	                              g: 1
	                            }],
	                            f: ["file"]
	                          }, " \": \" ", {
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "code-string",
	                              g: 1
	                            }],
	                            f: ["/"]
	                          }, " ", {
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "code-string",
	                              g: 1
	                            }],
	                            f: ["dist"]
	                          }, " ", {
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "code-string",
	                              g: 1
	                            }],
	                            f: ["/"]
	                          }, " ", {
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "code-string",
	                              g: 1
	                            }],
	                            f: ["js"]
	                          }, " ", {
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "code-string",
	                              g: 1
	                            }],
	                            f: ["/"]
	                          }, " ", {
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "code-string",
	                              g: 1
	                            }],
	                            f: ["bootstrap"]
	                          }, " ", {
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "code-string",
	                              g: 1
	                            }],
	                            f: [".min"]
	                          }, " ", {
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "code-string",
	                              g: 1
	                            }],
	                            f: [".js"]
	                          }, " \","]
	                        }, " ", {
	                          t: 7,
	                          e: "div",
	                          f: ["      \" ", {
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "code-key",
	                              g: 1
	                            }],
	                            f: ["guessed"]
	                          }, " \": ", {
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "code-boolean",
	                              g: 1
	                            }],
	                            f: [" false"]
	                          }]
	                        }, " ", {
	                          t: 7,
	                          e: "div",
	                          f: ["    },"]
	                        }, " ", {
	                          t: 7,
	                          e: "div",
	                          f: ["    \" ", {
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "code-key",
	                              g: 1
	                            }],
	                            f: ["css"]
	                          }, " \": {"]
	                        }, " ", {
	                          t: 7,
	                          e: "div",
	                          f: ["      \" ", {
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "code-key",
	                              g: 1
	                            }],
	                            f: ["file"]
	                          }, " \": \" ", {
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "code-string",
	                              g: 1
	                            }],
	                            f: ["/"]
	                          }, " ", {
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "code-string",
	                              g: 1
	                            }],
	                            f: ["dist"]
	                          }, " ", {
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "code-string",
	                              g: 1
	                            }],
	                            f: ["/"]
	                          }, " ", {
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "code-string",
	                              g: 1
	                            }],
	                            f: ["css"]
	                          }, " ", {
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "code-string",
	                              g: 1
	                            }],
	                            f: ["/"]
	                          }, " ", {
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "code-string",
	                              g: 1
	                            }],
	                            f: ["bootstrap"]
	                          }, " ", {
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "code-string",
	                              g: 1
	                            }],
	                            f: [".min"]
	                          }, " ", {
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "code-string",
	                              g: 1
	                            }],
	                            f: [".css"]
	                          }, " \","]
	                        }, " ", {
	                          t: 7,
	                          e: "div",
	                          f: ["      \" ", {
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "code-key",
	                              g: 1
	                            }],
	                            f: ["guessed"]
	                          }, " \": ", {
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "code-boolean",
	                              g: 1
	                            }],
	                            f: [" false"]
	                          }]
	                        }, " ", {
	                          t: 7,
	                          e: "div",
	                          f: ["    }"]
	                        }, " ", {
	                          t: 7,
	                          e: "div",
	                          f: ["  }"]
	                        }, " ", {
	                          t: 7,
	                          e: "div",
	                          f: ["}"]
	                        }]
	                      }]
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "c-slide",
	                    f: [{
	                      t: 7,
	                      e: "div",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "code-slide versions",
	                        g: 1
	                      }],
	                      f: [{
	                        t: 7,
	                        e: "div",
	                        m: [{
	                          t: 13,
	                          n: "class",
	                          f: "code-lines-counter",
	                          g: 1
	                        }]
	                      }, " ", {
	                        t: 7,
	                        e: "div",
	                        m: [{
	                          t: 13,
	                          n: "class",
	                          f: "code-wrapper",
	                          g: 1
	                        }],
	                        f: [{
	                          t: 7,
	                          e: "div",
	                          m: [{
	                            t: 13,
	                            n: "class",
	                            f: "code-link",
	                            g: 1
	                          }],
	                          f: [{
	                            t: 7,
	                            e: "span",
	                            f: ["https://data.jsdelivr.com/v1/packages/npm/bootstrap"]
	                          }]
	                        }, " ", {
	                          t: 7,
	                          e: "div",
	                          f: [" "]
	                        }, " ", {
	                          t: 7,
	                          e: "div",
	                          f: ["// =>"]
	                        }, " ", {
	                          t: 7,
	                          e: "div",
	                          f: ["{"]
	                        }, " ", {
	                          t: 7,
	                          e: "div",
	                          f: ["  \" ", {
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "code-key",
	                              g: 1
	                            }],
	                            f: ["tags"]
	                          }, " \": {"]
	                        }, " ", {
	                          t: 7,
	                          e: "div",
	                          f: ["    \" ", {
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "code-key",
	                              g: 1
	                            }],
	                            f: ["latest"]
	                          }, " \": \" ", {
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "code-string",
	                              g: 1
	                            }],
	                            f: ["5.1.0"]
	                          }, " \""]
	                        }, " ", {
	                          t: 7,
	                          e: "div",
	                          f: ["  },"]
	                        }, " ", {
	                          t: 7,
	                          e: "div",
	                          f: ["  \" ", {
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "code-key",
	                              g: 1
	                            }],
	                            f: ["versions"]
	                          }, " \": ["]
	                        }, " ", {
	                          t: 7,
	                          e: "div",
	                          f: ["    {"]
	                        }, " ", {
	                          t: 7,
	                          e: "div",
	                          f: ["      \" ", {
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "code-key",
	                              g: 1
	                            }],
	                            f: ["version"]
	                          }, " \": \" ", {
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "code-string",
	                              g: 1
	                            }],
	                            f: ["5.1.0"]
	                          }, " \","]
	                        }, " ", {
	                          t: 7,
	                          e: "div",
	                          f: ["      \" ", {
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "code-key",
	                              g: 1
	                            }],
	                            f: ["links"]
	                          }, " \": { ... }"]
	                        }, " ", {
	                          t: 7,
	                          e: "div",
	                          f: ["    },"]
	                        }, " ", {
	                          t: 7,
	                          e: "div",
	                          f: ["    ..."]
	                        }, " ", {
	                          t: 7,
	                          e: "div",
	                          f: ["  ]"]
	                        }, " ", {
	                          t: 7,
	                          e: "div",
	                          f: ["}"]
	                        }]
	                      }]
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "c-slide",
	                    f: [{
	                      t: 7,
	                      e: "div",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "code-slide files",
	                        g: 1
	                      }],
	                      f: [{
	                        t: 7,
	                        e: "div",
	                        m: [{
	                          t: 13,
	                          n: "class",
	                          f: "code-lines-counter",
	                          g: 1
	                        }]
	                      }, " ", {
	                        t: 7,
	                        e: "div",
	                        m: [{
	                          t: 13,
	                          n: "class",
	                          f: "code-wrapper",
	                          g: 1
	                        }],
	                        f: [{
	                          t: 7,
	                          e: "div",
	                          m: [{
	                            t: 13,
	                            n: "class",
	                            f: "code-link",
	                            g: 1
	                          }],
	                          f: [{
	                            t: 7,
	                            e: "span",
	                            f: ["https://data.jsdelivr.com/v1/packages/npm/bootstrap@5.1.0"]
	                          }]
	                        }, " ", {
	                          t: 7,
	                          e: "div",
	                          f: [" "]
	                        }, " ", {
	                          t: 7,
	                          e: "div",
	                          f: ["// =>"]
	                        }, " ", {
	                          t: 7,
	                          e: "div",
	                          f: ["{"]
	                        }, " ", {
	                          t: 7,
	                          e: "div",
	                          f: ["  \" ", {
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "code-key",
	                              g: 1
	                            }],
	                            f: ["default"]
	                          }, " \": \" ", {
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "code-string",
	                              g: 1
	                            }],
	                            f: ["/dist/js/bootstrap.min.js"]
	                          }, " \","]
	                        }, " ", {
	                          t: 7,
	                          e: "div",
	                          f: ["  \" ", {
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "code-key",
	                              g: 1
	                            }],
	                            f: ["files"]
	                          }, " \": ["]
	                        }, " ", {
	                          t: 7,
	                          e: "div",
	                          f: ["    {"]
	                        }, " ", {
	                          t: 7,
	                          e: "div",
	                          f: ["      \" ", {
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "code-key",
	                              g: 1
	                            }],
	                            f: ["type"]
	                          }, " \": \" ", {
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "code-string",
	                              g: 1
	                            }],
	                            f: ["file"]
	                          }, " \","]
	                        }, " ", {
	                          t: 7,
	                          e: "div",
	                          f: ["      \" ", {
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "code-key",
	                              g: 1
	                            }],
	                            f: ["name"]
	                          }, " \": \" ", {
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "code-string",
	                              g: 1
	                            }],
	                            f: ["package.json"]
	                          }, " \","]
	                        }, " ", {
	                          t: 7,
	                          e: "div",
	                          f: ["      \" ", {
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "code-key",
	                              g: 1
	                            }],
	                            f: ["hash"]
	                          }, " \": \" ", {
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "code-string",
	                              g: 1
	                            }],
	                            f: ["j19bdlJ6sukErRbeEIVWdlup1uM8tAg8c0INKUgkvHI="]
	                          }, " \","]
	                        }, " ", {
	                          t: 7,
	                          e: "div",
	                          f: ["      \" ", {
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "code-key",
	                              g: 1
	                            }],
	                            f: ["size"]
	                          }, " \": ", {
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "code-number",
	                              g: 1
	                            }],
	                            f: [" 9352"]
	                          }]
	                        }, " ", {
	                          t: 7,
	                          e: "div",
	                          f: ["    },"]
	                        }, " ", {
	                          t: 7,
	                          e: "div",
	                          f: ["    {"]
	                        }, " ", {
	                          t: 7,
	                          e: "div",
	                          f: ["      \" ", {
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "code-key",
	                              g: 1
	                            }],
	                            f: ["type"]
	                          }, " \": \" ", {
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "code-string",
	                              g: 1
	                            }],
	                            f: ["file"]
	                          }, " \","]
	                        }, " ", {
	                          t: 7,
	                          e: "div",
	                          f: ["      \" ", {
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "code-key",
	                              g: 1
	                            }],
	                            f: ["name"]
	                          }, " \": \" ", {
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "code-string",
	                              g: 1
	                            }],
	                            f: ["README.md"]
	                          }, " \","]
	                        }, " ", {
	                          t: 7,
	                          e: "div",
	                          f: ["      \" ", {
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "code-key",
	                              g: 1
	                            }],
	                            f: ["hash"]
	                          }, " \": \" ", {
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "code-string",
	                              g: 1
	                            }],
	                            f: ["0VD+BFt1wT4LdvxuZYxl2657grnDUvEoRso1T0QcoIo="]
	                          }, " \","]
	                        }, " ", {
	                          t: 7,
	                          e: "div",
	                          f: ["      \" ", {
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "code-key",
	                              g: 1
	                            }],
	                            f: ["size"]
	                          }, " \": ", {
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "code-number",
	                              g: 1
	                            }],
	                            f: [" 13566"]
	                          }]
	                        }, " ", {
	                          t: 7,
	                          e: "div",
	                          f: ["    },"]
	                        }, " ", {
	                          t: 7,
	                          e: "div",
	                          f: ["    ..."]
	                        }, " ", {
	                          t: 7,
	                          e: "div",
	                          f: ["  ]"]
	                        }, " ", {
	                          t: 7,
	                          e: "div",
	                          f: ["}"]
	                        }]
	                      }]
	                    }]
	                  }]
	                }]
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "c-new-infographic-banner"
	          }, " ", {
	            t: 7,
	            e: "section",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "js-modules wrapper-lg",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "js-modules_content",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "h3",
	                f: ["A New-Age CDN for", {
	                  t: 7,
	                  e: "br"
	                }, "JavaScript modules"]
	              }, " ", {
	                t: 7,
	                e: "p",
	                f: ["Load modern JavaScript packages built for you on-demand. ", {
	                  t: 7,
	                  e: "br"
	                }, "Works in modern web browsers, node.js, and deno."]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "js-modules_content_checklist",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "div",
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "width",
	                      f: "24",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "24",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/icons/check-circle.svg"],
	                      t: 13
	                    }]
	                  }, " Global Multi-CDN"]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "width",
	                      f: "24",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "24",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/icons/check-circle.svg"],
	                      t: 13
	                    }]
	                  }, " HTTP/3, minification, brotli compression, fine-tuned HTTP caching, dependency preloading"]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "width",
	                      f: "24",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "24",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/icons/check-circle.svg"],
	                      t: 13
	                    }]
	                  }, " Permanent storage shared by all edge servers"]
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "btn-link-to",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "btn-arrow",
	                    g: 1
	                  }, {
	                    n: "href",
	                    f: "/esm",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "span",
	                    f: ["Learn more about ESM"]
	                  }, " ", {
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "width",
	                      f: "20",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "20",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/icons/arrow-right.svg"],
	                      t: 13
	                    }]
	                  }]
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "js-modules_code code",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "code-head",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "span"
	                }, " ", {
	                  t: 7,
	                  e: "span"
	                }, " ", {
	                  t: 7,
	                  e: "span"
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "js-modules_code_wrapper",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "js-modules_code_wrapper_counters",
	                    g: 1
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "pre",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "code-colors",
	                    g: 1
	                  }],
	                  f: ["\t\t\t\t\t\t\t\t", {
	                    t: 7,
	                    e: "span",
	                    f: [{
	                      t: 7,
	                      e: "span",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "code-colors_reserved",
	                        g: 1
	                      }],
	                      f: ["import"]
	                    }, " { ", {
	                      t: 7,
	                      e: "span",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "code-colors_var",
	                        g: 1
	                      }],
	                      f: ["Fireworks"]
	                    }, " } ", {
	                      t: 7,
	                      e: "span",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "code-colors_reserved",
	                        g: 1
	                      }],
	                      f: ["from"]
	                    }, " '", {
	                      t: 7,
	                      e: "span",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "code-colors_string",
	                        g: 1
	                      }],
	                      f: ["https://esm.run/fireworks-js"]
	                    }, "';"]
	                  }, "\n\t\t\t\t\t\t\t\t", {
	                    t: 7,
	                    e: "span"
	                  }, "\n\t\t\t\t\t\t\t\t", {
	                    t: 7,
	                    e: "span",
	                    f: [{
	                      t: 7,
	                      e: "span",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "code-colors_reserved",
	                        g: 1
	                      }],
	                      f: ["let"]
	                    }, " ", {
	                      t: 7,
	                      e: "span",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "code-colors_var",
	                        g: 1
	                      }],
	                      f: ["container"]
	                    }, " = ", {
	                      t: 7,
	                      e: "span",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "code-colors_obj",
	                        g: 1
	                      }],
	                      f: ["document"]
	                    }, ".", {
	                      t: 7,
	                      e: "span",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "code-colors_method",
	                        g: 1
	                      }],
	                      f: ["querySelector"]
	                    }, "('", {
	                      t: 7,
	                      e: "span",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "code-colors_string",
	                        g: 1
	                      }],
	                      f: [".container"]
	                    }, "');"]
	                  }, "\n\t\t\t\t\t\t\t\t", {
	                    t: 7,
	                    e: "span"
	                  }, "\n\t\t\t\t\t\t\t\t", {
	                    t: 7,
	                    e: "span",
	                    f: [{
	                      t: 7,
	                      e: "span",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "code-colors_reserved",
	                        g: 1
	                      }],
	                      f: ["let"]
	                    }, " ", {
	                      t: 7,
	                      e: "span",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "code-colors_var",
	                        g: 1
	                      }],
	                      f: ["options"]
	                    }, " = {\n\t\t\t\t\t\t\t\t\t  ", {
	                      t: 7,
	                      e: "span",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "code-colors_key",
	                        g: 1
	                      }],
	                      f: ["gravity"]
	                    }, ": ", {
	                      t: 7,
	                      e: "span",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "code-colors_number",
	                        g: 1
	                      }],
	                      f: ["1.4"]
	                    }, ",\n\t\t\t\t\t\t\t\t\t  ", {
	                      t: 7,
	                      e: "span",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "code-colors_key",
	                        g: 1
	                      }],
	                      f: ["opacity"]
	                    }, ": ", {
	                      t: 7,
	                      e: "span",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "code-colors_number",
	                        g: 1
	                      }],
	                      f: ["0.4"]
	                    }, ",\n\t\t\t\t\t\t\t\t\t  ", {
	                      t: 7,
	                      e: "span",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "code-colors_key",
	                        g: 1
	                      }],
	                      f: ["autoresize"]
	                    }, ": ", {
	                      t: 7,
	                      e: "span",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "code-colors_boolean",
	                        g: 1
	                      }],
	                      f: ["true"]
	                    }, ",\n\t\t\t\t\t\t\t\t\t  ", {
	                      t: 7,
	                      e: "span",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "code-colors_key",
	                        g: 1
	                      }],
	                      f: ["acceleration"]
	                    }, ": ", {
	                      t: 7,
	                      e: "span",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "code-colors_number",
	                        g: 1
	                      }],
	                      f: ["1.00"]
	                    }, ",\n\t\t\t\t\t\t\t\t\t};\n\t\t\t\t\t\t\t\t"]
	                  }, "\n\t\t\t\t\t\t\t\t", {
	                    t: 7,
	                    e: "span",
	                    f: [{
	                      t: 7,
	                      e: "span",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "code-colors_reserved",
	                        g: 1
	                      }],
	                      f: ["let"]
	                    }, " ", {
	                      t: 7,
	                      e: "span",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "code-colors_var",
	                        g: 1
	                      }],
	                      f: ["fireworks"]
	                    }, " = ", {
	                      t: 7,
	                      e: "span",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "code-colors_reserved",
	                        g: 1
	                      }],
	                      f: ["new"]
	                    }, " ", {
	                      t: 7,
	                      e: "span",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "code-colors_obj",
	                        g: 1
	                      }],
	                      f: ["Fireworks"]
	                    }, "(", {
	                      t: 7,
	                      e: "span",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "code-colors_var",
	                        g: 1
	                      }],
	                      f: ["container"]
	                    }, ", ", {
	                      t: 7,
	                      e: "span",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "code-colors_var",
	                        g: 1
	                      }],
	                      f: ["options"]
	                    }, ");"]
	                  }, "\n\t\t\t\t\t\t\t\t", {
	                    t: 7,
	                    e: "span"
	                  }, "\n\t\t\t\t\t\t\t\t", {
	                    t: 7,
	                    e: "span",
	                    f: [{
	                      t: 7,
	                      e: "span",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "code-colors_obj",
	                        g: 1
	                      }],
	                      f: ["fireworks"]
	                    }, ".", {
	                      t: 7,
	                      e: "span",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "code-colors_method",
	                        g: 1
	                      }],
	                      f: ["start"]
	                    }, "();"]
	                  }, "\n\t\t\t\t\t\t\t\t", {
	                    t: 7,
	                    e: "span"
	                  }, "\n\t\t\t\t\t\t\t\t"]
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "code-footer",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "span",
	                  f: [{
	                    t: 4,
	                    f: [{
	                      t: 4,
	                      f: [{
	                        t: 2,
	                        r: "esmDemoLoadTime"
	                      }, " ms, loaded from the CDN"],
	                      n: 50,
	                      r: "esmDemoLoadTime"
	                    }, {
	                      t: 4,
	                      f: [{
	                        t: 2,
	                        r: "esmDemoLoadTime"
	                      }, " ms, still cached"],
	                      n: 51,
	                      l: 1
	                    }],
	                    n: 50,
	                    x: {
	                      r: ["esmDemoLoadTime"],
	                      s: "_0!==null"
	                    }
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "button",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "btn-primary",
	                    g: 1
	                  }, {
	                    n: ["click"],
	                    t: 70,
	                    f: {
	                      r: ["@this", "@event"],
	                      s: "[_0.runEsmDemo(_1)]"
	                    }
	                  }],
	                  f: ["Run"]
	                }]
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "section",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "top-packages wrapper-lg",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "top-packages_analytics-graph",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "svg",
	                m: [{
	                  n: "width",
	                  f: "1216",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "520",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "viewBox",
	                  f: "0 0 1216 520",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "fill",
	                  f: "none",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "xmlns",
	                  f: "http://www.w3.org/2000/svg",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "g",
	                  m: [{
	                    n: "transform",
	                    f: "translate(5 0)",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "rect",
	                    m: [{
	                      n: "width",
	                      f: "1",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "520",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "fill",
	                      f: "url(#paint_line_linear0)",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "rect",
	                    m: [{
	                      n: "x",
	                      f: "45",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "width",
	                      f: "1",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "520",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "fill",
	                      f: "url(#paint_line_linear0)",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "rect",
	                    m: [{
	                      n: "x",
	                      f: "90",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "width",
	                      f: "1",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "520",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "fill",
	                      f: "url(#paint_line_linear0)",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "rect",
	                    m: [{
	                      n: "x",
	                      f: "135",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "width",
	                      f: "1",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "520",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "fill",
	                      f: "url(#paint_line_linear0)",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "rect",
	                    m: [{
	                      n: "x",
	                      f: "180",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "width",
	                      f: "1",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "520",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "fill",
	                      f: "url(#paint_line_linear0)",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "rect",
	                    m: [{
	                      n: "x",
	                      f: "225",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "width",
	                      f: "1",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "520",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "fill",
	                      f: "url(#paint_line_linear0)",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "rect",
	                    m: [{
	                      n: "x",
	                      f: "270",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "width",
	                      f: "1",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "520",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "fill",
	                      f: "url(#paint_line_linear0)",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "rect",
	                    m: [{
	                      n: "x",
	                      f: "315",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "width",
	                      f: "1",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "520",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "fill",
	                      f: "url(#paint_line_linear0)",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "rect",
	                    m: [{
	                      n: "x",
	                      f: "360",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "width",
	                      f: "1",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "520",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "fill",
	                      f: "url(#paint_line_linear0)",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "rect",
	                    m: [{
	                      n: "x",
	                      f: "405",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "width",
	                      f: "1",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "520",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "fill",
	                      f: "url(#paint_line_linear0)",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "rect",
	                    m: [{
	                      n: "x",
	                      f: "450",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "width",
	                      f: "1",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "520",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "fill",
	                      f: "url(#paint_line_linear0)",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "rect",
	                    m: [{
	                      n: "x",
	                      f: "495",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "width",
	                      f: "1",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "520",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "fill",
	                      f: "url(#paint_line_linear0)",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "rect",
	                    m: [{
	                      n: "x",
	                      f: "540",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "width",
	                      f: "1",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "520",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "fill",
	                      f: "url(#paint_line_linear0)",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "rect",
	                    m: [{
	                      n: "x",
	                      f: "585",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "width",
	                      f: "1",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "520",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "fill",
	                      f: "url(#paint_line_linear0)",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "rect",
	                    m: [{
	                      n: "x",
	                      f: "630",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "width",
	                      f: "1",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "520",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "fill",
	                      f: "url(#paint_line_linear0)",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "rect",
	                    m: [{
	                      n: "x",
	                      f: "675",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "width",
	                      f: "1",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "520",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "fill",
	                      f: "url(#paint_line_linear0)",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "rect",
	                    m: [{
	                      n: "x",
	                      f: "720",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "width",
	                      f: "1",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "520",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "fill",
	                      f: "url(#paint_line_linear0)",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "rect",
	                    m: [{
	                      n: "x",
	                      f: "765",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "width",
	                      f: "1",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "520",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "fill",
	                      f: "url(#paint_line_linear0)",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "rect",
	                    m: [{
	                      n: "x",
	                      f: "810",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "width",
	                      f: "1",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "520",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "fill",
	                      f: "url(#paint_line_linear0)",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "rect",
	                    m: [{
	                      n: "x",
	                      f: "855",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "width",
	                      f: "1",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "520",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "fill",
	                      f: "url(#paint_line_linear0)",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "rect",
	                    m: [{
	                      n: "x",
	                      f: "900",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "width",
	                      f: "1",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "520",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "fill",
	                      f: "url(#paint_line_linear0)",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "rect",
	                    m: [{
	                      n: "x",
	                      f: "945",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "width",
	                      f: "1",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "520",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "fill",
	                      f: "url(#paint_line_linear0)",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "rect",
	                    m: [{
	                      n: "x",
	                      f: "990",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "width",
	                      f: "1",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "520",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "fill",
	                      f: "url(#paint_line_linear0)",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "rect",
	                    m: [{
	                      n: "x",
	                      f: "1035",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "width",
	                      f: "1",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "520",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "fill",
	                      f: "url(#paint_line_linear0)",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "rect",
	                    m: [{
	                      n: "x",
	                      f: "1080",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "width",
	                      f: "1",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "520",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "fill",
	                      f: "url(#paint_line_linear0)",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "rect",
	                    m: [{
	                      n: "x",
	                      f: "1125",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "width",
	                      f: "1",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "520",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "fill",
	                      f: "url(#paint_line_linear0)",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "rect",
	                    m: [{
	                      n: "x",
	                      f: "1170",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "width",
	                      f: "1",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "520",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "fill",
	                      f: "url(#paint_line_linear0)",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "rect",
	                    m: [{
	                      n: "x",
	                      f: "1215",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "width",
	                      f: "1",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "520",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "fill",
	                      f: "url(#paint_line_linear0)",
	                      t: 13,
	                      g: 1
	                    }]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "g",
	                  m: [{
	                    n: "width",
	                    f: "592",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "253",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "transform",
	                    f: "translate(0 260)",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "path",
	                    m: [{
	                      n: "d",
	                      f: "M7 246L51 206L96 246L141 206L186 166L232 206L277 166L322 126L366 86L411 46L456 86L500 46L545 6L591 46",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "stroke",
	                      f: "url(#paint_line_linear1)",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "stroke-width",
	                      f: "2",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "stroke-linecap",
	                      f: "round",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "circle",
	                    m: [{
	                      n: "cx",
	                      f: "6.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "cy",
	                      f: "246.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "r",
	                      f: "4.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "fill",
	                      f: "white",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "circle",
	                    m: [{
	                      n: "cx",
	                      f: "6.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "cy",
	                      f: "246.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "r",
	                      f: "5.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "stroke",
	                      f: "#F65128",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "stroke-opacity",
	                      f: "0.24",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "stroke-width",
	                      f: "2",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "circle",
	                    m: [{
	                      n: "cx",
	                      f: "51.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "cy",
	                      f: "206.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "r",
	                      f: "4.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "fill",
	                      f: "white",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "circle",
	                    m: [{
	                      n: "cx",
	                      f: "51.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "cy",
	                      f: "206.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "r",
	                      f: "5.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "stroke",
	                      f: "#F65128",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "stroke-opacity",
	                      f: "0.24",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "stroke-width",
	                      f: "2",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "circle",
	                    m: [{
	                      n: "cx",
	                      f: "96.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "cy",
	                      f: "246.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "r",
	                      f: "4.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "fill",
	                      f: "white",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "circle",
	                    m: [{
	                      n: "cx",
	                      f: "96.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "cy",
	                      f: "246.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "r",
	                      f: "5.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "stroke",
	                      f: "#F65128",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "stroke-opacity",
	                      f: "0.24",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "stroke-width",
	                      f: "2",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "circle",
	                    m: [{
	                      n: "cx",
	                      f: "141.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "cy",
	                      f: "206.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "r",
	                      f: "4.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "fill",
	                      f: "white",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "circle",
	                    m: [{
	                      n: "cx",
	                      f: "141.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "cy",
	                      f: "206.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "r",
	                      f: "5.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "stroke",
	                      f: "#F65128",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "stroke-opacity",
	                      f: "0.24",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "stroke-width",
	                      f: "2",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "circle",
	                    m: [{
	                      n: "cx",
	                      f: "186.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "cy",
	                      f: "166.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "r",
	                      f: "4.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "fill",
	                      f: "white",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "circle",
	                    m: [{
	                      n: "cx",
	                      f: "186.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "cy",
	                      f: "166.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "r",
	                      f: "5.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "stroke",
	                      f: "#F65128",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "stroke-opacity",
	                      f: "0.24",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "stroke-width",
	                      f: "2",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "circle",
	                    m: [{
	                      n: "cx",
	                      f: "231.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "cy",
	                      f: "206.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "r",
	                      f: "4.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "fill",
	                      f: "white",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "circle",
	                    m: [{
	                      n: "cx",
	                      f: "231.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "cy",
	                      f: "206.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "r",
	                      f: "5.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "stroke",
	                      f: "#F65128",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "stroke-opacity",
	                      f: "0.24",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "stroke-width",
	                      f: "2",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "circle",
	                    m: [{
	                      n: "cx",
	                      f: "276.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "cy",
	                      f: "166.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "r",
	                      f: "4.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "fill",
	                      f: "white",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "circle",
	                    m: [{
	                      n: "cx",
	                      f: "276.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "cy",
	                      f: "166.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "r",
	                      f: "5.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "stroke",
	                      f: "#F65128",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "stroke-opacity",
	                      f: "0.24",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "stroke-width",
	                      f: "2",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "circle",
	                    m: [{
	                      n: "cx",
	                      f: "321.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "cy",
	                      f: "126.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "r",
	                      f: "4.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "fill",
	                      f: "white",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "circle",
	                    m: [{
	                      n: "cx",
	                      f: "321.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "cy",
	                      f: "126.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "r",
	                      f: "5.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "stroke",
	                      f: "#F65128",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "stroke-opacity",
	                      f: "0.24",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "stroke-width",
	                      f: "2",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "circle",
	                    m: [{
	                      n: "cx",
	                      f: "366.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "cy",
	                      f: "86.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "r",
	                      f: "4.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "fill",
	                      f: "white",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "circle",
	                    m: [{
	                      n: "cx",
	                      f: "366.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "cy",
	                      f: "86.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "r",
	                      f: "5.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "stroke",
	                      f: "#F65128",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "stroke-opacity",
	                      f: "0.24",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "stroke-width",
	                      f: "2",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "circle",
	                    m: [{
	                      n: "cx",
	                      f: "411.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "cy",
	                      f: "46.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "r",
	                      f: "4.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "fill",
	                      f: "white",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "circle",
	                    m: [{
	                      n: "cx",
	                      f: "411.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "cy",
	                      f: "46.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "r",
	                      f: "5.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "stroke",
	                      f: "#F65128",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "stroke-opacity",
	                      f: "0.24",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "stroke-width",
	                      f: "2",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "circle",
	                    m: [{
	                      n: "cx",
	                      f: "456.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "cy",
	                      f: "86.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "r",
	                      f: "4.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "fill",
	                      f: "white",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "circle",
	                    m: [{
	                      n: "cx",
	                      f: "456.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "cy",
	                      f: "86.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "r",
	                      f: "5.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "stroke",
	                      f: "#F65128",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "stroke-opacity",
	                      f: "0.24",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "stroke-width",
	                      f: "2",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "circle",
	                    m: [{
	                      n: "cx",
	                      f: "501.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "cy",
	                      f: "46.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "r",
	                      f: "4.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "fill",
	                      f: "white",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "circle",
	                    m: [{
	                      n: "cx",
	                      f: "501.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "cy",
	                      f: "46.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "r",
	                      f: "5.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "stroke",
	                      f: "#F65128",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "stroke-opacity",
	                      f: "0.24",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "stroke-width",
	                      f: "2",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "circle",
	                    m: [{
	                      n: "cx",
	                      f: "545.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "cy",
	                      f: "6.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "r",
	                      f: "4.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "fill",
	                      f: "white",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "circle",
	                    m: [{
	                      n: "cx",
	                      f: "545.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "cy",
	                      f: "6.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "r",
	                      f: "5.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "stroke",
	                      f: "#F65128",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "stroke-opacity",
	                      f: "0.24",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "stroke-width",
	                      f: "2",
	                      t: 13,
	                      g: 1
	                    }]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "defs",
	                  f: [{
	                    t: 7,
	                    e: "linearGradient",
	                    m: [{
	                      n: "id",
	                      f: "paint_line_linear0",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "x1",
	                      f: "0.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "y1",
	                      f: "0",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "x2",
	                      f: "0.5",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "y2",
	                      f: "520",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "gradientUnits",
	                      f: "userSpaceOnUse",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "stop",
	                      m: [{
	                        n: "stop-color",
	                        f: "#EDF0F2",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "stop-opacity",
	                        f: "0",
	                        t: 13,
	                        g: 1
	                      }]
	                    }, " ", {
	                      t: 7,
	                      e: "stop",
	                      m: [{
	                        n: "offset",
	                        f: "0.458333",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "stop-color",
	                        f: "#EDF0F2",
	                        t: 13,
	                        g: 1
	                      }]
	                    }, " ", {
	                      t: 7,
	                      e: "stop",
	                      m: [{
	                        n: "offset",
	                        f: "1",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "stop-color",
	                        f: "#EDF0F2",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "stop-opacity",
	                        f: "0",
	                        t: 13,
	                        g: 1
	                      }]
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "linearGradient",
	                    m: [{
	                      n: "id",
	                      f: "paint_line_linear1",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "x1",
	                      f: "299",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "y1",
	                      f: "6",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "x2",
	                      f: "299",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "y2",
	                      f: "246",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "gradientUnits",
	                      f: "userSpaceOnUse",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "stop",
	                      m: [{
	                        n: "stop-color",
	                        f: "#F65128",
	                        t: 13,
	                        g: 1
	                      }]
	                    }, " ", {
	                      t: 7,
	                      e: "stop",
	                      m: [{
	                        n: "offset",
	                        f: "1",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "stop-color",
	                        f: "#F65128",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "stop-opacity",
	                        f: "0.08",
	                        t: 13,
	                        g: 1
	                      }]
	                    }]
	                  }]
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "top-packages_content",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "h3",
	                f: ["Analytics and Stats"]
	              }, " ", {
	                t: 7,
	                e: "p",
	                f: ["Use our stats to better understand how your projects are being used, which versions are popular, and which files are being downloaded the most."]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "btn-link-to",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "btn-arrow",
	                    g: 1
	                  }, {
	                    n: "href",
	                    f: "/statistics",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "span",
	                    f: ["See more stats"]
	                  }, " ", {
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "width",
	                      f: "20",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "20",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/icons/arrow-right.svg"],
	                      t: 13
	                    }]
	                  }]
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "top-packages_packages-list code",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "code-head",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "span"
	                }, " ", {
	                  t: 7,
	                  e: "span"
	                }, " ", {
	                  t: 7,
	                  e: "span"
	                }, " ", {
	                  t: 7,
	                  e: "p",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "title",
	                    g: 1
	                  }],
	                  f: ["Top 10 npm packages past 30 days"]
	                }]
	              }, " ", {
	                t: 7,
	                e: "c-stats-table",
	                m: [{
	                  n: "rowIndexes",
	                  f: "true",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "data",
	                  f: [{
	                    t: 2,
	                    x: {
	                      r: ["topPackages"],
	                      s: "_0.slice(0,10)"
	                    }
	                  }],
	                  t: 13
	                }],
	                f: [],
	                p: {
	                  column1: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "href",
	                      f: ["/package/", {
	                        t: 2,
	                        r: "type"
	                      }, "/", {
	                        t: 2,
	                        r: "name"
	                      }],
	                      t: 13
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "span",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "prefix",
	                        g: 1
	                      }],
	                      f: [{
	                        t: 2,
	                        r: "type"
	                      }, "/"]
	                    }, " ", {
	                      t: 2,
	                      r: "name"
	                    }]
	                  }]
	                }
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "btn-link-to bottom",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "btn-arrow",
	                  g: 1
	                }, {
	                  n: "href",
	                  f: "/statistics",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "span",
	                  f: ["See more stats"]
	                }, " ", {
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: "width",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/icons/arrow-right.svg"],
	                    t: 13
	                  }]
	                }]
	              }]
	            }]
	          }]
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "section",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "endpoints wrapper-lg",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "endpoints_content",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "h5",
	          f: ["Custom CDN Endpoints"]
	        }, " ", {
	          t: 7,
	          e: "span",
	          f: ["jsDelivr is happy to support unique OSS use-cases that require a fast CDN"]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "btn-link-to",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "a",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "btn-arrow",
	              g: 1
	            }, {
	              n: "href",
	              f: "/oss-cdn",
	              t: 13,
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "span",
	              f: ["Explore all custom endpoints"]
	            }, " ", {
	              t: 7,
	              e: "img",
	              m: [{
	                n: "width",
	                f: "20",
	                t: 13,
	                g: 1
	              }, {
	                n: "height",
	                f: "20",
	                t: 13,
	                g: 1
	              }, {
	                n: "src",
	                f: [{
	                  t: 2,
	                  r: "@shared.assetsHost"
	                }, "/img/icons/arrow-right.svg"],
	                t: 13
	              }]
	            }]
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "endpoints_list",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "endpoints_list_wrapper",
	            g: 1
	          }],
	          f: [{
	            t: 4,
	            f: [{
	              t: 7,
	              e: "c-proxy-data-card",
	              m: [{
	                n: "jsDelivrLink",
	                f: [{
	                  t: 2,
	                  r: "jsDelivrLink"
	                }],
	                t: 13
	              }, {
	                n: "apiName",
	                f: [{
	                  t: 2,
	                  r: "apiCdnName"
	                }],
	                t: 13
	              }, {
	                n: "period",
	                f: "month",
	                t: 13,
	                g: 1
	              }, {
	                n: "bandwidthUnit",
	                f: "GB",
	                t: 13,
	                g: 1
	              }, {
	                n: "imgSrc",
	                f: [{
	                  t: 2,
	                  r: "imgSrc"
	                }],
	                t: 13
	              }, {
	                n: "imgWidth",
	                f: [{
	                  t: 2,
	                  r: "imgWidth"
	                }],
	                t: 13
	              }, {
	                n: "imgHeight",
	                f: [{
	                  t: 2,
	                  r: "imgHeight"
	                }],
	                t: 13
	              }],
	              f: []
	            }],
	            n: 52,
	            r: "ossCdnProjects"
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "btn-link-to bottom",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "a",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "btn-arrow",
	            g: 1
	          }, {
	            n: "href",
	            f: "/oss-cdn",
	            t: 13,
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "span",
	            f: ["Explore all custom endpoints"]
	          }, " ", {
	            t: 7,
	            e: "img",
	            m: [{
	              n: "width",
	              f: "20",
	              t: 13,
	              g: 1
	            }, {
	              n: "height",
	              f: "20",
	              t: 13,
	              g: 1
	            }, {
	              n: "src",
	              f: [{
	                t: 2,
	                r: "@shared.assetsHost"
	              }, "/img/icons/arrow-right.svg"],
	              t: 13
	            }]
	          }]
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "container-fluid container-mw",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "row",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "divider",
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "col-xs-12",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "section",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "sponsors wrapper-lg",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "sponsors_content",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "h5",
	                f: ["jsDelivr is used by millions of websites globally"]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "btn-link-to",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "btn-arrow",
	                    g: 1
	                  }, {
	                    n: "href",
	                    f: "/become-a-sponsor",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "span",
	                    f: ["Become a sponsor"]
	                  }, " ", {
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "width",
	                      f: "20",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "20",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/icons/arrow-right.svg"],
	                      t: 13
	                    }]
	                  }]
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                n: "class",
	                f: ["sponsors_sponsors-list ", {
	                  t: 4,
	                  f: ["expanded"],
	                  n: 50,
	                  r: "showMoreExLogo"
	                }],
	                t: 13
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "sponsors_sponsors-list_list-wrapper",
	                  g: 1
	                }],
	                f: [{
	                  t: 4,
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/landing/new/external-websites/", {
	                        t: 2,
	                        r: ".image"
	                      }],
	                      t: 13
	                    }, {
	                      n: "loading",
	                      f: "lazy",
	                      t: 13,
	                      g: 1
	                    }]
	                  }],
	                  n: 52,
	                  r: "exWebLogo"
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "sponsors_sponsors-list_gradient",
	                  g: 1
	                }]
	              }, " ", {
	                t: 7,
	                e: "button",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "btn-more btn-grey",
	                  g: 1
	                }, {
	                  n: ["click"],
	                  t: 70,
	                  f: {
	                    r: ["@this", "showMoreExLogo"],
	                    s: "[_0.set(\"showMoreExLogo\",!_1)]"
	                  }
	                }],
	                f: [{
	                  t: 4,
	                  f: ["Load more"],
	                  n: 50,
	                  x: {
	                    r: ["showMoreExLogo"],
	                    s: "!_0"
	                  }
	                }, {
	                  t: 4,
	                  f: ["Show less"],
	                  n: 51,
	                  l: 1
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "btn-link-to bottom",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "btn-arrow",
	                  g: 1
	                }, {
	                  n: "href",
	                  f: "/become-a-sponsor",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "span",
	                  f: ["Become a sponsor"]
	                }, " ", {
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: "width",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/icons/arrow-right.svg"],
	                    t: 13
	                  }]
	                }]
	              }]
	            }]
	          }]
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "fireworks",
	        g: 1
	      }]
	    }]
	  }],
	  e: {
	    "_0.formatNumber(_1)": function (_0, _1) {
	      return _0.formatNumber(_1);
	    },
	    "[_0.set(\"activeTab\",\"entrypoints\")]": function (_0) {
	      return [_0.set("activeTab", "entrypoints")];
	    },
	    "_0===\"entrypoints\"": function (_0) {
	      return _0 === "entrypoints";
	    },
	    "[_0.set(\"activeTab\",\"versions\")]": function (_0) {
	      return [_0.set("activeTab", "versions")];
	    },
	    "_0===\"versions\"": function (_0) {
	      return _0 === "versions";
	    },
	    "[_0.set(\"activeTab\",\"files\")]": function (_0) {
	      return [_0.set("activeTab", "files")];
	    },
	    "_0===\"files\"": function (_0) {
	      return _0 === "files";
	    },
	    "[_0.set(\"activeTab\",_1)]": function (_0, _1) {
	      return [_0.set("activeTab", _1)];
	    },
	    "_0!==null": function (_0) {
	      return _0 !== null;
	    },
	    "[_0.runEsmDemo(_1)]": function (_0, _1) {
	      return [_0.runEsmDemo(_1)];
	    },
	    "_0.slice(0,10)": function (_0) {
	      return _0.slice(0, 10);
	    },
	    "[_0.set(\"showMoreExLogo\",!_1)]": function (_0, _1) {
	      return [_0.set("showMoreExLogo", !_1)];
	    },
	    "!_0": function (_0) {
	      return !_0;
	    }
	  }
	};
	component$L.exports.components = {
	  "c-proxy-data-card": proxyDataCard,
	  "c-slide": slide,
	  "c-slider": slider,
	  "c-stats-table": statsTable,
	  "c-new-infographic-banner": newInfographicBanner
	};
	var landingBottom = ractive__default["default"].extend(component$L.exports);

	var component$K = {
	  exports: {}
	};
	component$K.exports = {
	  oninit() {
	    this.on('c-header.main-logo-click', () => {
	      this.set('query', '');
	      return false;
	    });
	  }
	};
	component$K.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "r-page",
	    m: [{
	      n: "noYield",
	      f: [{
	        t: 2,
	        r: "noYield"
	      }],
	      t: 13
	    }, {
	      n: "title",
	      f: [{
	        t: 2,
	        r: "title"
	      }],
	      t: 13
	    }, {
	      n: "description",
	      f: [{
	        t: 2,
	        r: "description"
	      }],
	      t: 13
	    }],
	    f: [" ", {
	      t: 7,
	      e: "c-notification"
	    }, " ", {
	      t: 7,
	      e: "c-header"
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "home",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "c-header-gradient",
	        m: [{
	          n: "showMap",
	          f: [{
	            t: 2,
	            x: {
	              r: [],
	              s: "true"
	            }
	          }],
	          t: 13
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "p-index page",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "c-landing-top",
	          m: [{
	            n: "activeDocs",
	            f: [{
	              t: 2,
	              r: "docs"
	            }],
	            t: 13
	          }]
	        }, " ", {
	          t: 7,
	          e: "c-search",
	          m: [{
	            n: "__ready",
	            f: [{
	              t: 2,
	              r: "__ready"
	            }],
	            t: 13
	          }, {
	            n: "hideLanding",
	            f: [{
	              t: 2,
	              r: "hideLanding"
	            }],
	            t: 13
	          }, {
	            n: "page",
	            f: [{
	              t: 2,
	              r: "page"
	            }],
	            t: 13
	          }, {
	            n: "query",
	            f: [{
	              t: 2,
	              r: "query"
	            }],
	            t: 13
	          }, {
	            n: "type",
	            f: [{
	              t: 2,
	              r: "type"
	            }],
	            t: 13
	          }, {
	            n: "style",
	            f: [{
	              t: 2,
	              r: "style"
	            }],
	            t: 13
	          }, {
	            n: "caretPosition",
	            f: [{
	              t: 2,
	              r: "caretPosition"
	            }],
	            t: 13
	          }]
	        }, " ", {
	          t: 4,
	          f: [{
	            t: 7,
	            e: "c-landing-bottom"
	          }],
	          n: 51,
	          r: "~/hideLanding"
	        }]
	      }, " ", {
	        t: 7,
	        e: "c-footer"
	      }]
	    }],
	    p: {
	      seo: [{
	        t: 7,
	        e: "script",
	        m: [{
	          n: "type",
	          f: "application/ld+json",
	          t: 13,
	          g: 1
	        }],
	        f: ["\t\t[\n\t\t\t{\n\t\t\t\t\"@context\": \"http://schema.org\",\n\t\t\t\t\"@type\": \"Organization\",\n\t\t\t\t\"url\": \"https://www.jsdelivr.com/\",\n\t\t\t\t\"sameAs\": [\n\t\t\t\t\t\"https://www.linkedin.com/company/jsdelivr/\",\n\t\t\t\t\t\"https://twitter.com/jsdelivr\",\n\t\t\t\t\t\"https://en.wikipedia.org/wiki/JSDelivr\"\n\t\t\t\t],\n\t\t\t\t\"@id\": \"#organization\",\n\t\t\t\t\"name\": \"jsDelivr\",\n\t\t\t\t\"alternateName\": \"JSDelivr\",\n\t\t\t\t\"foundingDate\": \"2012-04-10\",\n\t\t\t\t\"logo\": \"https://www.jsdelivr.com/icon_256x256.png\",\n\t\t\t\t\"founders\": [\n\t\t\t\t\t\"Dmitriy Akulov\"\n\t\t\t\t],\n\t\t\t\t\"numberOfEmployees\": \"5\"\n\t\t\t},\n\t\t\t{\n\t\t\t\t\"@context\": \"https://schema.org\",\n\t\t\t\t\"@type\": \"WebSite\",\n\t\t\t\t\"url\": \"https://www.jsdelivr.com/\",\n\t\t\t\t\"potentialAction\": {\n\t\t\t\t\t\"@type\": \"SearchAction\",\n\t\t\t\t\t\"target\": {\n\t\t\t\t\t\t\"@type\": \"EntryPoint\",\n\t\t\t\t\t\t\"urlTemplate\": \"https://www.jsdelivr.com/?query={search_term_string}\"\n\t\t\t\t\t},\n\t\t\t\t\t\"query-input\": \"required name=search_term_string\"\n\t\t\t\t}\n\t\t\t}\n\t\t]\n\t"]
	      }]
	    }
	  }],
	  e: {
	    "true": function () {
	      return true;
	    }
	  }
	};
	component$K.exports.components = {
	  "c-header-gradient": headerGradient,
	  "c-search": search_1,
	  "c-notification": notification,
	  "c-landing-top": landingTop,
	  "c-landing-bottom": landingBottom,
	  "c-footer": footer,
	  "c-header": header,
	  "r-page": rPage
	};
	var _index = ractive__default["default"].extend(component$K.exports);

	var component$J = {
	  exports: {}
	};
	const providers = Object.values(providerData).filter(provider => provider.enabled);
	const xIndexes = {
	  GCore: 1,
	  Cloudflare: 2,
	  Fastly: 3,
	  Bunny: 4
	};
	const getProvider = location => providers.find(provider => location.title.startsWith(provider.name));
	let infoWindows = [];
	let markers = [];
	let map;
	component$J.exports = {
	  computed: {
	    locations() {
	      return this.get('allLocations').filter(location => {
	        let p = getProvider(location);
	        return providers.some((provider, index) => {
	          return provider === p && this.get('enabled')[index];
	        });
	      });
	    }
	  },
	  data() {
	    return {
	      providers,
	      enabled: providers.map(() => true),
	      title: 'Our Network - jsDelivr',
	      description: 'jsDelivr uses Cloudflare, Fastly, Bunny, and Gcore, as well as custom servers in locations where CDNs have little or no presence.',
	      allLocations: []
	    };
	  },
	  oninit() {
	    if (!ractive__default["default"].isServer) {
	      fetch(`${this.get('@shared.assetsHost')}/js/map/map.json`).then(r => r.json()).then(locations => {
	        this.set('allLocations', locations.sort((a, b) => a.title > b.title ? -1 : a.title < b.title));
	      });
	    }
	  },
	  initMap() {
	    infoWindows.splice(0);
	    markers.splice(0);
	    let mq = window.matchMedia('(min-width: 768px)');
	    let CENTER = {
	      lat: 48,
	      lng: 16
	    };
	    map = new google.maps.Map(this.find('.network-map'), {
	      zoom: 3.74,
	      center: CENTER,
	      mapTypeId: 'roadmap',
	      draggableCursor: 'default',
	      mapTypeControl: false,
	      streetViewControl: false,
	      fullscreenControl: false,
	      mapId: 'ce04bbf9d49b6f34'
	    });
	    if (mq.matches) {
	      CENTER = {
	        lat: 30,
	        lng: 18
	      };
	      map.setZoom(2.14);
	    }
	    this.observe('locations', () => {
	      this.updateMarkers();
	    });
	  },
	  onrender() {
	    this.set('@shared.googleMapsLoaded', true);
	    if (app.loaded) {
	      setTimeout(this.initMap.bind(this));
	    }
	  },
	  updateMarkers() {
	    let locations = this.get('locations');
	    let added = [],
	      removed = [];

	    // Compute added and removed markers.
	    // Don't do anything with markers that haven't changed (re-rendering everything is too slow).
	    locations.forEach((location, index) => {
	      if (!infoWindows.some(iw => location.title === iw.content)) {
	        added.push(index);
	      }
	    });
	    infoWindows.forEach((iw, index) => {
	      if (!locations.some(location => location.title === iw.content)) {
	        removed.push(index);
	      }
	    });

	    // Remove old markers.
	    removed.forEach(index => {
	      infoWindows[index].close();
	      markers[index].setMap(null);
	      infoWindows[index] = null;
	      markers[index] = null;
	    });
	    infoWindows = infoWindows.filter(v => v);
	    markers = markers.filter(v => v);

	    // Add new markers.
	    added.forEach(index => {
	      let location = locations[index];
	      let infoWindow = new google.maps.InfoWindow({
	        content: location.title
	      });
	      let markerContent = document.createElement('div');
	      markerContent.style.backgroundImage = `url(${this.get('@shared.assetsHost')}/img/features/map-${getProvider(location).name.toLowerCase()}.svg)`;
	      markerContent.style.backgroundRepeat = 'no-repeat';
	      markerContent.style.backgroundPosition = 'center';
	      markerContent.style.backgroundSize = 'contain';
	      markerContent.style.width = '14px';
	      markerContent.style.height = '14px';
	      markerContent.title = location.title;
	      let marker = new google.maps.marker.AdvancedMarkerElement({
	        map,
	        content: markerContent,
	        position: new google.maps.LatLng(location.latitude, location.longitude),
	        zIndex: xIndexes[getProvider(location).name]
	      });
	      google.maps.event.addListener(marker, 'click', () => {
	        infoWindows.forEach(iw => iw.close());
	        infoWindow.open(map, marker);
	      });
	      google.maps.event.addListener(map, 'click', () => {
	        infoWindow.close();
	      });
	      infoWindows.push(infoWindow);
	      markers.push(marker);
	    });
	  },
	  toggleMap(key) {
	    this.toggle(ractive__default["default"].joinKeys('enabled', key));
	    return false;
	  }
	};
	component$J.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "r-page",
	    m: [{
	      n: "noYield",
	      f: [{
	        t: 2,
	        r: "noYield"
	      }],
	      t: 13
	    }, {
	      n: "title",
	      f: [{
	        t: 2,
	        r: "title"
	      }],
	      t: 13
	    }, {
	      n: "description",
	      f: [{
	        t: 2,
	        r: "description"
	      }],
	      t: 13
	    }],
	    f: [{
	      t: 7,
	      e: "style",
	      f: ["\t\t", {
	        t: 4,
	        f: ["\n\t\t\t.", {
	          t: 2,
	          r: "name"
	        }, ".switch-inline + label:before {\n\t\t\t\tbackground-color: ", {
	          t: 2,
	          r: "color"
	        }, ";\n\t\t\t}\n\n\t\t\t.", {
	          t: 2,
	          r: "name"
	        }, ".switch-inline:checked + label {\n\t\t\t\tbackground-color: ", {
	          t: 2,
	          r: "color"
	        }, ";\n\t\t\t\tborder-color: ", {
	          t: 2,
	          r: "color"
	        }, ";\n\t\t\t}\n\n\t\t\t.", {
	          t: 2,
	          r: "name"
	        }, ".switch-inline:checked + label:before {\n\t\t\t\tbackground-color: #fff;\n\t\t\t}\n"],
	        n: 52,
	        r: "providers"
	      }, "\t"]
	    }, " ", {
	      t: 4,
	      f: [{
	        t: 7,
	        e: "script",
	        f: ["\t\t\tfunction onDocumentReady (fn) {\n\t\t\t\tif (document.readyState !== 'loading') {\n\t\t\t\t\tfn();\n\t\t\t\t} else {\n\t\t\t\t\tdocument.addEventListener('DOMContentLoaded', fn);\n\t\t\t\t}\n\t\t\t}\n\t\t\t/* eslint-disable */\n\t\t\tfunction initMap () {\n\t\t\t\tonDocumentReady(function () {\n\t\t\t\t\tapp.loaded = true;\n\n\t\t\t\t\tif (app.router.route && app.router.route.view && app.router.route.view.initMap) {\n\t\t\t\t\t\tapp.router.route.view.initMap();\n\t\t\t\t\t}\n\t\t\t\t});\n\t\t\t}\n\t\t"]
	      }, " ", {
	        t: 7,
	        e: "script",
	        m: [{
	          n: "src",
	          f: "https://maps.googleapis.com/maps/api/js?key=AIzaSyBTICLY5LgWNJ0Uly61Q1sNXz_1KZIECwg&language=en&callback=initMap&libraries=marker&loading=async",
	          t: 13,
	          g: 1
	        }, {
	          n: "async",
	          f: 0,
	          t: 13
	        }]
	      }],
	      n: 50,
	      x: {
	        r: ["@shared.isServer", "@shared.googleMapsLoaded"],
	        s: "!_0&&!_1"
	      }
	    }, " ", {
	      t: 7,
	      e: "c-notification"
	    }, " ", {
	      t: 7,
	      e: "c-header"
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "p-network",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "map-wrapper",
	          g: 1
	        }, {
	          n: "id",
	          f: "map",
	          t: 13,
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "h1",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "page-title",
	            g: 1
	          }],
	          f: ["Network"]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            n: "class",
	            f: ["network-controls network-controls_type-", {
	              t: 2,
	              r: "providers.length"
	            }],
	            t: 13
	          }],
	          f: [{
	            t: 4,
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                n: "class",
	                f: ["network-controls_switcher ", {
	                  t: 4,
	                  f: ["unpaired"],
	                  n: 50,
	                  x: {
	                    r: ["idx", "providers.length"],
	                    s: "_1-1==_0&&_1%2!=0"
	                  }
	                }],
	                t: 13
	              }],
	              f: [{
	                t: 7,
	                e: "input",
	                m: [{
	                  n: "class",
	                  f: ["switch-inline ", {
	                    t: 2,
	                    r: "name"
	                  }],
	                  t: 13
	                }, {
	                  n: "type",
	                  f: "checkbox",
	                  t: 13
	                }, {
	                  n: "id",
	                  f: ["provider-", {
	                    t: 2,
	                    r: "name"
	                  }],
	                  t: 13
	                }, {
	                  n: "checked",
	                  f: [{
	                    t: 2,
	                    rx: {
	                      r: "~/enabled",
	                      m: [{
	                        t: 30,
	                        n: "idx"
	                      }]
	                    }
	                  }],
	                  t: 13
	                }, {
	                  t: 73,
	                  v: "t",
	                  f: "false"
	                }]
	              }, " ", {
	                t: 7,
	                e: "label",
	                m: [{
	                  n: "for",
	                  f: ["provider-", {
	                    t: 2,
	                    r: "name"
	                  }],
	                  t: 13
	                }, {
	                  n: ["click"],
	                  t: 70,
	                  f: {
	                    r: ["@this", "idx"],
	                    s: "[_0.toggleMap(_1)]"
	                  }
	                }]
	              }, {
	                t: 2,
	                r: "name"
	              }]
	            }],
	            n: 52,
	            i: "idx",
	            r: "providers"
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "network-map",
	            g: 1
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "content-wrapper",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "section",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "content-wrapper_section",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "h2",
	            f: ["Production ready"]
	          }, " ", {
	            t: 7,
	            e: "p",
	            f: ["Unlike the competition, jsDelivr uses a unique Multi-CDN infrastructure built on top of CDN networks provided by Cloudflare, Fastly, Bunny, and GCore. Additionally, we use custom servers in locations where CDNs have little or no presence."]
	          }, " ", {
	            t: 7,
	            e: "br"
	          }, " ", {
	            t: 7,
	            e: "p",
	            f: ["Our smart load balancing system ensures the best possible uptime and the best possible performance. Each time a user downloads a file from jsDelivr, our algorithm figures out the optimal provider for that particular user and that particular time based on the performance and availability data for the last few minutes. All that happens within a few milliseconds."]
	          }, " ", {
	            t: 7,
	            e: "br"
	          }, " ", {
	            t: 7,
	            e: "p",
	            f: ["This algorithm also immediately responds to performance degradation. For example, if a CDN provider gets DDoSed in Europe and their response times increase, jsDelivr will notice the change and simply stop using this provider in Europe but still consider it for users in other locations."]
	          }]
	        }, " ", {
	          t: 7,
	          e: "c-new-infographic-banner"
	        }, " ", {
	          t: 7,
	          e: "section",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "content-wrapper_section",
	            g: 1
	          }, {
	            n: "id",
	            f: "failover",
	            t: 13,
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "h2",
	            f: ["Failover on every layer"]
	          }, " ", {
	            t: 7,
	            e: "p",
	            f: ["We use two independent DNS providers. For jsDelivr to go down, both of these companies would have to go down at the same time. Both of our DNS providers monitor our load-balanced endpoint and if they detect problems they automatically switch all traffic to a single CDN provider."]
	          }, " ", {
	            t: 7,
	            e: "br"
	          }, " ", {
	            t: 7,
	            e: "p",
	            f: ["Our load-balancer monitors the uptime of all CDN providers using both RUM and synthetic data. If any of those detect downtime or performance degradation, the affected CDN provider is removed immediately."]
	          }, " ", {
	            t: 7,
	            e: "br"
	          }, " ", {
	            t: 7,
	            e: "p",
	            f: ["Our origin servers are located in several data-centers in different states. If a server goes down, the CDNs automatically switch to the remaining healthy servers."]
	          }, " ", {
	            t: 7,
	            e: "br"
	          }, " ", {
	            t: 7,
	            e: "p",
	            f: ["In total, we have one of the most resilient systems out there, ready to be used in production by even the largest websites."]
	          }]
	        }, " ", {
	          t: 7,
	          e: "section",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "content-wrapper_section",
	            g: 1
	          }, {
	            n: "id",
	            f: "china",
	            t: 13,
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "h2",
	            f: ["Low latency \"Near China\" network"]
	          }, " ", {
	            t: 7,
	            e: "p",
	            f: ["jsDelivr has multiple locations close Chinese urban centers to ensure low latency and high performance for all Chinese users."]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "china-map",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "img",
	              m: [{
	                n: "src",
	                f: [{
	                  t: 2,
	                  r: "@shared.assetsHost"
	                }, "/img/network/china-map.svg"],
	                t: 13
	              }, {
	                n: "loading",
	                f: "lazy",
	                t: 13,
	                g: 1
	              }]
	            }]
	          }]
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "c-footer"
	    }]
	  }],
	  e: {
	    "!_0&&!_1": function (_0, _1) {
	      return !_0 && !_1;
	    },
	    "_1-1==_0&&_1%2!=0": function (_0, _1) {
	      return _1 - 1 == _0 && _1 % 2 != 0;
	    },
	    "[_0.toggleMap(_1)]": function (_0, _1) {
	      return [_0.toggleMap(_1)];
	    }
	  }
	};
	component$J.exports.components = {
	  "c-new-infographic-banner": newInfographicBanner,
	  "c-notification": notification,
	  "c-footer": footer,
	  "c-header": header,
	  "r-page": rPage
	};
	var network = ractive__default["default"].extend(component$J.exports);

	var component$I = {
	  exports: {}
	};
	component$I.exports.template = {
	  v: 4,
	  t: [{
	    t: 4,
	    f: [{
	      t: 8,
	      r: "page"
	    }],
	    n: 50,
	    x: {
	      r: ["@shared.isServer"],
	      s: "!_0"
	    }
	  }, {
	    t: 4,
	    f: [{
	      t: 18,
	      a: " html"
	    }, " ", {
	      t: 7,
	      e: "html",
	      m: [{
	        n: "lang",
	        f: "en",
	        t: 13,
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "head",
	        f: [{
	          t: 7,
	          e: "meta",
	          m: [{
	            n: "charset",
	            f: "utf-8",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "meta",
	          m: [{
	            n: "name",
	            f: "viewport",
	            t: 13,
	            g: 1
	          }, {
	            n: "content",
	            f: "width=device-width, initial-scale=1",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "meta",
	          m: [{
	            n: "name",
	            f: "description",
	            t: 13,
	            g: 1
	          }, {
	            n: "content",
	            f: "jsDelivr uses multiple DNS, CDN, and web hosting providers to deliver the most reliable service possible.",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "meta",
	          m: [{
	            n: "name",
	            f: "keywords",
	            t: 13,
	            g: 1
	          }, {
	            n: "content",
	            f: "jsdelivr, cdn, npm, github, js, javascript, free, open source, oss",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "title",
	          f: ["How jsDelivr works"]
	        }, " ", {
	          t: 7,
	          e: "link",
	          m: [{
	            n: "rel",
	            f: "stylesheet",
	            t: 13,
	            g: 1
	          }, {
	            n: "href",
	            f: [{
	              t: 2,
	              r: "@shared.assetsHost"
	            }, "/css/app.css?v=", {
	              t: 2,
	              r: "@shared.assetsVersion"
	            }],
	            t: 13
	          }]
	        }, " ", {
	          t: 7,
	          e: "link",
	          m: [{
	            n: "rel",
	            f: "sitemap",
	            t: 13,
	            g: 1
	          }, {
	            n: "href",
	            f: "/sitemap/index.xml",
	            t: 13,
	            g: 1
	          }, {
	            n: "type",
	            f: "application/xml",
	            t: 13,
	            g: 1
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "body",
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            n: "id",
	            f: "page",
	            t: 13,
	            g: 1
	          }],
	          f: [{
	            t: 8,
	            r: "page"
	          }]
	        }, " ", {
	          t: 7,
	          e: "script",
	          m: [{
	            n: "defer",
	            f: 0,
	            t: 13
	          }, {
	            n: "data-domain",
	            f: "jsdelivr.com",
	            t: 13,
	            g: 1
	          }, {
	            n: "src",
	            f: "https://datum.jsdelivr.com/js/script.js",
	            t: 13,
	            g: 1
	          }]
	        }]
	      }]
	    }],
	    n: 51,
	    l: 1
	  }],
	  p: {
	    page: [{
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "p-network-infographic",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "img",
	        m: [{
	          n: "width",
	          f: "1140",
	          t: 13,
	          g: 1
	        }, {
	          n: "src",
	          f: [{
	            t: 2,
	            r: "@shared.assetsHost"
	          }, "/img/network/infographics.png?v=", {
	            t: 2,
	            r: "@shared.assetsVersion"
	          }],
	          t: 13
	        }, {
	          n: "srcset",
	          f: [{
	            t: 2,
	            r: "@shared.assetsHost"
	          }, "/img/network/infographics@2x.png?v=", {
	            t: 2,
	            r: "@shared.assetsVersion"
	          }, " 2x"],
	          t: 13
	        }]
	      }]
	    }]
	  },
	  e: {
	    "!_0": function (_0) {
	      return !_0;
	    }
	  }
	};
	var infographic = ractive__default["default"].extend(component$I.exports);

	var component$H = {
	  exports: {}
	};
	component$H.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      t: 13,
	      n: "class",
	      f: "c-coming-soon",
	      g: 1
	    }],
	    f: [{
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "container",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "h1",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "page-title",
	          g: 1
	        }],
	        f: [{
	          t: 2,
	          r: "title"
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "box box-featured",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "i",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "fa fa-envelope",
	            g: 1
	          }, {
	            n: "aria-hidden",
	            f: "true",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "span",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "box-headline",
	            g: 1
	          }],
	          f: ["Want to hear about the most important news?"]
	        }, " ", {
	          t: 7,
	          e: "a",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "box-action",
	            g: 1
	          }, {
	            n: "target",
	            f: "_blank",
	            t: 13,
	            g: 1
	          }, {
	            n: "rel",
	            f: "noopener noreferrer",
	            t: 13,
	            g: 1
	          }, {
	            n: "href",
	            f: "https://jsdelivr.us11.list-manage.com/subscribe?u=0c85fe2c9a60310df9a3d6751&id=283887f736",
	            t: 13,
	            g: 1
	          }],
	          f: ["Subscribe to our newsletter."]
	        }, " ", {
	          t: 7,
	          e: "span",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "box-note",
	            g: 1
	          }],
	          f: ["No more than a few emails per year."]
	        }]
	      }]
	    }]
	  }]
	};
	component$H.exports.components = {
	  "r-page": rPage
	};
	var comingSoon = ractive__default["default"].extend(component$H.exports);

	var component$G = {
	  exports: {}
	};
	component$G.exports = {
	  data() {
	    return {
	      title: 'The New jsDelivr'
	    };
	  }
	};
	component$G.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "r-page",
	    m: [{
	      n: "noYield",
	      f: [{
	        t: 2,
	        r: "noYield"
	      }],
	      t: 13
	    }, {
	      n: "title",
	      f: [{
	        t: 2,
	        r: "title"
	      }],
	      t: 13
	    }, {
	      n: "description",
	      f: [{
	        t: 2,
	        r: "description"
	      }],
	      t: 13
	    }],
	    f: [{
	      t: 7,
	      e: "c-notification"
	    }, " ", {
	      t: 7,
	      e: "c-header"
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "p-new-jsdelivr old-text-page",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "container",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "row",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "col-md-9",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "h1",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "page-title",
	                g: 1
	              }],
	              f: ["The new jsDelivr"]
	            }, " ", {
	              t: 7,
	              e: "section",
	              f: [{
	                t: 7,
	                e: "h3",
	                f: ["What happened?"]
	              }, " ", {
	                t: 7,
	                e: "p",
	                f: ["We switched from manual file uploads to a fully automated system. You can ", {
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    n: "href",
	                    f: "/features",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: ["read more about it here"]
	                }, "."]
	              }, " ", {
	                t: 7,
	                e: "h3",
	                f: ["As a user, do I need to do anything?"]
	              }, " ", {
	                t: 7,
	                e: "p",
	                f: ["No. All existing links will continue to work, and there is no action required on your end. However, the legacy projects no longer receive updates. To use the latest available version, you'll need to switch to one of our new endpoints."]
	              }, " ", {
	                t: 7,
	                e: "h3",
	                f: ["As a project author, do I need to do anything?"]
	              }, " ", {
	                t: 7,
	                e: "p",
	                f: ["Yes. You should update your documentation to use one of our new endpoints. New versions of your project won't be available at the legacy endpoint. Our new endpoints have many interesting features, including detailed project usage statistics!"]
	              }]
	            }]
	          }]
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "c-footer"
	    }]
	  }]
	};
	component$G.exports.components = {
	  "c-notification": notification,
	  "c-footer": footer,
	  "c-header": header,
	  "c-coming-soon": comingSoon,
	  "r-page": rPage
	};
	var newJsdelivr = ractive__default["default"].extend(component$G.exports);

	var component$F = {
	  exports: {}
	};
	component$F.exports = {
	  data() {
	    return {
	      _,
	      page: 0,
	      query: '',
	      packages: [],
	      currSelectedItemIdx: null,
	      pagination(page, nbPages) {
	        let start = Math.max(page - 2, 0);
	        let pages = [];
	        if (nbPages - page === 1) {
	          start = Math.max(Math.min(start, start - 1, start - 2), 0);
	        } else if (nbPages - page === 2) {
	          start = Math.max(Math.min(start, start - 1), 0);
	        }
	        for (let i = 0; i < 5 && start + i < nbPages; i++) {
	          pages.push(start + i);
	        }
	        return pages;
	      }
	    };
	  },
	  onrender() {
	    if (!this.isServer) {
	      let offsetTop = pageYOffset;
	      scrollTo(0, offsetTop);
	      let s = debounce(keypath => {
	        if (this.get('query')) {
	          search(this.get('query'), this.get('page'), 5).then(result => {
	            // The query might have changed since we sent the request.
	            if (result.query === this.get('query')) {
	              this.set('packages', result.response.hits, {
	                shuffle: 'name'
	              });
	              if (this.get('inputFocused')) {
	                this.set('searchOpened', true);
	              }
	              this.set({
	                fadeIn: true,
	                nbPages: result.response.nbPages,
	                nbHits: result.response.nbHits
	              });

	              // Scroll to the results.
	              if (!pageYOffset || keypath === 'page') {
	                this.scrollToSearch();
	              }
	            }
	          });
	        }
	      }, 40);

	      // Make sure query is always a string.
	      this.observe('query', value => {
	        if (typeof value !== 'string') {
	          this.set('query', String(value));
	        }
	      });

	      // Update results on input.
	      this.observe('page query __ready', (newValue, oldValue, keypath) => {
	        // Don't send requests before have all the data.
	        if (this.get('__ready')) {
	          // Reset page on query change.
	          if (keypath === 'query' && this.get('page') !== 0) {
	            this.set('page', 0);
	          } else if (!this.get('query')) {
	            this.set('searchOpened', false);
	            this.set('packages', []);
	          } else {
	            s(keypath);
	          }
	        }
	      });

	      // handle search input focus/blur
	      this.observe('inputFocused', isFocused => {
	        if (isFocused) {
	          this.set('searchOpened', !!this.get('query'));
	        } else {
	          let selectedEl = document.querySelector('.c-package-header-wrapper.selected');
	          if (selectedEl) {
	            selectedEl.classList.remove('selected');
	          }
	          this.set('currSelectedItemIdx', null);
	        }
	      });

	      // check if pagackes received and searchResults is opened
	      this.observe('searchOpened packages', () => {
	        let searchOpened = this.get('searchOpened');
	        let packages = this.get('packages');
	        if (searchOpened && packages.length) {
	          this.set('searchResulsOpened', true);
	        }
	      });

	      // once packages is received and search opened add listener to handle keyDown
	      this.observe('searchResulsOpened', isOpened => {
	        if (isOpened) {
	          setTimeout(() => {
	            let searchResultsEl = this.find('.c-search-compact-wrapper');
	            searchResultsEl.addEventListener('keydown', e => {
	              this.onKeyDown(e);
	              e.preventDefault();
	            });
	          }, 4);
	        }
	      });
	    }
	  },
	  onKeyDown(e) {
	    let listEl = this.find('.c-search-compact-wrapper');
	    if (!listEl) {
	      return;
	    }
	    let selectedItemEl = listEl.querySelector('.c-package-header-wrapper.selected');
	    let currSelectedItemIdx = this.get('currSelectedItemIdx');
	    let packages = this.get('packages');
	    if (e.key === 'ArrowDown') {
	      currSelectedItemIdx = currSelectedItemIdx === null ? 0 : currSelectedItemIdx + 1 > packages.length - 1 ? 0 : currSelectedItemIdx + 1;
	      this.set('currSelectedItemIdx', currSelectedItemIdx);
	    } else if (e.key === 'ArrowUp') {
	      currSelectedItemIdx = currSelectedItemIdx === null ? packages.length - 1 : currSelectedItemIdx - 1 < 0 ? packages.length - 1 : currSelectedItemIdx - 1;
	      this.set('currSelectedItemIdx', currSelectedItemIdx);
	    } else if (e.key === 'Enter') {
	      // if there is a selected element then go to the selected package page
	      if (currSelectedItemIdx !== null) {
	        app.router.dispatch(`/package/npm/${selectedItemEl.querySelector('.package-name').textContent}`);
	        return;
	      }

	      // otherwise navigate to the main page search
	      this.goTo(this.get('query'));
	    }
	  },
	  goTo(query) {
	    app.router.dispatch(`/?query=${encodeURIComponent(query)}`, {
	      state: {
	        caretPosition: this.find('.search-input').selectionStart
	      }
	    });
	  },
	  scrollToSearch() {
	    scrollTo({
	      top: 0,
	      left: Math.floor(this.find('.search-input').getBoundingClientRect().top / 100) * 100,
	      behavior: 'smooth'
	    });
	  },
	  handlePagination(pageNumber) {
	    this.set('page', pageNumber);
	    this.set('currSelectedItemIdx', 0);
	  }
	};
	component$F.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      n: "class",
	      f: ["c-search-compact ", {
	        t: 4,
	        f: ["active"],
	        n: 50,
	        r: "searchOpened"
	      }],
	      t: 13
	    }],
	    f: [{
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "search-input-wrapper",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "img",
	        m: [{
	          n: "width",
	          f: "20",
	          t: 13,
	          g: 1
	        }, {
	          n: "height",
	          f: "20",
	          t: 13,
	          g: 1
	        }, {
	          n: "src",
	          f: [{
	            t: 2,
	            r: "@shared.assetsHost"
	          }, "/img/icons/magnifier.svg"],
	          t: 13
	        }]
	      }, " ", {
	        t: 7,
	        e: "input",
	        m: [{
	          n: "type",
	          f: "text",
	          t: 13
	        }, {
	          n: "class",
	          f: "search-input",
	          t: 13
	        }, {
	          n: ["focus"],
	          t: 70,
	          f: {
	            r: ["@this"],
	            s: "[_0.set(\"inputFocused\",true)]"
	          }
	        }, {
	          n: ["blur"],
	          t: 70,
	          f: {
	            r: ["@this"],
	            s: "[_0.set(\"inputFocused\",false)]"
	          }
	        }, {
	          n: ["keydown"],
	          t: 70,
	          f: {
	            r: ["@this", "@event"],
	            s: "[_0.onKeyDown(_1)]"
	          }
	        }, {
	          n: "placeholder",
	          f: "search all of npm",
	          t: 13
	        }, {
	          n: "value",
	          f: [{
	            t: 2,
	            r: "query"
	          }],
	          t: 13
	        }, {
	          n: "spellcheck",
	          f: "false",
	          t: 13
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "c-search-compact-overlay",
	        g: 1
	      }, {
	        n: ["click"],
	        t: 70,
	        f: {
	          r: ["@this"],
	          s: "[_0.set(\"searchOpened\",false)]"
	        }
	      }]
	    }, " ", {
	      t: 4,
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "c-search-compact-wrapper",
	          g: 1
	        }, {
	          n: "tabindex",
	          f: "-1",
	          t: 13,
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "search-results",
	            g: 1
	          }],
	          f: [{
	            t: 4,
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                n: "class",
	                f: ["c-package-header-wrapper ", {
	                  t: 4,
	                  f: ["selected"],
	                  n: 50,
	                  x: {
	                    r: ["currSelectedItemIdx", "packIdx"],
	                    s: "_0==_1"
	                  }
	                }],
	                t: 13
	              }],
	              f: [{
	                t: 7,
	                e: "c-package-header",
	                m: [{
	                  n: "package",
	                  f: [{
	                    t: 2,
	                    r: "."
	                  }],
	                  t: 13
	                }, {
	                  n: "version",
	                  f: [{
	                    t: 2,
	                    r: "version"
	                  }],
	                  t: 13
	                }, {
	                  n: "query",
	                  f: [{
	                    t: 2,
	                    r: "query"
	                  }],
	                  t: 13
	                }, {
	                  n: "searchOpened",
	                  f: [{
	                    t: 2,
	                    r: "searchOpened"
	                  }],
	                  t: 13
	                }, {
	                  n: "packageNameAsLink",
	                  f: "true",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "showDownloads",
	                  f: "true",
	                  t: 13,
	                  g: 1
	                }],
	                f: []
	              }]
	            }],
	            n: 52,
	            i: "packIdx",
	            r: "packages"
	          }, {
	            t: 4,
	            f: [{
	              t: 7,
	              e: "p",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "c-search-compact-empty",
	                g: 1
	              }],
	              f: ["No results found"]
	            }],
	            n: 50,
	            x: {
	              r: ["query", "nbHits"],
	              s: "_0&&_1===0"
	            },
	            l: 1
	          }]
	        }, " ", {
	          t: 4,
	          f: [{
	            t: 7,
	            e: "nav",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "search-pagination",
	              g: 1
	            }, {
	              n: "aria-label",
	              f: "Search results pagination",
	              t: 13,
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "ul",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "pagination",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "li",
	                m: [{
	                  n: "style",
	                  f: [{
	                    t: 4,
	                    f: ["visibility: hidden;"],
	                    n: 51,
	                    r: "page"
	                  }],
	                  t: 13
	                }],
	                f: [{
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    n: ["click"],
	                    t: 70,
	                    f: {
	                      r: ["page", "@this"],
	                      s: "[_0>0&&_1.subtract(\"page\")]"
	                    }
	                  }, {
	                    n: "aria-label",
	                    f: "Previous",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "span",
	                    m: [{
	                      n: "aria-hidden",
	                      f: "true",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["«"]
	                  }]
	                }]
	              }, " ", {
	                t: 4,
	                f: [{
	                  t: 7,
	                  e: "li",
	                  m: [{
	                    n: "class",
	                    f: [{
	                      t: 4,
	                      f: ["active"],
	                      n: 50,
	                      x: {
	                        r: ["page", "."],
	                        s: "_0===_1"
	                      }
	                    }],
	                    t: 13
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: ["click"],
	                      t: 70,
	                      f: {
	                        r: ["@this", "."],
	                        s: "[_0.handlePagination(_1)]"
	                      }
	                    }],
	                    f: [{
	                      t: 2,
	                      x: {
	                        r: ["."],
	                        s: "_0+1"
	                      }
	                    }]
	                  }]
	                }],
	                n: 52,
	                x: {
	                  r: ["pagination", "page", "nbPages"],
	                  s: "_0(_1,_2)"
	                }
	              }, " ", {
	                t: 7,
	                e: "li",
	                m: [{
	                  n: "style",
	                  f: [{
	                    t: 4,
	                    f: ["visibility: hidden;"],
	                    n: 51,
	                    x: {
	                      r: ["page", "nbPages"],
	                      s: "_0+1<_1"
	                    }
	                  }],
	                  t: 13
	                }],
	                f: [{
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    n: ["click"],
	                    t: 70,
	                    f: {
	                      r: ["page", "nbPages", "@this"],
	                      s: "[_0+1<_1&&_2.add(\"page\")]"
	                    }
	                  }, {
	                    n: "aria-label",
	                    f: "Next",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "span",
	                    m: [{
	                      n: "aria-hidden",
	                      f: "true",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["»"]
	                  }]
	                }]
	              }]
	            }]
	          }],
	          n: 50,
	          x: {
	            r: ["query", "nbHits"],
	            s: "_0&&_1!==0"
	          }
	        }]
	      }],
	      n: 50,
	      r: "searchOpened"
	    }]
	  }],
	  e: {
	    "[_0.set(\"inputFocused\",true)]": function (_0) {
	      return [_0.set("inputFocused", true)];
	    },
	    "[_0.set(\"inputFocused\",false)]": function (_0) {
	      return [_0.set("inputFocused", false)];
	    },
	    "[_0.onKeyDown(_1)]": function (_0, _1) {
	      return [_0.onKeyDown(_1)];
	    },
	    "[_0.set(\"searchOpened\",false)]": function (_0) {
	      return [_0.set("searchOpened", false)];
	    },
	    "_0==_1": function (_0, _1) {
	      return _0 == _1;
	    },
	    "_0&&_1===0": function (_0, _1) {
	      return _0 && _1 === 0;
	    },
	    "[_0>0&&_1.subtract(\"page\")]": function (_0, _1) {
	      return [_0 > 0 && _1.subtract("page")];
	    },
	    "_0===_1": function (_0, _1) {
	      return _0 === _1;
	    },
	    "[_0.handlePagination(_1)]": function (_0, _1) {
	      return [_0.handlePagination(_1)];
	    },
	    "_0+1": function (_0) {
	      return _0 + 1;
	    },
	    "_0(_1,_2)": function (_0, _1, _2) {
	      return _0(_1, _2);
	    },
	    "_0+1<_1": function (_0, _1) {
	      return _0 + 1 < _1;
	    },
	    "[_0+1<_1&&_2.add(\"page\")]": function (_0, _1, _2) {
	      return [_0 + 1 < _1 && _2.add("page")];
	    },
	    "_0&&_1!==0": function (_0, _1) {
	      return _0 && _1 !== 0;
	    }
	  }
	};
	component$F.exports.components = {
	  "c-package-header": packageHeader
	};
	var searchCompact = ractive__default["default"].extend(component$F.exports);

	var component$E = {
	  exports: {}
	};
	const ID_PREFIX$2 = 'id-';
	component$E.exports = {
	  data() {
	    return {
	      _,
	      html: '',
	      safeHtmlToRender: ''
	    };
	  },
	  oninit() {
	    if (!ractive__default["default"].isServer) {
	      app.injectGlobalStyle('https://cdn.jsdelivr.net/gh/highlightjs/cdn-release@11.7.0/build/styles/github.min.css');
	      Promise.all([
	      // eslint-disable-next-line n/no-missing-import
	      import('https://cdn.jsdelivr.net/npm/dompurify@2.4.3/+esm')]).then(([{
	        default: DOMPurify
	      }]) => {
	        let _this = this;
	        DOMPurify.removeAllHooks();
	        DOMPurify.addHook('afterSanitizeAttributes', node => {
	          if (node.hasAttribute('href')) {
	            node.setAttribute('href', _.normalizeHref(node.getAttribute('href'), ID_PREFIX$2));
	          }
	          if (node.hasAttribute('src')) {
	            node.setAttribute('src', _.optimizeSrc(node.getAttribute('src'), _this.get('github')));
	            node.setAttribute('loading', 'lazy');
	          }
	          if ('target' in node) {
	            if (_.isExternalLink(node.getAttribute('href'))) {
	              node.setAttribute('target', '_blank');
	            }
	            node.setAttribute('rel', 'nofollow noopener noreferrer');
	            node.classList.add('router-ignore');
	          }
	        });

	        // if page URL has a hash then scroll page to the anchor
	        this.observe('safeHtmlToRender', () => {
	          // it appears the observer sometimes executes too soon despite defer: true, so we delay by one cycle here
	          setTimeout(() => {
	            let anchor = app.router.uri.hash;
	            let el = anchor ? this.find(anchor) : null;
	            if (el) {
	              if (document.visibilityState === 'visible') {
	                el.scrollIntoView({
	                  behavior: 'smooth'
	                });
	              } else {
	                document.addEventListener('visibilitychange', function listener() {
	                  el.scrollIntoView({
	                    behavior: 'smooth'
	                  });
	                  document.removeEventListener('visibilitychange', listener);
	                });
	              }
	            }
	          });
	        }, {
	          init: false,
	          defer: true
	        });
	        this.observe('html', html => {
	          this.set('safeHtmlToRender', DOMPurify.sanitize(html));
	        });
	      });
	    }
	  }
	};
	component$E.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      t: 13,
	      n: "class",
	      f: "c-html",
	      g: 1
	    }],
	    f: [{
	      t: 3,
	      r: "safeHtmlToRender"
	    }]
	  }]
	};
	var html = ractive__default["default"].extend(component$E.exports);

	var component$D = {
	  exports: {}
	};
	component$D.exports = {
	  computed: {
	    formatValue() {
	      let key = this.get('valueKey');
	      let isBandwidth = this.get('isBandwidth');
	      let data = this.get('data');
	      return _.getValueFormatter(isBandwidth, data.map(v => v[key]));
	    },
	    pageRange() {
	      let page = this.get('page');
	      let pageLimit = this.get('pageLimit');
	      let xTotalCount = this.get('xTotalCount');
	      let xTotalPages = this.get('xTotalPages');
	      let start = (page - 1) * pageLimit + 1;
	      let end = start + pageLimit - 1;
	      if (xTotalCount < end) {
	        end = xTotalCount;
	      }
	      return xTotalPages && xTotalCount ? `Records ${start} - ${end} of ${xTotalCount}` : 'Records 0 of 0';
	    },
	    preliminaryHeight() {
	      let pageLimit = this.get('pageLimit');
	      if (window.innerWidth < 1272) {
	        return pageLimit * 72;
	      }
	      return pageLimit * 40;
	    }
	  },
	  data() {
	    return {
	      desc: true,
	      data: [],
	      valueKey: 'hits',
	      page: 1,
	      pageLimit: 5,
	      paginationLimits: [5, 10, 15, 20],
	      xTotalCount: 0,
	      xTotalPages: 0,
	      noDataMsg: 'No available data',
	      contentHeight: null
	    };
	  },
	  oninit() {
	    if (!ractive__default["default"].isServer) {
	      this.observe('responseHeaders', responseHeaders => {
	        if (responseHeaders) {
	          this.set('xTotalCount', parseInt(responseHeaders['x-total-count']));
	          this.set('xTotalPages', parseInt(responseHeaders['x-total-pages']));
	        }
	      }, {
	        init: false
	      });
	      this.observe('responseData screenWidth', () => {
	        let responseData = this.get('responseData');
	        if (responseData.length) {
	          this.animate('data', responseData).then(() => {
	            let els = this.findAll('.table-body_content .table-row');
	            let contentHeight = 0;
	            els.forEach(el => {
	              contentHeight += el.offsetHeight;
	            });
	            this.set('contentHeight', contentHeight);
	          });
	        } else {
	          this.animate('data', null);
	        }
	      }, {
	        init: false
	      });
	      this.observe('pageLimit', (pageLimit, prevVal) => {
	        if (pageLimit !== prevVal) {
	          this.set('page', 1);
	          this.set('contentHeight', null);
	        }
	      }, {
	        init: false
	      });
	      this.observe('version', (version, prevVal) => {
	        let handleVersionChange = this.get('handleVersionChange');
	        if (handleVersionChange && version !== prevVal) {
	          this.set('page', 1);
	        }
	      }, {
	        init: false
	      });
	      listeners.screenWidthListener(this);
	    }
	  },
	  prevPage() {
	    let data = this.get('data');
	    if (!data || !data.length) {
	      return;
	    }
	    let page = this.get('page');
	    let value = page > 1 ? page - 1 : page;
	    this.set('page', value);
	  },
	  nextPage() {
	    let data = this.get('data');
	    if (!data || !data.length) {
	      return;
	    }
	    let page = this.get('page');
	    let xTotalPages = this.get('xTotalPages');
	    let value = page + 1 > xTotalPages ? page : page + 1;
	    this.set('page', value);
	  },
	  handlePageLimitChange(pageLimit) {
	    this.set('page', 1);
	    this.set('pageLimit', pageLimit);
	  }
	};
	component$D.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      t: 13,
	      n: "class",
	      f: "c-top-stats-table",
	      g: 1
	    }],
	    f: [{
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "table-wrapper",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "table-header",
	          g: 1
	        }],
	        f: [{
	          t: 4,
	          f: [{
	            t: 2,
	            r: "title"
	          }],
	          n: 50,
	          r: "title"
	        }, {
	          t: 4,
	          f: [{
	            t: 8,
	            r: "header"
	          }],
	          n: 51,
	          l: 1
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "table-body",
	          g: 1
	        }],
	        f: [{
	          t: 4,
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "table-body_content",
	              g: 1
	            }, {
	              n: "style",
	              f: ["height: ", {
	                t: 2,
	                x: {
	                  r: ["contentHeight", "preliminaryHeight"],
	                  s: "_0||_1"
	                }
	              }, "px;"],
	              t: 13
	            }],
	            f: [{
	              t: 4,
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  n: "class",
	                  f: ["table-row ", {
	                    t: 4,
	                    f: ["table-row_no-shadow"],
	                    n: 50,
	                    x: {
	                      r: ["responseData", "pageLimit", "responseData.length"],
	                      s: "_0&&_1===_2"
	                    }
	                  }],
	                  t: 13
	                }],
	                f: [{
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "file-name",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 8,
	                    r: "column1"
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "hits text-table-number",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 2,
	                    x: {
	                      r: ["~/formatValue", "valueKey", "."],
	                      s: "_0(_2[_1])"
	                    }
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "percentage-bar",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "div",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "table-chart",
	                      g: 1
	                    }, {
	                      n: "style-width",
	                      f: [{
	                        t: 2,
	                        x: {
	                          r: [".", "valueKey", "desc", "data.length", "data"],
	                          s: "(_0[_1]/_4[_2?0:_3-1][_1]*100)>2?_0[_1]/_4[_2?0:_3-1][_1]*100:2"
	                        }
	                      }, "%"],
	                      t: 13
	                    }],
	                    f: []
	                  }]
	                }]
	              }],
	              n: 52,
	              r: "~/data"
	            }]
	          }],
	          n: 50,
	          x: {
	            r: ["data"],
	            s: "_0!==null"
	          }
	        }, {
	          t: 4,
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "table-body_no-data-msg",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "img",
	              m: [{
	                n: "width",
	                f: "180",
	                t: 13,
	                g: 1
	              }, {
	                n: "height",
	                f: "152",
	                t: 13,
	                g: 1
	              }, {
	                n: "src",
	                f: [{
	                  t: 2,
	                  r: "@shared.assetsHost"
	                }, "/img/no-data-chart-main.svg"],
	                t: 13
	              }]
	            }, " ", {
	              t: 7,
	              e: "span",
	              f: [{
	                t: 2,
	                r: "noDataMsg"
	              }]
	            }]
	          }],
	          n: 51,
	          l: 1
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "table-body_pagination",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "table-body_pagination_range",
	              g: 1
	            }],
	            f: [{
	              t: 2,
	              r: "pageRange"
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "table-body_pagination_ctrls",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "button",
	              m: [{
	                n: ["click"],
	                t: 70,
	                f: {
	                  r: ["@this"],
	                  s: "[_0.prevPage()]"
	                }
	              }, {
	                n: "class",
	                f: ["table-body_pagination_ctrls_btn table-body_pagination_ctrls_btn-prev ", {
	                  t: 4,
	                  f: ["disabled"],
	                  n: 50,
	                  x: {
	                    r: ["page"],
	                    s: "_0===1"
	                  }
	                }],
	                t: 13
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "20",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "20",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/statistics/left.svg"],
	                  t: 13
	                }, {
	                  n: "loading",
	                  f: "lazy",
	                  t: 13,
	                  g: 1
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                n: "class",
	                f: ["table-body_pagination_ctrls_limit ", {
	                  t: 4,
	                  f: ["table-wrapper_pagination_ctrls_limit_disabled"],
	                  n: 50,
	                  x: {
	                    r: ["data", "data.length"],
	                    s: "_0&&!_1"
	                  }
	                }],
	                t: 13
	              }],
	              f: [{
	                t: 7,
	                e: "span",
	                f: ["Show:"]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "btn-group",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "button",
	                  m: [{
	                    n: "type",
	                    f: "button",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "class",
	                    f: ["btn dropdown-toggle ", {
	                      t: 4,
	                      f: ["disabled"],
	                      n: 50,
	                      x: {
	                        r: ["data", "data.length"],
	                        s: "_0&&!_1"
	                      }
	                    }],
	                    t: 13
	                  }, {
	                    n: "data-toggle",
	                    f: "dropdown",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "aria-haspopup",
	                    f: "true",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "aria-expanded",
	                    f: "false",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "span",
	                    f: [{
	                      t: 2,
	                      r: "pageLimit"
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "width",
	                      f: "20",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "20",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/statistics/left.svg"],
	                      t: 13
	                    }, {
	                      n: "loading",
	                      f: "lazy",
	                      t: 13,
	                      g: 1
	                    }]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "ul",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "dropdown-menu",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 4,
	                    f: [{
	                      t: 7,
	                      e: "li",
	                      f: [{
	                        t: 7,
	                        e: "a",
	                        m: [{
	                          n: ["click"],
	                          t: 70,
	                          f: {
	                            r: ["@this", "."],
	                            s: "[_0.handlePageLimitChange(_1)]"
	                          }
	                        }],
	                        f: [{
	                          t: 2,
	                          r: "."
	                        }]
	                      }]
	                    }],
	                    n: 52,
	                    r: "paginationLimits"
	                  }]
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "button",
	              m: [{
	                n: ["click"],
	                t: 70,
	                f: {
	                  r: ["@this"],
	                  s: "[_0.nextPage()]"
	                }
	              }, {
	                n: "class",
	                f: ["table-body_pagination_ctrls_btn table-body_pagination_ctrls_btn-next ", {
	                  t: 4,
	                  f: ["disabled"],
	                  n: 50,
	                  x: {
	                    r: ["page", "xTotalPages"],
	                    s: "_0===_1"
	                  }
	                }],
	                t: 13
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "20",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "20",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/statistics/right.svg"],
	                  t: 13
	                }, {
	                  n: "loading",
	                  f: "lazy",
	                  t: 13,
	                  g: 1
	                }]
	              }]
	            }]
	          }]
	        }]
	      }]
	    }]
	  }],
	  e: {
	    "_0||_1": function (_0, _1) {
	      return _0 || _1;
	    },
	    "_0&&_1===_2": function (_0, _1, _2) {
	      return _0 && _1 === _2;
	    },
	    "_0(_2[_1])": function (_0, _1, _2) {
	      return _0(_2[_1]);
	    },
	    "(_0[_1]/_4[_2?0:_3-1][_1]*100)>2?_0[_1]/_4[_2?0:_3-1][_1]*100:2": function (_0, _1, _2, _3, _4) {
	      return _0[_1] / _4[_2 ? 0 : _3 - 1][_1] * 100 > 2 ? _0[_1] / _4[_2 ? 0 : _3 - 1][_1] * 100 : 2;
	    },
	    "_0!==null": function (_0) {
	      return _0 !== null;
	    },
	    "[_0.prevPage()]": function (_0) {
	      return [_0.prevPage()];
	    },
	    "_0===1": function (_0) {
	      return _0 === 1;
	    },
	    "_0&&!_1": function (_0, _1) {
	      return _0 && !_1;
	    },
	    "[_0.handlePageLimitChange(_1)]": function (_0, _1) {
	      return [_0.handlePageLimitChange(_1)];
	    },
	    "[_0.nextPage()]": function (_0) {
	      return [_0.nextPage()];
	    },
	    "_0===_1": function (_0, _1) {
	      return _0 === _1;
	    }
	  }
	};
	component$D.exports.components = {
	  "c-version-dropdown": versionDropdown
	};
	var topStatsTable = ractive__default["default"].extend(component$D.exports);

	var component$C = {
	  exports: {}
	};
	component$C.exports = {
	  computed: {
	    filteredPeriods() {
	      let filterBy = this.get('filterBy');
	      let prepStatPeriods = this.get('prepStatPeriods');
	      if (filterBy) {
	        return filterBy.toLowerCase().split(' ').reduce((results, filterPart) => {
	          return results.filter(i => {
	            if (i.periodText) {
	              return i.periodText.toLowerCase().includes(filterPart);
	            }
	            return false;
	          });
	        }, [...prepStatPeriods]);
	      }
	      return prepStatPeriods;
	    }
	  },
	  data() {
	    return {
	      periodToDisplay: null,
	      prepStatPeriods: [],
	      filterPlaceholder: 'Filter periods',
	      nothingFoundMsg: 'No periods found',
	      dropdownOpened: false,
	      currSelectedItemIdx: null,
	      currentSelectedClass: 'selected'
	    };
	  },
	  oninit() {
	    if (!ractive__default["default"].isServer) {
	      this.observe('@shared.rawListStatPeriods', rawListStatPeriods => {
	        if (rawListStatPeriods) {
	          let prepStatPeriods = _.getPreparedListStatPeriods(rawListStatPeriods);
	          this.set('prepStatPeriods', prepStatPeriods);
	        }
	      });
	      this.observe('selectedValue prepStatPeriods', () => {
	        let selectedValue = this.get('selectedValue');
	        let prepStatPeriods = this.get('prepStatPeriods');
	        if (selectedValue && prepStatPeriods && prepStatPeriods.length) {
	          prepStatPeriods.forEach(prepPeriod => {
	            if (prepPeriod.periodValue === selectedValue) {
	              this.set('periodToDisplay', prepPeriod.periodText);
	            }
	          });
	        }
	      });
	    }
	  },
	  oncomplete() {
	    if (!ractive__default["default"].isServer) {
	      // close dropdown and clear filter on click outside the dropdown el
	      let el = this.find('.c-periods-dropdown');
	      let handleOnOutsideClick = event => {
	        let currDropdownOpened = this.get('dropdownOpened');
	        if (currDropdownOpened && !el.contains(event.target)) {
	          this.set('dropdownOpened', false);
	        }
	      };
	      listeners.addManagedListener(this, document, 'click', handleOnOutsideClick);
	      this.observe('dropdownOpened', newValue => {
	        let ul = this.find('.dropdown_body_list');
	        if (!ul) {
	          return;
	        }
	        if (newValue) {
	          this.set('calculatedListWidth', ul.getBoundingClientRect().width);
	          this.find('.dropdown_body_filter input').focus();
	          this.find('.dropdown_body_list_item.selected')?.scrollIntoView?.({
	            block: 'nearest'
	          });
	        } else {
	          this.set('calculatedListWidth', null);
	        }
	      }, {
	        defer: true
	      });
	      this.observe('currSelectedItemIdx', () => {
	        this.find('.dropdown_body_list_item.selected')?.scrollIntoView?.({
	          block: 'nearest'
	        });
	      }, {
	        defer: true
	      });
	    }
	  },
	  onKeyDown(e) {
	    let listEl = this.find('.dropdown_body_list');
	    if (!listEl) {
	      return;
	    }
	    let currSelectedItemIdx = this.get('currSelectedItemIdx');
	    let periods = this.get('filteredPeriods');
	    let periodToDisplay = this.get('periodToDisplay');

	    // start nav from the selected value position
	    currSelectedItemIdx === null && periods.some((p, pIdx) => {
	      if (p.periodText === periodToDisplay) {
	        currSelectedItemIdx = pIdx;
	        return true;
	      }
	      return false;
	    });
	    if (e.key === 'ArrowDown') {
	      currSelectedItemIdx = currSelectedItemIdx === null ? 0 : currSelectedItemIdx + 1 > periods.length - 1 ? periods.length - 1 : currSelectedItemIdx + 1;
	      if (periods[currSelectedItemIdx].periodType === 'separator') {
	        currSelectedItemIdx++;
	      }
	      this.set('currSelectedItemIdx', currSelectedItemIdx);
	    } else if (e.key === 'ArrowUp') {
	      currSelectedItemIdx = currSelectedItemIdx === null ? 0 : currSelectedItemIdx - 1 < 0 ? 0 : currSelectedItemIdx - 1;
	      if (periods[currSelectedItemIdx].periodType === 'separator') {
	        currSelectedItemIdx--;
	      }
	      this.set('currSelectedItemIdx', currSelectedItemIdx);
	    } else if (e.key === 'Enter') {
	      this.handleClick(periods[currSelectedItemIdx]);
	    } else {
	      this.set('currSelectedItemIdx', 0);
	    }
	  },
	  toggleDropdown() {
	    this.set('dropdownOpened', !this.get('dropdownOpened'));
	    this.set('currSelectedItemIdx', null);
	  },
	  handleClick(periodData) {
	    let selectHandler = this.get('selectHandler');
	    this.toggleDropdown();
	    selectHandler(periodData);
	  }
	};
	component$C.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      t: 13,
	      n: "class",
	      f: "c-periods-dropdown",
	      g: 1
	    }],
	    f: [{
	      t: 4,
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "dropdown_head",
	          g: 1
	        }],
	        f: [{
	          t: 4,
	          f: [{
	            t: 8,
	            r: "pinnedLabel"
	          }],
	          n: 50,
	          r: "pinnedLabel"
	        }, " ", {
	          t: 7,
	          e: "button",
	          m: [{
	            n: "class",
	            f: ["dropdown_head_selected ", {
	              t: 4,
	              f: ["opened"],
	              n: 50,
	              r: "dropdownOpened"
	            }],
	            t: 13
	          }, {
	            n: ["click"],
	            t: 70,
	            f: {
	              r: ["@this"],
	              s: "[_0.toggleDropdown()]"
	            }
	          }],
	          f: [{
	            t: 7,
	            e: "a",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "dropdown_head_selected_text",
	              g: 1
	            }],
	            f: [{
	              t: 2,
	              r: "periodToDisplay"
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "dropdown_head_selected_img-wrapper",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "img",
	              m: [{
	                n: "width",
	                f: "20",
	                t: 13,
	                g: 1
	              }, {
	                n: "height",
	                f: "20",
	                t: 13,
	                g: 1
	              }, {
	                n: "src",
	                f: [{
	                  t: 2,
	                  r: "@shared.assetsHost"
	                }, "/img/icons/", {
	                  t: 4,
	                  f: ["chevron-down.orange"],
	                  n: 50,
	                  x: {
	                    r: ["dropdownOpened", "useCustomIconStyles"],
	                    s: "_0&&!_1"
	                  }
	                }, {
	                  t: 4,
	                  f: ["chevron-down"],
	                  n: 51,
	                  l: 1
	                }, ".svg"],
	                t: 13
	              }, {
	                n: "loading",
	                f: "lazy",
	                t: 13,
	                g: 1
	              }]
	            }]
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          n: "class",
	          f: ["dropdown_body ", {
	            t: 4,
	            f: ["opened"],
	            n: 50,
	            r: "dropdownOpened"
	          }],
	          t: 13
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "dropdown_body_filter",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "img",
	            m: [{
	              n: "width",
	              f: "20",
	              t: 13,
	              g: 1
	            }, {
	              n: "height",
	              f: "20",
	              t: 13,
	              g: 1
	            }, {
	              n: "src",
	              f: [{
	                t: 2,
	                r: "@shared.assetsHost"
	              }, "/img/icons/magnifier.svg"],
	              t: 13
	            }]
	          }, " ", {
	            t: 7,
	            e: "input",
	            m: [{
	              n: "placeholder",
	              f: [{
	                t: 2,
	                r: "filterPlaceholder"
	              }],
	              t: 13
	            }, {
	              n: "value",
	              f: [{
	                t: 2,
	                r: "filterBy"
	              }],
	              t: 13
	            }, {
	              n: ["keydown"],
	              t: 70,
	              f: {
	                r: ["@this", "@event"],
	                s: "[_0.onKeyDown(_1)]"
	              }
	            }]
	          }]
	        }, " ", {
	          t: 4,
	          f: [{
	            t: 7,
	            e: "ul",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "dropdown_body_list",
	              g: 1
	            }, {
	              n: "style",
	              f: [{
	                t: 4,
	                f: ["min-width: ", {
	                  t: 2,
	                  r: "calculatedListWidth"
	                }, "px;"],
	                n: 50,
	                r: "calculatedListWidth"
	              }],
	              t: 13
	            }],
	            f: [{
	              t: 4,
	              f: [{
	                t: 4,
	                f: [{
	                  t: 7,
	                  e: "li",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "dropdown_body_list_separator",
	                    g: 1
	                  }]
	                }],
	                n: 50,
	                x: {
	                  r: ["periodType"],
	                  s: "_0===\"separator\""
	                }
	              }, {
	                t: 4,
	                f: [{
	                  t: 7,
	                  e: "li",
	                  m: [{
	                    n: "class",
	                    f: ["dropdown_body_list_item ", {
	                      t: 4,
	                      f: [{
	                        t: 2,
	                        r: "currentSelectedClass"
	                      }],
	                      n: 50,
	                      x: {
	                        r: ["currSelectedItemIdx", "currentSelectedClass", "periodText", "periodToDisplay"],
	                        s: "_0===null&&_1&&_2===_3"
	                      }
	                    }, " ", {
	                      t: 4,
	                      f: ["selected"],
	                      n: 50,
	                      x: {
	                        r: ["currSelectedItemIdx", "itemIndex"],
	                        s: "_0==_1"
	                      }
	                    }],
	                    t: 13
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: ["click"],
	                      t: 70,
	                      f: {
	                        r: ["@this", "."],
	                        s: "[_0.handleClick(_1)]"
	                      }
	                    }],
	                    f: [{
	                      t: 2,
	                      r: "periodText"
	                    }]
	                  }]
	                }],
	                n: 51,
	                l: 1
	              }],
	              n: 52,
	              i: "itemIndex",
	              r: "filteredPeriods"
	            }]
	          }],
	          n: 50,
	          r: "filteredPeriods.length"
	        }, {
	          t: 4,
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "dropdown_body_nothing-found-msg",
	              g: 1
	            }],
	            f: [{
	              t: 2,
	              r: "nothingFoundMsg"
	            }]
	          }],
	          n: 51,
	          l: 1
	        }]
	      }],
	      n: 50,
	      r: "periodToDisplay"
	    }]
	  }],
	  e: {
	    "[_0.toggleDropdown()]": function (_0) {
	      return [_0.toggleDropdown()];
	    },
	    "_0&&!_1": function (_0, _1) {
	      return _0 && !_1;
	    },
	    "[_0.onKeyDown(_1)]": function (_0, _1) {
	      return [_0.onKeyDown(_1)];
	    },
	    "_0===\"separator\"": function (_0) {
	      return _0 === "separator";
	    },
	    "_0===null&&_1&&_2===_3": function (_0, _1, _2, _3) {
	      return _0 === null && _1 && _2 === _3;
	    },
	    "_0==_1": function (_0, _1) {
	      return _0 == _1;
	    },
	    "[_0.handleClick(_1)]": function (_0, _1) {
	      return [_0.handleClick(_1)];
	    }
	  }
	};
	var periodsDropdown = ractive__default["default"].extend(component$C.exports);

	var component$B = {
	  exports: {}
	};
	component$B.exports = {
	  data() {
	    return {
	      _
	    };
	  }
	};
	component$B.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      t: 13,
	      n: "class",
	      f: "c-request-bandwidth-stats",
	      g: 1
	    }],
	    f: [{
	      t: 7,
	      e: "div",
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "card-icon",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "img",
	          m: [{
	            n: "width",
	            f: "32",
	            t: 13,
	            g: 1
	          }, {
	            n: "height",
	            f: "32",
	            t: 13,
	            g: 1
	          }, {
	            n: "src",
	            f: [{
	              t: 2,
	              r: "@shared.assetsHost"
	            }, "/img/icons/request.alt.svg"],
	            t: 13
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "card-main-stat",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          f: [{
	            t: 7,
	            e: "span",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "text-table-number",
	              g: 1
	            }],
	            f: [{
	              t: 2,
	              x: {
	                r: ["_", "requestsAmount"],
	                s: "_0.formatNumber(_1)"
	              }
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          f: [{
	            t: 7,
	            e: "span",
	            f: ["Requests"]
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "card-growth",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            n: "class",
	            f: [{
	              t: 4,
	              f: ["growth-positive"],
	              n: 50,
	              x: {
	                r: ["requestsGrowthPercent"],
	                s: "_0>=0"
	              }
	            }, {
	              t: 4,
	              f: ["growth-negative"],
	              n: 51,
	              l: 1
	            }],
	            t: 13
	          }],
	          f: [{
	            t: 7,
	            e: "span",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "text-table-number",
	              g: 1
	            }],
	            f: [{
	              t: 2,
	              x: {
	                r: ["_", "requestsGrowthPercent"],
	                s: "_0.formatGrowth(_1)"
	              }
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          f: [{
	            t: 7,
	            e: "span",
	            f: [{
	              t: 2,
	              r: "growthPeriod"
	            }, " ", {
	              t: 4,
	              f: ["growth"],
	              n: 50,
	              x: {
	                r: ["requestsGrowthPercent"],
	                s: "_0>=0"
	              }
	            }, {
	              t: 4,
	              f: ["decline"],
	              n: 51,
	              l: 1
	            }]
	          }]
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "div",
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "card-icon",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "img",
	          m: [{
	            n: "width",
	            f: "32",
	            t: 13,
	            g: 1
	          }, {
	            n: "height",
	            f: "32",
	            t: 13,
	            g: 1
	          }, {
	            n: "src",
	            f: [{
	              t: 2,
	              r: "@shared.assetsHost"
	            }, "/img/icons/transfer.alt.svg"],
	            t: 13
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "card-main-stat",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          f: [{
	            t: 7,
	            e: "span",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "text-table-number",
	              g: 1
	            }],
	            f: [{
	              t: 2,
	              x: {
	                r: ["_", "bandwidthAmount"],
	                s: "_0.formatNumber(_1)"
	              }
	            }, " ", {
	              t: 2,
	              r: "bandwidthUnit"
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          f: [{
	            t: 7,
	            e: "span",
	            f: ["Bandwidth"]
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "card-growth",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            n: "class",
	            f: [{
	              t: 4,
	              f: ["growth-positive"],
	              n: 50,
	              x: {
	                r: ["bandwidthGrowthPercent"],
	                s: "_0>=0"
	              }
	            }, {
	              t: 4,
	              f: ["growth-negative"],
	              n: 51,
	              l: 1
	            }],
	            t: 13
	          }],
	          f: [{
	            t: 7,
	            e: "span",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "text-table-number",
	              g: 1
	            }],
	            f: [{
	              t: 2,
	              x: {
	                r: ["_", "bandwidthGrowthPercent"],
	                s: "_0.formatGrowth(_1)"
	              }
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          f: [{
	            t: 7,
	            e: "span",
	            f: [{
	              t: 2,
	              r: "growthPeriod"
	            }, " ", {
	              t: 4,
	              f: ["growth"],
	              n: 50,
	              x: {
	                r: ["bandwidthGrowthPercent"],
	                s: "_0>=0"
	              }
	            }, {
	              t: 4,
	              f: ["decline"],
	              n: 51,
	              l: 1
	            }]
	          }]
	        }]
	      }]
	    }]
	  }],
	  e: {
	    "_0.formatNumber(_1)": function (_0, _1) {
	      return _0.formatNumber(_1);
	    },
	    "_0>=0": function (_0) {
	      return _0 >= 0;
	    },
	    "_0.formatGrowth(_1)": function (_0, _1) {
	      return _0.formatGrowth(_1);
	    }
	  }
	};
	var requestBandwidthStats = ractive__default["default"].extend(component$B.exports);

	var stats = {
	  periods: {
	    // day: 1,
	    // week: 7,
	    month: 30,
	    quarter: 90,
	    year: 365
	  },
	  groupByOptions: {
	    's-month': {
	      day: {
	        value: 'day',
	        isAvailable: true
	      },
	      week: {
	        value: 'week',
	        isAvailable: true
	      },
	      month: {
	        value: 'month',
	        isAvailable: false
	      }
	    },
	    's-quarter': {
	      day: {
	        value: 'day',
	        isAvailable: true
	      },
	      week: {
	        value: 'week',
	        isAvailable: true
	      },
	      month: {
	        value: 'month',
	        isAvailable: false
	      }
	    },
	    's-year': {
	      day: {
	        value: 'day',
	        isAvailable: true
	      },
	      week: {
	        value: 'week',
	        isAvailable: true
	      },
	      month: {
	        value: 'month',
	        isAvailable: true
	      }
	    }
	  },
	  growthPeriods: {
	    // day: 'daily',
	    // week: 'weekly',
	    's-month': 'monthly',
	    's-quarter': 'quarterly',
	    's-year': 'yearly'
	  }
	};

	var component$A = {
	  exports: {}
	};
	component$A.exports = {
	  data() {
	    return {
	      _,
	      requestsAmount: 0,
	      bandwidthAmount: 0,
	      requestsGrowthPercent: 0,
	      bandwidthGrowthPercent: 0,
	      growthPeriods: stats.growthPeriods,
	      growthPeriod: 'quarterly'
	    };
	  },
	  oninit() {
	    if (!ractive__default["default"].isServer) {
	      this.observe('periodData', ({
	        periodValue,
	        periodType
	      }) => {
	        let name = this.get('name');
	        let type = this.get('type');
	        let bandwidthUnit = this.get('bandwidthUnit');
	        this.set('growthPeriod', this.get('growthPeriods')[periodType]);
	        http.fetchPackageSummaryStats(type, name, periodValue).then(({
	          hits,
	          bandwidth
	        }) => {
	          if (hits.total >= 0) {
	            this.animate('requestsAmount', hits.total, {
	              duration: 1000
	            });
	            this.animate('requestsGrowthPercent', _.calculateGrowth(hits.total, hits.prev.total), {
	              duration: 1000
	            });
	          }
	          if (bandwidth.total >= 0) {
	            if (!bandwidthUnit) {
	              bandwidthUnit = _.findUnitFromNumber(bandwidth.total);
	            }
	            this.set('bandwidthUnitInternal', bandwidthUnit);
	            this.animate('bandwidthAmount', _.convertBytesToUnits(bandwidth.total, bandwidthUnit), {
	              duration: 1000
	            });
	            this.animate('bandwidthGrowthPercent', _.calculateGrowth(bandwidth.total, bandwidth.prev.total), {
	              duration: 1000
	            });
	          }
	        });
	      });
	    }
	  }
	};
	component$A.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      t: 13,
	      n: "class",
	      f: "c-package-request-bandwidth-stats",
	      g: 1
	    }],
	    f: [{
	      t: 7,
	      e: "c-request-bandwidth-stats",
	      m: [{
	        n: "requestsAmount",
	        f: [{
	          t: 2,
	          r: "requestsAmount"
	        }],
	        t: 13
	      }, {
	        n: "requestsGrowthPercent",
	        f: [{
	          t: 2,
	          r: "requestsGrowthPercent"
	        }],
	        t: 13
	      }, {
	        n: "growthPeriod",
	        f: [{
	          t: 2,
	          r: "growthPeriod"
	        }],
	        t: 13
	      }, {
	        n: "bandwidthAmount",
	        f: [{
	          t: 2,
	          r: "bandwidthAmount"
	        }],
	        t: 13
	      }, {
	        n: "bandwidthUnit",
	        f: [{
	          t: 2,
	          r: "bandwidthUnitInternal"
	        }],
	        t: 13
	      }, {
	        n: "bandwidthGrowthPercent",
	        f: [{
	          t: 2,
	          r: "bandwidthGrowthPercent"
	        }],
	        t: 13
	      }],
	      f: []
	    }]
	  }]
	};
	component$A.exports.components = {
	  "c-request-bandwidth-stats": requestBandwidthStats
	};
	var packageRequestBandwidthStats = ractive__default["default"].extend(component$A.exports);

	// chartEl - canvas element
	// chartData (labels, datasets) - data to render within the chart
	// chartSettings - additional params for the chart
	//	chartSettings.onHoverNotActiveBarsBGColor - all bars color except the hovered one
	//	chartSettings.useYAxisBorderPlugin - use plugin to render vertical y-axis border
	//	chartSettings.useExternalTooltip - use custom external tooltip instead of default one
	// 	chartSettings.externalTooltipId - if there are more than one barChart on the page you should set different ids for tooltips
	// chartConfig - config of the chart(chartjs lib config)

	const createBarChart = Chart => (chartEl, chartData = {}, chartSettings = {}, chartConfig = {}) => {
	  // remove tooltip elem if chart was recreated (e.g. after screen resizing)
	  let prevTooltipInstance = document.getElementById(chartSettings.externalTooltipId || 'barChart-tooltip');
	  if (prevTooltipInstance) {
	    prevTooltipInstance.remove();
	  }
	  if (!chartEl) {
	    return;
	  }

	  // create bar with background with gradient
	  let createBarWithGradient = chart => {
	    let barBackground = chart.getContext('2d').createLinearGradient(0, 0, 0, 300);
	    barBackground.addColorStop(0, 'rgb(246, 81, 40)');
	    barBackground.addColorStop(1, 'rgba(246, 81, 40, 0.08)');
	    return barBackground;
	  };

	  // handle hover over the chart to change colors of the bars
	  let handleChartOnHover = (event, elements, chart) => {
	    if (elements.length > 0) {
	      let dataset = chart.data.datasets[0];
	      let data = chart.data.datasets[0].data;
	      event.native.target.style.cursor = 'pointer';
	      dataset.backgroundColor = data.map(() => chartSettings.onHoverNotActiveBarsBGColor || '#FAE5E0');
	      chart.update();
	    }
	  };

	  // handle mouse out of the chart area to restore bar colors
	  let chartMouseOutHandler = {
	    id: 'chartMouseOutHandler',
	    afterEvent(chart, args) {
	      let {
	        event
	      } = args;
	      if (event.type === 'mouseout') {
	        let dataset = chart.data.datasets[0];
	        let data = chart.data.datasets[0].data;
	        event.native.target.style.cursor = 'default';
	        dataset.backgroundColor = data.map(() => chartConfig?.options?.elements?.bar.backgroundColor || createBarWithGradient(chartEl));
	        chart.update();
	      }
	    }
	  };

	  // create vertical y-axis border line
	  let verticalYAxisBorder = {
	    id: 'statsChartYBorder',
	    beforeDraw(chart) {
	      let {
	        ctx,
	        chartArea
	      } = chart;
	      ctx.save();
	      ctx.beginPath();
	      ctx.moveTo(chartArea.left - 20, 22);
	      ctx.lineTo(chartArea.left - 20, 319);
	      ctx.lineWidth = 1;
	      ctx.strokeStyle = '#DADDE2';
	      ctx.stroke();
	      ctx.restore();
	    }
	  };

	  // create external tooltip with Dates/Periods and value displaying
	  let externalTooltipImproved = ctx => {
	    let {
	      chart,
	      tooltip: tooltipModel
	    } = ctx;
	    let tooltipInstance = document.getElementById(chartSettings.externalTooltipId || 'barChart-tooltip');

	    // Create element on first render
	    if (!tooltipInstance) {
	      tooltipInstance = document.createElement('div');
	      tooltipInstance.id = chartSettings.externalTooltipId || 'barChart-tooltip';
	      tooltipInstance.classList.add('tooltipEl');
	      let wrapper = document.createElement('div');
	      wrapper.classList.add('barTooltipWrapper', 'barTooltipWrapper-improved');
	      tooltipInstance.appendChild(wrapper);
	      chart.canvas.parentNode.appendChild(tooltipInstance);
	    }

	    // Hide if no tooltip
	    if (tooltipModel.opacity === 0) {
	      tooltipInstance.style.opacity = 0;
	      return;
	    }
	    if (tooltipModel.body) {
	      let [periodStart, periodEnd] = chartData.labelsStartEndPeriods[tooltipModel.dataPoints[0].parsed.x];
	      let tooltipDate = _.createImprovedExternalTooltipTitle(periodStart, periodEnd, chartData.usageChartGroupBy);
	      let bodyValue = tooltipModel.body.map(item => item.lines[0])[0];
	      let innerHtml = `<div>${tooltipDate}</div><div><span class='color-square'></span><span>${bodyValue}${chartData.valueUnits}</span></div>`;
	      let tooltipWrapper = tooltipInstance.querySelector('div.barTooltipWrapper');
	      tooltipWrapper.innerHTML = innerHtml;
	    }
	    tooltipInstance.style.opacity = 1;
	    if (screen.width >= 768) {
	      tooltipInstance.style.top = tooltipModel.caretY - (chartSettings.externalTooltipVerticalOffset || 0) + 'px';
	      if (tooltipModel.caretX + tooltipInstance.offsetWidth > chart.canvas.clientWidth) {
	        tooltipInstance.style.left = chart.canvas.offsetLeft + tooltipModel.caretX - tooltipInstance.offsetWidth / 2 - 10 + 'px';
	      } else {
	        tooltipInstance.style.left = chart.canvas.offsetLeft + tooltipModel.caretX + tooltipInstance.offsetWidth / 2 + 10 + 'px';
	      }
	    } else {
	      tooltipInstance.style.left = chart.canvas.clientWidth / 2 + 'px';
	      tooltipInstance.style.top = '0px';
	    }
	  };

	  // create external tooltip with only value displaying
	  let externalTooltipSimple = ctx => {
	    let {
	      chart,
	      tooltip: tooltipModel
	    } = ctx;
	    let tooltipInstance = document.getElementById(chartSettings.externalTooltipId || 'barChart-tooltip');

	    // Create element on first render
	    if (!tooltipInstance) {
	      tooltipInstance = document.createElement('div');
	      tooltipInstance.id = chartSettings.externalTooltipId || 'barChart-tooltip';
	      tooltipInstance.classList.add('tooltipEl');
	      let wrapper = document.createElement('div');
	      wrapper.classList.add('barTooltipWrapper', 'barTooltipWrapper-simple');
	      tooltipInstance.appendChild(wrapper);
	      chart.canvas.parentNode.appendChild(tooltipInstance);
	    }

	    // Hide if no tooltip
	    if (tooltipModel.opacity === 0) {
	      tooltipInstance.style.opacity = 0;
	      return;
	    }
	    if (tooltipModel.body) {
	      let bodyValue = tooltipModel.body.map(item => item.lines[0])[0];
	      let innerHtml = `<span>${bodyValue}${chartData.valueUnits || ''}</span>`;
	      let tooltipWrapper = tooltipInstance.querySelector('div.barTooltipWrapper');
	      tooltipWrapper.innerHTML = innerHtml;
	    }
	    tooltipInstance.style.opacity = 1;
	    tooltipInstance.style.top = tooltipModel.caretY - (chartSettings.externalTooltipVerticalOffset || 0) + 'px';
	    tooltipInstance.style.left = chart.canvas.offsetLeft + tooltipModel.caretX + 'px';
	  };

	  // get chart plugins
	  let getChartPlugins = () => {
	    let {
	      useYAxisBorderPlugin
	    } = chartSettings;
	    let plugins = [chartMouseOutHandler];
	    if (useYAxisBorderPlugin) {
	      plugins.push(verticalYAxisBorder);
	    }
	    return plugins;
	  };

	  // chart configuration
	  let defaultConfig = {
	    type: 'bar',
	    data: {
	      labels: chartData.labels,
	      datasets: chartData.datasets
	    },
	    options: {
	      responsive: true,
	      maintainAspectRatio: false,
	      elements: {
	        bar: {
	          backgroundColor: createBarWithGradient(chartEl),
	          ...chartConfig?.options?.elements?.bar
	        }
	      },
	      plugins: {
	        legend: {
	          display: false
	        },
	        tooltip: {
	          enabled: !chartSettings.useExternalTooltip && true,
	          external: !chartSettings.useExternalTooltip ? null : chartSettings.useImprovedTooltip ? externalTooltipImproved : externalTooltipSimple,
	          bodyColor: '#fff',
	          backgroundColor: 'rgba(17, 26, 44, .9)',
	          cornerRadius: 4,
	          padding: 6,
	          caretSize: 0,
	          caretPadding: 8,
	          bodyAlign: 'center',
	          displayColors: false,
	          xAlign: 'center',
	          yAlign: 'bottom',
	          bodyFont: {
	            size: 12,
	            weight: 600,
	            family: 'Lexend, sans-serif',
	            style: 'normal',
	            lineHeight: 1.3
	          },
	          callbacks: {
	            title: () => {},
	            footer: () => {},
	            label: ctx => {
	              let {
	                formattedValue
	              } = ctx;
	              return _.formatNumber(formattedValue.replace(/\D/g, ''));
	            }
	          }
	        }
	      },
	      scales: {
	        x: {
	          display: true,
	          ...chartConfig?.options?.scales?.x
	        },
	        y: {
	          display: true,
	          ...chartConfig?.options?.scales?.y
	        }
	      },
	      interaction: {
	        intersect: false,
	        mode: 'nearest',
	        axis: 'x',
	        ...chartConfig?.options?.intercation
	      },
	      onHover: handleChartOnHover
	    },
	    plugins: getChartPlugins()
	  };

	  // create chart instance
	  return new Chart(chartEl, defaultConfig);
	};
	var createBarChart_1 = createBarChart;

	// chartEl - canvas element
	// chartData (labels, datasets) - data to render within the chart
	// chartSettings - additional params for the chart
	//	chartSettings.useYAxisBorderPlugin - use plugin to render vertical y-axis border
	//	chartSettings.useExternalTooltip - use custom external tooltip instead of default one
	// chartConfig - config of the chart(chartjs lib config)

	const createLineChart = Chart => (chartEl, chartData = {}, chartSettings = {
	  useExternalTooltip: false
	}, chartConfig = {}) => {
	  // remove tooltip elem if chart was recreated (e.g. after screen resizing)
	  let prevTooltipInstance = document.getElementById('lineChart-tooltip');
	  if (prevTooltipInstance) {
	    prevTooltipInstance.remove();
	  }
	  if (!chartEl) {
	    return;
	  }

	  // TODO: Statistics page only, should be rechecked and fix if needed
	  // create external tooltip (prev version)
	  let externalTooltipOldVersion = ctx => {
	    let {
	      chart,
	      tooltip: tooltipModel
	    } = ctx;
	    let tooltipInstance = document.getElementById('lineChart-tooltip');

	    // Create element on first render
	    if (!tooltipInstance) {
	      tooltipInstance = document.createElement('div');
	      tooltipInstance.id = 'lineChart-tooltip';
	      tooltipInstance.classList.add('tooltipEl');
	      let wrapper = document.createElement('div');
	      wrapper.classList.add('tooltipWrapper');
	      tooltipInstance.appendChild(wrapper);
	      let verticalLine = document.createElement('div');
	      verticalLine.classList.add('tooltipVerticalLine');
	      tooltipInstance.appendChild(verticalLine);
	      chart.canvas.parentNode.appendChild(tooltipInstance);
	    }

	    // Hide if no tooltip
	    if (tooltipModel.opacity === 0) {
	      tooltipInstance.style.opacity = 0;
	      return;
	    }
	    if (tooltipModel.body) {
	      // get title text and body lines
	      let titleText = new Date(tooltipModel.title[0].split(',')[0]).toLocaleDateString('en-US', {
	        day: 'numeric',
	        month: 'long',
	        year: 'numeric'
	      });

	      // prepare body lines and color map for lines-backgrounds
	      let bodyData = tooltipModel.body.reduce((res, item, itemIdx) => {
	        res.lines.push(item.lines[0]);
	        res.linesMap[item.lines[0]] = tooltipModel.labelColors[itemIdx].backgroundColor;
	        return res;
	      }, {
	        lines: [],
	        linesMap: {}
	      });

	      // sort body lines from max to min
	      let sortedBodyLines = bodyData.lines.sort((a, b) => b.split(': ')[1].replace(/,/g, '') - a.split(': ')[1].replace(/,/g, ''));

	      // create title element
	      let innerHtml = `<div class='tooltipTitle'>${titleText}</div><div class='tooltipBody'>`;

	      // create body lines
	      sortedBodyLines.forEach(line => {
	        let coloredSquare = `<span class='tooltipSquare' style='background: ${bodyData.linesMap[line]}'></span>`;
	        innerHtml += `<div class='tooltipBodyItem'>${coloredSquare}`;
	        line.split(' ').forEach((part, partIdx) => {
	          let prepPart = part;
	          if (partIdx === 0) {
	            prepPart = prepPart.replace(':', '');
	          } else {
	            prepPart = prepPart.replaceAll(',', ' ');
	          }
	          innerHtml += `<span>${prepPart}</span>`;
	        });
	        innerHtml += '</div>';
	        let provider = line.split(' ')[0].replace(':', '');
	        let providerData = tooltipModel.dataPoints.find(one => {
	          return one.dataset.label === provider;
	        });
	        innerHtml += `<div class='ratio-text'>
					<span>Average file size</span>
					<span>${providerData.dataset.ratio[providerData.label.replace(',', '')]}</span>
				</div>`;
	      });
	      innerHtml += `</div>`;
	      let tooltipWrapper = tooltipInstance.querySelector('div.tooltipWrapper');
	      tooltipWrapper.innerHTML = innerHtml;
	    }
	    tooltipInstance.style.opacity = 1;
	    let {
	      canvas: {
	        offsetLeft
	      },
	      chartArea
	    } = chart;
	    let tooltipVerticalLine = tooltipInstance.querySelector('.tooltipVerticalLine');

	    // caretX min 0 max 1110
	    // 120px based on the half width of the tooltip + vertical line and gap
	    if (tooltipModel.caretX > 882) {
	      tooltipVerticalLine.style.left = '230px';
	      tooltipInstance.style.left = -120 + offsetLeft + tooltipModel.caretX + 'px';
	    } else {
	      tooltipVerticalLine.style.left = '-10px';
	      tooltipInstance.style.left = 120 + offsetLeft + tooltipModel.caretX + 'px';
	    }
	    tooltipVerticalLine.style.height = chartArea.height + 'px';
	    tooltipInstance.style.top = chartArea.top + 'px';
	  };

	  // create external tooltip (new version)
	  let externalTooltip = (noSpaceCase = false) => ctx => {
	    let {
	      chart,
	      tooltip: tooltipModel
	    } = ctx;
	    let tooltipInstance = document.getElementById('lineChart-tooltip');

	    // Create element on first render
	    if (!tooltipInstance) {
	      tooltipInstance = document.createElement('div');
	      tooltipInstance.id = 'lineChart-tooltip';
	      tooltipInstance.classList.add('tooltipEl');
	      let wrapper = document.createElement('div');
	      wrapper.classList.add('tooltipWrapper', 'tooltipWrapper-improved');
	      tooltipInstance.appendChild(wrapper);
	      let verticalLine = document.createElement('div');
	      verticalLine.classList.add('tooltipVerticalLine');
	      tooltipInstance.appendChild(verticalLine);
	      chart.canvas.parentNode.appendChild(tooltipInstance);
	    }

	    // Hide if no tooltip
	    if (tooltipModel.opacity === 0) {
	      tooltipInstance.style.opacity = 0;
	      return;
	    }
	    if (tooltipModel.body) {
	      let [periodStart, periodEnd] = chartData.labelsStartEndPeriods[tooltipModel.dataPoints[0].parsed.x];
	      let tooltipDate = _.createImprovedExternalTooltipTitle(periodStart, periodEnd, chartData.usageChartGroupBy);

	      // prepare body lines and color map for lines-backgrounds
	      let bodyData = tooltipModel.body.reduce((res, item, itemIdx) => {
	        // add index to the key because content of the line could be cut and therefore they will ahve the same value which leads to bugs
	        res.lines.push(itemIdx + item.lines[0]);
	        res.linesMap[itemIdx + item.lines[0]] = tooltipModel.labelColors[itemIdx].backgroundColor;
	        return res;
	      }, {
	        lines: [],
	        linesMap: {}
	      });

	      // sort body lines from max to min
	      let sortedBodyLines = bodyData.lines.sort((a, b) => b.split(': ')[1].replace(/,/g, '') - a.split(': ')[1].replace(/,/g, ''));

	      // create title element
	      let innerHtml = `<div class='tooltipTitle'>${tooltipDate}</div><div class='tooltipBody'><div class='tooltipBodyItemsWrapper'>`;

	      // create body lines
	      sortedBodyLines.forEach((line, idx) => {
	        let coloredSquare = `<span class='tooltipSquare' style='background: ${bodyData.linesMap[line]}'></span>`;
	        // remove first number character from the line because it is an index which is used to differentiate lines names in case if they were cut
	        let [iVersion, iAmount] = (idx < 10 ? line.replace(/^\d/, '') : line.replace(/^\d\d/, '')).split(':');
	        let formattedAmount = _.formatNumber(iAmount.replace(/\D/g, ''));
	        if (idx === 10) {
	          innerHtml += `</div><div class='tooltipBodyDivider'></div><div class='tooltipBodyItemsWrapper'>`;
	        }
	        innerHtml += `<div class='tooltipBodyItem'>${coloredSquare}`;
	        innerHtml += `<span>${iVersion}</span><span>${formattedAmount + chartData.valueUnits}</span>`;
	        innerHtml += '</div>';
	      });
	      let tooltipWrapper = tooltipInstance.querySelector('div.tooltipWrapper');
	      tooltipWrapper.innerHTML = innerHtml;
	    }
	    tooltipInstance.style.opacity = 1;
	    let {
	      canvas,
	      chartArea
	    } = chart;
	    let tooltipVerticalLine = tooltipInstance.querySelector('.tooltipVerticalLine');
	    let tooltipWrapperEl = tooltipInstance.querySelector('div.tooltipWrapper');
	    if (noSpaceCase ? screen.width >= 992 : screen.width >= 768) {
	      tooltipInstance.style.top = chartArea.top + 'px';
	      tooltipVerticalLine.style.height = chartArea.height + 'px';
	      if (tooltipModel.caretX + tooltipInstance.offsetWidth > canvas.clientWidth) {
	        tooltipVerticalLine.style.left = tooltipInstance.offsetWidth + 10 + 'px';
	        tooltipInstance.style.left = canvas.offsetLeft + tooltipModel.caretX - tooltipInstance.offsetWidth / 2 - 10 + 'px';
	      } else {
	        tooltipVerticalLine.style.left = '-10px';
	        tooltipInstance.style.left = canvas.offsetLeft + tooltipModel.caretX + tooltipInstance.offsetWidth / 2 + 10 + 'px';
	      }
	    } else if (noSpaceCase && screen.width >= 768 && screen.width < 992) {
	      tooltipInstance.style.top = chartArea.top + 'px';
	      tooltipVerticalLine.style.height = chartArea.height + 'px';
	      tooltipWrapperEl.style.position = 'absolute';
	      tooltipWrapperEl.style.top = -tooltipWrapperEl.offsetHeight + tooltipVerticalLine.offsetHeight + 'px';
	      if (tooltipModel.caretX > canvas.clientWidth / 2) {
	        tooltipVerticalLine.style.left = tooltipWrapperEl.offsetWidth + 10 + 'px';
	        tooltipInstance.style.left = tooltipModel.caretX - tooltipWrapperEl.offsetWidth - 10 + 'px';
	      } else {
	        tooltipVerticalLine.style.left = tooltipInstance.offsetWidth - 10 + 'px';
	        tooltipInstance.style.left = canvas.offsetLeft + tooltipModel.caretX + tooltipInstance.offsetWidth / 2 + 10 + 'px';
	      }
	    } else {
	      tooltipInstance.style.top = chartArea.top + 'px';
	      // tooltip data wrapper should be stick to the center
	      tooltipWrapperEl.style.position = 'absolute';
	      tooltipWrapperEl.style.left = canvas.clientWidth / 2 - tooltipWrapperEl.offsetWidth / 2 + 'px';
	      tooltipWrapperEl.style.top = -tooltipWrapperEl.offsetHeight + 'px';
	      // only vertical line is moving around the chart
	      tooltipVerticalLine.style.height = chartArea.height + 'px';
	      tooltipVerticalLine.style.left = canvas.offsetLeft + tooltipModel.caretX - tooltipInstance.offsetLeft + 'px';
	    }
	  };

	  // create vertical y-axis border line
	  let verticalYAxisBorder = {
	    id: 'lineChartYBorder',
	    beforeDraw(chart) {
	      let {
	        ctx,
	        chartArea
	      } = chart;
	      ctx.save();
	      ctx.beginPath();
	      ctx.moveTo(chartArea.left - 20, 22);
	      ctx.lineTo(chartArea.left - 20, 319);
	      ctx.lineWidth = 1;
	      ctx.strokeStyle = '#DADDE2';
	      ctx.stroke();
	      ctx.restore();
	    }
	  };

	  // get chart plugins
	  let getChartPlugins = () => {
	    let {
	      useYAxisBorderPlugin
	    } = chartSettings;
	    let plugins = [];
	    if (useYAxisBorderPlugin) {
	      plugins.push(verticalYAxisBorder);
	    }
	    return plugins;
	  };

	  // chart configuration
	  let defaultConfig = {
	    type: 'line',
	    data: {
	      labels: chartData.labels,
	      datasets: chartData.datasets
	    },
	    options: {
	      responsive: true,
	      maintainAspectRatio: false,
	      elements: {
	        point: {
	          pointRadius: 0,
	          pointHoverRadius: 0
	        }
	      },
	      plugins: {
	        legend: {
	          display: false
	        },
	        tooltip: {
	          enabled: !chartSettings.useExternalTooltip && true,
	          external: !chartSettings.useExternalTooltip ? null : chartSettings.useImprovedTooltip ? externalTooltip(chartSettings.noSpaceForImprvdTltp) : externalTooltipOldVersion
	        }
	      },
	      scales: {
	        x: {
	          display: false,
	          ...chartConfig?.options?.scales?.x
	        },
	        y: {
	          display: false,
	          ...chartConfig?.options?.scales?.y
	        }
	      },
	      interaction: {
	        axis: 'x',
	        mode: 'nearest',
	        intersect: false
	      }
	    },
	    plugins: getChartPlugins()
	  };

	  // create chart instance
	  return new Chart(chartEl, defaultConfig);
	};
	var createLineChart_1 = createLineChart;

	var charts = () => {
	  return Promise.all([
	  // eslint-disable-next-line n/no-missing-import
	  import('https://cdn.jsdelivr.net/npm/chart.js@4.4.0/+esm')]).then(([{
	    Chart,
	    ArcElement,
	    LineElement,
	    BarElement,
	    PointElement,
	    BarController,
	    BubbleController,
	    DoughnutController,
	    LineController,
	    PieController,
	    PolarAreaController,
	    RadarController,
	    ScatterController,
	    CategoryScale,
	    LinearScale,
	    LogarithmicScale,
	    RadialLinearScale,
	    TimeScale,
	    TimeSeriesScale,
	    Decimation,
	    Filler,
	    Legend,
	    Title,
	    Tooltip
	  }]) => {
	    Chart.register(ArcElement, LineElement, BarElement, PointElement, BarController, BubbleController, DoughnutController, LineController, PieController, PolarAreaController, RadarController, ScatterController, CategoryScale, LinearScale, LogarithmicScale, RadialLinearScale, TimeScale, TimeSeriesScale, Decimation, Filler, Legend, Title, Tooltip);
	    return {
	      createBarChart: createBarChart_1(Chart),
	      createLineChart: createLineChart_1(Chart)
	    };
	  });
	};

	var component$z = {
	  exports: {}
	};
	const DEFAULT_LIMIT = 5;
	const COLORS_ARR = ['#5C667A', '#BC5090', '#FFA600', '#FF6361', '#69C4F7', '#018b01', '#ffd68b', '#056ca6', '#c6302e', '#f53daa', '#aa0065', '#4eff4e', '#c79331', '#ffec00', '#FF6361', '#a2a9b6', '#dd8cbc', '#fab996', '#009ff9', '#709e11'];
	component$z.exports = {
	  computed: {
	    usageChartGroupByValues() {
	      return stats.groupByOptions[this.get('periodData').periodType];
	    }
	  },
	  data() {
	    return {
	      _,
	      colorsArray: COLORS_ARR,
	      periodData: {
	        periodText: 'quarter',
	        periodValue: 'quarter',
	        periodType: 's-quarter'
	      },
	      showChartBandwidth: false,
	      usageChartGroupByValues: stats.groupByOptions['s-quarter'],
	      usageChartGroupBy: 'day',
	      noPackageStatsData: false,
	      chartTitlePeriodText: 'Stats for past',
	      topTablesLimit: DEFAULT_LIMIT,
	      topPackagesPage: 1,
	      filesStatsPage: 1
	    };
	  },
	  oninit() {
	    if (!ractive__default["default"].isServer) {
	      // fetch Package Version File Stats for Top-files-per-package-version
	      this.observe('periodData fileStatsVersion showChartBandwidth topTablesLimit filesStatsPage', () => {
	        if (!this.get('periodData') || !this.get('fileStatsVersion')) {
	          return;
	        }
	        let version = this.get('fileStatsVersion');
	        let period = this.get('periodData').periodValue;
	        let showChartBandwidth = this.get('showChartBandwidth');
	        let dataType = showChartBandwidth ? 'bandwidth' : 'hits';
	        let type = this.get('type');
	        let name = this.get('name');
	        let filesStatsPage = this.get('filesStatsPage');
	        let topTablesLimit = this.get('topTablesLimit');
	        http.fetchPackageFileStatsWithHeaders(type, name, version, period, dataType, topTablesLimit, filesStatsPage).then(({
	          response,
	          responseHeaders
	        }) => {
	          let filesStats = response.map(statsPerFile => ({
	            file: statsPerFile.name,
	            hits: statsPerFile[dataType].total
	          }));
	          this.set('filesStats', filesStats);
	          this.set('filesStatsHeaders', responseHeaders);
	        });
	      });

	      // get Package Version Stats for Top-package-versions
	      this.observe('periodData versionP showChartBandwidth topPackagesPage topTablesLimit', () => {
	        if (!this.get('periodData') || !this.get('versionP')) {
	          return;
	        }
	        let type = this.get('type');
	        let name = this.get('name');
	        let period = this.get('periodData').periodValue;
	        let showChartBandwidth = this.get('showChartBandwidth');
	        let dataType = showChartBandwidth ? 'bandwidth' : 'hits';
	        let limit = this.get('topTablesLimit');
	        let page = this.get('topPackagesPage');
	        http.fetchPackageVersionsStatsWithHeaders(type, name, period, dataType, limit, page).then(({
	          response,
	          responseHeaders
	        }) => {
	          let {
	            noHitsData: noTopFiveHitsData,
	            noBandwidthData: noTopFiveBandData
	          } = this.checkPackageVersionsDataStatus(response);
	          this.set('noTopFiveHitsData', noTopFiveHitsData);
	          this.set('noTopFiveBandData', noTopFiveBandData);
	          if (noTopFiveHitsData && noTopFiveBandData) {
	            this.set('fileStatsVersion', null);
	            this.set('topVersions', null);
	            return;
	          }
	          let versionsStats = response.map(statsPerVersion => ({
	            version: statsPerVersion.version,
	            hits: statsPerVersion[dataType].total
	          }));
	          if (versionsStats[0] && (!noTopFiveHitsData && !noTopFiveBandData || !noTopFiveHitsData && !showChartBandwidth || !noTopFiveBandData && showChartBandwidth)) {
	            this.set('fileStatsVersion', versionsStats[0].version);
	          }
	          this.set('topVersions', versionsStats);
	          this.set('topVersionsHeaders', responseHeaders);
	          this.set('filesStatsPage', 1);
	        });
	      });

	      // handle period changes by updating groupBy options and fetch statsChart/hitsChart data
	      this.observe('periodData topTablesLimit topPackagesPage', () => {
	        let period = this.get('periodData').periodValue;
	        let type = this.get('type');
	        let name = this.get('name');
	        let dataType = this.get('showChartBandwidth') ? 'bandwidth' : 'hits';
	        let limit = this.get('topTablesLimit');
	        let page = this.get('topPackagesPage');

	        // prevent chart data fetching from the back when period is DAY, left it as it was prev
	        if (period === 'day') {
	          return;
	        }

	        // get data for barChart
	        http.fetchPackageSummaryStats(type, name, period).then(response => {
	          if (!response.hits.total && !response.bandwidth.total) {
	            this.set('noStatsChartHitsData', true);
	            this.set('noStatsChartBandData', true);
	            this.set('rawStatsChartData', null);
	            return;
	          } else if (!response.hits.total) {
	            this.set('noStatsChartHitsData', true);
	          } else if (!response.bandwidth.total) {
	            this.set('noStatsChartBandData', true);
	          } else {
	            this.set('noStatsChartHitsData', false);
	            this.set('noStatsChartBandData', false);
	          }

	          // once new data fetched we should set groupBy to default value before raw data set
	          this.set('usageChartGroupBy', 'day');
	          this.set('rawStatsChartData', response);
	        });

	        // get data for lineChart
	        http.fetchPackageVersionsStatsWithHeaders(type, name, period, dataType, limit, page).then(({
	          response
	        }) => {
	          let {
	            noHitsData: noHitsChartHitsData,
	            noBandwidthData: noHitsChartBandData
	          } = this.checkPackageVersionsDataStatus(response);
	          this.set('noHitsChartHitsData', noHitsChartHitsData);
	          this.set('noHitsChartBandData', noHitsChartBandData);
	          if (noHitsChartHitsData && noHitsChartBandData) {
	            this.set('rawHitsChartData', null);
	            return;
	          }

	          // once new data fetched we should set groupBy to default value before raw data set
	          this.set('usageChartGroupBy', 'day');
	          this.set('rawHitsChartData', response);
	        });
	      });

	      // get data for lineChart when Request/Bandwidth switch clicked (since it is sorting on the server)
	      this.observe('showChartBandwidth', showChartBandwidth => {
	        let period = this.get('periodData').periodValue;
	        let type = this.get('type');
	        let name = this.get('name');
	        let dataType = showChartBandwidth ? 'bandwidth' : 'hits';
	        let limit = this.get('topTablesLimit');
	        let page = this.get('topPackagesPage');
	        http.fetchPackageVersionsStatsWithHeaders(type, name, period, dataType, limit, page).then(({
	          response
	        }) => {
	          let {
	            noHitsData: noHitsChartHitsData,
	            noBandwidthData: noHitsChartBandData
	          } = this.checkPackageVersionsDataStatus(response);
	          this.set('noHitsChartHitsData', noHitsChartHitsData);
	          this.set('noHitsChartBandData', noHitsChartBandData);
	          if (noHitsChartHitsData && noHitsChartBandData) {
	            this.set('rawHitsChartData', null);
	            return;
	          }
	          this.set('rawHitsChartData', response);
	        });
	      }, {
	        init: false
	      });

	      // handle raw StatsChart data and prepare it for StatsChart
	      // screenWidth to observe when screen width is resized to recreate stats chart
	      this.observe('rawStatsChartData showChartBandwidth usageChartGroupBy screenWidth', () => {
	        let rawStatsChartData = this.get('rawStatsChartData');
	        let showChartBandwidth = this.get('showChartBandwidth');
	        if (!rawStatsChartData || !rawStatsChartData.hits.total && !showChartBandwidth || !rawStatsChartData.bandwidth.total && showChartBandwidth || !rawStatsChartData.hits.total && !rawStatsChartData.bandwidth.total) {
	          return;
	        }
	        let chartPeriodType = this.get('periodData').periodType;
	        let usageChartGroupBy = this.get('usageChartGroupBy');
	        let screenWidth = this.get('screenWidth') ? this.get('screenWidth') : window.innerWidth;
	        let dataType = showChartBandwidth ? 'bandwidth' : 'hits';

	        // collect X-Axis dates, group data by period, get
	        let {
	          values,
	          labels,
	          labelsStartEndPeriods,
	          maxRangeValue,
	          valueUnits
	        } = _.getPreparedDataForBarChart(rawStatsChartData[dataType], usageChartGroupBy, chartPeriodType, showChartBandwidth);

	        // get bat thickness of the chart depending on screen resolution, chartPeriodType and groupBy
	        let chartBarThickness = _.calcChartBarThicknessByResolution(chartPeriodType, usageChartGroupBy);

	        // set prepared data for chart
	        this.set('preparedStatsChartData', {
	          data: values,
	          labels,
	          labelsStartEndPeriods,
	          maxRangeValue,
	          showChartBandwidth,
	          barThickness: chartBarThickness,
	          useYAxisBorderPlugin: screenWidth >= 768,
	          yAxisPadding: screenWidth >= 768 ? 20 : 8,
	          valueUnits,
	          usageChartGroupBy
	        });
	      }, {
	        init: false,
	        defer: true
	      });

	      // handle raw HitsChart data and prepare it for HitsChart
	      this.observe('rawHitsChartData showChartBandwidth usageChartGroupBy screenWidth', () => {
	        let rawHitsChartData = this.get('rawHitsChartData');
	        let noHitsChartHitsData = this.get('noHitsChartHitsData');
	        let noHitsChartBandData = this.get('noHitsChartBandData');
	        let showChartBandwidth = this.get('showChartBandwidth');
	        let topTablesLimit = this.get('topTablesLimit');
	        let colorsArray = this.get('colorsArray');
	        if (!rawHitsChartData || noHitsChartHitsData && !showChartBandwidth || noHitsChartBandData && showChartBandwidth || noHitsChartHitsData && noHitsChartBandData) {
	          return;
	        }
	        let chartPeriodType = this.get('periodData').periodType;
	        let usageChartGroupBy = this.get('usageChartGroupBy');
	        let screenWidth = this.get('screenWidth') ? this.get('screenWidth') : window.innerWidth;

	        // collect versions for hitsChart Legend element
	        let hitsChartLegendVersions = rawHitsChartData.map(item => ({
	          version: item.version
	        }));

	        // collect X-Axis dates, group data by period, get
	        let {
	          labels,
	          maxRangeValue,
	          datasets,
	          labelsStartEndPeriods,
	          valueUnits
	        } = _.getPreparedDataForLineChart(rawHitsChartData, usageChartGroupBy, chartPeriodType, showChartBandwidth, topTablesLimit, true, colorsArray);
	        this.set('preparedHitsChartData', {
	          datasets,
	          labels,
	          labelsStartEndPeriods,
	          maxRangeValue,
	          showChartBandwidth,
	          useYAxisBorderPlugin: screenWidth >= 768,
	          yAxisPadding: screenWidth >= 768 ? 30 : 18,
	          valueUnits,
	          usageChartGroupBy
	        });
	        this.set('hitsChartLegendVersions', hitsChartLegendVersions);
	      }, {
	        init: false,
	        defer: true
	      });

	      // set Chart text based on periodData
	      this.observe('periodData', ({
	        periodValue
	      }) => {
	        switch (periodValue) {
	          case 'month':
	          case 'quarter':
	          case 'year':
	            this.set('chartTitlePeriodText', 'Stats for past');
	            break;
	          default:
	            this.set('chartTitlePeriodText', 'Stats for');
	        }
	      });

	      // handle case when no data for the Package at all
	      this.observe('noStatsChartHitsData noStatsChartBandData noHitsChartHitsData noHitsChartBandData noTopFiveHitsData noTopFiveBandData', () => {
	        let noStatsChartHitsData = this.get('noStatsChartHitsData');
	        let noStatsChartBandData = this.get('noStatsChartBandData');
	        let noHitsChartHitsData = this.get('noHitsChartHitsData');
	        let noHitsChartBandData = this.get('noHitsChartBandData');
	        let noTopFiveHitsData = this.get('noTopFiveHitsData');
	        let noTopFiveBandData = this.get('noTopFiveBandData');
	        if (noStatsChartHitsData && noStatsChartBandData && noHitsChartHitsData && noHitsChartBandData && noTopFiveHitsData && noTopFiveBandData) {
	          this.set('showChartBandwidth', false);
	          this.set('noPackageStatsData', true);
	        } else {
	          this.set('noPackageStatsData', false);
	        }
	      });
	    }
	  },
	  onrender() {
	    if (!ractive__default["default"].isServer) {
	      let statsChart;
	      let hitsChart;
	      charts().then(({
	        createBarChart,
	        createLineChart
	      }) => {
	        // create barChart
	        this.observe('preparedStatsChartData', preparedStatsChartData => {
	          if (!preparedStatsChartData) {
	            return;
	          }
	          let {
	            labels,
	            maxRangeValue,
	            data,
	            showChartBandwidth,
	            barThickness,
	            useYAxisBorderPlugin,
	            yAxisPadding,
	            labelsStartEndPeriods,
	            valueUnits,
	            usageChartGroupBy
	          } = preparedStatsChartData;
	          let statsChartCanvasEl = this.find('#stats-chart');
	          if (!preparedStatsChartData || !statsChartCanvasEl) {
	            return;
	          }
	          if (statsChart) {
	            statsChart.destroy();
	            statsChart = null;
	          }
	          let chartData = {
	            labels,
	            datasets: [{
	              data,
	              borderWidth: 0,
	              barThickness,
	              hoverBackgroundColor: '#F65128'
	            }],
	            labelsStartEndPeriods,
	            valueUnits,
	            usageChartGroupBy
	          };
	          let chartSettings = {
	            useYAxisBorderPlugin,
	            useExternalTooltip: true,
	            useImprovedTooltip: true,
	            externalTooltipVerticalOffset: 40
	          };
	          let maxRangeMagnitude = Math.floor(Math.log10(maxRangeValue));
	          let chartConfig = {
	            options: {
	              scales: {
	                x: {
	                  display: true,
	                  ticks: {
	                    color: '#5C667A',
	                    font: {
	                      size: 12,
	                      family: 'Lexend, sans-serif',
	                      lineHeight: 2
	                    },
	                    // return nothing when labelValue array is empty
	                    // this way we will not get italicized text when all ticks can't be displayed at once normally
	                    callback(value) {
	                      let labelValue = this.getLabelForValue(value);
	                      if (labelValue.length) {
	                        return labelValue;
	                      }
	                    }
	                  },
	                  grid: {
	                    display: false
	                  },
	                  border: {
	                    display: false
	                  }
	                },
	                y: {
	                  display: true,
	                  min: 0,
	                  suggestedMax: Math.ceil(maxRangeValue / Math.pow(10, maxRangeMagnitude)) * Math.pow(10, maxRangeMagnitude),
	                  ticks: {
	                    padding: yAxisPadding,
	                    count: 9,
	                    color: '#5C667A',
	                    crossAlign: 'near',
	                    font: {
	                      size: 12,
	                      family: 'Lexend, sans-serif'
	                    },
	                    callback(value) {
	                      let valueByMagnitude = _.getValueByMagnitude(Math.round(value), 'round', 1, false);
	                      if (_.isMobileScreen()) {
	                        return showChartBandwidth ? `${_.formatNumber(valueByMagnitude)} ${valueUnits}` : _.formatToShortNumber(valueByMagnitude);
	                      }
	                      return showChartBandwidth ? `${_.formatNumber(valueByMagnitude)} ${valueUnits}` : _.formatNumber(valueByMagnitude);
	                    }
	                  },
	                  grid: {
	                    display: false
	                  },
	                  border: {
	                    display: false
	                  }
	                }
	              }
	            }
	          };
	          statsChart = createBarChart(statsChartCanvasEl, chartData, chartSettings, chartConfig);
	        });

	        // create lineChart
	        this.observe('preparedHitsChartData', preparedHitsChartData => {
	          if (!preparedHitsChartData) {
	            return;
	          }
	          let {
	            datasets,
	            labels,
	            maxRangeValue,
	            useYAxisBorderPlugin,
	            showChartBandwidth,
	            yAxisPadding,
	            labelsStartEndPeriods,
	            valueUnits,
	            usageChartGroupBy
	          } = preparedHitsChartData;
	          let hitsChartCanvasEl = this.find('#hits-chart');
	          if (!preparedHitsChartData || !hitsChartCanvasEl) {
	            return;
	          }
	          if (hitsChart) {
	            hitsChart.destroy();
	            hitsChart = null;
	          }
	          let chartData = {
	            labels,
	            datasets,
	            labelsStartEndPeriods,
	            valueUnits,
	            usageChartGroupBy
	          };
	          let chartSettings = {
	            useYAxisBorderPlugin,
	            useExternalTooltip: true,
	            useImprovedTooltip: true,
	            noSpaceForImprvdTltp: true,
	            plugins: {
	              useExternalTooltip: true
	            }
	          };
	          let maxRangeMagnitude = Math.floor(Math.log10(maxRangeValue));
	          let chartConfig = {
	            options: {
	              scales: {
	                x: {
	                  display: true,
	                  ticks: {
	                    autoSkip: false,
	                    color: '#5C667A',
	                    font: {
	                      size: 12,
	                      family: 'Lexend, sans-serif',
	                      lineHeight: 2
	                    },
	                    callback(value) {
	                      let labelValue = this.getLabelForValue(value);
	                      if (labelValue.length) {
	                        return labelValue;
	                      }
	                    }
	                  },
	                  grid: {
	                    display: false
	                  },
	                  border: {
	                    display: false
	                  }
	                },
	                y: {
	                  display: true,
	                  min: 0,
	                  suggestedMax: Math.ceil(maxRangeValue / Math.pow(10, maxRangeMagnitude)) * Math.pow(10, maxRangeMagnitude),
	                  ticks: {
	                    padding: yAxisPadding,
	                    count: 9,
	                    color: '#5C667A',
	                    crossAlign: 'near',
	                    font: {
	                      size: 12,
	                      family: 'Lexend, sans-serif'
	                    },
	                    callback(value) {
	                      let valueByMagnitude = _.getValueByMagnitude(Math.round(value), 'round', 1, false);
	                      if (_.isMobileScreen()) {
	                        return showChartBandwidth ? `${_.formatNumber(valueByMagnitude)} ${valueUnits}` : _.formatToShortNumber(valueByMagnitude);
	                      }
	                      return showChartBandwidth ? `${_.formatNumber(valueByMagnitude)} ${valueUnits}` : _.formatNumber(valueByMagnitude);
	                    }
	                  },
	                  grid: {
	                    color: '#CFD6DD',
	                    tickLength: 0
	                  },
	                  border: {
	                    display: false
	                  }
	                }
	              }
	            }
	          };
	          hitsChart = createLineChart(hitsChartCanvasEl, chartData, chartSettings, chartConfig);
	        });
	      });
	      listeners.screenWidthListener(this);
	    }
	  },
	  handlePeriodSelecting() {
	    return periodData => {
	      this.set('periodData', periodData);
	    };
	  },
	  checkPackageVersionsDataStatus(response) {
	    return response.reduce((res, data) => {
	      if (data.hits.total) {
	        res.noHitsData = false;
	      }
	      if (data.bandwidth.total) {
	        res.noBandwidthData = false;
	      }
	      return res;
	    }, {
	      noHitsData: true,
	      noBandwidthData: true
	    });
	  }
	};
	component$z.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      t: 13,
	      n: "class",
	      f: "header",
	      g: 1
	    }],
	    f: [{
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "header-title",
	        g: 1
	      }],
	      f: ["Statistics"]
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "header-ctrls",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "data-range-ctrl",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "span",
	          f: ["Data range:"]
	        }, " ", {
	          t: 7,
	          e: "c-periods-dropdown",
	          m: [{
	            n: "selectedValue",
	            f: [{
	              t: 2,
	              r: "periodData.periodValue"
	            }],
	            t: 13
	          }, {
	            n: "selectHandler",
	            f: [{
	              t: 2,
	              x: {
	                r: ["@this"],
	                s: "_0.handlePeriodSelecting()"
	              }
	            }],
	            t: 13
	          }]
	        }]
	      }]
	    }]
	  }, " ", {
	    t: 4,
	    f: [{
	      t: 7,
	      e: "c-package-request-bandwidth-stats",
	      m: [{
	        n: "name",
	        f: [{
	          t: 2,
	          r: "name"
	        }],
	        t: 13
	      }, {
	        n: "type",
	        f: [{
	          t: 2,
	          r: "type"
	        }],
	        t: 13
	      }, {
	        n: "periodData",
	        f: [{
	          t: 2,
	          r: "periodData"
	        }],
	        t: 13
	      }],
	      f: []
	    }],
	    n: 50,
	    x: {
	      r: ["tabRoute", "NAV_MENU_TABS.stats"],
	      s: "_0===_1"
	    }
	  }, {
	    t: 4,
	    f: [{
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "no-data-wrapper",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "img",
	        m: [{
	          n: "width",
	          f: "180",
	          t: 13,
	          g: 1
	        }, {
	          n: "height",
	          f: "152",
	          t: 13,
	          g: 1
	        }, {
	          n: "src",
	          f: [{
	            t: 2,
	            r: "@shared.assetsHost"
	          }, "/img/no-data-chart-main.svg"],
	          t: 13
	        }]
	      }, " ", {
	        t: 7,
	        e: "span",
	        f: ["No statistics yet"]
	      }, " ", {
	        t: 7,
	        e: "span",
	        f: ["This is probably not a very popular package :("]
	      }]
	    }],
	    n: 50,
	    r: "noPackageStatsData"
	  }, {
	    t: 4,
	    f: [{
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "chart-stats-per-period",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "package-usage",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "small-headline",
	            g: 1
	          }],
	          f: [{
	            t: 2,
	            r: "chartTitlePeriodText"
	          }, " ", {
	            t: 2,
	            r: "~/periodData.periodText"
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "chart-type-ctrl",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "span",
	            f: ["Show numbers of"]
	          }, " ", {
	            t: 7,
	            e: "input",
	            m: [{
	              n: "id",
	              f: "chart-switch",
	              t: 13
	            }, {
	              n: "type",
	              f: "checkbox",
	              t: 13
	            }, {
	              n: "class",
	              f: ["chart-type-switch ", {
	                t: 4,
	                f: ["checked"],
	                n: 50,
	                r: "showChartBandwidth"
	              }],
	              t: 13
	            }, {
	              t: 73,
	              v: "t",
	              f: "false"
	            }]
	          }, " ", {
	            t: 7,
	            e: "label",
	            m: [{
	              n: "for",
	              f: "chart-switch",
	              t: 13,
	              g: 1
	            }, {
	              n: ["click"],
	              t: 70,
	              f: {
	                r: ["@this", "showChartBandwidth"],
	                s: "[_0.set(\"showChartBandwidth\",!_1)]"
	              }
	            }],
	            f: [{
	              t: 7,
	              e: "span",
	              f: ["Requests"]
	            }, " ", {
	              t: 7,
	              e: "span",
	              f: ["Bandwidth"]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "slide-select",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "selected",
	                  g: 1
	                }]
	              }]
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "group-by-ctrl",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "span",
	            f: ["Group by:"]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "btn-group",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "button",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "btn dropdown-toggle",
	                g: 1
	              }, {
	                n: "type",
	                f: "button",
	                t: 13,
	                g: 1
	              }, {
	                n: "data-toggle",
	                f: "dropdown",
	                t: 13,
	                g: 1
	              }, {
	                n: "aria-haspopup",
	                f: "true",
	                t: 13,
	                g: 1
	              }, {
	                n: "aria-expanded",
	                f: "false",
	                t: 13,
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "span",
	                f: [{
	                  t: 2,
	                  rx: {
	                    r: "~/usageChartGroupByValues",
	                    m: [{
	                      t: 30,
	                      n: "usageChartGroupBy"
	                    }, "value"]
	                  }
	                }]
	              }, " ", {
	                t: 7,
	                e: "i",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "fa fa-angle-down",
	                  g: 1
	                }, {
	                  n: "aria-hidden",
	                  f: "true",
	                  t: 13,
	                  g: 1
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "ul",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "dropdown-menu",
	                g: 1
	              }],
	              f: [{
	                t: 4,
	                f: [{
	                  t: 7,
	                  e: "li",
	                  f: [{
	                    t: 4,
	                    f: [{
	                      t: 7,
	                      e: "a",
	                      m: [{
	                        n: ["click"],
	                        t: 70,
	                        f: {
	                          r: ["@this", "@key"],
	                          s: "[_0.set(\"usageChartGroupBy\",_1)]"
	                        }
	                      }],
	                      f: [{
	                        t: 2,
	                        r: "./value"
	                      }]
	                    }],
	                    n: 50,
	                    r: "./isAvailable"
	                  }]
	                }],
	                n: 52,
	                r: "~/usageChartGroupByValues"
	              }]
	            }]
	          }]
	        }]
	      }, " ", {
	        t: 4,
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "stats-chart-no-data",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "img",
	            m: [{
	              n: "width",
	              f: "270",
	              t: 13,
	              g: 1
	            }, {
	              n: "height",
	              f: "148",
	              t: 13,
	              g: 1
	            }, {
	              n: "src",
	              f: [{
	                t: 2,
	                r: "@shared.assetsHost"
	              }, "/img/landing/new/no-results.svg"],
	              t: 13
	            }]
	          }, " ", {
	            t: 7,
	            e: "span",
	            f: ["No data"]
	          }]
	        }],
	        n: 50,
	        x: {
	          r: ["noStatsChartHitsData", "noStatsChartBandData", "showChartBandwidth"],
	          s: "(_0&&!_2)||(_1&&_2)"
	        }
	      }, {
	        t: 4,
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "stats-chart-wrapper",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "canvas",
	            m: [{
	              n: "id",
	              f: "stats-chart",
	              t: 13,
	              g: 1
	            }]
	          }]
	        }],
	        n: 51,
	        l: 1
	      }]
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "horizontal-divider",
	        g: 1
	      }]
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "chart-tops",
	        g: 1
	      }],
	      f: [{
	        t: 4,
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "chart-tops-no-data",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "img",
	            m: [{
	              n: "width",
	              f: "270",
	              t: 13,
	              g: 1
	            }, {
	              n: "height",
	              f: "148",
	              t: 13,
	              g: 1
	            }, {
	              n: "src",
	              f: [{
	                t: 2,
	                r: "@shared.assetsHost"
	              }, "/img/landing/new/no-results.svg"],
	              t: 13
	            }]
	          }, " ", {
	            t: 7,
	            e: "span",
	            f: ["No data for Top versions"]
	          }]
	        }],
	        n: 50,
	        x: {
	          r: ["noTopFiveHitsData", "noTopFiveBandData", "showChartBandwidth"],
	          s: "(_0&&!_2)||(_1&&_2)"
	        }
	      }, {
	        t: 4,
	        f: [{
	          t: 7,
	          e: "c-top-stats-table",
	          m: [{
	            n: "title",
	            f: "Top versions",
	            t: 13,
	            g: 1
	          }, {
	            n: "responseData",
	            f: [{
	              t: 2,
	              r: "~/topVersions"
	            }],
	            t: 13
	          }, {
	            n: "responseHeaders",
	            f: [{
	              t: 2,
	              r: "topVersionsHeaders"
	            }],
	            t: 13
	          }, {
	            n: "version",
	            f: [{
	              t: 2,
	              r: "~/fileStatsVersion"
	            }],
	            t: 13
	          }, {
	            n: "isBandwidth",
	            f: [{
	              t: 2,
	              r: "~/showChartBandwidth"
	            }],
	            t: 13
	          }, {
	            n: "pageLimit",
	            f: [{
	              t: 2,
	              r: "topTablesLimit"
	            }],
	            t: 13
	          }, {
	            n: "page",
	            f: [{
	              t: 2,
	              r: "topPackagesPage"
	            }],
	            t: 13
	          }],
	          f: [],
	          p: {
	            column1: [{
	              t: 7,
	              e: "a",
	              m: [{
	                n: ["click"],
	                t: 70,
	                f: {
	                  r: ["@this", "version"],
	                  s: "[_0.set(\"version\",_1)]"
	                }
	              }],
	              f: [{
	                t: 2,
	                r: "version"
	              }]
	            }]
	          }
	        }, " ", {
	          t: 7,
	          e: "c-top-stats-table",
	          m: [{
	            n: "type",
	            f: [{
	              t: 2,
	              r: "~/type"
	            }],
	            t: 13
	          }, {
	            n: "name",
	            f: [{
	              t: 2,
	              r: "~/name"
	            }],
	            t: 13
	          }, {
	            n: "responseData",
	            f: [{
	              t: 2,
	              r: "~/filesStats"
	            }],
	            t: 13
	          }, {
	            n: "responseHeaders",
	            f: [{
	              t: 2,
	              r: "filesStatsHeaders"
	            }],
	            t: 13
	          }, {
	            n: "version",
	            f: [{
	              t: 2,
	              r: "~/fileStatsVersion"
	            }],
	            t: 13
	          }, {
	            n: "versions",
	            f: [{
	              t: 2,
	              r: "~/packageVersionsList"
	            }],
	            t: 13
	          }, {
	            n: "isBandwidth",
	            f: [{
	              t: 2,
	              r: "~/showChartBandwidth"
	            }],
	            t: 13
	          }, {
	            n: "pageLimit",
	            f: [{
	              t: 2,
	              r: "topTablesLimit"
	            }],
	            t: 13
	          }, {
	            n: "page",
	            f: [{
	              t: 2,
	              r: "filesStatsPage"
	            }],
	            t: 13
	          }, {
	            n: "handleVersionChange",
	            f: "true",
	            t: 13,
	            g: 1
	          }],
	          f: [" "],
	          p: {
	            header: ["Top files in version ", {
	              t: 7,
	              e: "c-version-dropdown",
	              m: [{
	                n: "versions",
	                f: [{
	                  t: 2,
	                  r: "versions"
	                }],
	                t: 13
	              }, {
	                n: "version",
	                f: [{
	                  t: 2,
	                  r: "version"
	                }],
	                t: 13
	              }]
	            }],
	            column1: [{
	              t: 7,
	              e: "a",
	              m: [{
	                n: "title",
	                f: [{
	                  t: 2,
	                  r: "file"
	                }],
	                t: 13
	              }, {
	                n: "target",
	                f: "_blank",
	                t: 13,
	                g: 1
	              }, {
	                n: "rel",
	                f: "noopener noreferrer",
	                t: 13,
	                g: 1
	              }, {
	                n: "href",
	                f: ["https://cdn.jsdelivr.net/", {
	                  t: 2,
	                  r: "~/type"
	                }, "/", {
	                  t: 2,
	                  r: "~/name"
	                }, "@", {
	                  t: 2,
	                  r: "~/version"
	                }, {
	                  t: 2,
	                  r: "file"
	                }],
	                t: 13
	              }],
	              f: [{
	                t: 2,
	                r: "file"
	              }]
	            }]
	          }
	        }],
	        n: 51,
	        l: 1
	      }]
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "horizontal-divider",
	        g: 1
	      }]
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "chart-hits-per-period",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "package-usage",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "small-headline",
	            g: 1
	          }],
	          f: [{
	            t: 4,
	            f: ["Bandwidth"],
	            n: 50,
	            r: "showChartBandwidth"
	          }, {
	            t: 4,
	            f: ["Requests"],
	            n: 51,
	            l: 1
	          }, " per ", {
	            t: 2,
	            r: "~/periodData.periodText"
	          }, " per version"]
	        }]
	      }, " ", {
	        t: 4,
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "hits-chart-no-data",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "img",
	            m: [{
	              n: "width",
	              f: "270",
	              t: 13,
	              g: 1
	            }, {
	              n: "height",
	              f: "148",
	              t: 13,
	              g: 1
	            }, {
	              n: "src",
	              f: [{
	                t: 2,
	                r: "@shared.assetsHost"
	              }, "/img/landing/new/no-results.svg"],
	              t: 13
	            }]
	          }, " ", {
	            t: 7,
	            e: "span",
	            f: ["No data"]
	          }]
	        }],
	        n: 50,
	        x: {
	          r: ["noHitsChartHitsData", "noHitsChartBandData", "showChartBandwidth"],
	          s: "(_0&&!_2)||(_1&&_2)"
	        }
	      }, {
	        t: 4,
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "hits-chart-wrapper",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "canvas",
	            m: [{
	              n: "id",
	              f: "hits-chart",
	              t: 13,
	              g: 1
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "hits-chart-legend",
	            g: 1
	          }],
	          f: [{
	            t: 4,
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "legend-item",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  n: "style",
	                  f: ["background: ", {
	                    t: 2,
	                    rx: {
	                      r: "colorsArray",
	                      m: [{
	                        t: 30,
	                        n: "idx"
	                      }]
	                    }
	                  }, ";"],
	                  t: 13
	                }]
	              }, " ", {
	                t: 2,
	                r: "version"
	              }]
	            }],
	            n: 52,
	            i: "idx",
	            r: "hitsChartLegendVersions"
	          }]
	        }],
	        n: 51,
	        l: 1
	      }]
	    }],
	    n: 51,
	    l: 1
	  }],
	  e: {
	    "_0.handlePeriodSelecting()": function (_0) {
	      return _0.handlePeriodSelecting();
	    },
	    "_0===_1": function (_0, _1) {
	      return _0 === _1;
	    },
	    "[_0.set(\"showChartBandwidth\",!_1)]": function (_0, _1) {
	      return [_0.set("showChartBandwidth", !_1)];
	    },
	    "[_0.set(\"usageChartGroupBy\",_1)]": function (_0, _1) {
	      return [_0.set("usageChartGroupBy", _1)];
	    },
	    "(_0&&!_2)||(_1&&_2)": function (_0, _1, _2) {
	      return _0 && !_2 || _1 && _2;
	    },
	    "[_0.set(\"version\",_1)]": function (_0, _1) {
	      return [_0.set("version", _1)];
	    }
	  }
	};
	component$z.exports.components = {
	  "c-version-dropdown": versionDropdown,
	  "c-top-stats-table": topStatsTable,
	  "c-periods-dropdown": periodsDropdown,
	  "c-package-request-bandwidth-stats": packageRequestBandwidthStats
	};
	var packageStats = ractive__default["default"].extend(component$z.exports);

	var component$y = {
	  exports: {}
	};
	component$y.exports = {
	  computed: {
	    barThickness() {
	      switch (this.get('periodData').periodType) {
	        case 's-quarter':
	          return 2;
	        case 's-year':
	          return 1;
	        default:
	          return 4;
	      }
	    },
	    usageChartGroupBy() {
	      switch (this.get('periodData').periodType) {
	        default:
	          return 'day';
	      }
	    }
	  },
	  data() {
	    return {
	      _,
	      periodData: {
	        periodText: 'month',
	        periodValue: 'month',
	        periodType: 's-month'
	      },
	      noDataOfRequests: false,
	      noDataOfBandwidth: false,
	      noDataOfVersions: false,
	      topVersionHits: 0,
	      bandwidthTotal: 0,
	      requestsTotal: 0,
	      twitterPeriodPartText: ''
	    };
	  },
	  decorators: {
	    clipboard,
	    tooltip
	  },
	  oninit() {
	    if (!ractive__default["default"].isServer) {
	      this.set('link', this.get('@global.location.href'));
	      this.observe('periodData.periodValue', periodValue => {
	        if (periodValue) {
	          let type = this.get('type');
	          let name = this.get('name');

	          // get overall package stats (hits-bandwidth data for charts, hits rank of package)
	          http.fetchPackageSummaryStats(type, name, periodValue).then(response => {
	            this.animate('packageRank', response.hits.rank + 1, {
	              duration: 1000
	            });
	            if (response.hits.total) {
	              this.set('noDataOfRequests', false);
	              this.set('packageDateStats', response.hits);
	              this.animate('requestsTotal', response.hits.total, {
	                duration: 1000
	              });
	            } else {
	              this.set('noDataOfRequests', true);
	            }
	            if (response.bandwidth.total) {
	              this.set('noDataOfBandwidth', false);
	              this.set('packageBandwidthStats', response.bandwidth);
	              this.set('bandwidthUnit', _.findUnitFromNumber(response.bandwidth.total));
	              this.animate('bandwidthTotal', _.convertBytesToUnits(response.bandwidth.total, this.get('bandwidthUnit')), {
	                duration: 1000
	              });
	            } else {
	              this.set('noDataOfBandwidth', true);
	            }
	          });

	          // get package top version stats
	          http.fetchPackageVersionsStats(type, name, periodValue, 'hits').then(response => {
	            if (!response.length) {
	              this.set('noDataOfVersions', true);
	              return;
	            }
	            this.set('topVersion', response[0].version);
	            this.animate('topVersionHits', response[0].hits.total, {
	              duration: 1000
	            });
	          });
	        }
	      });
	      this.observe('periodData.periodText', periodText => {
	        let twitterPeriodPartText = 'in the ';
	        if (periodText === 'month' || periodText === 'quarter' || periodText === 'year') {
	          twitterPeriodPartText += 'last ';
	        }
	        twitterPeriodPartText += periodText;
	        this.set('twitterPeriodPartText', twitterPeriodPartText);
	      });
	      charts().then(({
	        createBarChart
	      }) => {
	        this.observe('packageDateStats tabRoute', () => {
	          if (this.get('tabRoute') === 'stats') {
	            return null;
	          }
	          let packageDateStats = this.get('packageDateStats');
	          let chartPeriodType = this.get('periodData').periodType;
	          let usageChartGroupBy = this.get('usageChartGroupBy');
	          if (!packageDateStats) {
	            return null;
	          }
	          let {
	            values,
	            labels,
	            valueUnits
	          } = _.getPreparedDataForBarChart(packageDateStats, usageChartGroupBy, chartPeriodType, false);

	          // temp solution to fix chart recreation after switching from stats tab
	          setTimeout(() => {
	            let requestsChart = this.get('requestsChart');
	            if (requestsChart) {
	              requestsChart.destroy();
	              this.set('requestsChart', null);
	            }
	            let chartEl = this.find('#requests-chart');
	            let chartData = {
	              labels,
	              datasets: [{
	                data: values,
	                borderWidth: 0,
	                barThickness: this.get('barThickness'),
	                hoverBackgroundColor: '#F65128',
	                borderRadius: 1
	              }],
	              valueUnits
	            };
	            let chartSettings = {
	              useExternalTooltip: true,
	              externalTooltipId: 'packageSidemenuRequestsChartTooltip',
	              externalTooltipVerticalOffset: 40
	            };
	            let chartConfig = {
	              options: {
	                scales: {
	                  x: {
	                    display: false
	                  },
	                  y: {
	                    display: false
	                  }
	                }
	              }
	            };
	            requestsChart = createBarChart(chartEl, chartData, chartSettings, chartConfig);
	            this.set('requestsChart', requestsChart);
	          }, 100);
	        });
	        this.observe('packageBandwidthStats tabRoute', () => {
	          if (this.get('tabRoute') === 'stats') {
	            return null;
	          }
	          let packageBandwidthStats = this.get('packageBandwidthStats');
	          let chartPeriodType = this.get('periodData').periodType;
	          let usageChartGroupBy = this.get('usageChartGroupBy');
	          if (!packageBandwidthStats) {
	            return null;
	          }
	          let {
	            values,
	            labels,
	            valueUnits
	          } = _.getPreparedDataForBarChart(packageBandwidthStats, usageChartGroupBy, chartPeriodType, true);

	          // temp solution to fix chart recreation after switching from stats tab
	          setTimeout(() => {
	            let bandwidthChart = this.get('bandwidthChart');
	            if (bandwidthChart) {
	              bandwidthChart.destroy();
	              this.set('bandwidthChart', null);
	            }
	            let chartEl = this.find('#bandwidth-chart');
	            let chartData = {
	              labels,
	              datasets: [{
	                data: values,
	                borderWidth: 0,
	                barThickness: this.get('barThickness'),
	                hoverBackgroundColor: '#F65128',
	                borderRadius: 1
	              }],
	              valueUnits
	            };
	            let chartSettings = {
	              useExternalTooltip: true,
	              externalTooltipId: 'packageSidemenuBandwidthChartTooltip',
	              externalTooltipVerticalOffset: 40
	            };
	            let chartConfig = {
	              options: {
	                scales: {
	                  x: {
	                    display: false
	                  },
	                  y: {
	                    display: false
	                  }
	                }
	              }
	            };
	            bandwidthChart = createBarChart(chartEl, chartData, chartSettings, chartConfig);
	            this.set('bandwidthChart', bandwidthChart);
	          }, 100);
	        });
	      });
	    }
	  },
	  handlePeriodSelecting() {
	    return periodData => {
	      this.set('periodData', periodData);
	    };
	  }
	};
	component$y.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      t: 13,
	      n: "class",
	      f: "c-package-sidemenu",
	      g: 1
	    }],
	    f: [{
	      t: 7,
	      e: "div",
	      m: [{
	        n: "class",
	        f: ["package-stats ", {
	          t: 2,
	          x: {
	            r: ["tabRoute"],
	            s: "_0===\"stats\"?\"move-top\":\"\""
	          }
	        }],
	        t: 13
	      }],
	      f: [{
	        t: 4,
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            n: "class",
	            f: ["block-shadow ", {
	              t: 2,
	              x: {
	                r: ["tabRoute"],
	                s: "_0===\"files\"?\"bottom\":_0===\"stats\"?\"top\":\"\""
	              }
	            }],
	            t: 13
	          }]
	        }],
	        n: 51,
	        x: {
	          r: ["tabRoute", "type"],
	          s: "_0===\"stats\"&&_1!==\"npm\""
	        }
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          n: "style",
	          f: ["position: relative; z-index: 1;", {
	            t: 4,
	            f: ["display: none;"],
	            n: 51,
	            x: {
	              r: ["tabRoute"],
	              s: "_0!==\"stats\""
	            }
	          }],
	          t: 13
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "sidemenu-title",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "span",
	            f: ["Statistics"]
	          }, " ", {
	            t: 7,
	            e: "c-periods-dropdown",
	            m: [{
	              n: "selectedValue",
	              f: [{
	                t: 2,
	                r: "periodData.periodValue"
	              }],
	              t: 13
	            }, {
	              n: "selectHandler",
	              f: [{
	                t: 2,
	                x: {
	                  r: ["@this"],
	                  s: "_0.handlePeriodSelecting()"
	                }
	              }],
	              t: 13
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "horizontal-divider",
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "stats-section mb-18",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "span",
	            f: ["Requests"]
	          }, " ", {
	            t: 7,
	            e: "span",
	            f: [{
	              t: 2,
	              x: {
	                r: ["noDataOfRequests", "_", "requestsTotal"],
	                s: "_0?\"No data\":_1.formatNumber(_2)"
	              }
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "requests-chart-wrapper",
	            g: 1
	          }],
	          f: [{
	            t: 4,
	            f: [{
	              t: 7,
	              e: "img",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "empty-chart",
	                g: 1
	              }, {
	                n: "src",
	                f: [{
	                  t: 2,
	                  r: "@shared.assetsHost"
	                }, "/img/no-data-chart-side.svg"],
	                t: 13
	              }, {
	                n: "width",
	                f: "294",
	                t: 13,
	                g: 1
	              }, {
	                n: "height",
	                f: "56",
	                t: 13,
	                g: 1
	              }]
	            }],
	            n: 50,
	            r: "noDataOfRequests"
	          }, {
	            t: 4,
	            f: [{
	              t: 7,
	              e: "canvas",
	              m: [{
	                n: "id",
	                f: "requests-chart",
	                t: 13,
	                g: 1
	              }]
	            }],
	            n: 51,
	            l: 1
	          }]
	        }, " ", {
	          t: 4,
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "horizontal-divider",
	              g: 1
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "stats-section mb-18",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "span",
	              f: ["Bandwidth"]
	            }, " ", {
	              t: 7,
	              e: "span",
	              f: [{
	                t: 4,
	                f: ["No data"],
	                n: 50,
	                r: "noDataOfBandwidth"
	              }, {
	                t: 4,
	                f: [{
	                  t: 2,
	                  x: {
	                    r: ["_", "bandwidthTotal"],
	                    s: "_0.formatNumber(_1)"
	                  }
	                }, " ", {
	                  t: 2,
	                  r: "bandwidthUnit"
	                }],
	                n: 51,
	                l: 1
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "bandwidth-chart-wrapper",
	              g: 1
	            }],
	            f: [{
	              t: 4,
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "empty-chart",
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/no-data-chart-side.svg"],
	                  t: 13
	                }, {
	                  n: "width",
	                  f: "294",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "56",
	                  t: 13,
	                  g: 1
	                }]
	              }],
	              n: 50,
	              r: "noDataOfBandwidth"
	            }, {
	              t: 4,
	              f: [{
	                t: 7,
	                e: "canvas",
	                m: [{
	                  n: "id",
	                  f: "bandwidth-chart",
	                  t: 13,
	                  g: 1
	                }]
	              }],
	              n: 51,
	              l: 1
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "horizontal-divider",
	              g: 1
	            }]
	          }],
	          n: 50,
	          x: {
	            r: ["tabRoute", "type"],
	            s: "_0===\"readme\"||_1===\"npm\""
	          }
	        }]
	      }, " ", {
	        t: 4,
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "stats-section mb-24",
	            g: 1
	          }],
	          f: [{
	            t: 9,
	            c: " show package version if no data of top versions "
	          }, " ", {
	            t: 7,
	            e: "span",
	            f: ["Top version - ", {
	              t: 2,
	              x: {
	                r: ["noDataOfVersions", "package.version", "topVersion"],
	                s: "_0?_1:_2"
	              }
	            }]
	          }, " ", {
	            t: 7,
	            e: "span",
	            f: [{
	              t: 4,
	              f: ["No data"],
	              n: 50,
	              r: "noDataOfVersions"
	            }, {
	              t: 4,
	              f: [{
	                t: 2,
	                x: {
	                  r: ["_", "topVersionHits"],
	                  s: "_0.formatNumber(_1)"
	                }
	              }],
	              n: 51,
	              l: 1
	            }]
	          }]
	        }],
	        n: 50,
	        x: {
	          r: ["tabRoute", "type"],
	          s: "_0===\"readme\"||_1===\"npm\""
	        }
	      }, " ", {
	        t: 4,
	        f: [{
	          t: 4,
	          f: [{
	            t: 7,
	            e: "a",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "btn-secondary",
	              g: 1
	            }, {
	              n: ["click"],
	              t: 70,
	              f: {
	                r: ["@this"],
	                s: "[_0.set(\"tabRoute\",\"stats\")]"
	              }
	            }],
	            f: ["Full ", {
	              t: 2,
	              r: "name"
	            }, " Download Stats"]
	          }],
	          n: 50,
	          x: {
	            r: ["tabRoute", "type"],
	            s: "_0===\"readme\"||_1===\"npm\""
	          }
	        }, " ", {
	          t: 4,
	          f: [{
	            t: 4,
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "horizontal-divider",
	                g: 1
	              }]
	            }],
	            n: 50,
	            x: {
	              r: ["tabRoute", "type"],
	              s: "_0===\"readme\"||_1===\"npm\""
	            }
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "twitter-share",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              f: [{
	                t: 4,
	                f: ["The ", {
	                  t: 2,
	                  x: {
	                    r: ["_", "packageRank"],
	                    s: "_0.nth(_1)"
	                  }
	                }, " most popular on jsDelivr"],
	                n: 50,
	                r: "packageRank"
	              }]
	            }, " ", {
	              t: 7,
	              e: "a",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "btn-twitter-share mt-8",
	                g: 1
	              }, {
	                n: "target",
	                f: "_blank",
	                t: 13,
	                g: 1
	              }, {
	                n: "rel",
	                f: "noopener noreferrer",
	                t: 13,
	                g: 1
	              }, {
	                n: "href",
	                f: ["https://twitter.com/intent/tweet?text=", {
	                  t: 2,
	                  x: {
	                    r: ["name", "packageRank", "_", "requestsTotal", "twitterPeriodPartText", "~/link"],
	                    s: "encodeURIComponent((\"\"+(_0)+\" is the \"+(_2.nth(_1))+\" most popular package on @jsDelivr CDN, with \"+(_2.formatNumber(_3))+\" hits \"+(_4)+\": \"+(_5)))"
	                  }
	                }],
	                t: 13
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "20",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "20",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/icons/twitter-white.svg"],
	                  t: 13
	                }]
	              }, " Share"]
	            }]
	          }],
	          n: 51,
	          r: "noDataOfVersions"
	        }, " ", {
	          t: 4,
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "stats-keywords mt-32",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "stats-keywords-header",
	                g: 1
	              }],
	              f: ["Keywords"]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                n: "class",
	                f: ["stats-keywords-badges ", {
	                  t: 4,
	                  f: ["shortened"],
	                  n: 50,
	                  x: {
	                    r: ["tabRoute"],
	                    s: "_0===\"stats\""
	                  }
	                }],
	                t: 13
	              }],
	              f: [{
	                t: 4,
	                f: [{
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "keyword-badge",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 2,
	                    r: "."
	                  }]
	                }],
	                n: 52,
	                r: "package.keywords"
	              }, " ", {
	                t: 4,
	                f: [{
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "badge-cover",
	                    g: 1
	                  }]
	                }],
	                n: 50,
	                x: {
	                  r: [],
	                  s: "true===\"stats\""
	                }
	              }]
	            }]
	          }],
	          n: 50,
	          r: "package.keywords"
	        }],
	        n: 50,
	        x: {
	          r: ["tabRoute"],
	          s: "_0!==\"files\""
	        }
	      }]
	    }, " ", {
	      t: 4,
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "box-badge mt-32 mb-32",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "box-title",
	            g: 1
	          }],
	          f: ["Get a badge for your package"]
	        }, " ", {
	          t: 7,
	          e: "img",
	          m: [{
	            n: "src",
	            f: ["https://data.jsdelivr.com/v1/package/", {
	              t: 2,
	              x: {
	                r: ["~/type"],
	                s: "_0||\"npm\""
	              }
	            }, "/", {
	              t: 2,
	              r: "name"
	            }, "/badge", {
	              t: 4,
	              f: ["?style=rounded"],
	              n: 50,
	              r: "~/badgeAltStyle"
	            }],
	            t: 13
	          }]
	        }, " ", {
	          t: 7,
	          e: "img",
	          m: [{
	            n: "clipboard",
	            t: 71,
	            f: {
	              r: [],
	              s: "[\"Copy markdown to clipboard\"]"
	            }
	          }, {
	            n: "data-clipboard-text",
	            f: ["[![](https://data.jsdelivr.com/v1/package/", {
	              t: 2,
	              r: "~/type"
	            }, "/", {
	              t: 2,
	              r: "~/name"
	            }, "/badge", {
	              t: 4,
	              f: ["?style=rounded"],
	              n: 50,
	              r: "~/badgeAltStyle"
	            }, ")](https://www.jsdelivr.com/package/", {
	              t: 2,
	              r: "~/type"
	            }, "/", {
	              t: 2,
	              r: "~/name"
	            }, ")"],
	            t: 13
	          }, {
	            n: "width",
	            f: "20",
	            t: 13,
	            g: 1
	          }, {
	            n: "height",
	            f: "20",
	            t: 13,
	            g: 1
	          }, {
	            n: "src",
	            f: [{
	              t: 2,
	              r: "@shared.assetsHost"
	            }, "/img/icons/copy-btn-black.svg"],
	            t: 13
	          }]
	        }, " ", {
	          t: 7,
	          e: "img",
	          m: [{
	            n: "tooltip",
	            t: 71,
	            f: {
	              r: [],
	              s: "[\"Alternate badge style\"]"
	            }
	          }, {
	            n: ["click"],
	            t: 70,
	            f: {
	              r: ["@this"],
	              s: "[_0.toggle(\"badgeAltStyle\")]"
	            }
	          }, {
	            n: "width",
	            f: "20",
	            t: 13,
	            g: 1
	          }, {
	            n: "height",
	            f: "20",
	            t: 13,
	            g: 1
	          }, {
	            n: "src",
	            f: [{
	              t: 2,
	              r: "@shared.assetsHost"
	            }, "/img/icons/alternate-btn.svg"],
	            t: 13
	          }]
	        }]
	      }],
	      n: 50,
	      x: {
	        r: ["tabRoute"],
	        s: "_0!==\"files\""
	      }
	    }]
	  }],
	  e: {
	    "_0===\"stats\"?\"move-top\":\"\"": function (_0) {
	      return _0 === "stats" ? "move-top" : "";
	    },
	    "_0===\"files\"?\"bottom\":_0===\"stats\"?\"top\":\"\"": function (_0) {
	      return _0 === "files" ? "bottom" : _0 === "stats" ? "top" : "";
	    },
	    "_0===\"stats\"&&_1!==\"npm\"": function (_0, _1) {
	      return _0 === "stats" && _1 !== "npm";
	    },
	    "_0!==\"stats\"": function (_0) {
	      return _0 !== "stats";
	    },
	    "_0.handlePeriodSelecting()": function (_0) {
	      return _0.handlePeriodSelecting();
	    },
	    "_0?\"No data\":_1.formatNumber(_2)": function (_0, _1, _2) {
	      return _0 ? "No data" : _1.formatNumber(_2);
	    },
	    "_0.formatNumber(_1)": function (_0, _1) {
	      return _0.formatNumber(_1);
	    },
	    "_0===\"readme\"||_1===\"npm\"": function (_0, _1) {
	      return _0 === "readme" || _1 === "npm";
	    },
	    "_0?_1:_2": function (_0, _1, _2) {
	      return _0 ? _1 : _2;
	    },
	    "[_0.set(\"tabRoute\",\"stats\")]": function (_0) {
	      return [_0.set("tabRoute", "stats")];
	    },
	    "_0.nth(_1)": function (_0, _1) {
	      return _0.nth(_1);
	    },
	    "encodeURIComponent((\"\"+(_0)+\" is the \"+(_2.nth(_1))+\" most popular package on @jsDelivr CDN, with \"+(_2.formatNumber(_3))+\" hits \"+(_4)+\": \"+(_5)))": function (_0, _1, _2, _3, _4, _5) {
	      return encodeURIComponent("" + _0 + " is the " + _2.nth(_1) + " most popular package on @jsDelivr CDN, with " + _2.formatNumber(_3) + " hits " + _4 + ": " + _5);
	    },
	    "_0===\"stats\"": function (_0) {
	      return _0 === "stats";
	    },
	    "true===\"stats\"": function () {
	      return true === "stats";
	    },
	    "_0!==\"files\"": function (_0) {
	      return _0 !== "files";
	    },
	    "_0||\"npm\"": function (_0) {
	      return _0 || "npm";
	    },
	    "[\"Copy markdown to clipboard\"]": function () {
	      return ["Copy markdown to clipboard"];
	    },
	    "[\"Alternate badge style\"]": function () {
	      return ["Alternate badge style"];
	    },
	    "[_0.toggle(\"badgeAltStyle\")]": function (_0) {
	      return [_0.toggle("badgeAltStyle")];
	    }
	  }
	};
	component$y.exports.components = {
	  "c-periods-dropdown": periodsDropdown
	};
	var packageSidemenu = ractive__default["default"].extend(component$y.exports);

	var everyWithoutClosingOnEarlyError = iteratorHelperWithoutClosingOnEarlyError('every', TypeError);

	// `Iterator.prototype.every` method
	// https://tc39.es/ecma262/#sec-iterator.prototype.every
	_export({
	  target: 'Iterator',
	  proto: true,
	  real: true,
	  forced: everyWithoutClosingOnEarlyError
	}, {
	  every: function every(predicate) {
	    anObject(this);
	    try {
	      aCallable(predicate);
	    } catch (error) {
	      iteratorClose(this, 'throw', error);
	    }
	    if (everyWithoutClosingOnEarlyError) return functionCall(everyWithoutClosingOnEarlyError, this, predicate);
	    var record = getIteratorDirect(this);
	    var counter = 0;
	    return !iterate(record, function (value, stop) {
	      if (!predicate(value, counter++)) return stop();
	    }, {
	      IS_RECORD: true,
	      INTERRUPTED: true
	    }).stopped;
	  }
	});

	var component$x = {
	  exports: {}
	};
	const {
	  buildIntegrity: buildIntegrity$1,
	  canBuildHtml: canBuildHtml$1,
	  buildHtml: buildHtml$1
	} = buildLinks_1;
	component$x.exports = {
	  computed: {
	    importName() {
	      let name = this.get('name').split(/[ ._-]/g).reduce((acc, value) => {
	        return acc + value.substr(0, 1).toUpperCase() + value.substr(1);
	      }).replace(/[^a-zA-Z0-9_$]/g, '');
	      if (/^\d/.test(name)) {
	        return `_${name}`;
	      }
	      return name || 'm';
	    },
	    jsFiddleJsCode() {
	      return `// See https://www.npmjs.com/package/${this.get('name')} documentation.\nimport * as ${this.get('importName')} from 'https://esm.run/${this.get('name')}';\n\nconsole.log(${this.get('importName')})\n`;
	    }
	  },
	  decorators: {
	    clipboard
	  },
	  data() {
	    return {
	      _,
	      versionsList: ['Static', 'Latest Patch', 'Latest Minor', 'Latest Major'],
	      isDefaultPackage: null,
	      isDefaultPackageTmp: null,
	      selectedVersion: 'Static',
	      selectedVersionTmp: 'Static',
	      isGuessedJsFile: false,
	      isGuessedCssFile: false,
	      buildIntegrity: buildIntegrity$1,
	      canBuildHtml: canBuildHtml$1,
	      buildHtml: buildHtml$1,
	      mobileSettingsVisible: false,
	      learnMoreHref: null,
	      entrypoints: {}
	    };
	  },
	  oninit() {
	    if (this.get('type') !== 'npm') {
	      return;
	    }
	    if (!ractive__default["default"].isServer) {
	      this.observe('isDefaultPackage name', () => {
	        let isDefaultPackage = this.get('isDefaultPackage');
	        if (isDefaultPackage) {
	          this.set('learnMoreHref', `/documentation#id-npm`);
	        } else {
	          this.set('learnMoreHref', '/esm');
	        }
	      });

	      // update selectedVersion (and tmp version for mobile) when sharedVersion was changed within FilesTab
	      this.observe('sharedVersion', sharedVersion => {
	        let initVersion = this.get('initVersion');
	        let updSelectedVersion;
	        if (sharedVersion === initVersion) {
	          updSelectedVersion = 'Static';
	        } else {
	          updSelectedVersion = sharedVersion;
	        }
	        this.set('selectedVersion', updSelectedVersion);
	        this.set('selectedVersionTmp', updSelectedVersion);
	      });

	      // handle version selection
	      this.observe('selectedVersion', selectedVersion => {
	        // clear SRI hashes from previous version
	        this.set('packageJsHash', null);
	        this.set('packageCssHash', null);
	        let installPackageVersion = '@';
	        let packageName = this.get('name');
	        let initVersion = this.get('initVersion');
	        let packageType = this.get('type');
	        let sharedVersion;
	        if (selectedVersion === 'Static') {
	          installPackageVersion += initVersion;
	          sharedVersion = initVersion;
	        } else if (selectedVersion === 'Latest Patch') {
	          installPackageVersion += initVersion.split('.').slice(0, 2).join('.');
	          sharedVersion = initVersion;
	        } else if (selectedVersion === 'Latest Minor') {
	          installPackageVersion += initVersion.split('.')[0];
	          sharedVersion = initVersion;
	        } else if (selectedVersion === 'Latest Major') {
	          installPackageVersion = '';
	          sharedVersion = initVersion;
	        } else {
	          installPackageVersion += selectedVersion;
	          sharedVersion = selectedVersion;
	        }

	        // update sharedVersion
	        this.set('sharedVersion', sharedVersion);
	        http.fetchPackageEntrypoints(packageType, packageName, sharedVersion).then(data => {
	          // clear script src and links href from prev version
	          this.set('installScriptSrc', null);
	          this.set('installLinkHref', null);
	          let packageJsEntrypoint = '';
	          let packageCssEntrypoint = '';
	          let isGuessedJsFile = false;
	          let isGuessedCssFile = false;
	          if (data.entrypoints.js) {
	            if (data.entrypoints.js.guessed) {
	              isGuessedJsFile = true;
	            }
	            packageJsEntrypoint = data.entrypoints.js.file;
	            this.set('installScriptSrc', `https://cdn.jsdelivr.net/${packageType}/${packageName}${installPackageVersion}${packageJsEntrypoint}`);
	            this.set('packageJsEntrypoint', packageJsEntrypoint);
	          }
	          if (data.entrypoints.css) {
	            if (data.entrypoints.css.guessed) {
	              isGuessedCssFile = true;
	            }
	            packageCssEntrypoint = data.entrypoints.css.file;
	            this.set('installLinkHref', `https://cdn.jsdelivr.net/${packageType}/${packageName}${installPackageVersion}${packageCssEntrypoint}`);
	            this.set('packageCssEntrypoint', packageCssEntrypoint);
	          }
	          this.set('isGuessedJsFile', isGuessedJsFile);
	          this.set('isGuessedCssFile', isGuessedCssFile);
	          this.set('entrypoints', data.entrypoints);
	          http.fetchPackageFilesFlat(packageType, packageName, sharedVersion).then(data => {
	            if (packageJsEntrypoint) {
	              data.files.forEach(file => {
	                if (file.name === this.get('packageJsEntrypoint')) {
	                  this.set('packageJsHash', file.hash);
	                }
	              });
	            }
	            if (packageCssEntrypoint) {
	              data.files.forEach(file => {
	                if (file.name === this.get('packageCssEntrypoint')) {
	                  this.set('packageCssHash', file.hash);
	                }
	              });
	            }
	          });
	        }).finally(() => {
	          this.set('installEsmSrc', `https://cdn.jsdelivr.net/npm/${packageName}${installPackageVersion}/+esm`);
	          let entrypointValues = Object.values(this.get('entrypoints'));
	          if (!entrypointValues.length || entrypointValues.every(e => e.guessed) && this.get('package.moduleTypes').indexOf('esm') !== -1) {
	            this.set('isDefaultPackage', false);
	            this.set('isDefaultPackageTmp', false);
	          } else {
	            this.set('isDefaultPackage', true);
	            this.set('isDefaultPackageTmp', true);
	          }
	        }).catch(() => {});
	      });
	      this.observe('mobileSettingsVisible', newValue => {
	        let body = document.querySelector('body');
	        if (newValue === true) {
	          body.classList.add('noscroll');
	        } else {
	          body.classList.remove('noscroll');
	        }
	      });
	    }
	  },
	  onClickMobileApply() {
	    this.set('mobileSettingsVisible', false);
	    this.set('isDefaultPackage', this.get('isDefaultPackageTmp'));
	    this.set('selectedVersion', this.get('selectedVersionTmp'));
	  },
	  onClickMobileCancel() {
	    this.set('mobileSettingsVisible', false);
	    this.set('isDefaultPackageTmp', this.get('isDefaultPackage'));
	    this.set('selectedVersionTmp', this.get('selectedVersion'));
	  },
	  handleEsmDefaultSwitch() {
	    let installScriptSrc = this.get('installScriptSrc');
	    let installEsmSrc = this.get('installEsmSrc');
	    if (installScriptSrc && installEsmSrc) {
	      this.toggle('isDefaultPackage');
	    }
	  },
	  handleMobileEsmDefaultSwitch() {
	    let installScriptSrc = this.get('installScriptSrc');
	    let installEsmSrc = this.get('installEsmSrc');
	    if (installScriptSrc && installEsmSrc) {
	      this.toggle('isDefaultPackageTmp');
	    }
	  }
	};
	component$x.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      n: "class",
	      f: ["c-package-install-block ", {
	        t: 4,
	        f: ["block-empty"],
	        n: 51,
	        x: {
	          r: ["type"],
	          s: "_0===\"npm\""
	        }
	      }],
	      t: 13
	    }],
	    f: [{
	      t: 4,
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "package-install-wrapper",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "install-settings",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            f: ["INSTALL"]
	          }, " ", {
	            t: 4,
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "switch-wrapper",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "span",
	                f: ["Type:"]
	              }, " ", {
	                t: 7,
	                e: "input",
	                m: [{
	                  n: "id",
	                  f: "switch-id",
	                  t: 13
	                }, {
	                  n: "type",
	                  f: "checkbox",
	                  t: 13
	                }, {
	                  t: 73,
	                  v: "t",
	                  f: "false"
	                }, {
	                  n: "class",
	                  f: ["switch-input ", {
	                    t: 4,
	                    f: ["checked"],
	                    n: 50,
	                    r: "isDefaultPackage"
	                  }],
	                  t: 13
	                }]
	              }, " ", {
	                t: 7,
	                e: "label",
	                m: [{
	                  n: "for",
	                  f: "switch-id",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: ["click"],
	                  t: 70,
	                  f: {
	                    r: ["@this"],
	                    s: "[_0.handleEsmDefaultSwitch()]"
	                  }
	                }, {
	                  n: "class",
	                  f: [{
	                    t: 4,
	                    f: ["disabled"],
	                    n: 51,
	                    x: {
	                      r: ["installEsmSrc", "installScriptSrc"],
	                      s: "_0&&_1"
	                    }
	                  }],
	                  t: 13
	                }],
	                f: [{
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    n: "class",
	                    f: [{
	                      t: 4,
	                      f: ["disabled"],
	                      n: 51,
	                      r: "installEsmSrc"
	                    }],
	                    t: 13
	                  }],
	                  f: ["ESM"]
	                }, " ", {
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    n: "class",
	                    f: [{
	                      t: 4,
	                      f: ["disabled"],
	                      n: 51,
	                      r: "installScriptSrc"
	                    }],
	                    t: 13
	                  }],
	                  f: ["Default"]
	                }]
	              }]
	            }],
	            n: 50,
	            x: {
	              r: ["isDefaultPackage"],
	              s: "_0!==null"
	            }
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "versions-wrapper",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "span",
	              f: ["Version:"]
	            }, " ", {
	              t: 7,
	              e: "c-version-dropdown",
	              m: [{
	                n: "versions",
	                f: [{
	                  t: 2,
	                  x: {
	                    r: ["versionsList", "packageVersionsList"],
	                    s: "[].concat(_0,[\"separator\"],_1)"
	                  }
	                }],
	                t: 13
	              }, {
	                n: "version",
	                f: [{
	                  t: 2,
	                  r: "selectedVersion"
	                }],
	                t: 13
	              }, {
	                n: "useCustomIconStyles",
	                f: "true",
	                t: 13,
	                g: 1
	              }],
	              f: []
	            }]
	          }, " ", {
	            t: 7,
	            e: "button",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "settings-btn",
	              g: 1
	            }, {
	              n: ["click"],
	              t: 70,
	              f: {
	                r: ["@this"],
	                s: "[_0.set(\"mobileSettingsVisible\",true)]"
	              }
	            }],
	            f: [{
	              t: 7,
	              e: "img",
	              m: [{
	                n: "width",
	                f: "24",
	                t: 13,
	                g: 1
	              }, {
	                n: "height",
	                f: "24",
	                t: 13,
	                g: 1
	              }, {
	                n: "src",
	                f: [{
	                  t: 2,
	                  r: "@shared.assetsHost"
	                }, "/img/icons/settings-white.svg"],
	                t: 13
	              }]
	            }]
	          }, " ", {
	            t: 4,
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "overlay",
	                g: 1
	              }, {
	                n: ["click"],
	                t: 70,
	                f: {
	                  r: ["@this"],
	                  s: "[_0.onClickMobileCancel()]"
	                }
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "settings-mobile",
	                g: 1
	              }, {
	                n: "slide",
	                t: 72,
	                v: "t1"
	              }, {
	                n: "slide",
	                t: 72,
	                v: "t2"
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "switch-wrapper",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "span",
	                  f: ["Type:"]
	                }, " ", {
	                  t: 7,
	                  e: "input",
	                  m: [{
	                    n: "id",
	                    f: "switch-id",
	                    t: 13
	                  }, {
	                    n: "type",
	                    f: "checkbox",
	                    t: 13
	                  }, {
	                    t: 73,
	                    v: "t",
	                    f: "false"
	                  }, {
	                    n: "class",
	                    f: ["switch-input ", {
	                      t: 4,
	                      f: ["checked"],
	                      n: 50,
	                      r: "isDefaultPackageTmp"
	                    }],
	                    t: 13
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "label",
	                  m: [{
	                    n: "for",
	                    f: "switch-id",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: ["click"],
	                    t: 70,
	                    f: {
	                      r: ["@this"],
	                      s: "[_0.handleMobileEsmDefaultSwitch()]"
	                    }
	                  }, {
	                    n: "class",
	                    f: [{
	                      t: 4,
	                      f: ["disabled"],
	                      n: 51,
	                      x: {
	                        r: ["installEsmSrc", "installScriptSrc"],
	                        s: "_0&&_1"
	                      }
	                    }],
	                    t: 13
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "span",
	                    m: [{
	                      n: "class",
	                      f: [{
	                        t: 4,
	                        f: ["disabled"],
	                        n: 51,
	                        r: "installEsmSrc"
	                      }],
	                      t: 13
	                    }],
	                    f: ["ESM"]
	                  }, " ", {
	                    t: 7,
	                    e: "span",
	                    m: [{
	                      n: "class",
	                      f: [{
	                        t: 4,
	                        f: ["disabled"],
	                        n: 51,
	                        r: "installScriptSrc"
	                      }],
	                      t: 13
	                    }],
	                    f: ["Default"]
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "versions-wrapper",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "span",
	                  f: ["Version:"]
	                }, " ", {
	                  t: 7,
	                  e: "c-version-dropdown",
	                  m: [{
	                    n: "versions",
	                    f: [{
	                      t: 2,
	                      x: {
	                        r: ["versionsList", "packageVersionsList"],
	                        s: "[].concat(_0,[\"separator\"],_1)"
	                      }
	                    }],
	                    t: 13
	                  }, {
	                    n: "version",
	                    f: [{
	                      t: 2,
	                      r: "selectedVersionTmp"
	                    }],
	                    t: 13
	                  }],
	                  f: []
	                }]
	              }, " ", {
	                t: 7,
	                e: "button",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "btn-primary",
	                  g: 1
	                }, {
	                  n: ["click"],
	                  t: 70,
	                  f: {
	                    r: ["@this"],
	                    s: "[_0.onClickMobileApply()]"
	                  }
	                }],
	                f: ["Apply"]
	              }, " ", {
	                t: 7,
	                e: "button",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "btn-secondary",
	                  g: 1
	                }, {
	                  n: ["click"],
	                  t: 70,
	                  f: {
	                    r: ["@this"],
	                    s: "[_0.onClickMobileCancel()]"
	                  }
	                }],
	                f: ["Cancel"]
	              }]
	            }],
	            n: 50,
	            r: "mobileSettingsVisible"
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "horizontal-divider-19",
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            n: "class",
	            f: ["install-script ", {
	              t: 4,
	              f: ["install-script-2"],
	              n: 50,
	              x: {
	                r: ["isDefaultPackage", "package.moduleTypes", "package.styleTypes"],
	                s: "_0===null&&!_1.includes(\"none\")&&!_2.includes(\"none\")"
	              }
	            }],
	            t: 13
	          }],
	          f: [{
	            t: 4,
	            f: [{
	              t: 4,
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "script-wrapper-default",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "code-wrapper",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "span",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "script-tag",
	                      g: 1
	                    }],
	                    f: ["<script src=\""]
	                  }, " ", {
	                    t: 7,
	                    e: "span",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "script-text",
	                      g: 1
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "a",
	                      m: [{
	                        n: "target",
	                        f: "_blank",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "href",
	                        f: [{
	                          t: 2,
	                          r: "~/installScriptSrc"
	                        }],
	                        t: 13
	                      }],
	                      f: [{
	                        t: 2,
	                        r: "~/installScriptSrc"
	                      }]
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "span",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "script-tag",
	                      g: 1
	                    }],
	                    f: ["\"></script>"]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "btn-group btn-group_copy-dropdown",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "button",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "btn dropdown-toggle",
	                      g: 1
	                    }, {
	                      n: "title",
	                      f: "Copy to Clipboard",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "type",
	                      f: "button",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "data-toggle",
	                      f: "dropdown",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "aria-haspopup",
	                      f: "true",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "aria-expanded",
	                      f: "false",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "img",
	                      m: [{
	                        n: "width",
	                        f: "20",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "height",
	                        f: "20",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "src",
	                        f: [{
	                          t: 2,
	                          r: "@shared.assetsHost"
	                        }, "/img/icons/copy-btn.svg"],
	                        t: 13
	                      }]
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "ul",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "dropdown-menu",
	                      g: 1
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "li",
	                      f: [{
	                        t: 7,
	                        e: "a",
	                        m: [{
	                          n: "clipboard",
	                          t: 71,
	                          f: {
	                            r: [],
	                            s: "[\"Copy URL to clipboard\",\"right\"]"
	                          }
	                        }, {
	                          n: "data-clipboard-text",
	                          f: [{
	                            t: 2,
	                            r: "~/installScriptSrc"
	                          }],
	                          t: 13
	                        }],
	                        f: ["Copy URL"]
	                      }]
	                    }, " ", {
	                      t: 4,
	                      f: [{
	                        t: 7,
	                        e: "li",
	                        f: [{
	                          t: 7,
	                          e: "a",
	                          m: [{
	                            n: "clipboard",
	                            t: 71,
	                            f: {
	                              r: [],
	                              s: "[\"Copy SRI to clipboard\",\"right\"]"
	                            }
	                          }, {
	                            n: "data-clipboard-text",
	                            f: [{
	                              t: 2,
	                              x: {
	                                r: ["buildIntegrity", "~/packageJsHash"],
	                                s: "_0(_1)"
	                              }
	                            }],
	                            t: 13
	                          }],
	                          f: ["Copy SRI"]
	                        }]
	                      }],
	                      n: 50,
	                      r: "~/packageJsHash"
	                    }, " ", {
	                      t: 4,
	                      f: [{
	                        t: 7,
	                        e: "li",
	                        f: [{
	                          t: 7,
	                          e: "a",
	                          m: [{
	                            n: "clipboard",
	                            t: 71,
	                            f: {
	                              r: [],
	                              s: "[\"Copy HTML to clipboard\",\"right\"]"
	                            }
	                          }, {
	                            n: "data-clipboard-text",
	                            f: [{
	                              t: 2,
	                              x: {
	                                r: ["buildHtml", "~/installScriptSrc"],
	                                s: "_0(_1)"
	                              }
	                            }],
	                            t: 13
	                          }],
	                          f: ["Copy HTML"]
	                        }]
	                      }, " ", {
	                        t: 4,
	                        f: [{
	                          t: 7,
	                          e: "li",
	                          f: [{
	                            t: 7,
	                            e: "a",
	                            m: [{
	                              n: "clipboard",
	                              t: 71,
	                              f: {
	                                r: [],
	                                s: "[\"Copy HTML + SRI to clipboard\",\"right\"]"
	                              }
	                            }, {
	                              n: "data-clipboard-text",
	                              f: [{
	                                t: 2,
	                                x: {
	                                  r: ["buildHtml", "~/installScriptSrc", "~/packageJsHash"],
	                                  s: "_0(_1,_2)"
	                                }
	                              }],
	                              t: 13
	                            }],
	                            f: ["Copy HTML + SRI"]
	                          }]
	                        }],
	                        n: 50,
	                        r: "~/packageJsHash"
	                      }],
	                      n: 50,
	                      x: {
	                        r: ["canBuildHtml", "~/installScriptSrc"],
	                        s: "_0(_1)"
	                      }
	                    }]
	                  }]
	                }]
	              }],
	              n: 50,
	              r: "~/packageJsEntrypoint"
	            }, " ", {
	              t: 4,
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "script-wrapper-default",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "code-wrapper",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "span",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "script-tag",
	                      g: 1
	                    }],
	                    f: ["<link href=\""]
	                  }, " ", {
	                    t: 7,
	                    e: "span",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "script-text",
	                      g: 1
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "a",
	                      m: [{
	                        n: "target",
	                        f: "_blank",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "href",
	                        f: [{
	                          t: 2,
	                          r: "~/installLinkHref"
	                        }],
	                        t: 13
	                      }],
	                      f: [{
	                        t: 2,
	                        r: "~/installLinkHref"
	                      }]
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "span",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "script-tag",
	                      g: 1
	                    }],
	                    f: ["\" rel=\"stylesheet\">"]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "btn-group btn-group_copy-dropdown",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "button",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "btn dropdown-toggle",
	                      g: 1
	                    }, {
	                      n: "title",
	                      f: "Copy to Clipboard",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "type",
	                      f: "button",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "data-toggle",
	                      f: "dropdown",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "aria-haspopup",
	                      f: "true",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "aria-expanded",
	                      f: "false",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "img",
	                      m: [{
	                        n: "width",
	                        f: "20",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "height",
	                        f: "20",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "src",
	                        f: [{
	                          t: 2,
	                          r: "@shared.assetsHost"
	                        }, "/img/icons/copy-btn.svg"],
	                        t: 13
	                      }]
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "ul",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "dropdown-menu",
	                      g: 1
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "li",
	                      f: [{
	                        t: 7,
	                        e: "a",
	                        m: [{
	                          n: "clipboard",
	                          t: 71,
	                          f: {
	                            r: [],
	                            s: "[\"Copy URL to clipboard\",\"right\"]"
	                          }
	                        }, {
	                          n: "data-clipboard-text",
	                          f: [{
	                            t: 2,
	                            r: "~/installLinkHref"
	                          }],
	                          t: 13
	                        }],
	                        f: ["Copy URL"]
	                      }]
	                    }, " ", {
	                      t: 4,
	                      f: [{
	                        t: 7,
	                        e: "li",
	                        f: [{
	                          t: 7,
	                          e: "a",
	                          m: [{
	                            n: "clipboard",
	                            t: 71,
	                            f: {
	                              r: [],
	                              s: "[\"Copy SRI to clipboard\",\"right\"]"
	                            }
	                          }, {
	                            n: "data-clipboard-text",
	                            f: [{
	                              t: 2,
	                              x: {
	                                r: ["buildIntegrity", "~/packageCssHash"],
	                                s: "_0(_1)"
	                              }
	                            }],
	                            t: 13
	                          }],
	                          f: ["Copy SRI"]
	                        }]
	                      }],
	                      n: 50,
	                      r: "~/packageCssHash"
	                    }, " ", {
	                      t: 4,
	                      f: [{
	                        t: 7,
	                        e: "li",
	                        f: [{
	                          t: 7,
	                          e: "a",
	                          m: [{
	                            n: "clipboard",
	                            t: 71,
	                            f: {
	                              r: [],
	                              s: "[\"Copy HTML to clipboard\",\"right\"]"
	                            }
	                          }, {
	                            n: "data-clipboard-text",
	                            f: [{
	                              t: 2,
	                              x: {
	                                r: ["buildHtml", "~/installLinkHref"],
	                                s: "_0(_1)"
	                              }
	                            }],
	                            t: 13
	                          }],
	                          f: ["Copy HTML"]
	                        }]
	                      }, " ", {
	                        t: 4,
	                        f: [{
	                          t: 7,
	                          e: "li",
	                          f: [{
	                            t: 7,
	                            e: "a",
	                            m: [{
	                              n: "clipboard",
	                              t: 71,
	                              f: {
	                                r: [],
	                                s: "[\"Copy HTML + SRI to clipboard\",\"right\"]"
	                              }
	                            }, {
	                              n: "data-clipboard-text",
	                              f: [{
	                                t: 2,
	                                x: {
	                                  r: ["buildHtml", "~/installLinkHref", "~/packageCssHash"],
	                                  s: "_0(_1,_2)"
	                                }
	                              }],
	                              t: 13
	                            }],
	                            f: ["Copy HTML + SRI"]
	                          }]
	                        }],
	                        n: 50,
	                        r: "~/packageCssHash"
	                      }],
	                      n: 50,
	                      x: {
	                        r: ["canBuildHtml", "~/installLinkHref"],
	                        s: "_0(_1)"
	                      }
	                    }]
	                  }]
	                }]
	              }],
	              n: 50,
	              r: "~/packageCssEntrypoint"
	            }],
	            n: 50,
	            x: {
	              r: ["isDefaultPackage"],
	              s: "_0===true"
	            }
	          }, {
	            t: 4,
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "script-wrapper-esm",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "code-wrapper",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "script-tag",
	                    g: 1
	                  }],
	                  f: ["<script type=\"module\">"]
	                }, " ", {
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "script-text",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "span",
	                    f: ["import ", {
	                      t: 2,
	                      x: {
	                        r: ["_", "name"],
	                        s: "_0.packageToImportName(_1)"
	                      }
	                    }, " from"]
	                  }, " ", {
	                    t: 7,
	                    e: "span",
	                    f: ["'", {
	                      t: 7,
	                      e: "a",
	                      m: [{
	                        n: "target",
	                        f: "_blank",
	                        t: 13,
	                        g: 1
	                      }, {
	                        n: "href",
	                        f: [{
	                          t: 2,
	                          r: "~/installEsmSrc"
	                        }],
	                        t: 13
	                      }],
	                      f: [{
	                        t: 2,
	                        r: "~/installEsmSrc"
	                      }]
	                    }, "'"]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "script-tag",
	                    g: 1
	                  }],
	                  f: ["</script>"]
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "btn-group btn-group_copy-dropdown",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "button",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "btn dropdown-toggle",
	                    g: 1
	                  }, {
	                    n: "title",
	                    f: "Copy to Clipboard",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "type",
	                    f: "button",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "data-toggle",
	                    f: "dropdown",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "aria-haspopup",
	                    f: "true",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "aria-expanded",
	                    f: "false",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "width",
	                      f: "20",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "20",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/icons/copy-btn.svg"],
	                      t: 13
	                    }]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "ul",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "dropdown-menu",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "li",
	                    f: [{
	                      t: 7,
	                      e: "a",
	                      m: [{
	                        n: "clipboard",
	                        t: 71,
	                        f: {
	                          r: [],
	                          s: "[\"Copy URL to clipboard\",\"right\"]"
	                        }
	                      }, {
	                        n: "data-clipboard-text",
	                        f: [{
	                          t: 2,
	                          r: "~/installEsmSrc"
	                        }],
	                        t: 13
	                      }],
	                      f: ["Copy URL"]
	                    }]
	                  }, " ", {
	                    t: 4,
	                    f: [{
	                      t: 7,
	                      e: "li",
	                      f: [{
	                        t: 7,
	                        e: "a",
	                        m: [{
	                          n: "clipboard",
	                          t: 71,
	                          f: {
	                            r: [],
	                            s: "[\"Copy HTML to clipboard\",\"right\"]"
	                          }
	                        }, {
	                          n: "data-clipboard-text",
	                          f: [{
	                            t: 2,
	                            x: {
	                              r: ["buildHtml", "~/installEsmSrc", "_", "name"],
	                              s: "_0(_1,\"\",_2.packageToImportName(_3))"
	                            }
	                          }],
	                          t: 13
	                        }],
	                        f: ["Copy HTML"]
	                      }]
	                    }],
	                    n: 50,
	                    x: {
	                      r: ["canBuildHtml", "~/installEsmSrc"],
	                      s: "_0(_1)"
	                    }
	                  }]
	                }]
	              }]
	            }],
	            n: 50,
	            x: {
	              r: ["isDefaultPackage"],
	              s: "_0===false"
	            },
	            l: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "horizontal-divider-19",
	            g: 1
	          }]
	        }, " ", {
	          t: 4,
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "install-default-warning",
	              g: 1
	            }],
	            f: ["No default ", {
	              t: 4,
	              f: ["files"],
	              n: 50,
	              x: {
	                r: ["isGuessedJsFile", "isGuessedCssFile"],
	                s: "_0&&_1"
	              }
	            }, {
	              t: 4,
	              f: ["JS file "],
	              n: 50,
	              r: "isGuessedJsFile",
	              l: 1
	            }, {
	              t: 4,
	              f: [" CSS file"],
	              n: 50,
	              r: "isGuessedCssFile",
	              l: 1
	            }, " ", {
	              t: 7,
	              e: "a",
	              m: [{
	                n: "href",
	                f: "/documentation#id-configuring-a-default-file-in-packagejson",
	                t: 13,
	                g: 1
	              }],
	              f: ["set by the package author"]
	            }, " so the ", {
	              t: 4,
	              f: ["URLs are"],
	              n: 50,
	              x: {
	                r: ["isGuessedJsFile", "isGuessedCssFile"],
	                s: "_0&&_1"
	              }
	            }, {
	              t: 4,
	              f: ["URL is"],
	              n: 51,
	              l: 1
	            }, " guessed. You can always ", {
	              t: 7,
	              e: "a",
	              m: [{
	                n: ["click"],
	                t: 70,
	                f: {
	                  r: ["@this"],
	                  s: "[_0.set(\"tabRoute\",\"files\")]"
	                }
	              }],
	              f: ["browse all package files"]
	            }, " to use ", {
	              t: 4,
	              f: ["other ones"],
	              n: 50,
	              x: {
	                r: ["isGuessedJsFile", "isGuessedCssFile"],
	                s: "_0&&_1"
	              }
	            }, {
	              t: 4,
	              f: ["another one"],
	              n: 51,
	              l: 1
	            }, "."]
	          }],
	          n: 50,
	          x: {
	            r: ["isDefaultPackage", "isGuessedJsFile", "isGuessedCssFile"],
	            s: "_0&&(_1||_2)"
	          }
	        }, {
	          t: 4,
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "install-esm-ctrls",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "form",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "jsfiddle-form",
	                g: 1
	              }, {
	                n: "action",
	                f: "https://jsfiddle.net/api/post/library/pure",
	                t: 13,
	                g: 1
	              }, {
	                n: "method",
	                f: "POST",
	                t: 13,
	                g: 1
	              }, {
	                n: "target",
	                f: "_blank",
	                t: 13,
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "input",
	                m: [{
	                  n: "type",
	                  f: "hidden",
	                  t: 13
	                }, {
	                  n: "name",
	                  f: "title",
	                  t: 13
	                }, {
	                  n: "value",
	                  f: [{
	                    t: 4,
	                    f: ["jsDelivr"],
	                    n: 50,
	                    r: "isDefaultPackage"
	                  }, {
	                    t: 4,
	                    f: ["esm.run"],
	                    n: 51,
	                    l: 1
	                  }, " ", {
	                    t: 2,
	                    r: "name"
	                  }, " demo"],
	                  t: 13
	                }]
	              }, " ", {
	                t: 4,
	                f: [{
	                  t: 7,
	                  e: "input",
	                  m: [{
	                    n: "type",
	                    f: "hidden",
	                    t: 13
	                  }, {
	                    n: "name",
	                    f: "resources",
	                    t: 13
	                  }, {
	                    n: "value",
	                    f: [{
	                      t: 2,
	                      r: "installScriptSrc"
	                    }],
	                    t: 13
	                  }, {
	                    t: 73,
	                    v: "t",
	                    f: "false"
	                  }]
	                }],
	                n: 50,
	                r: "isDefaultPackage"
	              }, {
	                t: 4,
	                f: [{
	                  t: 7,
	                  e: "input",
	                  m: [{
	                    n: "type",
	                    f: "hidden",
	                    t: 13
	                  }, {
	                    n: "name",
	                    f: "js",
	                    t: 13
	                  }, {
	                    n: "value",
	                    f: [{
	                      t: 2,
	                      r: "jsFiddleJsCode"
	                    }],
	                    t: 13
	                  }, {
	                    t: 73,
	                    v: "t",
	                    f: "false"
	                  }]
	                }],
	                n: 51,
	                l: 1
	              }, " ", {
	                t: 7,
	                e: "button",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "esm-ctrl",
	                  g: 1
	                }, {
	                  n: "type",
	                  f: "submit",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "tabindex",
	                  f: "2",
	                  t: 13,
	                  g: 1
	                }],
	                f: ["Open in jsfiddle"]
	              }]
	            }, " ", {
	              t: 7,
	              e: "a",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "esm-ctrl",
	                g: 1
	              }, {
	                n: "href",
	                f: [{
	                  t: 2,
	                  r: "learnMoreHref"
	                }],
	                t: 13
	              }],
	              f: ["Learn more"]
	            }]
	          }],
	          n: 51,
	          l: 1
	        }]
	      }],
	      n: 50,
	      x: {
	        r: ["type"],
	        s: "_0===\"npm\""
	      }
	    }]
	  }],
	  e: {
	    "_0===\"npm\"": function (_0) {
	      return _0 === "npm";
	    },
	    "[_0.handleEsmDefaultSwitch()]": function (_0) {
	      return [_0.handleEsmDefaultSwitch()];
	    },
	    "_0&&_1": function (_0, _1) {
	      return _0 && _1;
	    },
	    "_0!==null": function (_0) {
	      return _0 !== null;
	    },
	    "[].concat(_0,[\"separator\"],_1)": function (_0, _1) {
	      return [].concat(_0, ["separator"], _1);
	    },
	    "[_0.set(\"mobileSettingsVisible\",true)]": function (_0) {
	      return [_0.set("mobileSettingsVisible", true)];
	    },
	    "[_0.onClickMobileCancel()]": function (_0) {
	      return [_0.onClickMobileCancel()];
	    },
	    "[_0.handleMobileEsmDefaultSwitch()]": function (_0) {
	      return [_0.handleMobileEsmDefaultSwitch()];
	    },
	    "[_0.onClickMobileApply()]": function (_0) {
	      return [_0.onClickMobileApply()];
	    },
	    "_0===null&&!_1.includes(\"none\")&&!_2.includes(\"none\")": function (_0, _1, _2) {
	      return _0 === null && !_1.includes("none") && !_2.includes("none");
	    },
	    "[\"Copy URL to clipboard\",\"right\"]": function () {
	      return ["Copy URL to clipboard", "right"];
	    },
	    "[\"Copy SRI to clipboard\",\"right\"]": function () {
	      return ["Copy SRI to clipboard", "right"];
	    },
	    "_0(_1)": function (_0, _1) {
	      return _0(_1);
	    },
	    "[\"Copy HTML to clipboard\",\"right\"]": function () {
	      return ["Copy HTML to clipboard", "right"];
	    },
	    "[\"Copy HTML + SRI to clipboard\",\"right\"]": function () {
	      return ["Copy HTML + SRI to clipboard", "right"];
	    },
	    "_0(_1,_2)": function (_0, _1, _2) {
	      return _0(_1, _2);
	    },
	    "_0===true": function (_0) {
	      return _0 === true;
	    },
	    "_0.packageToImportName(_1)": function (_0, _1) {
	      return _0.packageToImportName(_1);
	    },
	    "_0(_1,\"\",_2.packageToImportName(_3))": function (_0, _1, _2, _3) {
	      return _0(_1, "", _2.packageToImportName(_3));
	    },
	    "_0===false": function (_0) {
	      return _0 === false;
	    },
	    "[_0.set(\"tabRoute\",\"files\")]": function (_0) {
	      return [_0.set("tabRoute", "files")];
	    },
	    "_0&&(_1||_2)": function (_0, _1, _2) {
	      return _0 && (_1 || _2);
	    }
	  }
	};
	component$x.exports.components = {
	  "c-version-dropdown": versionDropdown
	};
	var packageInstallBlock = ractive__default["default"].extend(component$x.exports);

	var component$w = {
	  exports: {}
	};
	const {
	  buildIntegrity,
	  buildHtml,
	  canBuildHtml
	} = buildLinks_1;
	component$w.exports = {
	  decorators: {
	    clipboard
	  },
	  data() {
	    return {
	      buildIntegrity,
	      buildHtml,
	      canBuildHtml
	    };
	  },
	  onrender() {
	    let handleDropdownShown = event => {
	      let dropdown = $(event.target);
	      dropdown.find('.dropdown-menu').attr('aria-expanded', true);
	      dropdown.on('keydown', e => {
	        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
	          e.preventDefault();
	          let items = dropdown.find('.dropdown-menu li button');
	          let currentIndex = items.index(e.target);
	          let nextIndex = (currentIndex + (e.key === 'ArrowDown' ? 1 : -1)) % items.length;
	          if (nextIndex < 0) {
	            nextIndex = items.length - 1;
	          }
	          items.eq(nextIndex).focus();
	        }
	      });
	    };
	    let handleDropdownHidden = event => {
	      let dropdown = $(event.target);
	      dropdown.find('.dropdown-menu').attr('aria-expanded', false);
	      dropdown.find('.dropdown-toggle').focus();
	    };
	    $(document).on('shown.bs.dropdown', handleDropdownShown);
	    $(document).on('hidden.bs.dropdown', handleDropdownHidden);
	    this.on('unrender', () => {
	      $(document).off('shown.bs.dropdown', handleDropdownShown);
	      $(document).off('hidden.bs.dropdown', handleDropdownHidden);
	    });
	  }
	};
	component$w.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      n: "class",
	      f: ["c-copy-dropdown btn-group ", {
	        t: 4,
	        f: ["dropup"],
	        n: 50,
	        r: "dropup"
	      }],
	      t: 13
	    }],
	    f: [{
	      t: 7,
	      e: "button",
	      m: [{
	        n: "data-toggle",
	        f: "dropdown",
	        t: 13,
	        g: 1
	      }, {
	        n: "role",
	        f: "button",
	        t: 13,
	        g: 1
	      }, {
	        n: "aria-haspopup",
	        f: "true",
	        t: 13,
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "img",
	        m: [{
	          n: "width",
	          f: "20",
	          t: 13,
	          g: 1
	        }, {
	          n: "height",
	          f: "20",
	          t: 13,
	          g: 1
	        }, {
	          n: "src",
	          f: [{
	            t: 2,
	            r: "@shared.assetsHost"
	          }, "/img/icons/copy-btn-black.svg"],
	          t: 13
	        }, {
	          n: "loading",
	          f: "lazy",
	          t: 13,
	          g: 1
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "ul",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "dropdown-menu dropdown-menu-right",
	        g: 1
	      }, {
	        n: "role",
	        f: "listbox",
	        t: 13,
	        g: 1
	      }, {
	        n: "aria-label",
	        f: "Copy options",
	        t: 13,
	        g: 1
	      }, {
	        n: "aria-expanded",
	        f: "false",
	        t: 13,
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "li",
	        f: [{
	          t: 7,
	          e: "button",
	          m: [{
	            n: "clipboard",
	            t: 71,
	            f: {
	              r: ["dropup"],
	              s: "[undefined,_0?\"bottom\":\"top\",\".c-copy-dropdown\"]"
	            }
	          }, {
	            n: "data-clipboard-text",
	            f: [{
	              t: 2,
	              r: "url"
	            }],
	            t: 13
	          }],
	          f: ["Copy URL"]
	        }]
	      }, " ", {
	        t: 4,
	        f: [{
	          t: 7,
	          e: "li",
	          f: [{
	            t: 7,
	            e: "button",
	            m: [{
	              n: "clipboard",
	              t: 71,
	              f: {
	                r: ["dropup"],
	                s: "[undefined,_0?\"bottom\":\"top\",\".c-copy-dropdown\"]"
	              }
	            }, {
	              n: "data-clipboard-text",
	              f: [{
	                t: 2,
	                x: {
	                  r: ["buildIntegrity", "hash"],
	                  s: "_0(_1)"
	                }
	              }],
	              t: 13
	            }],
	            f: ["Copy SRI"]
	          }]
	        }],
	        n: 50,
	        r: "hash"
	      }, " ", {
	        t: 4,
	        f: [{
	          t: 7,
	          e: "li",
	          f: [{
	            t: 7,
	            e: "button",
	            m: [{
	              n: "clipboard",
	              t: 71,
	              f: {
	                r: ["dropup"],
	                s: "[undefined,_0?\"bottom\":\"top\",\".c-copy-dropdown\"]"
	              }
	            }, {
	              n: "data-clipboard-text",
	              f: [{
	                t: 2,
	                x: {
	                  r: ["buildHtml", "url"],
	                  s: "_0(_1)"
	                }
	              }],
	              t: 13
	            }],
	            f: ["Copy HTML"]
	          }]
	        }, " ", {
	          t: 4,
	          f: [{
	            t: 7,
	            e: "li",
	            f: [{
	              t: 7,
	              e: "button",
	              m: [{
	                n: "clipboard",
	                t: 71,
	                f: {
	                  r: ["dropup"],
	                  s: "[undefined,_0?\"bottom\":\"top\",\".c-copy-dropdown\"]"
	                }
	              }, {
	                n: "data-clipboard-text",
	                f: [{
	                  t: 2,
	                  x: {
	                    r: ["buildHtml", "url", "hash"],
	                    s: "_0(_1,_2)"
	                  }
	                }],
	                t: 13
	              }],
	              f: ["Copy HTML + SRI"]
	            }]
	          }],
	          n: 50,
	          r: "hash"
	        }],
	        n: 50,
	        x: {
	          r: ["canBuildHtml", "url"],
	          s: "_0(_1)"
	        }
	      }]
	    }]
	  }],
	  e: {
	    "[undefined,_0?\"bottom\":\"top\",\".c-copy-dropdown\"]": function (_0) {
	      return [undefined, _0 ? "bottom" : "top", ".c-copy-dropdown"];
	    },
	    "_0(_1)": function (_0, _1) {
	      return _0(_1);
	    },
	    "_0(_1,_2)": function (_0, _1, _2) {
	      return _0(_1, _2);
	    }
	  }
	};
	var copyDropdown = ractive__default["default"].extend(component$w.exports);

	var component$v = {
	  exports: {}
	};
	component$v.exports = {
	  computed: {
	    issueDefaultFile() {
	      return `https://github.com/${this.get('github.user')}/${this.get('github.project')}/issues/new/` + `?title=No default jsDelivr CDN file set` + `&body=[This package](${this.get('@global.location.href')}) doesn't have a [default file](https://www.jsdelivr.com/features%23publishing-packages) set. You can set it via \`jsdelivr\`, \`browser\`, or \`main\` field in \`package.json\``;
	    },
	    issueTooBig() {
	      return `https://github.com/${this.get('github.user')}/${this.get('github.project')}/issues/new/` + `?title=${this.get('type') === 'npm' ? 'npm package' : 'GitHub release'} too big for jsDelivr` + `&body=I'm trying to load this package from [jsDelivr CDN](${this.get('@global.location.href')})` + ` but it fails because the package is over 50 MB. Are there any files that could be removed to reduce the package size?`;
	    },
	    pathS() {
	      return this.get('path').length ? this.get('path').join('/') + '/' : '';
	    },
	    defaultFile() {
	      let d = this.get('default');
	      return d && this.getFile(d);
	    }
	  },
	  data() {
	    return {
	      _,
	      files: [],
	      filesLimit: 10,
	      filesLoadingMessage: '',
	      path: [],
	      downloadsPerFile: [],
	      downloadsPerDir: []
	    };
	  },
	  decorators: {
	    tooltip
	  },
	  oninit() {
	    if (!ractive__default["default"].isServer) {
	      this.observe('path files', () => {
	        if (this.get('files').length && _.listFiles(this.get('files'), this.get('path')) === null) {
	          this.set('path', []);
	        }
	      });
	      this.observe('sharedVersion', sharedVersion => {
	        if (!sharedVersion) {
	          return;
	        }
	        this.set('files', []);
	        this.set('filesLoadingMessage', '');
	        let packageType = this.get('type');
	        let packageName = this.get('name');
	        if (packageType === 'npm') {
	          http.fetchPackageEntrypoints(packageType, packageName, sharedVersion).then(data => {
	            let defaultFile = '';
	            if (data.entrypoints.js) {
	              defaultFile = data.entrypoints.js.file || '';
	            } else if (data.entrypoints.css) {
	              defaultFile = data.entrypoints.css.file || '';
	            }
	            this.set('default', defaultFile);
	          }).catch(() => {});
	        }

	        // Load package files.
	        http.fetchPackageFiles(packageType, packageName, sharedVersion).then(data => {
	          this.set('files', data.files);
	        }).catch(error => {
	          let defaultError = 'Failed to load the file listing.';
	          if (error.message) {
	            let errorHtml = defaultError + '<br>' + error.message;
	            if (error.message.indexOf('size exceeded') !== -1 && this.get('github')) {
	              http.findProjectIssue(this.get('github.user'), this.get('github.project'), `${packageType === 'npm' ? 'npm package' : 'GitHub release'} too big for jsDelivr`).then(data => {
	                errorHtml += `<br><br>Consider <a target="_blank" rel="noopener noreferrer" href="${data.items.length ? data.items[0].html_url : this.get('issueTooBig')}">asking the author to remove unnecessary files</a> to make the package smaller.`;
	              }).finally(() => {
	                errorHtml += `<strong><br><br>You may still find the files you need in the <a target="_blank" rel="noopener noreferrer" href="https://github.com/${this.get('github.user')}/${this.get('github.project')}/">GitHub repository</a> and include them in your project like this:<br><code>https://cdn.jsdelivr.net/gh/${this.get('github.user')}/${this.get('github.project')}@${this.get('sharedVersion')}/file</code></strong><br><br>Read more about <a target="_blank" href="/documentation#id-github">GitHub CDN</a>, which can load individual files even if the overall package size exceeds the limit.`;
	                this.set('filesLoadingMessage', errorHtml);
	              });
	            }
	            this.set('filesLoadingMessage', errorHtml);
	          } else {
	            this.set('filesLoadingMessage', defaultError);
	          }
	        });

	        // fetch package File stats to get downloads amount per file
	        http.fetchPackageFileStats(packageType, packageName, sharedVersion).then(response => {
	          let downloadsPerFile = response.reduce((downloadsPerFile, fileStats) => {
	            let fileName = fileStats.name.substring(fileStats.name.indexOf('/') + 1);
	            if (!fileName) {
	              return downloadsPerFile;
	            }
	            downloadsPerFile = {
	              ...downloadsPerFile,
	              [fileName]: fileStats.hits.total
	            };
	            return downloadsPerFile;
	          }, {});
	          this.set('downloadsPerFile', downloadsPerFile);
	        });
	      });
	      this.observe('files downloadsPerFile', () => {
	        let files = this.get('files');
	        let downloadsPerFile = this.get('downloadsPerFile');
	        if (!files.length || !Object.keys(downloadsPerFile).length) {
	          return;
	        }
	        function countDirDownloadsRecursively(items, downloadsPerFile, incResults = {}, currentDirName = '/') {
	          let results = incResults || {};
	          results[currentDirName] = results[currentDirName] || 0;
	          items.forEach(item => {
	            if (item.type === 'directory') {
	              let recResults = countDirDownloadsRecursively(item.files, downloadsPerFile, results, `${currentDirName === '/' ? '' : currentDirName + '/'}${item.name}`);
	              results = {
	                ...results,
	                ...recResults
	              };
	              results[currentDirName] += recResults[`${currentDirName === '/' ? '' : currentDirName + '/'}${item.name}`] || 0;
	            }
	            results[currentDirName] += downloadsPerFile[`${currentDirName === '/' ? '' : currentDirName + '/'}${item.name}`] || 0;
	          });
	          return results;
	        }
	        let downloadsPerDir = countDirDownloadsRecursively(files, downloadsPerFile);
	        this.set('downloadsPerDir', downloadsPerDir);
	      });
	    }
	  },
	  getCollectionIndex(collection, type, name, sharedVersion, file) {
	    for (let i = 0; i < collection.length; i++) {
	      if (collection[i].type === type && collection[i].name === name && collection[i].version === sharedVersion && (collection[i].file === file || collection[i].isDefault && this.getFile(file).path === this.getFile(this.get('default')).path)) {
	        return i;
	      }
	    }
	    return -1;
	  },
	  getFile(file) {
	    let files = this.get('files');
	    if (!file || files.length === 0) {
	      return {};
	    }
	    let p = file.split('/');
	    let n = p.slice(-1)[0];
	    let f = _.listFiles(files, p.slice(1, -1)).filter(f => f.name === n)[0];
	    if (!f) {
	      if (file === this.get('default') && _.getNonMinifiedName(file) !== file) {
	        return Object.assign({
	          path: _.getNonMinifiedName(file)
	        }, f);
	      }
	      return {};
	    }
	    return Object.assign({
	      path: file
	    }, f);
	  },
	  handleLabelKeydown(e, path) {
	    if (e.event.key === 'Enter' || e.event.key === ' ') {
	      e.event.preventDefault();
	      e.event.stopPropagation();
	      this.toggleCollectionFile(path);
	    }
	  },
	  toggleCollectionFile(file) {
	    let type = this.get('type');
	    let name = this.get('name');
	    let sharedVersion = this.get('sharedVersion');
	    let collection = this.get('collection');
	    let index = this.getCollectionIndex(collection, type, name, sharedVersion, file);
	    if (index !== -1) {
	      this.splice('collection', index, 1);
	    } else {
	      let f = this.getFile(file);
	      if (!f.path) {
	        console.log('File not found in the list.');
	        return false;
	      } else if (f.path !== file) {
	        return this.toggleCollectionFile(f.path);
	      }
	      this.push('collection', {
	        type,
	        name,
	        version: sharedVersion,
	        file,
	        hash: f.hash,
	        isDefault: f.path === this.getFile(this.get('default')).path
	      });
	    }
	    return false;
	  },
	  toggleShowMoreFiles() {
	    this.toggle('showMoreFiles').then(() => {
	      if (!this.get('showMoreFiles') && document.querySelector('.c-package').getBoundingClientRect().top + document.documentElement.scrollTop < (window.pageYOffset || document.documentElement.scrollTop)) {
	        window.scrollTo({
	          top: 0,
	          behavior: 'smooth'
	        });
	      }
	    });
	  }
	};
	component$v.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      t: 13,
	      n: "class",
	      f: "c-package-file-browser",
	      g: 1
	    }],
	    f: [{
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "box-files",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "path-n-version",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          f: [{
	            t: 7,
	            e: "button",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "path-text",
	              g: 1
	            }, {
	              n: ["click"],
	              t: 70,
	              f: {
	                r: ["@this"],
	                s: "[_0.set(\"path\",[])]"
	              }
	            }],
	            f: [{
	              t: 2,
	              r: "name"
	            }]
	          }, " ", {
	            t: 4,
	            f: [{
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "path-divider",
	                g: 1
	              }],
	              f: [{
	                t: 2,
	                x: {
	                  r: [],
	                  s: "\" / \""
	                }
	              }]
	            }, " ", {
	              t: 7,
	              e: "button",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "path-text",
	                g: 1
	              }, {
	                n: ["click"],
	                t: 70,
	                f: {
	                  r: ["@this", "@index"],
	                  s: "[_0.splice(\"path\",_1+1)]"
	                }
	              }],
	              f: [{
	                t: 2,
	                r: "."
	              }]
	            }],
	            n: 52,
	            x: {
	              r: ["path"],
	              s: "_0.slice(0,-1)"
	            }
	          }, " ", {
	            t: 4,
	            f: [{
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "path-divider",
	                g: 1
	              }],
	              f: [{
	                t: 2,
	                x: {
	                  r: [],
	                  s: "\" / \""
	                }
	              }]
	            }, " ", {
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "path-active-part",
	                g: 1
	              }],
	              f: [{
	                t: 2,
	                rx: {
	                  r: "path",
	                  m: [{
	                    r: ["path.length"],
	                    s: "_0-1"
	                  }]
	                }
	              }]
	            }],
	            n: 50,
	            r: "path"
	          }]
	        }, " ", {
	          t: 7,
	          e: "c-version-dropdown",
	          m: [{
	            n: "versions",
	            f: [{
	              t: 2,
	              r: "versions"
	            }],
	            t: 13
	          }, {
	            n: "version",
	            f: [{
	              t: 2,
	              r: "~/sharedVersion"
	            }],
	            t: 13
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "box-content-wrapper",
	          g: 1
	        }],
	        f: [{
	          t: 4,
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "file-default",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "a",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "file-default-link",
	                g: 1
	              }, {
	                n: "target",
	                f: "_blank",
	                t: 13,
	                g: 1
	              }, {
	                n: "rel",
	                f: "noopener noreferrer",
	                t: 13,
	                g: 1
	              }, {
	                n: "href",
	                f: ["https://cdn.jsdelivr.net/", {
	                  t: 2,
	                  r: "~/type"
	                }, "/", {
	                  t: 2,
	                  r: "~/name"
	                }, "@", {
	                  t: 2,
	                  r: "~/sharedVersion"
	                }, {
	                  t: 2,
	                  r: "~/default"
	                }],
	                t: 13
	              }, {
	                n: "tooltip",
	                t: 71,
	                f: {
	                  r: ["~/default"],
	                  s: "[\"Default file: \"+_0,\"top\"]"
	                }
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "20",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "20",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/icons/code.svg"],
	                  t: 13
	                }, {
	                  n: "loading",
	                  f: "lazy",
	                  t: 13,
	                  g: 1
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "default-path",
	                  g: 1
	                }],
	                f: [{
	                  t: 4,
	                  f: [{
	                    t: 4,
	                    f: [{
	                      t: 7,
	                      e: "span",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "file-path",
	                        g: 1
	                      }],
	                      f: [{
	                        t: 2,
	                        x: {
	                          r: ["i", "default"],
	                          s: "_1.split(\"/\")[_0]"
	                        }
	                      }]
	                    }],
	                    n: 50,
	                    x: {
	                      r: ["i", "default"],
	                      s: "_0===_1.split(\"/\").length-1"
	                    }
	                  }, {
	                    t: 4,
	                    f: [{
	                      t: 7,
	                      e: "span",
	                      f: [{
	                        t: 2,
	                        x: {
	                          r: ["i", "default"],
	                          s: "_1.split(\"/\")[_0]"
	                        }
	                      }, "/"]
	                    }, " "],
	                    n: 50,
	                    x: {
	                      r: ["i", "default"],
	                      s: "_1.split(\"/\")[_0]"
	                    },
	                    l: 1
	                  }, {
	                    t: 4,
	                    f: [" ", {
	                      t: 7,
	                      e: "span",
	                      f: ["/"]
	                    }],
	                    n: 51,
	                    l: 1
	                  }],
	                  n: 52,
	                  i: "i",
	                  x: {
	                    r: ["default"],
	                    s: "_0.split(\"/\")"
	                  }
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "file-default-ctrls",
	                g: 1
	              }],
	              f: [{
	                t: 4,
	                f: [{
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "downloads-cnt",
	                    g: 1
	                  }, {
	                    n: "tooltip",
	                    t: 71,
	                    f: {
	                      r: [],
	                      s: "[\"Monthly downloads\"]"
	                    }
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "span",
	                    f: [{
	                      t: 2,
	                      x: {
	                        r: ["_", "default", "~/downloadsPerFile"],
	                        s: "_0.formatToShortNumber(_2[_1.substring(_1.indexOf(\"/\")+1)])"
	                      }
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "width",
	                      f: "20",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "20",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/icons/chart.svg"],
	                      t: 13
	                    }, {
	                      n: "loading",
	                      f: "lazy",
	                      t: 13,
	                      g: 1
	                    }]
	                  }]
	                }],
	                n: 50,
	                rx: {
	                  r: "~/downloadsPerFile",
	                  m: [{
	                    r: ["default"],
	                    s: "_0.substring(_0.indexOf(\"/\")+1)"
	                  }]
	                }
	              }, " ", {
	                t: 7,
	                e: "c-copy-dropdown",
	                m: [{
	                  n: "url",
	                  f: ["https://cdn.jsdelivr.net/", {
	                    t: 2,
	                    r: "~/type"
	                  }, "/", {
	                    t: 2,
	                    r: "~/name"
	                  }, "@", {
	                    t: 2,
	                    r: "~/sharedVersion"
	                  }, {
	                    t: 2,
	                    r: "~/default"
	                  }],
	                  t: 13
	                }, {
	                  n: "hash",
	                  f: [{
	                    t: 2,
	                    r: "defaultFile.hash"
	                  }],
	                  t: 13
	                }]
	              }, " ", {
	                t: 7,
	                e: "input",
	                m: [{
	                  n: "type",
	                  f: "checkbox",
	                  t: 13
	                }, {
	                  n: "class",
	                  f: "switch-inline",
	                  t: 13
	                }, {
	                  n: "id",
	                  f: "df",
	                  t: 13
	                }, {
	                  n: "checked",
	                  f: [{
	                    t: 2,
	                    x: {
	                      r: ["@this", "~/collection", "~/type", "~/name", "~/sharedVersion", "~/default"],
	                      s: "_0.getCollectionIndex(_1,_2,_3,_4,_5)!==-1"
	                    }
	                  }],
	                  t: 13
	                }, {
	                  t: 73,
	                  v: "t",
	                  f: "false"
	                }]
	              }, " ", {
	                t: 7,
	                e: "label",
	                m: [{
	                  n: "for",
	                  f: "df",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: ["click"],
	                  t: 70,
	                  f: {
	                    r: ["@this", "~/default"],
	                    s: "[_0.toggleCollectionFile(_1)]"
	                  }
	                }, {
	                  n: ["keydown"],
	                  t: 70,
	                  f: {
	                    r: ["@this", "event", "~/default"],
	                    s: "[_0.handleLabelKeydown(_1,_2)]"
	                  }
	                }, {
	                  n: "tooltip",
	                  t: 71,
	                  f: {
	                    r: [],
	                    s: "[\"Add to collection\"]"
	                  }
	                }, {
	                  n: "role",
	                  f: "button",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "aria-pressed",
	                  f: [{
	                    t: 2,
	                    x: {
	                      r: ["@this", "~/collection", "~/type", "~/name", "~/sharedVersion", "~/default"],
	                      s: "_0.getCollectionIndex(_1,_2,_3,_4,_5)!==-1"
	                    }
	                  }],
	                  t: 13
	                }, {
	                  n: "tabindex",
	                  f: "0",
	                  t: 13,
	                  g: 1
	                }]
	              }]
	            }]
	          }],
	          n: 50,
	          x: {
	            r: ["type", "files", "~/default"],
	            s: "_0===\"npm\"&&_1&&_2"
	          }
	        }, " ", {
	          t: 4,
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "text-center files-loading-msg",
	              g: 1
	            }],
	            f: [{
	              t: 3,
	              x: {
	                r: ["filesLoadingMessage"],
	                s: "_0||\"Files are loading...\""
	              }
	            }]
	          }],
	          n: 50,
	          x: {
	            r: ["files.length"],
	            s: "!_0"
	          }
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "files-list",
	            g: 1
	          }],
	          f: [{
	            t: 4,
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "all-files-header",
	                g: 1
	              }],
	              f: ["All files"]
	            }, " ", {
	              t: 4,
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "files-list-back",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "button",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "disable-button-styles",
	                    g: 1
	                  }, {
	                    n: ["click"],
	                    t: 70,
	                    f: {
	                      r: ["@this"],
	                      s: "[_0.pop(\"path\")]"
	                    }
	                  }, {
	                    n: "tabindex",
	                    f: "0",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "width",
	                      f: "20",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "20",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/icons/back.svg"],
	                      t: 13
	                    }, {
	                      n: "loading",
	                      f: "lazy",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "span",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "path-divider-small",
	                      g: 1
	                    }],
	                    f: ["/"]
	                  }, " ", {
	                    t: 7,
	                    e: "span",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "file-path",
	                      g: 1
	                    }],
	                    f: [{
	                      t: 2,
	                      r: "pathS"
	                    }, "..."]
	                  }]
	                }]
	              }],
	              n: 50,
	              r: "path.length"
	            }],
	            n: 50,
	            r: "files"
	          }, " ", {
	            t: 4,
	            f: [{
	              t: 8,
	              r: "fileLink"
	            }],
	            n: 52,
	            x: {
	              r: ["_", "~/files", "path", "~/filesLimit"],
	              s: "_0.listFiles(_1,_2).slice(0,_3)"
	            }
	          }, " ", {
	            t: 4,
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                n: "slide",
	                t: 72,
	                v: "t0"
	              }],
	              f: [{
	                t: 4,
	                f: [{
	                  t: 8,
	                  r: "fileLink"
	                }],
	                n: 52,
	                x: {
	                  r: ["_", "~/files", "path", "filesLimit"],
	                  s: "_0.listFiles(_1,_2).slice(_3)"
	                }
	              }]
	            }],
	            n: 50,
	            r: "showMoreFiles"
	          }],
	          p: {
	            fileLink: [{
	              t: 7,
	              e: "div",
	              m: [{
	                n: "class",
	                f: ["file-item file-item-", {
	                  t: 2,
	                  r: "type"
	                }],
	                t: 13
	              }],
	              f: [{
	                t: 4,
	                f: [{
	                  t: 7,
	                  e: "button",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "disable-button-styles",
	                    g: 1
	                  }, {
	                    n: ["click"],
	                    t: 70,
	                    f: {
	                      r: ["@this", "name"],
	                      s: "[_0.push(\"path\",_1)]"
	                    }
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "width",
	                      f: "20",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "20",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/icons/folder.svg"],
	                      t: 13
	                    }, {
	                      n: "loading",
	                      f: "lazy",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " /", {
	                    t: 2,
	                    r: "~/type"
	                  }, "/", {
	                    t: 2,
	                    r: "~/name"
	                  }, "@", {
	                    t: 2,
	                    r: "~/sharedVersion"
	                  }, "/", {
	                    t: 7,
	                    e: "span",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "file-path",
	                      g: 1
	                    }],
	                    f: [{
	                      t: 2,
	                      r: "pathS"
	                    }, {
	                      t: 2,
	                      r: "name"
	                    }]
	                  }]
	                }],
	                n: 50,
	                x: {
	                  r: ["type"],
	                  s: "_0===\"directory\""
	                }
	              }, {
	                t: 4,
	                f: [{
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    n: "target",
	                    f: "_blank",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "rel",
	                    f: "noopener noreferrer",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "href",
	                    f: ["https://cdn.jsdelivr.net/", {
	                      t: 2,
	                      r: "~/type"
	                    }, "/", {
	                      t: 2,
	                      r: "~/name"
	                    }, "@", {
	                      t: 2,
	                      r: "~/sharedVersion"
	                    }, "/", {
	                      t: 2,
	                      r: "pathS"
	                    }, {
	                      t: 2,
	                      r: "name"
	                    }],
	                    t: 13
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "width",
	                      f: "20",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "height",
	                      f: "20",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "@shared.assetsHost"
	                      }, "/img/icons/file.svg"],
	                      t: 13
	                    }, {
	                      n: "loading",
	                      f: "lazy",
	                      t: 13,
	                      g: 1
	                    }]
	                  }, " /", {
	                    t: 2,
	                    r: "~/type"
	                  }, "/", {
	                    t: 2,
	                    r: "~/name"
	                  }, "@", {
	                    t: 2,
	                    r: "~/sharedVersion"
	                  }, "/", {
	                    t: 7,
	                    e: "span",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "file-path",
	                      g: 1
	                    }],
	                    f: [{
	                      t: 2,
	                      r: "pathS"
	                    }, {
	                      t: 2,
	                      r: "name"
	                    }]
	                  }]
	                }],
	                n: 51,
	                l: 1
	              }, " ", {
	                t: 7,
	                e: "div",
	                f: [{
	                  t: 4,
	                  f: [{
	                    t: 4,
	                    f: [{
	                      t: 7,
	                      e: "div",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "downloads-cnt",
	                        g: 1
	                      }, {
	                        n: "tooltip",
	                        t: 71,
	                        f: {
	                          r: [],
	                          s: "[\"Monthly downloads\"]"
	                        }
	                      }],
	                      f: [{
	                        t: 7,
	                        e: "span",
	                        f: [{
	                          t: 2,
	                          x: {
	                            r: ["_", "pathS", "name", "~/downloadsPerDir"],
	                            s: "_0.formatToShortNumber(_3[_1+_2])"
	                          }
	                        }]
	                      }, " ", {
	                        t: 7,
	                        e: "img",
	                        m: [{
	                          n: "width",
	                          f: "20",
	                          t: 13,
	                          g: 1
	                        }, {
	                          n: "height",
	                          f: "20",
	                          t: 13,
	                          g: 1
	                        }, {
	                          n: "src",
	                          f: [{
	                            t: 2,
	                            r: "@shared.assetsHost"
	                          }, "/img/icons/chart.svg"],
	                          t: 13
	                        }, {
	                          n: "loading",
	                          f: "lazy",
	                          t: 13,
	                          g: 1
	                        }]
	                      }]
	                    }],
	                    n: 50,
	                    rx: {
	                      r: "~/downloadsPerDir",
	                      m: [{
	                        r: ["pathS", "name"],
	                        s: "_0+_1"
	                      }]
	                    }
	                  }],
	                  n: 50,
	                  x: {
	                    r: ["type"],
	                    s: "_0===\"directory\""
	                  }
	                }, {
	                  t: 4,
	                  f: [{
	                    t: 4,
	                    f: [{
	                      t: 7,
	                      e: "div",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "downloads-cnt",
	                        g: 1
	                      }, {
	                        n: "tooltip",
	                        t: 71,
	                        f: {
	                          r: [],
	                          s: "[\"Monthly downloads\"]"
	                        }
	                      }],
	                      f: [{
	                        t: 7,
	                        e: "span",
	                        f: [{
	                          t: 2,
	                          x: {
	                            r: ["_", "pathS", "name", "~/downloadsPerFile"],
	                            s: "_0.formatToShortNumber(_3[_1+_2])"
	                          }
	                        }]
	                      }, " ", {
	                        t: 7,
	                        e: "img",
	                        m: [{
	                          n: "width",
	                          f: "20",
	                          t: 13,
	                          g: 1
	                        }, {
	                          n: "height",
	                          f: "20",
	                          t: 13,
	                          g: 1
	                        }, {
	                          n: "src",
	                          f: [{
	                            t: 2,
	                            r: "@shared.assetsHost"
	                          }, "/img/icons/chart.svg"],
	                          t: 13
	                        }, {
	                          n: "loading",
	                          f: "lazy",
	                          t: 13,
	                          g: 1
	                        }]
	                      }]
	                    }],
	                    n: 50,
	                    rx: {
	                      r: "~/downloadsPerFile",
	                      m: [{
	                        r: ["pathS", "name"],
	                        s: "_0+_1"
	                      }]
	                    }
	                  }],
	                  n: 51,
	                  l: 1
	                }, " ", {
	                  t: 7,
	                  e: "c-copy-dropdown",
	                  m: [{
	                    n: "url",
	                    f: ["https://cdn.jsdelivr.net/", {
	                      t: 2,
	                      r: "~/type"
	                    }, "/", {
	                      t: 2,
	                      r: "~/name"
	                    }, "@", {
	                      t: 2,
	                      r: "~/sharedVersion"
	                    }, "/", {
	                      t: 2,
	                      r: "pathS"
	                    }, {
	                      t: 2,
	                      r: "name"
	                    }],
	                    t: 13
	                  }, {
	                    n: "hash",
	                    f: [{
	                      t: 2,
	                      r: "hash"
	                    }],
	                    t: 13
	                  }, {
	                    n: "dropup",
	                    f: [{
	                      t: 2,
	                      x: {
	                        r: ["pathS", "../length", "@index"],
	                        s: "(_2>(_0?0:1))&&_1-_2<=4"
	                      }
	                    }],
	                    t: 13
	                  }],
	                  f: []
	                }, " ", {
	                  t: 7,
	                  e: "input",
	                  m: [{
	                    n: "id",
	                    f: [{
	                      t: 2,
	                      r: "name"
	                    }],
	                    t: 13
	                  }, {
	                    n: "type",
	                    f: "checkbox",
	                    t: 13
	                  }, {
	                    n: "class",
	                    f: "switch-inline",
	                    t: 13
	                  }, {
	                    n: "checked",
	                    f: [{
	                      t: 2,
	                      x: {
	                        r: ["@this", "~/collection", "~/type", "~/name", "~/sharedVersion", "pathS", "name"],
	                        s: "_0.getCollectionIndex(_1,_2,_3,_4,\"/\"+_5+_6)!==-1"
	                      }
	                    }],
	                    t: 13
	                  }, {
	                    t: 73,
	                    v: "t",
	                    f: "false"
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "label",
	                  m: [{
	                    n: "for",
	                    f: [{
	                      t: 2,
	                      r: "name"
	                    }],
	                    t: 13
	                  }, {
	                    n: ["click"],
	                    t: 70,
	                    f: {
	                      r: ["@this", "pathS", "name"],
	                      s: "[_0.toggleCollectionFile(\"/\"+_1+_2)]"
	                    }
	                  }, {
	                    n: ["keydown"],
	                    t: 70,
	                    f: {
	                      r: ["@this", "event", "pathS", "name"],
	                      s: "[_0.handleLabelKeydown(_1,\"/\"+_2+_3)]"
	                    }
	                  }, {
	                    n: "tooltip",
	                    t: 71,
	                    f: {
	                      r: [],
	                      s: "[\"Add to collection\"]"
	                    }
	                  }, {
	                    n: "role",
	                    f: "button",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "aria-pressed",
	                    f: [{
	                      t: 2,
	                      x: {
	                        r: ["@this", "~/collection", "~/type", "~/name", "~/sharedVersion", "pathS", "name"],
	                        s: "_0.getCollectionIndex(_1,_2,_3,_4,\"/\"+_5+_6)!==-1"
	                      }
	                    }],
	                    t: 13
	                  }, {
	                    n: "tabindex",
	                    f: "0",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: []
	                }]
	              }]
	            }]
	          }
	        }]
	      }, " ", {
	        t: 4,
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "show-more-toggle",
	            g: 1
	          }],
	          f: [{
	            t: 4,
	            f: [{
	              t: 7,
	              e: "button",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "disable-button-styles",
	                g: 1
	              }, {
	                n: ["click"],
	                t: 70,
	                f: {
	                  r: ["@this"],
	                  s: "[_0.toggleShowMoreFiles()]"
	                }
	              }],
	              f: [{
	                t: 7,
	                e: "i",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "fa fa-angle-up",
	                  g: 1
	                }, {
	                  n: "aria-hidden",
	                  f: "true",
	                  t: 13,
	                  g: 1
	                }]
	              }, " Show first 10"]
	            }],
	            n: 50,
	            r: "showMoreFiles"
	          }, {
	            t: 4,
	            f: [{
	              t: 7,
	              e: "button",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "disable-button-styles",
	                g: 1
	              }, {
	                n: ["click"],
	                t: 70,
	                f: {
	                  r: ["@this"],
	                  s: "[_0.toggleShowMoreFiles()]"
	                }
	              }],
	              f: [{
	                t: 7,
	                e: "i",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "fa fa-angle-down",
	                  g: 1
	                }, {
	                  n: "aria-hidden",
	                  f: "true",
	                  t: 13,
	                  g: 1
	                }]
	              }, " Show all"]
	            }],
	            n: 51,
	            l: 1
	          }]
	        }],
	        n: 50,
	        x: {
	          r: ["_", "~/files", "path", "filesLimit"],
	          s: "_0.listFiles(_1,_2).length>_3"
	        }
	      }]
	    }]
	  }],
	  e: {
	    "[_0.set(\"path\",[])]": function (_0) {
	      return [_0.set("path", [])];
	    },
	    "\" / \"": function () {
	      return " / ";
	    },
	    "[_0.splice(\"path\",_1+1)]": function (_0, _1) {
	      return [_0.splice("path", _1 + 1)];
	    },
	    "_0.slice(0,-1)": function (_0) {
	      return _0.slice(0, -1);
	    },
	    "_0-1": function (_0) {
	      return _0 - 1;
	    },
	    "[\"Default file: \"+_0,\"top\"]": function (_0) {
	      return ["Default file: " + _0, "top"];
	    },
	    "_1.split(\"/\")[_0]": function (_0, _1) {
	      return _1.split("/")[_0];
	    },
	    "_0===_1.split(\"/\").length-1": function (_0, _1) {
	      return _0 === _1.split("/").length - 1;
	    },
	    "_0.split(\"/\")": function (_0) {
	      return _0.split("/");
	    },
	    "[\"Monthly downloads\"]": function () {
	      return ["Monthly downloads"];
	    },
	    "_0.formatToShortNumber(_2[_1.substring(_1.indexOf(\"/\")+1)])": function (_0, _1, _2) {
	      return _0.formatToShortNumber(_2[_1.substring(_1.indexOf("/") + 1)]);
	    },
	    "_0.substring(_0.indexOf(\"/\")+1)": function (_0) {
	      return _0.substring(_0.indexOf("/") + 1);
	    },
	    "_0.getCollectionIndex(_1,_2,_3,_4,_5)!==-1": function (_0, _1, _2, _3, _4, _5) {
	      return _0.getCollectionIndex(_1, _2, _3, _4, _5) !== -1;
	    },
	    "[_0.toggleCollectionFile(_1)]": function (_0, _1) {
	      return [_0.toggleCollectionFile(_1)];
	    },
	    "[_0.handleLabelKeydown(_1,_2)]": function (_0, _1, _2) {
	      return [_0.handleLabelKeydown(_1, _2)];
	    },
	    "[\"Add to collection\"]": function () {
	      return ["Add to collection"];
	    },
	    "_0===\"npm\"&&_1&&_2": function (_0, _1, _2) {
	      return _0 === "npm" && _1 && _2;
	    },
	    "_0||\"Files are loading...\"": function (_0) {
	      return _0 || "Files are loading...";
	    },
	    "!_0": function (_0) {
	      return !_0;
	    },
	    "[_0.pop(\"path\")]": function (_0) {
	      return [_0.pop("path")];
	    },
	    "_0.listFiles(_1,_2).slice(0,_3)": function (_0, _1, _2, _3) {
	      return _0.listFiles(_1, _2).slice(0, _3);
	    },
	    "_0.listFiles(_1,_2).slice(_3)": function (_0, _1, _2, _3) {
	      return _0.listFiles(_1, _2).slice(_3);
	    },
	    "[_0.push(\"path\",_1)]": function (_0, _1) {
	      return [_0.push("path", _1)];
	    },
	    "_0===\"directory\"": function (_0) {
	      return _0 === "directory";
	    },
	    "_0.formatToShortNumber(_3[_1+_2])": function (_0, _1, _2, _3) {
	      return _0.formatToShortNumber(_3[_1 + _2]);
	    },
	    "_0+_1": function (_0, _1) {
	      return _0 + _1;
	    },
	    "(_2>(_0?0:1))&&_1-_2<=4": function (_0, _1, _2) {
	      return _2 > (_0 ? 0 : 1) && _1 - _2 <= 4;
	    },
	    "_0.getCollectionIndex(_1,_2,_3,_4,\"/\"+_5+_6)!==-1": function (_0, _1, _2, _3, _4, _5, _6) {
	      return _0.getCollectionIndex(_1, _2, _3, _4, "/" + _5 + _6) !== -1;
	    },
	    "[_0.toggleCollectionFile(\"/\"+_1+_2)]": function (_0, _1, _2) {
	      return [_0.toggleCollectionFile("/" + _1 + _2)];
	    },
	    "[_0.handleLabelKeydown(_1,\"/\"+_2+_3)]": function (_0, _1, _2, _3) {
	      return [_0.handleLabelKeydown(_1, "/" + _2 + _3)];
	    },
	    "[_0.toggleShowMoreFiles()]": function (_0) {
	      return [_0.toggleShowMoreFiles()];
	    },
	    "_0.listFiles(_1,_2).length>_3": function (_0, _1, _2, _3) {
	      return _0.listFiles(_1, _2).length > _3;
	    }
	  }
	};
	component$v.exports.components = {
	  "c-copy-dropdown": copyDropdown,
	  "c-version-dropdown": versionDropdown
	};
	var packageFileBrowser = ractive__default["default"].extend(component$v.exports);

	var component$u = {
	  exports: {}
	};
	component$u.exports = {
	  decorators: {
	    tooltip
	  }
	};
	component$u.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      t: 13,
	      n: "class",
	      f: "c-collection-box",
	      g: 1
	    }],
	    f: [{
	      t: 4,
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "collection-header",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "span",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "header-text",
	            g: 1
	          }],
	          f: ["Selected files"]
	        }, " ", {
	          t: 4,
	          f: [{
	            t: 7,
	            e: "span",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "remove-text",
	              g: 1
	            }, {
	              n: ["click"],
	              t: 70,
	              f: {
	                r: ["@this"],
	                s: "[_0.set(\"collection\",[])]"
	              }
	            }],
	            f: ["Remove all"]
	          }],
	          n: 50,
	          r: "collection"
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "collection-list",
	          g: 1
	        }],
	        f: [{
	          t: 4,
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "collection-item",
	              g: 1
	            }, {
	              n: "sortable",
	              t: 71
	            }],
	            f: [{
	              t: 7,
	              e: "span",
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "href",
	                  f: ["/package/", {
	                    t: 2,
	                    r: "type"
	                  }, "/", {
	                    t: 2,
	                    r: "name"
	                  }],
	                  t: 13
	                }],
	                f: [{
	                  t: 2,
	                  r: "name"
	                }]
	              }, {
	                t: 2,
	                r: "file"
	              }]
	            }, " ", {
	              t: 7,
	              e: "img",
	              m: [{
	                n: "width",
	                f: "20",
	                t: 13,
	                g: 1
	              }, {
	                n: "height",
	                f: "20",
	                t: 13,
	                g: 1
	              }, {
	                n: "src",
	                f: [{
	                  t: 2,
	                  r: "@shared.assetsHost"
	                }, "/img/icons/remove-icon.svg"],
	                t: 13
	              }, {
	                n: "loading",
	                f: "lazy",
	                t: 13,
	                g: 1
	              }, {
	                n: ["click"],
	                t: 70,
	                f: {
	                  r: ["@this", "@index"],
	                  s: "[_0.splice(\"collection\",_1,1)]"
	                }
	              }, {
	                n: "tooltip",
	                t: 71,
	                f: {
	                  r: [],
	                  s: "[\"Remove this file\"]"
	                }
	              }]
	            }]
	          }],
	          n: 52,
	          r: "."
	        }, {
	          t: 4,
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "box-message",
	              g: 1
	            }],
	            f: ["No files selected. Select the files you want to use using the switches on the left."]
	          }],
	          n: 51,
	          l: 1
	        }]
	      }, " ", {
	        t: 4,
	        f: [{
	          t: 7,
	          e: "a",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "config-btn",
	            g: 1
	          }, {
	            n: ["click"],
	            t: 70,
	            f: "slide-next"
	          }],
	          f: ["Show & Configure all links"]
	        }],
	        n: 50,
	        r: "."
	      }],
	      n: 54,
	      r: "collection"
	    }]
	  }],
	  e: {
	    "[_0.set(\"collection\",[])]": function (_0) {
	      return [_0.set("collection", [])];
	    },
	    "[_0.splice(\"collection\",_1,1)]": function (_0, _1) {
	      return [_0.splice("collection", _1, 1)];
	    },
	    "[\"Remove this file\"]": function () {
	      return ["Remove this file"];
	    }
	  }
	};
	var collectionBox = ractive__default["default"].extend(component$u.exports);

	var component$t = {
	  exports: {}
	};
	const NAV_MENU_SHORT_TITLES = {
	  readmeTabTitle: 'Readme',
	  filesTabTitle: 'Files',
	  statsTabTitle: 'Statistics',
	  browseCdnTitle: 'Browse CDN'
	};
	const NAV_MENU_FULL_TITLES = {
	  readmeTabTitle: 'Readme',
	  filesTabTitle: 'Files',
	  statsTabTitle: 'Statistics',
	  browseCdnTitle: 'Browse CDN'
	};
	const NAV_MENU_TABS = {
	  readme: 'readme',
	  files: 'files',
	  stats: 'stats'
	};
	component$t.exports = {
	  computed: {
	    issueReleaseRequest() {
	      return `https://github.com/${this.get('package.githubRepo.user')}/${this.get('package.githubRepo.project')}/issues/new/` + `?title=No package release on GitHub` + `&body=[This package](${this.get('@global.location.href')}) doesn't have any [GitHub release](https://help.github.com/articles/about-releases/). Could you please create one, so that people can use this project from jsDelivr CDN?`;
	    }
	  },
	  data() {
	    return {
	      _,
	      collection: [],
	      packageVersionsList: [],
	      tabRoute: NAV_MENU_TABS.readme,
	      navMenuTitles: NAV_MENU_SHORT_TITLES,
	      NAV_MENU_TABS
	    };
	  },
	  oninit() {
	    if (!ractive__default["default"].isServer) {
	      // change Nav Menu titles depending on the screen size (also on the resize of the page)
	      // switch tab to readme after resizing (if it was Files tab)
	      this.observe('screenWidth', newScreenWidth => {
	        let actualScreenWidth = newScreenWidth ? newScreenWidth : window.innerWidth;

	        // set tab titles after resizing
	        if (actualScreenWidth < 1200) {
	          this.set('navMenuTitles', NAV_MENU_SHORT_TITLES);
	        } else {
	          this.set('navMenuTitles', NAV_MENU_FULL_TITLES);
	        }
	      });

	      // check if Package has readme (if algolia has no Readme, we try to fetch it from https://raw.githubusercontent.com, getGHUserContentPackageReadme)
	      // if readme still absent we show FilesTab as default
	      this.observe('package', () => {
	        // package.readme
	        let readme = this.get('package').readme;
	        if ((!readme || readme === 'ERROR: No README data found!') && this.get('tabRoute') === NAV_MENU_TABS.readme) {
	          this.set('tabRoute', this.get('packageVersionsNotFound') ? NAV_MENU_TABS.stats : NAV_MENU_TABS.files);
	          let url = new URL(window.location);
	          url.searchParams.set('tab', NAV_MENU_TABS.files);
	          app.router.history.replaceState(app.router.history.state, '', url);
	        }
	      });

	      // set versionP to a separate variable to use it as a shared value between PackageInstallBlock and PackageFielsTab and do not mutate origin variable
	      this.observe('versionP', versionP => {
	        this.set('sharedVersion', versionP);
	      });
	      this.observe('sharedVersion', sharedVersion => {
	        this.set('versionP', sharedVersion);
	      });
	      if (!this.get('versionP')) {
	        this.set('versionP', this.get('package.version'));
	      }
	    }
	  }
	};
	component$t.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      t: 13,
	      n: "class",
	      f: "c-package",
	      g: 1
	    }],
	    f: [{
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "page-content",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "page-content_top-content-wrapper",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "main-content",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "c-package-header",
	            m: [{
	              n: "package",
	              f: [{
	                t: 2,
	                r: "package"
	              }],
	              t: 13
	            }, {
	              n: "type",
	              f: [{
	                t: 2,
	                r: "type"
	              }],
	              t: 13
	            }, {
	              n: "name",
	              f: [{
	                t: 2,
	                r: "name"
	              }],
	              t: 13
	            }, {
	              n: "version",
	              f: [{
	                t: 2,
	                r: "versionP"
	              }],
	              t: 13
	            }, {
	              n: "packageVersionsNotFound",
	              f: [{
	                t: 2,
	                r: "packageVersionsNotFound"
	              }],
	              t: 13
	            }],
	            f: []
	          }, " ", {
	            t: 4,
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "text-center package-no-release",
	                g: 1
	              }],
	              f: ["This package doesn't have any release on GitHub.", {
	                t: 7,
	                e: "br"
	              }, " Please ", {
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "href",
	                  f: [{
	                    t: 2,
	                    r: "issueReleaseRequest"
	                  }],
	                  t: 13
	                }],
	                f: ["ask the author"]
	              }, " to make a GitHub release in order to use jsDelivr CDN.", {
	                t: 7,
	                e: "br"
	              }, " ", {
	                t: 4,
	                f: ["Alternatively, you can use a ", {
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    n: "target",
	                    f: "_blank",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "rel",
	                    f: "noopener noreferrer",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "href",
	                    f: ["https://cdn.jsdelivr.net/gh/", {
	                      t: 2,
	                      r: "package.githubRepo.user"
	                    }, "/", {
	                      t: 2,
	                      r: "package.githubRepo.project"
	                    }, "@", {
	                      t: 2,
	                      r: "~/latestCommitSha"
	                    }, "/"],
	                    t: 13
	                  }],
	                  f: ["specific git commit hash"]
	                }, "."],
	                n: 50,
	                r: "~/latestCommitSha"
	              }]
	            }],
	            n: 50,
	            r: "~/packageVersionsNotFound"
	          }, " ", {
	            t: 7,
	            e: "c-package-install-block",
	            m: [{
	              n: "package",
	              f: [{
	                t: 2,
	                r: "package"
	              }],
	              t: 13
	            }, {
	              n: "packageVersionsList",
	              f: [{
	                t: 2,
	                r: "packageVersionsList"
	              }],
	              t: 13
	            }, {
	              n: "type",
	              f: [{
	                t: 2,
	                r: "type"
	              }],
	              t: 13
	            }, {
	              n: "name",
	              f: [{
	                t: 2,
	                r: "name"
	              }],
	              t: 13
	            }, {
	              n: "initVersion",
	              f: [{
	                t: 2,
	                r: "package.version"
	              }],
	              t: 13
	            }, {
	              n: "sharedVersion",
	              f: [{
	                t: 2,
	                r: "sharedVersion"
	              }],
	              t: 13
	            }, {
	              n: "tabRoute",
	              f: [{
	                t: 2,
	                r: "tabRoute"
	              }],
	              t: 13
	            }],
	            f: []
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "package-nav",
	              g: 1
	            }],
	            f: [{
	              t: 4,
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "id",
	                  f: "tabRouteReadme",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "href",
	                  f: [{
	                    t: 2,
	                    r: "@shared.app.router.uri.path"
	                  }],
	                  t: 13
	                }, {
	                  n: ["click"],
	                  t: 70,
	                  f: {
	                    r: ["@this", "NAV_MENU_TABS.readme"],
	                    s: "[_0.set(\"tabRoute\",_1),false]"
	                  }
	                }, {
	                  n: "class",
	                  f: ["package-nav_route ", {
	                    t: 2,
	                    x: {
	                      r: ["tabRoute", "NAV_MENU_TABS.readme"],
	                      s: "_0===_1?\"package-nav_route_active\":\"\""
	                    }
	                  }],
	                  t: 13
	                }],
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: "width",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/icons/book.svg"],
	                    t: 13
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "span",
	                  f: [{
	                    t: 2,
	                    r: "navMenuTitles.readmeTabTitle"
	                  }]
	                }]
	              }],
	              n: 50,
	              r: "package.readme"
	            }, " ", {
	              t: 4,
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "id",
	                  f: "tabRouteFiles",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "href",
	                  f: ["?tab=", {
	                    t: 2,
	                    r: "NAV_MENU_TABS.files"
	                  }],
	                  t: 13
	                }, {
	                  n: ["click"],
	                  t: 70,
	                  f: {
	                    r: ["@this", "NAV_MENU_TABS.files"],
	                    s: "[_0.set(\"tabRoute\",_1),false]"
	                  }
	                }, {
	                  n: "class",
	                  f: ["package-nav_route ", {
	                    t: 2,
	                    x: {
	                      r: ["tabRoute", "NAV_MENU_TABS.files"],
	                      s: "_0===_1?\"package-nav_route_active\":\"\""
	                    }
	                  }],
	                  t: 13
	                }],
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: "width",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/icons/settings.svg"],
	                    t: 13
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "span",
	                  f: [{
	                    t: 2,
	                    r: "navMenuTitles.filesTabTitle"
	                  }]
	                }]
	              }],
	              n: 51,
	              r: "packageVersionsNotFound"
	            }, " ", {
	              t: 7,
	              e: "a",
	              m: [{
	                n: "id",
	                f: "tabRouteStats",
	                t: 13,
	                g: 1
	              }, {
	                n: "href",
	                f: ["?tab=", {
	                  t: 2,
	                  r: "NAV_MENU_TABS.stats"
	                }],
	                t: 13
	              }, {
	                n: ["click"],
	                t: 70,
	                f: {
	                  r: ["@this", "NAV_MENU_TABS.stats"],
	                  s: "[_0.set(\"tabRoute\",_1),false]"
	                }
	              }, {
	                n: "class",
	                f: ["package-nav_route ", {
	                  t: 2,
	                  x: {
	                    r: ["tabRoute", "NAV_MENU_TABS.stats"],
	                    s: "_0===_1?\"package-nav_route_active\":\"\""
	                  }
	                }],
	                t: 13
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "20",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "20",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/icons/statistics.svg"],
	                  t: 13
	                }]
	              }, " ", {
	                t: 7,
	                e: "span",
	                f: [{
	                  t: 2,
	                  r: "navMenuTitles.statsTabTitle"
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "a",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "package-nav_route",
	                g: 1
	              }, {
	                n: "id",
	                f: "tabRouteCdn",
	                t: 13,
	                g: 1
	              }, {
	                n: "target",
	                f: "_blank",
	                t: 13,
	                g: 1
	              }, {
	                n: "rel",
	                f: "noopener noreferrer",
	                t: 13,
	                g: 1
	              }, {
	                n: "href",
	                f: ["https://cdn.jsdelivr.net/", {
	                  t: 2,
	                  r: "type"
	                }, "/", {
	                  t: 2,
	                  r: "name"
	                }, "/"],
	                t: 13
	              }],
	              f: [{
	                t: 7,
	                e: "span",
	                f: [{
	                  t: 2,
	                  r: "navMenuTitles.browseCdnTitle"
	                }]
	              }, " ", {
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "20",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "20",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/icons/external-link.svg"],
	                  t: 13
	                }]
	              }]
	            }]
	          }, " ", {
	            t: 4,
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "package-readme",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "c-html",
	                m: [{
	                  n: "html",
	                  f: [{
	                    t: 2,
	                    r: "package.readme"
	                  }],
	                  t: 13
	                }, {
	                  n: "github",
	                  f: [{
	                    t: 2,
	                    r: "package.githubRepo"
	                  }],
	                  t: 13
	                }]
	              }]
	            }],
	            n: 50,
	            x: {
	              r: ["tabRoute", "NAV_MENU_TABS.readme", "package.readme"],
	              s: "_0===_1&&_2"
	            }
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "side-content",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "c-package-sidemenu",
	            m: [{
	              n: "tabRoute",
	              f: [{
	                t: 2,
	                r: "tabRoute"
	              }],
	              t: 13
	            }, {
	              n: "name",
	              f: [{
	                t: 2,
	                r: "name"
	              }],
	              t: 13
	            }, {
	              n: "type",
	              f: [{
	                t: 2,
	                r: "type"
	              }],
	              t: 13
	            }, {
	              n: "package",
	              f: [{
	                t: 2,
	                r: "package"
	              }],
	              t: 13
	            }],
	            f: []
	          }]
	        }]
	      }, " ", {
	        t: 4,
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "package-files full-width-content",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "c-package-file-browser",
	            m: [{
	              n: "type",
	              f: [{
	                t: 2,
	                r: "type"
	              }],
	              t: 13
	            }, {
	              n: "name",
	              f: [{
	                t: 2,
	                r: "name"
	              }],
	              t: 13
	            }, {
	              n: "github",
	              f: [{
	                t: 2,
	                r: "package.githubRepo"
	              }],
	              t: 13
	            }, {
	              n: "sharedVersion",
	              f: [{
	                t: 2,
	                r: "sharedVersion"
	              }],
	              t: 13
	            }, {
	              n: "versions",
	              f: [{
	                t: 2,
	                r: "packageVersionsList"
	              }],
	              t: 13
	            }, {
	              n: "path",
	              f: [{
	                t: 2,
	                r: "path"
	              }],
	              t: 13
	            }, {
	              n: "collection",
	              f: [{
	                t: 2,
	                r: "collection"
	              }],
	              t: 13
	            }],
	            f: []
	          }, " ", {
	            t: 7,
	            e: "c-collection-box",
	            m: [{
	              n: "collection",
	              f: [{
	                t: 2,
	                r: "collection"
	              }],
	              t: 13
	            }]
	          }]
	        }],
	        n: 50,
	        x: {
	          r: ["tabRoute", "NAV_MENU_TABS.files"],
	          s: "_0===_1"
	        }
	      }, " ", {
	        t: 4,
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "package-statistics full-width-content",
	            g: 1
	          }, {
	            n: "style",
	            f: ["visibility: ", {
	              t: 4,
	              f: ["visible; height: auto;"],
	              n: 50,
	              x: {
	                r: ["tabRoute", "NAV_MENU_TABS.stats"],
	                s: "_0===_1"
	              }
	            }, {
	              t: 4,
	              f: ["hidden; height: 0;"],
	              n: 51,
	              l: 1
	            }],
	            t: 13
	          }],
	          f: [{
	            t: 7,
	            e: "c-package-stats",
	            m: [{
	              n: "type",
	              f: [{
	                t: 2,
	                r: "type"
	              }],
	              t: 13
	            }, {
	              n: "name",
	              f: [{
	                t: 2,
	                r: "name"
	              }],
	              t: 13
	            }, {
	              n: "versionP",
	              f: [{
	                t: 2,
	                r: "versionP"
	              }],
	              t: 13
	            }, {
	              n: "packageVersionsList",
	              f: [{
	                t: 2,
	                r: "packageVersionsList"
	              }],
	              t: 13
	            }]
	          }]
	        }],
	        n: 50,
	        x: {
	          r: ["tabRoute", "NAV_MENU_TABS.stats"],
	          s: "_0===_1"
	        }
	      }]
	    }]
	  }],
	  e: {
	    "[_0.set(\"tabRoute\",_1),false]": function (_0, _1) {
	      return [_0.set("tabRoute", _1), false];
	    },
	    "_0===_1?\"package-nav_route_active\":\"\"": function (_0, _1) {
	      return _0 === _1 ? "package-nav_route_active" : "";
	    },
	    "_0===_1&&_2": function (_0, _1, _2) {
	      return _0 === _1 && _2;
	    },
	    "_0===_1": function (_0, _1) {
	      return _0 === _1;
	    }
	  }
	};
	component$t.exports.components = {
	  "c-html": html,
	  "c-package-stats": packageStats,
	  "c-package-sidemenu": packageSidemenu,
	  "c-package-install-block": packageInstallBlock,
	  "c-package-header": packageHeader,
	  "c-package-file-browser": packageFileBrowser,
	  "c-collection-box": collectionBox
	};
	var _package$1 = ractive__default["default"].extend(component$t.exports);

	var component$s = {
	  exports: {}
	};
	component$s.exports = {
	  computed: {
	    html() {
	      return this.get('links').map(link => link.html);
	    }
	  },
	  decorators: {
	    clipboard
	  }
	};
	component$s.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      t: 13,
	      n: "class",
	      f: "c-collection-links",
	      g: 1
	    }],
	    f: [{
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "links-title",
	        g: 1
	      }],
	      f: [{
	        t: 2,
	        r: "title"
	      }]
	    }, " ", {
	      t: 4,
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          n: "class",
	          f: ["collection-link", {
	            t: 4,
	            f: [" combined"],
	            n: 50,
	            x: {
	              r: ["~/combined", "@index", "links.length"],
	              s: "_0&&!_1&&_2>1"
	            }
	          }],
	          t: 13
	        }],
	        f: [{
	          t: 7,
	          e: "a",
	          m: [{
	            n: "target",
	            f: "_blank",
	            t: 13,
	            g: 1
	          }, {
	            n: "rel",
	            f: "noopener noreferrer",
	            t: 13,
	            g: 1
	          }, {
	            n: "href",
	            f: [{
	              t: 2,
	              r: "text"
	            }],
	            t: 13
	          }],
	          f: [{
	            t: 2,
	            r: "html"
	          }]
	        }, " ", {
	          t: 7,
	          e: "i",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "fa fa-clipboard pull-right",
	            g: 1
	          }, {
	            n: "aria-hidden",
	            f: "true",
	            t: 13,
	            g: 1
	          }, {
	            n: "clipboard",
	            t: 71
	          }, {
	            n: "data-clipboard-text",
	            f: [{
	              t: 2,
	              r: "html"
	            }],
	            t: 13
	          }]
	        }]
	      }],
	      n: 52,
	      r: "links"
	    }, " ", {
	      t: 7,
	      e: "button",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "copy-all",
	        g: 1
	      }, {
	        n: "clipboard",
	        t: 71
	      }, {
	        n: "data-clipboard-text",
	        f: [{
	          t: 2,
	          x: {
	            r: ["combined", "html.length", "html"],
	            s: "(_0&&_1>1?_2.slice(1):_2).join(\"\\n\")"
	          }
	        }],
	        t: 13
	      }],
	      f: ["COPY ALL"]
	    }]
	  }],
	  e: {
	    "_0&&!_1&&_2>1": function (_0, _1, _2) {
	      return _0 && !_1 && _2 > 1;
	    },
	    "(_0&&_1>1?_2.slice(1):_2).join(\"\\n\")": function (_0, _1, _2) {
	      return (_0 && _1 > 1 ? _2.slice(1) : _2).join("\n");
	    }
	  }
	};
	var collectionLinks = ractive__default["default"].extend(component$s.exports);

	var component$r = {
	  exports: {}
	};
	component$r.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      n: "class",
	      f: ["c-switch-box", {
	        t: 4,
	        f: [" active"],
	        n: 50,
	        r: "active"
	      }],
	      t: 13
	    }, {
	      n: ["click"],
	      t: 70,
	      f: {
	        r: ["@this"],
	        s: "[_0.toggle(\"active\")]"
	      }
	    }],
	    f: [{
	      t: 16
	    }]
	  }],
	  e: {
	    "[_0.toggle(\"active\")]": function (_0) {
	      return [_0.toggle("active")];
	    }
	  }
	};
	var switchBox = ractive__default["default"].extend(component$r.exports);

	var component$q = {
	  exports: {}
	};
	const {
	  buildLinks
	} = buildLinks_1;
	component$q.exports = {
	  computed: {
	    alias: {
	      get() {
	        return this.get('_alias');
	      },
	      set(value) {
	        this.set('_alias', value);
	        this.set('_aliasSri', value);
	      }
	    },
	    html: {
	      get() {
	        return this.get('sri') || this.get('_html');
	      },
	      set(value) {
	        this.set('_html', value);
	        this.set('_htmlSri', value);
	      }
	    },
	    links() {
	      return buildLinks(this.get('collection'), this.get('html'), this.get('optimize'), this.get('alias'), this.get('sri'));
	    },
	    optimize: {
	      get() {
	        return this.get('_optimize');
	      },
	      set(value) {
	        this.set('_optimize', value);
	        this.set('_optimizeSri', value);
	      }
	    },
	    sri: {
	      get() {
	        return this.get('_sri') && this.get('_html') && !this.get('_optimize') && !this.get('_alias');
	      },
	      set(value) {
	        this.set('_sri', value);
	        if (value) {
	          this.set('_html', true);
	          this.set('_optimize', false);
	          this.set('_alias', false);
	        } else {
	          this.set('_html', this.get('_htmlSri'));
	          this.set('_optimize', this.get('_optimizeSri'));
	          this.set('_alias', this.get('_aliasSri'));
	        }
	      }
	    }
	  },
	  data() {
	    return {
	      html: false,
	      optimize: true,
	      alias: false,
	      sri: false
	    };
	  }
	};
	component$q.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      t: 13,
	      n: "class",
	      f: "c-collection",
	      g: 1
	    }],
	    f: [{
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "container",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "a",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "go-back",
	          g: 1
	        }, {
	          n: ["click"],
	          t: 70,
	          f: "slide-prev"
	        }],
	        f: [{
	          t: 7,
	          e: "i",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "fa fa-chevron-left",
	            g: 1
	          }, {
	            n: "aria-hidden",
	            f: "true",
	            t: 13,
	            g: 1
	          }]
	        }, " back to ", {
	          t: 2,
	          r: "name"
	        }]
	      }, " ", {
	        t: 7,
	        e: "h1",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "headline",
	          g: 1
	        }],
	        f: ["Selected files"]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "alert alert-warning",
	          g: 1
	        }],
	        f: ["Using the combined link may cause problems with relative imports, such as images or font files referenced by one of the files. You need to use the regular, single-file links for any files that use relative imports (e.g., font-awesome)."]
	      }, " ", {
	        t: 4,
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "alert alert-warning",
	            g: 1
	          }],
	          f: ["Check ", {
	            t: 7,
	            e: "a",
	            m: [{
	              n: "href",
	              f: "/using-sri-with-dynamic-files",
	              t: 13,
	              g: 1
	            }],
	            f: ["this page"]
	          }, " for more information about using SRI with jsDelivr."]
	        }],
	        n: 50,
	        r: "sri"
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "row",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "col-md-3 col-sm-6",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "c-switch-box",
	            m: [{
	              n: "active",
	              f: [{
	                t: 2,
	                r: "html"
	              }],
	              t: 13
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "switch-box-title",
	                g: 1
	              }],
	              f: ["HTML output"]
	            }, " Display all links as HTML code for easier copy-paste."]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "col-md-3 col-sm-6",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "c-switch-box",
	            m: [{
	              n: "active",
	              f: [{
	                t: 2,
	                r: "optimize"
	              }],
	              t: 13
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "switch-box-title",
	                g: 1
	              }],
	              f: ["Auto-optimization"]
	            }, " If a minified version of JS/CSS isn't available, generate it on the fly.", {
	              t: 7,
	              e: "br"
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "col-md-3 col-sm-6",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "c-switch-box",
	            m: [{
	              n: "active",
	              f: [{
	                t: 2,
	                r: "alias"
	              }],
	              t: 13
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "switch-box-title",
	                g: 1
	              }],
	              f: ["Version aliasing"]
	            }, " Automatically receive bug fixes and new non-breaking features.", {
	              t: 7,
	              e: "br"
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "col-md-3 col-sm-6",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "c-switch-box",
	            m: [{
	              n: "active",
	              f: [{
	                t: 2,
	                r: "sri"
	              }],
	              t: 13
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "switch-box-title",
	                g: 1
	              }],
	              f: ["SRI"]
	            }, " Enable Subresource Integrity check for increased security.", {
	              t: 7,
	              e: "br"
	            }]
	          }]
	        }]
	      }, " ", {
	        t: 4,
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "row",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "col-md-12",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "c-collection-links",
	              m: [{
	                n: "title",
	                f: "JavaScript",
	                t: 13,
	                g: 1
	              }, {
	                n: "links",
	                f: [{
	                  t: 2,
	                  r: "links.js"
	                }],
	                t: 13
	              }, {
	                n: "combined",
	                f: "true",
	                t: 13,
	                g: 1
	              }]
	            }]
	          }]
	        }],
	        n: 50,
	        r: "links.js"
	      }, " ", {
	        t: 4,
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "row",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "col-md-12",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "c-collection-links",
	              m: [{
	                n: "title",
	                f: "CSS",
	                t: 13,
	                g: 1
	              }, {
	                n: "links",
	                f: [{
	                  t: 2,
	                  r: "links.css"
	                }],
	                t: 13
	              }, {
	                n: "combined",
	                f: "true",
	                t: 13,
	                g: 1
	              }]
	            }]
	          }]
	        }],
	        n: 50,
	        r: "links.css"
	      }, " ", {
	        t: 4,
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "row",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "col-md-12",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "c-collection-links",
	              m: [{
	                n: "title",
	                f: "Other",
	                t: 13,
	                g: 1
	              }, {
	                n: "links",
	                f: [{
	                  t: 2,
	                  r: "links.other"
	                }],
	                t: 13
	              }]
	            }]
	          }]
	        }],
	        n: 50,
	        r: "links.other"
	      }]
	    }]
	  }]
	};
	component$q.exports.components = {
	  "c-collection-links": collectionLinks,
	  "c-switch-box": switchBox
	};
	var collection = ractive__default["default"].extend(component$q.exports);

	var component$p = {
	  exports: {}
	};
	component$p.exports = {
	  computed: {
	    tab: {
	      get() {
	        return this.get('tabRoute') !== 'readme' ? this.get('tabRoute') : '';
	      },
	      set(value = 'readme') {
	        this.set('tabRoute', value);
	      }
	    },
	    path: {
	      get() {
	        return this.get('pathA').join('/');
	      },
	      set(value = '') {
	        this.set('pathA', value.split('/').filter(v => v));
	      }
	    },
	    title() {
	      return this.get('name') + ' CDN by jsDelivr - A CDN for npm and GitHub';
	    },
	    description() {
	      return this.get('package.description') ? `A free, fast, and reliable CDN for ${this.get('name')}. ${this.get('package.description')}` : undefined;
	    },
	    version: {
	      get() {
	        return !this.get('versionS') || this.get('versionS') === this.get('versionP') ? '' : this.get('versionP');
	      },
	      set(value) {
	        this.set({
	          versionS: true,
	          versionP: value
	        });
	      }
	    },
	    microdata: {
	      get() {
	        return {
	          '@context': 'https://schema.org',
	          '@type': 'SoftwareSourceCode',
	          'name': this.get('name'),
	          'version': this.get('versionP'),
	          'description': this.get('description'),
	          'url': `https://www.jsdelivr.com/package/${this.get('type')}/${this.get('name')}`,
	          'codeRepository': this.get('package.repository.url'),
	          'dateCreated': Object.values(this.get('package.versions') || {}).at(0),
	          'dateModified': Object.values(this.get('package.versions') || {}).at(-1),
	          'programmingLanguage': 'JavaScript',
	          'maintainer': {
	            '@type': 'Person',
	            'name': this.get('package.owner.name')
	          },
	          'image': this.get('package.owner.avatar')
	        };
	      }
	    }
	  },
	  data() {
	    return {
	      collection: [],
	      package: {},
	      pathA: []
	    };
	  },
	  oninit() {
	    this.set('activeSlide', this.get('slide') === 'collection' ? 1 : 0);
	    this.observe('slide', newValue => {
	      this.findComponent('c-slider').show(newValue === 'collection' ? 1 : 0);
	    }, {
	      init: false
	    });
	    this.observe('activeSlide', newValue => {
	      this.set('slide', newValue ? 'collection' : '');
	    }, {
	      init: false
	    });
	    this.observe('versionP', newValue => {
	      if (newValue && !this.get('versionS')) {
	        this.set('versionS', newValue);
	      }
	    });

	    // Support scoped npm packages.
	    this.observe('scope name', () => {
	      if (this.get('scope') && this.get('name') && this.get('name').indexOf(this.get('scope')) !== 0) {
	        this.set('name', this.get('scope') + '/' + this.get('name'));
	      }
	    });

	    // Convert user/repo to name for GitHub packages.
	    this.observe('user repo', () => {
	      if (this.get('user') && this.get('repo')) {
	        this.set('name', this.get('user') + '/' + this.get('repo'));
	      }
	    });
	    if (this.get('type') !== 'npm') {
	      this.set({
	        package: {
	          githubRepo: {
	            user: this.get('user'),
	            project: this.get('repo')
	          },
	          owner: {
	            link: `https://github.com/${this.get('user')}/`,
	            avatar: `https://github.com/${this.get('user')}.png`,
	            name: this.get('user')
	          },
	          readme: ' '
	        }
	      }, {
	        deep: true
	      });
	    }
	    if (!ractive__default["default"].isServer) {
	      this.observe('version', version => {
	        http.fetchPackageReadme(this.get('type'), this.get('name'), version).then(readme => {
	          if (readme && version === this.get('version')) {
	            this.set('package.readme', readme);
	          }
	        });
	      }, {
	        init: false
	      });
	      Promise.all([Object.keys(this.get('package')).length ? this.get('package') : search.getByName(this.get('name')), http.fetchPackageVersions(this.get('type'), this.get('name')), http.fetchPackageReadme(this.get('type'), this.get('name'), this.get('version')).catch(() => '')]).then(([result, versionsResponse, readme]) => {
	        let versionsArr = versionsResponse.versions.map(item => item.version);

	        // This can only happen for GitHub packages.
	        if (versionsResponse.versions.length === 0) {
	          http.fetchProjectCommits(this.get('package.githubRepo.user'), this.get('package.githubRepo.project')).then(data => {
	            let sha = data[0].sha; // if there are no commits this will throw and trigger the catch() block, which is intended
	            this.set('packageVersionsList', [sha]);
	            this.set('package.githubRepo.head', sha);
	            this.set('package.version', sha);
	            this.set('versionP', sha);
	          }).catch(error => {
	            this.set({
	              packageVersionsNotFound: true
	            });
	            this.set('package.githubRepo.head', 'HEAD');
	            console.error(`Commits not found.`, error);
	          });
	        } else {
	          let sortedVersionsArr = versionsArr.reduce((acc, version) => {
	            if (version.indexOf('-') !== -1) {
	              acc.prerelease.push(version);
	            } else {
	              acc.stable.push(version);
	            }
	            return acc;
	          }, {
	            stable: [],
	            prerelease: []
	          });
	          this.set('packageVersionsList', [...sortedVersionsArr.stable, 'separator', ...sortedVersionsArr.prerelease]);
	          if (versionsResponse.tags.latest && !app.router.route.getState().qs.version) {
	            result.version = versionsResponse.tags.latest;
	            this.set({
	              versionP: result.version,
	              versionS: result.version
	            });
	          }

	          // Set version for GitHub packages.
	          if (!result.version) {
	            result.version = versionsResponse.versions[0].version;
	            result.githubRepo.head = versionsResponse.versions[0].version;
	          }

	          // Set version for GitHub packages or when an invalid version is selected.
	          if (!this.get('versionP') || versionsArr.indexOf(this.get('versionP')) === -1) {
	            this.set('versionP', versionsResponse.versions[0].version);
	          }
	        }
	        this.set({
	          package: {
	            ...result,
	            readme
	          }
	        });
	      }).catch(error => {
	        if (error.statusCode === 404 || error.status === 404) {
	          this.set({
	            packageNotFound: true
	          });
	        } else {
	          this.set({
	            packageFailedToLoad: true
	          });
	        }
	        console.error(error);
	      });
	      if (has.localStorage()) {
	        this.observe('collection', newValue => {
	          localStorage.setItem('collection2', JSON.stringify(newValue));
	        }, {
	          init: false
	        });
	      }
	    }
	  }
	};
	component$p.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "r-page",
	    m: [{
	      n: "noYield",
	      f: [{
	        t: 2,
	        r: "noYield"
	      }],
	      t: 13
	    }, {
	      n: "title",
	      f: [{
	        t: 2,
	        r: "title"
	      }],
	      t: 13
	    }, {
	      n: "description",
	      f: [{
	        t: 2,
	        r: "description"
	      }],
	      t: 13
	    }, {
	      n: "openGraphImage",
	      f: [{
	        t: 4,
	        f: [{
	          t: 2,
	          r: "@shared.serverHost"
	        }, "/open-graph/image/npm/", {
	          t: 2,
	          r: "name"
	        }],
	        n: 50,
	        x: {
	          r: ["type"],
	          s: "_0===\"npm\""
	        }
	      }],
	      t: 13
	    }],
	    f: [" ", {
	      t: 7,
	      e: "link",
	      m: [{
	        n: "rel",
	        f: "stylesheet",
	        t: 13,
	        g: 1
	      }, {
	        n: "href",
	        f: "https://cdn.jsdelivr.net/npm/pace-js@1.2.4/themes/orange/pace-theme-minimal.css",
	        t: 13,
	        g: 1
	      }, {
	        n: "media",
	        f: "print",
	        t: 13,
	        g: 1
	      }, {
	        n: "onload",
	        f: "this.media='all'",
	        t: 13,
	        g: 1
	      }]
	    }, " ", {
	      t: 7,
	      e: "script",
	      m: [{
	        n: "async",
	        f: 0,
	        t: 13
	      }, {
	        n: "data-pace-options",
	        f: "{ \"restartOnPushState\": false, \"restartOnRequestAfter\": false }",
	        t: 13,
	        g: 1
	      }, {
	        n: "src",
	        f: "https://cdn.jsdelivr.net/npm/pace-js@1.2.4/pace.min.js",
	        t: 13,
	        g: 1
	      }]
	    }, " ", {
	      t: 7,
	      e: "c-notification"
	    }, " ", {
	      t: 7,
	      e: "c-header",
	      m: [{
	        n: "name",
	        f: [{
	          t: 2,
	          r: "name"
	        }],
	        t: 13
	      }, {
	        n: "searchOpened",
	        f: [{
	          t: 2,
	          r: "searchOpened"
	        }],
	        t: 13
	      }],
	      f: [{
	        t: 7,
	        e: "c-search-compact",
	        m: [{
	          n: "__ready",
	          f: [{
	            t: 2,
	            r: "__ready"
	          }],
	          t: 13
	        }, {
	          n: "searchOpened",
	          f: [{
	            t: 2,
	            r: "searchOpened"
	          }],
	          t: 13
	        }, {
	          n: "page",
	          f: [{
	            t: 2,
	            r: "page"
	          }],
	          t: 13
	        }, {
	          n: "query",
	          f: [{
	            t: 2,
	            r: "query"
	          }],
	          t: 13
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "p-package page",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "c-slider",
	        m: [{
	          n: "active",
	          f: [{
	            t: 2,
	            r: "activeSlide"
	          }],
	          t: 13
	        }],
	        f: [{
	          t: 7,
	          e: "c-slide",
	          f: [{
	            t: 4,
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "text-center package-not-found",
	                g: 1
	              }],
	              f: ["Package ", {
	                t: 2,
	                r: "name"
	              }, " was not found.", {
	                t: 7,
	                e: "br"
	              }, " Please retry in a few minutes and if the problem persists, file an issue on ", {
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "rel",
	                  f: "noopener noreferrer",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "href",
	                  f: "https://github.com/jsdelivr/www.jsdelivr.com/issues",
	                  t: 13,
	                  g: 1
	                }],
	                f: ["GitHub"]
	              }, "."]
	            }],
	            n: 50,
	            r: "packageNotFound"
	          }, {
	            t: 4,
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "text-center package-not-found",
	                g: 1
	              }],
	              f: ["Package ", {
	                t: 2,
	                r: "name"
	              }, " failed to load.", {
	                t: 7,
	                e: "br"
	              }, " There might be a problem with your internet connection. Try refreshing the page a few times.", {
	                t: 7,
	                e: "br"
	              }, " If the problem persists, file an issue on ", {
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "rel",
	                  f: "noopener noreferrer",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "href",
	                  f: "https://github.com/jsdelivr/www.jsdelivr.com/issues",
	                  t: 13,
	                  g: 1
	                }],
	                f: ["GitHub"]
	              }, "."]
	            }, " "],
	            n: 50,
	            r: "packageFailedToLoad",
	            l: 1
	          }, {
	            t: 4,
	            f: [" ", {
	              t: 7,
	              e: "c-package",
	              m: [{
	                n: "type",
	                f: [{
	                  t: 2,
	                  r: "type"
	                }],
	                t: 13
	              }, {
	                n: "name",
	                f: [{
	                  t: 2,
	                  r: "name"
	                }],
	                t: 13
	              }, {
	                n: "path",
	                f: [{
	                  t: 2,
	                  r: "pathA"
	                }],
	                t: 13
	              }, {
	                n: "package",
	                f: [{
	                  t: 2,
	                  r: "package"
	                }],
	                t: 13
	              }, {
	                n: "packageVersionsList",
	                f: [{
	                  t: 2,
	                  r: "packageVersionsList"
	                }],
	                t: 13
	              }, {
	                n: "versionP",
	                f: [{
	                  t: 2,
	                  r: "versionP"
	                }],
	                t: 13
	              }, {
	                n: "collection",
	                f: [{
	                  t: 2,
	                  r: "collection"
	                }],
	                t: 13
	              }, {
	                n: "query",
	                f: [{
	                  t: 2,
	                  r: "query"
	                }],
	                t: 13
	              }, {
	                n: "packageVersionsNotFound",
	                f: [{
	                  t: 2,
	                  r: "packageVersionsNotFound"
	                }],
	                t: 13
	              }, {
	                n: "tabRoute",
	                f: [{
	                  t: 2,
	                  r: "tabRoute"
	                }],
	                t: 13
	              }],
	              f: []
	            }],
	            n: 50,
	            r: "package",
	            l: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "c-slide",
	          f: [{
	            t: 7,
	            e: "c-collection",
	            m: [{
	              n: "name",
	              f: [{
	                t: 2,
	                r: "name"
	              }],
	              t: 13
	            }, {
	              n: "collection",
	              f: [{
	                t: 2,
	                r: "collection"
	              }],
	              t: 13
	            }]
	          }]
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "c-footer"
	    }],
	    p: {
	      seo: [{
	        t: 4,
	        f: [{
	          t: 7,
	          e: "meta",
	          m: [{
	            n: "name",
	            f: "robots",
	            t: 13,
	            g: 1
	          }, {
	            n: "content",
	            f: "noindex",
	            t: 13,
	            g: 1
	          }]
	        }],
	        n: 50,
	        r: "packageNotFound"
	      }, " ", {
	        t: 7,
	        e: "script",
	        m: [{
	          n: "type",
	          f: "application/ld+json",
	          t: 13,
	          g: 1
	        }],
	        f: ["\t\t\t", {
	          t: 2,
	          x: {
	            r: ["@shared", "microdata"],
	            s: "_0.escape(JSON.stringify(_1))"
	          }
	        }, "\n\t\t"]
	      }],
	      css: [{
	        t: 7,
	        e: "link",
	        m: [{
	          n: "rel",
	          f: "preconnect",
	          t: 13,
	          g: 1
	        }, {
	          n: "href",
	          f: "https://ofcncog2cu-dsn.algolia.net/",
	          t: 13,
	          g: 1
	        }, {
	          n: "crossorigin",
	          f: "anonymous",
	          t: 13,
	          g: 1
	        }]
	      }, " ", {
	        t: 7,
	        e: "link",
	        m: [{
	          n: "rel",
	          f: "preconnect",
	          t: 13,
	          g: 1
	        }, {
	          n: "href",
	          f: "https://data.jsdelivr.com/",
	          t: 13,
	          g: 1
	        }, {
	          n: "crossorigin",
	          f: "anonymous",
	          t: 13,
	          g: 1
	        }]
	      }]
	    }
	  }],
	  e: {
	    "_0===\"npm\"": function (_0) {
	      return _0 === "npm";
	    },
	    "_0.escape(JSON.stringify(_1))": function (_0, _1) {
	      return _0.escape(JSON.stringify(_1));
	    }
	  }
	};
	component$p.exports.components = {
	  "c-search-compact": searchCompact,
	  "c-slide": slide,
	  "c-slider": slider,
	  "c-package": _package$1,
	  "c-notification": notification,
	  "c-footer": footer,
	  "c-header": header,
	  "c-collection": collection,
	  "r-page": rPage
	};
	var _package = ractive__default["default"].extend(component$p.exports);

	var component$o = {
	  exports: {}
	};
	component$o.exports = {
	  data() {
	    return {
	      title: 'Our Sponsors - jsDelivr',
	      description: 'jsDelivr is sponsored by Cloudflare, Fastly, Bunny, IBM, and other awesome companies.'
	    };
	  }
	};
	component$o.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "r-page",
	    m: [{
	      n: "noYield",
	      f: [{
	        t: 2,
	        r: "noYield"
	      }],
	      t: 13
	    }, {
	      n: "title",
	      f: [{
	        t: 2,
	        r: "title"
	      }],
	      t: 13
	    }, {
	      n: "description",
	      f: [{
	        t: 2,
	        r: "description"
	      }],
	      t: 13
	    }],
	    f: [{
	      t: 7,
	      e: "c-notification"
	    }, " ", {
	      t: 7,
	      e: "c-header"
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "p-sponsors",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "navigation",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "a",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "active",
	            g: 1
	          }],
	          f: ["Our sponsors"]
	        }, " ", {
	          t: 7,
	          e: "a",
	          m: [{
	            n: "href",
	            f: "/become-a-sponsor",
	            t: 13,
	            g: 1
	          }],
	          f: ["Become our sponsor"]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "container",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "head-wrapper",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "head-wrapper_map-wrapper",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "img",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "head-map-bg",
	                g: 1
	              }, {
	                n: "width",
	                f: "908",
	                t: 13,
	                g: 1
	              }, {
	                n: "height",
	                f: "428",
	                t: 13,
	                g: 1
	              }, {
	                n: "src",
	                f: [{
	                  t: 2,
	                  r: "@shared.assetsHost"
	                }, "/img/sponsors/map.svg"],
	                t: 13
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "head-title",
	              g: 1
	            }],
	            f: ["Our Sponsors"]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "head-subtitle",
	              g: 1
	            }],
	            f: ["Support us"]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "head-descr",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "span",
	              f: ["Support jsDelivr by donating to us through GitHub Sponsors and Open Collective and help cover the expenses of our infrastructure and sponsor the development of new features"]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "head-ctrls",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "a",
	              m: [{
	                n: "target",
	                f: "_blank",
	                t: 13,
	                g: 1
	              }, {
	                n: "rel",
	                f: "noopener noreferrer",
	                t: 13,
	                g: 1
	              }, {
	                n: "href",
	                f: "https://github.com/sponsors/jsdelivr",
	                t: 13,
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "20",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "20",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/icons/github.black.svg"],
	                  t: 13
	                }]
	              }, " GitHub Sponsors"]
	            }, " ", {
	              t: 7,
	              e: "a",
	              m: [{
	                n: "target",
	                f: "_blank",
	                t: 13,
	                g: 1
	              }, {
	                n: "rel",
	                f: "noopener noreferrer",
	                t: 13,
	                g: 1
	              }, {
	                n: "href",
	                f: "https://opencollective.com/jsdelivr",
	                t: 13,
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "18",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "18",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/icons/open-collective.svg"],
	                  t: 13
	                }]
	              }, " Open Collective"]
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "h3",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "sp-header platinum-header",
	            g: 1
	          }, {
	            n: "id",
	            f: "platinum",
	            t: 13,
	            g: 1
	          }],
	          f: ["PLATINUM"]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "sp-row",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "sp-item",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "sp",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "sp-img",
	                  g: 1
	                }, {
	                  n: "width",
	                  f: "167",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "60",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/sponsors/cloudflare.png"],
	                  t: 13
	                }, {
	                  n: "srcset",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/sponsors/cloudflare@2x.png 2x"],
	                  t: 13
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "sp-text",
	                  g: 1
	                }],
	                f: ["Main backend CDN for jsDelivr offering unlimited bandwidth and locations. \"Offers free and commercial, cloud-based services to help secure and accelerate websites.\""]
	              }, " ", {
	                t: 7,
	                e: "a",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "sp-link",
	                  g: 1
	                }, {
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "rel",
	                  f: "noopener noreferrer",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "href",
	                  f: "https://www.cloudflare.com",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: "width",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/icons/share.svg"],
	                    t: 13
	                  }]
	                }, " www.cloudflare.com"]
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "sp-item",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "sp",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "sp-img",
	                  g: 1
	                }, {
	                  n: "width",
	                  f: "126",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "60",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/sponsors/fastly.png"],
	                  t: 13
	                }, {
	                  n: "srcset",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/sponsors/fastly@2x.png 2x"],
	                  t: 13
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "sp-text",
	                  g: 1
	                }],
	                f: ["Main backend CDN for jsDelivr offering unlimited bandwidth and locations. \"Fastly's edge cloud platform powers fast, secure, and scalable digital experiences.\""]
	              }, " ", {
	                t: 7,
	                e: "a",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "sp-link",
	                  g: 1
	                }, {
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "rel",
	                  f: "noopener noreferrer",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "href",
	                  f: "https://www.fastly.com",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: "width",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/icons/share.svg"],
	                    t: 13
	                  }]
	                }, " www.fastly.com"]
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "sp-item",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "sp",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "sp-img",
	                  g: 1
	                }, {
	                  n: "width",
	                  f: "150",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "60",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/sponsors/ibm.svg"],
	                  t: 13
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "sp-text",
	                  g: 1
	                }],
	                f: ["Our DNS hosting provider offering unlimited DNS queries and an additional layer of failover. \"Industry leading DNS traffic management - managed DNS, private DNS networks, and powerful turnkey traffic routing setups.\""]
	              }, " ", {
	                t: 7,
	                e: "a",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "sp-link",
	                  g: 1
	                }, {
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "rel",
	                  f: "noopener noreferrer",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "href",
	                  f: "https://www.ibm.com/products/ns1-connect",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: "width",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/icons/share.svg"],
	                    t: 13
	                  }]
	                }, " www.ibm.com"]
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "sp-item",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "sp",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "sp-img",
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "60",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/sponsors/g-core.svg"],
	                  t: 13
	                }, {
	                  n: "loading",
	                  f: "lazy",
	                  t: 13,
	                  g: 1
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "sp-text",
	                  g: 1
	                }],
	                f: ["Regional and backup CDN for jsDelivr offering unlimited bandwidth and locations. \"A secure Edge & Cloud Platform to go global faster. Offering low-latency services around the world, trusted by the largest online businesses.\""]
	              }, " ", {
	                t: 7,
	                e: "a",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "sp-link",
	                  g: 1
	                }, {
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "rel",
	                  f: "noopener noreferrer",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "href",
	                  f: "https://gcore.com",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: "width",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/icons/share.svg"],
	                    t: 13
	                  }]
	                }, " gcore.com"]
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "sp-item",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "sp",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "sp-img",
	                  g: 1
	                }, {
	                  n: "width",
	                  f: "207",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "60",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/sponsors/bunny.png"],
	                  t: 13
	                }, {
	                  n: "srcset",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/sponsors/bunny@2x.png 2x"],
	                  t: 13
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "sp-text",
	                  g: 1
	                }],
	                f: ["Regional and backup CDN for jsDelivr offering unlimited bandwidth and locations. \"Go faster than the fastest with our next-generation CDN, edge storage, and optimization service.\""]
	              }, " ", {
	                t: 7,
	                e: "a",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "sp-link",
	                  g: 1
	                }, {
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "rel",
	                  f: "noopener noreferrer",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "href",
	                  f: "https://bunny.net",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: "width",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/icons/share.svg"],
	                    t: 13
	                  }]
	                }, " bunny.net"]
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "sp-item",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "sp",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "sp-img render",
	                  g: 1
	                }, {
	                  n: "width",
	                  f: "157",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "30",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/sponsors/render-black.svg"],
	                  t: 13
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "sp-text",
	                  g: 1
	                }],
	                f: ["Main hosting provider for jsDelivr related websites and APIs. \"Render is a unified cloud to build and run all your apps and websites with free SSL, a global CDN, private networks, and auto deploys from Git.\""]
	              }, " ", {
	                t: 7,
	                e: "a",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "sp-link",
	                  g: 1
	                }, {
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "rel",
	                  f: "noopener noreferrer",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "href",
	                  f: "https://render.com",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: "width",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/icons/share.svg"],
	                    t: 13
	                  }]
	                }, " render.com"]
	              }]
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "h3",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "sp-header gold-header",
	            g: 1
	          }, {
	            n: "id",
	            f: "gold",
	            t: 13,
	            g: 1
	          }],
	          f: ["GOLD"]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "sp-row row-gold",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "sp-item",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "sp",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "sp-img",
	                  g: 1
	                }, {
	                  n: "width",
	                  f: "169",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "60",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/sponsors/algolia.png"],
	                  t: 13
	                }, {
	                  n: "srcset",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/sponsors/algolia@2x.png 2x"],
	                  t: 13
	                }, {
	                  n: "loading",
	                  f: "lazy",
	                  t: 13,
	                  g: 1
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "sp-text",
	                  g: 1
	                }],
	                f: ["Algolia Search provides hosted full-text, numerical, faceted, and geolocalized search."]
	              }, " ", {
	                t: 7,
	                e: "a",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "sp-link",
	                  g: 1
	                }, {
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "rel",
	                  f: "noopener noreferrer",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "href",
	                  f: "https://www.algolia.com",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: "width",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/icons/share.svg"],
	                    t: 13
	                  }]
	                }, " www.algolia.com"]
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "sp-item",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "sp",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "sp-img",
	                  g: 1
	                }, {
	                  n: "width",
	                  f: "150",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "60",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/sponsors/cloudns.png"],
	                  t: 13
	                }, {
	                  n: "srcset",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/sponsors/cloudns@2x.png 2x"],
	                  t: 13
	                }, {
	                  n: "loading",
	                  f: "lazy",
	                  t: 13,
	                  g: 1
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "sp-text",
	                  g: 1
	                }],
	                f: ["ClouDNS is offering Premium, DDoS Protected, and GeoDNS services supported by Global Anycast network."]
	              }, " ", {
	                t: 7,
	                e: "a",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "sp-link",
	                  g: 1
	                }, {
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "rel",
	                  f: "noopener noreferrer",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "href",
	                  f: "https://www.cloudns.net",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: "width",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/icons/share.svg"],
	                    t: 13
	                  }]
	                }, " www.cloudns.net"]
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "sp-item",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "sp",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "sp-img",
	                  g: 1
	                }, {
	                  n: "width",
	                  f: "237",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "60",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/sponsors/digitalocean.png"],
	                  t: 13
	                }, {
	                  n: "srcset",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/sponsors/digitalocean@2x.png 2x"],
	                  t: 13
	                }, {
	                  n: "loading",
	                  f: "lazy",
	                  t: 13,
	                  g: 1
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "sp-text",
	                  g: 1
	                }],
	                f: ["Helping millions of developers easily build, test, manage, and scale applications of any size."]
	              }, " ", {
	                t: 7,
	                e: "a",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "sp-link",
	                  g: 1
	                }, {
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "rel",
	                  f: "noopener noreferrer",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "href",
	                  f: "https://www.digitalocean.com",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: "width",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/icons/share.svg"],
	                    t: 13
	                  }]
	                }, " www.digitalocean.com"]
	              }]
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "h3",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "sp-header bronze-header",
	            g: 1
	          }, {
	            n: "id",
	            f: "bronze",
	            t: 13,
	            g: 1
	          }],
	          f: ["BRONZE"]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "sp-row row-bronze",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "sp-item",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "sp",
	                g: 1
	              }, {
	                n: "title",
	                f: "Clever Cloud",
	                t: 13,
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "rel",
	                  f: "noopener noreferrer",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "href",
	                  f: "https://www.clever-cloud.com",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "sp-img",
	                    g: 1
	                  }, {
	                    n: "width",
	                    f: "231",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "60",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/sponsors/clever-cloud.png"],
	                    t: 13
	                  }, {
	                    n: "srcset",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/sponsors/clever-cloud@2x.png 2x"],
	                    t: 13
	                  }, {
	                    n: "loading",
	                    f: "lazy",
	                    t: 13,
	                    g: 1
	                  }]
	                }]
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "sp-item",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "sp",
	                g: 1
	              }, {
	                n: "title",
	                f: "Prebid",
	                t: 13,
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "rel",
	                  f: "noopener noreferrer",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "href",
	                  f: "https://prebid.org",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 9
	                }, " ", {
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "sp-img",
	                    g: 1
	                  }, {
	                    n: "width",
	                    f: "201",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "60",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/sponsors/pb.png"],
	                    t: 13
	                  }, {
	                    n: "srcset",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/sponsors/pb@2x.png 2x"],
	                    t: 13
	                  }, {
	                    n: "loading",
	                    f: "lazy",
	                    t: 13,
	                    g: 1
	                  }]
	                }]
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "sp-item",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "sp",
	                g: 1
	              }, {
	                n: "title",
	                f: "SpeedCurve",
	                t: 13,
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "rel",
	                  f: "noopener noreferrer",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "href",
	                  f: "https://www.speedcurve.com",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "sp-img",
	                    g: 1
	                  }, {
	                    n: "width",
	                    f: "265",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "60",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/sponsors/speedcurve.png"],
	                    t: 13
	                  }, {
	                    n: "srcset",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/sponsors/speedcurve@2x.png 2x"],
	                    t: 13
	                  }, {
	                    n: "loading",
	                    f: "lazy",
	                    t: 13,
	                    g: 1
	                  }]
	                }]
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "sp-item",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "sp",
	                g: 1
	              }, {
	                n: "title",
	                f: "PackageCloud",
	                t: 13,
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "rel",
	                  f: "noopener noreferrer",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "href",
	                  f: "https://packagecloud.io",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "sp-img packagecloud",
	                    g: 1
	                  }, {
	                    n: "width",
	                    f: "223",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "30",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/sponsors/packagecloud.png"],
	                    t: 13
	                  }, {
	                    n: "srcset",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/sponsors/packagecloud@2x.png 2x"],
	                    t: 13
	                  }, {
	                    n: "loading",
	                    f: "lazy",
	                    t: 13,
	                    g: 1
	                  }]
	                }]
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "sp-item",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "sp",
	                g: 1
	              }, {
	                n: "title",
	                f: "BairesDev",
	                t: 13,
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "rel",
	                  f: "noopener noreferrer",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "href",
	                  f: "https://www.bairesdev.com/sponsoring-open-source-projects/",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "sp-img",
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "36",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "width",
	                    f: "242",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/sponsors/bairesdev.svg"],
	                    t: 13
	                  }, {
	                    n: "loading",
	                    f: "lazy",
	                    t: 13,
	                    g: 1
	                  }]
	                }]
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "sp-item",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "sp",
	                g: 1
	              }, {
	                n: "title",
	                f: "Route4Me",
	                t: 13,
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "rel",
	                  f: "noopener noreferrer",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "href",
	                  f: "https://route4me.com/",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "sp-img",
	                    g: 1
	                  }, {
	                    n: "width",
	                    f: "250",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "60",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/sponsors/route_4_me.svg"],
	                    t: 13
	                  }, {
	                    n: "alt",
	                    f: "Route Planner and Route Optimizer",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "loading",
	                    f: "lazy",
	                    t: 13,
	                    g: 1
	                  }]
	                }]
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "sp-item",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "sp",
	                g: 1
	              }, {
	                n: "title",
	                f: "Dotcom-Monitor is a trusted leader in website and network monitoring, providing a comprehensive suite of tools to keep digital assets secure, optimized, and available 24/7. With over two decades of experience, Dotcom-Monitor serves thousands of organizations globally.",
	                t: 13,
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "rel",
	                  f: "noopener noreferrer",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "href",
	                  f: "https://www.dotcom-monitor.com/sponsoring-open-source-projects/",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "sp-img dotcom-monitor",
	                    g: 1
	                  }, {
	                    n: "width",
	                    f: "245",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "25",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/sponsors/dotcom-monitor.svg"],
	                    t: 13
	                  }, {
	                    n: "alt",
	                    f: "Advanced Website Monitoring Solutions",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "loading",
	                    f: "lazy",
	                    t: 13,
	                    g: 1
	                  }]
	                }]
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "sp-item",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "sp",
	                g: 1
	              }, {
	                n: "title",
	                f: "CodeRabbit",
	                t: 13,
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "rel",
	                  f: "noopener noreferrer",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "href",
	                  f: "https://coderabbit.link/jsdelivr",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "sp-img",
	                    g: 1
	                  }, {
	                    n: "width",
	                    f: "287",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "42",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/sponsors/code-rabbit.svg"],
	                    t: 13
	                  }, {
	                    n: "loading",
	                    f: "lazy",
	                    t: 13,
	                    g: 1
	                  }]
	                }]
	              }]
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "be-a-sp",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "img",
	            m: [{
	              n: "width",
	              f: "41",
	              t: 13,
	              g: 1
	            }, {
	              n: "height",
	              f: "40",
	              t: 13,
	              g: 1
	            }, {
	              n: "src",
	              f: [{
	                t: 2,
	                r: "@shared.assetsHost"
	              }, "/img/icons/heart.svg"],
	              t: 13
	            }]
	          }, " ", {
	            t: 7,
	            e: "span",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "be-a-sp-text",
	              g: 1
	            }],
	            f: ["Help us make jsDelivr even better"]
	          }, " ", {
	            t: 7,
	            e: "a",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "btn-primary be-a-sp-btn",
	              g: 1
	            }, {
	              n: "target",
	              f: "_blank",
	              t: 13,
	              g: 1
	            }, {
	              n: "href",
	              f: "/become-a-sponsor",
	              t: 13,
	              g: 1
	            }],
	            f: ["Become our sponsor"]
	          }]
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "c-footer"
	    }]
	  }]
	};
	component$o.exports.components = {
	  "c-notification": notification,
	  "c-footer": footer,
	  "c-header": header,
	  "r-page": rPage
	};
	var sponsors = ractive__default["default"].extend(component$o.exports);

	var component$n = {
	  exports: {}
	};
	component$n.exports = {
	  computed: {
	    pageRange() {
	      let page = this.get('page');
	      let pageLimit = this.get('pageLimit');
	      let xTotalCount = this.get('xTotalCount');
	      let xTotalPages = this.get('xTotalPages');
	      let start = (page.value - 1) * pageLimit + 1;
	      let end = start + pageLimit - 1;
	      if (xTotalCount < end) {
	        end = xTotalCount;
	      }
	      return xTotalPages && xTotalCount ? `${start} - ${end} of ${xTotalCount}` : '0 of 0';
	    },
	    showablePages() {
	      let page = this.get('page');
	      let xTotalPages = this.get('xTotalPages');
	      let start = page.value - 2 < 1 ? 1 : page.value - 2;
	      let end = start + 4;
	      if (start + 4 > xTotalPages) {
	        start = xTotalPages - 4 > 0 ? xTotalPages - 4 : 1;
	        end = xTotalPages;
	      }
	      return {
	        start,
	        xTotalPages,
	        pageCount: new Array(end - start + 1)
	      };
	    }
	  },
	  data() {
	    return {
	      _,
	      statsType: 'all',
	      statsTypeList: {
	        all: 'All types',
	        npm: 'npm',
	        gh: 'GitHub'
	      },
	      page: {
	        value: 1
	      },
	      pageLimit: 10,
	      paginationLimits: [10, 20, 50, 100],
	      projectsList: [],
	      sortProjectsBy: 'hits',
	      xTotalCount: 0,
	      xTotalPages: 0
	    };
	  },
	  oninit() {
	    if (!ractive__default["default"].isServer) {
	      this.observe('period statsType sortProjectsBy pageLimit', () => {
	        this.set('page', {
	          value: 1
	        });
	      }, {
	        init: false
	      });

	      // this.observe('period statsType sortProjectsBy pageLimit page __ready', function () {
	      this.observe('page __ready', () => {
	        if (this.get('__ready')) {
	          let period = this.get('period');
	          let statsType = this.get('statsType');
	          let sortProjectsBy = this.get('sortProjectsBy');
	          let pageLimit = this.get('pageLimit');
	          let page = this.get('page');

	          // fetch projectsList using http api calls
	          http.fetchProjectStats(statsType, period, sortProjectsBy, page.value, pageLimit).then(({
	            response,
	            responseHeaders
	          }) => {
	            this.set('xTotalCount', parseInt(responseHeaders['x-total-count']));
	            this.set('xTotalPages', parseInt(responseHeaders['x-total-pages']));
	            this.animate('projectsList', this.processProjectStats(response));
	          });
	        }
	      });
	    }
	  },
	  processProjectStats(projectsList) {
	    let hitsMax = Math.max(...projectsList.map(({
	      hits
	    }) => hits));
	    let bandwidthMax = Math.max(...projectsList.map(({
	      bandwidth
	    }) => bandwidth));
	    return projectsList.map(one => {
	      let interest = (one.hits + one.bandwidth) * 100 / (one.prev.hits + one.prev.bandwidth) - 1;
	      let barWidth = {
	        hits: one.hits * 100 / hitsMax + '%',
	        bandwidth: one.bandwidth * 100 / bandwidthMax + '%'
	      };
	      let bandwidth = _.convertBytesToUnits(one.bandwidth);
	      interest = Number(interest.toFixed(2));
	      return {
	        ...one,
	        interest,
	        barWidth,
	        bandwidth
	      };
	    });
	  },
	  prevPage() {
	    let page = this.get('page');
	    let value = page.value > 1 ? page.value - 1 : page.value;
	    this.set('page', {
	      value
	    });
	  },
	  nextPage() {
	    let page = this.get('page');
	    let xTotalPages = this.get('xTotalPages');
	    let value = page.value + 1 > xTotalPages ? page.value : page.value + 1;
	    this.set('page', {
	      value
	    });
	  },
	  prettifyNumbersToDisplay(num) {
	    return _.formatNumberWithSpace(Math.round(num));
	  }
	};
	component$n.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      t: 13,
	      n: "class",
	      f: "c-statistics-project-table",
	      g: 1
	    }],
	    f: [{
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "projects-info",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "h3",
	        f: [{
	          t: 2,
	          r: "title"
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "btn-group",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "span",
	          f: ["Type:"]
	        }, " ", {
	          t: 7,
	          e: "button",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "btn dropdown-toggle",
	            g: 1
	          }, {
	            n: "type",
	            f: "button",
	            t: 13,
	            g: 1
	          }, {
	            n: "data-toggle",
	            f: "dropdown",
	            t: 13,
	            g: 1
	          }, {
	            n: "aria-haspopup",
	            f: "true",
	            t: 13,
	            g: 1
	          }, {
	            n: "aria-expanded",
	            f: "false",
	            t: 13,
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "span",
	            f: [{
	              t: 2,
	              rx: {
	                r: "statsTypeList",
	                m: [{
	                  t: 30,
	                  n: "statsType"
	                }]
	              }
	            }]
	          }, " ", {
	            t: 7,
	            e: "i",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "fa fa-angle-down",
	              g: 1
	            }, {
	              n: "aria-hidden",
	              f: "true",
	              t: 13,
	              g: 1
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "ul",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "dropdown-menu",
	            g: 1
	          }],
	          f: [{
	            t: 4,
	            f: [{
	              t: 7,
	              e: "li",
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  n: ["click"],
	                  t: 70,
	                  f: {
	                    r: ["@this", "@key"],
	                    s: "[_0.set(\"statsType\",_1)]"
	                  }
	                }],
	                f: [{
	                  t: 2,
	                  r: "."
	                }]
	              }]
	            }],
	            n: 52,
	            r: "statsTypeList"
	          }]
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "projects-content",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "projects-content_ctrls",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "span",
	          f: ["Sort by:"]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "projects-content_ctrls_switch",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "button",
	            m: [{
	              n: "class",
	              f: ["button ", {
	                t: 2,
	                x: {
	                  r: ["sortProjectsBy"],
	                  s: "_0===\"hits\"&&\"selected\""
	                }
	              }],
	              t: 13
	            }, {
	              n: ["click"],
	              t: 70,
	              f: {
	                r: ["@this"],
	                s: "[_0.set(\"sortProjectsBy\",\"hits\")]"
	              }
	            }],
	            f: ["Requests"]
	          }, " ", {
	            t: 7,
	            e: "button",
	            m: [{
	              n: "class",
	              f: ["button ", {
	                t: 2,
	                x: {
	                  r: ["sortProjectsBy"],
	                  s: "_0===\"bandwidth\"&&\"selected\""
	                }
	              }],
	              t: 13
	            }, {
	              n: ["click"],
	              t: 70,
	              f: {
	                r: ["@this"],
	                s: "[_0.set(\"sortProjectsBy\",\"bandwidth\")]"
	              }
	            }],
	            f: ["Bandwidth"]
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "projects-content_table",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "projects-content_table_header",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "cell cell_one",
	              g: 1
	            }],
	            f: ["Name"]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              n: "class",
	              f: ["cell cell_two ", {
	                t: 2,
	                x: {
	                  r: ["sortProjectsBy"],
	                  s: "_0===\"hits\"&&\"sorted\""
	                }
	              }],
	              t: 13
	            }, {
	              n: ["click"],
	              t: 70,
	              f: {
	                r: ["@this"],
	                s: "[_0.set(\"sortProjectsBy\",\"hits\")]"
	              }
	            }],
	            f: ["Requests ", {
	              t: 7,
	              e: "img",
	              m: [{
	                n: "width",
	                f: "20",
	                t: 13,
	                g: 1
	              }, {
	                n: "height",
	                f: "20",
	                t: 13,
	                g: 1
	              }, {
	                n: "src",
	                f: [{
	                  t: 2,
	                  r: "@shared.assetsHost"
	                }, "/img/statistics/left.svg"],
	                t: 13
	              }, {
	                n: "loading",
	                f: "lazy",
	                t: 13,
	                g: 1
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              n: "class",
	              f: ["cell cell_three ", {
	                t: 2,
	                x: {
	                  r: ["sortProjectsBy"],
	                  s: "_0===\"bandwidth\"&&\"sorted\""
	                }
	              }],
	              t: 13
	            }, {
	              n: ["click"],
	              t: 70,
	              f: {
	                r: ["@this"],
	                s: "[_0.set(\"sortProjectsBy\",\"bandwidth\")]"
	              }
	            }],
	            f: ["Bandwidth ", {
	              t: 7,
	              e: "img",
	              m: [{
	                n: "width",
	                f: "20",
	                t: 13,
	                g: 1
	              }, {
	                n: "height",
	                f: "20",
	                t: 13,
	                g: 1
	              }, {
	                n: "src",
	                f: [{
	                  t: 2,
	                  r: "@shared.assetsHost"
	                }, "/img/statistics/left.svg"],
	                t: 13
	              }, {
	                n: "loading",
	                f: "lazy",
	                t: 13,
	                g: 1
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              n: "class",
	              f: ["cell cell_four ", {
	                t: 2,
	                x: {
	                  r: ["dataType", "sortProjectsBy"],
	                  s: "_0!==\"trending\"&&_1===\"bandwidth\"&&\"sorted\""
	                }
	              }],
	              t: 13
	            }, {
	              n: ["click"],
	              t: 70,
	              f: {
	                r: ["@this"],
	                s: "[_0.set(\"sortProjectsBy\",\"bandwidth\")]"
	              }
	            }],
	            f: [{
	              t: 4,
	              f: ["Increased"],
	              n: 50,
	              x: {
	                r: ["dataType"],
	                s: "_0===\"trending\""
	              }
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "projects-content_table_scrollable",
	            g: 1
	          }],
	          f: [{
	            t: 4,
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "projects-content_table_row",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "cell cell_one",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "proj-index",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 2,
	                    x: {
	                      r: ["page.value", "pageLimit", "idx"],
	                      s: "(_0-1)*_1+_2+1"
	                    }
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "proj-path",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "href",
	                      f: ["/package/", {
	                        t: 2,
	                        r: "type"
	                      }, "/", {
	                        t: 2,
	                        r: "name"
	                      }],
	                      t: 13
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "span",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "proj-path_type",
	                        g: 1
	                      }],
	                      f: [{
	                        t: 2,
	                        r: "type"
	                      }, "/"]
	                    }, {
	                      t: 7,
	                      e: "span",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "proj-path_name",
	                        g: 1
	                      }],
	                      f: [{
	                        t: 2,
	                        r: "name"
	                      }]
	                    }]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    n: "class",
	                    f: ["proj-growth ", {
	                      t: 2,
	                      x: {
	                        r: ["interest"],
	                        s: "_0>=0?\"positive\":\"negative\""
	                      }
	                    }],
	                    t: 13
	                  }],
	                  f: [{
	                    t: 2,
	                    x: {
	                      r: ["_", "interest"],
	                      s: "_0.formatGrowth(_1,2)"
	                    }
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  n: "class",
	                  f: ["cell cell_two ", {
	                    t: 2,
	                    x: {
	                      r: ["sortProjectsBy"],
	                      s: "_0===\"hits\"&&\"sorted\""
	                    }
	                  }],
	                  t: 13
	                }],
	                f: [{
	                  t: 7,
	                  e: "span",
	                  f: ["Requests"]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "percentage-bar-container",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "div",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "text text-table-number",
	                      g: 1
	                    }],
	                    f: [{
	                      t: 2,
	                      x: {
	                        r: ["@this", "hits"],
	                        s: "_0.prettifyNumbersToDisplay(_1)"
	                      }
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "div",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "percentage-bar",
	                      g: 1
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "div",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "barWidth",
	                        g: 1
	                      }, {
	                        n: "style",
	                        f: ["width: ", {
	                          t: 2,
	                          r: "barWidth.hits"
	                        }],
	                        t: 13
	                      }]
	                    }]
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  n: "class",
	                  f: ["cell cell_three ", {
	                    t: 2,
	                    x: {
	                      r: ["sortProjectsBy"],
	                      s: "_0===\"bandwidth\"&&\"sorted\""
	                    }
	                  }],
	                  t: 13
	                }],
	                f: [{
	                  t: 7,
	                  e: "span",
	                  f: ["Bandwidth"]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "percentage-bar-container",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "div",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "text text-table-number",
	                      g: 1
	                    }],
	                    f: [{
	                      t: 2,
	                      x: {
	                        r: ["@this", "bandwidth"],
	                        s: "_0.prettifyNumbersToDisplay(_1)"
	                      }
	                    }, " GB"]
	                  }, " ", {
	                    t: 7,
	                    e: "div",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "percentage-bar",
	                      g: 1
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "div",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "barWidth",
	                        g: 1
	                      }, {
	                        n: "style",
	                        f: ["width: ", {
	                          t: 2,
	                          r: "barWidth.bandwidth"
	                        }],
	                        t: 13
	                      }]
	                    }]
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  n: "class",
	                  f: ["cell cell_four ", {
	                    t: 2,
	                    x: {
	                      r: ["interest"],
	                      s: "_0>=0?\"positive\":\"negative\""
	                    }
	                  }, " ", {
	                    t: 2,
	                    x: {
	                      r: ["dataType", "sortProjectsBy"],
	                      s: "_0!==\"trending\"&&_1===\"bandwidth\"&&\"sorted\""
	                    }
	                  }],
	                  t: 13
	                }],
	                f: [{
	                  t: 4,
	                  f: [{
	                    t: 2,
	                    x: {
	                      r: ["_", "interest"],
	                      s: "_0.formatGrowth(_1,2)"
	                    }
	                  }],
	                  n: 50,
	                  x: {
	                    r: ["dataType"],
	                    s: "_0===\"trending\""
	                  }
	                }]
	              }]
	            }],
	            n: 52,
	            i: "idx",
	            r: "projectsList"
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "projects-content_pagination",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "projects-content_pagination_range",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "span",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "supporting-text_alt",
	              g: 1
	            }],
	            f: ["Records"]
	          }, " ", {
	            t: 7,
	            e: "span",
	            f: [{
	              t: 2,
	              r: "pageRange"
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "projects-content_pagination_numeration",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "button",
	            m: [{
	              n: ["click"],
	              t: 70,
	              f: {
	                r: ["@this"],
	                s: "[_0.prevPage()]"
	              }
	            }, {
	              n: "class",
	              f: [{
	                t: 4,
	                f: ["disabled"],
	                n: 50,
	                x: {
	                  r: ["page.value"],
	                  s: "_0===1"
	                }
	              }],
	              t: 13
	            }],
	            f: [{
	              t: 7,
	              e: "img",
	              m: [{
	                n: "width",
	                f: "20",
	                t: 13,
	                g: 1
	              }, {
	                n: "height",
	                f: "24",
	                t: 13,
	                g: 1
	              }, {
	                n: "src",
	                f: [{
	                  t: 2,
	                  r: "@shared.assetsHost"
	                }, "/img/statistics/left.svg"],
	                t: 13
	              }, {
	                n: "loading",
	                f: "lazy",
	                t: 13,
	                g: 1
	              }]
	            }]
	          }, " ", {
	            t: 4,
	            f: [{
	              t: 7,
	              e: "button",
	              m: [{
	                n: "class",
	                f: ["page-num ", {
	                  t: 4,
	                  f: ["selected"],
	                  n: 50,
	                  x: {
	                    r: ["~/showablePages.start", "@key", "page.value"],
	                    s: "(_0+_1)===_2"
	                  }
	                }],
	                t: 13
	              }, {
	                n: ["click"],
	                t: 70,
	                f: {
	                  r: ["@this", "~/showablePages.start", "@key"],
	                  s: "[_0.set(\"page\",{value:parseInt(_1+_2)})]"
	                }
	              }],
	              f: [{
	                t: 2,
	                x: {
	                  r: ["~/showablePages.start", "@key"],
	                  s: "_0+_1"
	                }
	              }]
	            }],
	            n: 52,
	            r: "showablePages.pageCount"
	          }, " ", {
	            t: 7,
	            e: "button",
	            m: [{
	              n: ["click"],
	              t: 70,
	              f: {
	                r: ["@this"],
	                s: "[_0.nextPage()]"
	              }
	            }, {
	              n: "class",
	              f: [{
	                t: 4,
	                f: ["disabled"],
	                n: 50,
	                x: {
	                  r: ["page.value", "xTotalPages"],
	                  s: "_0===_1"
	                }
	              }],
	              t: 13
	            }],
	            f: [{
	              t: 7,
	              e: "img",
	              m: [{
	                n: "width",
	                f: "24",
	                t: 13,
	                g: 1
	              }, {
	                n: "height",
	                f: "24",
	                t: 13,
	                g: 1
	              }, {
	                n: "src",
	                f: [{
	                  t: 2,
	                  r: "@shared.assetsHost"
	                }, "/img/statistics/right.svg"],
	                t: 13
	              }, {
	                n: "loading",
	                f: "lazy",
	                t: 13,
	                g: 1
	              }]
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "projects-content_pagination_ctrls",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "button",
	            m: [{
	              n: "class",
	              f: ["projects-content_pagination_ctrls_btn projects-content_pagination_ctrls_btn-prev ", {
	                t: 4,
	                f: ["disabled"],
	                n: 50,
	                x: {
	                  r: ["page.value"],
	                  s: "_0===1"
	                }
	              }],
	              t: 13
	            }, {
	              n: ["click"],
	              t: 70,
	              f: {
	                r: ["@this"],
	                s: "[_0.prevPage()]"
	              }
	            }],
	            f: [{
	              t: 7,
	              e: "img",
	              m: [{
	                n: "width",
	                f: "20",
	                t: 13,
	                g: 1
	              }, {
	                n: "height",
	                f: "20",
	                t: 13,
	                g: 1
	              }, {
	                n: "src",
	                f: [{
	                  t: 2,
	                  r: "@shared.assetsHost"
	                }, "/img/statistics/left.svg"],
	                t: 13
	              }, {
	                n: "loading",
	                f: "lazy",
	                t: 13,
	                g: 1
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "projects-content_pagination_ctrls_limit",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "supporting-text",
	                g: 1
	              }],
	              f: ["Page:"]
	            }, " ", {
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "supporting-text_alt",
	                g: 1
	              }],
	              f: ["Show:"]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "btn-group",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "button",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "btn dropdown-toggle",
	                  g: 1
	                }, {
	                  n: "type",
	                  f: "button",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "data-toggle",
	                  f: "dropdown",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "aria-haspopup",
	                  f: "true",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "aria-expanded",
	                  f: "false",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "span",
	                  f: [{
	                    t: 2,
	                    r: "pageLimit"
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: "width",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/statistics/left.svg"],
	                    t: 13
	                  }, {
	                    n: "loading",
	                    f: "lazy",
	                    t: 13,
	                    g: 1
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "ul",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "dropdown-menu",
	                  g: 1
	                }],
	                f: [{
	                  t: 4,
	                  f: [{
	                    t: 7,
	                    e: "li",
	                    f: [{
	                      t: 7,
	                      e: "a",
	                      m: [{
	                        n: ["click"],
	                        t: 70,
	                        f: {
	                          r: ["@this", "."],
	                          s: "[_0.set(\"pageLimit\",_1)]"
	                        }
	                      }],
	                      f: [{
	                        t: 2,
	                        r: "."
	                      }]
	                    }]
	                  }],
	                  n: 52,
	                  r: "paginationLimits"
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "supporting-text_alt",
	                g: 1
	              }],
	              f: ["per page"]
	            }]
	          }, " ", {
	            t: 7,
	            e: "button",
	            m: [{
	              n: "class",
	              f: ["projects-content_pagination_ctrls_btn projects-content_pagination_ctrls_btn-next ", {
	                t: 4,
	                f: ["disabled"],
	                n: 50,
	                x: {
	                  r: ["page.value", "xTotalPages"],
	                  s: "_0===_1"
	                }
	              }],
	              t: 13
	            }, {
	              n: ["click"],
	              t: 70,
	              f: {
	                r: ["@this"],
	                s: "[_0.nextPage()]"
	              }
	            }],
	            f: [{
	              t: 7,
	              e: "img",
	              m: [{
	                n: "width",
	                f: "20",
	                t: 13,
	                g: 1
	              }, {
	                n: "height",
	                f: "20",
	                t: 13,
	                g: 1
	              }, {
	                n: "src",
	                f: [{
	                  t: 2,
	                  r: "@shared.assetsHost"
	                }, "/img/statistics/right.svg"],
	                t: 13
	              }, {
	                n: "loading",
	                f: "lazy",
	                t: 13,
	                g: 1
	              }]
	            }]
	          }]
	        }]
	      }]
	    }]
	  }],
	  e: {
	    "[_0.set(\"statsType\",_1)]": function (_0, _1) {
	      return [_0.set("statsType", _1)];
	    },
	    "_0===\"hits\"&&\"selected\"": function (_0) {
	      return _0 === "hits" && "selected";
	    },
	    "[_0.set(\"sortProjectsBy\",\"hits\")]": function (_0) {
	      return [_0.set("sortProjectsBy", "hits")];
	    },
	    "_0===\"bandwidth\"&&\"selected\"": function (_0) {
	      return _0 === "bandwidth" && "selected";
	    },
	    "[_0.set(\"sortProjectsBy\",\"bandwidth\")]": function (_0) {
	      return [_0.set("sortProjectsBy", "bandwidth")];
	    },
	    "_0===\"hits\"&&\"sorted\"": function (_0) {
	      return _0 === "hits" && "sorted";
	    },
	    "_0===\"bandwidth\"&&\"sorted\"": function (_0) {
	      return _0 === "bandwidth" && "sorted";
	    },
	    "_0!==\"trending\"&&_1===\"bandwidth\"&&\"sorted\"": function (_0, _1) {
	      return _0 !== "trending" && _1 === "bandwidth" && "sorted";
	    },
	    "_0===\"trending\"": function (_0) {
	      return _0 === "trending";
	    },
	    "(_0-1)*_1+_2+1": function (_0, _1, _2) {
	      return (_0 - 1) * _1 + _2 + 1;
	    },
	    "_0>=0?\"positive\":\"negative\"": function (_0) {
	      return _0 >= 0 ? "positive" : "negative";
	    },
	    "_0.formatGrowth(_1,2)": function (_0, _1) {
	      return _0.formatGrowth(_1, 2);
	    },
	    "_0.prettifyNumbersToDisplay(_1)": function (_0, _1) {
	      return _0.prettifyNumbersToDisplay(_1);
	    },
	    "[_0.prevPage()]": function (_0) {
	      return [_0.prevPage()];
	    },
	    "_0===1": function (_0) {
	      return _0 === 1;
	    },
	    "(_0+_1)===_2": function (_0, _1, _2) {
	      return _0 + _1 === _2;
	    },
	    "[_0.set(\"page\",{value:parseInt(_1+_2)})]": function (_0, _1, _2) {
	      return [_0.set("page", {
	        value: parseInt(_1 + _2)
	      })];
	    },
	    "_0+_1": function (_0, _1) {
	      return _0 + _1;
	    },
	    "[_0.nextPage()]": function (_0) {
	      return [_0.nextPage()];
	    },
	    "_0===_1": function (_0, _1) {
	      return _0 === _1;
	    },
	    "[_0.set(\"pageLimit\",_1)]": function (_0, _1) {
	      return [_0.set("pageLimit", _1)];
	    }
	  }
	};
	var statisticsProjectTable = ractive__default["default"].extend(component$n.exports);

	var countries$1 = [
		{
			code: "AD",
			name: "Andorra"
		},
		{
			code: "AE",
			name: "United Arab Emirates"
		},
		{
			code: "AF",
			name: "Afghanistan"
		},
		{
			code: "AG",
			name: "Antigua and Barbuda"
		},
		{
			code: "AI",
			name: "Anguilla"
		},
		{
			code: "AL",
			name: "Albania"
		},
		{
			code: "AM",
			name: "Armenia"
		},
		{
			code: "AO",
			name: "Angola"
		},
		{
			code: "AQ",
			name: "Antarctica"
		},
		{
			code: "AR",
			name: "Argentina"
		},
		{
			code: "AS",
			name: "American Samoa"
		},
		{
			code: "AT",
			name: "Austria"
		},
		{
			code: "AU",
			name: "Australia"
		},
		{
			code: "AW",
			name: "Aruba"
		},
		{
			code: "AX",
			name: "Åland"
		},
		{
			code: "AZ",
			name: "Azerbaijan"
		},
		{
			code: "BA",
			name: "Bosnia and Herzegovina"
		},
		{
			code: "BB",
			name: "Barbados"
		},
		{
			code: "BD",
			name: "Bangladesh"
		},
		{
			code: "BE",
			name: "Belgium"
		},
		{
			code: "BF",
			name: "Burkina Faso"
		},
		{
			code: "BG",
			name: "Bulgaria"
		},
		{
			code: "BH",
			name: "Bahrain"
		},
		{
			code: "BI",
			name: "Burundi"
		},
		{
			code: "BJ",
			name: "Benin"
		},
		{
			code: "BL",
			name: "Saint Barthélemy"
		},
		{
			code: "BM",
			name: "Bermuda"
		},
		{
			code: "BN",
			name: "Brunei"
		},
		{
			code: "BO",
			name: "Bolivia"
		},
		{
			code: "BQ",
			name: "Bonaire"
		},
		{
			code: "BR",
			name: "Brazil"
		},
		{
			code: "BS",
			name: "Bahamas"
		},
		{
			code: "BT",
			name: "Bhutan"
		},
		{
			code: "BV",
			name: "Bouvet Island"
		},
		{
			code: "BW",
			name: "Botswana"
		},
		{
			code: "BY",
			name: "Belarus"
		},
		{
			code: "BZ",
			name: "Belize"
		},
		{
			code: "CA",
			name: "Canada"
		},
		{
			code: "CC",
			name: "Cocos [Keeling] Islands"
		},
		{
			code: "CD",
			name: "Democratic Republic of the Congo"
		},
		{
			code: "CF",
			name: "Central African Republic"
		},
		{
			code: "CG",
			name: "Republic of the Congo"
		},
		{
			code: "CH",
			name: "Switzerland"
		},
		{
			code: "CI",
			name: "Ivory Coast"
		},
		{
			code: "CK",
			name: "Cook Islands"
		},
		{
			code: "CL",
			name: "Chile"
		},
		{
			code: "CM",
			name: "Cameroon"
		},
		{
			code: "CN",
			name: "China"
		},
		{
			code: "CO",
			name: "Colombia"
		},
		{
			code: "CR",
			name: "Costa Rica"
		},
		{
			code: "CU",
			name: "Cuba"
		},
		{
			code: "CV",
			name: "Cape Verde"
		},
		{
			code: "CW",
			name: "Curacao"
		},
		{
			code: "CX",
			name: "Christmas Island"
		},
		{
			code: "CY",
			name: "Cyprus"
		},
		{
			code: "CZ",
			name: "Czech Republic"
		},
		{
			code: "DE",
			name: "Germany"
		},
		{
			code: "DJ",
			name: "Djibouti"
		},
		{
			code: "DK",
			name: "Denmark"
		},
		{
			code: "DM",
			name: "Dominica"
		},
		{
			code: "DO",
			name: "Dominican Republic"
		},
		{
			code: "DZ",
			name: "Algeria"
		},
		{
			code: "EC",
			name: "Ecuador"
		},
		{
			code: "EE",
			name: "Estonia"
		},
		{
			code: "EG",
			name: "Egypt"
		},
		{
			code: "EH",
			name: "Western Sahara"
		},
		{
			code: "ER",
			name: "Eritrea"
		},
		{
			code: "ES",
			name: "Spain"
		},
		{
			code: "ET",
			name: "Ethiopia"
		},
		{
			code: "FI",
			name: "Finland"
		},
		{
			code: "FJ",
			name: "Fiji"
		},
		{
			code: "FK",
			name: "Falkland Islands"
		},
		{
			code: "FM",
			name: "Micronesia"
		},
		{
			code: "FO",
			name: "Faroe Islands"
		},
		{
			code: "FR",
			name: "France"
		},
		{
			code: "GA",
			name: "Gabon"
		},
		{
			code: "GB",
			name: "United Kingdom"
		},
		{
			code: "GD",
			name: "Grenada"
		},
		{
			code: "GE",
			name: "Georgia"
		},
		{
			code: "GF",
			name: "French Guiana"
		},
		{
			code: "GG",
			name: "Guernsey"
		},
		{
			code: "GH",
			name: "Ghana"
		},
		{
			code: "GI",
			name: "Gibraltar"
		},
		{
			code: "GL",
			name: "Greenland"
		},
		{
			code: "GM",
			name: "Gambia"
		},
		{
			code: "GN",
			name: "Guinea"
		},
		{
			code: "GP",
			name: "Guadeloupe"
		},
		{
			code: "GQ",
			name: "Equatorial Guinea"
		},
		{
			code: "GR",
			name: "Greece"
		},
		{
			code: "GS",
			name: "South Georgia and the South Sandwich Islands"
		},
		{
			code: "GT",
			name: "Guatemala"
		},
		{
			code: "GU",
			name: "Guam"
		},
		{
			code: "GW",
			name: "Guinea-Bissau"
		},
		{
			code: "GY",
			name: "Guyana"
		},
		{
			code: "HK",
			name: "Hong Kong"
		},
		{
			code: "HM",
			name: "Heard Island and McDonald Islands"
		},
		{
			code: "HN",
			name: "Honduras"
		},
		{
			code: "HR",
			name: "Croatia"
		},
		{
			code: "HT",
			name: "Haiti"
		},
		{
			code: "HU",
			name: "Hungary"
		},
		{
			code: "ID",
			name: "Indonesia"
		},
		{
			code: "IE",
			name: "Ireland"
		},
		{
			code: "IL",
			name: "Israel"
		},
		{
			code: "IM",
			name: "Isle of Man"
		},
		{
			code: "IN",
			name: "India"
		},
		{
			code: "IO",
			name: "British Indian Ocean Territory"
		},
		{
			code: "IQ",
			name: "Iraq"
		},
		{
			code: "IR",
			name: "Iran"
		},
		{
			code: "IS",
			name: "Iceland"
		},
		{
			code: "IT",
			name: "Italy"
		},
		{
			code: "JE",
			name: "Jersey"
		},
		{
			code: "JM",
			name: "Jamaica"
		},
		{
			code: "JO",
			name: "Jordan"
		},
		{
			code: "JP",
			name: "Japan"
		},
		{
			code: "KE",
			name: "Kenya"
		},
		{
			code: "KG",
			name: "Kyrgyzstan"
		},
		{
			code: "KH",
			name: "Cambodia"
		},
		{
			code: "KI",
			name: "Kiribati"
		},
		{
			code: "KM",
			name: "Comoros"
		},
		{
			code: "KN",
			name: "Saint Kitts and Nevis"
		},
		{
			code: "KP",
			name: "North Korea"
		},
		{
			code: "KR",
			name: "South Korea"
		},
		{
			code: "KW",
			name: "Kuwait"
		},
		{
			code: "KY",
			name: "Cayman Islands"
		},
		{
			code: "KZ",
			name: "Kazakhstan"
		},
		{
			code: "LA",
			name: "Laos"
		},
		{
			code: "LB",
			name: "Lebanon"
		},
		{
			code: "LC",
			name: "Saint Lucia"
		},
		{
			code: "LI",
			name: "Liechtenstein"
		},
		{
			code: "LK",
			name: "Sri Lanka"
		},
		{
			code: "LR",
			name: "Liberia"
		},
		{
			code: "LS",
			name: "Lesotho"
		},
		{
			code: "LT",
			name: "Lithuania"
		},
		{
			code: "LU",
			name: "Luxembourg"
		},
		{
			code: "LV",
			name: "Latvia"
		},
		{
			code: "LY",
			name: "Libya"
		},
		{
			code: "MA",
			name: "Morocco"
		},
		{
			code: "MC",
			name: "Monaco"
		},
		{
			code: "MD",
			name: "Moldova"
		},
		{
			code: "ME",
			name: "Montenegro"
		},
		{
			code: "MF",
			name: "Saint Martin"
		},
		{
			code: "MG",
			name: "Madagascar"
		},
		{
			code: "MH",
			name: "Marshall Islands"
		},
		{
			code: "MK",
			name: "North Macedonia"
		},
		{
			code: "ML",
			name: "Mali"
		},
		{
			code: "MM",
			name: "Myanmar [Burma]"
		},
		{
			code: "MN",
			name: "Mongolia"
		},
		{
			code: "MO",
			name: "Macao"
		},
		{
			code: "MP",
			name: "Northern Mariana Islands"
		},
		{
			code: "MQ",
			name: "Martinique"
		},
		{
			code: "MR",
			name: "Mauritania"
		},
		{
			code: "MS",
			name: "Montserrat"
		},
		{
			code: "MT",
			name: "Malta"
		},
		{
			code: "MU",
			name: "Mauritius"
		},
		{
			code: "MV",
			name: "Maldives"
		},
		{
			code: "MW",
			name: "Malawi"
		},
		{
			code: "MX",
			name: "Mexico"
		},
		{
			code: "MY",
			name: "Malaysia"
		},
		{
			code: "MZ",
			name: "Mozambique"
		},
		{
			code: "NA",
			name: "Namibia"
		},
		{
			code: "NC",
			name: "New Caledonia"
		},
		{
			code: "NE",
			name: "Niger"
		},
		{
			code: "NF",
			name: "Norfolk Island"
		},
		{
			code: "NG",
			name: "Nigeria"
		},
		{
			code: "NI",
			name: "Nicaragua"
		},
		{
			code: "NL",
			name: "Netherlands"
		},
		{
			code: "NO",
			name: "Norway"
		},
		{
			code: "NP",
			name: "Nepal"
		},
		{
			code: "NR",
			name: "Nauru"
		},
		{
			code: "NU",
			name: "Niue"
		},
		{
			code: "NZ",
			name: "New Zealand"
		},
		{
			code: "OM",
			name: "Oman"
		},
		{
			code: "PA",
			name: "Panama"
		},
		{
			code: "PE",
			name: "Peru"
		},
		{
			code: "PF",
			name: "French Polynesia"
		},
		{
			code: "PG",
			name: "Papua New Guinea"
		},
		{
			code: "PH",
			name: "Philippines"
		},
		{
			code: "PK",
			name: "Pakistan"
		},
		{
			code: "PL",
			name: "Poland"
		},
		{
			code: "PM",
			name: "Saint Pierre and Miquelon"
		},
		{
			code: "PN",
			name: "Pitcairn Islands"
		},
		{
			code: "PR",
			name: "Puerto Rico"
		},
		{
			code: "PS",
			name: "Palestine"
		},
		{
			code: "PT",
			name: "Portugal"
		},
		{
			code: "PW",
			name: "Palau"
		},
		{
			code: "PY",
			name: "Paraguay"
		},
		{
			code: "QA",
			name: "Qatar"
		},
		{
			code: "RE",
			name: "Réunion"
		},
		{
			code: "RO",
			name: "Romania"
		},
		{
			code: "RS",
			name: "Serbia"
		},
		{
			code: "RU",
			name: "Russia"
		},
		{
			code: "RW",
			name: "Rwanda"
		},
		{
			code: "SA",
			name: "Saudi Arabia"
		},
		{
			code: "SB",
			name: "Solomon Islands"
		},
		{
			code: "SC",
			name: "Seychelles"
		},
		{
			code: "SD",
			name: "Sudan"
		},
		{
			code: "SE",
			name: "Sweden"
		},
		{
			code: "SG",
			name: "Singapore"
		},
		{
			code: "SH",
			name: "Saint Helena"
		},
		{
			code: "SI",
			name: "Slovenia"
		},
		{
			code: "SJ",
			name: "Svalbard and Jan Mayen"
		},
		{
			code: "SK",
			name: "Slovakia"
		},
		{
			code: "SL",
			name: "Sierra Leone"
		},
		{
			code: "SM",
			name: "San Marino"
		},
		{
			code: "SN",
			name: "Senegal"
		},
		{
			code: "SO",
			name: "Somalia"
		},
		{
			code: "SR",
			name: "Suriname"
		},
		{
			code: "SS",
			name: "South Sudan"
		},
		{
			code: "ST",
			name: "São Tomé and Príncipe"
		},
		{
			code: "SV",
			name: "El Salvador"
		},
		{
			code: "SX",
			name: "Sint Maarten"
		},
		{
			code: "SY",
			name: "Syria"
		},
		{
			code: "SZ",
			name: "Swaziland"
		},
		{
			code: "TC",
			name: "Turks and Caicos Islands"
		},
		{
			code: "TD",
			name: "Chad"
		},
		{
			code: "TF",
			name: "French Southern Territories"
		},
		{
			code: "TG",
			name: "Togo"
		},
		{
			code: "TH",
			name: "Thailand"
		},
		{
			code: "TJ",
			name: "Tajikistan"
		},
		{
			code: "TK",
			name: "Tokelau"
		},
		{
			code: "TL",
			name: "East Timor"
		},
		{
			code: "TM",
			name: "Turkmenistan"
		},
		{
			code: "TN",
			name: "Tunisia"
		},
		{
			code: "TO",
			name: "Tonga"
		},
		{
			code: "TR",
			name: "Turkey"
		},
		{
			code: "TT",
			name: "Trinidad and Tobago"
		},
		{
			code: "TV",
			name: "Tuvalu"
		},
		{
			code: "TW",
			name: "Taiwan"
		},
		{
			code: "TZ",
			name: "Tanzania"
		},
		{
			code: "UA",
			name: "Ukraine"
		},
		{
			code: "UG",
			name: "Uganda"
		},
		{
			code: "UM",
			name: "U.S. Minor Outlying Islands"
		},
		{
			code: "US",
			name: "United States"
		},
		{
			code: "UY",
			name: "Uruguay"
		},
		{
			code: "UZ",
			name: "Uzbekistan"
		},
		{
			code: "VA",
			name: "Vatican City"
		},
		{
			code: "VC",
			name: "Saint Vincent and the Grenadines"
		},
		{
			code: "VE",
			name: "Venezuela"
		},
		{
			code: "VG",
			name: "British Virgin Islands"
		},
		{
			code: "VI",
			name: "U.S. Virgin Islands"
		},
		{
			code: "VN",
			name: "Vietnam"
		},
		{
			code: "VU",
			name: "Vanuatu"
		},
		{
			code: "WF",
			name: "Wallis and Futuna"
		},
		{
			code: "WS",
			name: "Samoa"
		},
		{
			code: "XK",
			name: "Kosovo"
		},
		{
			code: "YE",
			name: "Yemen"
		},
		{
			code: "YT",
			name: "Mayotte"
		},
		{
			code: "ZA",
			name: "South Africa"
		},
		{
			code: "ZM",
			name: "Zambia"
		},
		{
			code: "ZW",
			name: "Zimbabwe"
		}
	];

	var countries$2 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		'default': countries$1
	});

	var countries = getCjsExportFromNamespace(countries$2);

	var component$m = {
	  exports: {}
	};
	component$m.exports = {
	  computed: {
	    pageRange() {
	      let page = this.get('page');
	      let pageLimit = this.get('pageLimit');
	      let xTotalCount = this.get('xTotalCount');
	      let xTotalPages = this.get('xTotalPages');
	      let start = (page.value - 1) * pageLimit + 1;
	      let end = start + pageLimit - 1;
	      if (xTotalCount < end) {
	        end = xTotalCount;
	      }
	      return xTotalPages && xTotalCount ? `Records ${start} - ${end} of ${xTotalCount}` : 'Records 0 of 0';
	    }
	  },
	  decorators: {
	    tooltip
	  },
	  data() {
	    return {
	      _,
	      topList: null,
	      isVersionGrouped: true,
	      selectedItem: '',
	      breakdown: 'countries',
	      breakdownIdx: 0,
	      breakdownList: [],
	      page: {
	        value: 1
	      },
	      pageLimit: 10,
	      paginationLimits: [10, 20, 50, 100],
	      xTotalCount: 0,
	      xTotalPages: 0,
	      periods: stats.periods
	    };
	  },
	  oninit() {
	    if (!ractive__default["default"].isServer) {
	      this.observe('tableDataType selectedItem country continent isVersionGrouped', () => {
	        let tableDataType = this.get('tableDataType');
	        let location = this.get('country') || this.get('continent');
	        let isVersionGrouped = this.get('isVersionGrouped');
	        let breakdownList = [{
	          value: 'countries',
	          name: 'Country',
	          disabled: location || false
	        }, {
	          value: tableDataType === 'platform' ? 'browsers' : 'platforms',
	          name: tableDataType === 'platform' ? 'Browser' : 'Platform',
	          disabled: !isVersionGrouped
	        }, {
	          value: 'versions',
	          name: 'Version',
	          disabled: !isVersionGrouped
	        }];
	        this.set('breakdownList', breakdownList);
	      });
	      this.observe('country continent selectedItem', () => {
	        let location = this.get('country') || this.get('continent');
	        let isVersionGrouped = this.get('isVersionGrouped');
	        let selectedItem = this.get('selectedItem');
	        if (location && !isVersionGrouped) {
	          this.set('selectedItem', '');
	        }
	        if (location && isVersionGrouped && selectedItem) {
	          this.set('breakdownIdx', 1);
	        }
	      });
	      this.observe('breakdownIdx', breakdownIdx => {
	        let breakdownList = this.get('breakdownList');
	        let {
	          value,
	          disabled
	        } = breakdownList[breakdownIdx];
	        if (!disabled) {
	          this.set('breakdown', value);
	        }
	      });
	      this.observe('isVersionGrouped selectedItem breakdown period country continent pageLimit', () => {
	        this.set('page', {
	          value: 1
	        });
	      }, {
	        init: false
	      });

	      // fetch platform/browser data
	      this.observe('page __ready', () => {
	        if (this.get('__ready')) {
	          let tableDataType = this.get('tableDataType');
	          let isVersionGrouped = this.get('isVersionGrouped');
	          let selectedItem = this.get('selectedItem');
	          let breakdown = this.get('breakdown');
	          let period = this.get('period');
	          let country = this.get('country');
	          let continent = this.get('continent');
	          let pageLimit = this.get('pageLimit');
	          let page = this.get('page');
	          let sharedAssetsHost = this.get('@shared.assetsHost');
	          let baseUrl = `${sharedAssetsHost}/img/statistics`;
	          http.fetchTopPlatformBrowserStats(tableDataType, isVersionGrouped, period, selectedItem, breakdown, country, continent, page.value, pageLimit).then(({
	            response,
	            responseHeaders
	          }) => {
	            let topList = response.map((one, index) => {
	              let result = {
	                index,
	                name: one.name,
	                version: one.version,
	                share: one.share,
	                displayName: ''
	              };
	              Object.keys(one).forEach(key => {
	                if (key === 'share' || key === 'prev' || key === 'links') {
	                  return;
	                }

	                // set name
	                if (key === 'country') {
	                  let country = countries.find(country => country.code === one[key]);
	                  result.displayName += country?.name + ' ';
	                } else if (key === 'versionName') {
	                  result.displayName += one[key] ? `(${one[key]}) ` : '';
	                } else {
	                  result.displayName += one[key] + ' ';
	                }

	                // set icon
	                if (selectedItem) {
	                  switch (breakdown) {
	                    case 'platforms':
	                      result.icon = `${baseUrl}/platforms/${one[key]}@2x.png`;
	                      break;
	                    case 'versions':
	                      result.icon = tableDataType === 'platform' ? `${baseUrl}/platforms/${selectedItem.name}@2x.png` : `${baseUrl}/browsers/${selectedItem.name}@2x.png`;
	                      break;
	                    case 'countries':
	                      result.icon = `https://cdn.jsdelivr.net/npm/country-flag-icons@1.5.5/3x2/${one[key]}.svg`;
	                      break;
	                  }
	                } else {
	                  if (key === 'name') {
	                    result.icon = tableDataType === 'platform' ? `${baseUrl}/platforms/${one[key]}@2x.png` : `${baseUrl}/browsers/${one[key]}@2x.png`;
	                  }
	                }
	              });
	              result.displayName = result.displayName.trim();
	              result.changes = _.calculateGrowth(one.share, one.prev.share);
	              return result;
	            });
	            this.set('xTotalCount', parseInt(responseHeaders['x-total-count']));
	            this.set('xTotalPages', parseInt(responseHeaders['x-total-pages']));
	            this.animate('topList', topList);
	          });
	        }
	      });
	    }
	  },
	  prevPage() {
	    let topList = this.get('topList');
	    if (!topList || !topList.length) {
	      return;
	    }
	    let page = this.get('page');
	    let value = page.value > 1 ? page.value - 1 : page.value;
	    this.set('page', {
	      value
	    });
	  },
	  nextPage() {
	    let topList = this.get('topList');
	    if (!topList || !topList.length) {
	      return;
	    }
	    let page = this.get('page');
	    let xTotalPages = this.get('xTotalPages');
	    let value = page.value + 1 > xTotalPages ? page.value : page.value + 1;
	    this.set('page', {
	      value
	    });
	  },
	  handleBreakdownSelect(idx, isDisabled) {
	    if (isDisabled) {
	      return;
	    }
	    this.set('breakdownIdx', idx);
	  },
	  handleIconBrokenSrc(e) {
	    let sharedAssetsHost = this.get('@shared.assetsHost');
	    let dataTypeIconsDir = this.get('tableDataType') === 'platform' ? 'platforms' : 'browsers';
	    let defaultIconName = 'Other@2x.png';
	    e.event.target.src = `${sharedAssetsHost}/img/statistics/${dataTypeIconsDir}/${defaultIconName}`;
	  }
	};
	component$m.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      t: 13,
	      n: "class",
	      f: "c-top-platform-browser",
	      g: 1
	    }],
	    f: [{
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "table-info",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "h3",
	        f: ["Top ", {
	          t: 2,
	          r: "tableDataType"
	        }, "s"]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "switch-block",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "label",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "switch",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "input",
	            m: [{
	              n: "type",
	              f: "checkbox",
	              t: 13
	            }, {
	              n: ["click"],
	              t: 70,
	              f: {
	                r: ["@this", "isVersionGrouped"],
	                s: "[_0.set(\"isVersionGrouped\",!_1)]"
	              }
	            }, {
	              n: "disabled",
	              f: [{
	                t: 2,
	                x: {
	                  r: ["selectedItem", "topList", "topList.length"],
	                  s: "_0||(!_1||!_2)"
	                }
	              }],
	              t: 13
	            }, {
	              n: "checked",
	              f: 0,
	              t: 13
	            }]
	          }, " ", {
	            t: 7,
	            e: "span",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "slider round",
	              g: 1
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "span",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "name",
	            g: 1
	          }],
	          f: ["Group ", {
	            t: 2,
	            r: "tableDataType"
	          }, " versions"]
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "table-wrapper",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "table-wrapper_chosen-platform",
	          g: 1
	        }],
	        f: [{
	          t: 4,
	          f: [{
	            t: 7,
	            e: "img",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "table-wrapper_chosen-platform_choose-icon",
	              g: 1
	            }, {
	              n: "width",
	              f: "20",
	              t: 13,
	              g: 1
	            }, {
	              n: "height",
	              f: "20",
	              t: 13,
	              g: 1
	            }, {
	              n: "src",
	              f: [{
	                t: 2,
	                r: "@shared.assetsHost"
	              }, "/img/statistics/information.svg"],
	              t: 13
	            }, {
	              n: "loading",
	              f: "lazy",
	              t: 13,
	              g: 1
	            }]
	          }, " ", {
	            t: 7,
	            e: "span",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "table-wrapper_chosen-platform_choose-msg",
	              g: 1
	            }],
	            f: ["Choose ", {
	              t: 2,
	              r: "tableDataType"
	            }, " below to check more data"]
	          }],
	          n: 50,
	          x: {
	            r: ["selectedItem"],
	            s: "!_0"
	          }
	        }, {
	          t: 4,
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "table-wrapper_chosen-platform_selected",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "chosen-name",
	                g: 1
	              }, {
	                n: ["click"],
	                t: 70,
	                f: {
	                  r: ["@this"],
	                  s: "[_0.set(\"selectedItem\",\"\")]"
	                }
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/statistics/left.svg"],
	                  t: 13
	                }, {
	                  n: "loading",
	                  f: "lazy",
	                  t: 13,
	                  g: 1
	                }]
	              }, " ", {
	                t: 4,
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "icon",
	                    g: 1
	                  }, {
	                    n: "width",
	                    f: "24",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "24",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "selectedItem.icon"
	                    }],
	                    t: 13
	                  }, {
	                    n: "loading",
	                    f: "lazy",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: ["error"],
	                    t: 70,
	                    f: {
	                      r: ["@this", "event"],
	                      s: "[_0.handleIconBrokenSrc(_1)]"
	                    }
	                  }]
	                }],
	                n: 50,
	                r: "selectedItem.icon"
	              }, " ", {
	                t: 7,
	                e: "span",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "chosen-name_platform-name",
	                  g: 1
	                }],
	                f: [{
	                  t: 2,
	                  r: "selectedItem.displayName"
	                }]
	              }, "   ", {
	                t: 7,
	                e: "span",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "chosen-name_platform-share",
	                  g: 1
	                }],
	                f: ["(", {
	                  t: 2,
	                  r: "selectedItem.share"
	                }, "%", {
	                  t: 7,
	                  e: "span",
	                  f: [" globally"]
	                }, ")"]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "btn-group",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "button",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "btn dropdown-toggle",
	                  g: 1
	                }, {
	                  n: "type",
	                  f: "button",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "data-toggle",
	                  f: "dropdown",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "aria-haspopup",
	                  f: "true",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "aria-expanded",
	                  f: "false",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "breakdown",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 2,
	                    rx: {
	                      r: "breakdownList",
	                      m: [{
	                        t: 30,
	                        n: "breakdownIdx"
	                      }, "name"]
	                    }
	                  }, " ", {
	                    t: 7,
	                    e: "span",
	                    f: [" breakdown"]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: "width",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/statistics/left.svg"],
	                    t: 13
	                  }, {
	                    n: "loading",
	                    f: "lazy",
	                    t: 13,
	                    g: 1
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "ul",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "dropdown-menu",
	                  g: 1
	                }],
	                f: [{
	                  t: 4,
	                  f: [{
	                    t: 7,
	                    e: "li",
	                    f: [{
	                      t: 7,
	                      e: "a",
	                      m: [{
	                        n: ["click"],
	                        t: 70,
	                        f: {
	                          r: ["@this", "idx", "breakdownList"],
	                          s: "[_0.handleBreakdownSelect(_1,_2[_1].disabled)]"
	                        }
	                      }, {
	                        n: "class",
	                        f: [{
	                          t: 4,
	                          f: ["disabled"],
	                          n: 50,
	                          rx: {
	                            r: "breakdownList",
	                            m: [{
	                              t: 30,
	                              n: "idx"
	                            }, "disabled"]
	                          }
	                        }],
	                        t: 13
	                      }],
	                      f: [{
	                        t: 2,
	                        rx: {
	                          r: "breakdownList",
	                          m: [{
	                            t: 30,
	                            n: "idx"
	                          }, "name"]
	                        }
	                      }, " ", {
	                        t: 7,
	                        e: "span",
	                        f: [" breakdown"]
	                      }]
	                    }]
	                  }],
	                  n: 52,
	                  i: "idx",
	                  r: "breakdownList"
	                }]
	              }]
	            }]
	          }],
	          n: 51,
	          l: 1
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "table-wrapper_content",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "table-wrapper_content_header",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "cell cell_one",
	              g: 1
	            }],
	            f: ["Name"]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "cell cell_two",
	              g: 1
	            }],
	            f: ["Market share"]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "cell cell_three",
	              g: 1
	            }],
	            f: ["Change ", {
	              t: 7,
	              e: "img",
	              m: [{
	                n: "width",
	                f: "16",
	                t: 13,
	                g: 1
	              }, {
	                n: "height",
	                f: "16",
	                t: 13,
	                g: 1
	              }, {
	                n: "tooltip",
	                t: 71,
	                f: {
	                  r: ["period", "periods"],
	                  s: "[\"Compared to the previous \"+_1[_0]+\"-day period\",\"top\"]"
	                }
	              }, {
	                n: "src",
	                f: [{
	                  t: 2,
	                  r: "@shared.assetsHost"
	                }, "/img/statistics/information.svg"],
	                t: 13
	              }, {
	                n: "loading",
	                f: "lazy",
	                t: 13,
	                g: 1
	              }]
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "table-wrapper_content_scrollable",
	            g: 1
	          }],
	          f: [{
	            t: 4,
	            f: [{
	              t: 4,
	              f: [{
	                t: 4,
	                f: [{
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "table-wrapper_content_row",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "div",
	                    m: [{
	                      n: "class",
	                      f: ["cell cell_one ", {
	                        t: 4,
	                        f: ["cell_one_active"],
	                        n: 51,
	                        r: "selectedItem"
	                      }],
	                      t: 13
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "span",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "platform-index",
	                        g: 1
	                      }],
	                      f: [{
	                        t: 2,
	                        x: {
	                          r: ["page.value", "pageLimit", "idx"],
	                          s: "(_0-1)*_1+_2+1"
	                        }
	                      }]
	                    }, " ", {
	                      t: 4,
	                      f: [{
	                        t: 7,
	                        e: "img",
	                        m: [{
	                          n: "class",
	                          f: ["platform-icon ", {
	                            t: 4,
	                            f: ["breakdown-", {
	                              t: 2,
	                              r: "breakdown"
	                            }],
	                            n: 50,
	                            r: "selectedItem"
	                          }],
	                          t: 13
	                        }, {
	                          n: "width",
	                          f: "24",
	                          t: 13,
	                          g: 1
	                        }, {
	                          n: "src",
	                          f: [{
	                            t: 2,
	                            r: "icon"
	                          }],
	                          t: 13
	                        }, {
	                          n: ["error"],
	                          t: 70,
	                          f: {
	                            r: ["@this", "event"],
	                            s: "[_0.handleIconBrokenSrc(_1)]"
	                          }
	                        }]
	                      }],
	                      n: 50,
	                      r: "icon"
	                    }, " ", {
	                      t: 4,
	                      f: [{
	                        t: 7,
	                        e: "span",
	                        m: [{
	                          t: 13,
	                          n: "class",
	                          f: "platform-name",
	                          g: 1
	                        }, {
	                          n: ["click"],
	                          t: 70,
	                          f: {
	                            r: ["@this", "idx", "topList"],
	                            s: "[_0.set(\"selectedItem\",_2[_1])]"
	                          }
	                        }],
	                        f: [{
	                          t: 2,
	                          r: "displayName"
	                        }]
	                      }],
	                      n: 50,
	                      x: {
	                        r: ["selectedItem"],
	                        s: "!_0"
	                      }
	                    }, {
	                      t: 4,
	                      f: [{
	                        t: 7,
	                        e: "span",
	                        m: [{
	                          t: 13,
	                          n: "class",
	                          f: "platform-name",
	                          g: 1
	                        }],
	                        f: [{
	                          t: 2,
	                          r: "displayName"
	                        }]
	                      }],
	                      n: 51,
	                      l: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "div",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "cell cell_two text-table-number",
	                      g: 1
	                    }],
	                    f: [{
	                      t: 2,
	                      x: {
	                        r: ["_", "share"],
	                        s: "_0.formatShare(_1,2)"
	                      }
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "div",
	                    m: [{
	                      n: "class",
	                      f: ["cell cell_three text-table-number ", {
	                        t: 2,
	                        x: {
	                          r: ["changes"],
	                          s: "_0>=0?\"positive\":\"negative\""
	                        }
	                      }],
	                      t: 13
	                    }],
	                    f: [{
	                      t: 2,
	                      x: {
	                        r: ["_", "changes"],
	                        s: "_0.formatGrowth(_1)"
	                      }
	                    }]
	                  }]
	                }],
	                n: 52,
	                i: "idx",
	                r: "topList"
	              }],
	              n: 50,
	              r: "topList.length"
	            }, {
	              t: 4,
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "table-wrapper_content_no-data",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: "width",
	                    f: "270",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "148",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/landing/new/no-results.svg"],
	                    t: 13
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "span",
	                  f: ["No data"]
	                }]
	              }],
	              n: 51,
	              l: 1
	            }],
	            n: 50,
	            x: {
	              r: ["topList"],
	              s: "_0!==null"
	            }
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "table-wrapper_pagination",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "table-wrapper_pagination_range",
	            g: 1
	          }],
	          f: [{
	            t: 2,
	            r: "pageRange"
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "table-wrapper_pagination_ctrls",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "button",
	            m: [{
	              n: ["click"],
	              t: 70,
	              f: {
	                r: ["@this"],
	                s: "[_0.prevPage()]"
	              }
	            }, {
	              n: "class",
	              f: ["table-wrapper_pagination_ctrls_btn table-wrapper_pagination_ctrls_btn-prev ", {
	                t: 4,
	                f: ["disabled"],
	                n: 50,
	                x: {
	                  r: ["page.value"],
	                  s: "_0===1"
	                }
	              }],
	              t: 13
	            }],
	            f: [{
	              t: 7,
	              e: "img",
	              m: [{
	                n: "width",
	                f: "20",
	                t: 13,
	                g: 1
	              }, {
	                n: "height",
	                f: "20",
	                t: 13,
	                g: 1
	              }, {
	                n: "src",
	                f: [{
	                  t: 2,
	                  r: "@shared.assetsHost"
	                }, "/img/statistics/left.svg"],
	                t: 13
	              }, {
	                n: "loading",
	                f: "lazy",
	                t: 13,
	                g: 1
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              n: "class",
	              f: ["table-wrapper_pagination_ctrls_limit ", {
	                t: 4,
	                f: ["table-wrapper_pagination_ctrls_limit_disabled"],
	                n: 50,
	                x: {
	                  r: ["topList", "topList.length"],
	                  s: "_0&&!_1"
	                }
	              }],
	              t: 13
	            }],
	            f: [{
	              t: 7,
	              e: "span",
	              f: ["Show:"]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "btn-group",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "button",
	                m: [{
	                  n: "type",
	                  f: "button",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "class",
	                  f: ["btn dropdown-toggle ", {
	                    t: 4,
	                    f: ["disabled"],
	                    n: 50,
	                    x: {
	                      r: ["topList", "topList.length"],
	                      s: "_0&&!_1"
	                    }
	                  }],
	                  t: 13
	                }, {
	                  n: "data-toggle",
	                  f: "dropdown",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "aria-haspopup",
	                  f: "true",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "aria-expanded",
	                  f: "false",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "span",
	                  f: [{
	                    t: 2,
	                    r: "pageLimit"
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: "width",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/statistics/left.svg"],
	                    t: 13
	                  }, {
	                    n: "loading",
	                    f: "lazy",
	                    t: 13,
	                    g: 1
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "ul",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "dropdown-menu",
	                  g: 1
	                }],
	                f: [{
	                  t: 4,
	                  f: [{
	                    t: 7,
	                    e: "li",
	                    f: [{
	                      t: 7,
	                      e: "a",
	                      m: [{
	                        n: ["click"],
	                        t: 70,
	                        f: {
	                          r: ["@this", "."],
	                          s: "[_0.set(\"pageLimit\",_1)]"
	                        }
	                      }],
	                      f: [{
	                        t: 2,
	                        r: "."
	                      }]
	                    }]
	                  }],
	                  n: 52,
	                  r: "paginationLimits"
	                }]
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "button",
	            m: [{
	              n: ["click"],
	              t: 70,
	              f: {
	                r: ["@this"],
	                s: "[_0.nextPage()]"
	              }
	            }, {
	              n: "class",
	              f: ["table-wrapper_pagination_ctrls_btn table-wrapper_pagination_ctrls_btn-next ", {
	                t: 4,
	                f: ["disabled"],
	                n: 50,
	                x: {
	                  r: ["page.value", "xTotalPages"],
	                  s: "_0===_1"
	                }
	              }],
	              t: 13
	            }],
	            f: [{
	              t: 7,
	              e: "img",
	              m: [{
	                n: "width",
	                f: "20",
	                t: 13,
	                g: 1
	              }, {
	                n: "height",
	                f: "20",
	                t: 13,
	                g: 1
	              }, {
	                n: "src",
	                f: [{
	                  t: 2,
	                  r: "@shared.assetsHost"
	                }, "/img/statistics/right.svg"],
	                t: 13
	              }, {
	                n: "loading",
	                f: "lazy",
	                t: 13,
	                g: 1
	              }]
	            }]
	          }]
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "table-msg",
	        g: 1
	      }],
	      f: ["Compared to the previous ", {
	        t: 2,
	        rx: {
	          r: "periods",
	          m: [{
	            t: 30,
	            n: "period"
	          }]
	        }
	      }, "-day period"]
	    }]
	  }],
	  e: {
	    "[_0.set(\"isVersionGrouped\",!_1)]": function (_0, _1) {
	      return [_0.set("isVersionGrouped", !_1)];
	    },
	    "_0||(!_1||!_2)": function (_0, _1, _2) {
	      return _0 || !_1 || !_2;
	    },
	    "!_0": function (_0) {
	      return !_0;
	    },
	    "[_0.set(\"selectedItem\",\"\")]": function (_0) {
	      return [_0.set("selectedItem", "")];
	    },
	    "[_0.handleIconBrokenSrc(_1)]": function (_0, _1) {
	      return [_0.handleIconBrokenSrc(_1)];
	    },
	    "[_0.handleBreakdownSelect(_1,_2[_1].disabled)]": function (_0, _1, _2) {
	      return [_0.handleBreakdownSelect(_1, _2[_1].disabled)];
	    },
	    "[\"Compared to the previous \"+_1[_0]+\"-day period\",\"top\"]": function (_0, _1) {
	      return ["Compared to the previous " + _1[_0] + "-day period", "top"];
	    },
	    "(_0-1)*_1+_2+1": function (_0, _1, _2) {
	      return (_0 - 1) * _1 + _2 + 1;
	    },
	    "[_0.set(\"selectedItem\",_2[_1])]": function (_0, _1, _2) {
	      return [_0.set("selectedItem", _2[_1])];
	    },
	    "_0.formatShare(_1,2)": function (_0, _1) {
	      return _0.formatShare(_1, 2);
	    },
	    "_0>=0?\"positive\":\"negative\"": function (_0) {
	      return _0 >= 0 ? "positive" : "negative";
	    },
	    "_0.formatGrowth(_1)": function (_0, _1) {
	      return _0.formatGrowth(_1);
	    },
	    "_0!==null": function (_0) {
	      return _0 !== null;
	    },
	    "[_0.prevPage()]": function (_0) {
	      return [_0.prevPage()];
	    },
	    "_0===1": function (_0) {
	      return _0 === 1;
	    },
	    "_0&&!_1": function (_0, _1) {
	      return _0 && !_1;
	    },
	    "[_0.set(\"pageLimit\",_1)]": function (_0, _1) {
	      return [_0.set("pageLimit", _1)];
	    },
	    "[_0.nextPage()]": function (_0) {
	      return [_0.nextPage()];
	    },
	    "_0===_1": function (_0, _1) {
	      return _0 === _1;
	    }
	  }
	};
	var topPlatformBrowser = ractive__default["default"].extend(component$m.exports);

	var component$l = {
	  exports: {}
	};
	const LEGEND_AXIS_TICKS_AMOUNT = 8;
	component$l.exports = {
	  data() {
	    return {
	      type: 'hits',
	      switchList: [],
	      providerStatsByCountry: null,
	      legendAxisTicks: [],
	      tooltipData: {},
	      currentCountryId: null,
	      providersJson: providerData,
	      noMapData: null
	    };
	  },
	  oninit() {
	    if (!ractive__default["default"].isServer) {
	      // fetch data
	      this.observe('period __ready', function () {
	        if (this.get('__ready')) {
	          let period = this.get('period');
	          http.fetchNetworkProviderStatsByCountry(period).then(response => {
	            if (!response.hits.total && !response.bandwidth.total) {
	              this.set('noMapData', true);
	              this.set('switchList', []);
	              this.set('providerStatsByCountry', null);
	              return;
	            }
	            let providers = Object.values(response.hits.countries)[0].providers;
	            let oldSwitchList = this.get('switchList');
	            let newSwitchList = providers.map(provider => {
	              let oldOne = oldSwitchList.filter(one => one.name === providerData[provider.code].name);
	              return oldOne.length ? oldOne[0] : {
	                name: providerData[provider.code].name,
	                active: true,
	                shortName: provider.code
	              };
	            });
	            this.set('noMapData', false);
	            this.set('switchList', newSwitchList);
	            this.set('providerStatsByCountry', response);
	          });
	        }
	      });

	      // handle switchList logic
	      this.observe('switchList', switchList => {
	        let disabledSwitches = switchList.filter(s => s.active === false).length;
	        let switchListLength = switchList.length;
	        let updatedSwitchList = [];
	        if (disabledSwitches === switchListLength - 1) {
	          updatedSwitchList = switchList.map(switchItem => {
	            if (switchItem.active) {
	              switchItem.disabled = true;
	            } else {
	              switchItem.disabled = false;
	            }
	            return switchItem;
	          });
	        } else {
	          updatedSwitchList = switchList.map(switchItem => {
	            switchItem.disabled = false;
	            return switchItem;
	          });
	        }
	        this.set('switchList', updatedSwitchList);
	      });

	      // prepare data for the Map
	      this.observe('providerStatsByCountry type switchList', () => {
	        let providerStatsByCountry = this.get('providerStatsByCountry');
	        if (!providerStatsByCountry) {
	          return;
	        }
	        let preparedMapData = {
	          dataByCountries: {},
	          switchList: []
	        };
	        let {
	          hits: hitsData,
	          bandwidth: bandwidthData
	        } = providerStatsByCountry;
	        let switchList = this.get('switchList');
	        let type = this.get('type');
	        if (!hitsData.countries || !bandwidthData.countries || switchList.length === 0) {
	          return;
	        }

	        // prepare countries total, data by countries etc.
	        hitsData.countries.forEach(country => {
	          let countryHitsStat = country;
	          let countryBandwidthStat = bandwidthData.countries.find(i => i.code === country.code);
	          let ratioList = {};
	          let hitsByCountryTotal = 0;
	          let bandwidthByCountryTotal = 0;
	          countryHitsStat.providers.forEach(provider => {
	            let providerData$1 = providerData[provider.code];
	            let switchOne = switchList.find(one => one.name === providerData$1.name);
	            if (!switchOne || !switchOne.active) {
	              return;
	            }
	            let providerBandwidthObj = countryBandwidthStat.providers.find(i => i.code === provider.code);
	            ratioList[providerData$1.name] = this.calcRatio(provider.total, providerBandwidthObj.total);
	            hitsByCountryTotal += provider.total;
	          });
	          countryBandwidthStat.providers.forEach(provider => {
	            let providerData$1 = providerData[provider.code];
	            let switchOne = switchList.find(one => one.name === providerData$1.name);
	            if (!switchOne || !switchOne.active) {
	              return;
	            }
	            bandwidthByCountryTotal += provider.total;
	          });
	          preparedMapData.dataByCountries[country.code] = type === 'hits' ? countryHitsStat : countryBandwidthStat;
	          preparedMapData.dataByCountries[country.code].total = type === 'hits' ? hitsByCountryTotal : bandwidthByCountryTotal;
	          preparedMapData.dataByCountries[country.code].ratio = ratioList;
	        });

	        // prepare additional data
	        preparedMapData.switchList = switchList;
	        preparedMapData.type = type;

	        // prepare data for the Legend axis of the Map and for the Map itself (domain values)
	        let minMapValue = _.getValueByMagnitude(Math.min(...Object.keys(preparedMapData.dataByCountries).map(k => preparedMapData.dataByCountries[k].total)), 'floor');
	        let maxMapValue = _.getValueByMagnitude(Math.max(...Object.keys(preparedMapData.dataByCountries).map(k => preparedMapData.dataByCountries[k].total)), 'ceil', 1);
	        let maxMapValuesRangeMagnitude = Math.floor(Math.log10(maxMapValue));
	        let suggestedLegendMax = Math.floor(maxMapValue / Math.pow(10, maxMapValuesRangeMagnitude)) * Math.pow(10, maxMapValuesRangeMagnitude);
	        preparedMapData.legendValuesRangeSteps = [suggestedLegendMax];
	        preparedMapData.mapValuesRangeSteps = [minMapValue];
	        let mapValuesRangeStep = Math.ceil((suggestedLegendMax - minMapValue) / LEGEND_AXIS_TICKS_AMOUNT);
	        let lagendValuesRangeStep = Math.ceil(suggestedLegendMax / LEGEND_AXIS_TICKS_AMOUNT);
	        for (let i = LEGEND_AXIS_TICKS_AMOUNT - 1; i > 0; i--) {
	          preparedMapData.legendValuesRangeSteps.push(i * lagendValuesRangeStep);
	          preparedMapData.mapValuesRangeSteps.push(minMapValue + (LEGEND_AXIS_TICKS_AMOUNT - i) * mapValuesRangeStep);
	        }
	        preparedMapData.mapValuesRangeSteps.push(suggestedLegendMax);

	        // set prepared data
	        this.set('preparedMapData', preparedMapData);
	      }, {
	        init: false
	      });
	    }
	  },
	  onrender() {
	    if (!ractive__default["default"].isServer) {
	      Promise.all([
	      // eslint-disable-next-line n/no-missing-import
	      import('https://cdn.jsdelivr.net/npm/d3@7.8.2/+esm'),
	      // eslint-disable-next-line n/no-missing-import
	      fetch(`${this.get('@shared.assetsHost')}/json/geodata.json`).then(r => r.json())]).then(([d3, geoData]) => {
	        this.set({
	          d3
	        });

	        // draw the Map and the Legend
	        this.observe('preparedMapData screenWidth', () => {
	          let legendColorRange = ['#a2ecf6', '#65d69e', '#90eb9d', '#ffff8c', '#f9d057', '#f29e2e', '#e76818', '#d7191c'];
	          let screenWidth = this.get('screenWidth') ? this.get('screenWidth') : window.innerWidth;
	          let svg = d3.select('#hits-map');
	          if (!svg || !this.get('__ready') || !screenWidth || !this.get('preparedMapData')) {
	            return;
	          }
	          let {
	            dataByCountries,
	            mapValuesRangeSteps,
	            legendValuesRangeSteps,
	            type
	          } = this.get('preparedMapData');
	          let legendAxisTicks = legendValuesRangeSteps.reduce((result, rawValue) => {
	            if (type === 'bandwidth') {
	              result.push(_.formatBytesWithUnit(rawValue, 'TB'));
	            } else {
	              if (screenWidth < 768) {
	                result.push(_.formatToShortNumber(rawValue, ' '));
	              } else {
	                result.push(_.formatNumber(Math.round(rawValue)));
	              }
	            }
	            return result;
	          }, []);
	          this.set('legendAxisTicks', legendAxisTicks);
	          svg.selectAll('*').remove();
	          let mapSvgWidth = parseInt(svg.style('width').replace('px', ''));
	          let mapSvgHeight = parseInt(svg.style('height').replace('px', ''));
	          let colorScale = d3.scaleLinear().domain(mapValuesRangeSteps).range(legendColorRange).clamp(true).unknown('#ccc');

	          // Map and projection
	          let projection = d3.geoMercator().scale(mapSvgWidth / 2.5 / Math.PI).center([0, 20]).translate(screenWidth < 768 ? [mapSvgWidth / 2, mapSvgHeight / 2] : [mapSvgWidth / 2, mapSvgHeight / 2 + 50]);

	          // Draw the map
	          svg.append('g').selectAll('path').data(geoData.features).join('path')
	          // draw each country
	          .attr('d', d3.geoPath().projection(projection))
	          // set the color of each country
	          .attr('fill', d => {
	            let countryCode = d.id;
	            return colorScale(dataByCountries[countryCode] ? dataByCountries[countryCode].total : null);
	          }).attr('stroke', 'white').attr('stroke-width', '1px').on('mouseover click', (event, d) => this.showTooltip(event, d)).on('mouseout', () => this.hideTooltip());
	          function filter(event) {
	            switch (event.type) {
	              case 'wheel':
	                if (event.ctrlKey) {
	                  event.preventDefault();
	                  return true;
	                }
	                break;
	              case 'touchstart':
	              case 'click':
	              case 'mousedown':
	                return true;
	              default:
	                return false;
	            }
	          }
	          function wheelDelta(event) {
	            return -event.deltaY * (event.deltaMode === 1 ? 0.05 : event.deltaMode ? 1 : 0.002);
	          }
	          let zoom = d3.zoom().scaleExtent([1, 8]).filter(filter).wheelDelta(wheelDelta).on('zoom', event => {
	            svg.selectAll('g').attr('transform', event.transform);
	          });
	          svg.call(zoom).call(zoom.transform, d3.zoomIdentity);
	        });
	        listeners.screenWidthListener(this);
	      });
	    }
	  },
	  calcRatio(hits, bandwidth) {
	    return hits ? _.formatBytesWithUnit(bandwidth / hits) : 0;
	  },
	  hideTooltip() {
	    let tooltipEl = document.querySelector('.map-block_map-wrapper_tooltip');
	    let mapOverlayEl = document.querySelector('.map-block_map-wrapper_overlay');
	    tooltipEl.style.opacity = 0;
	    tooltipEl.style.zIndex = -1;
	    mapOverlayEl.style.opacity = 0;
	    mapOverlayEl.style.zIndex = -1;
	    this.set('tooltipData', {});
	    this.set('currentCountryId', null);
	  },
	  handleMapZoom(zoomDirection = 'in', scale = 1.4, duration = 750) {
	    let mapSvg = this.get('d3').select('#hits-map');
	    let zoom = this.get('d3').zoom().scaleExtent([1, 8]).on('zoom', event => {
	      mapSvg.selectAll('g').attr('transform', event.transform);
	    });
	    if (zoomDirection === 'out') {
	      scale = 0.6;
	    }
	    zoom.scaleBy(mapSvg.transition().duration(duration), scale);
	  },
	  showTooltip(event, data) {
	    let currentCountryId = this.get('currentCountryId');
	    let mapDataType = this.get('type');
	    if (currentCountryId === data.id) {
	      return;
	    }
	    this.set('currentCountryId', data.id);
	    let {
	      dataByCountries,
	      switchList
	    } = this.get('preparedMapData');
	    let {
	      layerX,
	      layerY,
	      type: eventType
	    } = event;
	    let {
	      properties: {
	        name: countryName
	      },
	      id: countryId
	    } = data;
	    let tooltipEl = document.querySelector('.map-block_map-wrapper_tooltip');
	    let tooltipData = {
	      countryName,
	      providersData: []
	    };
	    tooltipEl.style.opacity = 1;
	    tooltipEl.style.zIndex = 2;
	    if (eventType === 'click') {
	      let mapOverlayEl = document.querySelector('.map-block_map-wrapper_overlay');
	      mapOverlayEl.style.opacity = 0.6;
	      mapOverlayEl.style.zIndex = 1;
	      tooltipEl.style.top = '50%';
	      tooltipEl.style.left = '50%';
	      tooltipEl.style.transform = 'translate(-50%, -50%)';
	    } else {
	      let svgMapEl = document.querySelector('#hits-map');
	      let {
	        clientWidth: svgElWidth,
	        clientHeight: svgElHeight
	      } = svgMapEl;
	      if (layerY > svgElHeight / 2) {
	        tooltipEl.style.bottom = `${svgElHeight - layerY > 0 ? svgElHeight - layerY + 20 : 30}px`;
	        tooltipEl.style.top = 'auto';
	      } else {
	        tooltipEl.style.top = `${layerY + 10}px`;
	        tooltipEl.style.bottom = 'auto';
	      }
	      if (layerX + tooltipEl.clientWidth > svgElWidth && layerX - tooltipEl.clientWidth - 10 > 0) {
	        tooltipEl.style.left = `${layerX - tooltipEl.clientWidth - 10}px`;
	      } else {
	        tooltipEl.style.left = `${layerX + 10}px`;
	      }
	      tooltipEl.style.transform = 'none';
	    }
	    switchList.forEach(provider => {
	      if (!provider.active) {
	        return;
	      }
	      let statsValueRaw = dataByCountries[countryId]?.providers.find(i => i.code === provider.shortName)?.total || 0;
	      let statsInfo = mapDataType === 'hits' ? _.formatNumberWithSpace(statsValueRaw) : _.formatBytesWithUnit(statsValueRaw);
	      let ratio = dataByCountries[countryId] ? dataByCountries[countryId].ratio[provider.name] : 0;
	      let providerBoxColor = providerData[provider.shortName].color;
	      tooltipData.providersData.push({
	        statsInfo,
	        provider,
	        ratio,
	        providerBoxColor,
	        statsValueRaw
	      });
	    });
	    tooltipData.providersData.sort((a, b) => b.statsValueRaw - a.statsValueRaw);
	    this.set('tooltipData', tooltipData);
	  }
	};
	component$l.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      t: 13,
	      n: "class",
	      f: "c-network-request-map",
	      g: 1
	    }],
	    f: [{
	      t: 7,
	      e: "style",
	      f: ["\t\t", {
	        t: 4,
	        f: ["\n\t\t\t.switchers-block_item_switch input.", {
	          t: 2,
	          r: "name"
	        }, ":checked + .slider {\n\t\t\t\tbackground-color: ", {
	          t: 2,
	          r: "color"
	        }, ";\n\t\t\t}\n\n\t\t\t.switchers-block_item_switch input.", {
	          t: 2,
	          r: "name"
	        }, ":focus + .slider {\n\t\t\t\tbox-shadow: 0 0 1px ", {
	          t: 2,
	          r: "color"
	        }, ";\n\t\t\t}\n"],
	        n: 52,
	        r: "providersJson"
	      }, "\t"]
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "map-header",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "h3",
	        f: [{
	          t: 4,
	          f: ["Bandwidth"],
	          n: 50,
	          x: {
	            r: ["type"],
	            s: "_0===\"bandwidth\""
	          }
	        }, {
	          t: 4,
	          f: ["Requests"],
	          n: 51,
	          l: 1
	        }, " by country"]
	      }, " ", {
	        t: 4,
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "map-header_switch",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "button",
	            m: [{
	              n: "class",
	              f: ["button ", {
	                t: 2,
	                x: {
	                  r: ["type"],
	                  s: "_0===\"hits\"&&\"selected\""
	                }
	              }],
	              t: 13
	            }, {
	              n: ["click"],
	              t: 70,
	              f: {
	                r: ["@this"],
	                s: "[_0.set(\"type\",\"hits\")]"
	              }
	            }],
	            f: ["Requests"]
	          }, " ", {
	            t: 7,
	            e: "button",
	            m: [{
	              n: "class",
	              f: ["button ", {
	                t: 2,
	                x: {
	                  r: ["type"],
	                  s: "_0===\"bandwidth\"&&\"selected\""
	                }
	              }],
	              t: 13
	            }, {
	              n: ["click"],
	              t: 70,
	              f: {
	                r: ["@this"],
	                s: "[_0.set(\"type\",\"bandwidth\")]"
	              }
	            }],
	            f: ["Bandwidth"]
	          }]
	        }],
	        n: 51,
	        r: "noMapData"
	      }]
	    }, " ", {
	      t: 4,
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "map-no-data",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "img",
	          m: [{
	            n: "width",
	            f: "270",
	            t: 13,
	            g: 1
	          }, {
	            n: "height",
	            f: "148",
	            t: 13,
	            g: 1
	          }, {
	            n: "src",
	            f: [{
	              t: 2,
	              r: "@shared.assetsHost"
	            }, "/img/landing/new/no-results.svg"],
	            t: 13
	          }]
	        }, " ", {
	          t: 7,
	          e: "span",
	          f: ["No data"]
	        }]
	      }],
	      n: 50,
	      r: "noMapData"
	    }, {
	      t: 4,
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "map-wrapper",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "switchers-block",
	            g: 1
	          }],
	          f: [{
	            t: 4,
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                n: "class",
	                f: ["switchers-block_item ", {
	                  t: 4,
	                  f: ["disabled"],
	                  n: 50,
	                  rx: {
	                    r: "switchList",
	                    m: [{
	                      t: 30,
	                      n: "index"
	                    }, "disabled"]
	                  }
	                }],
	                t: 13
	              }],
	              f: [{
	                t: 7,
	                e: "label",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "switchers-block_item_switch",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "input",
	                  m: [{
	                    n: "class",
	                    f: [{
	                      t: 2,
	                      r: "name"
	                    }],
	                    t: 13
	                  }, {
	                    n: "type",
	                    f: "checkbox",
	                    t: 13
	                  }, {
	                    n: ["click"],
	                    t: 70,
	                    f: {
	                      r: ["@this", "@index", "active"],
	                      s: "[_0.set(\"switchList[\"+_1+\"].active\",!_2)]"
	                    }
	                  }, {
	                    n: "disabled",
	                    f: [{
	                      t: 2,
	                      rx: {
	                        r: "switchList",
	                        m: [{
	                          t: 30,
	                          n: "index"
	                        }, "disabled"]
	                      }
	                    }],
	                    t: 13
	                  }, {
	                    n: "checked",
	                    f: 0,
	                    t: 13
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "slider round",
	                    g: 1
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "span",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "switchers-block_item_name",
	                  g: 1
	                }],
	                f: [{
	                  t: 2,
	                  r: "name"
	                }]
	              }]
	            }],
	            n: 52,
	            i: "index",
	            r: "switchList"
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "map-block",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "map-block_map-wrapper",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "svg",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "map-block_map-wrapper_map",
	                g: 1
	              }, {
	                n: "id",
	                f: "hits-map",
	                t: 13,
	                g: 1
	              }, {
	                n: "xmlns",
	                f: "http://www.w3.org/2000/svg",
	                t: 13,
	                g: 1
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "map-block_map-wrapper_overlay",
	                g: 1
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "map-block_map-wrapper_tooltip",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "map-block_map-wrapper_tooltip_head",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "map-block_map-wrapper_tooltip_head_name",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 2,
	                    r: "tooltipData.countryName"
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: ["click"],
	                    t: 70,
	                    f: {
	                      r: ["@this"],
	                      s: "[_0.hideTooltip()]"
	                    }
	                  }, {
	                    n: "width",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/statistics/close.white.svg"],
	                    t: 13
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "map-block_map-wrapper_tooltip_body",
	                  g: 1
	                }],
	                f: [{
	                  t: 4,
	                  f: [{
	                    t: 7,
	                    e: "div",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "map-block_map-wrapper_tooltip_body_row",
	                      g: 1
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "div",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "map-block_map-wrapper_tooltip_body_row_box",
	                        g: 1
	                      }, {
	                        n: "style",
	                        f: ["background: ", {
	                          t: 2,
	                          r: "./providerBoxColor"
	                        }],
	                        t: 13
	                      }]
	                    }, " ", {
	                      t: 7,
	                      e: "div",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "map-block_map-wrapper_tooltip_body_row_content",
	                        g: 1
	                      }],
	                      f: [{
	                        t: 7,
	                        e: "div",
	                        m: [{
	                          t: 13,
	                          n: "class",
	                          f: "map-block_map-wrapper_tooltip_body_row_content_main-data",
	                          g: 1
	                        }],
	                        f: [{
	                          t: 7,
	                          e: "span",
	                          f: [{
	                            t: 2,
	                            r: "./provider.name"
	                          }]
	                        }, " ", {
	                          t: 7,
	                          e: "span",
	                          f: [{
	                            t: 2,
	                            r: "./statsInfo"
	                          }]
	                        }]
	                      }, " ", {
	                        t: 7,
	                        e: "div",
	                        m: [{
	                          t: 13,
	                          n: "class",
	                          f: "map-block_map-wrapper_tooltip_body_row_content_file-size",
	                          g: 1
	                        }],
	                        f: [{
	                          t: 7,
	                          e: "span",
	                          f: ["Average file size"]
	                        }, " ", {
	                          t: 7,
	                          e: "span",
	                          f: [{
	                            t: 2,
	                            r: "./ratio"
	                          }]
	                        }]
	                      }]
	                    }]
	                  }],
	                  n: 52,
	                  r: "tooltipData.providersData"
	                }]
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "map-block_legend",
	              g: 1
	            }],
	            f: [{
	              t: 4,
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "map-block_legend_bar",
	                  g: 1
	                }]
	              }],
	              n: 50,
	              r: "legendAxisTicks.length"
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "map-block_legend_axis",
	                g: 1
	              }],
	              f: [{
	                t: 4,
	                f: [{
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "map-block_legend_axis_tick",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 2,
	                    r: "."
	                  }]
	                }],
	                n: 52,
	                r: "legendAxisTicks"
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "map-block_ctrls",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "map-block_ctrls_plus",
	                g: 1
	              }, {
	                n: ["click"],
	                t: 70,
	                f: {
	                  r: ["@this"],
	                  s: "[_0.handleMapZoom(\"in\")]"
	                }
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/statistics/plus.svg"],
	                  t: 13
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "map-block_ctrls_minus",
	                g: 1
	              }, {
	                n: ["click"],
	                t: 70,
	                f: {
	                  r: ["@this"],
	                  s: "[_0.handleMapZoom(\"out\")]"
	                }
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/statistics/minus.svg"],
	                  t: 13
	                }]
	              }]
	            }]
	          }]
	        }]
	      }],
	      n: 51,
	      l: 1
	    }]
	  }],
	  e: {
	    "_0===\"bandwidth\"": function (_0) {
	      return _0 === "bandwidth";
	    },
	    "_0===\"hits\"&&\"selected\"": function (_0) {
	      return _0 === "hits" && "selected";
	    },
	    "[_0.set(\"type\",\"hits\")]": function (_0) {
	      return [_0.set("type", "hits")];
	    },
	    "_0===\"bandwidth\"&&\"selected\"": function (_0) {
	      return _0 === "bandwidth" && "selected";
	    },
	    "[_0.set(\"type\",\"bandwidth\")]": function (_0) {
	      return [_0.set("type", "bandwidth")];
	    },
	    "[_0.set(\"switchList[\"+_1+\"].active\",!_2)]": function (_0, _1, _2) {
	      return [_0.set("switchList[" + _1 + "].active", !_2)];
	    },
	    "[_0.hideTooltip()]": function (_0) {
	      return [_0.hideTooltip()];
	    },
	    "[_0.handleMapZoom(\"in\")]": function (_0) {
	      return [_0.handleMapZoom("in")];
	    },
	    "[_0.handleMapZoom(\"out\")]": function (_0) {
	      return [_0.handleMapZoom("out")];
	    }
	  }
	};
	var networkRequestMap = ractive__default["default"].extend(component$l.exports);

	var component$k = {
	  exports: {}
	};
	component$k.exports = {
	  data() {
	    return {
	      showChartBandwidth: false,
	      switchList: [],
	      rawHitsChartData: '',
	      providersJson: providerData,
	      showProviderBreakdown: true,
	      noChartData: null
	    };
	  },
	  oninit() {
	    if (!ractive__default["default"].isServer) {
	      this.observe('period country continent __ready', function () {
	        if (this.get('__ready')) {
	          let period = this.get('period').periodValue;
	          let country = this.get('country');
	          let continent = this.get('continent');
	          if (country === null) {
	            country = '';
	          }
	          if (continent === null) {
	            continent = '';
	          }
	          http.fetchNetworkProviderStats(period, country, continent).then(response => {
	            if (!response.hits.total && !response.bandwidth.total) {
	              this.set('noChartData', true);
	              this.set('switchList', []);
	              this.set('rawHitsChartData', '');
	              return;
	            }
	            let {
	              providers: respProviders
	            } = response.hits;
	            let oldSwitchList = this.get('switchList');
	            let newSwitchList = respProviders.map(provider => {
	              let oldOne = oldSwitchList.filter(one => one.name === providerData[provider.code].name);
	              return oldOne.length ? oldOne[0] : {
	                name: providerData[provider.code].name,
	                active: true,
	                shortName: provider.code
	              };
	            });
	            this.set('noChartData', false);
	            this.set('switchList', newSwitchList);
	            this.set('rawHitsChartData', response);
	          });
	        }
	      });
	      this.observe('switchList', switchList => {
	        let disabledSwitches = switchList.filter(s => s.active === false).length;
	        let switchListLength = switchList.length;
	        let updatedSwitchList = [];
	        if (disabledSwitches === switchListLength - 1) {
	          updatedSwitchList = switchList.map(switchItem => {
	            if (switchItem.active) {
	              switchItem.disabled = true;
	            } else {
	              switchItem.disabled = false;
	            }
	            return switchItem;
	          });
	        } else {
	          updatedSwitchList = switchList.map(switchItem => {
	            switchItem.disabled = false;
	            return switchItem;
	          });
	        }
	        this.set('switchList', updatedSwitchList);
	      });
	      this.observe('rawHitsChartData showChartBandwidth screenWidth switchList showProviderBreakdown', () => {
	        let rawHitsChartData = this.get('rawHitsChartData');
	        let switchList = this.get('switchList');
	        if (!rawHitsChartData || switchList.length === 0) {
	          return;
	        }
	        let chartPeriodType = this.get('period').periodType;
	        let showChartBandwidth = this.get('showChartBandwidth');
	        let showProviderBreakdown = this.get('showProviderBreakdown');
	        let screenWidth = this.get('screenWidth') ? this.get('screenWidth') : window.innerWidth;
	        let usageChartGroupBy = 'day';
	        let hitsProviders = [...rawHitsChartData.hits.providers];
	        let bandwidthProviders = [...rawHitsChartData.bandwidth.providers];
	        let filteredHitsChartData = {};
	        if (showProviderBreakdown) {
	          let notActiveSwitches = [...switchList].filter(s => s.active === false).map(s => s.shortName);
	          notActiveSwitches.forEach(s => {
	            hitsProviders = hitsProviders.filter(p => p.code !== s);
	            bandwidthProviders = bandwidthProviders.filter(p => p.code !== s);
	          });
	          filteredHitsChartData = {
	            ...rawHitsChartData,
	            bandwidth: {
	              ...rawHitsChartData.bandwidth,
	              providers: bandwidthProviders
	            },
	            hits: {
	              ...rawHitsChartData.hits,
	              providers: hitsProviders
	            }
	          };
	        } else {
	          filteredHitsChartData = {
	            ...rawHitsChartData,
	            bandwidth: this.combineProvidersData(bandwidthProviders),
	            hits: this.combineProvidersData(hitsProviders)
	          };
	        }

	        // collect X-Axis dates, group data by period, get
	        let {
	          labels,
	          maxRangeValue,
	          datasets,
	          labelsStartEndPeriods,
	          valueUnits
	        } = _.getPreparedProvidersDataForLineChart(filteredHitsChartData, usageChartGroupBy, chartPeriodType, showChartBandwidth);
	        this.set('preparedHitsChartData', {
	          datasets,
	          labels,
	          labelsStartEndPeriods,
	          maxRangeValue,
	          showChartBandwidth,
	          yAxisPadding: screenWidth >= 768 ? 24 : 12,
	          valueUnits,
	          usageChartGroupBy
	        });
	      }, {
	        init: false
	      });
	      this.observe('showProviderBreakdown', showProviderBreakdown => {
	        if (showProviderBreakdown === false) {
	          let switchList = this.get('switchList');
	          let updSwitchList = switchList.map(switchItem => ({
	            ...switchItem,
	            active: true,
	            disabled: true
	          }));
	          this.set('switchList', updSwitchList);
	        }
	      });
	    }
	  },
	  onrender() {
	    let hitsChart;
	    charts().then(({
	      createLineChart
	    }) => {
	      // create hits chart
	      this.observe('preparedHitsChartData', preparedHitsChartData => {
	        if (!preparedHitsChartData) {
	          return;
	        }
	        let {
	          datasets,
	          labels,
	          maxRangeValue,
	          showChartBandwidth,
	          yAxisPadding,
	          labelsStartEndPeriods,
	          valueUnits,
	          usageChartGroupBy
	        } = preparedHitsChartData;
	        let hitsChartCanvasEl = this.find('#hits-chart');
	        if (!preparedHitsChartData || !hitsChartCanvasEl) {
	          return;
	        }
	        if (hitsChart) {
	          hitsChart.destroy();
	          hitsChart = null;
	        }
	        let chartData = {
	          labels,
	          datasets,
	          labelsStartEndPeriods,
	          valueUnits,
	          usageChartGroupBy
	        };
	        let chartSettings = {
	          useExternalTooltip: true,
	          useImprovedTooltip: true,
	          plugins: {
	            useExternalTooltip: true
	          }
	        };
	        let maxRangeMagnitude = Math.floor(Math.log10(maxRangeValue));
	        let chartConfig = {
	          options: {
	            scales: {
	              x: {
	                display: true,
	                ticks: {
	                  autoSkip: false,
	                  color: '#5C667A',
	                  font: {
	                    size: 12,
	                    family: 'Lexend, sans-serif',
	                    lineHeight: 2
	                  },
	                  callback(value) {
	                    let labelValue = this.getLabelForValue(value);
	                    if (labelValue.length) {
	                      return labelValue;
	                    }
	                  }
	                },
	                grid: {
	                  display: false
	                },
	                border: {
	                  display: false
	                }
	              },
	              y: {
	                display: true,
	                min: 0,
	                suggestedMax: Math.ceil(maxRangeValue / Math.pow(10, maxRangeMagnitude)) * Math.pow(10, maxRangeMagnitude),
	                ticks: {
	                  padding: yAxisPadding,
	                  count: 9,
	                  color: '#5C667A',
	                  crossAlign: 'near',
	                  font: {
	                    size: 12,
	                    family: 'Lexend, sans-serif'
	                  },
	                  callback(value) {
	                    let valueByMagnitude = _.getValueByMagnitude(Math.round(value), 'round', 1, false);
	                    if (_.isMobileScreen()) {
	                      return showChartBandwidth ? `${_.formatNumber(valueByMagnitude)} ${valueUnits}` : _.formatToShortNumber(valueByMagnitude);
	                    }
	                    return showChartBandwidth ? `${_.formatNumber(valueByMagnitude)} ${valueUnits}` : _.formatNumber(valueByMagnitude);
	                  }
	                },
	                grid: {
	                  color: '#CFD6DD',
	                  tickLength: 0
	                },
	                border: {
	                  display: false
	                }
	              }
	            }
	          }
	        };
	        hitsChart = createLineChart(hitsChartCanvasEl, chartData, chartSettings, chartConfig);
	      });
	    });
	    listeners.screenWidthListener(this);
	  },
	  combineProvidersData(providersList) {
	    return providersList.reduce((res, currProvider) => {
	      if (!res.providers) {
	        res = {
	          total: 0,
	          prev: {
	            total: 0
	          },
	          providers: [{
	            code: 'combinedProviders',
	            dates: {},
	            prev: {
	              total: 0
	            },
	            total: 0
	          }]
	        };
	      }
	      Object.keys(currProvider.dates).forEach(dateKey => {
	        if (!res.providers[0].dates[dateKey]) {
	          res.providers[0].dates[dateKey] = {
	            total: 0
	          };
	        }
	        let currProviderDateValue = currProvider.dates[dateKey].total;
	        res.providers[0].dates[dateKey].total += currProviderDateValue;
	      });
	      res.providers[0].total += currProvider.total;
	      res.total += currProvider.total;
	      res.providers[0].prev.total += currProvider.prev.total;
	      res.prev.total += currProvider.prev.total;
	      return res;
	    }, {});
	  }
	};
	component$k.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      t: 13,
	      n: "class",
	      f: "c-network-request-chart",
	      g: 1
	    }],
	    f: [{
	      t: 7,
	      e: "style",
	      f: ["\t\t", {
	        t: 4,
	        f: ["\n\t\t\t.hits-chart-block_switchers_item_switch input.", {
	          t: 2,
	          r: "name"
	        }, ":checked + .slider {\n\t\t\t\tbackground-color: ", {
	          t: 2,
	          r: "color"
	        }, ";\n\t\t\t}\n\n\t\t\t.hits-chart-block_switchers_item_switch input.", {
	          t: 2,
	          r: "name"
	        }, ":focus + .slider {\n\t\t\t\tbox-shadow: 0 0 1px ", {
	          t: 2,
	          r: "color"
	        }, ";\n\t\t\t}\n"],
	        n: 52,
	        r: "providersJson"
	      }, "\t"]
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "chart-header",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "h3",
	        f: [{
	          t: 4,
	          f: ["Bandwidth"],
	          n: 50,
	          r: "showChartBandwidth"
	        }, {
	          t: 4,
	          f: ["Requests"],
	          n: 51,
	          l: 1
	        }, " over time"]
	      }, " ", {
	        t: 4,
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "chart-header_switch",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "button",
	            m: [{
	              n: "class",
	              f: ["button ", {
	                t: 2,
	                x: {
	                  r: ["showChartBandwidth"],
	                  s: "_0?\"\":\"selected\""
	                }
	              }],
	              t: 13
	            }, {
	              n: ["click"],
	              t: 70,
	              f: {
	                r: ["@this"],
	                s: "[_0.set(\"showChartBandwidth\",false)]"
	              }
	            }],
	            f: ["Requests"]
	          }, " ", {
	            t: 7,
	            e: "button",
	            m: [{
	              n: "class",
	              f: ["button ", {
	                t: 2,
	                x: {
	                  r: ["showChartBandwidth"],
	                  s: "_0?\"selected\":\"\""
	                }
	              }],
	              t: 13
	            }, {
	              n: ["click"],
	              t: 70,
	              f: {
	                r: ["@this"],
	                s: "[_0.set(\"showChartBandwidth\",true)]"
	              }
	            }],
	            f: ["Bandwidth"]
	          }]
	        }],
	        n: 51,
	        r: "noChartData"
	      }]
	    }, " ", {
	      t: 4,
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "hits-chart-no-data",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "img",
	          m: [{
	            n: "width",
	            f: "270",
	            t: 13,
	            g: 1
	          }, {
	            n: "height",
	            f: "148",
	            t: 13,
	            g: 1
	          }, {
	            n: "src",
	            f: [{
	              t: 2,
	              r: "@shared.assetsHost"
	            }, "/img/landing/new/no-results.svg"],
	            t: 13
	          }]
	        }, " ", {
	          t: 7,
	          e: "span",
	          f: ["No data"]
	        }]
	      }],
	      n: 50,
	      r: "noChartData"
	    }, {
	      t: 4,
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "hits-chart-block",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "hits-chart-block_switchers",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "hits-chart-block_switchers_breakdown",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "hits-chart-block_switchers_item",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "label",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "hits-chart-block_switchers_item_switch",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "input",
	                  m: [{
	                    n: "type",
	                    f: "checkbox",
	                    t: 13
	                  }, {
	                    n: ["click"],
	                    t: 70,
	                    f: {
	                      r: ["@this"],
	                      s: "[_0.toggle(\"showProviderBreakdown\")]"
	                    }
	                  }, {
	                    n: "checked",
	                    f: 0,
	                    t: 13
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    n: "class",
	                    f: ["slider round provider-breakdown ", {
	                      t: 4,
	                      f: ["provider-breakdown_turned-off"],
	                      n: 51,
	                      r: "showProviderBreakdown"
	                    }],
	                    t: 13
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "span",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "hits-chart-block_switchers_item_name",
	                  g: 1
	                }],
	                f: ["Show provider breakdown"]
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "hits-chart-block_switchers_wrapper",
	              g: 1
	            }],
	            f: [{
	              t: 4,
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  n: "class",
	                  f: ["hits-chart-block_switchers_item ", {
	                    t: 4,
	                    f: ["disabled"],
	                    n: 50,
	                    x: {
	                      r: ["index", "switchList", "showProviderBreakdown"],
	                      s: "_1[_0].disabled||!_2"
	                    }
	                  }],
	                  t: 13
	                }],
	                f: [{
	                  t: 7,
	                  e: "label",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "hits-chart-block_switchers_item_switch",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "input",
	                    m: [{
	                      n: "class",
	                      f: [{
	                        t: 2,
	                        r: "name"
	                      }],
	                      t: 13
	                    }, {
	                      n: "type",
	                      f: "checkbox",
	                      t: 13
	                    }, {
	                      n: ["click"],
	                      t: 70,
	                      f: {
	                        r: ["@this", "@index", "active"],
	                        s: "[_0.set(\"switchList[\"+_1+\"].active\",!_2)]"
	                      }
	                    }, {
	                      n: "disabled",
	                      f: [{
	                        t: 2,
	                        x: {
	                          r: ["index", "switchList", "showProviderBreakdown"],
	                          s: "_1[_0].disabled||!_2"
	                        }
	                      }],
	                      t: 13
	                    }, {
	                      n: "checked",
	                      f: [{
	                        t: 2,
	                        rx: {
	                          r: "switchList",
	                          m: [{
	                            t: 30,
	                            n: "index"
	                          }, "active"]
	                        }
	                      }],
	                      t: 13
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "span",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "slider round",
	                      g: 1
	                    }]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "hits-chart-block_switchers_item_name",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 2,
	                    r: "name"
	                  }]
	                }]
	              }],
	              n: 52,
	              i: "index",
	              r: "switchList"
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "hits-chart-block_chart-wrapper",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "canvas",
	            m: [{
	              n: "id",
	              f: "hits-chart",
	              t: 13,
	              g: 1
	            }]
	          }]
	        }]
	      }],
	      n: 51,
	      l: 1
	    }]
	  }],
	  e: {
	    "_0?\"\":\"selected\"": function (_0) {
	      return _0 ? "" : "selected";
	    },
	    "[_0.set(\"showChartBandwidth\",false)]": function (_0) {
	      return [_0.set("showChartBandwidth", false)];
	    },
	    "_0?\"selected\":\"\"": function (_0) {
	      return _0 ? "selected" : "";
	    },
	    "[_0.set(\"showChartBandwidth\",true)]": function (_0) {
	      return [_0.set("showChartBandwidth", true)];
	    },
	    "[_0.toggle(\"showProviderBreakdown\")]": function (_0) {
	      return [_0.toggle("showProviderBreakdown")];
	    },
	    "_1[_0].disabled||!_2": function (_0, _1, _2) {
	      return _1[_0].disabled || !_2;
	    },
	    "[_0.set(\"switchList[\"+_1+\"].active\",!_2)]": function (_0, _1, _2) {
	      return [_0.set("switchList[" + _1 + "].active", !_2)];
	    }
	  }
	};
	var networkRequestChart = ractive__default["default"].extend(component$k.exports);

	var component$j = {
	  exports: {}
	};
	component$j.exports = {
	  data() {
	    return {
	      _,
	      requestsData: {
	        total: 0,
	        growth: 0,
	        statsList: []
	      },
	      bandwidthData: {
	        total: 0,
	        growth: 0,
	        statsList: []
	      },
	      providersToDisplay: [],
	      noProvidersToDisplay: null,
	      growthPeriods: stats.growthPeriods,
	      growthPeriod: 'monthly'
	    };
	  },
	  oninit() {
	    if (!ractive__default["default"].isServer) {
	      this.observe('periodData', ({
	        periodValue,
	        periodType
	      }) => {
	        this.set('growthPeriod', this.get('growthPeriods')[periodType]);
	        http.fetchNetworkProviderStats(periodValue).then(({
	          hits,
	          bandwidth
	        }) => {
	          this.animate('requestsData', this.processStats(hits));
	          this.animate('bandwidthData', this.processStats(bandwidth));
	          this.set('providersCodes', hits.providers.map(p => p.code));
	        });
	      });
	      this.observe('providersCodes', providersCodes => {
	        if (providersCodes.length) {
	          this.set('noProvidersToDisplay', false);
	        } else {
	          this.set('noProvidersToDisplay', true);
	        }
	        this.set('providersToDisplay', providersCodes.map(code => providerData[code]));
	      }, {
	        init: false
	      });
	    }
	  },
	  processStats(data) {
	    let {
	      providers,
	      total,
	      prev
	    } = data;
	    let result = {
	      total: 0,
	      growth: 0,
	      statsList: []
	    };
	    providers.forEach((provider, idx) => {
	      let providerData$1 = providerData[provider.code] ?? {};
	      let svg = providerData$1.imgPath;
	      let color = providerData$1.color;
	      let name = providerData$1.name;
	      let stat = providers[idx];
	      let interest = this.calcGrowth(stat.total, stat.prev.total);
	      let percentage = this.calcPercentage(stat.total, total);
	      result.statsList.push({
	        svg,
	        name,
	        color,
	        interest,
	        total: stat.total,
	        percentage
	      });
	    });
	    result.statsList.sort((a, b) => b.total - a.total);
	    result.total = total;
	    result.growth = this.calcGrowth(total, prev.total);
	    return result;
	  },
	  calcGrowth(cur, prev) {
	    if (cur === 0 && prev === 0) {
	      return 0;
	    }
	    return prev ? (cur - prev) * 100 / prev : 100;
	  },
	  calcPercentage(provTotal, overallTotal) {
	    let percentage = Number((provTotal * 100 / overallTotal).toFixed(1));
	    return percentage < 1 ? '1%' : percentage + '%';
	  },
	  prettifyNumbersToDisplay(num) {
	    return _.formatNumberWithSpace(Math.round(num));
	  }
	};
	component$j.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      t: 13,
	      n: "class",
	      f: "c-network-provider-stats",
	      g: 1
	    }],
	    f: [{
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "block",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "h3",
	        f: ["Requests"]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "table",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "bandwidth-stats",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "card-icon",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "img",
	              m: [{
	                n: "width",
	                f: "20",
	                t: 13,
	                g: 1
	              }, {
	                n: "height",
	                f: "20",
	                t: 13,
	                g: 1
	              }, {
	                n: "src",
	                f: [{
	                  t: 2,
	                  r: "@shared.assetsHost"
	                }, "/img/icons/request.svg"],
	                t: 13
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "card-main-stat text-table-number",
	              g: 1
	            }],
	            f: [{
	              t: 2,
	              x: {
	                r: ["@this", "requestsData.total"],
	                s: "_0.prettifyNumbersToDisplay(_1)"
	              }
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "card-growth",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                n: "class",
	                f: [{
	                  t: 2,
	                  x: {
	                    r: ["requestsData.growth"],
	                    s: "_0<0?\"growth-negative\":\"growth-positive\""
	                  }
	                }],
	                t: 13
	              }],
	              f: [{
	                t: 7,
	                e: "span",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "text-table-number",
	                  g: 1
	                }],
	                f: [{
	                  t: 2,
	                  x: {
	                    r: ["_", "requestsData.growth"],
	                    s: "_0.formatGrowth(_1)"
	                  }
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "span",
	              f: [{
	                t: 2,
	                r: "growthPeriod"
	              }, " ", {
	                t: 2,
	                x: {
	                  r: ["requestsData.growth"],
	                  s: "_0<0?\"decline\":\"growth\""
	                }
	              }]
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "bandwidth-list",
	            g: 1
	          }],
	          f: [{
	            t: 4,
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "bandwidth-list_item",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "bandwidth-list_item_provider",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: "width",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, {
	                      t: 2,
	                      r: "svg"
	                    }],
	                    t: 13
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "span",
	                  f: [{
	                    t: 2,
	                    r: "name"
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "bandwidth-list_item_provider-stats",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "bandwidth-list_item_provider-stats_value text-table-number",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 2,
	                    x: {
	                      r: ["@this", "total"],
	                      s: "_0.prettifyNumbersToDisplay(_1)"
	                    }
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "percentage-bar",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "div",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "percentage-bar_filled",
	                      g: 1
	                    }, {
	                      n: "style",
	                      f: ["width: ", {
	                        t: 2,
	                        r: "percentage"
	                      }, "; background: ", {
	                        t: 2,
	                        r: "color"
	                      }],
	                      t: 13
	                    }]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    n: "class",
	                    f: ["interest text-table-number ", {
	                      t: 2,
	                      x: {
	                        r: ["interest"],
	                        s: "_0<0?\"growth-negative\":\"growth-positive\""
	                      }
	                    }],
	                    t: 13
	                  }],
	                  f: [{
	                    t: 2,
	                    x: {
	                      r: ["_", "interest"],
	                      s: "_0.formatGrowth(_1)"
	                    }
	                  }]
	                }]
	              }]
	            }],
	            n: 52,
	            r: "requestsData.statsList"
	          }]
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "block",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "h3",
	        f: ["Bandwidth"]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "table",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "bandwidth-stats",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "card-icon",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "img",
	              m: [{
	                n: "width",
	                f: "20",
	                t: 13,
	                g: 1
	              }, {
	                n: "height",
	                f: "20",
	                t: 13,
	                g: 1
	              }, {
	                n: "src",
	                f: [{
	                  t: 2,
	                  r: "@shared.assetsHost"
	                }, "/img/icons/transfer.svg"],
	                t: 13
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "card-main-stat text-table-number",
	              g: 1
	            }],
	            f: [{
	              t: 2,
	              x: {
	                r: ["_", "bandwidthData.total"],
	                s: "_0.formatBytesWithUnit(_1,\"TB\")"
	              }
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "card-growth",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                n: "class",
	                f: [{
	                  t: 2,
	                  x: {
	                    r: ["bandwidthData.growth"],
	                    s: "_0<0?\"growth-negative\":\"growth-positive\""
	                  }
	                }],
	                t: 13
	              }],
	              f: [{
	                t: 7,
	                e: "span",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "text-table-number",
	                  g: 1
	                }],
	                f: [{
	                  t: 2,
	                  x: {
	                    r: ["_", "bandwidthData.growth"],
	                    s: "_0.formatGrowth(_1)"
	                  }
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "span",
	              f: [{
	                t: 2,
	                r: "growthPeriod"
	              }, " ", {
	                t: 2,
	                x: {
	                  r: ["bandwidthData.growth"],
	                  s: "_0<0?\"decline\":\"growth\""
	                }
	              }]
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "bandwidth-list",
	            g: 1
	          }],
	          f: [{
	            t: 4,
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "bandwidth-list_item",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "bandwidth-list_item_provider",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: "width",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, {
	                      t: 2,
	                      r: "svg"
	                    }],
	                    t: 13
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "span",
	                  f: [{
	                    t: 2,
	                    r: "name"
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "bandwidth-list_item_provider-stats",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "bandwidth-list_item_provider-stats_value text-table-number",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 2,
	                    x: {
	                      r: ["_", "total"],
	                      s: "_0.formatBytesWithUnit(_1,\"TB\")"
	                    }
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "percentage-bar",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "div",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "percentage-bar_filled",
	                      g: 1
	                    }, {
	                      n: "style",
	                      f: ["width: ", {
	                        t: 2,
	                        r: "percentage"
	                      }, "; background: ", {
	                        t: 2,
	                        r: "color"
	                      }],
	                      t: 13
	                    }]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    n: "class",
	                    f: ["interest text-table-number ", {
	                      t: 2,
	                      x: {
	                        r: ["interest"],
	                        s: "_0<0?\"growth-negative\":\"growth-positive\""
	                      }
	                    }],
	                    t: 13
	                  }],
	                  f: [{
	                    t: 2,
	                    x: {
	                      r: ["_", "interest"],
	                      s: "_0.formatGrowth(_1)"
	                    }
	                  }]
	                }]
	              }]
	            }],
	            n: 52,
	            r: "bandwidthData.statsList"
	          }]
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "hit-rate",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "h3",
	        f: ["Cache hit rate"]
	      }, " ", {
	        t: 4,
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "hit-rate_no-data",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "img",
	            m: [{
	              n: "width",
	              f: "270",
	              t: 13,
	              g: 1
	            }, {
	              n: "height",
	              f: "148",
	              t: 13,
	              g: 1
	            }, {
	              n: "src",
	              f: [{
	                t: 2,
	                r: "@shared.assetsHost"
	              }, "/img/landing/new/no-results.svg"],
	              t: 13
	            }]
	          }, " ", {
	            t: 7,
	            e: "span",
	            f: ["No data"]
	          }]
	        }],
	        n: 50,
	        r: "noProvidersToDisplay"
	      }, {
	        t: 4,
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            n: "class",
	            f: ["rate-row ", {
	              t: 4,
	              f: ["rate-row_odd"],
	              n: 50,
	              x: {
	                r: ["providersToDisplay.length"],
	                s: "_0%2"
	              }
	            }, {
	              t: 4,
	              f: ["rate-row_even"],
	              n: 51,
	              l: 1
	            }],
	            t: 13
	          }],
	          f: [{
	            t: 4,
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "row-item",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "row-item_provider",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: "width",
	                    f: "24",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "24",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, {
	                      t: 2,
	                      r: "imgPath"
	                    }],
	                    t: 13
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "span",
	                  f: [{
	                    t: 2,
	                    r: "name"
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "row-item_interest text-table-number",
	                  g: 1
	                }],
	                f: [{
	                  t: 2,
	                  r: "cacheHitRate"
	                }, "%"]
	              }]
	            }],
	            n: 52,
	            r: "providersToDisplay"
	          }]
	        }],
	        n: 51,
	        l: 1
	      }]
	    }]
	  }],
	  e: {
	    "_0.prettifyNumbersToDisplay(_1)": function (_0, _1) {
	      return _0.prettifyNumbersToDisplay(_1);
	    },
	    "_0<0?\"growth-negative\":\"growth-positive\"": function (_0) {
	      return _0 < 0 ? "growth-negative" : "growth-positive";
	    },
	    "_0.formatGrowth(_1)": function (_0, _1) {
	      return _0.formatGrowth(_1);
	    },
	    "_0<0?\"decline\":\"growth\"": function (_0) {
	      return _0 < 0 ? "decline" : "growth";
	    },
	    "_0.formatBytesWithUnit(_1,\"TB\")": function (_0, _1) {
	      return _0.formatBytesWithUnit(_1, "TB");
	    },
	    "_0%2": function (_0) {
	      return _0 % 2;
	    }
	  }
	};
	var networkProviderStats = ractive__default["default"].extend(component$j.exports);

	var continents$1 = [
		{
			code: "AN",
			name: "Antarctica"
		},
		{
			code: "AS",
			name: "Asia"
		},
		{
			code: "EU",
			name: "Europe"
		},
		{
			code: "NA",
			name: "North America"
		},
		{
			code: "OC",
			name: "Oceania"
		},
		{
			code: "SA",
			name: "South America"
		},
		{
			code: "AF",
			name: "Africa"
		}
	];

	var continents$2 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		'default': continents$1
	});

	var continents = getCjsExportFromNamespace(continents$2);

	var component$i = {
	  exports: {}
	};
	const GLOBAL_SEARCH_ITEM_TYPE = 'global';
	const NO_RESULTS_SEARCH_ITEM_TYPE = 'no-results';
	const COUNTRY_SEARCH_ITEM_TYPE = 'country';
	const CONTINENT_SEARCH_ITEM_TYPE = 'continent';
	const GLOBAL_SEARCH_ITEM = {
	  code: 'WW',
	  name: 'Global',
	  type: GLOBAL_SEARCH_ITEM_TYPE
	};
	const NO_RESULTS_SEARCH_ITEM = {
	  code: 'no-results',
	  name: 'No results found',
	  type: NO_RESULTS_SEARCH_ITEM_TYPE
	};
	component$i.exports = {
	  data() {
	    return {
	      _,
	      desc: true,
	      title: 'Usage Statistics - jsDelivr',
	      name: 'd3',
	      description: 'Load modern JavaScript packages built for you on-demand. Works in modern web browsers, node.js, and deno.',
	      periodData: {
	        periodText: 'month',
	        periodValue: 'month',
	        periodType: 's-month'
	      },
	      showGlobalStickyMenu: false,
	      selectedCountry: null,
	      selectedContinent: null,
	      showNetworkStickyMenu: false,
	      lastOffsetTop: 0,
	      showProjectsStickyMenu: false,
	      selectedSearchItem: null,
	      searchDefaultIcon: null,
	      searchDisplayValue: ''
	    };
	  },
	  decorators: {
	    tooltip
	  },
	  oninit() {
	    let continentsList = continents.map(i => ({
	      ...i,
	      type: CONTINENT_SEARCH_ITEM_TYPE
	    }));
	    let countriesList = countries.map(i => ({
	      ...i,
	      type: COUNTRY_SEARCH_ITEM_TYPE
	    }));
	    this.set('continentsList', continentsList);
	    this.set('countriesList', countriesList);
	    this.observe('screenWidth', screenWidth => {
	      if ((screenWidth || window.innerWidth) < 768) {
	        this.set('searchPlaceholder', 'Search');
	      } else {
	        this.set('searchPlaceholder', 'Filter for a specific country or a continent...');
	      }
	    });
	    this.observe('selectedSearchItem', selectedSearchItem => {
	      let sharedAssetsHost = this.get('@shared.assetsHost');
	      let flagIconPath = 'https://cdn.jsdelivr.net/npm/country-flag-icons@1.5.5/3x2';
	      let wwIconSrc = `${sharedAssetsHost}/img/statistics/WW.svg`;
	      let defaultSrc = `${sharedAssetsHost}/img/statistics/search.svg`;
	      if (!selectedSearchItem) {
	        this.set('searchDefaultIcon', {
	          src: defaultSrc,
	          width: '20px',
	          height: '20px',
	          class: 'default'
	        });
	        return;
	      }
	      switch (selectedSearchItem.type) {
	        case COUNTRY_SEARCH_ITEM_TYPE:
	          this.set('selectedCountry', selectedSearchItem.code);
	          this.set('selectedContinent', null);
	          this.set('searchDisplayValue', selectedSearchItem.name);
	          this.set('searchDefaultIcon', {
	            src: `${flagIconPath}/${selectedSearchItem.code}.svg`,
	            width: '21px',
	            height: '15px'
	          });
	          break;
	        case CONTINENT_SEARCH_ITEM_TYPE:
	          this.set('selectedContinent', selectedSearchItem.code);
	          this.set('selectedCountry', null);
	          this.set('searchDisplayValue', selectedSearchItem.name);
	          this.set('searchDefaultIcon', {
	            src: wwIconSrc,
	            width: '21px',
	            height: '15px'
	          });
	          break;
	        case GLOBAL_SEARCH_ITEM_TYPE:
	          this.set('selectedCountry', null);
	          this.set('selectedContinent', null);
	          this.set('searchDisplayValue', '');
	          this.set('searchDefaultIcon', {
	            src: defaultSrc,
	            width: '20px',
	            height: '20px',
	            class: 'default'
	          });
	          break;
	      }
	    });
	  },
	  onrender() {
	    let sharedAssetsHost = this.get('@shared.assetsHost');
	    let flagIconPath = 'https://cdn.jsdelivr.net/npm/country-flag-icons@1.5.5/3x2';
	    let wwIconSrc = `${sharedAssetsHost}/img/statistics/WW.svg`;
	    let continentsList = this.get('continentsList');
	    let countriesList = this.get('countriesList');
	    let seachElement = $('#search');
	    seachElement.autocomplete({
	      hint: false,
	      clearOnSelected: true
	    }, [{
	      source: (query, cb) => {
	        let results = continentsList.filter(one => {
	          return one.name.toLowerCase().search(query.toLowerCase()) !== -1;
	        });
	        this.set('noSearchContinents', results.length === 0);
	        cb([GLOBAL_SEARCH_ITEM, ...results]);
	      },
	      displayKey: 'name',
	      templates: {
	        suggestion: ({
	          name,
	          type
	        }) => {
	          let itemClassName = type === CONTINENT_SEARCH_ITEM_TYPE ? 'search-item_continent' : 'search-item_global';
	          let contentEl = `<img width="21px" height="15px" src="${wwIconSrc}"><span>${name}</span>`;
	          let suggestionEl = `<div class='search-item ${itemClassName}'>${contentEl}<hr /></div>`;
	          return suggestionEl;
	        }
	      }
	    }, {
	      source: (query, cb) => {
	        let noSearchContinents = this.get('noSearchContinents');
	        let results = countriesList.filter(one => {
	          return one.name.toLowerCase().search(query.toLowerCase()) !== -1;
	        });
	        if (noSearchContinents && !results.length) {
	          cb([NO_RESULTS_SEARCH_ITEM, ...results]);
	        } else {
	          cb(results);
	        }
	      },
	      displayKey: 'name',
	      templates: {
	        suggestion: ({
	          code,
	          name,
	          type
	        }) => {
	          let itemClassName = type === NO_RESULTS_SEARCH_ITEM_TYPE ? 'search-item_no-results' : 'search-item_country';
	          let src = `${flagIconPath}/${code}.svg`;
	          let contentEl = type === NO_RESULTS_SEARCH_ITEM_TYPE ? name : `<img width="21px" height="15px" src="${src}"><span>${name}</span>`;
	          let suggestionEl = `<div class='search-item ${itemClassName}'>${contentEl}</div>`;
	          return suggestionEl;
	        }
	      }
	    }]).on('autocomplete:selected', (e, suggestion) => {
	      if (suggestion.type === NO_RESULTS_SEARCH_ITEM_TYPE) {
	        let selecteItem = this.get('selectedSearchItem');
	        this.set('selectedSearchItem', selecteItem);
	      } else {
	        this.set('selectedSearchItem', suggestion);
	      }
	    });
	    seachElement.focusout(event => {
	      setTimeout(() => {
	        let selectedSearchItem = this.get('selectedSearchItem');
	        let searchDisplayValue = this.get('searchDisplayValue');

	        // when user cleared search input after he already selected location
	        if (!event.target.value && !searchDisplayValue && selectedSearchItem && selectedSearchItem.name) {
	          seachElement.val('');
	          this.set('selectedSearchItem', GLOBAL_SEARCH_ITEM);
	        } else if (selectedSearchItem && event.target.value !== selectedSearchItem.name) {
	          // when user not completely removed data from search input after he already selected location
	          switch (selectedSearchItem.type) {
	            case GLOBAL_SEARCH_ITEM_TYPE:
	            case NO_RESULTS_SEARCH_ITEM_TYPE:
	              seachElement.val('');
	              break;
	            case COUNTRY_SEARCH_ITEM_TYPE:
	            case CONTINENT_SEARCH_ITEM_TYPE:
	              seachElement.val(selectedSearchItem.name);
	              break;
	          }
	        }
	      }, 4);
	    });
	    listeners.screenWidthListener(this);
	  },
	  oncomplete() {
	    let globalEl = this.find('.global-data');
	    let networkEl = this.find('.network-data');
	    let projectsEl = this.find('.projects-data');
	    this.stickyObserve(globalEl);
	    this.stickyObserve(networkEl);
	    this.stickyObserve(projectsEl);
	  },
	  stickyObserve(el) {
	    let observer = new IntersectionObserver(([e]) => {
	      return e.target.classList.toggle('is-pinned', e.intersectionRatio < 1);
	    }, {
	      threshold: [1]
	    });
	    observer.observe(el);
	  },
	  handlePeriodSelecting() {
	    return periodData => {
	      this.set('periodData', periodData);
	    };
	  }
	};
	component$i.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "r-page",
	    m: [{
	      n: "noYield",
	      f: [{
	        t: 2,
	        r: "noYield"
	      }],
	      t: 13
	    }, {
	      n: "title",
	      f: [{
	        t: 2,
	        r: "title"
	      }],
	      t: 13
	    }, {
	      n: "description",
	      f: [{
	        t: 2,
	        r: "description"
	      }],
	      t: 13
	    }],
	    f: [{
	      t: 7,
	      e: "c-notification"
	    }, " ", {
	      t: 7,
	      e: "c-header"
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "p-statistics",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "div",
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "container",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "head-wrapper",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "head-wrapper_map-wrapper",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "head-map-bg",
	                  g: 1
	                }, {
	                  n: "width",
	                  f: "908",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "428",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/sponsors/map.svg"],
	                  t: 13
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "h2",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "head-title",
	                g: 1
	              }],
	              f: ["Statistics"]
	            }, " ", {
	              t: 7,
	              e: "p",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "head-text",
	                g: 1
	              }],
	              f: ["Global internet insights from jsDelivr, based on anonymous aggregated data"]
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "global-data",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "global-data_content-wrapper",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "global-data_info",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "global-data_info_icon",
	                  g: 1
	                }, {
	                  n: "width",
	                  f: "48",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "48",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/statistics/globalData.svg"],
	                  t: 13
	                }]
	              }, " ", {
	                t: 7,
	                e: "h2",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "global-data_info_title",
	                  g: 1
	                }],
	                f: ["Global data"]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  n: "class",
	                  f: ["global-data_info_settings-icon ", {
	                    t: 4,
	                    f: ["active"],
	                    n: 50,
	                    r: "showGlobalStickyMenu"
	                  }],
	                  t: 13
	                }, {
	                  n: ["click"],
	                  t: 70,
	                  f: {
	                    r: ["@this", "showGlobalStickyMenu"],
	                    s: "[_0.set(\"showGlobalStickyMenu\",!_1)]"
	                  }
	                }],
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: "width",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/statistics/setting.svg"],
	                    t: 13
	                  }]
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                n: "class",
	                f: ["data-range-ctrl ", {
	                  t: 4,
	                  f: ["global-data_visible"],
	                  n: 50,
	                  r: "showGlobalStickyMenu"
	                }],
	                t: 13
	              }],
	              f: [{
	                t: 7,
	                e: "c-periods-dropdown",
	                m: [{
	                  n: "selectedValue",
	                  f: [{
	                    t: 2,
	                    r: "periodData.periodValue"
	                  }],
	                  t: 13
	                }, {
	                  n: "selectHandler",
	                  f: [{
	                    t: 2,
	                    x: {
	                      r: ["@this"],
	                      s: "_0.handlePeriodSelecting()"
	                    }
	                  }],
	                  t: 13
	                }],
	                f: [],
	                p: {
	                  pinnedLabel: [{
	                    t: 7,
	                    e: "span",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "label-for-pinned",
	                      g: 1
	                    }],
	                    f: ["Data range"]
	                  }]
	                }
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "horizontal-divider",
	                g: 1
	              }]
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "container",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "c-network-provider-stats",
	            m: [{
	              n: "periodData",
	              f: [{
	                t: 2,
	                r: "periodData"
	              }],
	              t: 13
	            }]
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "grey",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "network-data",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "network-data_content-wrapper",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "network-data_info",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "network-data_info_icon",
	                  g: 1
	                }, {
	                  n: "width",
	                  f: "48",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "48",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/statistics/network.svg"],
	                  t: 13
	                }, {
	                  n: "loading",
	                  f: "lazy",
	                  t: 13,
	                  g: 1
	                }]
	              }, " ", {
	                t: 7,
	                e: "h2",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "network-data_info_title",
	                  g: 1
	                }],
	                f: ["Network data"]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  n: "class",
	                  f: ["network-data_info_settings-icon ", {
	                    t: 4,
	                    f: ["active"],
	                    n: 50,
	                    r: "showNetworkStickyMenu"
	                  }],
	                  t: 13
	                }, {
	                  n: ["click"],
	                  t: 70,
	                  f: {
	                    r: ["@this", "showNetworkStickyMenu"],
	                    s: "[_0.set(\"showNetworkStickyMenu\",!_1)]"
	                  }
	                }],
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: "width",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/statistics/setting.svg"],
	                    t: 13
	                  }]
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                n: "class",
	                f: ["network-data_action ", {
	                  t: 4,
	                  f: ["network-data_visible"],
	                  n: 50,
	                  r: "showNetworkStickyMenu"
	                }],
	                t: 13
	              }],
	              f: [{
	                t: 7,
	                e: "span",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "network-data_action_input-title",
	                  g: 1
	                }],
	                f: ["Filter for a specific country or a continent:"]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "search-block",
	                  g: 1
	                }],
	                f: [{
	                  t: 4,
	                  f: [{
	                    t: 7,
	                    e: "img",
	                    m: [{
	                      n: "class",
	                      f: [{
	                        t: 2,
	                        r: "searchDefaultIcon.class"
	                      }],
	                      t: 13
	                    }, {
	                      n: "width",
	                      f: [{
	                        t: 2,
	                        r: "searchDefaultIcon.width"
	                      }],
	                      t: 13
	                    }, {
	                      n: "height",
	                      f: [{
	                        t: 2,
	                        r: "searchDefaultIcon.height"
	                      }],
	                      t: 13
	                    }, {
	                      n: "src",
	                      f: [{
	                        t: 2,
	                        r: "searchDefaultIcon.src"
	                      }],
	                      t: 13
	                    }, {
	                      n: "loading",
	                      f: "lazy",
	                      t: 13,
	                      g: 1
	                    }]
	                  }],
	                  n: 50,
	                  r: "searchDefaultIcon"
	                }, " ", {
	                  t: 7,
	                  e: "input",
	                  m: [{
	                    n: "id",
	                    f: "search",
	                    t: 13
	                  }, {
	                    n: "class",
	                    f: "search",
	                    t: 13
	                  }, {
	                    n: "placeholder",
	                    f: [{
	                      t: 2,
	                      r: "searchPlaceholder"
	                    }],
	                    t: 13
	                  }, {
	                    n: "value",
	                    f: [{
	                      t: 2,
	                      r: "searchDisplayValue"
	                    }],
	                    t: 13
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "data-range-ctrl",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "c-periods-dropdown",
	                  m: [{
	                    n: "selectedValue",
	                    f: [{
	                      t: 2,
	                      r: "periodData.periodValue"
	                    }],
	                    t: 13
	                  }, {
	                    n: "selectHandler",
	                    f: [{
	                      t: 2,
	                      x: {
	                        r: ["@this"],
	                        s: "_0.handlePeriodSelecting()"
	                      }
	                    }],
	                    t: 13
	                  }],
	                  f: [],
	                  p: {
	                    pinnedLabel: [{
	                      t: 7,
	                      e: "span",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "label-for-pinned",
	                        g: 1
	                      }],
	                      f: ["Data range"]
	                    }]
	                  }
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "horizontal-divider",
	                g: 1
	              }]
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "container",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "c-network-request-chart",
	            m: [{
	              n: "__ready",
	              f: [{
	                t: 2,
	                r: "__ready"
	              }],
	              t: 13
	            }, {
	              n: "period",
	              f: [{
	                t: 2,
	                r: "periodData"
	              }],
	              t: 13
	            }, {
	              n: "country",
	              f: [{
	                t: 2,
	                r: "selectedCountry"
	              }],
	              t: 13
	            }, {
	              n: "continent",
	              f: [{
	                t: 2,
	                r: "selectedContinent"
	              }],
	              t: 13
	            }],
	            f: []
	          }, " ", {
	            t: 7,
	            e: "c-network-request-map",
	            m: [{
	              n: "__ready",
	              f: [{
	                t: 2,
	                r: "__ready"
	              }],
	              t: 13
	            }, {
	              n: "period",
	              f: [{
	                t: 2,
	                r: "periodData.periodValue"
	              }],
	              t: 13
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "tops",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "c-top-platform-browser",
	              m: [{
	                n: "__ready",
	                f: [{
	                  t: 2,
	                  r: "__ready"
	                }],
	                t: 13
	              }, {
	                n: "tableDataType",
	                f: "platform",
	                t: 13,
	                g: 1
	              }, {
	                n: "country",
	                f: [{
	                  t: 2,
	                  r: "selectedCountry"
	                }],
	                t: 13
	              }, {
	                n: "continent",
	                f: [{
	                  t: 2,
	                  r: "selectedContinent"
	                }],
	                t: 13
	              }, {
	                n: "period",
	                f: [{
	                  t: 2,
	                  r: "periodData.periodValue"
	                }],
	                t: 13
	              }],
	              f: []
	            }, " ", {
	              t: 7,
	              e: "c-top-platform-browser",
	              m: [{
	                n: "__ready",
	                f: [{
	                  t: 2,
	                  r: "__ready"
	                }],
	                t: 13
	              }, {
	                n: "tableDataType",
	                f: "browser",
	                t: 13,
	                g: 1
	              }, {
	                n: "country",
	                f: [{
	                  t: 2,
	                  r: "selectedCountry"
	                }],
	                t: 13
	              }, {
	                n: "continent",
	                f: [{
	                  t: 2,
	                  r: "selectedContinent"
	                }],
	                t: 13
	              }, {
	                n: "period",
	                f: [{
	                  t: 2,
	                  r: "periodData.periodValue"
	                }],
	                t: 13
	              }],
	              f: []
	            }]
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "projects-data",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "projects-data_content-wrapper",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "projects-data_info",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "projects-data_info_icon",
	                  g: 1
	                }, {
	                  n: "width",
	                  f: "48",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "48",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/statistics/projects.svg"],
	                  t: 13
	                }, {
	                  n: "loading",
	                  f: "lazy",
	                  t: 13,
	                  g: 1
	                }]
	              }, " ", {
	                t: 7,
	                e: "h2",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "projects-data_info_title",
	                  g: 1
	                }],
	                f: ["Projects statistics"]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  n: "class",
	                  f: ["projects-data_info_settings-icon ", {
	                    t: 4,
	                    f: ["active"],
	                    n: 50,
	                    r: "showProjectsStickyMenu"
	                  }],
	                  t: 13
	                }, {
	                  n: ["click"],
	                  t: 70,
	                  f: {
	                    r: ["@this", "showProjectsStickyMenu"],
	                    s: "[_0.set(\"showProjectsStickyMenu\",!_1)]"
	                  }
	                }],
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: "width",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/statistics/setting.svg"],
	                    t: 13
	                  }]
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                n: "class",
	                f: ["data-range-ctrl ", {
	                  t: 4,
	                  f: ["projects-data_visible"],
	                  n: 50,
	                  r: "showProjectsStickyMenu"
	                }],
	                t: 13
	              }],
	              f: [{
	                t: 7,
	                e: "c-periods-dropdown",
	                m: [{
	                  n: "selectedValue",
	                  f: [{
	                    t: 2,
	                    r: "periodData.periodValue"
	                  }],
	                  t: 13
	                }, {
	                  n: "selectHandler",
	                  f: [{
	                    t: 2,
	                    x: {
	                      r: ["@this"],
	                      s: "_0.handlePeriodSelecting()"
	                    }
	                  }],
	                  t: 13
	                }],
	                f: [],
	                p: {
	                  pinnedLabel: [{
	                    t: 7,
	                    e: "span",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "label-for-pinned",
	                      g: 1
	                    }],
	                    f: ["Data range"]
	                  }]
	                }
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "horizontal-divider",
	                g: 1
	              }]
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "container",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "c-statistics-project-table",
	            m: [{
	              n: "__ready",
	              f: [{
	                t: 2,
	                r: "__ready"
	              }],
	              t: 13
	            }, {
	              n: "title",
	              f: "Most popular projects",
	              t: 13,
	              g: 1
	            }, {
	              n: "period",
	              f: [{
	                t: 2,
	                r: "periodData.periodValue"
	              }],
	              t: 13
	            }],
	            f: []
	          }, " ", {
	            t: 9,
	            c: " <c-statistics-project-table\n\t\t\t\t\t__ready=\"{{ __ready }}\"\n\t\t\t\t\ttitle=\"Trending projects\"\n\t\t\t\t\tdataType=\"trending\"\n\t\t\t\t\tperiod=\"{{ periodData.periodValue }}\">\n\t\t\t\t</c-statistics-project-table> "
	          }]
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "c-footer"
	    }]
	  }],
	  e: {
	    "[_0.set(\"showGlobalStickyMenu\",!_1)]": function (_0, _1) {
	      return [_0.set("showGlobalStickyMenu", !_1)];
	    },
	    "_0.handlePeriodSelecting()": function (_0) {
	      return _0.handlePeriodSelecting();
	    },
	    "[_0.set(\"showNetworkStickyMenu\",!_1)]": function (_0, _1) {
	      return [_0.set("showNetworkStickyMenu", !_1)];
	    },
	    "[_0.set(\"showProjectsStickyMenu\",!_1)]": function (_0, _1) {
	      return [_0.set("showProjectsStickyMenu", !_1)];
	    }
	  }
	};
	component$i.exports.components = {
	  "c-periods-dropdown": periodsDropdown,
	  "c-statistics-project-table": statisticsProjectTable,
	  "c-top-platform-browser": topPlatformBrowser,
	  "c-network-request-map": networkRequestMap,
	  "c-network-request-chart": networkRequestChart,
	  "c-network-provider-stats": networkProviderStats,
	  "c-stats-table": statsTable,
	  "c-notification": notification,
	  "c-footer": footer,
	  "c-header": header,
	  "r-page": rPage
	};
	var statistics = ractive__default["default"].extend(component$i.exports);

	var component$h = {
	  exports: {}
	};
	component$h.exports = {
	  data() {
	    return {
	      title: 'Using SRI - jsDelivr'
	    };
	  }
	};
	component$h.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "r-page",
	    m: [{
	      n: "noYield",
	      f: [{
	        t: 2,
	        r: "noYield"
	      }],
	      t: 13
	    }, {
	      n: "title",
	      f: [{
	        t: 2,
	        r: "title"
	      }],
	      t: 13
	    }, {
	      n: "description",
	      f: [{
	        t: 2,
	        r: "description"
	      }],
	      t: 13
	    }],
	    f: [{
	      t: 7,
	      e: "c-notification"
	    }, " ", {
	      t: 7,
	      e: "c-header"
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "p-sri old-text-page",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "container",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "row",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "col-md-9",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "h1",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "page-title",
	                g: 1
	              }],
	              f: ["Using SRI with jsDelivr"]
	            }, " ", {
	              t: 7,
	              e: "section",
	              f: [{
	                t: 7,
	                e: "p",
	                f: [{
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    n: "target",
	                    f: "_blank",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "rel",
	                    f: "noopener noreferrer",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "href",
	                    f: "https://developer.mozilla.org/en-US/docs/Web/Security/Subresource_Integrity",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: ["Subresource Integrity (SRI)"]
	                }, " is a security feature that enables browsers to verify that files they fetch are delivered without unexpected manipulation. It works by allowing you to provide a cryptographic hash that a fetched file must match."]
	              }]
	            }, " ", {
	              t: 7,
	              e: "section",
	              f: [{
	                t: 7,
	                e: "h2",
	                f: ["When is it safe to use SRI with jsDelivr"]
	              }, " ", {
	                t: 7,
	                e: "p",
	                f: ["Because SRI verifies full contents of the file, changing even one byte will cause the verification to fail. For this reason, you must only use SRI with links that are guaranteed to never change. Only use SRI with full single-file links, and static versions. For example:"]
	              }, " ", {
	                t: 7,
	                e: "pre",
	                f: [{
	                  t: 7,
	                  e: "code",
	                  f: [{
	                    t: 2,
	                    x: {
	                      r: [],
	                      s: "\"<script src=\\\"https://cdn.jsdelivr.net/npm/jquery@3.2.1/dist/jquery.min.js\\\" integrity=\\\"sha256-hwg4gsxgFZhOsEEamdOYGBf13FyQuiTwlAQgxVSNgt4=\\\"></script>\""
	                    }
	                  }]
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "section",
	              f: [{
	                t: 7,
	                e: "h2",
	                f: ["Do NOT use SRI with"]
	              }, " ", {
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "href",
	                  f: "/features#alias",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "strong",
	                  f: ["version aliasing (version ranges)"]
	                }]
	              }, " ", {
	                t: 7,
	                e: "p",
	                f: ["The purpose of version aliasing is getting automatic updates. This obviously means the code can change any time."]
	              }, " ", {
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "href",
	                  f: "/features#default",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "strong",
	                  f: ["default files"]
	                }]
	              }, " ", {
	                t: 7,
	                e: "p",
	                f: ["Default file are automatically minified, so the reasons for minified files apply here as well."]
	              }, " ", {
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "href",
	                  f: "/features#minify",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "strong",
	                  f: ["files minified on-demand"]
	                }]
	              }, " ", {
	                t: 7,
	                e: "p",
	                f: ["Minifying the exact same source code multiple times might not result in the exact same generated code. While we store all generated files in our permanent storage, we might need to re-minify the file in certain situation, e.g., as a part of failover, if our storage provider goes down."]
	              }, " ", {
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "href",
	                  f: "/features#combine",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "strong",
	                  f: ["combined files"]
	                }]
	              }, " ", {
	                t: 7,
	                e: "p",
	                f: ["Combining the exact same source code multiple times might not result in the exact same generated code. There might be subtle changes over time, e.g. in added whitespace, caused by changes in our code. While we store all generated files in our permanent storage, we might need to re-combine the files in certain situation, e.g., as a part of failover, if our storage provider goes down."]
	              }]
	            }]
	          }]
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "c-footer"
	    }]
	  }],
	  e: {
	    "\"<script src=\\\"https://cdn.jsdelivr.net/npm/jquery@3.2.1/dist/jquery.min.js\\\" integrity=\\\"sha256-hwg4gsxgFZhOsEEamdOYGBf13FyQuiTwlAQgxVSNgt4=\\\"></script>\"": function () {
	      return "<script src=\"https://cdn.jsdelivr.net/npm/jquery@3.2.1/dist/jquery.min.js\" integrity=\"sha256-hwg4gsxgFZhOsEEamdOYGBf13FyQuiTwlAQgxVSNgt4=\"></script>";
	    }
	  }
	};
	component$h.exports.components = {
	  "c-notification": notification,
	  "c-footer": footer,
	  "c-header": header,
	  "r-page": rPage
	};
	var usingSriWithDynamicFiles = ractive__default["default"].extend(component$h.exports);

	var component$g = {
	  exports: {}
	};
	const ID_PREFIX$1 = 'id-';
	component$g.exports = {
	  data() {
	    return {
	      _,
	      html: '',
	      markdown: ''
	    };
	  },
	  oninit() {
	    if (!ractive__default["default"].isServer) {
	      app.injectGlobalStyle('https://cdn.jsdelivr.net/gh/highlightjs/cdn-release@11.7.0/build/styles/github.min.css');
	      Promise.all([
	      // eslint-disable-next-line n/no-missing-import
	      import('https://cdn.jsdelivr.net/npm/marked@4.2.12/+esm'),
	      // eslint-disable-next-line n/no-missing-import
	      import('https://cdn.jsdelivr.net/npm/@highlightjs/cdn-assets@11.7.0/es/highlight.min.js')]).then(([{
	        marked
	      }, {
	        default: hljs
	      }]) => {
	        marked.use({
	          renderer: {
	            table(...rows) {
	              return `<div class="table-responsive"><table class="table table-striped">${rows.join('')}</table></div>`;
	            }
	          }
	        });
	        marked.setOptions({
	          langPrefix: 'hljs language-',
	          headerIds: true,
	          headerPrefix: ID_PREFIX$1,
	          highlight(code, language) {
	            return hljs.getLanguage(language) ? hljs.highlightAuto(code, ['html', 'javascript', 'sh', 'bash']).value : code;
	          }
	        });
	        this.observe('markdown', md => {
	          this.set('html', marked.parse(md));
	        });
	      });
	    }
	  }
	};
	component$g.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      t: 13,
	      n: "class",
	      f: "c-markdown",
	      g: 1
	    }],
	    f: [{
	      t: 7,
	      e: "c-html",
	      m: [{
	        n: "html",
	        f: [{
	          t: 2,
	          r: "html"
	        }],
	        t: 13
	      }]
	    }]
	  }]
	};
	component$g.exports.components = {
	  "c-html": html
	};
	var markdown = ractive__default["default"].extend(component$g.exports);

	var component$f = {
	  exports: {}
	};
	component$f.exports = {
	  data() {
	    return {};
	  },
	  oninit() {
	    if (!ractive__default["default"].isServer && !this.get('@shared.tuText')) {
	      _.makeHTTPRequest({
	        url: 'https://raw.githubusercontent.com/jsdelivr/jsdelivr/master/Terms%20of%20Use.md',
	        rawResponse: true
	      }).then(response => {
	        this.set('@shared.tuText', response);
	      }).catch(() => {
	        this.set('@shared.tuText', `Failed to load the document. Please view it directly at:<br>https://github.com/jsdelivr/jsdelivr/blob/master/Terms%20of%20Use.md`);
	      });
	      _.makeHTTPRequest({
	        url: 'https://raw.githubusercontent.com/jsdelivr/jsdelivr/master/Privacy%20Policy.md',
	        rawResponse: true
	      }).then(response => {
	        this.set('@shared.ppText', response);
	      }).catch(() => {
	        this.set('@shared.ppText', `Failed to load the document. Please view it directly at:<br>https://github.com/jsdelivr/jsdelivr/blob/master/Privacy%20Policy.md`);
	      });
	      _.makeHTTPRequest({
	        url: 'https://raw.githubusercontent.com/jsdelivr/jsdelivr/master/Sub-Processors.md',
	        rawResponse: true
	      }).then(response => {
	        this.set('@shared.spText', response);
	      }).catch(() => {
	        this.set('@shared.spText', `Failed to load the document. Please view it directly at:<br>https://github.com/jsdelivr/jsdelivr/blob/master/Sub-Processors.md`);
	      });
	    }
	  }
	};
	component$f.exports.template = {
	  v: 4,
	  t: []
	};
	var githubMdDocumentsPrefetch = ractive__default["default"].extend(component$f.exports);

	var component$e = {
	  exports: {}
	};
	component$e.exports = {
	  data() {
	    return {
	      title: 'Terms & Policies - jsDelivr',
	      currentPolicy: 'terms-of-use'
	    };
	  },
	  onrender() {
	    if (!ractive__default["default"].isServer) {
	      listeners.stickySidebarScrollListener(this);
	    }
	  }
	};
	component$e.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "r-page",
	    m: [{
	      n: "noYield",
	      f: [{
	        t: 2,
	        r: "noYield"
	      }],
	      t: 13
	    }, {
	      n: "title",
	      f: [{
	        t: 2,
	        r: "title"
	      }],
	      t: 13
	    }, {
	      n: "description",
	      f: [{
	        t: 2,
	        r: "description"
	      }],
	      t: 13
	    }],
	    f: [{
	      t: 7,
	      e: "c-github-md-documents-prefetch"
	    }, " ", {
	      t: 7,
	      e: "c-notification"
	    }, " ", {
	      t: 7,
	      e: "c-header"
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "p-privacy-policy",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          n: "class",
	          f: ["please-wait-sign ", {
	            t: 4,
	            f: ["not-displayed"],
	            n: 50,
	            x: {
	              r: ["@shared.tuText", "@shared.ppText", "@shared.spText"],
	              s: "_0&&_1&&_2"
	            }
	          }],
	          t: 13
	        }],
	        f: ["Please wait while the document loads."]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          n: "class",
	          f: ["dropdown ", {
	            t: 4,
	            f: ["not-displayed"],
	            n: 51,
	            x: {
	              r: ["@shared.tuText", "@shared.ppText", "@shared.spText"],
	              s: "_0&&_1&&_2"
	            }
	          }],
	          t: 13
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "dropdown-toggle",
	            g: 1
	          }, {
	            n: "data-toggle",
	            f: "dropdown",
	            t: 13,
	            g: 1
	          }, {
	            n: "aria-haspopup",
	            f: "true",
	            t: 13,
	            g: 1
	          }, {
	            n: "aria-expanded",
	            f: "false",
	            t: 13,
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "span",
	            f: ["Navigation"]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "toggle-icon",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "toggle-bar",
	                g: 1
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "toggle-bar",
	                g: 1
	              }]
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "ul",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "dropdown-menu",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "li",
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "dropdown-subtitle",
	                g: 1
	              }],
	              f: ["Documents:"]
	            }]
	          }, " ", {
	            t: 7,
	            e: "li",
	            f: [{
	              t: 7,
	              e: "a",
	              m: [{
	                n: "href",
	                f: "/terms/terms-of-use",
	                t: 13,
	                g: 1
	              }, {
	                n: "class",
	                f: ["dropdown-item ", {
	                  t: 4,
	                  f: ["active"],
	                  n: 50,
	                  x: {
	                    r: ["currentPolicy"],
	                    s: "_0===\"terms-of-use\""
	                  }
	                }],
	                t: 13
	              }],
	              f: ["Terms of Use"]
	            }]
	          }, " ", {
	            t: 7,
	            e: "li",
	            f: [{
	              t: 7,
	              e: "a",
	              m: [{
	                n: "href",
	                f: "/terms/privacy-policy",
	                t: 13,
	                g: 1
	              }, {
	                n: "class",
	                f: ["dropdown-item ", {
	                  t: 4,
	                  f: ["active"],
	                  n: 50,
	                  x: {
	                    r: ["currentPolicy"],
	                    s: "_0===\"privacy-policy\""
	                  }
	                }],
	                t: 13
	              }],
	              f: ["Privacy Policy"]
	            }]
	          }, " ", {
	            t: 9,
	            c: "\t\t\t\t<li>"
	          }, {
	            t: 9,
	            c: "\t\t\t\t\t<div class=\"dropdown-subtitle\">Website - jsdelivr.com</div>"
	          }, " ", {
	            t: 9,
	            c: "\t\t\t\t</li>"
	          }, {
	            t: 9,
	            c: "\t\t\t\t<li>"
	          }, " ", {
	            t: 9,
	            c: "\t\t\t\t\t<a href=\"/terms/privacy-policy-jsdelivr-com\""
	          }, {
	            t: 9,
	            c: "\t\t\t\t\t\tclass=\"dropdown-item {{#if currentPolicy === 'privacy-policy-jsdelivr-com'}}active{{/if}}\">"
	          }, " ", {
	            t: 9,
	            c: "\t\t\t\t\t\tPrivacy Policy"
	          }, {
	            t: 9,
	            c: "\t\t\t\t\t</a>"
	          }, " ", {
	            t: 9,
	            c: "\t\t\t\t</li>"
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          n: "class",
	          f: ["page-content ", {
	            t: 4,
	            f: ["not-displayed"],
	            n: 51,
	            x: {
	              r: ["@shared.tuText", "@shared.ppText", "@shared.spText"],
	              s: "_0&&_1&&_2"
	            }
	          }],
	          t: 13
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "page-content_side-menu",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "menu-section",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "strong",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "section-title",
	                g: 1
	              }],
	              f: ["Documents:"]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "section-list",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                f: [{
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    n: "href",
	                    f: "/terms/terms-of-use",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "class",
	                    f: [{
	                      t: 4,
	                      f: ["active"],
	                      n: 50,
	                      x: {
	                        r: ["currentPolicy"],
	                        s: "_0===\"terms-of-use\""
	                      }
	                    }],
	                    t: 13
	                  }],
	                  f: ["Terms of Use"]
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                f: [{
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    n: "href",
	                    f: "/terms/privacy-policy",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "class",
	                    f: [{
	                      t: 4,
	                      f: ["active"],
	                      n: 50,
	                      x: {
	                        r: ["currentPolicy"],
	                        s: "_0===\"privacy-policy\""
	                      }
	                    }],
	                    t: 13
	                  }],
	                  f: ["Privacy Policy"]
	                }]
	              }]
	            }]
	          }, " ", {
	            t: 9,
	            c: "\t\t\t\t<div class=\"horizontal-divider\"></div>"
	          }, {
	            t: 9,
	            c: "\t\t\t\t<div class=\"menu-section\">"
	          }, " ", {
	            t: 9,
	            c: "\t\t\t\t\t<strong class=\"section-title\">Website - jsdelivr.com</strong>"
	          }, {
	            t: 9,
	            c: "\t\t\t\t\t<div class=\"section-list\">"
	          }, " ", {
	            t: 9,
	            c: "\t\t\t\t\t\t<a href=\"/terms/privacy-policy-jsdelivr-com\""
	          }, {
	            t: 9,
	            c: "\t\t\t\t\t\t\tclass=\"{{#if currentPolicy === 'privacy-policy-jsdelivr-com'}}active{{/if}}\">"
	          }, " ", {
	            t: 9,
	            c: "\t\t\t\t\t\t\t\tPrivacy Policy"
	          }, {
	            t: 9,
	            c: "\t\t\t\t\t\t</a>"
	          }, " ", {
	            t: 9,
	            c: "\t\t\t\t\t</div>"
	          }, {
	            t: 9,
	            c: "\t\t\t\t</div>"
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "page-content_main",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "h1",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "page-content_main_title",
	              g: 1
	            }],
	            f: ["Terms & Policies"]
	          }, " ", {
	            t: 4,
	            f: [{
	              t: 7,
	              e: "c-markdown",
	              m: [{
	                n: "markdown",
	                f: [{
	                  t: 2,
	                  r: "@shared.ppText"
	                }],
	                t: 13
	              }]
	            }],
	            n: 50,
	            x: {
	              r: ["currentPolicy"],
	              s: "_0===\"privacy-policy\""
	            }
	          }, {
	            t: 4,
	            f: [{
	              t: 7,
	              e: "c-markdown",
	              m: [{
	                n: "markdown",
	                f: [{
	                  t: 2,
	                  r: "@shared.spText"
	                }],
	                t: 13
	              }]
	            }, " "],
	            n: 50,
	            x: {
	              r: ["currentPolicy"],
	              s: "_0===\"sub-processors\""
	            },
	            l: 1
	          }, {
	            t: 4,
	            f: [" ", {
	              t: 7,
	              e: "c-markdown",
	              m: [{
	                n: "markdown",
	                f: [{
	                  t: 2,
	                  r: "@shared.tuText"
	                }],
	                t: 13
	              }]
	            }],
	            n: 51,
	            l: 1
	          }]
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "c-footer"
	    }]
	  }],
	  e: {
	    "_0&&_1&&_2": function (_0, _1, _2) {
	      return _0 && _1 && _2;
	    },
	    "_0===\"terms-of-use\"": function (_0) {
	      return _0 === "terms-of-use";
	    },
	    "_0===\"privacy-policy\"": function (_0) {
	      return _0 === "privacy-policy";
	    },
	    "_0===\"sub-processors\"": function (_0) {
	      return _0 === "sub-processors";
	    }
	  }
	};
	component$e.exports.components = {
	  "c-markdown": markdown,
	  "c-github-md-documents-prefetch": githubMdDocumentsPrefetch,
	  "c-notification": notification,
	  "c-footer": footer,
	  "c-header": header,
	  "r-page": rPage
	};
	var terms = ractive__default["default"].extend(component$e.exports);

	var isUrlValid = {
	  test: url => {
	    let pattern = /https?:\/\/cdn\.jsdelivr\.net\/.*/g;
	    return pattern.test(url);
	  },
	  getPathFromUrl: url => {
	    try {
	      let pattern = /https?:\/\/cdn\.jsdelivr\.net(.*)/;
	      let res = url.match(pattern);
	      return res[1];
	    } catch (e) {
	      return '/';
	    }
	  }
	};

	var component$d = {
	  exports: {}
	};
	component$d.exports = {
	  oncomplete() {
	    let pageUrlsEl = this.find('#purge-urls');
	    pageUrlsEl.addEventListener('input', e => {
	      e.target.style.height = 'auto';
	      e.target.style.height = (e.target.scrollHeight >= 80 ? e.target.scrollHeight : 80) + 'px';
	    });
	  },
	  data() {
	    return {
	      title: 'Purge CDN cache - jsDelivr',
	      purgingInProcess: false,
	      purgeErrorMsg: '',
	      results: [],
	      captchaToken: '',
	      proceedToCaptcha: false,
	      detailsDisplaying: false,
	      openedResultsList: [],
	      purgeBtnDisabled: true,
	      providerData
	    };
	  },
	  oninit() {
	    if (!ractive__default["default"].isServer) {
	      let recaptchaCallback = token => {
	        this.set('captchaToken', token);
	      };
	      window.recaptchaCallback = undefined;
	      _.onDocumentReady(() => {
	        window.recaptchaCallback = recaptchaCallback;
	      });
	      this.observe('captchaToken', token => {
	        if (token) {
	          this.purge();
	        }
	      });
	      this.observe('toggleOpenResult', data => {
	        if (typeof data === 'undefined') {
	          return;
	        }
	        let openedResultsList = this.get('openedResultsList');
	        let indexOfResult = openedResultsList.indexOf(data.newIdx);
	        if (indexOfResult === -1) {
	          openedResultsList.push(data.newIdx);
	        } else {
	          openedResultsList.splice(indexOfResult, 1);
	        }
	        if (!openedResultsList.length) {
	          this.set('detailsDisplaying', false);
	        } else {
	          this.set('detailsDisplaying', true);
	        }
	        this.set('openedResultsList', openedResultsList);
	      });
	      this.observe('urls', newValue => {
	        let paths = newValue.replace(/\n/g, ',');
	        let pathsArr = paths.split(',').map(p => p.trim()).filter(p => p);
	        if (pathsArr.length > 10) {
	          this.set('purgeErrorMsg', 'Allowed up to 10 URLs - one per line');
	          this.set('purgeBtnDisabled', true);
	          this.set('proceedToCaptcha', false);
	          this.set('captchaToken', '');
	        } else {
	          let isPathsValid = pathsArr.reduce((isValid, path) => {
	            if (!path) {
	              return isValid;
	            }
	            if (isUrlValid.test(path)) {
	              return isValid && true;
	            }
	            return false;
	          }, true);
	          if (isPathsValid) {
	            this.set('purgeErrorMsg', '');
	          } else {
	            this.set('purgeErrorMsg', 'Invalid URLs!');
	          }
	          if (pathsArr.length > 0 && isPathsValid) {
	            this.set('purgeBtnDisabled', false);
	          } else {
	            this.set('purgeBtnDisabled', true);
	            this.set('proceedToCaptcha', false);
	          }
	        }
	      });
	      this.observe('proceedToCaptcha', newValue => {
	        if (newValue) {
	          this.set('captchaToken', '');
	          this.set('results', []);
	        }
	      });
	      this.observe('detailsDisplaying', value => {
	        let resultsIdxs = [];
	        if (value) {
	          resultsIdxs = this.get('results').map((_, idx) => idx);
	        }
	        this.set('openedResultsList', resultsIdxs);
	      });
	    }
	  },
	  checkPurgeBtnStatus() {
	    if (this.get('purgeBtnDisabled')) {
	      return;
	    }
	    this.set('proceedToCaptcha', true);
	  },
	  getCDNstatus(id) {
	    return _.makeHTTPRequest({
	      url: `https://purge.jsdelivr.net/status/${id}`
	    });
	  },
	  purge() {
	    this.set('purgingInProcess', true);
	    this.set('purgeErrorMsg', '');
	    let paths = this.get('urls').replace(/\n/g, ',').split(',').map(p => p.trim()).filter(p => p);
	    if (!paths.length) {
	      this.set('purgingInProcess', false);
	      return;
	    }
	    paths = paths.map(path => {
	      return isUrlValid.getPathFromUrl(path);
	    });
	    if (paths.length > 10) {
	      this.set('purgingInProcess', false);
	      return;
	    }
	    _.makeHTTPRequest({
	      method: 'POST',
	      url: 'https://purge.jsdelivr.net/captcha',
	      body: {
	        'g-recaptcha-response': this.get('captchaToken'),
	        'path': paths
	      }
	    }).then(response => {
	      let intervalId = null;
	      intervalId = setInterval(() => {
	        this.getCDNstatus(response.id).then(data => {
	          if (data.status === 'finished') {
	            clearInterval(intervalId);
	            let results = Object.keys(data.paths).map(path => {
	              let providers = data.paths[path].providers ? Object.entries(data.paths[path].providers) : [];
	              let getProvidersStatus = providers => {
	                let failedProvidersStatus = '';
	                let amountOfFailed = providers.reduce((amountOfFailed, provider) => {
	                  if (provider[1] === true) {
	                    return amountOfFailed;
	                  }
	                  return amountOfFailed + 1;
	                }, 0);
	                switch (amountOfFailed) {
	                  case 1:
	                    failedProvidersStatus = 'One provider failed';
	                    break;
	                  case 2:
	                    failedProvidersStatus = 'Two providers failed';
	                    break;
	                  case 3:
	                    failedProvidersStatus = 'Three providers failed';
	                    break;
	                  case 4:
	                    failedProvidersStatus = 'Four providers failed';
	                    break;
	                  case 5:
	                    failedProvidersStatus = 'Five providers failed';
	                    break;
	                  default:
	                    failedProvidersStatus = 'Success';
	                }
	                return failedProvidersStatus;
	              };
	              let status = data.paths[path].throttled ? 'Throttled' : getProvidersStatus(providers);
	              return {
	                path,
	                status,
	                providers,
	                throttled: data.paths[path].throttled
	              };
	            });
	            this.set('results', results);
	            this.set('purgingInProcess', false);
	            this.set('proceedToCaptcha', false);
	            this.set('detailsDisplaying', false);
	            this.set('openedResultsList', []);
	          }
	        });
	      }, 1000);
	    }).catch(() => {
	      this.set('purgeErrorMsg', 'An error occurred while purging!');
	      this.set('purgingInProcess', false);
	      this.set('proceedToCaptcha', false);
	      this.set('detailsDisplaying', false);
	      this.set('openedResultsList', []);
	    });
	  }
	};
	component$d.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "r-page",
	    m: [{
	      n: "noYield",
	      f: [{
	        t: 2,
	        r: "noYield"
	      }],
	      t: 13
	    }, {
	      n: "title",
	      f: [{
	        t: 2,
	        r: "title"
	      }],
	      t: 13
	    }, {
	      n: "description",
	      f: [{
	        t: 2,
	        r: "description"
	      }],
	      t: 13
	    }],
	    f: [{
	      t: 7,
	      e: "c-notification"
	    }, " ", {
	      t: 7,
	      e: "c-header",
	      m: [{
	        n: "useWhiteLogos",
	        f: "true",
	        t: 13,
	        g: 1
	      }, {
	        n: "additionalClasses",
	        f: "header-with-orange-bg",
	        t: 13,
	        g: 1
	      }]
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "p-purge",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "c-header-gradient",
	        m: [{
	          n: "showMap",
	          f: [{
	            t: 2,
	            x: {
	              r: [],
	              s: "true"
	            }
	          }],
	          t: 13
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "content",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "section",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "content_heading",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "h1",
	            f: ["Purge jsDelivr CDN cache"]
	          }, " ", {
	            t: 7,
	            e: "h2",
	            f: ["Purge the cache of a @latest or version aliased URL to force your users to get the new updated version. Otherwise they might wait up to 7 days."]
	          }]
	        }, " ", {
	          t: 7,
	          e: "section",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "content_purge-form",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "textarea",
	            m: [{
	              n: "id",
	              f: "purge-urls",
	              t: 13
	            }, {
	              n: "class",
	              f: [{
	                t: 4,
	                f: ["textarea-error"],
	                n: 50,
	                r: "purgeErrorMsg"
	              }, {
	                t: 4,
	                f: [" loading"],
	                n: 50,
	                r: "purgingInProcess"
	              }],
	              t: 13
	            }, {
	              n: "placeholder",
	              f: "Enter up to 10 URLs - one per line",
	              t: 13
	            }, {
	              n: "value",
	              f: [{
	                t: 2,
	                r: "urls"
	              }],
	              t: 13
	            }],
	            f: ["\t\t\t\t"]
	          }, " ", {
	            t: 4,
	            f: [{
	              t: 7,
	              e: "a",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "animated",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "animation",
	                  g: 1
	                }]
	              }]
	            }],
	            n: 50,
	            r: "purgingInProcess"
	          }, {
	            t: 4,
	            f: [{
	              t: 7,
	              e: "a",
	              m: [{
	                n: "class",
	                f: ["btn-primary ", {
	                  t: 4,
	                  f: ["btn-primary-disabled"],
	                  n: 50,
	                  r: "purgeBtnDisabled"
	                }],
	                t: 13
	              }, {
	                n: ["click"],
	                t: 70,
	                f: {
	                  r: ["@this"],
	                  s: "[_0.checkPurgeBtnStatus()]"
	                }
	              }],
	              f: ["Purge now"]
	            }],
	            n: 51,
	            l: 1
	          }, " ", {
	            t: 4,
	            f: [{
	              t: 7,
	              e: "label",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "error",
	                g: 1
	              }],
	              f: [{
	                t: 2,
	                r: "purgeErrorMsg"
	              }]
	            }],
	            n: 50,
	            r: "purgeErrorMsg"
	          }, " ", {
	            t: 4,
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "recaptcha-wrapper",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "g-recaptcha",
	                  g: 1
	                }, {
	                  n: "id",
	                  f: "recaptcha-service",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "data-callback",
	                  f: "recaptchaCallback",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "data-sitekey",
	                  f: "6LdXrfkUAAAAAFkzRiSAV4MBvUfNR1aynq1ggATK",
	                  t: 13,
	                  g: 1
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "script",
	              m: [{
	                n: "type",
	                f: "text/javascript",
	                t: 13,
	                g: 1
	              }, {
	                n: "src",
	                f: "https://www.google.com/recaptcha/api.js?hl=en",
	                t: 13,
	                g: 1
	              }]
	            }],
	            n: 50,
	            r: "proceedToCaptcha"
	          }]
	        }, " ", {
	          t: 4,
	          f: [{
	            t: 7,
	            e: "section",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "content_purge-results",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "h2",
	              f: [{
	                t: 7,
	                e: "span",
	                f: ["Results"]
	              }, " ", {
	                t: 7,
	                e: "span",
	                m: [{
	                  n: ["click"],
	                  t: 70,
	                  f: {
	                    r: ["@this"],
	                    s: "[_0.toggle(\"detailsDisplaying\")]"
	                  }
	                }, {
	                  n: "class",
	                  f: ["results-toggle", {
	                    t: 4,
	                    f: [" hide-details"],
	                    n: 50,
	                    r: "detailsDisplaying"
	                  }],
	                  t: 13
	                }],
	                f: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: "width",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/icons/chevron-down.orange.svg"],
	                    t: 13
	                  }]
	                }, " ", {
	                  t: 4,
	                  f: ["Hide details"],
	                  n: 50,
	                  r: "detailsDisplaying"
	                }, {
	                  t: 4,
	                  f: ["Show details"],
	                  n: 51,
	                  l: 1
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "results-table",
	                g: 1
	              }],
	              f: [{
	                t: 4,
	                f: [{
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "results-item",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "div",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "item-descr",
	                      g: 1
	                    }, {
	                      n: ["click"],
	                      t: 70,
	                      f: {
	                        r: ["@this", "idx"],
	                        s: "[_0.set(\"toggleOpenResult\",{newIdx:_1})]"
	                      }
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "span",
	                      f: [{
	                        t: 2,
	                        r: "./path"
	                      }]
	                    }, " ", {
	                      t: 7,
	                      e: "div",
	                      m: [{
	                        n: "class",
	                        f: ["item-status ", {
	                          t: 4,
	                          f: ["success"],
	                          n: 50,
	                          x: {
	                            r: ["./status"],
	                            s: "_0===\"Success\""
	                          }
	                        }, {
	                          t: 4,
	                          f: ["failed"],
	                          n: 51,
	                          l: 1
	                        }, " ", {
	                          t: 4,
	                          f: ["opened"],
	                          n: 50,
	                          x: {
	                            r: ["openedResultsList", "idx"],
	                            s: "_0.includes(_1)"
	                          }
	                        }, " ", {
	                          t: 4,
	                          f: ["throttled"],
	                          n: 50,
	                          r: "./throttled"
	                        }],
	                        t: 13
	                      }],
	                      f: [{
	                        t: 2,
	                        r: "./status"
	                      }, " ", {
	                        t: 4,
	                        f: [{
	                          t: 7,
	                          e: "img",
	                          m: [{
	                            n: "width",
	                            f: "20",
	                            t: 13,
	                            g: 1
	                          }, {
	                            n: "height",
	                            f: "20",
	                            t: 13,
	                            g: 1
	                          }, {
	                            n: "src",
	                            f: [{
	                              t: 2,
	                              r: "@shared.assetsHost"
	                            }, "/img/icons/throttled.svg"],
	                            t: 13
	                          }]
	                        }],
	                        n: 50,
	                        r: "./throttled"
	                      }, {
	                        t: 4,
	                        f: [{
	                          t: 7,
	                          e: "img",
	                          m: [{
	                            t: 13,
	                            n: "class",
	                            f: "item-chevron",
	                            g: 1
	                          }, {
	                            n: "width",
	                            f: "20",
	                            t: 13,
	                            g: 1
	                          }, {
	                            n: "height",
	                            f: "20",
	                            t: 13,
	                            g: 1
	                          }, {
	                            n: "src",
	                            f: [{
	                              t: 2,
	                              r: "@shared.assetsHost"
	                            }, "/img/icons/chevron-down.svg"],
	                            t: 13
	                          }]
	                        }],
	                        n: 51,
	                        l: 1
	                      }]
	                    }]
	                  }, " ", {
	                    t: 4,
	                    f: [{
	                      t: 7,
	                      e: "div",
	                      m: [{
	                        n: "class",
	                        f: ["item-cdns ", {
	                          t: 4,
	                          f: ["opened"],
	                          n: 50,
	                          x: {
	                            r: ["openedResultsList", "idx"],
	                            s: "_0.includes(_1)"
	                          }
	                        }],
	                        t: 13
	                      }],
	                      f: [{
	                        t: 7,
	                        e: "hr"
	                      }, " ", {
	                        t: 7,
	                        e: "div",
	                        m: [{
	                          t: 13,
	                          n: "class",
	                          f: "item-cdns-items",
	                          g: 1
	                        }],
	                        f: [{
	                          t: 4,
	                          f: [{
	                            t: 7,
	                            e: "span",
	                            f: [{
	                              t: 4,
	                              f: [{
	                                t: 7,
	                                e: "img",
	                                m: [{
	                                  n: "width",
	                                  f: "24",
	                                  t: 13,
	                                  g: 1
	                                }, {
	                                  n: "height",
	                                  f: "24",
	                                  t: 13,
	                                  g: 1
	                                }, {
	                                  n: "src",
	                                  f: [{
	                                    t: 2,
	                                    r: "@shared.assetsHost"
	                                  }, "/img/icons/check-circle.full.svg"],
	                                  t: 13
	                                }]
	                              }],
	                              n: 50,
	                              x: {
	                                r: ["./1"],
	                                s: "_0===true"
	                              }
	                            }, {
	                              t: 4,
	                              f: [{
	                                t: 7,
	                                e: "img",
	                                m: [{
	                                  n: "width",
	                                  f: "24",
	                                  t: 13,
	                                  g: 1
	                                }, {
	                                  n: "height",
	                                  f: "24",
	                                  t: 13,
	                                  g: 1
	                                }, {
	                                  n: "src",
	                                  f: [{
	                                    t: 2,
	                                    r: "@shared.assetsHost"
	                                  }, "/img/icons/close.svg"],
	                                  t: 13
	                                }]
	                              }],
	                              n: 51,
	                              l: 1
	                            }, " ", {
	                              t: 7,
	                              e: "span",
	                              f: [{
	                                t: 2,
	                                rx: {
	                                  r: "~/providerData",
	                                  m: [{
	                                    t: 30,
	                                    n: "./0"
	                                  }, "name"]
	                                }
	                              }]
	                            }]
	                          }],
	                          n: 52,
	                          r: "./providers"
	                        }]
	                      }]
	                    }],
	                    n: 51,
	                    r: "./throttled"
	                  }]
	                }],
	                n: 52,
	                i: "idx",
	                r: "results"
	              }]
	            }]
	          }],
	          n: 50,
	          r: "results.length"
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "c-footer"
	    }]
	  }],
	  e: {
	    "true": function () {
	      return true;
	    },
	    "[_0.checkPurgeBtnStatus()]": function (_0) {
	      return [_0.checkPurgeBtnStatus()];
	    },
	    "[_0.toggle(\"detailsDisplaying\")]": function (_0) {
	      return [_0.toggle("detailsDisplaying")];
	    },
	    "[_0.set(\"toggleOpenResult\",{newIdx:_1})]": function (_0, _1) {
	      return [_0.set("toggleOpenResult", {
	        newIdx: _1
	      })];
	    },
	    "_0===\"Success\"": function (_0) {
	      return _0 === "Success";
	    },
	    "_0.includes(_1)": function (_0, _1) {
	      return _0.includes(_1);
	    },
	    "_0===true": function (_0) {
	      return _0 === true;
	    }
	  }
	};
	component$d.exports.components = {
	  "c-header-gradient": headerGradient,
	  "c-notification": notification,
	  "c-footer": footer,
	  "c-header": header,
	  "r-page": rPage
	};
	var purge = ractive__default["default"].extend(component$d.exports);

	var component$c = {
	  exports: {}
	};
	component$c.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      t: 13,
	      n: "class",
	      f: "c-spinner",
	      g: 1
	    }]
	  }]
	};
	var spinner = ractive__default["default"].extend(component$c.exports);

	var component$b = {
	  exports: {}
	};
	component$b.exports = {
	  decorators: {
	    autogrow(node, keypath) {
	      let $node = $(node).inputAutogrow({
	        maxWidth: 400,
	        trailingSpace: -20
	      });
	      let observer = this.observe(keypath, () => {
	        $node.trigger('autogrow');
	      }, {
	        defer: true
	      });
	      return {
	        teardown() {
	          $node.inputAutogrow('destroy');
	          observer.cancel();
	        }
	      };
	    }
	  },
	  computed: {
	    importName() {
	      return _.packageToImportName(this.get('name'));
	    },
	    jsFiddleJsCode() {
	      return `// See https://www.npmjs.com/package/${this.get('name')} documentation.\nimport * as ${this.get('importName')} from 'https://esm.run/${this.get('name')}';\n\nconsole.log(${this.get('importName')})\n`;
	    }
	  },
	  data() {
	    return {
	      name: 'd3',
	      title: 'esm.run by jsDelivr - A New-Age CDN for JavaScript modules',
	      description: 'Load modern JavaScript packages built for you on-demand. Works in modern web browsers, node.js, and deno.',
	      formatMs(value) {
	        return `${_.formatNumber(value)} ms`;
	      },
	      stats: [{
	        name: 'jsDelivr',
	        duration: 137,
	        requests: 32
	      }, {
	        name: 'Skypack',
	        duration: 532,
	        requests: 33
	      }, {
	        name: 'Unpkg',
	        duration: 1556,
	        requests: 660
	      }],
	      statsColumns: [{
	        width: '20%'
	      }, {
	        width: '20%'
	      }, {
	        width: '60%'
	      }],
	      statsKeys: ['duration', 'requests'],
	      statsMessage: 'Median of 10 benchmarks run on Feb 06, 2021 measuring the initial load time. To run a real-time benchmark with a package of your choice, use the button bellow.',
	      statsName: 'd3'
	    };
	  },
	  onrender() {
	    if (!this.isServer) {
	      this.updateSortedStats();
	      let ac = $(this.find('.package-name-input')).autocomplete({
	        hint: false
	      }, [{
	        source: (query, cb) => {
	          search(`${query}`, 0, 5).then(result => cb(result.response.hits, result.response)).catch(e => {
	            console.error(e);
	            cb([]);
	          });
	        },
	        displayKey: 'name'
	      }]).on('autocomplete:cursorchanged autocomplete:selected autocomplete:autocompleted', () => {
	        this.updateModel('name');
	      }).on('keyup', e => {
	        if (e.key === 'Enter') {
	          internal.close();
	        }
	      });

	      // This is an ugly hack and upgrading to a new version may break it.
	      let internal = ac.data('aaAutocomplete');
	      let originalSetCursor = internal.dropdown._setCursor;
	      internal.dropdown._setCursor = function (v) {
	        return originalSetCursor.call(this, v, false);
	      };
	      this.find('.package-name-input').focus();
	    }
	  },
	  run(name) {
	    if (this.get('loading')) {
	      return;
	    }
	    let providers = [{
	      name: 'jsDelivr',
	      url: `https://cdn.jsdelivr.net/npm/${name}/+esm`
	    }, {
	      name: 'Skypack',
	      url: `https://cdn.skypack.dev/${name}?min`
	    }, {
	      name: 'Unpkg',
	      url: `https://unpkg.com/${name}?module`,
	      countRequests(entries) {
	        let packageUriPattern = /^\/((?:@[^/@]+\/)?[^/@]+)(?:@?([^/]+))?(\/.*)?$/;
	        let semverPattern = /^(((\d+)\.(\d+)\.(\d+)(?:-([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?)(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?)$/;

	        // We are not able to detect redirects via the performance.getEntriesByType() API
	        // but we can simulate the unpkg behavior and count them by analyzing the requested URLs.
	        return entries.reduce((acc, entry) => {
	          let pathname = new URL(entry.name).pathname;
	          let [,, version, file] = packageUriPattern.exec(pathname);

	          // No static version in the URL => add +1 for a version redirect.
	          if (!semverPattern.test(version)) {
	            acc += 1;
	          }

	          // No explicit file in the URL => add +1 for a file redirect.
	          if (!file) {
	            acc += 1;
	          }
	          return acc + 1;
	        }, 0);
	      }
	    }];
	    let iframe = document.createElement('iframe');
	    iframe.classList.add('benchmark-iframe');
	    iframe.src = '/esm-benchmark';
	    document.win = window;
	    iframe.onload = () => {
	      window.runEsmBenchmark(providers).then(result => {
	        iframe.remove();
	        this.set('stats', result);
	        this.set('statsMessage', `Showing results from ${new Date().toGMTString()}.`);
	        this.set('statsName', this.get('name'));
	        this.set('loading', false);
	        this.updateSortedStats();
	      }).catch(console.error);
	    };
	    document.body.appendChild(iframe);
	    this.set('showInstructions', false);
	    this.set('loading', true);
	  },
	  showInstructions() {
	    if (!this.get('loading')) {
	      this.set('showInstructions', true);
	    }
	  },
	  updateSortedStats() {
	    let anyFailed = this.get('stats').some(result => result.error);
	    this.get('statsKeys').forEach(key => {
	      if (anyFailed) {
	        // Ractive somehow doesn't update correctly in this case, so we force it by setting an empty array first.
	        this.set(ractive__default["default"].joinKeys('sortedStats', key), []);
	      }
	      this.animate(ractive__default["default"].joinKeys('sortedStats', key), this.get('stats').slice().sort((a, b) => a[key] - b[key]));
	    });
	  }
	};
	component$b.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "r-page",
	    m: [{
	      n: "noYield",
	      f: [{
	        t: 2,
	        r: "noYield"
	      }],
	      t: 13
	    }, {
	      n: "title",
	      f: [{
	        t: 2,
	        r: "title"
	      }],
	      t: 13
	    }, {
	      n: "description",
	      f: [{
	        t: 2,
	        r: "description"
	      }],
	      t: 13
	    }],
	    f: [{
	      t: 7,
	      e: "c-header",
	      m: [{
	        n: "useWhiteLogos",
	        f: "true",
	        t: 13,
	        g: 1
	      }, {
	        n: "additionalClasses",
	        f: "header-with-orange-bg",
	        t: 13,
	        g: 1
	      }]
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "p-esm",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "c-header-gradient",
	        m: [{
	          n: "showMap",
	          f: [{
	            t: 2,
	            x: {
	              r: [],
	              s: "true"
	            }
	          }],
	          t: 13
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "content",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "section",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "content_title",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "h1",
	            f: ["A New-Age CDN for JavaScript modules"]
	          }, " ", {
	            t: 7,
	            e: "h2",
	            f: [{
	              t: 7,
	              e: "span",
	              f: ["Load modern JavaScript packages built for you on-demand"]
	            }, " ", {
	              t: 7,
	              e: "span",
	              f: ["Works in modern web browsers, node.js, and deno"]
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "section",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "content_main-box",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "code",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "code_import",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "span",
	                f: ["import"]
	              }, " ", {
	                t: 7,
	                e: "input",
	                m: [{
	                  n: "class",
	                  f: "package-name-input",
	                  t: 13
	                }, {
	                  n: "value",
	                  f: [{
	                    t: 2,
	                    r: "name"
	                  }],
	                  t: 13
	                }, {
	                  n: "placeholder",
	                  f: "name",
	                  t: 13
	                }, {
	                  n: "autogrow",
	                  t: 71,
	                  f: {
	                    r: [],
	                    s: "[\"name\"]"
	                  }
	                }, {
	                  n: "tabindex",
	                  f: "1",
	                  t: 13
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "code_from",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "span",
	                f: ["from 'https://esm.run/", {
	                  t: 2,
	                  x: {
	                    r: ["name"],
	                    s: "_0||\"name\""
	                  }
	                }, "';"]
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "buttons",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "form",
	              m: [{
	                n: "action",
	                f: "https://jsfiddle.net/api/post/library/pure",
	                t: 13,
	                g: 1
	              }, {
	                n: "method",
	                f: "POST",
	                t: 13,
	                g: 1
	              }, {
	                n: "target",
	                f: "_blank",
	                t: 13,
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "input",
	                m: [{
	                  n: "type",
	                  f: "hidden",
	                  t: 13
	                }, {
	                  n: "name",
	                  f: "title",
	                  t: 13
	                }, {
	                  n: "value",
	                  f: ["esm.run ", {
	                    t: 2,
	                    r: "name"
	                  }, " demo"],
	                  t: 13
	                }]
	              }, " ", {
	                t: 7,
	                e: "input",
	                m: [{
	                  n: "type",
	                  f: "hidden",
	                  t: 13
	                }, {
	                  n: "name",
	                  f: "js",
	                  t: 13
	                }, {
	                  n: "value",
	                  f: [{
	                    t: 2,
	                    r: "jsFiddleJsCode"
	                  }],
	                  t: 13
	                }, {
	                  t: 73,
	                  v: "t",
	                  f: "false"
	                }]
	              }, " ", {
	                t: 7,
	                e: "button",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "btn-primary",
	                  g: 1
	                }, {
	                  n: "type",
	                  f: "submit",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "tabindex",
	                  f: "2",
	                  t: 13,
	                  g: 1
	                }],
	                f: ["Open in JSFiddle"]
	              }, " ", {
	                t: 7,
	                e: "span",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "buttons-or",
	                  g: 1
	                }],
	                f: ["or"]
	              }, " ", {
	                t: 7,
	                e: "a",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "btn-secondary",
	                  g: 1
	                }, {
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "rel",
	                  f: "noopener noreferrer",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "href",
	                  f: ["https://esm.run/", {
	                    t: 2,
	                    r: "name"
	                  }],
	                  t: 13
	                }, {
	                  n: "tabindex",
	                  f: "3",
	                  t: 13,
	                  g: 1
	                }],
	                f: ["Open in a new tab"]
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "notice",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "span",
	              f: ["You can use esm.run links for quick demos or prototyping."]
	            }, " ", {
	              t: 7,
	              e: "span",
	              f: ["In production (once this feature is out of beta), always use our main domain."]
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "section",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "content_features",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "content_features_row",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "48",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "48",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/esm/global-multi-cdn.png"],
	                  t: 13
	                }, {
	                  n: "alt",
	                  f: "",
	                  t: 13,
	                  g: 1
	                }]
	              }, " ", {
	                t: 7,
	                e: "h4",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "feature-title",
	                  g: 1
	                }],
	                f: ["Global Multi-CDN powered by jsDelivr"]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "feature-content",
	                  g: 1
	                }],
	                f: ["esm.run is powered by jsDelivr and it's sponsors like Cloudflare, Fastly, Bunny, and GCore. This guarantees the best performance and uptime globally, including mainland China."]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "48",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "48",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/esm/permanent-storage.png"],
	                  t: 13
	                }, {
	                  n: "alt",
	                  f: "",
	                  t: 13,
	                  g: 1
	                }]
	              }, " ", {
	                t: 7,
	                e: "h4",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "feature-title",
	                  g: 1
	                }],
	                f: ["On-demand builds with permanent storage"]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "feature-content",
	                  g: 1
	                }],
	                f: ["Once built, files are stored in a permanent storage shared by all edge servers. That means future access will be always fast, even for files not yet cached at the CDN edge."]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "48",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "48",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/esm/optimized-delivery.png"],
	                  t: 13
	                }, {
	                  n: "alt",
	                  f: "",
	                  t: 13,
	                  g: 1
	                }]
	              }, " ", {
	                t: 7,
	                e: "h4",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "feature-title",
	                  g: 1
	                }],
	                f: ["State-of-the-art delivery"]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "feature-content",
	                  g: 1
	                }],
	                f: ["HTTP/2, HTTP/3, code minification, brotli compression, fine-tuned HTTP caching, dependency preloading - we always use all available options for improving the overall performance."]
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "a",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "btn-primary",
	              g: 1
	            }, {
	              n: "href",
	              f: "/?query=*%20type%3A%20esm",
	              t: 13,
	              g: 1
	            }],
	            f: ["Browse available packages"]
	          }]
	        }, " ", {
	          t: 7,
	          e: "section",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "content_performance",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "h2",
	            f: ["Performance comparison"]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "content_performance_row",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "c-stats-table",
	              m: [{
	                n: "title",
	                f: [{
	                  t: 2,
	                  r: "statsName"
	                }, " - load time"],
	                t: 13
	              }, {
	                n: "data",
	                f: [{
	                  t: 2,
	                  r: "sortedStats.duration"
	                }],
	                t: 13
	              }, {
	                n: "columns",
	                f: [{
	                  t: 2,
	                  r: "statsColumns"
	                }],
	                t: 13
	              }, {
	                n: "formatValue",
	                f: [{
	                  t: 2,
	                  r: "formatMs"
	                }],
	                t: 13
	              }, {
	                n: "valueKey",
	                f: "duration",
	                t: 13,
	                g: 1
	              }, {
	                n: "desc",
	                f: "false",
	                t: 13,
	                g: 1
	              }],
	              f: [],
	              p: {
	                column1: [{
	                  t: 4,
	                  f: [{
	                    t: 7,
	                    e: "span",
	                    m: [{
	                      t: 13,
	                      n: "style",
	                      f: "color: #f00;",
	                      g: 1
	                    }, {
	                      n: "tooltip",
	                      t: 71,
	                      f: {
	                        r: ["name"],
	                        s: "[\"Failed - \"+_0]"
	                      }
	                    }],
	                    f: ["Failed - ", {
	                      t: 2,
	                      r: "name"
	                    }]
	                  }],
	                  n: 50,
	                  r: "error"
	                }, {
	                  t: 4,
	                  f: [{
	                    t: 7,
	                    e: "span",
	                    f: [{
	                      t: 2,
	                      r: "name"
	                    }]
	                  }],
	                  n: 51,
	                  l: 1
	                }]
	              }
	            }, " ", {
	              t: 7,
	              e: "c-stats-table",
	              m: [{
	                n: "title",
	                f: [{
	                  t: 2,
	                  r: "statsName"
	                }, " - number of requests"],
	                t: 13
	              }, {
	                n: "data",
	                f: [{
	                  t: 2,
	                  r: "sortedStats.requests"
	                }],
	                t: 13
	              }, {
	                n: "columns",
	                f: [{
	                  t: 2,
	                  r: "statsColumns"
	                }],
	                t: 13
	              }, {
	                n: "valueKey",
	                f: "requests",
	                t: 13,
	                g: 1
	              }, {
	                n: "desc",
	                f: "false",
	                t: 13,
	                g: 1
	              }],
	              f: [],
	              p: {
	                column1: [{
	                  t: 4,
	                  f: [{
	                    t: 7,
	                    e: "span",
	                    m: [{
	                      t: 13,
	                      n: "style",
	                      f: "color: #f00;",
	                      g: 1
	                    }, {
	                      n: "tooltip",
	                      t: 71,
	                      f: {
	                        r: ["name"],
	                        s: "[\"Failed - \"+_0]"
	                      }
	                    }],
	                    f: ["Failed - ", {
	                      t: 2,
	                      r: "name"
	                    }]
	                  }],
	                  n: 50,
	                  r: "error"
	                }, {
	                  t: 4,
	                  f: [{
	                    t: 7,
	                    e: "span",
	                    f: [{
	                      t: 2,
	                      r: "name"
	                    }]
	                  }],
	                  n: 51,
	                  l: 1
	                }]
	              }
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "benchmark-text",
	              g: 1
	            }],
	            f: [{
	              t: 4,
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "benchmark-instructions",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "h4",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "benchmark-instructions-title",
	                    g: 1
	                  }],
	                  f: ["Please keep in mind the following to get correct benchmark results:"]
	                }, " ", {
	                  t: 7,
	                  e: "ol",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "benchmark-instructions-list",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "li",
	                    f: ["There is currently no way for our code to bypass browser caching. To benchmark the real network performance, you need to open you browser's DevTools and disable HTTP caching. If you run the benchmark with caching enabled, the results show the efficiency of the caching strategy employed by each service - this is also useful, just make sure you understand the difference."]
	                  }, " ", {
	                    t: 7,
	                    e: "li",
	                    f: ["On the first run, it is possible that one service will have some files already cached at the edge server closest to you and other services will not. Always run the benchmark at least twice and disregard the results from the first run."]
	                  }]
	                }]
	              }],
	              n: 50,
	              r: "~/showInstructions"
	            }, {
	              t: 4,
	              f: [{
	                t: 7,
	                e: "div",
	                f: [{
	                  t: 4,
	                  f: [{
	                    t: 7,
	                    e: "c-spinner"
	                  }],
	                  n: 50,
	                  r: "~/loading"
	                }, {
	                  t: 4,
	                  f: [{
	                    t: 7,
	                    e: "div",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "stats-message",
	                      g: 1
	                    }],
	                    f: [{
	                      t: 2,
	                      r: "statsMessage"
	                    }]
	                  }],
	                  n: 51,
	                  l: 1
	                }]
	              }],
	              n: 51,
	              l: 1
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "benchmark-buttons",
	              g: 1
	            }],
	            f: [{
	              t: 4,
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "btn-primary i-read-instr",
	                  g: 1
	                }, {
	                  n: ["click"],
	                  t: 70,
	                  f: {
	                    r: ["@this", "name"],
	                    s: "[_0.run(_1)]"
	                  }
	                }],
	                f: ["I read the instructions - run the benchmark"]
	              }],
	              n: 50,
	              r: "~/showInstructions"
	            }, {
	              t: 4,
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "class",
	                  f: ["btn-primary ", {
	                    t: 4,
	                    f: ["loading"],
	                    n: 50,
	                    r: "loading"
	                  }],
	                  t: 13
	                }, {
	                  n: ["click"],
	                  t: 70,
	                  f: {
	                    r: ["@this"],
	                    s: "[_0.showInstructions()]"
	                  }
	                }, {
	                  n: "disabled",
	                  f: [{
	                    t: 2,
	                    r: "loading"
	                  }],
	                  t: 13
	                }],
	                f: ["Run benchmark"]
	              }],
	              n: 51,
	              l: 1
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "c-new-infographic-banner"
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "c-footer"
	    }]
	  }],
	  e: {
	    "true": function () {
	      return true;
	    },
	    "[\"name\"]": function () {
	      return ["name"];
	    },
	    "_0||\"name\"": function (_0) {
	      return _0 || "name";
	    },
	    "[\"Failed - \"+_0]": function (_0) {
	      return ["Failed - " + _0];
	    },
	    "[_0.run(_1)]": function (_0, _1) {
	      return [_0.run(_1)];
	    },
	    "[_0.showInstructions()]": function (_0) {
	      return [_0.showInstructions()];
	    }
	  }
	};
	component$b.exports.components = {
	  "c-header-gradient": headerGradient,
	  "c-footer": footer,
	  "c-header": header,
	  "c-spinner": spinner,
	  "c-stats-table": statsTable,
	  "c-new-infographic-banner": newInfographicBanner,
	  "r-page": rPage
	};
	var esm = ractive__default["default"].extend(component$b.exports);

	var component$a = {
	  exports: {}
	};
	const DATA_TYPE_UPDATES = 'updates';
	const DATA_TYPE_DEALS = 'deals';
	const DATA_TYPE_NUMBERS = 'numbers';
	component$a.exports = {
	  data() {
	    return {
	      title: 'Our History - jsDelivr',
	      description: 'History and milestones',
	      eventsData: [{
	        year: '2024',
	        events: [{
	          month: 'September',
	          data: {
	            text: '<a target="_blank" rel="noopener noreferrer" href="https://dash.globalping.io/">Globalping Dashboard</a> goes live with extra benefits for registered users and sponsors',
	            type: DATA_TYPE_UPDATES
	          }
	        }, {
	          month: 'March',
	          data: {
	            text: 'Served 260 billion monthly requests, exceeding a 8.5B / day average',
	            type: DATA_TYPE_NUMBERS
	          }
	        }]
	      }, {
	        year: '2023',
	        events: [{
	          month: 'May',
	          data: {
	            text: '<a href="https://globalping.io/">Globalping</a> goes live! Includes CLI and Slack App',
	            type: DATA_TYPE_UPDATES
	          }
	        }, {
	          month: 'April',
	          data: {
	            text: 'jsDelivr joined the <a target="_blank" rel="noopener noreferrer" href="https://cdnalliance.org/">CDN Alliance</a> as an official member',
	            type: DATA_TYPE_DEALS,
	            img: {
	              name: 'cdn-alliance-logo',
	              widthLarge: '234',
	              widthSmall: '32',
	              ext: '.svg'
	            }
	          }
	        }, {
	          month: 'February',
	          data: {
	            text: 'Served 200 billion monthly requests for the first time',
	            type: DATA_TYPE_NUMBERS
	          }
	        }, {
	          month: 'January',
	          data: {
	            text: 'Website redesigned to support new ESM features and provide more information about packages',
	            type: DATA_TYPE_UPDATES
	          }
	        }]
	      }, {
	        year: '2022',
	        events: [{
	          month: 'December',
	          data: {
	            text: 'New DNS system and simplified Multi-CDN routing for better performance and availability',
	            type: DATA_TYPE_UPDATES
	          }
	        }, {
	          month: 'December',
	          data: {
	            text: 'Served 180B requests, reaching a 6B / day average',
	            type: DATA_TYPE_NUMBERS
	          }
	        }, {
	          month: 'August',
	          data: {
	            text: 'Gcore joins as a sponsor',
	            type: DATA_TYPE_DEALS,
	            img: {
	              name: 'g-core',
	              widthLarge: '148',
	              widthSmall: '74',
	              ext: '.svg'
	            }
	          }
	        }, {
	          month: 'July',
	          data: {
	            text: '<a href="https://github.com/jsdelivr/globalping" >Globalping</a> launches in Beta',
	            type: DATA_TYPE_UPDATES,
	            img: {
	              name: 'globalping',
	              widthLarge: '208',
	              widthSmall: '104',
	              ext: '.svg'
	            }
	          }
	        }]
	      }, {
	        year: '2021',
	        events: [{
	          month: 'October',
	          data: {
	            text: 'On-the-fly SVG optimization goes live',
	            type: DATA_TYPE_UPDATES
	          }
	        }, {
	          month: 'September',
	          data: {
	            text: 'Served 130B requests, 6 PB of bandwidth per month',
	            type: DATA_TYPE_NUMBERS
	          }
	        }, {
	          month: 'May',
	          data: {
	            text: 'RawGit CDN becomes part of jsDelivr',
	            type: DATA_TYPE_DEALS,
	            img: {
	              name: 'rawgit',
	              widthLarge: '68',
	              widthSmall: '52',
	              ext: '.png'
	            }
	          }
	        }, {
	          month: 'February',
	          data: {
	            text: 'BunnyCDN joins as a sponsor',
	            type: DATA_TYPE_DEALS,
	            img: {
	              name: 'bunny',
	              widthLarge: '148',
	              widthSmall: '104',
	              ext: '.svg'
	            }
	          }
	        }]
	      }, {
	        year: '2020',
	        events: [{
	          month: 'October',
	          data: {
	            text: '<a href="/esm">esm.run</a> launches to make jsDelivr a first choice CDN for ES modules',
	            type: DATA_TYPE_UPDATES
	          }
	        }, {
	          month: 'October',
	          data: {
	            text: '<a href="/blog/jsdelivr-welcomes-bootstrapcdn/" class="router-ignore">BootstrapCDN</a> becomes part of jsDelivr',
	            type: DATA_TYPE_DEALS,
	            img: {
	              name: 'bootstrap',
	              widthLarge: '147',
	              widthSmall: '104',
	              ext: '.png'
	            }
	          }
	        }, {
	          month: 'October',
	          data: {
	            text: '<a href="/oss-cdn/pyodide">Pyodide</a> becomes powered by jsDelivr, speeding up WASM delivery',
	            type: DATA_TYPE_DEALS,
	            img: {
	              name: 'pyodide',
	              widthLarge: '105',
	              widthSmall: '63',
	              ext: '.png'
	            }
	          }
	        }, {
	          month: 'May',
	          data: {
	            text: '<a href="/oss-cdn/cocoa">CocoaPods</a> becomes powered by jsDelivr, speeding up the installation of packages',
	            type: DATA_TYPE_DEALS,
	            img: {
	              name: 'cocoapods',
	              widthLarge: '147',
	              widthSmall: '104',
	              ext: '.png'
	            }
	          }
	        }]
	      }, {
	        year: '2019',
	        events: [{
	          month: 'October',
	          data: {
	            text: 'Served 60B requests, reaching a 2B / day average',
	            type: DATA_TYPE_NUMBERS
	          }
	        }, {
	          month: 'May',
	          data: {
	            text: 'The jsDelivr team builds PerfOps, a commercial service to improve multi-CDN routing',
	            type: DATA_TYPE_DEALS,
	            img: {
	              name: 'perfops',
	              widthLarge: '147',
	              widthSmall: '104',
	              ext: '.svg'
	            }
	          }
	        }]
	      }, {
	        year: '2018',
	        events: [{
	          month: 'October',
	          data: {
	            text: 'Plugins for Atom, IntelliJ, and Visual Studio released',
	            type: DATA_TYPE_UPDATES
	          }
	        }, {
	          month: 'September',
	          data: {
	            text: 'Served 30 billion requests per month, reaching a daily average of 1B for the first time',
	            type: DATA_TYPE_NUMBERS
	          }
	        }]
	      }, {
	        year: '2017',
	        events: [{
	          month: 'August',
	          data: {
	            text: 'Website rebuilt to support the new automated system that works with NPM and GitHub directly.',
	            type: DATA_TYPE_UPDATES
	          }
	        }, {
	          month: 'July',
	          data: {
	            text: 'Data API launches, providing detailed download statistics',
	            type: DATA_TYPE_UPDATES
	          }
	        }, {
	          month: 'May',
	          data: {
	            text: 'Fully automated npm and GitHub proxies launch',
	            type: DATA_TYPE_UPDATES
	          }
	        }, {
	          month: 'April',
	          data: {
	            text: 'Fastly joins as a sponsor',
	            type: DATA_TYPE_DEALS,
	            img: {
	              name: 'fastly',
	              widthLarge: '84',
	              widthSmall: '50',
	              ext: '.svg'
	            }
	          }
	        }]
	      }, {
	        year: '2016',
	        events: [{
	          month: 'April',
	          data: {
	            text: 'OSSCDN becomes part of jsDelivr',
	            type: DATA_TYPE_UPDATES
	          }
	        }, {
	          month: 'February',
	          data: {
	            text: 'Martin Kolárik joins as core developer',
	            type: DATA_TYPE_DEALS,
	            img: {
	              name: 'martin-kolarik',
	              widthLarge: '80',
	              widthSmall: '56',
	              ext: '.png',
	              class: 'img-rounded'
	            }
	          }
	        }]
	      }, {
	        year: '2015',
	        events: [{
	          month: 'November',
	          data: {
	            text: 'Served 7 billion requests, 132 TB per month',
	            type: DATA_TYPE_NUMBERS
	          }
	        }, {
	          month: 'September',
	          data: {
	            text: 'Quantil joins as a sponsor, adds locations in mainland China',
	            type: DATA_TYPE_DEALS,
	            img: {
	              name: 'quantil',
	              widthLarge: '105',
	              widthSmall: '53',
	              ext: '.png'
	            }
	          }
	        }, {
	          month: 'September',
	          data: {
	            text: 'Complete redesign of the website',
	            type: DATA_TYPE_UPDATES
	          }
	        }]
	      }, {
	        year: '2014',
	        events: [{
	          month: 'December',
	          data: {
	            text: 'NS1 joins as a sponsor',
	            type: DATA_TYPE_DEALS,
	            img: {
	              name: 'ns1',
	              widthLarge: '68',
	              widthSmall: '52',
	              ext: '.svg'
	            }
	          }
	        }, {
	          month: 'December',
	          data: {
	            text: 'WordPress plugins proxy launches',
	            type: DATA_TYPE_UPDATES
	          }
	        }, {
	          month: 'November',
	          data: {
	            text: 'Purge API launches',
	            type: DATA_TYPE_UPDATES
	          }
	        }, {
	          month: 'July',
	          data: {
	            text: 'Serving multiple files in one response possible thanks to /g/',
	            type: DATA_TYPE_UPDATES
	          }
	        }, {
	          month: 'June',
	          data: {
	            text: 'Automated project updates via libgrabber',
	            type: DATA_TYPE_UPDATES
	          }
	        }, {
	          month: 'April',
	          data: {
	            text: 'jsDelivr becomes the fastest open-source CDN according to CDNPerf',
	            type: DATA_TYPE_UPDATES
	          }
	        }, {
	          month: 'March',
	          data: {
	            text: 'Cloudflare joins as a sponsor',
	            type: DATA_TYPE_DEALS,
	            img: {
	              name: 'cloudflare',
	              widthLarge: '118',
	              widthSmall: '90',
	              ext: '.svg'
	            }
	          }
	        }]
	      }, {
	        year: '2013',
	        events: [{
	          month: 'December',
	          data: {
	            text: 'Public data API launches',
	            type: DATA_TYPE_UPDATES
	          }
	        }, {
	          month: 'June',
	          data: {
	            text: 'Cedexis joins as a sponsor, allows multi-CDN routing based on RUM',
	            type: DATA_TYPE_DEALS,
	            img: {
	              name: 'cedexis',
	              widthLarge: '119',
	              widthSmall: '76',
	              ext: '.png'
	            }
	          }
	        }, {
	          month: 'May',
	          data: {
	            text: 'CDN.NET joins as a sponsor',
	            type: DATA_TYPE_DEALS,
	            img: {
	              name: 'cdnnet',
	              widthLarge: '118',
	              widthSmall: '90',
	              ext: '.png'
	            }
	          }
	        }]
	      }, {
	        year: '2012',
	        events: [{
	          month: 'June',
	          data: {
	            text: 'MaxCDN joins as a sponsor',
	            type: DATA_TYPE_DEALS,
	            img: {
	              name: 'maxcdn',
	              widthLarge: '132',
	              widthSmall: '106',
	              ext: '.svg'
	            }
	          }
	        }, {
	          month: 'May',
	          data: {
	            text: 'Dmitriy Akulov founds jsDelivr',
	            type: DATA_TYPE_DEALS,
	            img: {
	              name: 'dmitriy-akulov',
	              widthLarge: '80',
	              widthSmall: '56',
	              ext: '.png',
	              class: 'img-rounded'
	            }
	          }
	        }]
	      }].map((yearData, index, years) => {
	        let before = years.slice(0, index).reduce((acc, val) => acc + val.events.length, 0);
	        return {
	          ...yearData,
	          events: yearData.events.map((event, index) => {
	            return {
	              ...event,
	              index: index + before
	            };
	          })
	        };
	      })
	    };
	  }
	};
	component$a.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "r-page",
	    m: [{
	      n: "noYield",
	      f: [{
	        t: 2,
	        r: "noYield"
	      }],
	      t: 13
	    }, {
	      n: "title",
	      f: [{
	        t: 2,
	        r: "title"
	      }],
	      t: 13
	    }, {
	      n: "description",
	      f: [{
	        t: 2,
	        r: "description"
	      }],
	      t: 13
	    }],
	    f: [{
	      t: 7,
	      e: "c-notification"
	    }, " ", {
	      t: 7,
	      e: "c-header",
	      m: [{
	        n: "useWhiteLogos",
	        f: "true",
	        t: 13,
	        g: 1
	      }, {
	        n: "additionalClasses",
	        f: "header-with-orange-bg",
	        t: 13,
	        g: 1
	      }]
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "p-history",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "c-header-gradient",
	        m: [{
	          n: "showMap",
	          f: [{
	            t: 2,
	            x: {
	              r: [],
	              s: "true"
	            }
	          }],
	          t: 13
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "navigation",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "a",
	          m: [{
	            n: "href",
	            f: "/about",
	            t: 13,
	            g: 1
	          }],
	          f: ["About Us"]
	        }, " ", {
	          t: 7,
	          e: "a",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "active",
	            g: 1
	          }, {
	            n: "href",
	            f: "/history",
	            t: 13,
	            g: 1
	          }],
	          f: ["Our History"]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "p-history_container",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "p-history_container_title",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "span",
	            f: ["jsDelivr over the years"]
	          }, " ", {
	            t: 7,
	            e: "span",
	            f: ["Our History"]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "p-history_container_content",
	            g: 1
	          }],
	          f: [{
	            t: 4,
	            f: [{
	              t: 7,
	              e: "section",
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "year",
	                  g: 1
	                }],
	                f: [{
	                  t: 2,
	                  r: "year"
	                }]
	              }, " ", {
	                t: 4,
	                f: [{
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "event-block",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "div",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "event-block_month",
	                      g: 1
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "div",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "binding",
	                        g: 1
	                      }]
	                    }, " ", {
	                      t: 7,
	                      e: "div",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "month",
	                        g: 1
	                      }],
	                      f: [{
	                        t: 2,
	                        r: "month"
	                      }]
	                    }, " ", {
	                      t: 7,
	                      e: "div",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "binding",
	                        g: 1
	                      }]
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "div",
	                    m: [{
	                      n: "class",
	                      f: ["event-block_main ", {
	                        t: 2,
	                        x: {
	                          r: ["index"],
	                          s: "_0%2?\"pos-right\":\"pos-left\""
	                        }
	                      }],
	                      t: 13
	                    }],
	                    f: [{
	                      t: 4,
	                      f: [{
	                        t: 7,
	                        e: "img",
	                        m: [{
	                          t: 13,
	                          n: "class",
	                          f: "event-block_main_type-icon",
	                          g: 1
	                        }, {
	                          n: "src",
	                          f: [{
	                            t: 2,
	                            r: "@shared.assetsHost"
	                          }, "/img/history/", {
	                            t: 2,
	                            r: "data.type"
	                          }, ".svg"],
	                          t: 13
	                        }]
	                      }],
	                      n: 50,
	                      r: "data.type"
	                    }, " ", {
	                      t: 4,
	                      f: [{
	                        t: 7,
	                        e: "div",
	                        m: [{
	                          t: 13,
	                          n: "class",
	                          f: "event-block_main_content",
	                          g: 1
	                        }],
	                        f: [{
	                          t: 7,
	                          e: "span",
	                          f: [{
	                            t: 3,
	                            r: "data.text"
	                          }]
	                        }, " ", {
	                          t: 4,
	                          f: [{
	                            t: 7,
	                            e: "img",
	                            m: [{
	                              n: "class",
	                              f: [{
	                                t: 2,
	                                r: "data.img.class"
	                              }],
	                              t: 13
	                            }, {
	                              n: "width",
	                              f: [{
	                                t: 2,
	                                r: "data.img.widthSmall"
	                              }],
	                              t: 13
	                            }, {
	                              n: "src",
	                              f: [{
	                                t: 2,
	                                r: "@shared.assetsHost"
	                              }, "/img/history/", {
	                                t: 2,
	                                r: "data.img.name"
	                              }, {
	                                t: 2,
	                                r: "data.img.ext"
	                              }],
	                              t: 13
	                            }]
	                          }],
	                          n: 50,
	                          x: {
	                            r: ["data.img", "data.img.ext"],
	                            s: "_0&&_1===\".svg\""
	                          }
	                        }, {
	                          t: 4,
	                          f: [{
	                            t: 7,
	                            e: "img",
	                            m: [{
	                              n: "class",
	                              f: [{
	                                t: 2,
	                                r: "data.img.class"
	                              }],
	                              t: 13
	                            }, {
	                              n: "width",
	                              f: [{
	                                t: 2,
	                                r: "data.img.widthSmall"
	                              }],
	                              t: 13
	                            }, {
	                              n: "src",
	                              f: [{
	                                t: 2,
	                                r: "@shared.assetsHost"
	                              }, "/img/history/", {
	                                t: 2,
	                                r: "data.img.name"
	                              }, {
	                                t: 2,
	                                r: "data.img.ext"
	                              }],
	                              t: 13
	                            }, {
	                              n: "srcset",
	                              f: [{
	                                t: 2,
	                                r: "@shared.assetsHost"
	                              }, "/img/history/", {
	                                t: 2,
	                                r: "data.img.name"
	                              }, "@2x", {
	                                t: 2,
	                                r: "data.img.ext"
	                              }, " 2x"],
	                              t: 13
	                            }]
	                          }],
	                          n: 50,
	                          x: {
	                            r: ["data.img", "data.img.ext"],
	                            s: "_0&&_1===\".png\""
	                          },
	                          l: 1
	                        }]
	                      }],
	                      n: 50,
	                      r: "data.text"
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "div",
	                    m: [{
	                      n: "class",
	                      f: ["event-block_relation ", {
	                        t: 2,
	                        x: {
	                          r: ["index"],
	                          s: "_0%2?\"pos-left\":\"pos-right\""
	                        }
	                      }],
	                      t: 13
	                    }],
	                    f: [{
	                      t: 4,
	                      f: [{
	                        t: 7,
	                        e: "img",
	                        m: [{
	                          n: "class",
	                          f: [{
	                            t: 2,
	                            r: "data.img.class"
	                          }],
	                          t: 13
	                        }, {
	                          n: "width",
	                          f: [{
	                            t: 2,
	                            r: "data.img.widthLarge"
	                          }],
	                          t: 13
	                        }, {
	                          n: "src",
	                          f: [{
	                            t: 2,
	                            r: "@shared.assetsHost"
	                          }, "/img/history/", {
	                            t: 2,
	                            r: "data.img.name"
	                          }, {
	                            t: 2,
	                            r: "data.img.ext"
	                          }],
	                          t: 13
	                        }]
	                      }],
	                      n: 50,
	                      x: {
	                        r: ["data.img", "data.img.ext"],
	                        s: "_0&&_1===\".svg\""
	                      }
	                    }, {
	                      t: 4,
	                      f: [{
	                        t: 7,
	                        e: "img",
	                        m: [{
	                          n: "class",
	                          f: [{
	                            t: 2,
	                            r: "data.img.class"
	                          }],
	                          t: 13
	                        }, {
	                          n: "width",
	                          f: [{
	                            t: 2,
	                            r: "data.img.widthLarge"
	                          }],
	                          t: 13
	                        }, {
	                          n: "src",
	                          f: [{
	                            t: 2,
	                            r: "@shared.assetsHost"
	                          }, "/img/history/", {
	                            t: 2,
	                            r: "data.img.name"
	                          }, {
	                            t: 2,
	                            r: "data.img.ext"
	                          }],
	                          t: 13
	                        }, {
	                          n: "srcset",
	                          f: [{
	                            t: 2,
	                            r: "@shared.assetsHost"
	                          }, "/img/history/", {
	                            t: 2,
	                            r: "data.img.name"
	                          }, "@2x", {
	                            t: 2,
	                            r: "data.img.ext"
	                          }, " 2x"],
	                          t: 13
	                        }]
	                      }],
	                      n: 50,
	                      x: {
	                        r: ["data.img", "data.img.ext"],
	                        s: "_0&&_1===\".png\""
	                      },
	                      l: 1
	                    }]
	                  }]
	                }],
	                n: 52,
	                r: "events"
	              }]
	            }],
	            n: 52,
	            r: "eventsData"
	          }]
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "c-footer"
	    }]
	  }],
	  e: {
	    "true": function () {
	      return true;
	    },
	    "_0%2?\"pos-right\":\"pos-left\"": function (_0) {
	      return _0 % 2 ? "pos-right" : "pos-left";
	    },
	    "_0&&_1===\".svg\"": function (_0, _1) {
	      return _0 && _1 === ".svg";
	    },
	    "_0&&_1===\".png\"": function (_0, _1) {
	      return _0 && _1 === ".png";
	    },
	    "_0%2?\"pos-left\":\"pos-right\"": function (_0) {
	      return _0 % 2 ? "pos-left" : "pos-right";
	    }
	  }
	};
	component$a.exports.components = {
	  "c-header-gradient": headerGradient,
	  "c-notification": notification,
	  "c-footer": footer,
	  "c-header": header,
	  "r-page": rPage
	};
	var history = ractive__default["default"].extend(component$a.exports);

	var component$9 = {
	  exports: {}
	};
	component$9.exports = {
	  computed: {
	    barThickness() {
	      switch (this.get('periodData').periodType) {
	        case 's-quarter':
	          return 2;
	        case 's-year':
	          return 1;
	        default:
	          return 4;
	      }
	    }
	  },
	  data() {
	    return {
	      _,
	      periodData: {
	        periodText: 'month',
	        periodValue: 'month',
	        periodType: 's-month'
	      },
	      packageTotal: 0,
	      bandwidthTotal: 0,
	      topVersion: '',
	      topVersionHits: 0
	    };
	  },
	  decorators: {
	    clipboard,
	    tooltip
	  },
	  oninit() {
	    if (!ractive__default["default"].isServer) {
	      this.observe('periodData', () => {
	        if (this.get('periodData')) {
	          let type = this.get('type');
	          let name = this.get('name');
	          let period = this.get('periodData').periodValue;

	          // get overall GSAP stats (data for charts, rank)
	          http.fetchPackageSummaryStats(type, name, period).then(response => {
	            this.animate('packageRank', response.hits.rank, {
	              duration: 1000
	            });
	            this.set('packageDateStats', response.hits);
	            this.animate('packageTotal', response.hits.total, {
	              duration: 1000
	            });
	            this.set('packageBandwidthStats', response.bandwidth);
	            this.animate('bandwidthTotal', _.convertBytesToUnits(response.bandwidth.total), {
	              duration: 1000
	            });
	          });

	          // get GSAP top version stats
	          http.fetchPackageVersionsStats(type, name, period, 'hits').then(response => {
	            this.animate('topVersion', response[0].version, {
	              duration: 1000
	            });
	            this.animate('topVersionHits', response[0].hits.total, {
	              duration: 1000
	            });
	          });
	        }
	      });
	      charts().then(({
	        createBarChart
	      }) => {
	        this.observe('packageDateStats', () => {
	          let packageDateStats = this.get('packageDateStats');
	          if (!packageDateStats) {
	            return null;
	          }
	          let array = Object.entries(packageDateStats.dates);
	          let labels = array.map(item => _.formatDate(new Date(item[0]), 'short').toUpperCase());
	          let data = array.map(item => item[1]);

	          // temp solution to fix chart recreation after switching from stats tab
	          setTimeout(() => {
	            let requestsChart = this.get('requestsChart');
	            if (requestsChart) {
	              requestsChart.destroy();
	              this.set('requestsChart', null);
	            }
	            let chartEl = this.find('#requests-chart');
	            let chartData = {
	              labels,
	              datasets: [{
	                data,
	                borderWidth: 0,
	                barThickness: this.get('barThickness'),
	                hoverBackgroundColor: '#57922a',
	                borderRadius: 1
	              }]
	            };
	            let chartSettings = {
	              onHoverNotActiveBarsBGColor: '#ecf7e3',
	              useExternalTooltip: true,
	              externalTooltipId: 'gsapRequestsChartTooltip',
	              externalTooltipVerticalOffset: 40
	            };
	            let chartConfig = {
	              options: {
	                elements: {
	                  bar: {
	                    backgroundColor: '#6fb936'
	                  }
	                },
	                scales: {
	                  x: {
	                    display: false
	                  },
	                  y: {
	                    display: false
	                  }
	                }
	              }
	            };
	            requestsChart = createBarChart(chartEl, chartData, chartSettings, chartConfig);
	            this.set('requestsChart', requestsChart);
	          }, 100);
	        });
	        this.observe('packageBandwidthStats', () => {
	          let packageBandwidthStats = this.get('packageBandwidthStats');
	          if (!packageBandwidthStats) {
	            return null;
	          }
	          let array = Object.entries(packageBandwidthStats.dates);
	          let labels = array.map(item => _.formatDate(new Date(item[0]), 'short').toUpperCase());
	          let data = array.map(item => _.convertBytesToUnits(item[1]));

	          // temp solution to fix chart recreation after switching from stats tab
	          setTimeout(() => {
	            let bandwidthChart = this.get('bandwidthChart');
	            if (bandwidthChart) {
	              bandwidthChart.destroy();
	              this.set('bandwidthChart', null);
	            }
	            let chartEl = this.find('#bandwidth-chart');
	            let chartData = {
	              labels,
	              datasets: [{
	                data,
	                borderWidth: 0,
	                barThickness: this.get('barThickness'),
	                hoverBackgroundColor: '#57922a',
	                borderRadius: 1
	              }]
	            };
	            let chartSettings = {
	              onHoverNotActiveBarsBGColor: '#ecf7e3',
	              useExternalTooltip: true,
	              externalTooltipId: 'gsapBandwidthChartTooltip',
	              externalTooltipVerticalOffset: 40,
	              valueUnits: ' GB'
	            };
	            let chartConfig = {
	              options: {
	                elements: {
	                  bar: {
	                    backgroundColor: '#6fb936'
	                  }
	                },
	                scales: {
	                  x: {
	                    display: false
	                  },
	                  y: {
	                    display: false
	                  }
	                }
	              }
	            };
	            bandwidthChart = createBarChart(chartEl, chartData, chartSettings, chartConfig);
	            this.set('bandwidthChart', bandwidthChart);
	          }, 100);
	        });
	      });
	    }
	  },
	  handlePeriodSelecting() {
	    return periodData => {
	      this.set('periodData', periodData);
	    };
	  }
	};
	component$9.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      t: 13,
	      n: "class",
	      f: "c-gsap-package-sidemenu",
	      g: 1
	    }],
	    f: [{
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "package-stats",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "sidemenu-title",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "span",
	          f: ["Statistics"]
	        }, " ", {
	          t: 7,
	          e: "c-periods-dropdown",
	          m: [{
	            n: "selectedValue",
	            f: [{
	              t: 2,
	              r: "periodData.periodValue"
	            }],
	            t: 13
	          }, {
	            n: "selectHandler",
	            f: [{
	              t: 2,
	              x: {
	                r: ["@this"],
	                s: "_0.handlePeriodSelecting()"
	              }
	            }],
	            t: 13
	          }, {
	            n: "currentSelectedClass",
	            f: "current",
	            t: 13,
	            g: 1
	          }, {
	            n: "useCustomIconStyles",
	            f: "true",
	            t: 13,
	            g: 1
	          }],
	          f: []
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "chart-block",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "chart-header",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "span",
	            f: ["Requests"]
	          }, " ", {
	            t: 7,
	            e: "span",
	            f: [{
	              t: 2,
	              x: {
	                r: ["_", "packageTotal"],
	                s: "_0.formatNumber(_1)"
	              }
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "requests-chart-wrapper",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "canvas",
	            m: [{
	              n: "id",
	              f: "requests-chart",
	              t: 13,
	              g: 1
	            }]
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "chart-block",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "chart-header",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "span",
	            f: ["Bandwidth"]
	          }, " ", {
	            t: 7,
	            e: "span",
	            f: [{
	              t: 2,
	              x: {
	                r: ["_", "bandwidthTotal"],
	                s: "_0.formatNumber(_1)"
	              }
	            }, " GB"]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "bandwidth-chart-wrapper",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "canvas",
	            m: [{
	              n: "id",
	              f: "bandwidth-chart",
	              t: 13,
	              g: 1
	            }]
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "top-version-block",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "span",
	          f: ["Top version ", {
	            t: 2,
	            x: {
	              r: ["topVersion"],
	              s: "_0?\"- \"+_0:\"\""
	            }
	          }]
	        }, " ", {
	          t: 7,
	          e: "span",
	          f: [{
	            t: 2,
	            x: {
	              r: ["_", "topVersionHits"],
	              s: "_0.formatNumber(_1)+\" hits\""
	            }
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "banner",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "a",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "banner_learn-more",
	            g: 1
	          }, {
	            n: "href",
	            f: "/network/infographic",
	            t: 13,
	            g: 1
	          }],
	          f: ["Learn more"]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "banner_check",
	            g: 1
	          }],
	          f: ["Check what makes us ", {
	            t: 7,
	            e: "br"
	          }, " production ready"]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "banner_img",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "img",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "banner_img_front",
	              g: 1
	            }, {
	              n: "width",
	              f: "196",
	              t: 13,
	              g: 1
	            }, {
	              n: "height",
	              f: "175",
	              t: 13,
	              g: 1
	            }, {
	              n: "src",
	              f: [{
	                t: 2,
	                r: "@shared.assetsHost"
	              }, "/img/gsap/banner-front.svg"],
	              t: 13
	            }]
	          }, " ", {
	            t: 7,
	            e: "img",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "banner_img_back",
	              g: 1
	            }, {
	              n: "width",
	              f: "196",
	              t: 13,
	              g: 1
	            }, {
	              n: "height",
	              f: "135",
	              t: 13,
	              g: 1
	            }, {
	              n: "src",
	              f: [{
	                t: 2,
	                r: "@shared.assetsHost"
	              }, "/img/gsap/banner-back.svg"],
	              t: 13
	            }]
	          }]
	        }]
	      }]
	    }]
	  }],
	  e: {
	    "_0.handlePeriodSelecting()": function (_0) {
	      return _0.handlePeriodSelecting();
	    },
	    "_0.formatNumber(_1)": function (_0, _1) {
	      return _0.formatNumber(_1);
	    },
	    "_0?\"- \"+_0:\"\"": function (_0) {
	      return _0 ? "- " + _0 : "";
	    },
	    "_0.formatNumber(_1)+\" hits\"": function (_0, _1) {
	      return _0.formatNumber(_1) + " hits";
	    }
	  }
	};
	component$9.exports.components = {
	  "c-periods-dropdown": periodsDropdown
	};
	var gsapPackageSidemenu = ractive__default["default"].extend(component$9.exports);

	var component$8 = {
	  exports: {}
	};
	component$8.exports = {
	  data() {
	    return {
	      title: 'GSAP CDN by jsDelivr - A CDN for npm and GitHub',
	      description: 'A free, fast, and reliable CDN for GSAP. Boost your animation superpowers with GSAP (GreenSock Animation Platform) - The industry standard for JavaScript animation.',
	      packageName: 'gsap',
	      packageType: 'npm',
	      showESMFiles: false,
	      aliasingList: ['Static', 'Minor', 'Major', 'Latest'],
	      versionIdx: 0,
	      versionIdxTmp: 0,
	      aliasingIdx: 1,
	      aliasingIdxTmp: 1,
	      versionsList: [],
	      filesData: {
	        CSSRulePlugin: '',
	        CustomBounce: '',
	        CustomEase: '',
	        CustomWiggle: '',
	        Draggable: '',
	        DrawSVGPlugin: '',
	        EasePack: '',
	        EaselPlugin: '',
	        Flip: '',
	        GSDevTools: '',
	        InertiaPlugin: '',
	        MorphSVGPlugin: '',
	        MotionPathPlugin: '',
	        MotionPathHelper: '',
	        Observer: '',
	        Physics2DPlugin: '',
	        PhysicsPropsPlugin: '',
	        PixiPlugin: '',
	        ScrambleTextPlugin: '',
	        ScrollSmoother: '',
	        ScrollToPlugin: '',
	        ScrollTrigger: '',
	        SplitText: '',
	        TextPlugin: ''
	      }
	    };
	  },
	  oninit() {
	    if (!ractive__default["default"].isServer) {
	      // get versions
	      http.fetchPackageVersions(this.get('packageType'), this.get('packageName')).then(response => {
	        this.set('versionsList', response.versions.map(item => item.version));
	      }).catch(error => {
	        console.error(`Gsap versions not found.`, error);
	      });
	      this.observe('versionIdx versionsList', () => {
	        let version = this.get('versionsList')[this.get('versionIdx')];
	        if (!version) {
	          return;
	        }

	        // get core file of GSAP package
	        http.fetchPackageEntrypoints(this.get('packageType'), this.get('packageName'), version).then(data => {
	          this.set('coreFile', data.entrypoints.js.file);
	        });

	        // get the rest of files of GSAP package
	        http.fetchPackageFiles(this.get('packageType'), this.get('packageName'), version).then(data => {
	          let distFiles = [];
	          let filesData = this.get('filesData');

	          // get /dist files, filter for .min.js only
	          for (let key in data.files) {
	            if (data.files[key].name === 'dist') {
	              distFiles = data.files[key].files.filter(file => {
	                return file.name.endsWith('.min.js');
	              });
	              break;
	            }
	          }

	          // get all existing file paths
	          Object.keys(filesData).forEach(fileName => {
	            for (let key in distFiles) {
	              if (distFiles[key].name.includes(fileName)) {
	                filesData[fileName] = distFiles[key].name;
	                break;
	              }
	            }
	          });
	          this.set('filesData', filesData);
	        });
	      });

	      // set initial value
	      this.set('showMoreFileItems', window.innerWidth >= 768);
	    }
	  },
	  createAliasing(aliasingBase, version, full = false) {
	    let versionSplitted = version.split('.');
	    let prepVersionBase = '';
	    let prepVersionPart = '';
	    switch (aliasingBase) {
	      case 'Minor':
	        prepVersionBase = `${versionSplitted[0]}.${versionSplitted[1]}`;
	        prepVersionPart = '.x';
	        break;
	      case 'Static':
	        prepVersionBase = version;
	        break;
	      case 'Major':
	        prepVersionBase = versionSplitted[0];
	        prepVersionPart = '.x.x';
	        break;
	    }
	    if (full) {
	      return prepVersionBase ? `(${prepVersionBase}${prepVersionPart})` : '';
	    }
	    return prepVersionBase ? prepVersionBase : 'latest';
	  },
	  createUrl(filePath, isEsm, isCore = false) {
	    let packageName = this.get('packageName');
	    let packageType = this.get('packageType');
	    let version = this.get('versionsList')[this.get('versionIdx')];
	    let aliasing = this.get('aliasingList')[this.get('aliasingIdx')];
	    if (!version || !filePath) {
	      return;
	    }
	    let URLbase = `https://cdn.jsdelivr.net/${packageType}/${packageName}@${this.createAliasing(aliasing, version)}`;
	    if (isCore && isEsm) {
	      return `${URLbase}/+esm`;
	    } else if (isCore && !isEsm) {
	      return `${URLbase}${filePath}`;
	    } else if (!isCore && isEsm) {
	      return `${URLbase}/dist/${filePath}/+esm`;
	    }
	    return `${URLbase}/dist/${filePath}`;
	  },
	  decorators: {
	    clipboard
	  },
	  oncomplete() {
	    document.querySelector('.menu-versions-mobile').addEventListener('click', event => {
	      event.stopPropagation();
	      if (event.target.matches('button')) {
	        document.querySelector('#btn_version').parentNode.classList.remove('open');
	      }
	    }, false);
	    document.querySelector('.menu-aliasing-mobile').addEventListener('click', event => {
	      event.stopPropagation();
	      if (event.target.matches('button')) {
	        document.querySelector('#btn_aliasing').parentNode.classList.remove('open');
	      }
	    }, false);

	    // HANDLE EXTRA FILE ITEMS EXPAND/COLLAPSE
	    let extraItems = this.find('#extraFileItems');

	    // handle initial satte
	    if (!this.get('showMoreFileItems') && window.innerWidth <= 768) {
	      extraItems.style.height = '0px';
	      extraItems.style.opacity = '0';
	    }
	    this.observe('showMoreFileItems', showMoreFileItems => {
	      // skip on large screens
	      if (window.innerWidth > 768) {
	        return;
	      }
	      if (showMoreFileItems) {
	        // handle expand
	        extraItems.style.height = 'auto';
	        let fullHeight = extraItems.scrollHeight + 'px';
	        extraItems.style.height = '0px';
	        void extraItems.offsetHeight; // force reflow, the browser applies pending style changes immediately
	        extraItems.style.transition = 'height 0.5s ease-out, opacity 0.5s ease-out';
	        extraItems.style.height = fullHeight;
	        extraItems.style.opacity = '1';
	      } else {
	        // handle collapse; fade first, then shrink
	        extraItems.style.transition = 'opacity 0.4s ease-out';
	        extraItems.style.opacity = '0';
	        requestAnimationFrame(() => {
	          setTimeout(() => {
	            extraItems.style.transition = 'height 0.6s ease';
	            extraItems.style.height = '0px';
	          }, 200);
	        });
	      }
	    });
	    this._boundResizeHandler = this.handleResize.bind(this);
	    window.addEventListener('resize', this._boundResizeHandler);
	  },
	  onteardown() {
	    if (!ractive__default["default"].isServer) {
	      window.removeEventListener('resize', this._boundResizeHandler);
	    }
	  },
	  handleResize() {
	    let extraItems = this.find('#extraFileItems');
	    if (!extraItems) {
	      return;
	    }
	    let isExpanded = this.get('showMoreFileItems');
	    if (window.innerWidth >= 768) {
	      // always expanded for large screens
	      extraItems.style.transition = '';
	      extraItems.style.height = 'auto';
	      extraItems.style.opacity = '1';
	    } else {
	      // preserve state and recalculate height
	      extraItems.style.height = 'auto';
	      let newHeight = extraItems.scrollHeight;
	      void extraItems.offsetHeight; // force reflow, the browser applies pending style changes immediately.

	      if (isExpanded) {
	        extraItems.style.height = `${newHeight}px`;
	        extraItems.style.opacity = '1';
	      } else {
	        extraItems.style.height = '0px';
	        extraItems.style.opacity = '0';
	      }
	    }
	  }
	};
	component$8.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "r-page",
	    m: [{
	      n: "noYield",
	      f: [{
	        t: 2,
	        r: "noYield"
	      }],
	      t: 13
	    }, {
	      n: "title",
	      f: [{
	        t: 2,
	        r: "title"
	      }],
	      t: 13
	    }, {
	      n: "description",
	      f: [{
	        t: 2,
	        r: "description"
	      }],
	      t: 13
	    }],
	    f: [{
	      t: 7,
	      e: "c-notification"
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "p-gsap",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "header",
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "menu-main",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "menu-main_left",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "a",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "main-logo",
	                g: 1
	              }, {
	                n: "href",
	                f: "/",
	                t: 13,
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "140",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "34",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/jsdelivr-horizontal-full-white.svg"],
	                  t: 13
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "a",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "header-btn",
	                g: 1
	              }, {
	                n: "target",
	                f: "_blank",
	                t: 13,
	                g: 1
	              }, {
	                n: "rel",
	                f: "noopener noreferrer",
	                t: 13,
	                g: 1
	              }, {
	                n: "href",
	                f: "https://gsap.com/docs/v3/Installation#CDN",
	                t: 13,
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "20",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "20",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/gsap/gsap.png"],
	                  t: 13
	                }]
	              }, " ", {
	                t: 7,
	                e: "span",
	                f: ["GSAP CDN"]
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "menu-main_right",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "a",
	              m: [{
	                n: "href",
	                f: "/",
	                t: 13,
	                g: 1
	              }],
	              f: ["jsdelivr"]
	            }, " ", {
	              t: 7,
	              e: "a",
	              m: [{
	                n: "target",
	                f: "_blank",
	                t: 13,
	                g: 1
	              }, {
	                n: "rel",
	                f: "noopener noreferrer",
	                t: 13,
	                g: 1
	              }, {
	                n: "href",
	                f: "https://gsap.com",
	                t: 13,
	                g: 1
	              }],
	              f: ["GSAP.com"]
	            }, " ", {
	              t: 7,
	              e: "a",
	              m: [{
	                n: "target",
	                f: "_blank",
	                t: 13,
	                g: 1
	              }, {
	                n: "rel",
	                f: "noopener noreferrer",
	                t: 13,
	                g: 1
	              }, {
	                n: "href",
	                f: "https://gsap.com/docs",
	                t: 13,
	                g: 1
	              }],
	              f: ["GSAP Docs"]
	            }, " ", {
	              t: 7,
	              e: "a",
	              m: [{
	                n: "target",
	                f: "_blank",
	                t: 13,
	                g: 1
	              }, {
	                n: "rel",
	                f: "noopener noreferrer",
	                t: 13,
	                g: 1
	              }, {
	                n: "href",
	                f: "https://github.com/greensock/GSAP",
	                t: 13,
	                g: 1
	              }],
	              f: ["GitHub Project"]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "menu-main_hamburger",
	              g: 1
	            }, {
	              n: ["click"],
	              t: 70,
	              f: {
	                r: ["@this"],
	                s: "[_0.set(\"mmDropdownOpen\",true)]"
	              }
	            }],
	            f: [{
	              t: 7,
	              e: "span",
	              f: ["Menu"]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "menu-main_hamburger_icon",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "bar1",
	                  g: 1
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "bar2",
	                  g: 1
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "bar3",
	                  g: 1
	                }]
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              n: "class",
	              f: ["menu-main_dropdown-menu ", {
	                t: 4,
	                f: ["menu-main_dropdown-menu_open"],
	                n: 50,
	                x: {
	                  r: ["mmDropdownOpen"],
	                  s: "_0===true"
	                }
	              }],
	              t: 13
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "menu-main_hamburger",
	                g: 1
	              }, {
	                n: ["click"],
	                t: 70,
	                f: {
	                  r: ["@this"],
	                  s: "[_0.set(\"mmDropdownOpen\",false)]"
	                }
	              }],
	              f: [{
	                t: 7,
	                e: "span",
	                f: ["Close"]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "menu-main_hamburger_icon",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "bar1",
	                    g: 1
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "bar2",
	                    g: 1
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "bar3",
	                    g: 1
	                  }]
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "menu-main_dropdown-menu_list",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "href",
	                  f: "/",
	                  t: 13,
	                  g: 1
	                }],
	                f: ["jsdelivr"]
	              }, " ", {
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "rel",
	                  f: "noopener noreferrer",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "href",
	                  f: "https://gsap.com",
	                  t: 13,
	                  g: 1
	                }],
	                f: ["GSAP.com"]
	              }, " ", {
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "rel",
	                  f: "noopener noreferrer",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "href",
	                  f: "https://gsap.com/docs",
	                  t: 13,
	                  g: 1
	                }],
	                f: ["GSAP Docs"]
	              }, " ", {
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "rel",
	                  f: "noopener noreferrer",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "href",
	                  f: "https://github.com/greensock/GSAP",
	                  t: 13,
	                  g: 1
	                }],
	                f: ["GitHub Project"]
	              }]
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "jumbotron",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "h1",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "title",
	              g: 1
	            }],
	            f: ["GSAP"]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "description-box",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "description",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "p",
	                f: ["Boost your animation superpowers with ", {
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "links",
	                    g: 1
	                  }, {
	                    n: "target",
	                    f: "_blank",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "rel",
	                    f: "noopener noreferrer",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "href",
	                    f: "https://gsap.com/docs/v3/GSAP",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: ["GSAP"]
	                }, " (GreenSock Animation Platform) - The industry standard for JavaScript animation."]
	              }, " ", {
	                t: 7,
	                e: "p",
	                f: ["Use the core library to animate ", {
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "text-italic",
	                    g: 1
	                  }],
	                  f: ["anything"]
	                }, " with ease: HTML DOM, SVG, canvas, WebGL, React, Vue. Leverage any of the 20+ ", {
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "links",
	                    g: 1
	                  }, {
	                    n: "target",
	                    f: "_blank",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "rel",
	                    f: "noopener noreferrer",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "href",
	                    f: "https://gsap.com/gsap-plugins",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: ["Plugins"]
	                }, " like ", {
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "links",
	                    g: 1
	                  }, {
	                    n: "target",
	                    f: "_blank",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "rel",
	                    f: "noopener noreferrer",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "href",
	                    f: "https://gsap.com/scrolltrigger",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: ["ScrollTrigger"]
	                }, " for even more control."]
	              }, " ", {
	                t: 7,
	                e: "p",
	                f: ["GSAP has ", {
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "text-bold",
	                    g: 1
	                  }],
	                  f: ["zero dependencies"]
	                }, " and works in every major browser; we obsess over performance and compatibility so you can focus on the fun stuff."]
	              }, " ", {
	                t: 7,
	                e: "p",
	                f: ["Visit our ", {
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "links",
	                    g: 1
	                  }, {
	                    n: "target",
	                    f: "_blank",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "rel",
	                    f: "noopener noreferrer",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "href",
	                    f: "https://gsap.com/docs",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: ["docs"]
	                }, " and ", {
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "links",
	                    g: 1
	                  }, {
	                    n: "target",
	                    f: "_blank",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "rel",
	                    f: "noopener noreferrer",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "href",
	                    f: "https://gsap.com/community",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: ["community"]
	                }, " to learn more."]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "boxes-bottom",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "112",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "112",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/gsap/gsap.png"],
	                  t: 13
	                }]
	              }, " ", {
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "112",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "112",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/gsap/box.png"],
	                  t: 13
	                }]
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "img",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "boxes",
	              g: 1
	            }, {
	              n: "width",
	              f: "279",
	              t: 13,
	              g: 1
	            }, {
	              n: "height",
	              f: "484",
	              t: 13,
	              g: 1
	            }, {
	              n: "src",
	              f: [{
	                t: 2,
	                r: "@shared.assetsHost"
	              }, "/img/gsap/boxes.svg"],
	              t: 13
	            }]
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "content-wrapper flex",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "main-content ",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "main-content_title",
	              g: 1
	            }],
	            f: ["Quick Start with GSAP CDN"]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "main-content_description",
	              g: 1
	            }],
	            f: ["Get your production ready CDN links below. If you want your versions to be auto-upgraded then use the dropdown below to select the method. \"Minor\" is recommended."]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "files-table-wrapper",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "ctrls",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "ctrl",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "span",
	                  f: ["Version:"]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "btn-group",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "button",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "btn dropdown-toggle",
	                      g: 1
	                    }, {
	                      n: "id",
	                      f: "btn_version",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "type",
	                      f: "button",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "data-toggle",
	                      f: "dropdown",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "aria-haspopup",
	                      f: "true",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "aria-expanded",
	                      f: "false",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "span",
	                      f: [{
	                        t: 2,
	                        rx: {
	                          r: "versionsList",
	                          m: [{
	                            t: 30,
	                            n: "versionIdx"
	                          }]
	                        }
	                      }]
	                    }, " ", {
	                      t: 7,
	                      e: "i",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "fa fa-angle-down",
	                        g: 1
	                      }, {
	                        n: "aria-hidden",
	                        f: "true",
	                        t: 13,
	                        g: 1
	                      }]
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "ul",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "menu-versions-web dropdown-menu",
	                      g: 1
	                    }],
	                    f: [{
	                      t: 4,
	                      f: [{
	                        t: 7,
	                        e: "li",
	                        f: [{
	                          t: 7,
	                          e: "a",
	                          m: [{
	                            n: ["click"],
	                            t: 70,
	                            f: {
	                              r: ["@this", "idx"],
	                              s: "[_0.set(\"versionIdx\",_1)]"
	                            }
	                          }, {
	                            n: "class",
	                            f: [{
	                              t: 4,
	                              f: ["current"],
	                              n: 50,
	                              x: {
	                                r: ["idx", "versionIdx"],
	                                s: "_0===_1"
	                              }
	                            }],
	                            t: 13
	                          }],
	                          f: [{
	                            t: 2,
	                            r: "."
	                          }]
	                        }]
	                      }],
	                      n: 52,
	                      i: "idx",
	                      r: "versionsList"
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "div",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "menu-mobile-bg",
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "div",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "menu-versions-mobile dropdown-menu",
	                      g: 1
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "p",
	                      f: ["Version:"]
	                    }, " ", {
	                      t: 7,
	                      e: "div",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "select-cdn",
	                        g: 1
	                      }],
	                      f: [{
	                        t: 4,
	                        f: [{
	                          t: 7,
	                          e: "div",
	                          f: [{
	                            t: 7,
	                            e: "input",
	                            m: [{
	                              n: "type",
	                              f: "radio",
	                              t: 13
	                            }, {
	                              n: "class",
	                              f: "select-cdn-tools",
	                              t: 13
	                            }, {
	                              n: "id",
	                              f: [{
	                                t: 2,
	                                r: "idx"
	                              }],
	                              t: 13
	                            }, {
	                              n: "name",
	                              f: "Version",
	                              t: 13
	                            }, {
	                              t: 4,
	                              f: [{
	                                n: "checked",
	                                f: 0,
	                                t: 13
	                              }],
	                              n: 50,
	                              x: {
	                                r: ["idx", "versionIdxTmp"],
	                                s: "_0===_1"
	                              }
	                            }]
	                          }, " ", {
	                            t: 7,
	                            e: "label",
	                            m: [{
	                              n: ["click"],
	                              t: 70,
	                              f: {
	                                r: ["@this", "idx"],
	                                s: "[_0.set(\"versionIdxTmp\",_1)]"
	                              }
	                            }, {
	                              n: "for",
	                              f: [{
	                                t: 2,
	                                r: "idx"
	                              }],
	                              t: 13
	                            }],
	                            f: [{
	                              t: 2,
	                              r: "."
	                            }]
	                          }]
	                        }],
	                        n: 52,
	                        i: "idx",
	                        r: "versionsList"
	                      }]
	                    }, " ", {
	                      t: 7,
	                      e: "button",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "select-cdn-btn apply",
	                        g: 1
	                      }, {
	                        n: ["click"],
	                        t: 70,
	                        f: {
	                          r: ["@this", "versionIdxTmp"],
	                          s: "[_0.set(\"versionIdx\",_1)]"
	                        }
	                      }],
	                      f: ["Apply"]
	                    }, " ", {
	                      t: 7,
	                      e: "button",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "menu-versions-mobile-btn-cancel select-cdn-btn cancel",
	                        g: 1
	                      }, {
	                        n: ["click"],
	                        t: 70,
	                        f: {
	                          r: ["@this", "versionIdx"],
	                          s: "[_0.set(\"versionIdxTmp\",_1)]"
	                        }
	                      }],
	                      f: ["Cancel"]
	                    }]
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "ctrl",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "span",
	                  f: ["Aliasing:"]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "btn-group",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "button",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "btn dropdown-toggle",
	                      g: 1
	                    }, {
	                      n: "id",
	                      f: "btn_aliasing",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "type",
	                      f: "button",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "data-toggle",
	                      f: "dropdown",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "aria-haspopup",
	                      f: "true",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "aria-expanded",
	                      f: "false",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "span",
	                      f: [{
	                        t: 2,
	                        rx: {
	                          r: "aliasingList",
	                          m: [{
	                            t: 30,
	                            n: "aliasingIdx"
	                          }]
	                        }
	                      }]
	                    }, " ", {
	                      t: 7,
	                      e: "i",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "fa fa-angle-down",
	                        g: 1
	                      }, {
	                        n: "aria-hidden",
	                        f: "true",
	                        t: 13,
	                        g: 1
	                      }]
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "ul",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "menu-aliasing-web dropdown-menu",
	                      g: 1
	                    }],
	                    f: [{
	                      t: 4,
	                      f: [{
	                        t: 7,
	                        e: "li",
	                        f: [{
	                          t: 7,
	                          e: "a",
	                          m: [{
	                            n: ["click"],
	                            t: 70,
	                            f: {
	                              r: ["@this", "idx"],
	                              s: "[_0.set(\"aliasingIdx\",_1)]"
	                            }
	                          }, {
	                            n: "class",
	                            f: [{
	                              t: 4,
	                              f: ["current"],
	                              n: 50,
	                              x: {
	                                r: ["idx", "aliasingIdx"],
	                                s: "_0===_1"
	                              }
	                            }],
	                            t: 13
	                          }],
	                          f: [{
	                            t: 2,
	                            r: "."
	                          }, " ", {
	                            t: 2,
	                            x: {
	                              r: ["@this", ".", "versionIdx", "versionsList"],
	                              s: "_0.createAliasing(_1,_3[_2],true)"
	                            }
	                          }]
	                        }]
	                      }],
	                      n: 52,
	                      i: "idx",
	                      r: "aliasingList"
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "div",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "menu-mobile-bg",
	                      g: 1
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "div",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "menu-aliasing-mobile dropdown-menu",
	                      g: 1
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "p",
	                      f: ["Aliasing:"]
	                    }, " ", {
	                      t: 7,
	                      e: "div",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "select-cdn",
	                        g: 1
	                      }],
	                      f: [{
	                        t: 4,
	                        f: [{
	                          t: 7,
	                          e: "div",
	                          f: [{
	                            t: 7,
	                            e: "input",
	                            m: [{
	                              n: "type",
	                              f: "radio",
	                              t: 13
	                            }, {
	                              n: "class",
	                              f: "select-cdn-tools",
	                              t: 13
	                            }, {
	                              n: "id",
	                              f: [{
	                                t: 2,
	                                r: "idx"
	                              }],
	                              t: 13
	                            }, {
	                              n: "name",
	                              f: "Aliasing",
	                              t: 13
	                            }, {
	                              t: 4,
	                              f: [{
	                                n: "checked",
	                                f: 0,
	                                t: 13
	                              }],
	                              n: 50,
	                              x: {
	                                r: ["idx", "aliasingIdxTmp"],
	                                s: "_0===_1"
	                              }
	                            }]
	                          }, " ", {
	                            t: 7,
	                            e: "label",
	                            m: [{
	                              n: ["click"],
	                              t: 70,
	                              f: {
	                                r: ["@this", "idx"],
	                                s: "[_0.set(\"aliasingIdxTmp\",_1)]"
	                              }
	                            }, {
	                              n: "for",
	                              f: [{
	                                t: 2,
	                                r: "idx"
	                              }],
	                              t: 13
	                            }],
	                            f: [{
	                              t: 2,
	                              r: "."
	                            }, " ", {
	                              t: 2,
	                              x: {
	                                r: ["@this", ".", "versionIdx", "versionsList"],
	                                s: "_0.createAliasing(_1,_3[_2],true)"
	                              }
	                            }]
	                          }]
	                        }],
	                        n: 52,
	                        i: "idx",
	                        r: "aliasingList"
	                      }]
	                    }, " ", {
	                      t: 7,
	                      e: "button",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "select-cdn-btn apply",
	                        g: 1
	                      }, {
	                        n: ["click"],
	                        t: 70,
	                        f: {
	                          r: ["@this", "aliasingIdxTmp"],
	                          s: "[_0.set(\"aliasingIdx\",_1)]"
	                        }
	                      }],
	                      f: ["Apply"]
	                    }, " ", {
	                      t: 7,
	                      e: "button",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "select-cdn-btn cancel",
	                        g: 1
	                      }, {
	                        n: ["click"],
	                        t: 70,
	                        f: {
	                          r: ["@this", "aliasingIdx"],
	                          s: "[_0.set(\"aliasingIdxTmp\",_1)]"
	                        }
	                      }],
	                      f: ["Cancel"]
	                    }]
	                  }]
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "divider",
	                g: 1
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "files-table",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "files-item",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "title",
	                    g: 1
	                  }],
	                  f: ["GSAP (core)"]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "block-core",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 4,
	                    f: [{
	                      t: 7,
	                      e: "div",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "block-core_switch",
	                        g: 1
	                      }],
	                      f: [{
	                        t: 7,
	                        e: "input",
	                        m: [{
	                          n: "id",
	                          f: "type-switch",
	                          t: 13
	                        }, {
	                          n: "type",
	                          f: "checkbox",
	                          t: 13
	                        }, {
	                          n: "class",
	                          f: ["data-type-switch ", {
	                            t: 4,
	                            f: ["checked"],
	                            n: 50,
	                            r: "showESMFiles"
	                          }],
	                          t: 13
	                        }, {
	                          t: 73,
	                          v: "t",
	                          f: "false"
	                        }]
	                      }, " ", {
	                        t: 7,
	                        e: "label",
	                        m: [{
	                          n: "for",
	                          f: "type-switch",
	                          t: 13,
	                          g: 1
	                        }, {
	                          n: ["click"],
	                          t: 70,
	                          f: {
	                            r: ["@this", "showESMFiles"],
	                            s: "[_0.set(\"showESMFiles\",!_1)]"
	                          }
	                        }],
	                        f: [{
	                          t: 7,
	                          e: "span",
	                          f: ["UMD"]
	                        }, " ", {
	                          t: 7,
	                          e: "span",
	                          f: ["ESM"]
	                        }]
	                      }]
	                    }, " ", {
	                      t: 7,
	                      e: "span",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "block-core_url",
	                        g: 1
	                      }],
	                      f: [{
	                        t: 4,
	                        f: [{
	                          t: 4,
	                          f: [{
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "block-core_url_part",
	                              g: 1
	                            }],
	                            f: [{
	                              t: 2,
	                              r: "."
	                            }]
	                          }],
	                          n: 50,
	                          x: {
	                            r: ["idx", "@this", "coreFile", "showESMFiles"],
	                            s: "_0===_1.createUrl(_2,_3,true).split(\"/\").length-1"
	                          }
	                        }, {
	                          t: 4,
	                          f: [{
	                            t: 7,
	                            e: "span",
	                            m: [{
	                              t: 13,
	                              n: "class",
	                              f: "block-core_url_part",
	                              g: 1
	                            }],
	                            f: [{
	                              t: 2,
	                              x: {
	                                r: ["."],
	                                s: "_0+\"/\""
	                              }
	                            }]
	                          }],
	                          n: 51,
	                          l: 1
	                        }],
	                        n: 52,
	                        i: "idx",
	                        x: {
	                          r: ["@this", "coreFile", "showESMFiles"],
	                          s: "_0.createUrl(_1,_2,true).split(\"/\")"
	                        }
	                      }]
	                    }, " ", {
	                      t: 7,
	                      e: "a",
	                      m: [{
	                        n: "clipboard",
	                        t: 71,
	                        f: {
	                          r: [],
	                          s: "[\"Copy URL to clipboard\",\"right\"]"
	                        }
	                      }, {
	                        n: "data-clipboard-text",
	                        f: [{
	                          t: 2,
	                          x: {
	                            r: ["@this", "coreFile", "showESMFiles"],
	                            s: "_0.createUrl(_1,_2,true)"
	                          }
	                        }],
	                        t: 13
	                      }],
	                      f: [{
	                        t: 7,
	                        e: "img",
	                        m: [{
	                          n: "width",
	                          f: "20",
	                          t: 13,
	                          g: 1
	                        }, {
	                          n: "height",
	                          f: "20",
	                          t: 13,
	                          g: 1
	                        }, {
	                          n: "src",
	                          f: [{
	                            t: 2,
	                            r: "@shared.assetsHost"
	                          }, "/img/icons/copy-btn-black.svg"],
	                          t: 13
	                        }]
	                      }]
	                    }],
	                    n: 50,
	                    r: "coreFile"
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "extra-file-items",
	                  g: 1
	                }, {
	                  n: "id",
	                  f: "extraFileItems",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 4,
	                  f: [{
	                    t: 7,
	                    e: "div",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "files-item",
	                      g: 1
	                    }],
	                    f: [{
	                      t: 7,
	                      e: "div",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "title",
	                        g: 1
	                      }],
	                      f: [{
	                        t: 2,
	                        r: "key"
	                      }]
	                    }, " ", {
	                      t: 7,
	                      e: "div",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "block",
	                        g: 1
	                      }],
	                      f: [{
	                        t: 4,
	                        f: [{
	                          t: 7,
	                          e: "span",
	                          m: [{
	                            t: 13,
	                            n: "class",
	                            f: "ex-url",
	                            g: 1
	                          }],
	                          f: [{
	                            t: 4,
	                            f: [{
	                              t: 4,
	                              f: [{
	                                t: 7,
	                                e: "span",
	                                m: [{
	                                  t: 13,
	                                  n: "class",
	                                  f: "ex-url_part",
	                                  g: 1
	                                }],
	                                f: [{
	                                  t: 2,
	                                  r: "."
	                                }]
	                              }],
	                              n: 50,
	                              x: {
	                                r: ["idx", "@this", ".", "showESMFiles"],
	                                s: "_0===_1.createUrl(_2,_3).split(\"/\").length-1"
	                              }
	                            }, {
	                              t: 4,
	                              f: [{
	                                t: 7,
	                                e: "span",
	                                m: [{
	                                  t: 13,
	                                  n: "class",
	                                  f: "ex-url_part",
	                                  g: 1
	                                }],
	                                f: [{
	                                  t: 2,
	                                  x: {
	                                    r: ["."],
	                                    s: "_0+\"/\""
	                                  }
	                                }]
	                              }],
	                              n: 51,
	                              l: 1
	                            }],
	                            n: 52,
	                            i: "idx",
	                            x: {
	                              r: ["@this", ".", "showESMFiles"],
	                              s: "_0.createUrl(_1,_2).split(\"/\")"
	                            }
	                          }]
	                        }, " ", {
	                          t: 7,
	                          e: "a",
	                          m: [{
	                            n: "clipboard",
	                            t: 71,
	                            f: {
	                              r: [],
	                              s: "[\"Copy URL to clipboard\",\"right\"]"
	                            }
	                          }, {
	                            n: "data-clipboard-text",
	                            f: [{
	                              t: 2,
	                              x: {
	                                r: ["@this", ".", "showESMFiles"],
	                                s: "_0.createUrl(_1,_2)"
	                              }
	                            }],
	                            t: 13
	                          }],
	                          f: [{
	                            t: 7,
	                            e: "img",
	                            m: [{
	                              n: "width",
	                              f: "20",
	                              t: 13,
	                              g: 1
	                            }, {
	                              n: "height",
	                              f: "20",
	                              t: 13,
	                              g: 1
	                            }, {
	                              n: "src",
	                              f: [{
	                                t: 2,
	                                r: "@shared.assetsHost"
	                              }, "/img/icons/copy-btn-black.svg"],
	                              t: 13
	                            }]
	                          }]
	                        }],
	                        n: 50,
	                        r: "."
	                      }]
	                    }]
	                  }],
	                  n: 52,
	                  i: "key",
	                  r: "filesData"
	                }]
	              }, " ", {
	                t: 7,
	                e: "button",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "btn-more",
	                  g: 1
	                }, {
	                  n: ["click"],
	                  t: 70,
	                  f: {
	                    r: ["@this", "showMoreFileItems"],
	                    s: "[_0.set(\"showMoreFileItems\",!_1)]"
	                  }
	                }],
	                f: [{
	                  t: 4,
	                  f: ["Show more CDN"],
	                  n: 50,
	                  x: {
	                    r: ["showMoreFileItems"],
	                    s: "!_0"
	                  }
	                }, {
	                  t: 4,
	                  f: ["Hide more CDN"],
	                  n: 51,
	                  l: 1
	                }]
	              }]
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "side-content",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "c-gsap-package-sidemenu",
	            m: [{
	              n: "name",
	              f: [{
	                t: 2,
	                r: "packageName"
	              }],
	              t: 13
	            }, {
	              n: "type",
	              f: [{
	                t: 2,
	                r: "packageType"
	              }],
	              t: 13
	            }],
	            f: []
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "footer-wrapper",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "footer",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "img",
	            m: [{
	              n: "width",
	              f: "140",
	              t: 13,
	              g: 1
	            }, {
	              n: "height",
	              f: "34",
	              t: 13,
	              g: 1
	            }, {
	              n: "src",
	              f: [{
	                t: 2,
	                r: "@shared.assetsHost"
	              }, "/img/jsdelivr-horizontal-regular.svg"],
	              t: 13
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "footer_powered",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "span",
	              f: ["Powered by ", {
	                t: 7,
	                e: "a",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "footer_link",
	                  g: 1
	                }, {
	                  n: "href",
	                  f: "/",
	                  t: 13,
	                  g: 1
	                }],
	                f: ["jsDelivr"]
	              }]
	            }, " ", {
	              t: 7,
	              e: "span",
	              f: ["and sponsored by ", {
	                t: 7,
	                e: "a",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "footer_link",
	                  g: 1
	                }, {
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "rel",
	                  f: "noopener noreferrer",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "href",
	                  f: "https://www.cloudflare.com",
	                  t: 13,
	                  g: 1
	                }],
	                f: ["Cloudflare"]
	              }, ", ", {
	                t: 7,
	                e: "a",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "footer_link",
	                  g: 1
	                }, {
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "rel",
	                  f: "noopener noreferrer",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "href",
	                  f: "https://appfleet.com",
	                  t: 13,
	                  g: 1
	                }],
	                f: ["appfleet"]
	              }, ", ", {
	                t: 7,
	                e: "a",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "footer_link",
	                  g: 1
	                }, {
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "rel",
	                  f: "noopener noreferrer",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "href",
	                  f: "https://www.fastly.com",
	                  t: 13,
	                  g: 1
	                }],
	                f: ["Fastly"]
	              }, ", ", {
	                t: 7,
	                e: "a",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "footer_link",
	                  g: 1
	                }, {
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "rel",
	                  f: "noopener noreferrer",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "href",
	                  f: "https://www.ibm.com/products/ns1-connect",
	                  t: 13,
	                  g: 1
	                }],
	                f: ["IBM"]
	              }, " & ", {
	                t: 7,
	                e: "a",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "footer_link",
	                  g: 1
	                }, {
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "rel",
	                  f: "noopener noreferrer",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "href",
	                  f: "https://bunny.net",
	                  t: 13,
	                  g: 1
	                }],
	                f: ["bunny.net"]
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "footer_nav",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "a",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "footer_link",
	                g: 1
	              }, {
	                n: "href",
	                f: "/about",
	                t: 13,
	                g: 1
	              }],
	              f: ["About"]
	            }, " ", {
	              t: 7,
	              e: "a",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "footer_link",
	                g: 1
	              }, {
	                n: "href",
	                f: "/terms",
	                t: 13,
	                g: 1
	              }],
	              f: ["Privacy Policy"]
	            }]
	          }]
	        }]
	      }]
	    }]
	  }],
	  e: {
	    "[_0.set(\"mmDropdownOpen\",true)]": function (_0) {
	      return [_0.set("mmDropdownOpen", true)];
	    },
	    "_0===true": function (_0) {
	      return _0 === true;
	    },
	    "[_0.set(\"mmDropdownOpen\",false)]": function (_0) {
	      return [_0.set("mmDropdownOpen", false)];
	    },
	    "[_0.set(\"versionIdx\",_1)]": function (_0, _1) {
	      return [_0.set("versionIdx", _1)];
	    },
	    "_0===_1": function (_0, _1) {
	      return _0 === _1;
	    },
	    "[_0.set(\"versionIdxTmp\",_1)]": function (_0, _1) {
	      return [_0.set("versionIdxTmp", _1)];
	    },
	    "[_0.set(\"aliasingIdx\",_1)]": function (_0, _1) {
	      return [_0.set("aliasingIdx", _1)];
	    },
	    "_0.createAliasing(_1,_3[_2],true)": function (_0, _1, _2, _3) {
	      return _0.createAliasing(_1, _3[_2], true);
	    },
	    "[_0.set(\"aliasingIdxTmp\",_1)]": function (_0, _1) {
	      return [_0.set("aliasingIdxTmp", _1)];
	    },
	    "[_0.set(\"showESMFiles\",!_1)]": function (_0, _1) {
	      return [_0.set("showESMFiles", !_1)];
	    },
	    "_0===_1.createUrl(_2,_3,true).split(\"/\").length-1": function (_0, _1, _2, _3) {
	      return _0 === _1.createUrl(_2, _3, true).split("/").length - 1;
	    },
	    "_0+\"/\"": function (_0) {
	      return _0 + "/";
	    },
	    "_0.createUrl(_1,_2,true).split(\"/\")": function (_0, _1, _2) {
	      return _0.createUrl(_1, _2, true).split("/");
	    },
	    "[\"Copy URL to clipboard\",\"right\"]": function () {
	      return ["Copy URL to clipboard", "right"];
	    },
	    "_0.createUrl(_1,_2,true)": function (_0, _1, _2) {
	      return _0.createUrl(_1, _2, true);
	    },
	    "_0===_1.createUrl(_2,_3).split(\"/\").length-1": function (_0, _1, _2, _3) {
	      return _0 === _1.createUrl(_2, _3).split("/").length - 1;
	    },
	    "_0.createUrl(_1,_2).split(\"/\")": function (_0, _1, _2) {
	      return _0.createUrl(_1, _2).split("/");
	    },
	    "_0.createUrl(_1,_2)": function (_0, _1, _2) {
	      return _0.createUrl(_1, _2);
	    },
	    "[_0.set(\"showMoreFileItems\",!_1)]": function (_0, _1) {
	      return [_0.set("showMoreFileItems", !_1)];
	    },
	    "!_0": function (_0) {
	      return !_0;
	    }
	  }
	};
	component$8.exports.components = {
	  "c-gsap-package-sidemenu": gsapPackageSidemenu,
	  "c-notification": notification,
	  "r-page": rPage
	};
	var gsap = ractive__default["default"].extend(component$8.exports);

	var component$7 = {
	  exports: {}
	};

	/* eslint-disable no-throw-literal */

	const defaultError$1 = 'Sorry, this doesn\'t look like a valid Skypack link :(';
	component$7.exports = {
	  decorators: {
	    clipboard
	  },
	  data() {
	    return {
	      title: 'Migrate from Skypack to jsDelivr',
	      description: 'Migrate from Skypack to jsDelivr - a free, fast, and reliable Open Source CDN optimized for JS and ESM delivery from npm and GitHub. Works with all web formats. Serving more than 150 billion requests per month.'
	    };
	  },
	  oninit() {
	    let buildJsDelivrLink = (name, scope = '', version = '', hooks = '', restPath = '') => {
	      if (hooks) {
	        return `https://cdn.jsdelivr.net/npm/${scope}${name}${version}${hooks}/+esm`;
	      }
	      return `https://cdn.jsdelivr.net/npm/${scope}${name}${version}${restPath}/+esm`;
	    };
	    let skypack2jsDelivr = skypack => Promise.resolve().then(() => {
	      let pattern = /^https?:\/\/cdn\.skypack\.dev\/(@scope\/)?([A-Za-z-0-9-_]+)(@\^?\d+\.\d+\.\d+|@\^?\d+\.\d+|@\^?\d+|@next)?(\/hooks)?((\/\w*)+(\.[a-z]+)+)?(\?\w+)?/i;
	      let match = pattern.exec(skypack);
	      if (match) {
	        let [matchedInput, scope, name, version, hooks, restPath] = match;
	        if (matchedInput === skypack) {
	          return buildJsDelivrLink(name, scope, version, hooks, restPath);
	        }
	      }
	      throw defaultError$1;
	    });
	    this.observe('in', debounce(throttle(skypack => {
	      this.set('displayHtmlWarning', skypack.slice(-5) === '.html');
	      if (!skypack) {
	        return this.set('out', '');
	      }
	      skypack2jsDelivr(skypack).then(jsDelivr => {
	        this.set('error', false);
	        if (this.get('in') === skypack) {
	          this.set('out', jsDelivr);
	        }
	      }).catch(error => {
	        this.set('error', true);
	        this.set('out', typeof error === 'string' ? error : defaultError$1);
	      });
	    }, 1000)));
	  }
	};
	component$7.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "r-page",
	    m: [{
	      n: "noYield",
	      f: [{
	        t: 2,
	        r: "noYield"
	      }],
	      t: 13
	    }, {
	      n: "title",
	      f: [{
	        t: 2,
	        r: "title"
	      }],
	      t: 13
	    }, {
	      n: "description",
	      f: [{
	        t: 2,
	        r: "description"
	      }],
	      t: 13
	    }],
	    f: [{
	      t: 7,
	      e: "c-header",
	      m: [{
	        n: "useWhiteLogos",
	        f: "true",
	        t: 13,
	        g: 1
	      }, {
	        n: "additionalClasses",
	        f: "header-with-orange-bg",
	        t: 13,
	        g: 1
	      }]
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "p-skypack",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "c-header-gradient",
	        m: [{
	          n: "showMap",
	          f: [{
	            t: 2,
	            x: {
	              r: [],
	              s: "true"
	            }
	          }],
	          t: 13
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "content",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "title",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "h1",
	            f: ["Migrating from Skypack to jsDelivr"]
	          }, " ", {
	            t: 7,
	            e: "h2",
	            f: ["jsDelivr is a free, fast, and reliable Open Source CDN for npm and GitHub. Most Skypack links can be easily converted to jsDelivr links."]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "container",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "box",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                n: "class",
	                f: ["bar ", {
	                  t: 4,
	                  f: ["bar-active"],
	                  n: 50,
	                  x: {
	                    r: ["out", "error"],
	                    s: "_0&&!_1"
	                  }
	                }],
	                t: 13
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "circle",
	                  g: 1
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  n: "class",
	                  f: ["line ", {
	                    t: 4,
	                    f: ["filled"],
	                    n: 50,
	                    x: {
	                      r: ["out", "error"],
	                      s: "_0&&!_1"
	                    }
	                  }],
	                  t: 13
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  n: "class",
	                  f: ["circle bottom ", {
	                    t: 4,
	                    f: ["circle-disabled"],
	                    n: 51,
	                    x: {
	                      r: ["out", "error"],
	                      s: "_0&&!_1"
	                    }
	                  }],
	                  t: 13
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "icon-competitor",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "111",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "24",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/skypack.svg"],
	                  t: 13
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "input-wrapper mb-48",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "input",
	                m: [{
	                  n: "type",
	                  f: "text",
	                  t: 13
	                }, {
	                  n: "class",
	                  f: ["input ", {
	                    t: 4,
	                    f: ["active"],
	                    n: 50,
	                    r: "out"
	                  }],
	                  t: 13
	                }, {
	                  n: "placeholder",
	                  f: "Paste a Skypack link here",
	                  t: 13
	                }, {
	                  n: "value",
	                  f: [{
	                    t: 2,
	                    r: "in"
	                  }],
	                  t: 13
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "icon-jsdelivr",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "115",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "28",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/jsDelivr.logo.svg"],
	                  t: 13
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "input-wrapper",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "input",
	                m: [{
	                  n: "type",
	                  f: "text",
	                  t: 13
	                }, {
	                  n: "class",
	                  f: ["input ", {
	                    t: 4,
	                    f: ["input-jsdelivr-copy"],
	                    n: 50,
	                    x: {
	                      r: ["out", "error"],
	                      s: "_0&&!_1"
	                    }
	                  }, " ", {
	                    t: 4,
	                    f: ["active"],
	                    n: 50,
	                    r: "out"
	                  }],
	                  t: 13
	                }, {
	                  n: "placeholder",
	                  f: "Get a jsDelivr link here",
	                  t: 13
	                }, {
	                  n: "value",
	                  f: [{
	                    t: 2,
	                    r: "out"
	                  }],
	                  t: 13
	                }]
	              }, " ", {
	                t: 4,
	                f: [{
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "copy",
	                    g: 1
	                  }, {
	                    n: "clipboard",
	                    t: 71
	                  }, {
	                    n: "data-clipboard-text",
	                    f: [{
	                      t: 2,
	                      r: "out"
	                    }],
	                    t: 13
	                  }],
	                  f: ["Copy"]
	                }],
	                n: 50,
	                x: {
	                  r: ["out", "error"],
	                  s: "_0&&!_1"
	                }
	              }]
	            }, " ", {
	              t: 4,
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "alert alert-warning",
	                  g: 1
	                }, {
	                  n: "role",
	                  f: "alert",
	                  t: 13,
	                  g: 1
	                }],
	                f: ["For security reasons, we serve HTML files with ", {
	                  t: 7,
	                  e: "code",
	                  f: ["Content-Type: text/plain"]
	                }, ". We recommend using ", {
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    n: "href",
	                    f: "https://pages.github.com/",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "target",
	                    f: "_blank",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "rel",
	                    f: "noopener noreferrer",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: ["GitHub Pages"]
	                }, " if this is a problem."]
	              }],
	              n: 50,
	              r: "displayHtmlWarning"
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "host-descr-title",
	              g: 1
	            }],
	            f: ["Skypack and jsDelivr comparison"]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "host-descr-text",
	              g: 1
	            }],
	            f: ["jsDelivr is a great alternative for Skypack and offers many advanced features like direct npm and github integration, file minification, and ES modules compilation and optimized delivery. In addition to that jsDelivr is faster thanks to it's global infrastructure that utilizes multiple CDN providers"]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "container",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "c-comparison-table",
	            m: [{
	              n: "competitorImgSrc",
	              f: [{
	                t: 2,
	                r: "@shared.assetsHost"
	              }, "/img/skypack.svg"],
	              t: 13
	            }, {
	              n: "competitorImgWidth",
	              f: "111",
	              t: 13,
	              g: 1
	            }, {
	              n: "competitorImgHeight",
	              f: "24",
	              t: 13,
	              g: 1
	            }],
	            f: []
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "buttons",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "a",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "all-features",
	                g: 1
	              }, {
	                n: "href",
	                f: "/",
	                t: 13,
	                g: 1
	              }],
	              f: ["See All Features"]
	            }]
	          }]
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "c-footer"
	    }]
	  }],
	  e: {
	    "true": function () {
	      return true;
	    },
	    "_0&&!_1": function (_0, _1) {
	      return _0 && !_1;
	    }
	  }
	};
	component$7.exports.components = {
	  "c-header-gradient": headerGradient,
	  "c-comparison-table": comparisonTable,
	  "c-footer": footer,
	  "c-header": header,
	  "r-page": rPage
	};
	var skypack = ractive__default["default"].extend(component$7.exports);

	var component$6 = {
	  exports: {}
	};

	/* eslint-disable no-throw-literal */

	const defaultError = 'Sorry, this doesn\'t look like a valid esm.sh link :(';
	component$6.exports = {
	  decorators: {
	    clipboard
	  },
	  data() {
	    return {
	      title: 'Migrate from esm.sh to jsDelivr',
	      description: 'Migrate from esm.sh to jsDelivr - a free, fast, and reliable Open Source CDN optimized for JS and ESM delivery from npm and GitHub. Works with all web formats. Serving more than 150 billion requests per month.'
	    };
	  },
	  oninit() {
	    let buildJsDelivrLink = (name, version = '', restPath = '') => {
	      return `https://cdn.jsdelivr.net/npm/${name}${version}${restPath}/+esm`;
	    };
	    let esmsh2jsDelivr = esmsh => Promise.resolve().then(() => {
	      let pattern = /^https?:\/\/esm\.sh\/([A-Za-z0-9-_]+)(@\d+\.\d+\.\d+|@\d+\.\d+|@\d+)?((\/\w+)?(\/\w+)*(\.\w+){0,2})?(\?[A-Za-z0-9-_=:/&@.]+)?/i;
	      let match = pattern.exec(esmsh);
	      if (match) {
	        let [matchedInput, name, version, restPath] = match;
	        if (matchedInput === esmsh) {
	          return buildJsDelivrLink(name, version, restPath);
	        }
	      }
	      throw defaultError;
	    });
	    this.observe('in', debounce(throttle(esmsh => {
	      this.set('displayHtmlWarning', esmsh.slice(-5) === '.html');
	      if (!esmsh) {
	        return this.set('out', '');
	      }
	      esmsh2jsDelivr(esmsh).then(jsDelivr => {
	        this.set('error', false);
	        if (this.get('in') === esmsh) {
	          this.set('out', jsDelivr);
	        }
	      }).catch(error => {
	        this.set('error', true);
	        this.set('out', typeof error === 'string' ? error : defaultError);
	      });
	    }, 1000)));
	  }
	};
	component$6.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "r-page",
	    m: [{
	      n: "noYield",
	      f: [{
	        t: 2,
	        r: "noYield"
	      }],
	      t: 13
	    }, {
	      n: "title",
	      f: [{
	        t: 2,
	        r: "title"
	      }],
	      t: 13
	    }, {
	      n: "description",
	      f: [{
	        t: 2,
	        r: "description"
	      }],
	      t: 13
	    }],
	    f: [{
	      t: 7,
	      e: "c-header",
	      m: [{
	        n: "useWhiteLogos",
	        f: "true",
	        t: 13,
	        g: 1
	      }, {
	        n: "additionalClasses",
	        f: "header-with-orange-bg",
	        t: 13,
	        g: 1
	      }]
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "p-esmsh",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "c-header-gradient",
	        m: [{
	          n: "showMap",
	          f: [{
	            t: 2,
	            x: {
	              r: [],
	              s: "true"
	            }
	          }],
	          t: 13
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "content",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "title",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "h1",
	            f: ["Migrating from esm.sh to jsDelivr"]
	          }, " ", {
	            t: 7,
	            e: "h2",
	            f: ["jsDelivr is a free, fast, and reliable Open Source CDN for npm and GitHub. Most esm.sh links can be easily converted to jsDelivr links."]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "container",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "box",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                n: "class",
	                f: ["bar ", {
	                  t: 4,
	                  f: ["bar-active"],
	                  n: 50,
	                  x: {
	                    r: ["out", "error"],
	                    s: "_0&&!_1"
	                  }
	                }],
	                t: 13
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "circle",
	                  g: 1
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  n: "class",
	                  f: ["line ", {
	                    t: 4,
	                    f: ["filled"],
	                    n: 50,
	                    x: {
	                      r: ["out", "error"],
	                      s: "_0&&!_1"
	                    }
	                  }],
	                  t: 13
	                }]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  n: "class",
	                  f: ["circle bottom ", {
	                    t: 4,
	                    f: ["circle-disabled"],
	                    n: 51,
	                    x: {
	                      r: ["out", "error"],
	                      s: "_0&&!_1"
	                    }
	                  }],
	                  t: 13
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "icon-competitor",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "p",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "icon-as-text",
	                  g: 1
	                }],
	                f: ["esm.sh"]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "input-wrapper mb-48",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "input",
	                m: [{
	                  n: "type",
	                  f: "text",
	                  t: 13
	                }, {
	                  n: "class",
	                  f: ["input ", {
	                    t: 4,
	                    f: ["active"],
	                    n: 50,
	                    r: "out"
	                  }],
	                  t: 13
	                }, {
	                  n: "placeholder",
	                  f: "Paste a esm.sh link here",
	                  t: 13
	                }, {
	                  n: "value",
	                  f: [{
	                    t: 2,
	                    r: "in"
	                  }],
	                  t: 13
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "icon-jsdelivr",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "115",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "28",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/jsDelivr.logo.svg"],
	                  t: 13
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "input-wrapper",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "input",
	                m: [{
	                  n: "type",
	                  f: "text",
	                  t: 13
	                }, {
	                  n: "class",
	                  f: ["input ", {
	                    t: 4,
	                    f: ["input-jsdelivr-copy"],
	                    n: 50,
	                    x: {
	                      r: ["out", "error"],
	                      s: "_0&&!_1"
	                    }
	                  }, " ", {
	                    t: 4,
	                    f: ["active"],
	                    n: 50,
	                    r: "out"
	                  }],
	                  t: 13
	                }, {
	                  n: "placeholder",
	                  f: "Get a jsDelivr link here",
	                  t: 13
	                }, {
	                  n: "value",
	                  f: [{
	                    t: 2,
	                    r: "out"
	                  }],
	                  t: 13
	                }]
	              }, " ", {
	                t: 4,
	                f: [{
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "copy",
	                    g: 1
	                  }, {
	                    n: "clipboard",
	                    t: 71
	                  }, {
	                    n: "data-clipboard-text",
	                    f: [{
	                      t: 2,
	                      r: "out"
	                    }],
	                    t: 13
	                  }],
	                  f: ["Copy"]
	                }],
	                n: 50,
	                x: {
	                  r: ["out", "error"],
	                  s: "_0&&!_1"
	                }
	              }]
	            }, " ", {
	              t: 4,
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "alert alert-warning",
	                  g: 1
	                }, {
	                  n: "role",
	                  f: "alert",
	                  t: 13,
	                  g: 1
	                }],
	                f: ["For security reasons, we serve HTML files with ", {
	                  t: 7,
	                  e: "code",
	                  f: ["Content-Type: text/plain"]
	                }, ". We recommend using ", {
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    n: "href",
	                    f: "https://pages.github.com/",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "target",
	                    f: "_blank",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "rel",
	                    f: "noopener noreferrer",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: ["GitHub Pages"]
	                }, " if this is a problem."]
	              }],
	              n: 50,
	              r: "displayHtmlWarning"
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "host-descr-title",
	              g: 1
	            }],
	            f: ["esm.sh and jsDelivr comparison"]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "host-descr-text",
	              g: 1
	            }],
	            f: ["jsDelivr is a great alternative for esm.sh and offers many advanced features like direct npm and github integration, file minification, and ES modules compilation and optimized delivery. In addition to that jsDelivr is faster thanks to it's global infrastructure that utilizes multiple CDN providers"]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "container",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "c-comparison-table",
	            m: [{
	              n: "competitorTitleEl",
	              f: [{
	                t: 2,
	                x: {
	                  r: [],
	                  s: "\"<p class='icon-as-text'>ESM.SH</p>\""
	                }
	              }],
	              t: 13
	            }, {
	              n: "competitorImgWidth",
	              f: "111",
	              t: 13,
	              g: 1
	            }, {
	              n: "competitorImgHeight",
	              f: "24",
	              t: 13,
	              g: 1
	            }],
	            f: []
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "buttons",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "a",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "all-features",
	                g: 1
	              }, {
	                n: "href",
	                f: "/",
	                t: 13,
	                g: 1
	              }],
	              f: ["See All Features"]
	            }]
	          }]
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "c-footer"
	    }]
	  }],
	  e: {
	    "true": function () {
	      return true;
	    },
	    "_0&&!_1": function (_0, _1) {
	      return _0 && !_1;
	    },
	    "\"<p class='icon-as-text'>ESM.SH</p>\"": function () {
	      return "<p class='icon-as-text'>ESM.SH</p>";
	    }
	  }
	};
	component$6.exports.components = {
	  "c-header-gradient": headerGradient,
	  "c-comparison-table": comparisonTable,
	  "c-footer": footer,
	  "c-header": header,
	  "r-page": rPage
	};
	var esmsh = ractive__default["default"].extend(component$6.exports);

	var component$5 = {
	  exports: {}
	};
	component$5.exports = {
	  data() {
	    return {
	      _,
	      requestsAmount: 0,
	      bandwidthAmount: 0,
	      requestsGrowthPercent: 0,
	      bandwidthGrowthPercent: 0,
	      growthPeriods: stats.growthPeriods,
	      growthPeriod: 'monthly'
	    };
	  },
	  oninit() {
	    if (!ractive__default["default"].isServer) {
	      this.observe('periodData', ({
	        periodValue,
	        periodType
	      }) => {
	        let name = this.get('name');
	        let bandwidthUnit = this.get('bandwidthUnit');
	        this.set('growthPeriod', this.get('growthPeriods')[periodType]);
	        http.fetchCdnOssStats(name, periodValue).then(({
	          hits,
	          bandwidth
	        }) => {
	          if (hits.total >= 0) {
	            this.animate('requestsAmount', hits.total, {
	              duration: 1000
	            });
	            this.animate('requestsGrowthPercent', _.calculateGrowth(hits.total, hits.prev.total), {
	              duration: 1000
	            });
	          }
	          if (bandwidth.total >= 0) {
	            if (!bandwidthUnit) {
	              bandwidthUnit = _.findUnitFromNumber(bandwidth.total);
	            }
	            this.set('bandwidthUnitInternal', bandwidthUnit);
	            this.animate('bandwidthAmount', _.convertBytesToUnits(bandwidth.total, bandwidthUnit), {
	              duration: 1000
	            });
	            this.animate('bandwidthGrowthPercent', _.calculateGrowth(bandwidth.total, bandwidth.prev.total), {
	              duration: 1000
	            });
	          }
	        });
	      });
	    }
	  }
	};
	component$5.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      t: 13,
	      n: "class",
	      f: "c-proxy-request-bandwidth-stats",
	      g: 1
	    }],
	    f: [{
	      t: 7,
	      e: "c-request-bandwidth-stats",
	      m: [{
	        n: "requestsAmount",
	        f: [{
	          t: 2,
	          r: "requestsAmount"
	        }],
	        t: 13
	      }, {
	        n: "requestsGrowthPercent",
	        f: [{
	          t: 2,
	          r: "requestsGrowthPercent"
	        }],
	        t: 13
	      }, {
	        n: "growthPeriod",
	        f: [{
	          t: 2,
	          r: "growthPeriod"
	        }],
	        t: 13
	      }, {
	        n: "bandwidthAmount",
	        f: [{
	          t: 2,
	          r: "bandwidthAmount"
	        }],
	        t: 13
	      }, {
	        n: "bandwidthUnit",
	        f: [{
	          t: 2,
	          r: "bandwidthUnitInternal"
	        }],
	        t: 13
	      }, {
	        n: "bandwidthGrowthPercent",
	        f: [{
	          t: 2,
	          r: "bandwidthGrowthPercent"
	        }],
	        t: 13
	      }],
	      f: []
	    }]
	  }]
	};
	component$5.exports.components = {
	  "c-request-bandwidth-stats": requestBandwidthStats
	};
	var proxyRequestBandwidthStats = ractive__default["default"].extend(component$5.exports);

	var component$4 = {
	  exports: {}
	};
	component$4.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      t: 13,
	      n: "class",
	      f: "c-proxy-head",
	      g: 1
	    }],
	    f: [{
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "info-block",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "head-title",
	          g: 1
	        }],
	        f: [{
	          t: 16,
	          x: {
	            r: [],
	            s: "\"title\""
	          }
	        }]
	      }, " ", {
	        t: 16,
	        x: {
	          r: [],
	          s: "\"img\""
	        }
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "head-descr",
	          g: 1
	        }],
	        f: [{
	          t: 16,
	          x: {
	            r: [],
	            s: "\"descr\""
	          }
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "head-links",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "a",
	          m: [{
	            n: "href",
	            f: [{
	              t: 2,
	              r: "link"
	            }],
	            t: 13
	          }, {
	            n: "target",
	            f: "_blank",
	            t: 13,
	            g: 1
	          }, {
	            n: "rel",
	            f: "noopener noreferrer",
	            t: 13,
	            g: 1
	          }],
	          f: [{
	            t: 2,
	            r: "link"
	          }]
	        }, " ", {
	          t: 7,
	          e: "a",
	          m: [{
	            n: "href",
	            f: [{
	              t: 2,
	              r: "docsLink"
	            }],
	            t: 13
	          }, {
	            n: "target",
	            f: "_blank",
	            t: 13,
	            g: 1
	          }, {
	            n: "rel",
	            f: "noopener noreferrer",
	            t: 13,
	            g: 1
	          }],
	          f: ["Documentation"]
	        }, " ", {
	          t: 7,
	          e: "a",
	          m: [{
	            n: "href",
	            f: [{
	              t: 2,
	              r: "jsDelivrLink"
	            }],
	            t: 13
	          }],
	          f: ["jsDelivr Project Page"]
	        }]
	      }]
	    }, " ", {
	      t: 16,
	      x: {
	        r: [],
	        s: "\"img\""
	      }
	    }]
	  }],
	  e: {
	    "\"title\"": function () {
	      return "title";
	    },
	    "\"img\"": function () {
	      return "img";
	    },
	    "\"descr\"": function () {
	      return "descr";
	    }
	  }
	};
	var proxyHead = ractive__default["default"].extend(component$4.exports);

	var component$3 = {
	  exports: {}
	};
	component$3.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      t: 13,
	      n: "class",
	      f: "c-proxy-hosting-info",
	      g: 1
	    }],
	    f: [{
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "bg-container",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "img",
	        m: [{
	          n: "src",
	          f: [{
	            t: 2,
	            r: "@shared.assetsHost"
	          }, "/img/proxy/info-logo.svg"],
	          t: 13
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "info",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "info-title",
	          g: 1
	        }],
	        f: ["Custom CDN Endpoints"]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "info-text",
	          g: 1
	        }],
	        f: ["We can work together and setup a custom configuration for your project. This way, you can have full control over your files and the ability to utilize the full power of jsDelivr."]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "info-text",
	          g: 1
	        }],
	        f: ["This kind of custom hosting can be suitable for:"]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "info-subtitle",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "img",
	          m: [{
	            n: "width",
	            f: "24",
	            t: 13,
	            g: 1
	          }, {
	            n: "height",
	            f: "24",
	            t: 13,
	            g: 1
	          }, {
	            n: "src",
	            f: [{
	              t: 2,
	              r: "@shared.assetsHost"
	            }, "/img/icons/check-circle.svg"],
	            t: 13
	          }]
	        }, " Binary hosting. Windows executable files and zips"]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "info-subtitle",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "img",
	          m: [{
	            n: "width",
	            f: "24",
	            t: 13,
	            g: 1
	          }, {
	            n: "height",
	            f: "24",
	            t: 13,
	            g: 1
	          }, {
	            n: "src",
	            f: [{
	              t: 2,
	              r: "@shared.assetsHost"
	            }, "/img/icons/check-circle.svg"],
	            t: 13
	          }]
	        }, " Frequently updated files"]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "info-subtitle",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "img",
	          m: [{
	            n: "width",
	            f: "24",
	            t: 13,
	            g: 1
	          }, {
	            n: "height",
	            f: "24",
	            t: 13,
	            g: 1
	          }, {
	            n: "src",
	            f: [{
	              t: 2,
	              r: "@shared.assetsHost"
	            }, "/img/icons/check-circle.svg"],
	            t: 13
	          }]
	        }, " Projects that can't follow jsDelivr file structure"]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "info-subtitle",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "img",
	          m: [{
	            n: "width",
	            f: "24",
	            t: 13,
	            g: 1
	          }, {
	            n: "height",
	            f: "24",
	            t: 13,
	            g: 1
	          }, {
	            n: "src",
	            f: [{
	              t: 2,
	              r: "@shared.assetsHost"
	            }, "/img/icons/check-circle.svg"],
	            t: 13
	          }]
	        }, " Some other use that will blow all of our minds."]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "info-text",
	          g: 1
	        }],
	        f: ["Simply send an email to ", {
	          t: 7,
	          e: "a",
	          m: [{
	            n: "href",
	            f: "mailto:d@jsdelivr.com",
	            t: 13,
	            g: 1
	          }],
	          f: ["d@jsdelivr.com"]
	        }, " with a request for more information."]
	      }]
	    }]
	  }]
	};
	var proxyHostingInfo = ractive__default["default"].extend(component$3.exports);

	var component$2 = {
	  exports: {}
	};
	component$2.exports = {
	  data() {
	    return {
	      title: 'Custom CDN Endpoints - jsDelivr',
	      description: 'jsDelivr is happy to support unique use-cases that require a fast CDN.',
	      ossCdnProjects
	    };
	  }
	};
	component$2.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "r-page",
	    m: [{
	      n: "noYield",
	      f: [{
	        t: 2,
	        r: "noYield"
	      }],
	      t: 13
	    }, {
	      n: "title",
	      f: [{
	        t: 2,
	        r: "title"
	      }],
	      t: 13
	    }, {
	      n: "description",
	      f: [{
	        t: 2,
	        r: "description"
	      }],
	      t: 13
	    }],
	    f: [{
	      t: 7,
	      e: "c-header"
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "p-proxy",
	        g: 1
	      }],
	      f: [{
	        t: 4,
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "proxy-wrapper",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "proxy-item",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "c-proxy-head",
	              m: [{
	                n: "link",
	                f: [{
	                  t: 2,
	                  r: "link"
	                }],
	                t: 13
	              }, {
	                n: "docsLink",
	                f: [{
	                  t: 2,
	                  r: "docsLink"
	                }],
	                t: 13
	              }, {
	                n: "jsDelivrLink",
	                f: [{
	                  t: 2,
	                  r: "jsDelivrLink"
	                }],
	                t: 13
	              }],
	              f: [" "],
	              p: {
	                title: [{
	                  t: 2,
	                  r: "title"
	                }],
	                descr: [{
	                  t: 2,
	                  r: "descr"
	                }],
	                img: [{
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: "width",
	                    f: [{
	                      t: 2,
	                      r: "imgWidth"
	                    }],
	                    t: 13
	                  }, {
	                    n: "height",
	                    f: [{
	                      t: 2,
	                      r: "imgHeight"
	                    }],
	                    t: 13
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, {
	                      t: 2,
	                      r: "imgSrc"
	                    }],
	                    t: 13
	                  }]
	                }]
	              }
	            }, " ", {
	              t: 7,
	              e: "c-proxy-request-bandwidth-stats",
	              m: [{
	                n: "name",
	                f: [{
	                  t: 2,
	                  r: "apiCdnName"
	                }],
	                t: 13
	              }, {
	                n: "periodData",
	                f: "{periodValue: 'month', periodText: 'month', periodType: 's-month'}",
	                t: 13,
	                g: 1
	              }, {
	                n: "bandwidthUnit",
	                f: "GB",
	                t: 13,
	                g: 1
	              }],
	              f: []
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "full-stats-link btn-arrow",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "href",
	                  f: [{
	                    t: 2,
	                    r: "jsDelivrLink"
	                  }],
	                  t: 13
	                }],
	                f: [{
	                  t: 7,
	                  e: "span",
	                  f: [{
	                    t: 2,
	                    r: "title"
	                  }, " full stats"]
	                }, " ", {
	                  t: 7,
	                  e: "img",
	                  m: [{
	                    n: "width",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "20",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "src",
	                    f: [{
	                      t: 2,
	                      r: "@shared.assetsHost"
	                    }, "/img/icons/arrow-right.svg"],
	                    t: 13
	                  }]
	                }]
	              }]
	            }]
	          }]
	        }],
	        n: 52,
	        r: "ossCdnProjects"
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "proxy-info",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "divider",
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "c-proxy-hosting-info"
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "c-footer"
	    }]
	  }]
	};
	component$2.exports.components = {
	  "c-proxy-request-bandwidth-stats": proxyRequestBandwidthStats,
	  "c-proxy-head": proxyHead,
	  "c-proxy-hosting-info": proxyHostingInfo,
	  "c-footer": footer,
	  "c-header": header,
	  "r-page": rPage
	};
	var ossCdn = ractive__default["default"].extend(component$2.exports);

	var component$1 = {
	  exports: {}
	};
	component$1.exports = {
	  computed: {
	    title() {
	      return this.get('projectTitle') + ' CDN by jsDelivr';
	    },
	    description() {
	      return `A free, fast, and reliable CDN for ${this.get('projectTitle')}. ${this.get('projectDescr')}`;
	    },
	    usageChartGroupByValues() {
	      return stats.groupByOptions[this.get('periodData').periodType];
	    }
	  },
	  data() {
	    return {
	      periodData: {
	        periodText: 'quarter',
	        periodValue: 'quarter',
	        periodType: 's-quarter'
	      },
	      showChartBandwidth: false,
	      usageChartGroupBy: 'day',
	      noPackageStatsData: false,
	      projectTitle: '',
	      projectDescr: '',
	      projectImgSrc: '',
	      projectImgW: '',
	      projectImgH: '',
	      rawStatsData: {},
	      preparedStatsData: {},
	      cdnOssRes: null,
	      topFiles: null,
	      topFilesHeaders: null,
	      topFilesLimit: 10,
	      topFilesPage: 1
	    };
	  },
	  oninit() {
	    this.observe('name', name => {
	      this.set('projectTitle', ossCdnProjects[name].title);
	      this.set('projectDescr', ossCdnProjects[name].descr);
	      this.set('projectImgW', ossCdnProjects[name].imgWidth);
	      this.set('projectImgH', ossCdnProjects[name].imgHeight);
	      this.set('projectImgSrc', ossCdnProjects[name].imgSrc);
	      this.set('projectLink', ossCdnProjects[name].link);
	      this.set('projectApiName', ossCdnProjects[name].apiCdnName);
	      this.set('docsLink', ossCdnProjects[name].docsLink);
	    });
	    if (!ractive__default["default"].isServer) {
	      // get files for a specific cdn-oss
	      this.observe('projectApiName topFilesPage topFilesLimit showChartBandwidth', () => {
	        let projectApiName = this.get('projectApiName');
	        let topFilesLimit = this.get('topFilesLimit');
	        let topFilesPage = this.get('topFilesPage');
	        let filterBy = this.get('showChartBandwidth') ? 'bandwidth' : 'hits';
	        http.getCdnOssFiles(projectApiName, filterBy, topFilesLimit, topFilesPage).then(result => {
	          this.set('cdnOssRes', result);
	        });
	      });

	      // handle cdn oss files data
	      this.observe('cdnOssRes', () => {
	        let {
	          response,
	          responseHeaders
	        } = this.get('cdnOssRes');
	        this.set('topFiles', response.map(i => ({
	          name: i.name,
	          hits: i.hits.total,
	          bandwidth: i.bandwidth.total
	        })));
	        this.set('topFilesHeaders', responseHeaders);
	      }, {
	        init: false
	      });

	      // handle chart period changes by updating groupBy options and chart data fetching
	      this.observe('periodData', periodData => {
	        let period = periodData.periodValue;
	        let projectApiName = this.get('projectApiName');

	        // prevent chart data fetching from the back when period is DAY, left it as it was prev
	        if (period === 'day') {
	          return;
	        }
	        http.fetchCdnOssStats(projectApiName, period).then(response => {
	          if (!response.hits.total || !response.bandwidth.total) {
	            this.set('noPackageStatsData', true);
	            return;
	          }
	          this.set('noPackageStatsData', false);
	          // once new data fetched we should set groupBy to default value before raw data set
	          this.set('usageChartGroupBy', 'day');
	          this.set('rawStatsData', response);
	        });
	      });

	      // handle raw data and prepare it for chart
	      // screenWidth to observe when screen width is resized to recreate chart
	      this.observe('rawStatsData showChartBandwidth usageChartGroupBy screenWidth', () => {
	        let rawStatsData = this.get('rawStatsData');
	        let chartPeriodType = this.get('periodData').periodType;
	        let showChartBandwidth = this.get('showChartBandwidth');
	        let usageChartGroupBy = this.get('usageChartGroupBy');
	        let screenWidth = this.get('screenWidth') ? this.get('screenWidth') : window.innerWidth;
	        let dataType = showChartBandwidth ? 'bandwidth' : 'hits';

	        // collect X-Axis dates, group data by period, get
	        let {
	          values,
	          labels,
	          labelsStartEndPeriods,
	          maxRangeValue,
	          valueUnits
	        } = _.getPreparedDataForBarChart(rawStatsData[dataType], usageChartGroupBy, chartPeriodType, showChartBandwidth);

	        // get bat thickness of the chart depending on screen resolution, chartPeriodType and groupBy
	        let chartBarThickness = _.calcChartBarThicknessByResolution(chartPeriodType, usageChartGroupBy);

	        // set prepared data for chart
	        this.set('preparedStatsData', {
	          data: values,
	          labels,
	          labelsStartEndPeriods,
	          maxRangeValue,
	          showChartBandwidth,
	          barThickness: chartBarThickness,
	          useYAxisBorderPlugin: screenWidth >= 768,
	          yAxisPadding: screenWidth >= 768 ? 20 : 8,
	          valueUnits
	        });
	      }, {
	        init: false
	      });
	    }
	  },
	  onrender() {
	    let statsChart;
	    charts().then(({
	      createBarChart
	    }) => {
	      // draw a chart when data is ready
	      this.observe('preparedStatsData', preparedStatsData => {
	        if (!preparedStatsData) {
	          return;
	        }
	        let {
	          labels,
	          maxRangeValue,
	          data,
	          showChartBandwidth,
	          barThickness,
	          useYAxisBorderPlugin,
	          yAxisPadding,
	          labelsStartEndPeriods,
	          valueUnits
	        } = preparedStatsData;
	        let statsChartCanvasEl = this.find('#cdn-stats-chart');
	        if (!preparedStatsData || !statsChartCanvasEl) {
	          return;
	        }
	        if (statsChart) {
	          statsChart.destroy();
	          statsChart = null;
	        }
	        let chartData = {
	          labels,
	          datasets: [{
	            data,
	            borderWidth: 0,
	            barThickness,
	            hoverBackgroundColor: '#F65128'
	          }],
	          labelsStartEndPeriods,
	          valueUnits
	        };
	        let chartSettings = {
	          useYAxisBorderPlugin,
	          useExternalTooltip: true,
	          useImprovedTooltip: true,
	          externalTooltipVerticalOffset: 40
	        };
	        let maxRangeMagnitude = Math.floor(Math.log10(maxRangeValue));
	        let chartConfig = {
	          options: {
	            scales: {
	              x: {
	                display: true,
	                ticks: {
	                  autoSkip: false,
	                  color: '#5C667A',
	                  font: {
	                    size: 12,
	                    family: 'Lexend, sans-serif',
	                    lineHeight: 2
	                  },
	                  // return nothing when labelValue array is empty
	                  // this way we will not get italicized text when all ticks can't be displayed at once normally
	                  callback(value) {
	                    let labelValue = this.getLabelForValue(value);
	                    if (labelValue.length) {
	                      return labelValue;
	                    }
	                  }
	                },
	                grid: {
	                  display: false
	                },
	                border: {
	                  display: false
	                }
	              },
	              y: {
	                display: true,
	                min: 0,
	                suggestedMax: Math.ceil(maxRangeValue / Math.pow(10, maxRangeMagnitude)) * Math.pow(10, maxRangeMagnitude),
	                ticks: {
	                  padding: yAxisPadding,
	                  count: 9,
	                  color: '#5C667A',
	                  crossAlign: 'near',
	                  font: {
	                    size: 12,
	                    family: 'Lexend, sans-serif'
	                  },
	                  callback(value) {
	                    let valueByMagnitude = _.getValueByMagnitude(Math.round(value), 'round', 1, false);
	                    if (_.isMobileScreen()) {
	                      return showChartBandwidth ? `${_.formatNumber(valueByMagnitude)} ${valueUnits}` : _.formatToShortNumber(valueByMagnitude);
	                    }
	                    return showChartBandwidth ? `${_.formatNumber(valueByMagnitude)} ${valueUnits}` : _.formatNumber(valueByMagnitude);
	                  }
	                },
	                grid: {
	                  display: false
	                },
	                border: {
	                  display: false
	                }
	              }
	            }
	          }
	        };
	        statsChart = createBarChart(statsChartCanvasEl, chartData, chartSettings, chartConfig);
	      });
	    });
	    listeners.screenWidthListener(this);
	  },
	  handlePeriodSelecting() {
	    return periodData => {
	      this.set('periodData', periodData);
	    };
	  }
	};
	component$1.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "r-page",
	    m: [{
	      n: "noYield",
	      f: [{
	        t: 2,
	        r: "noYield"
	      }],
	      t: 13
	    }, {
	      n: "title",
	      f: [{
	        t: 2,
	        r: "title"
	      }],
	      t: 13
	    }, {
	      n: "description",
	      f: [{
	        t: 2,
	        r: "description"
	      }],
	      t: 13
	    }],
	    f: [{
	      t: 7,
	      e: "c-header"
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "p-proxy-project",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "content-wrapper",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "c-proxy-head",
	          m: [{
	            n: "name",
	            f: [{
	              t: 2,
	              r: "projectApiName"
	            }],
	            t: 13
	          }, {
	            n: "link",
	            f: [{
	              t: 2,
	              r: "projectLink"
	            }],
	            t: 13
	          }, {
	            n: "docsLink",
	            f: [{
	              t: 2,
	              r: "docsLink"
	            }],
	            t: 13
	          }, {
	            n: "jsDelivrLink",
	            f: ["/oss-cdn/", {
	              t: 2,
	              r: "name"
	            }],
	            t: 13
	          }],
	          f: [" "],
	          p: {
	            title: [{
	              t: 2,
	              r: "projectTitle"
	            }],
	            descr: [{
	              t: 2,
	              r: "projectDescr"
	            }],
	            img: [{
	              t: 7,
	              e: "img",
	              m: [{
	                n: "width",
	                f: [{
	                  t: 2,
	                  r: "projectImgW"
	                }],
	                t: 13
	              }, {
	                n: "height",
	                f: [{
	                  t: 2,
	                  r: "projectImgH"
	                }],
	                t: 13
	              }, {
	                n: "src",
	                f: [{
	                  t: 2,
	                  r: "@shared.assetsHost"
	                }, {
	                  t: 2,
	                  r: "projectImgSrc"
	                }],
	                t: 13
	              }]
	            }]
	          }
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "divider",
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "ctrls-block",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "ctrls-block-title",
	              g: 1
	            }],
	            f: ["Statistics"]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "ctrls-block-ctrls",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "chart-type-ctrl",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "span",
	                f: ["Show numbers of"]
	              }, " ", {
	                t: 7,
	                e: "input",
	                m: [{
	                  n: "id",
	                  f: "chart-switch",
	                  t: 13
	                }, {
	                  n: "type",
	                  f: "checkbox",
	                  t: 13
	                }, {
	                  n: "class",
	                  f: ["chart-type-switch ", {
	                    t: 4,
	                    f: ["checked"],
	                    n: 50,
	                    r: "showChartBandwidth"
	                  }],
	                  t: 13
	                }, {
	                  t: 73,
	                  v: "t",
	                  f: "false"
	                }]
	              }, " ", {
	                t: 7,
	                e: "label",
	                m: [{
	                  n: "for",
	                  f: "chart-switch",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: ["click"],
	                  t: 70,
	                  f: {
	                    r: ["@this", "showChartBandwidth"],
	                    s: "[_0.set(\"showChartBandwidth\",!_1)]"
	                  }
	                }],
	                f: [{
	                  t: 7,
	                  e: "span",
	                  f: ["Requests"]
	                }, " ", {
	                  t: 7,
	                  e: "span",
	                  f: ["Bandwidth"]
	                }, " ", {
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "slide-select",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "div",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "selected",
	                      g: 1
	                    }]
	                  }]
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "data-range-ctrl",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "span",
	                f: ["Data range:"]
	              }, " ", {
	                t: 7,
	                e: "c-periods-dropdown",
	                m: [{
	                  n: "selectedValue",
	                  f: [{
	                    t: 2,
	                    r: "periodData.periodValue"
	                  }],
	                  t: 13
	                }, {
	                  n: "selectHandler",
	                  f: [{
	                    t: 2,
	                    x: {
	                      r: ["@this"],
	                      s: "_0.handlePeriodSelecting()"
	                    }
	                  }],
	                  t: 13
	                }]
	              }]
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "c-proxy-request-bandwidth-stats",
	          m: [{
	            n: "name",
	            f: [{
	              t: 2,
	              r: "projectApiName"
	            }],
	            t: 13
	          }, {
	            n: "periodData",
	            f: [{
	              t: 2,
	              r: "periodData"
	            }],
	            t: 13
	          }]
	        }, " ", {
	          t: 4,
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "no-data-wrapper",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "img",
	              m: [{
	                n: "width",
	                f: "180",
	                t: 13,
	                g: 1
	              }, {
	                n: "height",
	                f: "152",
	                t: 13,
	                g: 1
	              }, {
	                n: "src",
	                f: [{
	                  t: 2,
	                  r: "@shared.assetsHost"
	                }, "/img/no-data-chart-main.svg"],
	                t: 13
	              }]
	            }, " ", {
	              t: 7,
	              e: "span",
	              f: ["No statistics yet"]
	            }, " ", {
	              t: 7,
	              e: "span",
	              f: ["This is probably not a very popular package :("]
	            }]
	          }],
	          n: 50,
	          r: "noPackageStatsData"
	        }, {
	          t: 4,
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "chart-ctrls",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "chart-ctrls-title",
	                g: 1
	              }],
	              f: ["Stats for last ", {
	                t: 2,
	                r: "~/periodData.periodText"
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "chart-ctrls-group-by",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "span",
	                f: ["Group by:"]
	              }, " ", {
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "btn-group",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "button",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "btn dropdown-toggle",
	                    g: 1
	                  }, {
	                    n: "type",
	                    f: "button",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "data-toggle",
	                    f: "dropdown",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "aria-haspopup",
	                    f: "true",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "aria-expanded",
	                    f: "false",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "span",
	                    f: [{
	                      t: 2,
	                      rx: {
	                        r: "~/usageChartGroupByValues",
	                        m: [{
	                          t: 30,
	                          n: "usageChartGroupBy"
	                        }, "value"]
	                      }
	                    }]
	                  }, " ", {
	                    t: 7,
	                    e: "i",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "fa fa-angle-down",
	                      g: 1
	                    }, {
	                      n: "aria-hidden",
	                      f: "true",
	                      t: 13,
	                      g: 1
	                    }]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "ul",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "dropdown-menu",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 4,
	                    f: [{
	                      t: 7,
	                      e: "li",
	                      f: [{
	                        t: 4,
	                        f: [{
	                          t: 7,
	                          e: "a",
	                          m: [{
	                            n: ["click"],
	                            t: 70,
	                            f: {
	                              r: ["@this", "@key"],
	                              s: "[_0.set(\"usageChartGroupBy\",_1)]"
	                            }
	                          }],
	                          f: [{
	                            t: 2,
	                            r: "./value"
	                          }]
	                        }],
	                        n: 50,
	                        r: "./isAvailable"
	                      }]
	                    }],
	                    n: 52,
	                    r: "~/usageChartGroupByValues"
	                  }]
	                }]
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "chart-wrapper",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "canvas",
	              m: [{
	                n: "id",
	                f: "cdn-stats-chart",
	                t: 13,
	                g: 1
	              }]
	            }]
	          }],
	          n: 51,
	          l: 1
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "files-table",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "c-top-stats-table",
	            m: [{
	              n: "title",
	              f: "Top files",
	              t: 13,
	              g: 1
	            }, {
	              n: "responseData",
	              f: [{
	                t: 2,
	                r: "~/topFiles"
	              }],
	              t: 13
	            }, {
	              n: "responseHeaders",
	              f: [{
	                t: 2,
	                r: "topFilesHeaders"
	              }],
	              t: 13
	            }, {
	              n: "isBandwidth",
	              f: [{
	                t: 2,
	                r: "~/showChartBandwidth"
	              }],
	              t: 13
	            }, {
	              n: "pageLimit",
	              f: [{
	                t: 2,
	                r: "topFilesLimit"
	              }],
	              t: 13
	            }, {
	              n: "page",
	              f: [{
	                t: 2,
	                r: "topFilesPage"
	              }],
	              t: 13
	            }, {
	              n: "paginationLimits",
	              f: [{
	                t: 2,
	                x: {
	                  r: [],
	                  s: "[10,20,50,100]"
	                }
	              }],
	              t: 13
	            }, {
	              n: "valueKey",
	              f: [{
	                t: 2,
	                x: {
	                  r: ["showChartBandwidth"],
	                  s: "_0?\"bandwidth\":\"hits\""
	                }
	              }],
	              t: 13
	            }],
	            f: [],
	            p: {
	              column1: [{
	                t: 2,
	                r: "name"
	              }]
	            }
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "explore-all-endpoints",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "a",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "btn-arrow",
	              g: 1
	            }, {
	              n: "href",
	              f: "/oss-cdn/",
	              t: 13,
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "span",
	              f: ["Explore all custom endpoints"]
	            }, " ", {
	              t: 7,
	              e: "img",
	              m: [{
	                n: "width",
	                f: "20",
	                t: 13,
	                g: 1
	              }, {
	                n: "height",
	                f: "20",
	                t: 13,
	                g: 1
	              }, {
	                n: "src",
	                f: [{
	                  t: 2,
	                  r: "@shared.assetsHost"
	                }, "/img/icons/arrow-right.svg"],
	                t: 13
	              }]
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "c-new-infographic-banner",
	          f: [],
	          p: {
	            text: ["Learn more about", {
	              t: 7,
	              e: "br"
	            }, " the infrastructure that", {
	              t: 7,
	              e: "br"
	            }, " powers ", {
	              t: 7,
	              e: "a",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "router-ignore",
	                g: 1
	              }, {
	                n: "href",
	                f: "/network/infographic",
	                t: 13,
	                g: 1
	              }, {
	                n: "target",
	                f: "_blank",
	                t: 13,
	                g: 1
	              }],
	              f: ["jsDelivr"]
	            }]
	          }
	        }, " ", {
	          t: 7,
	          e: "c-proxy-hosting-info"
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "c-footer"
	    }]
	  }],
	  e: {
	    "[_0.set(\"showChartBandwidth\",!_1)]": function (_0, _1) {
	      return [_0.set("showChartBandwidth", !_1)];
	    },
	    "_0.handlePeriodSelecting()": function (_0) {
	      return _0.handlePeriodSelecting();
	    },
	    "[_0.set(\"usageChartGroupBy\",_1)]": function (_0, _1) {
	      return [_0.set("usageChartGroupBy", _1)];
	    },
	    "[10,20,50,100]": function () {
	      return [10, 20, 50, 100];
	    },
	    "_0?\"bandwidth\":\"hits\"": function (_0) {
	      return _0 ? "bandwidth" : "hits";
	    }
	  }
	};
	component$1.exports.components = {
	  "c-top-stats-table": topStatsTable,
	  "c-periods-dropdown": periodsDropdown,
	  "c-proxy-request-bandwidth-stats": proxyRequestBandwidthStats,
	  "c-new-infographic-banner": newInfographicBanner,
	  "c-proxy-head": proxyHead,
	  "c-proxy-hosting-info": proxyHostingInfo,
	  "c-footer": footer,
	  "c-header": header,
	  "r-page": rPage
	};
	var _ossCdnProject = ractive__default["default"].extend(component$1.exports);

	var component = {
	  exports: {}
	};
	const ID_PREFIX = 'id-';
	component.exports = {
	  data() {
	    return {
	      title: 'Documentation - jsDelivr',
	      currentAnchor: '',
	      readmeText: '',
	      sideMenuLinksData: [{
	        id: 'ready-for-production',
	        text: 'Ready for production',
	        section: 'whyJsDelivr'
	      }, {
	        id: 'multi-cdn',
	        text: 'Multi-CDN',
	        section: 'whyJsDelivr'
	      }, {
	        id: 'smart-load-balancing',
	        text: 'Smart Load Balancing',
	        section: 'whyJsDelivr'
	      }, {
	        id: 'failover',
	        text: 'Failover',
	        section: 'whyJsDelivr'
	      }, {
	        id: 'china',
	        text: 'China',
	        section: 'whyJsDelivr'
	      }, {
	        id: 'npm',
	        text: 'npm',
	        section: 'usageDocs'
	      }, {
	        id: 'github',
	        text: 'GitHub',
	        section: 'usageDocs'
	      }, {
	        id: 'combine-multiple-files',
	        text: 'Combine multiple files',
	        section: 'usageDocs'
	      }, {
	        id: 'publishing-packages',
	        text: 'Publishing packages',
	        section: 'usageDocs'
	      }, {
	        id: 'configuring-a-default-file-in-packagejson',
	        text: 'Configuring a default file in package.json',
	        section: 'usageDocs'
	      }, {
	        id: 'wordpress',
	        text: 'WordPress',
	        section: 'usageDocs'
	      }, {
	        id: 'caching',
	        text: 'Caching',
	        section: 'usageDocs'
	      }, {
	        id: 'purge-cache',
	        text: 'Purge cache',
	        section: 'usageDocs'
	      }, {
	        id: 'custom-cdn-hosting',
	        text: 'Custom CDN Hosting',
	        section: 'usageDocs'
	      }, {
	        id: 'privacy-policy',
	        text: 'Privacy Policy',
	        section: 'usageDocs'
	      }]
	    };
	  },
	  handleSideMenuLinkClick(id) {
	    document.getElementById(ID_PREFIX + id).scrollIntoView({
	      behavior: 'smooth'
	    });
	    app.router.dispatch(`${location.pathname}#id-${id}`, {
	      noHistory: true,
	      noScroll: true
	    });
	  },
	  oninit() {
	    if (!ractive__default["default"].isServer) {
	      // fetch README.md from jsDelivr's github
	      // handle detecting which header is in the user view
	      if (this.get('readmeText') === '') {
	        let sideMenuIds = this.get('sideMenuLinksData').map(link => ID_PREFIX + link.id);
	        _.makeHTTPRequest({
	          url: 'https://raw.githubusercontent.com/jsdelivr/jsdelivr/master/README.md',
	          rawResponse: true
	        }).then(response => {
	          this.set('readmeText', response).then(() => {
	            let headers = Array.from(document.querySelectorAll(`h2[id*=${ID_PREFIX}], h3[id*=${ID_PREFIX}]`)).filter(node => sideMenuIds.includes(node.id));
	            let prevPageY = 0;
	            let currentPageY = 0;
	            let handleScroll = () => {
	              currentPageY = window.pageYOffset;
	              if (prevPageY > currentPageY) {
	                // when scroll goes up to not highlight top side menu link
	                headers.forEach((header, idx) => {
	                  if (idx === 1 && header.getBoundingClientRect().top > 600) {
	                    this.set('currentAnchor', '');
	                  }
	                });
	              }

	              // check what side menu link should be highlited on scroll
	              headers.forEach((header, idx) => {
	                if (idx !== headers.length - 1 && header.getBoundingClientRect().top < 150 || idx === headers.length - 1 && header.getBoundingClientRect().top < 250) {
	                  this.set('currentAnchor', header.id.replace(ID_PREFIX, ''));
	                }
	              });
	              prevPageY = currentPageY;
	            };
	            listeners.addManagedListener(this, window, 'scroll', handleScroll);
	          });
	        }).catch(() => {
	          this.set('readmeText', `Failed to load the document. Please view it directly at:<br>https://raw.githubusercontent.com/jsdelivr/jsdelivr/master/README.md`);
	        });
	      }
	    }
	  },
	  onrender() {
	    if (!ractive__default["default"].isServer) {
	      listeners.stickySidebarScrollListener(this);
	    }
	  }
	};
	component.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "r-page",
	    m: [{
	      n: "noYield",
	      f: [{
	        t: 2,
	        r: "noYield"
	      }],
	      t: 13
	    }, {
	      n: "title",
	      f: [{
	        t: 2,
	        r: "title"
	      }],
	      t: 13
	    }, {
	      n: "description",
	      f: [{
	        t: 2,
	        r: "description"
	      }],
	      t: 13
	    }],
	    f: [{
	      t: 7,
	      e: "c-notification"
	    }, " ", {
	      t: 7,
	      e: "c-header"
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "p-documentation",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          n: "class",
	          f: ["please-wait-sign ", {
	            t: 4,
	            f: ["not-displayed"],
	            n: 50,
	            r: "readmeText"
	          }],
	          t: 13
	        }],
	        f: ["Please wait while the document loads."]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          n: "class",
	          f: ["dropdown ", {
	            t: 4,
	            f: ["not-displayed"],
	            n: 51,
	            r: "readmeText"
	          }],
	          t: 13
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "dropdown-toggle",
	            g: 1
	          }, {
	            n: "data-toggle",
	            f: "dropdown",
	            t: 13,
	            g: 1
	          }, {
	            n: "aria-haspopup",
	            f: "true",
	            t: 13,
	            g: 1
	          }, {
	            n: "aria-expanded",
	            f: "false",
	            t: 13,
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "span",
	            f: ["Navigation"]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "toggle-icon",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "toggle-bar",
	                g: 1
	              }]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "toggle-bar",
	                g: 1
	              }]
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "ul",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "dropdown-menu",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "li",
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "dropdown-subtitle",
	                g: 1
	              }],
	              f: ["Why jsDelivr"]
	            }]
	          }, " ", {
	            t: 4,
	            f: [{
	              t: 4,
	              f: [{
	                t: 7,
	                e: "li",
	                f: [{
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    n: "class",
	                    f: ["dropdown-item router-ignore", {
	                      t: 4,
	                      f: [" active"],
	                      n: 50,
	                      x: {
	                        r: ["currentAnchor", "id"],
	                        s: "_0===_1"
	                      }
	                    }],
	                    t: 13
	                  }, {
	                    n: ["click"],
	                    t: 70,
	                    f: {
	                      r: ["@this", "id"],
	                      s: "[_0.handleSideMenuLinkClick(_1)]"
	                    }
	                  }],
	                  f: [{
	                    t: 2,
	                    r: "text"
	                  }]
	                }]
	              }],
	              n: 50,
	              x: {
	                r: ["section"],
	                s: "_0===\"whyJsDelivr\""
	              }
	            }],
	            n: 52,
	            r: "sideMenuLinksData"
	          }, " ", {
	            t: 7,
	            e: "li",
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "dropdown-subtitle",
	                g: 1
	              }],
	              f: ["Why jsDelivr"]
	            }]
	          }, " ", {
	            t: 4,
	            f: [{
	              t: 4,
	              f: [{
	                t: 7,
	                e: "li",
	                f: [{
	                  t: 7,
	                  e: "a",
	                  m: [{
	                    n: "class",
	                    f: ["dropdown-item router-ignore", {
	                      t: 4,
	                      f: [" active"],
	                      n: 50,
	                      x: {
	                        r: ["currentAnchor", "id"],
	                        s: "_0===_1"
	                      }
	                    }],
	                    t: 13
	                  }, {
	                    n: ["click"],
	                    t: 70,
	                    f: {
	                      r: ["@this", "id"],
	                      s: "[_0.handleSideMenuLinkClick(_1)]"
	                    }
	                  }],
	                  f: [{
	                    t: 2,
	                    r: "text"
	                  }]
	                }]
	              }],
	              n: 50,
	              x: {
	                r: ["section"],
	                s: "_0===\"usageDocs\""
	              }
	            }],
	            n: 52,
	            r: "sideMenuLinksData"
	          }]
	        }]
	      }, " ", {
	        t: 7,
	        e: "div",
	        m: [{
	          n: "class",
	          f: ["page-content ", {
	            t: 4,
	            f: ["not-displayed"],
	            n: 51,
	            r: "readmeText"
	          }],
	          t: 13
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "page-content_side-menu",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "menu-section",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "strong",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "section-title",
	                g: 1
	              }],
	              f: ["Why jsDelivr"]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "section-list",
	                g: 1
	              }],
	              f: [{
	                t: 4,
	                f: [{
	                  t: 4,
	                  f: [{
	                    t: 7,
	                    e: "div",
	                    f: [{
	                      t: 7,
	                      e: "a",
	                      m: [{
	                        n: "class",
	                        f: ["router-ignore", {
	                          t: 4,
	                          f: [" active"],
	                          n: 50,
	                          x: {
	                            r: ["currentAnchor", "id"],
	                            s: "_0===_1"
	                          }
	                        }],
	                        t: 13
	                      }, {
	                        n: ["click"],
	                        t: 70,
	                        f: {
	                          r: ["@this", "id"],
	                          s: "[_0.handleSideMenuLinkClick(_1)]"
	                        }
	                      }],
	                      f: [{
	                        t: 2,
	                        r: "text"
	                      }]
	                    }]
	                  }],
	                  n: 50,
	                  x: {
	                    r: ["section"],
	                    s: "_0===\"whyJsDelivr\""
	                  }
	                }],
	                n: 52,
	                r: "sideMenuLinksData"
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "horizontal-divider",
	              g: 1
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "menu-section",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "strong",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "section-title",
	                g: 1
	              }],
	              f: ["Usage Documentation"]
	            }, " ", {
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "section-list",
	                g: 1
	              }],
	              f: [{
	                t: 4,
	                f: [{
	                  t: 4,
	                  f: [{
	                    t: 7,
	                    e: "div",
	                    f: [{
	                      t: 7,
	                      e: "a",
	                      m: [{
	                        n: "class",
	                        f: ["router-ignore", {
	                          t: 4,
	                          f: [" active"],
	                          n: 50,
	                          x: {
	                            r: ["currentAnchor", "id"],
	                            s: "_0===_1"
	                          }
	                        }],
	                        t: 13
	                      }, {
	                        n: ["click"],
	                        t: 70,
	                        f: {
	                          r: ["@this", "id"],
	                          s: "[_0.handleSideMenuLinkClick(_1)]"
	                        }
	                      }],
	                      f: [{
	                        t: 2,
	                        r: "text"
	                      }]
	                    }]
	                  }],
	                  n: 50,
	                  x: {
	                    r: ["section"],
	                    s: "_0===\"usageDocs\""
	                  }
	                }],
	                n: 52,
	                r: "sideMenuLinksData"
	              }]
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "page-content_main",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "c-markdown",
	            m: [{
	              n: "markdown",
	              f: [{
	                t: 2,
	                r: "readmeText"
	              }],
	              t: 13
	            }]
	          }]
	        }]
	      }]
	    }, " ", {
	      t: 7,
	      e: "c-footer"
	    }]
	  }],
	  e: {
	    "_0===_1": function (_0, _1) {
	      return _0 === _1;
	    },
	    "[_0.handleSideMenuLinkClick(_1)]": function (_0, _1) {
	      return [_0.handleSideMenuLinkClick(_1)];
	    },
	    "_0===\"whyJsDelivr\"": function (_0) {
	      return _0 === "whyJsDelivr";
	    },
	    "_0===\"usageDocs\"": function (_0) {
	      return _0 === "usageDocs";
	    }
	  }
	};
	component.exports.components = {
	  "c-markdown": markdown,
	  "c-notification": notification,
	  "c-footer": footer,
	  "c-header": header,
	  "r-page": rPage
	};
	var documentation = ractive__default["default"].extend(component.exports);

	Ractive.DEBUG = location.hostname === 'localhost';

	// Redirect from the old URL format.
	if (location.pathname === '/' && location.hash) {
	  location.href = '/projects/' + location.hash.substr(2);
	}
	let app$1 = {
	  config: {
	    animateScrolling: true
	  },
	  usedCdn: ''
	};
	app$1.router = new Ractive.Router({
	  el: '#page',
	  data() {
	    return {
	      app: app$1,
	      collection: has.localStorage() && localStorage.getItem('collection2') ? JSON.parse(localStorage.getItem('collection2')) : []
	    };
	  },
	  globals: ['query', 'collection']
	});
	app$1.router.addRoute('/', _index, {
	  qs: ['docs', 'limit', 'page', 'query', 'type', 'style']
	});
	app$1.router.addRoute('/esm', esm);
	app$1.router.addRoute('/about', about);
	app$1.router.addRoute('/rawgit', () => {
	  location.href = '/';
	});
	app$1.router.addRoute('/features', () => {
	  location.href = '/';
	});
	app$1.router.addRoute('/github', github);
	app$1.router.addRoute('/foundationcdn', foundationcdn);
	app$1.router.addRoute('/unpkg', unpkg);
	app$1.router.addRoute('/google', google$1);
	app$1.router.addRoute('/become-a-sponsor', becomeASponsor);
	app$1.router.addRoute('/network', network);
	app$1.router.addRoute('/network/infographic', infographic);
	app$1.router.addRoute('/new-jsdelivr', newJsdelivr);
	app$1.router.addRoute('/package/:type(npm)/:scope?/:name', _package, {
	  qs: ['path', 'tab', 'version', 'slide']
	});
	app$1.router.addRoute('/package/:type(gh)/:user/:repo', _package, {
	  qs: ['path', 'tab', 'version', 'slide']
	});
	app$1.router.addRoute('/sponsors', sponsors);
	app$1.router.addRoute('/statistics', statistics);
	app$1.router.addRoute('/tools/purge', purge);
	app$1.router.addRoute('/using-sri-with-dynamic-files', usingSriWithDynamicFiles);
	app$1.router.addRoute('/terms', terms);
	app$1.router.addRoute('/terms/:currentPolicy', terms);
	app$1.router.addRoute('/history', history);
	app$1.router.addRoute('/gsap', gsap);
	app$1.router.addRoute('/skypack', skypack);
	app$1.router.addRoute('/esmsh', esmsh);
	app$1.router.addRoute('/oss-cdn', ossCdn);
	app$1.router.addRoute('/oss-cdn/:name', _ossCdnProject);
	app$1.router.addRoute('/documentation', documentation);
	_.onDocumentReady(() => {
	  let state = {};
	  let ractive = new Ractive();
	  ractive.set('@shared.app', app$1);
	  ractive.set('@shared.escape', escape);
	  function escape(string) {
	    string.replace(/</g, '\\u003c').replace(/>/g, '\\u003e').replace(/\u2028/g, '\\u2028').replace(/\u2029/g, '\\u2029');
	  }
	  try {
	    let shared = JSON.parse(document.querySelector('#ractive-shared').innerHTML.trim());
	    if (shared) {
	      Object.keys(shared).forEach(key => {
	        ractive.set(`@shared.${key}`, shared[key]);
	      });
	    }
	    http.fetchListStatPeriods().then(response => {
	      ractive.set('@shared.rawListStatPeriods', response);
	    });
	  } catch (e) {}
	  try {
	    state = JSON.parse(document.querySelector('#ractive-data').innerHTML.trim());
	  } catch (e) {}
	  if (!document.title.includes('not found')) {
	    app$1.router.init({
	      noScroll: true,
	      state: {
	        ...state,
	        ...app$1.router.data()
	      }
	    }).watchLinks().watchState();
	  }
	});
	app$1.injectGlobalStyle = href => {
	  for (let link of document.getElementsByTagName('link')) {
	    if (link.href === href) {
	      return;
	    }
	  }
	  let link = document.createElement('link');
	  link.rel = 'stylesheet';
	  link.href = href;
	  document.head.appendChild(link);
	};
	var app_1 = app$1;

	return app_1;

}));
